import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import { ID } from '../scalars.js'
import { String } from '../scalars.js'
import { Boolean } from '../scalars.js'
import { Int } from '../scalars.js'
import { Float } from '../scalars.js'
import { DateTime } from '../scalars.js'
import { FileInput } from '../scalars.js'
import { JSONObject } from '../scalars.js'
import { JSONValue } from '../scalars.js'
import { Regtype } from '../scalars.js'
import { Vector } from '../scalars.js'
export type Maybe<T> = T | null
export type InputMaybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: ID
  String: String
  Boolean: Boolean
  Int: Int
  Float: Float
  DateTime: DateTime
  FileInput: FileInput
  JSONObject: JSONObject
  JSONValue: JSONValue
  Regtype: Regtype
  Vector: Vector
}

/**
 * An action is an asynchronous collection of steps (tasks) that can be triggered by a user or
 * automtically by the system. Actions are part of a workflow.
 */
export type Action = {
  __typename: 'Action'
  /** Configure whether action should trigger Segment alert to Slack */
  alertSlack: Scalars['Boolean']
  /** Trigger for action */
  apiTrigger: Maybe<ActionApiTrigger>
  autoTrigger: Maybe<ActionAutoTrigger>
  /** @deprecated Always returns at most one auto trigger */
  autoTriggers: Array<ActionAutoTrigger>
  /** Any datastore variables declared for this action */
  datastoreVariables: Array<ActionDatastoreVariable>
  description: Maybe<Scalars['String']>
  /** Feature flags for this action. Keys are ActionFeatureFlag names, values are booleans. */
  featureFlags: Maybe<Scalars['JSONObject']>
  frequencyTriggers: Array<ActionFrequencyTrigger>
  id: Scalars['ID']
  manualTriggers: Array<ActionManualTrigger>
  name: Scalars['String']
  /** All nested groups to take to accomplish the action */
  nestedGroups: Array<ActionStepGroup>
  /** All nested steps to take to accomplish the action */
  nestedSteps: Array<ActionStep>
  /** Determines the order of the action in the workflow */
  order: Scalars['Int']
  /** Comprehension edges attributed to this action for sync and maintenance */
  rootedComprehensionEdges: Array<ComprehensionEdge>
  /** The runs of this action */
  runs: Array<ExecutionInstance>
  /** Configure whether or not notifications show on app at start/complete/failure */
  showNotification: Scalars['Boolean']
  /** The slug of the action. This is automatically generated when the name is set. */
  slug: Scalars['String']
  status: ActionStatus
  /** Each step to take to accomplish the action */
  steps: Array<ActionStep>
  /** Transition records triggered by this action */
  triggeredButtonTransitionHistory: Array<TableButtonTransitionHistory>
  /** The validation messages for the action */
  validationMessages: Array<TriumvirateValidationMessage>
  /** Version history for this action's JSON definitions */
  versions: Array<EntityVersionHistory>
  /** The workflow this action is part of */
  workflow: Workflow
}

/**
 * An ActionApiTrigger is a trigger associated with an endpoint in the API gateway service
 * that will start an action when that endpoint receives a valid request from an authenticated organisation.
 */
export type ActionApiTrigger = {
  __typename: 'ActionApiTrigger'
  action: Action
  id: Scalars['ID']
  organization: Organization
  /** The user defined schema of the request payload that that triggers this Api trigger */
  requestSchema: Scalars['JSONObject']
  /** Whether this trigger requires serial execution (only one instance at a time) */
  requiresSerialExecution: Scalars['Boolean']
  /** The runs of this api trigger */
  runs: Array<ExecutionInstance>
  /** The slug of the api trigger. This is automatically generated when the action is set. */
  slug: Scalars['String']
}

/**
 * An ActionAutoTrigger is a trigger associated with an object that will start an action when certain
 * event conditions are met (i.e. new row added or cell updated in a table). These conditions are
 * defined in the filter metadata.
 */
export type ActionAutoTrigger = {
  __typename: 'ActionAutoTrigger'
  /** The action that will be triggered when the auto trigger is matched */
  action: Maybe<Action>
  concurrency: Maybe<ActionTriggerConcurrency>
  /**
   * Contains a logic expression (which is potentially nested) that is first resolved against the
   * trigger's data and then evaluated to determine whether the action corresponding to this trigger
   * should execute.
   */
  filterExpression: Maybe<Scalars['JSONObject']>
  id: Scalars['ID']
  /** Image to display for certain action triggers, mainly for the ActionAutoTriggerType DEMO */
  logo: Maybe<Document>
  organization: Organization
  /** Whether this trigger requires serial execution (only one instance at a time) */
  requiresSerialExecution: Scalars['Boolean']
  /** The runs of this auto trigger */
  runs: Array<ExecutionInstance>
  /** The slug of the auto trigger. This is automatically generated when the trigger type and action is set. */
  slug: Scalars['String']
  /**
   * A computed version of filterExpression where all IDs are converted to slugs.
   * This is useful for displaying the filter expression in a more readable format.
   */
  slugifiedFilterExpression: Maybe<Scalars['JSONObject']>
  /**
   * A computed version of triggerMetadata where all IDs are converted to slugs.
   * This is useful for displaying the trigger metadata in a more readable format.
   */
  slugifiedTriggerMetadata: Scalars['JSONObject']
  /**
   * Contains the properties that are used to determine whether this trigger should execute.
   * The properties depend on the type of trigger.
   */
  triggerMetadata: Scalars['JSONObject']
  type: ActionAutoTriggerType
  /** Optional validation messages for the auto trigger */
  validationMessages: Array<TriumvirateValidationMessage>
  /** Workflows V2 program this trigger dispatches instead of an action */
  workflowV2: Maybe<WorkflowV2>
}

/** The type of an action auto trigger */
export enum ActionAutoTriggerType {
  /** Webhook integrations — each @kafkaTopic value generates a Kafka topic */
  A2B_FULFILLMENT_WEBHOOK = 'A2B_FULFILLMENT_WEBHOOK',
  ADD_ROW = 'ADD_ROW',
  AIRTABLE_WEBHOOK = 'AIRTABLE_WEBHOOK',
  AMAZON_SELLER_WEBHOOK = 'AMAZON_SELLER_WEBHOOK',
  BILL_WEBHOOK = 'BILL_WEBHOOK',
  CARTONCLOUD_WEBHOOK = 'CARTONCLOUD_WEBHOOK',
  DELETE_ROW = 'DELETE_ROW',
  DEMO = 'DEMO',
  DOSS_BANKING_WEBHOOK = 'DOSS_BANKING_WEBHOOK',
  DOSS_BILL_PAY_WEBHOOK = 'DOSS_BILL_PAY_WEBHOOK',
  EASYPOST_WEBHOOK = 'EASYPOST_WEBHOOK',
  EXTENSIV_WEBHOOK = 'EXTENSIV_WEBHOOK',
  FENO_WEBHOOK = 'FENO_WEBHOOK',
  FIRSTBASE_WEBHOOK = 'FIRSTBASE_WEBHOOK',
  FLEXPORT_WEBHOOK = 'FLEXPORT_WEBHOOK',
  FORM_SUBMIT = 'FORM_SUBMIT',
  FORM_V2_SUBMIT = 'FORM_V2_SUBMIT',
  FORTY_SEAS_WEBHOOK = 'FORTY_SEAS_WEBHOOK',
  GMAIL_WEBHOOK = 'GMAIL_WEBHOOK',
  GNOSIS_WEBHOOK = 'GNOSIS_WEBHOOK',
  GOFREIGHT_WEBHOOK = 'GOFREIGHT_WEBHOOK',
  HUBSPOT_WEBHOOK = 'HUBSPOT_WEBHOOK',
  INGRAM_MICRO_WEBHOOK = 'INGRAM_MICRO_WEBHOOK',
  JAY_GROUP_WEBHOOK = 'JAY_GROUP_WEBHOOK',
  JAZZ_WEBHOOK = 'JAZZ_WEBHOOK',
  LAZADA_WEBHOOK = 'LAZADA_WEBHOOK',
  LOCAD_WEBHOOK = 'LOCAD_WEBHOOK',
  LOGIWA_WEBHOOK = 'LOGIWA_WEBHOOK',
  LOOP_RETURNS_WEBHOOK = 'LOOP_RETURNS_WEBHOOK',
  MAYA_WEBHOOK = 'MAYA_WEBHOOK',
  MINTSOFT_WEBHOOK = 'MINTSOFT_WEBHOOK',
  MISFITS_MARKET_WEBHOOK = 'MISFITS_MARKET_WEBHOOK',
  NAVISPHERE_WEBHOOK = 'NAVISPHERE_WEBHOOK',
  OUTLOOK_WEBHOOK = 'OUTLOOK_WEBHOOK',
  QUICKBOOKS_WEBHOOK = 'QUICKBOOKS_WEBHOOK',
  RILLET_WEBHOOK = 'RILLET_WEBHOOK',
  ROUTABLE_WEBHOOK = 'ROUTABLE_WEBHOOK',
  SALSIFY_WEBHOOK = 'SALSIFY_WEBHOOK',
  SHIPBOB_WEBHOOK = 'SHIPBOB_WEBHOOK',
  SHIPHERO_WEBHOOK = 'SHIPHERO_WEBHOOK',
  SHIPMONK_WEBHOOK = 'SHIPMONK_WEBHOOK',
  SHIPWIRE_WEBHOOK = 'SHIPWIRE_WEBHOOK',
  SHOPEE_WEBHOOK = 'SHOPEE_WEBHOOK',
  SHOPIFY_WEBHOOK = 'SHOPIFY_WEBHOOK',
  SILQ_WEBHOOK = 'SILQ_WEBHOOK',
  STORD_WEBHOOK = 'STORD_WEBHOOK',
  STRIPE_WEBHOOK = 'STRIPE_WEBHOOK',
  THINK_LOGISTICS_WEBHOOK = 'THINK_LOGISTICS_WEBHOOK',
  TIKTOK_SHOP_WEBHOOK = 'TIKTOK_SHOP_WEBHOOK',
  UPDATE_CELL = 'UPDATE_CELL',
  UPDATE_ROW = 'UPDATE_ROW',
  USA_SUPPLY_PORTAL_WEBHOOK = 'USA_SUPPLY_PORTAL_WEBHOOK',
  WALMART_WEBHOOK = 'WALMART_WEBHOOK',
  WOO_COMMERCE_WEBHOOK = 'WOO_COMMERCE_WEBHOOK',
}

export type ActionDatastoreVariable = {
  __typename: 'ActionDatastoreVariable'
  action: Action
  /** The default value of the variable. If not set, the variable will be null. */
  defaultValue: Scalars['JSONValue']
  /** The description of the variable */
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** The name of the variable */
  name: Scalars['String']
  /** The type of the variable */
  type: DataStoreVariableType
}

/**
 * An ActionFrequencyTrigger is a trigger associated with a certain time frequency
 * - like a CRON format reminder to trigger an action.
 *
 * For example:
 * 1. Daily at 5 AM on weekdays:
 * - repeatNumber = 1 (every 1 day)
 * - repeatUnit = DAY
 * - daysOfWeek = [1, 2, 3, 4, 5]
 * - startAt = tomorrow at 5AM
 * 2. Every 3rd month on the first Monday at noon
 * - repeatNumber = 3
 * - repeatUnit = MONTH
 * - daysOfWeek = [1]
 * - startAt = 1st of next Month at noon
 * 3. Every 2nd week at midnight
 * - repeatNumber = 2
 * - repeatUnit = WEEK
 * - daysOfWeek = null (Null means any day of the week)
 * - startAt = tonight at midnight
 * 4. Every 15 minutes between 9am and 5pm in the org's timezone on weekdays
 * - repeatNumber = 15
 * - repeatUnit = MINUTE
 * - daysOfWeek = [1, 2, 3, 4, 5]
 * - hoursOfDay = [9, 10, 11, 12, 13, 14, 15, 16, 17]
 * - startAt = next 9am
 */
export type ActionFrequencyTrigger = {
  __typename: 'ActionFrequencyTrigger'
  action: Maybe<Action>
  concurrency: Maybe<ActionTriggerConcurrency>
  daysOfWeek: Maybe<Array<Scalars['Int']>>
  /** Restricts firing to these hours-of-day (0-23) in the organization's timezone. Empty means any hour. */
  hoursOfDay: Maybe<Array<Scalars['Int']>>
  id: Scalars['ID']
  organization: Organization
  repeatNumber: Scalars['Int']
  repeatUnit: CalendarUnit
  /** Whether this trigger requires serial execution (only one instance at a time) */
  requiresSerialExecution: Scalars['Boolean']
  /** The runs of this frequency trigger */
  runs: Array<ExecutionInstance>
  /** The slug of the frequency trigger. This is automatically generated when the action is set. */
  slug: Scalars['String']
  startAt: Scalars['DateTime']
  /** Workflows V2 program this trigger dispatches instead of an action */
  workflowV2: Maybe<WorkflowV2>
}

/** Represents a single validation error found during Action JSON validation */
export type ActionJsonValidationError = {
  __typename: 'ActionJsonValidationError'
  /** Human-readable error message */
  message: Scalars['String']
  /** The JSON path where the error occurred (e.g., 'steps[0].selectionsData.tableId') */
  path: Scalars['String']
}

/** An ActionManualTrigger is a type of view that lets the user trigger an action. */
export type ActionManualTrigger = {
  __typename: 'ActionManualTrigger'
  action: Maybe<Action>
  /** The workspace buttons for this trigger */
  buttons: Array<WorkspaceButton>
  concurrency: Maybe<ActionTriggerConcurrency>
  id: Scalars['ID']
  /** The TRIGGER binding's authored identity; null when no binding exists. */
  logicalId: Maybe<Scalars['String']>
  name: Scalars['String']
  organization: Organization
  /** The permissions that control access to this manual trigger */
  permissions: Array<Permission>
  /** Whether this trigger requires serial execution (only one instance at a time) */
  requiresSerialExecution: Scalars['Boolean']
  /** The runs of this manual trigger */
  runs: Array<ExecutionInstance>
  /** The slug of the manual trigger. This is automatically generated when the name is set. */
  slug: Scalars['String']
  /** Workflows V2 program this trigger dispatches instead of an action */
  workflowV2: Maybe<WorkflowV2>
}

export enum ActionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

/** A step is a filter or post process done as part of an Action */
export type ActionStep = {
  __typename: 'ActionStep'
  /** The action this step belongs to */
  action: Maybe<Action>
  /** The action step group this step belongs to */
  actionStepGroup: Maybe<ActionStepGroup>
  /** Branches for this step if it is a branch step */
  branches: Array<ActionStepGroup>
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  /**
   * If the step is inactive, this is (optionally) why. This may be auto-generated by the system.
   * @deprecated To be removed in favor of Triumvirate 2.0
   */
  inactiveReason: Maybe<Scalars['String']>
  /** If the action step is of type READ_INTEGRATION or WRITE_INTEGRATION, this is the integration */
  integration: Maybe<Integration>
  /** If set, the integration ID will be resolved at runtime from this input mapping path instead of using the static integrationId */
  integrationIdMapping: Maybe<Scalars['String']>
  /** Image to display for certain action steps, mainly for the ActionStepType DEMO */
  logo: Maybe<Document>
  name: Scalars['String']
  /**
   * The selections used to execute this step when its root action was triggered by a formV1 submission.
   * It contains manual user inputs and mapped fields that need to be resolved before execution.
   * This can be dropped once all formV1 have successfully been migrated to formV2.
   */
  oldSelectionsData: Maybe<Scalars['JSONObject']>
  /** Determines the order of the step in the action */
  order: Scalars['Int']
  /** The user defined output schema for the action step */
  outputSchema: Maybe<Scalars['JSONObject']>
  /** The root action this step belongs to in all of the nested action steps and groups */
  rootAction: Action
  /** The runs of this action step */
  runs: Array<ExecutionInstance>
  /**
   * The selections used to execute this step. It contains manual user inputs and mapped fields that
   * need to be resolved before execution.
   */
  selectionsData: Scalars['JSONObject']
  /** The slug of the step. This is automatically generated when the name is set. */
  slug: Scalars['String']
  /**
   * A computed version of oldSelectionsData where all IDs are converted to slugs.
   * This is useful for displaying the selections data in a more readable format.
   */
  slugifiedOldSelectionsData: Scalars['JSONObject']
  /**
   * A computed version of selectionsData where all IDs are converted to slugs.
   * This is useful for displaying the selections data in a more readable format.
   */
  slugifiedSelectionsData: Scalars['JSONObject']
  /**
   * Status of the action step
   * @deprecated To be removed in favor of Triumvirate 2.0
   */
  status: ActionStepStatus
  type: ActionStepType
  /** Optional validation messages for the action step */
  validationMessages: Array<TriumvirateValidationMessage>
}

/** Groups action steps into a single logical branch */
export type ActionStepGroup = {
  __typename: 'ActionStepGroup'
  actionSteps: Array<ActionStep>
  id: Scalars['ID']
  name: Scalars['String']
  order: Scalars['Int']
  parentActionStep: ActionStep
  rootAction: Action
  /** The runs of this action step group */
  runs: Array<ExecutionInstance>
  /** The slug of the action step group. This is automatically generated when the name is set. */
  slug: Scalars['String']
  /** The validation messages for the action step group */
  validationMessages: Array<TriumvirateValidationMessage>
}

export enum ActionStepStatus {
  ACTIVE = 'ACTIVE',
  FORCED_INACTIVE = 'FORCED_INACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum ActionStepType {
  AI_PROMPT = 'AI_PROMPT',
  API_RESPONSE = 'API_RESPONSE',
  ARRAY_SELECT = 'ARRAY_SELECT',
  BRANCH = 'BRANCH',
  BULK_UPSERT_TABLE_ROW = 'BULK_UPSERT_TABLE_ROW',
  DATASTORE_WRITE = 'DATASTORE_WRITE',
  DELAY = 'DELAY',
  DELETE_TABLE_ROW = 'DELETE_TABLE_ROW',
  DEMO = 'DEMO',
  FORMULA = 'FORMULA',
  GENERATE_BARCODE = 'GENERATE_BARCODE',
  GENERATE_FILE = 'GENERATE_FILE',
  GROUP_BY = 'GROUP_BY',
  GROUP_BY_MULTIPLE = 'GROUP_BY_MULTIPLE',
  INSERT_TABLE_ROW = 'INSERT_TABLE_ROW',
  MAP = 'MAP',
  MERGE = 'MERGE',
  MERGE_FILES = 'MERGE_FILES',
  NOTIFICATION = 'NOTIFICATION',
  PARSE_FILE = 'PARSE_FILE',
  READ_INTEGRATION = 'READ_INTEGRATION',
  SEND_EMAIL = 'SEND_EMAIL',
  TABLE_QUERY = 'TABLE_QUERY',
  UNIQUE_BY = 'UNIQUE_BY',
  UNIQUE_BY_MULTIPLE = 'UNIQUE_BY_MULTIPLE',
  UPDATE_TABLE_ROW = 'UPDATE_TABLE_ROW',
  WHILE = 'WHILE',
  WRITE_INTEGRATION = 'WRITE_INTEGRATION',
}

export type ActionTriggerConcurrency = {
  __typename: 'ActionTriggerConcurrency'
  actionAutoTrigger: Maybe<ActionAutoTrigger>
  actionFrequencyTrigger: Maybe<ActionFrequencyTrigger>
  actionManualTrigger: Maybe<ActionManualTrigger>
  id: Scalars['ID']
  keyExpressions: Array<Scalars['String']>
  mode: ActionTriggerConcurrencyMode
  scope: Maybe<ActionTriggerConcurrencyScope>
}

export type ActionTriggerConcurrencyInput = {
  keyExpressions?: InputMaybe<Array<Scalars['String']>>
  mode: ActionTriggerConcurrencyMode
  scope?: InputMaybe<ActionTriggerConcurrencyScope>
}

export enum ActionTriggerConcurrencyMode {
  KEYED = 'KEYED',
  SEQUENTIAL = 'SEQUENTIAL',
}

export enum ActionTriggerConcurrencyScope {
  ACTION = 'ACTION',
  ORGANIZATION = 'ORGANIZATION',
  WORKFLOW = 'WORKFLOW',
}

/**
 * One entry of an object's activity feed, read from the ClickHouse system_events log. A subset of the
 * admin SystemEvent type: the causal and payload-storage fields stay admin-only.
 */
export type ActivityFeedEvent = {
  __typename: 'ActivityFeedEvent'
  /** The agent that carried the action out. Null when a person acted directly. */
  agentId: Maybe<Scalars['ID']>
  /** JSON event payload. Shape is per event type; see the catalog in @doss/common-all. */
  data: Scalars['JSONObject']
  /** The instance acted on (eg. table row id). A cell is the synthetic `<rowId>:<columnId>`. */
  entityId: Maybe<Scalars['ID']>
  entityType: Maybe<SystemEventEntityType>
  eventStatus: SystemEventStatus
  eventType: SystemEventType
  /** uuidv7. Unique per event, and the key the feed deduplicates live pushes by. */
  id: Scalars['ID']
  /** The user whose identity was borrowed. Null in the ordinary case. */
  impersonatedUserId: Maybe<Scalars['ID']>
  impersonatedUserName: Maybe<Scalars['String']>
  /**
   * Who or what the action is attributed to: a user, an inbound webhook's integration, or a
   * frequency trigger's workflow. `ANONYMOUS` for a visitor with no account, so not always a UUID.
   */
  originatorId: Scalars['ID']
  originatorName: Scalars['String']
  originatorType: SystemEventOriginatorType
  /** WORKFLOW | UI. Describes the current hop, so it flips as a cascade moves between them. */
  substrate: Maybe<SystemEventSubstrate>
  /** Event time, not ingest time. */
  timestamp: Scalars['DateTime']
}

/** Admin permissions for the admin system */
export enum AdminPermissionType {
  DELETE_ORGANIZATIONS = 'DELETE_ORGANIZATIONS',
  MANAGE_ADMIN_USERS = 'MANAGE_ADMIN_USERS',
  /** Set a person's access to every organization. Only admins who have it can grant it. */
  MANAGE_GLOBAL_ACCESS = 'MANAGE_GLOBAL_ACCESS',
}

/** Admin user entity for admin access management */
export type AdminUser = {
  __typename: 'AdminUser'
  createdAt: Scalars['DateTime']
  email: Scalars['String']
  externalUserId: Maybe<Scalars['String']>
  firebaseUid: Maybe<Scalars['String']>
  id: Scalars['ID']
  invitedByAdminUser: Maybe<AdminUser>
  invitedUsers: Array<AdminUser>
  permissions: Array<AdminUserPermission>
  status: AdminUserStatus
  updatedAt: Scalars['DateTime']
}

/** Permission assignment for an admin user */
export type AdminUserPermission = {
  __typename: 'AdminUserPermission'
  adminUser: AdminUser
  id: Scalars['ID']
  permission: AdminPermissionType
}

/** The status of an admin user's access */
export enum AdminUserStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  INVITED = 'INVITED',
}

export type AgentRun = {
  __typename: 'AgentRun'
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  /** The chat run within which this agent run was triggered */
  dossbotChatRun: DossbotChatRun
  events: Array<DossbotEvent>
  id: Scalars['ID']
  /** The input that was sent to the agent */
  input: Scalars['JSONValue']
  /** The model specification that was used to generate the response for this agent run */
  modelSpec: ModelSpecification
  status: AgentRunStatus
  /** The summary of the agent run */
  summary: Maybe<Scalars['String']>
  /** The system prompt that was used in this agent run */
  systemPrompt: SystemPrompt
  /** Token usage for the agent run */
  tokenUsage: Maybe<Scalars['JSONObject']>
  /** The tools that the agent runs */
  toolRunSteps: Array<ToolRunStep>
}

export enum AgentRunStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export type AggregateTableColumnInput = {
  /**
   * For backlink tables: the column containing the link to the source table.
   * Must be provided together with backlinkRowId.
   */
  backlinkColumnId?: InputMaybe<Scalars['ID']>
  /**
   * For backlink tables: the source row ID to scope aggregation to rows linked to that row.
   * Must be provided together with backlinkColumnId.
   */
  backlinkRowId?: InputMaybe<Scalars['ID']>
  columnId: Scalars['ID']
  filterBooleanOperator?: InputMaybe<BooleanOperator>
  filters?: InputMaybe<Array<TableColumnFilterInput>>
  operation: AggregationOperation
  /** For child tables: the parent row ID to scope aggregation to children of that parent. */
  parentRowId?: InputMaybe<Scalars['ID']>
  /** Optional search string to filter aggregation results. */
  searchString?: InputMaybe<Scalars['String']>
  tableTabId?: InputMaybe<Scalars['ID']>
}

export enum AggregationOperation {
  AVG = 'AVG',
  COUNT = 'COUNT',
  DISTINCT_COUNT = 'DISTINCT_COUNT',
  MAX = 'MAX',
  MEDIAN = 'MEDIAN',
  MIN = 'MIN',
  RANGE = 'RANGE',
  SUM = 'SUM',
}

/**
 * One cell. Its id is rowId:columnId, so a cell has one identity however it is reached: directly,
 * or as the target a lookup mirrors.
 */
export type AppTableCell = {
  __typename: 'AppTableCell'
  /** The cell's own update time */
  at: Maybe<Scalars['DateTime']>
  /** The rendered value */
  display: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** A lookup's targets, one per { rowId } in value, each with the cells the chain ends at */
  targets: Array<AppTableTarget>
  /**
   * The value as a workflow reads it, wire-encoded: { __date } for dates, { __decimal } for exact
   * numbers, { id firstName lastName email phoneNumber } per user, document ids for files. A lookup
   * holds { rowId } per target, and its targets carry the values.
   */
  value: Maybe<Scalars['JSONValue']>
}

export type AppTableDistinctInput = {
  /** At most this many values: 1 to 1000, 100 when omitted */
  limit?: InputMaybe<Scalars['Int']>
  /** A WaC table query plan whose projection names the one column, as plan.map((r) => ({ value: r.column })) builds it */
  plan: Scalars['JSONObject']
}

/** One distinct value of a column among the rows an App's read matches */
export type AppTableDistinctValue = {
  __typename: 'AppTableDistinctValue'
  /** The rendered value */
  display: Maybe<Scalars['String']>
  /** How many of the rows hold it */
  rowCount: Scalars['Int']
  /** The value as a workflow reads it, wire-encoded */
  value: Maybe<Scalars['JSONValue']>
}

/** The distinct values of a column among the rows an App's read matches, in ascending order */
export type AppTableDistinctValues = {
  __typename: 'AppTableDistinctValues'
  /** More distinct values exist than were returned */
  truncated: Scalars['Boolean']
  values: Array<AppTableDistinctValue>
}

/**
 * One row of a table as a Dynamic App reads it: the cells this viewer may see. Served by the same
 * search path as paginatedTableRows, in a shape a normalized client cache stores directly.
 */
export type AppTableRow = {
  __typename: 'AppTableRow'
  /** One cell per column the viewer may see, a null cell for an empty one */
  cells: Array<AppTableCell>
  createdAt: Scalars['DateTime']
  /** The user who created the row, as { id firstName lastName email phoneNumber }; null for a system write */
  createdBy: Maybe<Scalars['JSONValue']>
  id: Scalars['ID']
  parentRowId: Maybe<Scalars['ID']>
  updatedAt: Scalars['DateTime']
  /** The user who last updated the row, as createdBy */
  updatedBy: Maybe<Scalars['JSONValue']>
}

/** One page of a table's rows for a Dynamic App */
export type AppTableRowPage = {
  __typename: 'AppTableRowPage'
  hasNext: Scalars['Boolean']
  rows: Array<AppTableRow>
  /** A projected read's fields; null when the read returns the table's rows */
  select: Maybe<Array<AppTableSelectField>>
  totalCount: Scalars['Int']
}

export type AppTableRowSubscriptionInput = {
  rowId: Scalars['ID']
  tableId: Scalars['ID']
  /** The App following the row, named by the host: subscriptions carry no embed headers */
  viewContentId: Scalars['ID']
}

export type AppTableRowsInput = {
  /** A WaC table query plan, as the ORM's codec encodes it */
  plan: Scalars['JSONObject']
}

/** A projected read's field: the output name and the source field it reads */
export type AppTableSelectField = {
  __typename: 'AppTableSelectField'
  as: Scalars['String']
  field: Scalars['String']
}

export type AppTableSubscriptionInput = {
  tableId: Scalars['ID']
  /** The App following the table, named by the host: subscriptions carry no embed headers */
  viewContentId: Scalars['ID']
}

/** One target of a lookup: the row it points at, and the cells the lookup chain ends at */
export type AppTableTarget = {
  __typename: 'AppTableTarget'
  cells: Array<AppTableCell>
  rowId: Scalars['ID']
}

/** App user information for OAuth2 contexts (not a full entity) */
export type AppUserInfo = {
  __typename: 'AppUserInfo'
  /** the user's email */
  email: Scalars['String']
  /** the user's first name */
  firstName: Scalars['String']
  /** the user id */
  id: Scalars['ID']
  /** the user's last name */
  lastName: Scalars['String']
  /** the organization id the user belongs to */
  organizationId: Scalars['ID']
}

/** Determines which direction to show the application in */
export enum ApplicationOrientation {
  LEFT_TO_RIGHT = 'LEFT_TO_RIGHT',
  RIGHT_TO_LEFT = 'RIGHT_TO_LEFT',
}

export type AuthorizeIntegrationInput = {
  /** Parameters returned by the authorization server */
  authorizationParams: Scalars['JSONObject']
  organizationId: Scalars['String']
  type: IntegrationType
}

/** Result of approving an OAuth2 authorization request */
export type AuthorizeOAuth2Result = {
  __typename: 'AuthorizeOAuth2Result'
  authorizationCode: Maybe<Scalars['String']>
  error: Maybe<Scalars['String']>
  redirectUri: Maybe<Scalars['String']>
  state: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type BarChartAggregation = {
  __typename: 'BarChartAggregation'
  data: Array<Scalars['JSONObject']>
  indexBy: Scalars['String']
  keys: Array<Scalars['String']>
}

export enum BooleanOperator {
  AND = 'AND',
  OR = 'OR',
}

/** Breadcrumb objects to display in the Admin UI */
export type Breadcrumb = {
  __typename: 'Breadcrumb'
  iconName: Maybe<Scalars['String']>
  name: Scalars['String']
  objectId: Scalars['ID']
  type: BreadcrumbObjectType
}

export enum BreadcrumbObjectType {
  ACTION = 'ACTION',
  ACTION_STEP = 'ACTION_STEP',
  CHART = 'CHART',
  DOCUMENT = 'DOCUMENT',
  EMBED = 'EMBED',
  FORM = 'FORM',
  FORM_CATEGORY = 'FORM_CATEGORY',
  FORM_FIELD = 'FORM_FIELD',
  FORM_PAGE = 'FORM_PAGE',
  FORM_V2 = 'FORM_V2',
  FORM_V2_INPUT = 'FORM_V2_INPUT',
  ORGANIZATION = 'ORGANIZATION',
  PIVOT_TABLE = 'PIVOT_TABLE',
  PROJECT = 'PROJECT',
  TABLE = 'TABLE',
  TABLE_CELL = 'TABLE_CELL',
  TABLE_COLUMN = 'TABLE_COLUMN',
  TABLE_ROW = 'TABLE_ROW',
  USER = 'USER',
  WORKFLOW = 'WORKFLOW',
  WORKFLOW_V2 = 'WORKFLOW_V2',
  WORKFLOW_V2_TRIGGER = 'WORKFLOW_V2_TRIGGER',
  WORKSPACE = 'WORKSPACE',
}

export type BreadcrumbsInput = {
  objectId: Scalars['ID']
  objectType: BreadcrumbObjectType
}

/** Input for querying bulk action eligibility counts */
export type BulkActionEligibilityCountsInput = {
  /** Current view filters to apply when selecting all rows */
  filters?: InputMaybe<Array<TableFilterInput>>
  /** If provided, check eligibility for specific rows. If null/empty, check all rows matching filters. */
  rowIds?: InputMaybe<Array<Scalars['ID']>>
  /** Search string to apply when selecting all rows */
  searchString?: InputMaybe<Scalars['String']>
  tableId: Scalars['ID']
}

/** Result of bulk action eligibility counts query */
export type BulkActionEligibilityCountsResult = {
  __typename: 'BulkActionEligibilityCountsResult'
  buttonEligibilityCounts: Array<ButtonEligibilityCount>
  totalSelectedCount: Scalars['Int']
}

/** Error for a specific row during bulk action execution */
export type BulkActionError = {
  __typename: 'BulkActionError'
  /** References blocking the action, with column and table context */
  blockingReferences: Maybe<Array<DeleteBlockingReference>>
  /** Rows currently blocking the action, ordered by createdAt then id */
  blockingRows: Maybe<Array<TableRow>>
  message: Scalars['String']
  rowId: Scalars['ID']
  rowName: Maybe<Scalars['String']>
}

/** Input for deleting all rows under `selectAll` with specific filters and an operator. */
export type BulkDeleteFiltersInput = {
  /** OR or AND, corresponding for `filters`. */
  filterBooleanOperator: BooleanOperator
  /** Current view filters to apply, if `tableTabId` is not specified. */
  filters: Array<TableFilterInput>
}

/**
 * Input for deleting all rows under `selectAll`, matching either:
 * (1) The table tab, and its corresponding filter(s) and boolean operator
 * (2) Otherwise the `filters` and `filterBooleanOperator`
 * Should ideally be @oneOf the above two entities, but it's not supported yet.
 *
 * Also then match the search string.
 */
export type BulkDeleteSelectAllInput = {
  /** Filters to use when selecting all, if `tableTabId` is not specified. */
  filters?: InputMaybe<BulkDeleteFiltersInput>
  /** Search string to apply */
  searchString?: InputMaybe<Scalars['String']>
  /** The active tab when selecting all, applying the tab's saved filter(s) and operator. Cannot be combined with `filters`. */
  tableTabId?: InputMaybe<Scalars['ID']>
}

/** Input for bulk deleting table rows */
export type BulkDeleteTableRowsInput = {
  /** If provided, delete only these specific rows. Cannot be combined with selectAll. */
  rowIds?: InputMaybe<Array<Scalars['ID']>>
  /** If selectAll is checked, then delete all rows identified by this view. */
  selectAllView?: InputMaybe<BulkDeleteSelectAllInput>
  tableId: Scalars['ID']
}

/** Result of bulk delete operation */
export type BulkDeleteTableRowsResult = {
  __typename: 'BulkDeleteTableRowsResult'
  /** Number of rows successfully deleted */
  deletedCount: Scalars['Int']
  /** Any errors encountered during deletion */
  errors: Maybe<Array<BulkActionError>>
  /** Number of rows skipped (e.g., due to permission issues) */
  skippedCount: Scalars['Int']
}

/** Input for bulk duplicating table rows */
export type BulkDuplicateTableRowsInput = {
  /** Current view filters to apply when selecting all rows */
  filters?: InputMaybe<Array<TableFilterInput>>
  /** If true and rowIds is null/empty, duplicate all rows matching filters */
  isSelectAll?: InputMaybe<Scalars['Boolean']>
  /** If provided, duplicate only these specific rows. If null/empty with isSelectAll=true, use filters. */
  rowIds?: InputMaybe<Array<Scalars['ID']>>
  /** Search string to apply when selecting all rows */
  searchString?: InputMaybe<Scalars['String']>
  tableId: Scalars['ID']
}

/** Result of bulk duplicate operation */
export type BulkDuplicateTableRowsResult = {
  __typename: 'BulkDuplicateTableRowsResult'
  /** Number of rows successfully duplicated */
  duplicatedCount: Scalars['Int']
  /** Any errors encountered during duplication */
  errors: Maybe<Array<BulkActionError>>
  /** IDs of the newly created rows */
  newRowIds: Array<Scalars['ID']>
}

/** Eligibility count for a single workspace button */
export type ButtonEligibilityCount = {
  __typename: 'ButtonEligibilityCount'
  buttonConfiguration: Maybe<Scalars['JSONObject']>
  confirmationMessage: Maybe<Scalars['String']>
  eligibleCount: Scalars['Int']
  /** IDs of rows that are eligible for this action */
  eligibleRowIds: Array<Scalars['ID']>
  /** Indicates if there are more eligible rows beyond the displayed count (exceeds MAX_BULK_ROWS) */
  hasMore: Scalars['Boolean']
  icon: Maybe<Icon>
  id: Scalars['ID']
  manualTrigger: Maybe<ActionManualTrigger>
  name: Scalars['String']
  order: Scalars['Int']
  requiresConfirmation: Scalars['Boolean']
}

export enum CalendarUnit {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}

export type CallEndpointInput = {
  /** The endpoint's input, as the caller writes it (ids for rows and lookups) */
  input: Scalars['JSONObject']
  /** The logical id declared at `endpoint('…')` */
  logicalId: Scalars['String']
}

export type CallEndpointResult = {
  __typename: 'CallEndpointResult'
  /** The endpoint's declared output; null when it declares none */
  output: Maybe<Scalars['JSONValue']>
  /** True when the idempotency key replayed a saved output without running the handler */
  replayed: Scalars['Boolean']
}

export type Chart = {
  __typename: 'Chart'
  /**
   * Fields that will be aggregated in the chart. Only pivot tables can have more than one. All other
   * chart types must have one. Each aggregation column has its own aggregation operation
   */
  aggregationColumns: Array<ChartAggregationColumn>
  /**
   * The operation used to calculate the aggregated values (SUM, AVG, COUNT etc) - is being deprecated
   * for ChartAggregationColumn
   */
  aggregationOperation: AggregationOperation
  chartSubType: ChartSubType
  chartType: ChartType
  createdAt: Scalars['DateTime']
  filters: Array<TableColumnFilter>
  filtersBooleanOperator: Maybe<BooleanOperator>
  /** Dimensions to group data by (e.g. categories, time periods) */
  groupBys: Array<ChartGroupBy>
  id: Scalars['ID']
  name: Scalars['String']
  /** The organization that owns this chart */
  organization: Organization
  rootWorkspace: Workspace
  /** The slug of the chart, generated from its name at creation. A rename keeps it: it is the chart's identity in pulled configbases. */
  slug: Scalars['String']
  styling: Maybe<Scalars['JSONObject']>
  /** Source table containing data for this chart */
  table: Table
  /** thresholds are for gauge charts only, and the thresholds can only be ints */
  thresholds: Maybe<Array<Scalars['Float']>>
  updatedAt: Scalars['DateTime']
  views: Array<View>
  /** Column used for X axis values (used for bar, line, and scatterplot type charts) */
  xAxis: Maybe<TableColumn>
  /** Column used for Y axis values/metrics (required) - is being deprecated for ChartAggregationColumn */
  yAxis: TableColumn
}

export type ChartAggregation = {
  __typename: 'ChartAggregation'
  barChartAggregation: Maybe<BarChartAggregation>
  lineChartAggregation: Maybe<Array<LineChartAggregation>>
  metricAggregation: Maybe<Scalars['Float']>
  pieChartAggregation: Maybe<Array<PieChartAggregation>>
  pivotTableAggregation: Maybe<PivotTableAggregation>
  scatterplotAggregation: Maybe<Array<LineChartAggregation>>
  totalHits: Maybe<Scalars['Int']>
}

/**
 * The column that is being aggregated on in a chart with the aggregation operation and how the
 * aggregation is displayed
 */
export type ChartAggregationColumn = {
  __typename: 'ChartAggregationColumn'
  aggregationOperation: AggregationOperation
  /** The sort that uses the aggregation column, if any */
  aggregationSorts: Array<ChartGroupBySort>
  chart: Chart
  id: Scalars['ID']
  /**
   * If the chart has multiple aggregation columns, the order determines the order
   * in which the columns are displayed
   */
  order: Scalars['Int']
  /** The data source column for the aggregation */
  tableColumn: TableColumn
  /** Determines if the aggregated value is displayed as a raw value or a percentage */
  valueDisplayType: ChartValueDisplayType
}

export type ChartAggregationColumnInput = {
  aggregationOperation: AggregationOperation
  columnId: Scalars['ID']
  order: Scalars['Int']
  valueDisplayType: ChartValueDisplayType
}

export type ChartConfigurationInput = {
  aggregationColumns?: InputMaybe<Array<ChartAggregationColumnInput>>
  aggregationOperation?: InputMaybe<AggregationOperation>
  chartSubType: ChartSubType
  filters?: InputMaybe<Array<TableFilterInput>>
  filtersBooleanOperator?: InputMaybe<BooleanOperator>
  groupBys?: InputMaybe<Array<CreateGroupByInput>>
  xAxisColumnId?: InputMaybe<Scalars['ID']>
  yAxisColumnId?: InputMaybe<Scalars['ID']>
}

export type ChartGroupBy = {
  __typename: 'ChartGroupBy'
  chart: Chart
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  /**
   * For regular charts:
   * {
   *   interval: Int,
   *   intervalCalendarUnit: CalendarUnit,
   *   offset: Int,
   *   offsetUnit: CalendarUnit,
   *   stringBuckets: [String!],
   *   bounds: JSONObject
   * }
   *
   * For pivot tables:
   * {
   *   dimensionType: PivotDimensionType!, (ROW or COLUMN)
   *   order: Int!,
   *   # Whether to show totals for this dimension
   *   showTotals: Boolean!
   *   interval: Int,
   *   intervalCalendarUnit: CalendarUnit,
   *   offset: Int,
   *   offsetUnit: CalendarUnit,
   *   stringBuckets: [String!],
   *   bounds: JSONObject
   * }
   * NUMBER uses interval and bounds, DATE uses all fields
   */
  metadata: Maybe<Scalars['JSONObject']>
  /** Optional sorting configuration */
  sort: Maybe<ChartGroupBySort>
  tableColumn: TableColumn
  type: ChartGroupByType
  updatedAt: Scalars['DateTime']
}

export type ChartGroupBySort = {
  __typename: 'ChartGroupBySort'
  /**
   * Only used when sortType is AGGREGATION. Determines which aggregation column to sort by since
   * there could be more than one
   */
  aggregationColumn: Maybe<ChartAggregationColumn>
  direction: SortDirection
  groupBy: ChartGroupBy
  id: Scalars['ID']
  /** What type of sorting to apply (by header or by aggregations) */
  sortType: ChartGroupBySortType
}

/** Determines how the group by order is determined */
export enum ChartGroupBySortType {
  /** Sort by the aggregated values */
  AGGREGATION = 'AGGREGATION',
  /**
   * Sort by the dimension value names (the row/column headers) alphabetically
   * (or numerically or by asc/desc date interval)
   */
  HEADERS = 'HEADERS',
}

export enum ChartGroupByType {
  DEFAULT = 'DEFAULT',
  PIVOT = 'PIVOT',
}

export enum ChartSubType {
  AREA = 'AREA',
  BAR = 'BAR',
  COLUMN = 'COLUMN',
  DONUT = 'DONUT',
  GAUGE = 'GAUGE',
  HISTOGRAM = 'HISTOGRAM',
  LINE = 'LINE',
  METRIC = 'METRIC',
  PIE = 'PIE',
  PIVOT_TABLE = 'PIVOT_TABLE',
  SCATTERPLOT = 'SCATTERPLOT',
}

export enum ChartType {
  BAR = 'BAR',
  LINE = 'LINE',
  METRIC = 'METRIC',
  PIE = 'PIE',
  PIVOT_TABLE = 'PIVOT_TABLE',
  SCATTERPLOT = 'SCATTERPLOT',
}

/** Determines how to display the aggregation value for a chart aggregation column */
export enum ChartValueDisplayType {
  /** Display the aggregated value as a percentage of the total for the column */
  PERCENT_OF_COLUMN = 'PERCENT_OF_COLUMN',
  /** Display the aggregated value as a percentage of the grand total */
  PERCENT_OF_GRAND_TOTAL = 'PERCENT_OF_GRAND_TOTAL',
  /** Display the aggregated value as a percentage of the total for the row */
  PERCENT_OF_ROW = 'PERCENT_OF_ROW',
  /** Display the aggregated value as is */
  RAW_VALUE = 'RAW_VALUE',
}

export type ChartVisualizationDataInput = {
  chartConfiguration?: InputMaybe<ChartConfigurationInput>
  chartId?: InputMaybe<Scalars['ID']>
  pagination?: InputMaybe<PaginatedInput>
}

/**
 * An execution record read from the ClickHouse execution_payloads table. Only Restate-backed runs
 * are recorded there. executionId is the Restate jobId for action/step rows and the trigger's
 * ExecutionInstance UUID for trigger rows; hierarchy is expressed by parentExecutionId pointing at
 * the parent's executionId.
 */
export type ClickHouseExecutionPayload = {
  __typename: 'ClickHouseExecutionPayload'
  actionId: Scalars['ID']
  actionName: Scalars['String']
  actionStepGroupName: Maybe<Scalars['String']>
  actionStepId: Maybe<Scalars['ID']>
  actionStepName: Maybe<Scalars['String']>
  actionStepOrder: Scalars['Int']
  actionStepType: Maybe<Scalars['String']>
  attemptNumber: Scalars['Int']
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  executionId: Scalars['ID']
  invocationRootId: Scalars['String']
  iteration: Scalars['Int']
  parentExecutionId: Maybe<Scalars['ID']>
  /** Top-level ACTION run's executionId; query by it to fetch a run's whole subtree at once */
  rootExecutionId: Scalars['ID']
  startedAt: Maybe<Scalars['DateTime']>
  status: Maybe<ExecutionInstanceStatus>
  type: ExecutionInstanceType
}

/** Full JSON payloads for a single ClickHouse execution record */
export type ClickHouseExecutionPayloadData = {
  __typename: 'ClickHouseExecutionPayloadData'
  executionId: Scalars['ID']
  /** Resolved input data — trigger data for action/trigger rows, resolved input for step rows */
  jobData: Maybe<Scalars['JSONValue']>
  /** Output data for succeeded runs, or error details for failed runs */
  resultData: Maybe<Scalars['JSONValue']>
  /** Unresolved input data (selections/templates before resolution) */
  unresolvedJobData: Maybe<Scalars['JSONValue']>
}

export type ColumnAggregationResult = {
  __typename: 'ColumnAggregationResult'
  operation: AggregationOperation
  value: Maybe<Scalars['Float']>
}

/** A comment created within a workspace, with basic support for single-level threading. */
export type Comment = {
  __typename: 'Comment'
  author: Membership
  /** Deprecated: The user string ID is now a UUID */
  authorId_deprecated: Maybe<Scalars['String']>
  childComments: Array<Comment>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  notifications: Array<Notification>
  parentComment: Maybe<Comment>
  /** The parsed text with user IDs or UUIDs replaced with user names */
  parsedText: Scalars['String']
  text: Scalars['String']
  /** The workspace this comment is contained in */
  workspace: Workspace
}

/** Derived dependency edge between comprehension entities */
export type ComprehensionEdge = {
  __typename: 'ComprehensionEdge'
  edgeType: ComprehensionEdgeType
  /** The source table id for the upstream entity */
  fromEntityId: Scalars['ID']
  fromEntityType: ComprehensionEntityType
  id: Scalars['ID']
  metadata: Maybe<Scalars['JSONObject']>
  organization: Organization
  /** Disambiguates multiple edges between the same entity pair and edge type */
  relationshipKey: Scalars['String']
  /** Used to resync all edges produced by a single action */
  rootAction: Maybe<Action>
  /** The source table id for the downstream entity */
  toEntityId: Scalars['ID']
  toEntityType: ComprehensionEntityType
}

/** Dependency edge types stored in the comprehension graph */
export enum ComprehensionEdgeType {
  DATA_FLOW = 'DATA_FLOW',
  MONITOR = 'MONITOR',
  READ = 'READ',
  STRUCTURAL = 'STRUCTURAL',
  WRITE = 'WRITE',
}

/** Entity types tracked in the comprehension dependency graph */
export enum ComprehensionEntityType {
  ACTION = 'ACTION',
  ACTION_STEP = 'ACTION_STEP',
  ACTION_STEP_GROUP = 'ACTION_STEP_GROUP',
  AUTO_TRIGGER = 'AUTO_TRIGGER',
  FORM = 'FORM',
  FORM_FIELD = 'FORM_FIELD',
  FORM_INPUT = 'FORM_INPUT',
  FORM_V2 = 'FORM_V2',
  INTEGRATION = 'INTEGRATION',
  MANUAL_TRIGGER = 'MANUAL_TRIGGER',
  TABLE = 'TABLE',
  TABLE_COLUMN = 'TABLE_COLUMN',
  WORKFLOW_V2 = 'WORKFLOW_V2',
}

export type ComprehensionGraphInput = {
  /** Only follow edges of these types */
  edgeTypes?: InputMaybe<Array<ComprehensionEdgeType>>
  entityId: Scalars['ID']
  entityType: ComprehensionEntityType
  /** Only follow edges into these entity types */
  entityTypes?: InputMaybe<Array<ComprehensionEntityType>>
  /** Max returned edges (default: 500, hard max: 10000). Truncation keeps shallowest edges first */
  maxEdges?: InputMaybe<Scalars['Int']>
  /** Max traversal depth (default: 5, hard max: 5) */
  maxHops?: InputMaybe<Scalars['Int']>
  organizationId: Scalars['ID']
  /** Only follow edges with these relationship keys */
  relationshipKeys?: InputMaybe<Array<ComprehensionRelationshipKey>>
}

/** Result of a comprehension graph traversal */
export type ComprehensionGraphResult = {
  __typename: 'ComprehensionGraphResult'
  actionStepGroups: Array<ActionStepGroup>
  actionSteps: Array<ActionStep>
  actions: Array<Action>
  autoTriggers: Array<ActionAutoTrigger>
  edges: Array<ComprehensionTraversalEdge>
  formFields: Array<FormField>
  formInputs: Array<FormInput>
  forms: Array<Form>
  formsV2: Array<FormV2>
  integrations: Array<Integration>
  manualTriggers: Array<ActionManualTrigger>
  /** Effective max edge budget used for this traversal */
  maxEdges: Scalars['Int']
  /** Number of edges returned after truncation */
  returnedEdgeCount: Scalars['Int']
  /** Number of distinct entity references returned after truncation */
  returnedNodeCount: Scalars['Int']
  tableColumns: Array<TableColumn>
  tables: Array<Table>
  /** Whether the result omitted one or more edges because maxEdges was exceeded */
  truncated: Scalars['Boolean']
  /** Depth of the first omitted edge when truncated */
  truncatedAtDepth: Maybe<Scalars['Int']>
  workflowsV2: Array<WorkflowV2>
}

/**
 * Finer-grained discriminator distinguishing edges that share the same entity pair and
 * edgeType. The underlying column is TEXT; this enum constrains the values accepted on
 * filter inputs.
 */
export enum ComprehensionRelationshipKey {
  ACTION_STEP_COLUMN_MAPPING = 'ACTION_STEP_COLUMN_MAPPING',
  ACTION_STEP_INPUT_MAPPING = 'ACTION_STEP_INPUT_MAPPING',
  ACTION_STEP_TABLE_QUERY = 'ACTION_STEP_TABLE_QUERY',
  ACTION_STEP_WRITE_TARGET = 'ACTION_STEP_WRITE_TARGET',
  AUTO_TRIGGER_FILTER = 'AUTO_TRIGGER_FILTER',
  AUTO_TRIGGER_MONITOR = 'AUTO_TRIGGER_MONITOR',
  CHILD_TABLES = 'CHILD_TABLES',
  FORMULA_DEPENDENCY = 'FORMULA_DEPENDENCY',
  FORM_FIELDS = 'FORM_FIELDS',
  FORM_FIELD_LOOKUP_COLUMN = 'FORM_FIELD_LOOKUP_COLUMN',
  FORM_INPUTS = 'FORM_INPUTS',
  FORM_INPUT_LOOKUP_COLUMN = 'FORM_INPUT_LOOKUP_COLUMN',
  FORM_INPUT_SOURCE_COLUMN = 'FORM_INPUT_SOURCE_COLUMN',
  LOOKUP_COLUMN = 'LOOKUP_COLUMN',
  LOOKUP_FILTER = 'LOOKUP_FILTER',
  NESTED_ACTION_STEPS = 'NESTED_ACTION_STEPS',
  READ_INTEGRATION = 'READ_INTEGRATION',
  TABLE_COLUMNS = 'TABLE_COLUMNS',
  WORKFLOW_V2_REFERENCE = 'WORKFLOW_V2_REFERENCE',
  WORKFLOW_V2_TRIGGERS = 'WORKFLOW_V2_TRIGGERS',
  WRITE_INTEGRATION = 'WRITE_INTEGRATION',
}

/** An edge in the comprehension graph traversal result */
export type ComprehensionTraversalEdge = {
  __typename: 'ComprehensionTraversalEdge'
  depth: Scalars['Int']
  edgeType: ComprehensionEdgeType
  fromEntityId: Scalars['ID']
  fromEntityType: ComprehensionEntityType
  /**
   * Returned as a string since the underlying column is TEXT and may contain values that
   * don't currently match a ComprehensionRelationshipKey member.
   */
  relationshipKey: Scalars['String']
  toEntityId: Scalars['ID']
  toEntityType: ComprehensionEntityType
}

export type CreateActionFrequencyTriggerInput = {
  actionId: Scalars['ID']
  concurrency?: InputMaybe<ActionTriggerConcurrencyInput>
  frequency: FrequencyInput
}

export type CreateActionInput = {
  alertSlack: Scalars['Boolean']
  name: Scalars['String']
  order: Scalars['Int']
  showNotification: Scalars['Boolean']
  status: ActionStatus
  workflowId: Scalars['ID']
}

export type CreateActionManualTriggerInput = {
  actionId: Scalars['ID']
  concurrency?: InputMaybe<ActionTriggerConcurrencyInput>
  name: Scalars['String']
}

export type CreateAppOAuth2AuthorizationRequestInput = {
  clientId: Scalars['String']
  codeChallenge: Scalars['String']
  codeChallengeMethod: Scalars['String']
  organizationId: Scalars['ID']
  redirectUri: Scalars['String']
  state: Scalars['String']
}

export type CreateButtonNodeInput = {
  logicExpression: ParentLogicExpressionInput
  /** Authored identity for the state's logical binding; omit to mint one from the name */
  logicalId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  sourceNodeId: Scalars['ID']
  tableId: Scalars['ID']
}

export type CreateButtonNodeWorkspaceButtonInput = {
  buttonConfiguration: Scalars['JSONObject']
  confirmationMessage?: InputMaybe<Scalars['String']>
  formId?: InputMaybe<Scalars['ID']>
  formV2Id?: InputMaybe<Scalars['ID']>
  iconId?: InputMaybe<Scalars['ID']>
  manualTriggerId?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
  order: Scalars['Int']
  requiresConfirmation: Scalars['Boolean']
}

export type CreateButtonNodeWorkspaceButtonsInput = {
  buttonNodeId: Scalars['ID']
  workspaceButtons: Array<CreateButtonNodeWorkspaceButtonInput>
}

export type CreateButtonTransitionInput = {
  logicExpression: ParentLogicExpressionInput
  name?: InputMaybe<Scalars['String']>
  sourceNodeId: Scalars['ID']
  targetNodeId: Scalars['ID']
}

export type CreateChartGroupBySortInput = {
  aggregationOperation?: InputMaybe<AggregationOperation>
  aggregationTableColumnId?: InputMaybe<Scalars['ID']>
  direction: SortDirection
  sortType: ChartGroupBySortType
}

export type CreateChartInput = {
  aggregationColumns?: InputMaybe<Array<ChartAggregationColumnInput>>
  aggregationOperation?: InputMaybe<AggregationOperation>
  chartSubType: ChartSubType
  filters?: InputMaybe<Array<TableColumnFilterInput>>
  filtersBooleanOperator?: InputMaybe<BooleanOperator>
  groupBys?: InputMaybe<Array<CreateGroupByInput>>
  name: Scalars['String']
  thresholds?: InputMaybe<Array<Scalars['Float']>>
  workspaceId?: InputMaybe<Scalars['ID']>
  xAxisColumnId?: InputMaybe<Scalars['ID']>
  yAxisColumnId?: InputMaybe<Scalars['ID']>
}

export type CreateChildTableInput = {
  columns: Array<CreateTableColumnInput>
  description?: InputMaybe<Scalars['String']>
  iconId?: InputMaybe<Scalars['ID']>
  /** Authored identity for the table's logical binding; omit to mint one from the name */
  logicalId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  parentTableId: Scalars['ID']
}

export type CreateCommentInput = {
  mentionedUserIds?: InputMaybe<Array<Scalars['ID']>>
  /** The object this comment is being created in */
  objectId: Scalars['ID']
  objectType: BreadcrumbObjectType
  /** The ID of the comment this comment is replying to, if any */
  parentCommentId?: InputMaybe<Scalars['ID']>
  text: Scalars['String']
}

export type CreateDocumentViewInput = {
  file: Scalars['FileInput']
  name: Scalars['String']
  /** Provide organization ID for unauth endpoints */
  organizationId?: InputMaybe<Scalars['ID']>
  view?: InputMaybe<ViewInput>
}

export type CreateDossbotChatInput = {
  breadcrumb?: InputMaybe<BreadcrumbsInput>
  prompt: Scalars['String']
}

export type CreateDossbotChatRunInput = {
  breadcrumb?: InputMaybe<BreadcrumbsInput>
  chatId: Scalars['ID']
  inputPrompt: Scalars['String']
}

export type CreateFormCategoryInput = {
  formPageId: Scalars['ID']
  isArray: Scalars['Boolean']
  lookupTableId?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
  order: Scalars['Int']
}

export type CreateFormFieldInput = {
  defaultValue?: InputMaybe<Scalars['JSONObject']>
  description?: InputMaybe<Scalars['String']>
  displayImagesInline: Scalars['Boolean']
  fieldOptions?: InputMaybe<Array<Scalars['String']>>
  formCategoryId: Scalars['ID']
  isArray: Scalars['Boolean']
  isEditable: Scalars['Boolean']
  isFrozen: Scalars['Boolean']
  isRequired: Scalars['Boolean']
  isVisible: Scalars['Boolean']
  lookupColumnId?: InputMaybe<Scalars['ID']>
  metadata?: InputMaybe<Scalars['JSONObject']>
  name: Scalars['String']
  order: Scalars['Int']
  type: FormFieldType
}

export type CreateFormInput = {
  name?: InputMaybe<Scalars['String']>
  /** If redirectTarget = CUSTOM_PATH, this field stores the target path (e.g. '/projects/123/summary') */
  redirectCustomPath?: InputMaybe<Scalars['String']>
  /** Optional redirect behaviour after successful submission */
  redirectTarget?: InputMaybe<FormRedirectTarget>
  workspaceId?: InputMaybe<Scalars['ID']>
}

export type CreateFormInputBlockInput = {
  defaultValue?: InputMaybe<Scalars['JSONObject']>
  description?: InputMaybe<Scalars['String']>
  /** Provide the id of an existing lookup input group, if applicable */
  existingLookupInputGroupId?: InputMaybe<Scalars['ID']>
  formId: Scalars['ID']
  /** Variant-specific format configuration whose shape depends on formatPreset. */
  formatOptions?: InputMaybe<Scalars['JSONObject']>
  /** Display-only number/date format preset. Pairs with formatOptions; must be cleared together. */
  formatPreset?: InputMaybe<FormatPreset>
  /** Provide the formula that computes this input's value, when inputType = FORMULA */
  formulaInput?: InputMaybe<ParentFormulaInput>
  inputMetadata?: InputMaybe<Scalars['JSONObject']>
  inputType: FormInputType
  isAutoFill?: InputMaybe<Scalars['Boolean']>
  isFrozen: Scalars['Boolean']
  isMultiSelect?: InputMaybe<Scalars['Boolean']>
  isReadOnly: Scalars['Boolean']
  isRequired: Scalars['Boolean']
  isVisible: Scalars['Boolean']
  label: Scalars['String']
  /** Provide the input for the lookup filter expression, if applicable */
  lookupFilterExpressionInput?: InputMaybe<ParentLogicExpressionInput>
  /** Provide the source table column for the lookup, if applicable */
  lookupTableColumnId?: InputMaybe<Scalars['ID']>
  /** Order within the parent block */
  order: Scalars['Int']
  parentBlockId: Scalars['ID']
  /** Link this form input to a table column to auto-sync properties */
  sourceTableColumnId?: InputMaybe<Scalars['ID']>
  /** Provide any dynamic validation rules */
  validationRules: Array<FormValidationConditionInput>
  /** Provide any visibility conditions - either reference to existing by id or create a new one by value */
  visibilityConditions: Array<FormVisibilityConditionInput>
}

/** SECTION, TEXT_ELEMENT, and DIVIDER are layout blocks */
export type CreateFormLayoutBlockInput = {
  formBlockMetadata?: InputMaybe<Scalars['JSONObject']>
  formBlockType: FormBlockType
  formId: Scalars['ID']
  /** Order within the parent block, or within the form if it is a SECTION */
  order: Scalars['Int']
  /** Required for all types except SECTION */
  parentBlockId?: InputMaybe<Scalars['ID']>
  /** Provide any visibility conditions - either reference to existing by id or create a new one by value */
  visibilityConditions: Array<FormVisibilityConditionInput>
}

export type CreateFormPageInput = {
  formId: Scalars['ID']
  name: Scalars['String']
  order: Scalars['Int']
}

export type CreateFormRowBlockInput = {
  formId: Scalars['ID']
  /** Order within the parent block */
  order: Scalars['Int']
  orderedChildBlocks?: InputMaybe<Array<FormRowChildBlockInput>>
  parentBlockId: Scalars['ID']
}

export type CreateFormTableBlockInput = {
  formId: Scalars['ID']
  formInputGroupLabel: Scalars['String']
  /** Order within the parent block */
  order: Scalars['Int']
  parentBlockId: Scalars['ID']
  /** Provide any visibility conditions - either reference to existing by id or create a new one by value */
  visibilityConditions: Array<FormVisibilityConditionInput>
}

export type CreateFormVariantInput = {
  description?: InputMaybe<Scalars['String']>
  formId: Scalars['ID']
  name: Scalars['String']
  /** Pre-filled values for form inputs (can be empty, values can be added later) */
  variantInputs: Array<VariantInputValue>
}

export type CreateFormVisibilityConditionInput = {
  expression: ParentLogicExpressionInput
  formBlockIds: Array<Scalars['ID']>
  formId: Scalars['ID']
  name: Scalars['String']
}

export type CreateGroupByInput = {
  metadata?: InputMaybe<GroupByMetadata>
  sort?: InputMaybe<CreateChartGroupBySortInput>
  tableColumnId: Scalars['ID']
}

export type CreateIntegrationInput = {
  credentials?: InputMaybe<IntegrationCredentialInput>
  /**
   * Certain integrations require custom metadata to be passed in that doesn't go into the integration
   * metadata field
   */
  customMetadata?: InputMaybe<Scalars['JSONObject']>
  metadata: Scalars['JSONObject']
  organizationId: Scalars['String']
  type: IntegrationType
}

/** Result of creating an OAuth2 authorization request */
export type CreateOAuth2AuthorizationResult = {
  __typename: 'CreateOAuth2AuthorizationResult'
  error: Maybe<Scalars['String']>
  requestId: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type CreateObjectStoreTableSyncInput = {
  daysOfWeek: Array<Scalars['Int']>
  direction: ObjectStoreTransferDirection
  filePattern: Scalars['String']
  fileType: ObjectStoreTransferFileType
  ignoreMissingColumns: Scalars['Boolean']
  integrationId: Scalars['ID']
  repeatNumber: Scalars['Int']
  repeatUnit: CalendarUnit
  /** When omitted, the sync starts immediately. */
  startAt?: InputMaybe<Scalars['DateTime']>
  tableId: Scalars['ID']
}

export type CreateOrUpdateTableCellInput = {
  data?: InputMaybe<Scalars['JSONObject']>
  documentIds?: InputMaybe<Array<Scalars['ID']>>
  lookupCellIds?: InputMaybe<Array<Scalars['ID']>>
  tableColumnId: Scalars['ID']
  userIds?: InputMaybe<Array<Scalars['ID']>>
}

export type CreateRoleInput = {
  name: Scalars['String']
  permissions: Array<PermissionInput>
}

export type CreateSignatureInput = {
  file: Scalars['FileInput']
  formId: Scalars['ID']
  linkUserToSignature?: InputMaybe<Scalars['Boolean']>
  organizationId?: InputMaybe<Scalars['ID']>
}

export type CreateTableColumnFilterInput = {
  chartId?: InputMaybe<Scalars['ID']>
  filterableObjectType: FilterableObjectType
  operand: Scalars['JSONObject']
  operator: FilterOperator
  /** System-generated column to filter on (e.g. Created at). Omit when filtering on a table column. */
  systemGeneratedColumnType?: InputMaybe<SystemGeneratedTableColumnType>
  /** Table column to filter on. Omit when filtering on a system-generated column. */
  tableColumnId?: InputMaybe<Scalars['ID']>
  tableTabId?: InputMaybe<Scalars['ID']>
}

export type CreateTableColumnGroupInput = {
  columns: Array<Scalars['ID']>
  name: Scalars['String']
  order: Scalars['Int']
  tableId: Scalars['ID']
}

export type CreateTableColumnGroupMemberInput = {
  tableColumnGroupId: Scalars['ID']
  tableColumnId: Scalars['ID']
}

export type CreateTableColumnGroupMembersInput = {
  tableColumnGroupId: Scalars['ID']
  tableColumnIds: Array<Scalars['ID']>
}

export type CreateTableColumnInput = {
  /** For columns that can't be nullable, set a default value to initialize existing rows. */
  defaultValue?: InputMaybe<Scalars['JSONObject']>
  description?: InputMaybe<Scalars['String']>
  /** For DataType = File or InnerType = File, indicates whether images should be displayed inline */
  displayImagesInline: Scalars['Boolean']
  enumOptionInputs?: InputMaybe<Array<EnumOptionInput>>
  /** @deprecated Use enumOptionInputs, which also carries per-option color and order. */
  enumOptions?: InputMaybe<Array<Scalars['String']>>
  formatOptions?: InputMaybe<Scalars['JSONObject']>
  formatPreset?: InputMaybe<FormatPreset>
  /** For DataType = Formula, specify the input to create the associated formula */
  formula?: InputMaybe<ParentFormulaInput>
  indexAutogenerate: Scalars['Boolean']
  indexPrefix: Scalars['String']
  indexSuffix: Scalars['String']
  indexType: IndexType
  innerType?: InputMaybe<DataType>
  /** NUMBER columns only: read and written as an exact decimal by workflows-as-code. Defaults to false. */
  isDecimal?: InputMaybe<Scalars['Boolean']>
  isNullable: Scalars['Boolean']
  isReadOnly: Scalars['Boolean']
  /** Authored identity for the column's logical binding; omit to mint one from the name */
  logicalId?: InputMaybe<Scalars['String']>
  lookupBacklinkName?: InputMaybe<Scalars['String']>
  lookupColumnGroupId?: InputMaybe<Scalars['ID']>
  lookupColumnId?: InputMaybe<Scalars['ID']>
  lookupFilterExpression?: InputMaybe<ParentLogicExpressionInput>
  /** Authored identity for a lookup group this column creates; only with lookupTableId */
  lookupGroupLogicalId?: InputMaybe<Scalars['String']>
  lookupTableId?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
  showLookupBacklink: Scalars['Boolean']
  tableId: Scalars['ID']
  /** If provided, will create a TableTabColumn in this TableTab for the newly created TableColumn */
  tableTabId?: InputMaybe<Scalars['ID']>
  type: DataType
}

/** Input for creating a table CSV export */
export type CreateTableExportInput = {
  backlinkColumnId?: InputMaybe<Scalars['ID']>
  backlinkRowId?: InputMaybe<Scalars['ID']>
  columnIds: Array<Scalars['ID']>
  exportChildWithParentRow?: InputMaybe<Scalars['Boolean']>
  fileName: Scalars['String']
  filterBooleanOperator?: InputMaybe<BooleanOperator>
  filters?: InputMaybe<Array<TableFilterInput>>
  includeRecordId: Scalars['Boolean']
  parentRowId?: InputMaybe<Scalars['ID']>
  sorts?: InputMaybe<Array<TableSortInput>>
  tableId: Scalars['ID']
  tableTabId?: InputMaybe<Scalars['ID']>
}

export type CreateTableInput = {
  columns: Array<CreateTableColumnInput>
  description?: InputMaybe<Scalars['String']>
  iconId?: InputMaybe<Scalars['ID']>
  /** Authored identity for the table's logical binding; omit to mint one from the name */
  logicalId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  parentWorkspaceId: Scalars['ID']
}

export type CreateTableRowInput = {
  /** Initialize cells with these values. For any unprovided cells, set them to Null. */
  cells: Array<CreateOrUpdateTableCellInput>
  /** For child rows, a parent row must be specified */
  parentRowId?: InputMaybe<Scalars['ID']>
  tableId: Scalars['ID']
}

export type CreateTableTabColumnInput = {
  order: Scalars['Int']
  /** System-generated column to show. Omit when adding a table column. */
  systemGeneratedColumnType?: InputMaybe<SystemGeneratedTableColumnType>
  /** Table column to show. Omit when adding a system-generated column. */
  tableColumnId?: InputMaybe<Scalars['ID']>
  tableTabId: Scalars['ID']
}

export type CreateTableTabInput = {
  /** Logic operator to be used if tab has more than one filter */
  booleanOperator?: InputMaybe<BooleanOperator>
  columns: Array<TableTabColumnInput>
  filters: Array<TableColumnFilterInput>
  name?: InputMaybe<Scalars['String']>
  /** Do not support multiple sorts currently */
  sorts: Array<TableTabSortInput>
  tableId: Scalars['ID']
}

export type CreateTableTabSortInput = {
  direction: SortDirection
  systemGeneratedColumnType?: InputMaybe<SystemGeneratedTableColumnType>
  tableColumnId?: InputMaybe<Scalars['ID']>
  tableTabId: Scalars['ID']
}

export type CreateTableUniqueConstraintInput = {
  /** Ordered IDs of the columns that form the uniqueness key */
  columnIds: Array<Scalars['ID']>
  name: Scalars['String']
  /** Whether NULLs count as distinct values; defaults to true */
  nullsDistinct?: InputMaybe<Scalars['Boolean']>
  scope: TableUniqueConstraintScope
  tableId: Scalars['ID']
}

export type CreateUserInput = {
  /** At least one of email or phoneNumber must be provided */
  email?: InputMaybe<Scalars['String']>
  firstName: Scalars['String']
  lastName: Scalars['String']
  orientation: ApplicationOrientation
  phoneNumber?: InputMaybe<Scalars['String']>
  roleIds: Array<Scalars['ID']>
}

export type CreateViewInput = {
  /** EMBED only: name the inline-created embed. */
  embedName?: InputMaybe<Scalars['String']>
  /** EMBED only: associate guest content in the same transaction as the placement. */
  embedViewContentId?: InputMaybe<Scalars['ID']>
  properties?: InputMaybe<Scalars['JSONObject']>
  view: ViewInput
  viewableObjectId: Scalars['ID']
  viewableObjectType: ViewableObjectType
}

export type CreateWorkspaceButtonInput = {
  buttonConfiguration?: InputMaybe<Scalars['JSONObject']>
  buttonNodeId?: InputMaybe<Scalars['ID']>
  confirmationMessage?: InputMaybe<Scalars['String']>
  formId?: InputMaybe<Scalars['ID']>
  iconId?: InputMaybe<Scalars['ID']>
  /** Authored identity for the button's logical binding; omit to mint one from the name */
  logicalId?: InputMaybe<Scalars['String']>
  manualTriggerId?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
  parentWorkspaceId?: InputMaybe<Scalars['ID']>
  requiresConfirmation?: InputMaybe<Scalars['Boolean']>
}

export type CreateWorkspaceInput = {
  /**
   * Nested: the workspace where the view containing the new workspace will live.
   * It should be the current root workspace by default.
   * Exactly one of enclosingWorkspaceId and parentOrganizationId is required.
   */
  enclosingWorkspaceId?: InputMaybe<Scalars['String']>
  /** Authored identity for the workspace's logical binding; omit to mint one from the name */
  logicalId?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  /**
   * Root: the organization the new workspace hangs directly under. Must be the caller's
   * organization. Creates a top-level workspace with no View, ordered after the existing roots.
   * Exactly one of enclosingWorkspaceId and parentOrganizationId is required.
   */
  parentOrganizationId?: InputMaybe<Scalars['ID']>
}

export enum Currency {
  AUD = 'AUD',
  CAD = 'CAD',
  EUR = 'EUR',
  GBP = 'GBP',
  HKD = 'HKD',
  ILS = 'ILS',
  MYR = 'MYR',
  NZD = 'NZD',
  SGD = 'SGD',
  USD = 'USD',
}

export enum DataStoreVariableType {
  ARRAY_NUMBER = 'ARRAY_NUMBER',
  ARRAY_STRING = 'ARRAY_STRING',
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
}

/**
 * List of different primitive types allowed for a table's cell data
 * - id (special type of text): ID
 * - text: STRING
 * - number: NUMBER
 * - select: LOOKUP and ENUM
 * - date: DATE
 * - file: FILE
 * - relation: LOOKUP
 * - checkbox: BOOLEAN
 * - formula: FORMULA_NUMBER / FORMULA_STRING / FORMULA_DATE / FORMULA_DATE_TIME
 * - user: USER
 *
 * To make any one of these as a multi-select or array of items, the column would set isArray = true
 */
export enum DataType {
  ARRAY = 'ARRAY',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
  ENUM = 'ENUM',
  FILE_URL = 'FILE_URL',
  FORMULA_BOOLEAN = 'FORMULA_BOOLEAN',
  FORMULA_DATE = 'FORMULA_DATE',
  FORMULA_DATE_TIME = 'FORMULA_DATE_TIME',
  FORMULA_NUMBER = 'FORMULA_NUMBER',
  FORMULA_STRING = 'FORMULA_STRING',
  ID = 'ID',
  LOOKUP = 'LOOKUP',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  USER = 'USER',
}

export enum DayOfWeek {
  FRIDAY = 'Friday',
  MONDAY = 'Monday',
  SATURDAY = 'Saturday',
  SUNDAY = 'Sunday',
  THURSDAY = 'Thursday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
}

/** Input for pre-flight delete blocking check (single row) */
export type DeleteBlockingCheckInput = {
  /** The row to check for blocking references */
  rowId: Scalars['ID']
}

/** Result of pre-flight delete blocking check */
export type DeleteBlockingCheckResult = {
  __typename: 'DeleteBlockingCheckResult'
  /** Number of rows that are blocked from deletion */
  blockedCount: Scalars['Int']
  /** Blocking info for each row (only includes rows that have blocking references) */
  blockedRows: Array<RowDeleteBlockingInfo>
  /** Number of rows that can be deleted */
  deletableCount: Scalars['Int']
  /** Total number of rows checked */
  totalCount: Scalars['Int']
}

/** A blocking reference that prevents deletion of a row, with relationship context */
export type DeleteBlockingReference = {
  __typename: 'DeleteBlockingReference'
  /** ID of the column containing the non-nullable lookup reference */
  columnId: Scalars['ID']
  /** Name of the column containing the non-nullable lookup reference */
  columnName: Scalars['String']
  /** The row that is blocking deletion */
  row: TableRow
  /** ID of the table containing the blocking row */
  tableId: Scalars['ID']
  /** Name of the table containing the blocking row */
  tableName: Scalars['String']
}

export type DeleteFormInput = {
  formId: Scalars['ID']
  unshareTableIds?: InputMaybe<Array<Scalars['ID']>>
}

export type DeleteOrganizationResult = {
  __typename: 'DeleteOrganizationResult'
  jobId: Maybe<Scalars['ID']>
  jobUrl: Maybe<Scalars['String']>
  message: Scalars['String']
  success: Scalars['Boolean']
}

export type DeleteTableColumnGroupMembersInput = {
  tableColumnGroupId: Scalars['ID']
  tableColumnGroupMemberIds: Array<Scalars['ID']>
}

export type DeleteTableColumnInput = {
  /** Optional: If true, delete ALL form inputs linked to this column */
  deleteAllLinkedFormInputs?: InputMaybe<Scalars['Boolean']>
  /** Optional: Specific form input IDs to delete (must be linked to this column) */
  formInputIds?: InputMaybe<Array<Scalars['ID']>>
  /** The ID of the table column to delete */
  tableColumnId: Scalars['ID']
}

export type DeleteTableColumnsInput = {
  tableColumnIds: Array<Scalars['ID']>
  tableId: Scalars['ID']
}

/** Result of deleting a single table row */
export type DeleteTableRowResult = {
  __typename: 'DeleteTableRowResult'
  /** References blocking the delete, with column and table context */
  blockingReferences: Array<DeleteBlockingReference>
  /** Rows currently blocking the delete, ordered by createdAt then id */
  blockingRows: Array<TableRow>
  /** Any errors encountered while preparing the delete */
  errors: Maybe<Array<BulkActionError>>
  /** The row that was queued for deletion */
  row: Maybe<TableRow>
}

export type DeleteTableRowsInput = {
  /** Optional child table ID - used when deleting by parent row IDs to specify which child table */
  childTableId?: InputMaybe<Scalars['ID']>
  /** Optional list of parent row IDs - deletes all child rows under these parents */
  parentRowIds?: InputMaybe<Array<Scalars['ID']>>
  /** Optional list of specific row IDs to delete */
  rowIds?: InputMaybe<Array<Scalars['ID']>>
  tableId: Scalars['ID']
}

export type DisconnectFormBlockFromVisibilityConditionInput = {
  formBlockId: Scalars['ID']
  formVisibilityConditionId: Scalars['ID']
}

/** A document pulled either from an email attachment, uploaded by a user, or created as an export */
export type Document = {
  __typename: 'Document'
  /** If this document represents the image for an action auto trigger, this is the inverse relation */
  actionAutoTrigger: Maybe<ActionAutoTrigger>
  /** If this document represents the image for an action step, this is the inverse relation */
  actionStep: Maybe<ActionStep>
  /**
   * SHA-256 of the exact stored bytes, as 64 lowercase hex characters. Null for documents created
   * before the fingerprint existed, and for uploads streamed rather than buffered.
   */
  contentSha256: Maybe<Scalars['String']>
  /** Size of the stored bytes. Null wherever contentSha256 is null. */
  contentSizeBytes: Maybe<Scalars['Int']>
  createdAt: Scalars['DateTime']
  /** The user that created this document, null if created by the system or before property was added */
  createdBy: Maybe<Membership>
  /** Deprecated: The user string ID is now a UUID */
  createdById_deprecated: Maybe<Scalars['String']>
  documentType: DocumentType
  id: Scalars['ID']
  /** If this document represents the logo of an organization, this is the inverse relation */
  logoForOrganization: Maybe<Organization>
  /**
   * Set when the document is marked for deletion [PLAT-755]. Writers refuse to store references to
   * such documents; a later step filters them from reads and a sweep job hard-deletes them. Null for
   * live documents.
   */
  markForDeletionAt: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  /** The organization that owns this document */
  organization: Organization
  /** If this document is an organization export zip file, this is the inverse relation */
  organizationExport: Maybe<OrganizationExport>
  /** The workspace that contains this document as its root view */
  rootWorkspace: Workspace
  /** If this document refers to a signature file, this is the signature */
  signature: Maybe<Signature>
  /** Documents should be stored at some hosted location i.e. a GCP storage bucket */
  storagePath: Scalars['String']
  /** The actual URL of the storage path isn't stored in the DB. Instead it is computed and returned. */
  storageUrl: Scalars['String']
  /** If this document is a CSV export file, this is the inverse relation */
  tableExport: Maybe<TableExport>
  updatedAt: Scalars['DateTime']
  updatedBy: Maybe<Membership>
  updatedById_deprecated: Maybe<Scalars['String']>
  /** If this document represents the profile picture of a user, this is the inverse relation */
  user: Maybe<Membership>
  /** The views backed by this document */
  views: Array<View>
}

/** List of supported document types for upload or from email attachments */
export enum DocumentType {
  AI = 'AI',
  CSV = 'CSV',
  DOC = 'DOC',
  DOCX = 'DOCX',
  DWG = 'DWG',
  GIF = 'GIF',
  HTML = 'HTML',
  JPEG = 'JPEG',
  JPG = 'JPG',
  PDF = 'PDF',
  PNG = 'PNG',
  PPT = 'PPT',
  PPTX = 'PPTX',
  SIF = 'SIF',
  STEP = 'STEP',
  SVG = 'SVG',
  /** 3DM but enum can't start with a number */
  THREEDM = 'THREEDM',
  TXT = 'TXT',
  WEBP = 'WEBP',
  XLS = 'XLS',
  XLSM = 'XLSM',
  XLSX = 'XLSX',
  ZIP = 'ZIP',
  ZPL = 'ZPL',
}

/** CHAT = a single chat window/tab on the client */
export type DossbotChat = {
  __typename: 'DossbotChat'
  createdBy: Membership
  /** Deprecated: The user string ID is now a UUID */
  createdById_deprecated: Maybe<Scalars['String']>
  /** Events associated with this chat */
  events: Array<DossbotEvent>
  id: Scalars['ID']
  /**
   * The ordered user prompt runs for this chat, each is 1:1 with a typed in message from a user in the
   * chat window
   */
  runs: Array<DossbotChatRun>
  /** Summary of the chat that is updated after each user prompt run */
  summary: Maybe<Scalars['String']>
  /** Title of the chat, generated during the first user prompt run */
  title: Scalars['String']
}

/** Information about a single agent run that was triggered by some user prompt */
export type DossbotChatRun = {
  __typename: 'DossbotChatRun'
  /** The agent runs that were used to generate the response for this chat run */
  agentRuns: Array<AgentRun>
  /** The chat this agent run is associated with */
  chat: DossbotChat
  completedAt: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  events: Array<DossbotEvent>
  id: Scalars['ID']
  /** The user prompt that was passed to this run of the agent */
  inputPrompt: Scalars['String']
  /** Response generated based on the result of the run */
  response: Maybe<Scalars['String']>
  status: DossbotChatRunStatus
}

export enum DossbotChatRunStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
}

/** Events associated with any run of the DossBot (chat runs, agent runs, tool runs) */
export type DossbotEvent = {
  __typename: 'DossbotEvent'
  agentRun: Maybe<AgentRun>
  chat: Maybe<DossbotChat>
  chatRun: Maybe<DossbotChatRun>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  payload: Scalars['JSONObject']
  toolRunStep: Maybe<ToolRunStep>
  type: DossbotEventType
}

export enum DossbotEventType {
  AGENT_RUN_CANCELED = 'AGENT_RUN_CANCELED',
  AGENT_RUN_COMPLETED = 'AGENT_RUN_COMPLETED',
  AGENT_RUN_FAILED = 'AGENT_RUN_FAILED',
  AGENT_RUN_STARTED = 'AGENT_RUN_STARTED',
  CHAT_RUN_CANCELED = 'CHAT_RUN_CANCELED',
  CHAT_RUN_COMPLETED = 'CHAT_RUN_COMPLETED',
  CHAT_RUN_FAILED = 'CHAT_RUN_FAILED',
  CHAT_RUN_STARTED = 'CHAT_RUN_STARTED',
  CHAT_SUMMARY_UPDATED = 'CHAT_SUMMARY_UPDATED',
  CHAT_TITLE_UPDATED = 'CHAT_TITLE_UPDATED',
  TOOL_RUN_APPROVED = 'TOOL_RUN_APPROVED',
  TOOL_RUN_CANCELED = 'TOOL_RUN_CANCELED',
  TOOL_RUN_COMPLETED = 'TOOL_RUN_COMPLETED',
  TOOL_RUN_FAILED = 'TOOL_RUN_FAILED',
  TOOL_RUN_PENDING = 'TOOL_RUN_PENDING',
  TOOL_RUN_REJECTED = 'TOOL_RUN_REJECTED',
  TOOL_RUN_STARTED = 'TOOL_RUN_STARTED',
}

export type DuplicateChartInput = {
  chartId: Scalars['ID']
  shouldCreateLinkedView?: InputMaybe<Scalars['Boolean']>
  viewParentWorkspaceId?: InputMaybe<Scalars['ID']>
}

export type DuplicateViewInput = {
  /** The workspace that this view is to be created in */
  parentWorkspaceId?: InputMaybe<Scalars['ID']>
  viewId: Scalars['ID']
  viewableObjectType: ViewableObjectType
}

/** One app's compiled bundle and where it belongs, as `doss deploy --app` uploads it */
export type DynamicAppArtifactInput = {
  /** The compiled ESM bundle — accepted as-is after verification; the server never bundles */
  code: Scalars['String']
  /** Logical ids of the endpoints the bundle calls; each must be deployed and callable from an app. Omitted means none */
  endpoints?: InputMaybe<Array<Scalars['String']>>
  /** The exact SDK patch this was built against; must match the deploy's sdkVersion */
  sdkVersion: Scalars['String']
  /** sha256 hex digest of code, verified against the bytes before anything is written */
  sha256: Scalars['String']
  /** The logical id declared at application('…'), which becomes its ViewContent slug */
  slug: Scalars['String']
  /** The tables the app reaches, as a workflow build manifest carries them (`ManifestTable`); deploy resolves them into the mappings the frame boots with. Omitted means none */
  tables?: InputMaybe<Array<Scalars['JSONObject']>>
  /** Slugs of every workspace from withWorkspaceBySlugDeprecated. Deploy removes the app from any other workspace (with allowDestructive). Empty means no placement: the app is reachable only at /embed/{id} */
  workspaceSlugs: Array<Scalars['String']>
}

/** A single planned app deploy action */
export type DynamicAppDeployAction = {
  __typename: 'DynamicAppDeployAction'
  /** The app key the action targets */
  app: Scalars['String']
  detail: Scalars['JSONObject']
  kind: DynamicAppDeployActionKind
}

export enum DynamicAppDeployActionKind {
  APP_CREATE = 'APP_CREATE',
  APP_NOOP = 'APP_NOOP',
  APP_ORPHANED = 'APP_ORPHANED',
  APP_PUBLISH = 'APP_PUBLISH',
  PLACEMENT_CREATE = 'PLACEMENT_CREATE',
  PLACEMENT_DESTROY = 'PLACEMENT_DESTROY',
  PLACEMENT_NOOP = 'PLACEMENT_NOOP',
  PLACEMENT_ORPHANED = 'PLACEMENT_ORPHANED',
}

/** An app deploy finding. A WARNING is advisory and leaves the action list intact; anything else blocks. */
export type DynamicAppDeployDiagnostic = {
  __typename: 'DynamicAppDeployDiagnostic'
  /** The app key, or null when the finding is about the deploy as a whole */
  app: Maybe<Scalars['String']>
  code: DynamicAppDeployDiagnosticCode
  message: Scalars['String']
  severity: WorkflowV2DiagnosticSeverity
}

export enum DynamicAppDeployDiagnosticCode {
  APP_BUILD_INVALID = 'APP_BUILD_INVALID',
  INVALID_APP = 'INVALID_APP',
  KIND_DRIFT = 'KIND_DRIFT',
  PLAN_CHANGED = 'PLAN_CHANGED',
  SNAPSHOT_INCOMPLETE = 'SNAPSHOT_INCOMPLETE',
  UNKNOWN_WORKSPACE = 'UNKNOWN_WORKSPACE',
  UNRESOLVED_COLUMN = 'UNRESOLVED_COLUMN',
  UNRESOLVED_ENDPOINT = 'UNRESOLVED_ENDPOINT',
  UNRESOLVED_TABLE = 'UNRESOLVED_TABLE',
}

export type DynamicAppDeployInput = {
  /** Remove an app from a workspace its code no longer lists. Without it the placement is reported and left */
  allowDestructive?: InputMaybe<Scalars['Boolean']>
  /** The selection: apps to deploy */
  apps: Array<DynamicAppArtifactInput>
  /** Logical ids of endpoints the same `doss deploy` publishes first; the app plan counts them as deployed */
  deployingEndpoints?: InputMaybe<Array<Scalars['String']>>
  /** Logical ids of every deployable (non-draft) app in the configbase — keeps orphan reporting correct */
  registeredApps: Array<Scalars['String']>
  /** The configbase's pinned SDK version; every app in one deploy shares it */
  sdkVersion: Scalars['String']
  /** The configbase source snapshot; shares the workflow deploy's input types deliberately */
  snapshot?: InputMaybe<WorkflowsV2SnapshotInput>
}

/** One executed action's outcome; failures do not halt later apps — re-running converges */
export type DynamicAppDeployOutcome = {
  __typename: 'DynamicAppDeployOutcome'
  app: Scalars['String']
  /** The Embed serving this app, so the CLI can print where to reach it */
  embedId: Maybe<Scalars['String']>
  kind: DynamicAppDeployActionKind
  message: Maybe<Scalars['String']>
  status: DynamicAppDeployOutcomeStatus
  /** The workspace slug a placement outcome is about; null for the app's main Embed itself */
  workspace: Maybe<Scalars['String']>
}

export enum DynamicAppDeployOutcomeStatus {
  APPLIED = 'APPLIED',
  FAILED = 'FAILED',
}

/** What an app deploy would do — apply executes exactly this plan or refuses */
export type DynamicAppDeployPlan = {
  __typename: 'DynamicAppDeployPlan'
  actions: Array<DynamicAppDeployAction>
  diagnostics: Array<DynamicAppDeployDiagnostic>
  planHash: Scalars['String']
  sdkVersion: Scalars['String']
}

export type DynamicAppDeployResult = {
  __typename: 'DynamicAppDeployResult'
  outcomes: Array<DynamicAppDeployOutcome>
  plan: DynamicAppDeployPlan
}

/** A ViewContent plus additional metadata */
export type DynamicAppSource = {
  __typename: 'DynamicAppSource'
  /** The content format, e.g. "react-tsx" */
  contentType: Scalars['String']
  /** The latest version's source bytes */
  contents: Scalars['String']
  /** Names of the embeds rendering this app, sorted. Empty when no embed points at it. */
  embedNames: Array<Scalars['String']>
  /** The ViewContent's id — stable, and the tiebreak when two apps would take the same directory */
  id: Scalars['ID']
  /** Latest version number. Note that we won't return 0 here, since an app with no stored bytes will not be listed */
  latestVersion: Scalars['Int']
  /** The app's logical id from its APP binding. Null when nothing binds it, e.g. no embed presents it */
  logicalId: Maybe<Scalars['String']>
  /** The authoring address, set only by `doss deploy`. Null for every UI-authored app */
  slug: Maybe<Scalars['String']>
  /** Slugs of the workspaces placing the app that the caller can view, oldest placement first */
  workspaceSlugs: Array<Scalars['String']>
}

/** Edge used to track the relations between workflows, forms, and tables */
export type Edge = {
  __typename: 'Edge'
  id: Scalars['ID']
  sourceNode: Node
  targetNode: Node
}

/** A generic embeddable surface placed on a workspace. Backs an EMBED view; its rendered source lives in the referenced ViewContent. */
export type Embed = {
  __typename: 'Embed'
  /**
   * The tiled BETA watermark over this embed's guest frame is hidden by default (null/true); an
   * explicit false shows it. There is no write path on purpose — the column is flipped directly
   * in the database.
   */
  betaWatermarkDisabled: Maybe<Scalars['Boolean']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  /** The human-readable name of this embed, shown in the workspace UI and editable via rename. */
  name: Scalars['String']
  /** The organization that owns this embed. */
  organization: Organization
  updatedAt: Scalars['DateTime']
  /**
   * The versioned guest source this embed renders (always the latest version). Null until content
   * is attached. Org duplication duplicates the content itself (latest version only, bytes copied
   * to a new GCS object with embedded ids remapped) and repoints this reference at the copy.
   */
  viewContent: Maybe<ViewContent>
}

/**
 * A deployed WaC endpoint: a synchronous, typed, answer-returning function declared at `endpoint('…')`
 * under the configbase's endpoints/ directory. Not durable and not a workflow — it has no triggers and
 * no Restate invocation; api dispatches it to the endpoints runtime and returns the result.
 */
export type Endpoint = {
  __typename: 'Endpoint'
  enabled: Scalars['Boolean']
  id: Scalars['ID']
  /** Callable from workflows and endpoints only, never from apps. */
  internal: Scalars['Boolean']
  latestVersion: Maybe<EndpointVersion>
  organization: Organization
  /** CALL_ENDPOINT grants, per role. */
  permissions: Array<Permission>
  /** Org-unique authoring address: the logical id declared at `endpoint('…')`, what deploy diffs by and what goes over the wire. GCS paths key by id, so renames never orphan bytes. */
  slug: Scalars['String']
  versions: Array<EndpointVersion>
}

/**
 * One keyed call of an endpoint, kept for the idempotency window so a retried call with the same key
 * replays the first output instead of running the handler again. Scoped to the endpoint, not its content
 * hash, so a retry across a redeploy replays too. The row is taken before the handler runs, so concurrent
 * callers under one key run it once. An in-progress row is leased for the call timeout, so a crashed call
 * frees its key soon; a saved output is kept for the TTL from the save. An expired row under the same key
 * is taken over by the next call, and a daily sweeper deletes the rest. Nothing archives or replicates them.
 */
export type EndpointIdempotencyKey = {
  __typename: 'EndpointIdempotencyKey'
  /** The current owner's claim, new on every acquire; a save or release under a stale claim matches nothing. */
  claimId: Scalars['ID']
  /** The EndpointVersion content the output came from. */
  contentHash: Scalars['String']
  endpoint: Endpoint
  /** The lease's end while IN_PROGRESS; the retention's end once COMPLETED. */
  expiresAt: Scalars['DateTime']
  id: Scalars['ID']
  /** Canonical hash of the input the key was first used with; a different input under the same key is rejected. */
  inputHash: Scalars['String']
  /** The caller's key, opaque to the platform. */
  key: Scalars['String']
  /** What the handler returned, once COMPLETED; a completed call may well have returned null. */
  output: Maybe<Scalars['JSONValue']>
  /** IN_PROGRESS while the handler runs; COMPLETED once `output` holds what it returned. */
  status: EndpointIdempotencyKeyStatus
}

/** Whether the call under a key has finished: a held key refuses concurrent callers, a completed one replays its output. */
export enum EndpointIdempotencyKeyStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export type EndpointVersion = {
  __typename: 'EndpointVersion'
  compilerVersion: Scalars['String']
  configbaseHash: Maybe<Scalars['String']>
  /** sha256 of the serialized artifact manifest, computed once at deploy: the version's identity. Never recomputed from `manifest` — the jsonb round trip does not preserve the bytes it hashed. */
  contentHash: Scalars['String']
  createdAt: Scalars['DateTime']
  createdBy: Maybe<Membership>
  endpoint: Endpoint
  /** Engine provenance (constant v1 — the engine is version-agnostic). */
  engineVersion: Scalars['String']
  id: Scalars['ID']
  /** The declared `.idempotency` (the build manifest's `endpoint.idempotency`): the key's path into the input. Null when only the caller keys a call. */
  idempotency: Maybe<Scalars['JSONObject']>
  /** The declared input schema (the build manifest's `endpoint.input`): the contract's home, read here and never from `manifest`. */
  input: Scalars['JSONObject']
  /** Set on the Endpoint whose latestVersion points here. */
  latestOf: Maybe<Endpoint>
  /** The artifact manifest as published (sourceHash, shim, build): everything the runtime needs to fetch and verify out.js, on the row instead of in GCS. Stored without the contract (`build.endpoint`), which `input`/`output`/`idempotency` carry; contentHash covered it. */
  manifest: Scalars['JSONObject']
  /** The deploy-resolved bindings (sdk/mappings.ts Mappings). Org-dependent, so rewritten on every deploy, a noop included; mappingsHash says which resolution this is. */
  mappings: Scalars['JSONObject']
  mappingsHash: Scalars['String']
  /** The declared output field (the build manifest's `endpoint.output`); null when the endpoint returns nothing. */
  output: Maybe<Scalars['JSONObject']>
  shimHash: Scalars['String']
  /** Guest shim version this source was bundled against. */
  shimVersion: Scalars['String']
  /** sha256 of out.js.map: outside contentHash and rewritten on every deploy of this content, since the map follows the authored source and the bundle does not. */
  sourceMapHash: Maybe<Scalars['String']>
  /** Monotonic per Endpoint. */
  version: Scalars['Int']
}

export type EntityVersionHistory = {
  __typename: 'EntityVersionHistory'
  /** The action this version belongs to (when entityType is ACTION) */
  action: Maybe<Action>
  /** A comment related to the scope of the changes made in the update */
  comment: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  /** The type of entity this version belongs to */
  entityType: EntityVersionHistoryEntityType
  /** Execution instances that used this specific action version */
  executionInstances: Array<ExecutionInstance>
  /** The formV2 this version belongs to (when entityType is FORM_V2) */
  formV2: Maybe<FormV2>
  id: Scalars['ID']
  /** The entity definition JSON stored directly */
  jsonSnapshot: Scalars['JSONObject']
  /** The email of the admin user who modified/created this version */
  modifiedBy: Maybe<Scalars['String']>
  /** The table this version belongs to (when entityType is TABLE) */
  table: Maybe<Table>
}

export enum EntityVersionHistoryEntityType {
  ACTION = 'ACTION',
  FORM_V2 = 'FORM_V2',
  TABLE = 'TABLE',
}

export enum EnumColorPreset {
  BLUE = 'BLUE',
  GRAY = 'GRAY',
  GREEN = 'GREEN',
  ORANGE = 'ORANGE',
  PURPLE = 'PURPLE',
  RED = 'RED',
  YELLOW = 'YELLOW',
}

/** A single colorable, ordered option within an EnumSet */
export type EnumOption = {
  __typename: 'EnumOption'
  /** Custom OKLCH channel values, e.g. 0.6 0.25 145 (L C H), mutually exclusive with colorPreset */
  colorCustom: Maybe<Scalars['String']>
  /** The preset color, mutually exclusive with colorCustom */
  colorPreset: Maybe<EnumColorPreset>
  enumSet: EnumSet
  /** The option's icon */
  icon: Maybe<Icon>
  /** The option's icon, as a DossIcon asset name */
  iconName: Maybe<Scalars['String']>
  id: Scalars['ID']
  label: Scalars['String']
  /** The sort order of this option within its set */
  order: Scalars['Int']
}

/**
 * A single enum option. Order is positional (the array index), so `enumOptionInputs` is a declarative
 * full set: options present are kept/updated, absent options are deleted. At most one of colorPreset or
 * colorCustom may be set.
 */
export type EnumOptionInput = {
  /** Custom color as OKLCH channel values "L C H" (no oklch() wrapper), e.g. "0.6 0.25 145" */
  colorCustom?: InputMaybe<Scalars['String']>
  colorPreset?: InputMaybe<EnumColorPreset>
  /** The option's icon */
  iconId?: InputMaybe<Scalars['ID']>
  label: Scalars['String']
}

/** An ordered, colorable set of options backing a table ENUM column */
export type EnumSet = {
  __typename: 'EnumSet'
  column: Maybe<TableColumn>
  id: Scalars['ID']
  options: Array<EnumOption>
  organization: Organization
}

/** An activity event that has occurred and is being surfaced. */
export type Event = {
  __typename: 'Event'
  createdAt: Scalars['DateTime']
  createdBy: Maybe<Membership>
  /** Deprecated: The user string ID is now a UUID */
  createdById_deprecated: Maybe<Scalars['String']>
  /**
   * Associated data for this event (e.g. entity that this event is about, before and after snapshots,
   * etc.)
   */
  data: Maybe<Scalars['JSONObject']>
  id: Scalars['ID']
  type: EventType
  /** The workspace this event is contained in */
  workspace: Workspace
}

export enum EventType {
  ACTION_END = 'ACTION_END',
  ACTION_START = 'ACTION_START',
  ACTION_STEP_NOTIFICATION = 'ACTION_STEP_NOTIFICATION',
  CREATE_CHART = 'CREATE_CHART',
  CREATE_DOCUMENT = 'CREATE_DOCUMENT',
  CREATE_TABLE = 'CREATE_TABLE',
  CREATE_TABLE_COLUMN = 'CREATE_TABLE_COLUMN',
  CREATE_TABLE_ROW = 'CREATE_TABLE_ROW',
  CREATE_TABLE_TAB = 'CREATE_TABLE_TAB',
  DELETE_CHART = 'DELETE_CHART',
  DELETE_DOCUMENT = 'DELETE_DOCUMENT',
  DELETE_TABLE = 'DELETE_TABLE',
  DELETE_TABLE_COLUMN = 'DELETE_TABLE_COLUMN',
  DELETE_TABLE_ROW = 'DELETE_TABLE_ROW',
  DELETE_TABLE_TAB = 'DELETE_TABLE_TAB',
  UPDATE_CHART = 'UPDATE_CHART',
  UPDATE_DOCUMENT = 'UPDATE_DOCUMENT',
  UPDATE_TABLE_CELL = 'UPDATE_TABLE_CELL',
  UPDATE_TABLE_COLUMN = 'UPDATE_TABLE_COLUMN',
  UPDATE_TABLE_ROW = 'UPDATE_TABLE_ROW',
  UPDATE_TABLE_TAB = 'UPDATE_TABLE_TAB',
}

export type ExecuteActionManualTriggerInput = {
  actionManualTriggerId: Scalars['ID']
  rowId?: InputMaybe<Scalars['ID']>
  triggerMetadata?: InputMaybe<Scalars['JSONObject']>
  workspaceButtonId?: InputMaybe<Scalars['ID']>
}

/** Input for executing a bulk action on multiple rows */
export type ExecuteBulkActionInput = {
  /** Current view filters to apply when selecting all rows */
  filters?: InputMaybe<Array<TableFilterInput>>
  /** If true and rowIds is null/empty, execute on all rows matching filters */
  isSelectAll?: InputMaybe<Scalars['Boolean']>
  /** If provided, execute only on these specific rows. If null/empty with isSelectAll=true, use filters. */
  rowIds?: InputMaybe<Array<Scalars['ID']>>
  /** Search string to apply when selecting all rows */
  searchString?: InputMaybe<Scalars['String']>
  tableId: Scalars['ID']
  workspaceButtonId: Scalars['ID']
}

/** Result of bulk action execution */
export type ExecuteBulkActionResult = {
  __typename: 'ExecuteBulkActionResult'
  /** Any errors encountered during execution */
  errors: Maybe<Array<BulkActionError>>
  /** Number of rows successfully queued for execution */
  executedCount: Scalars['Int']
  /** IDs of all rows that were executed */
  executedRowIds: Array<Scalars['ID']>
  /** Number of rows skipped (not eligible for this button) */
  skippedCount: Scalars['Int']
}

/**
 * Tracks the execution of workflows, action steps, and action step groups.
 * Used primarily for debugging and monitoring purposes.
 */
export type ExecutionInstance = {
  __typename: 'ExecutionInstance'
  /** The action that this run belongs to. */
  action: Maybe<Action>
  /** The action step that this run belongs to. */
  actionStep: Maybe<ActionStep>
  /** The action step group that this run belongs to. */
  actionStepGroup: Maybe<ActionStepGroup>
  /** The specific action version that was used for this execution */
  actionVersion: Maybe<EntityVersionHistory>
  /** The api trigger that this run belongs to. */
  apiTrigger: Maybe<ActionApiTrigger>
  /** Denormalized id of the action (preserved in case of action deletion) */
  archivedActionId: Maybe<Scalars['String']>
  /** Denormalized id of the actionStepGroup (preserved in case of actionStepGroup deletion) */
  archivedActionStepGroupId: Maybe<Scalars['String']>
  /** Denormalized id of the actionStep (preserved in case of actionStep deletion) */
  archivedActionStepId: Maybe<Scalars['String']>
  /** Attempt number from BullMQ, defaults to 0 */
  attemptNumber: Scalars['Int']
  /** The auto trigger that this run belongs to. */
  autoTrigger: Maybe<ActionAutoTrigger>
  /** The Bull queue name this execution instance was routed to */
  bullQueue: Maybe<Scalars['String']>
  /** The child execution instances that were triggered by this execution */
  childExecutionInstances: Array<ExecutionInstance>
  /** The time when the target job completed (successfully or with error) */
  completedAt: Maybe<Scalars['DateTime']>
  /** The time this ExecutionInstance was queued up */
  createdAt: Scalars['DateTime']
  /** Computed name of the applicable entity that this run belongs to */
  entityName: Maybe<Scalars['String']>
  /** The frequency trigger that this run belongs to. */
  frequencyTrigger: Maybe<ActionFrequencyTrigger>
  /** Whether this execution instance has child execution instances */
  hasChildren: Scalars['Boolean']
  id: Scalars['ID']
  /** Job ID - used to help link to the results in the Queue */
  jobId: Scalars['String']
  /** The manual trigger that this run belongs to */
  manualTrigger: Maybe<ActionManualTrigger>
  /** The parent execution instance that triggered this execution */
  parentExecutionInstance: Maybe<ExecutionInstance>
  /** Whether this execution instance ran in priority queues */
  priority: Maybe<Scalars['Boolean']>
  /** The time when the target job became active */
  startedAt: Maybe<Scalars['DateTime']>
  /** The status of the execution instance */
  status: Maybe<ExecutionInstanceStatus>
  /** The type of execution instance */
  type: ExecutionInstanceType
  /** The time this ExecutionInstance was updated */
  updatedAt: Scalars['DateTime']
}

export enum ExecutionInstanceStatus {
  FAILED = 'FAILED',
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
}

export enum ExecutionInstanceType {
  ACTION = 'ACTION',
  ACTION_STEP = 'ACTION_STEP',
  ACTION_STEP_GROUP = 'ACTION_STEP_GROUP',
  ACTION_STEP_WAIT = 'ACTION_STEP_WAIT',
  API_TRIGGER = 'API_TRIGGER',
  AUTO_TRIGGER = 'AUTO_TRIGGER',
  FREQUENCY_TRIGGER = 'FREQUENCY_TRIGGER',
  MANUAL_TRIGGER = 'MANUAL_TRIGGER',
}

/** Execution backend selected when an export is dispatched */
export enum ExportBackend {
  BULLMQ = 'BULLMQ',
  RESTATE = 'RESTATE',
}

export type FileProgress = {
  __typename: 'FileProgress'
  completedCount: Scalars['Int']
  objectId: Scalars['ID']
  /** When set (e.g. table export), total rows expected so the client can show percent */
  totalCount: Maybe<Scalars['Int']>
}

/** Ways to filter data in a table */
export enum FilterOperator {
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  ENDS_WITH = 'ENDS_WITH',
  EQUALS = 'EQUALS',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
  IN = 'IN',
  IS_ANY_OF = 'IS_ANY_OF',
  IS_DUPLICATE = 'IS_DUPLICATE',
  IS_EMPTY = 'IS_EMPTY',
  IS_NONE_OF = 'IS_NONE_OF',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
  IS_NOT_EQUAL_TO = 'IS_NOT_EQUAL_TO',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  NOT_IN = 'NOT_IN',
  NOT_IN_RANGE = 'NOT_IN_RANGE',
  RANGE = 'RANGE',
  STARTS_WITH = 'STARTS_WITH',
}

export enum FilterableObjectType {
  CHART = 'CHART',
  TABLE_TAB = 'TABLE_TAB',
}

/** A form is a collection of pages with fields that can be filled out by a user. */
export type Form = {
  __typename: 'Form'
  /** A list of buttons that can be used to trigger the form */
  buttons: Array<WorkspaceButton>
  /** A list of categories in this form */
  categories: Array<FormCategory>
  /** A list of fields in this form */
  fields: Array<FormField>
  /** A list of files that will be generated using the data from this form */
  formFiles: Array<FormFile>
  /** If the form was used to create a formV2, the formV2Id will be set */
  formV2: Maybe<FormV2>
  id: Scalars['ID']
  /** Allow a table to be accessed without authentication */
  isShareable: Scalars['Boolean']
  name: Scalars['String']
  /** The organization that owns this form */
  organization: Organization
  /** A list of pages with each of the form fields */
  pages: Array<FormPage>
  /** A list of permissions that control access to this form */
  permissions: Array<Permission>
  /** Optional custom path (used when redirectTarget = CUSTOM_PATH). Should be a path beginning with '/'. */
  redirectCustomPath: Maybe<Scalars['String']>
  /** When set, indicates where to redirect the user after successful submission */
  redirectTarget: FormRedirectTarget
  /** The slug of the form. This is automatically generated when the name is set. */
  slug: Scalars['String']
  /** Gets the workflows that are triggered by a form's submission */
  workflows: Array<Workflow>
}

/**
 * The JSON Schemas used to render the form inputs and UI components when creating an action step or
 * an auto trigger
 */
export type FormBasedCreatorSchema = {
  __typename: 'FormBasedCreatorSchema'
  formSchema: JsonSchema
  uiSchema: JsonSchema
}

/**
 * A form block is the core building block of forms.
 * It maintains the hierarchical structure and visual layout of a form.
 */
export type FormBlock = {
  __typename: 'FormBlock'
  childBlocks: Array<FormBlock>
  form: FormV2
  id: Scalars['ID']
  /** The input wrapped in an input block, required if type = INPUT */
  input: Maybe<FormInput>
  /** The group that represents the data relationship of a table block, required if type = TABLE */
  inputGroup: Maybe<FormInputGroup>
  /**
   * JSON object that stores additional configuration data based on block type.
   * Required for:
   * - TEXT_ELEMENT blocks: Stores type information (BANNER, DESCRIPTION, HEADER),
   *   formatting options like background colors and rich text content.
   * - SECTION blocks: Stores section labels.
   */
  metadata: Maybe<Scalars['JSONObject']>
  order: Scalars['Int']
  parentBlock: Maybe<FormBlock>
  type: FormBlockType
  /**
   * The form block is visible if any of the visibility conditions evaluate to true,
   * or if there are no visibilty conditions applied to it.
   */
  visibilityConditions: Array<FormVisibilityCondition>
}

export enum FormBlockType {
  /** A visual divider that separates form blocks */
  DIVIDER = 'DIVIDER',
  /** A wrapper for a FormInput, cannot contain child blocks */
  INPUT = 'INPUT',
  /** A container for form input blocks laid out horizontally, space is split evenly between the form blocks */
  ROW = 'ROW',
  /** A container for other form blocks, can contain every form block type except itself */
  SECTION = 'SECTION',
  /** A container for a group of form input blocks repeated in a table format */
  TABLE = 'TABLE',
  /** A wrapper for FormTextElement, cannot contain form fields or child blocks */
  TEXT_ELEMENT = 'TEXT_ELEMENT',
}

/** A form category is a visual block of fields on a form page. i.e. Name has First and Last as fields */
export type FormCategory = {
  __typename: 'FormCategory'
  /**
   * If true, shows a "Fill All" button that allows users to populate the array
   * category with ALL rows from the lookup table at once. Can only be true when
   * isArray is true and lookupTable is specified.
   */
  allowFillAll: Scalars['Boolean']
  fields: Array<FormField>
  form: Form
  formFileCategories: Array<FormFile>
  id: Scalars['ID']
  /**
   * If this is true, there can be multiple copies of the same category. i.e. if the category is
   * Products when creating a Sales Order, there can be multiple products added to the order so those
   * fields can be filled out multiple times. This means the front-end should allow adding another of
   * the category.
   */
  isArray: Scalars['Boolean']
  /**
   * If specified, for any lookups in this form category, the data must originate from this table.
   * Once a row is selected from this table, it will auto-fill all lookup data in this form category.
   */
  lookupTable: Maybe<Table>
  /** A category may have a name or if the category has a header */
  name: Scalars['String']
  order: Scalars['Int']
  page: FormPage
  /** The slug of the category. This is automatically generated when the name is set. */
  slug: Scalars['String']
}

/** A form field is an individual field for the user to fill out when submitting a form */
export type FormField = {
  __typename: 'FormField'
  category: FormCategory
  /**
   * The value that the form field is populated with by default, is required if field is not visible
   * or not editable
   */
  defaultValue: Maybe<Scalars['JSONObject']>
  /** Optional description of the field for the tooltip */
  description: Maybe<Scalars['String']>
  /** For FILE types, indicates if images should be displayed inline */
  displayImagesInline: Scalars['Boolean']
  fieldOptions: Maybe<Array<Scalars['String']>>
  form: Form
  formFileNames: Array<FormFile>
  generatedFileFieldMappings: Array<GeneratedFileFieldMapping>
  id: Scalars['ID']
  /** Determines if multiple values can be selected for the field. Only allowed for DROPDOWN and FILE */
  isArray: Maybe<Scalars['Boolean']>
  /** Determines if the field is editable by the user */
  isEditable: Scalars['Boolean']
  /**
   * For form fields in array categories, determines if the form field display is pinned on the
   * table display
   */
  isFrozen: Scalars['Boolean']
  /** Determines if the field is required */
  isRequired: Scalars['Boolean']
  /** Determines if the field is visible for the user */
  isVisible: Scalars['Boolean']
  /** Reverse relation for logical expressions that use this field as a value input */
  logicalExpressionValues: Array<LogicExpressionValue>
  /**
   * For dropdowns/multiple choice fields the options will either come from a lookup column or from a
   * list of provided options
   */
  lookupColumn: Maybe<TableColumn>
  /** If defined, the filter expression that this field uses for lookups */
  lookupFilterExpression: Maybe<LogicExpression>
  /** Additional configs for the form field */
  metadata: Maybe<Scalars['JSONObject']>
  /** Name of the field */
  name: Scalars['String']
  /** Determines the order of the field in the form */
  order: Scalars['Int']
  /** The slug of the field. This is automatically generated when the name is set. */
  slug: Scalars['String']
  /** What type of information the field takes */
  type: FormFieldType
}

export enum FormFieldType {
  BOOLEAN = 'BOOLEAN',
  CHECKBOXES = 'CHECKBOXES',
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
  DROPDOWN = 'DROPDOWN',
  EMAIL = 'EMAIL',
  FILE = 'FILE',
  LOCATION = 'LOCATION',
  LONG_TEXT = 'LONG_TEXT',
  NUMBER = 'NUMBER',
  RADIO_BUTTON = 'RADIO_BUTTON',
  SHORT_TEXT = 'SHORT_TEXT',
  SIGNATURE = 'SIGNATURE',
}

/** A form file is a file that is generated from a form */
export type FormFile = {
  __typename: 'FormFile'
  /** Mapping of form fields to file fields when generating PDF file */
  fieldMappings: Maybe<Array<GeneratedFileFieldMapping>>
  form: Form
  /** Form Category to use for data when generating a CSV file */
  formCategory: Maybe<FormCategory>
  id: Scalars['ID']
  /** If specified, the value of this form field will be used as the name of the file */
  nameField: Maybe<FormField>
  type: GeneratedFileType
}

/** A form input is an individual input for the user to fill out when submitting a form. */
export type FormInput = {
  __typename: 'FormInput'
  /** The DossDataType of the value(s) produced by this input */
  dataType: DataType
  /** The value that the input is populated with by default */
  defaultValue: Maybe<Scalars['JSONObject']>
  /** Helper text or caption for the input */
  description: Maybe<Scalars['String']>
  /** The form this input belongs to */
  form: FormV2
  /** The form block that wraps this form input */
  formBlock: Maybe<FormBlock>
  /**
   * Variant-specific format configuration whose shape depends on formatPreset. Validated
   * at the application boundary via the shared Zod schema in common-all. NULL iff
   * formatPreset is NULL.
   */
  formatOptions: Maybe<Scalars['JSONObject']>
  /**
   * Format preset for NUMBER/FORMULA/DATE/DATE_TIME inputs. Pairs with formatOptions
   * to describe how the input's value should be rendered. Display-only: the submitted
   * value is always the raw value. NULL on input types that do not support formatting.
   */
  formatPreset: Maybe<FormatPreset>
  /** The formula that computes this input's value, present when inputType = FORMULA */
  formula: Maybe<Formula>
  /** A list of formulas that use this form input as a value input */
  formulaValueInputs: Array<FormulaValue>
  /** If defined, the input group this input belongs to */
  group: Maybe<FormInputGroup>
  id: Scalars['ID']
  /** The data type of the index value if it is an ID type input */
  indexDataType: IndexType
  /** The innertype of the input if the dataType is an array */
  innerDataType: Maybe<DataType>
  /** The materialized display type of the input on the UI */
  inputType: FormInputType
  /** For form inputs in tables, determines if the column is pinned in the table display */
  isFrozen: Scalars['Boolean']
  /** The derived value of whether the input is a multi-select based on input type and data type configuration */
  isMultiSelect: Maybe<Scalars['Boolean']>
  /** Determines if the field is read only, default false */
  isReadOnly: Scalars['Boolean']
  /** Determines if the field is required, default false */
  isRequired: Scalars['Boolean']
  /** Determines if the field is visible to the user, default true */
  isVisible: Scalars['Boolean']
  /** The label of the form input */
  label: Scalars['String']
  /** The logical expression values that use this input */
  logicExpressionValues: Array<LogicExpressionValue>
  /** If defined, the lookup input group this input belongs to */
  lookupGroup: Maybe<FormLookupInputGroup>
  /** If defined, the source table column of a lookup type input */
  lookupTableColumn: Maybe<TableColumn>
  /**
   * Stores additional configuration data based on input type.
   * May include:
   * - Common field attributes: placeholder text, whether to freeze the field in a table, etc.
   * - Type-specific configuration: enum options, signature user-linking, file display options, etc.
   */
  metadata: Maybe<Scalars['JSONObject']>
  /** The slug of the form input */
  slug: Scalars['String']
  /**
   * If defined, the source table column this input is linked to.
   * When linked, the input inherits properties from the column.
   */
  sourceTableColumn: Maybe<TableColumn>
  /** The validation rules that apply to this input */
  validationRules: Array<FormValidationCondition>
  /** Pre-filled values for this input across different form variants */
  variantValues: Array<FormVariantInput>
}

/** A data relationship grouping for a set of form inputs that are repeated together, usually in a table format. */
export type FormInputGroup = {
  __typename: 'FormInputGroup'
  /** The form that this input group belongs to */
  form: FormV2
  /** The form inputs that are part of this group */
  formInputs: Array<FormInput>
  id: Scalars['ID']
  /** The label of the form input group */
  label: Scalars['String']
  /** The table form block that is linked to this input group */
  linkedFormBlock: Maybe<FormBlock>
  /** The slug of the form input group */
  slug: Scalars['String']
}

export enum FormInputType {
  BOOLEAN = 'BOOLEAN',
  CHECKBOXES = 'CHECKBOXES',
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
  DROPDOWN = 'DROPDOWN',
  EMAIL = 'EMAIL',
  FILE = 'FILE',
  FORMULA = 'FORMULA',
  LONG_TEXT = 'LONG_TEXT',
  LOOKUP = 'LOOKUP',
  NUMBER = 'NUMBER',
  PHONE_NUMBER = 'PHONE_NUMBER',
  RADIO_BUTTON = 'RADIO_BUTTON',
  SHORT_TEXT = 'SHORT_TEXT',
  SIGNATURE = 'SIGNATURE',
  URL = 'URL',
  USER = 'USER',
}

/** A grouping of form inputs that looks up to the same row of the same source lookup table. */
export type FormLookupInputGroup = {
  __typename: 'FormLookupInputGroup'
  /** Default rows for this lookup group - computed from FormLookupInputGroupDefaultRow join table */
  defaultRows: Array<TableRow>
  /**
   * The filter expression as a string, used to display and edit the filter
   * @deprecated This is being replaced by logicExpressionString on LogicExpression
   */
  filterExpressionString: Maybe<Scalars['String']>
  /** The form that this lookup input group belongs to */
  form: FormV2
  /** The form inputs that are part of this group */
  formInputs: Array<FormInput>
  id: Scalars['ID']
  /** If true, fields in this group will auto-fill once all evaluate to exactly one value (after lookupFilterExpression) */
  isAutoFill: Scalars['Boolean']
  /** If defined, the logic expression that this group uses to filter matching lookups */
  lookupFilterExpression: Maybe<LogicExpression>
  /** The table that contains the columns that are looked up to by the form inputs in this group */
  lookupTable: Table
}

/**
 * Join table for FormLookupInputGroup default rows. Stores IDs as plain UUIDs without FK
 * constraints to avoid DB locks during high-write scenarios. Indexes on both columns for
 * query performance. Application code handles relationship logic.
 */
export type FormLookupInputGroupDefaultRow = {
  __typename: 'FormLookupInputGroupDefaultRow'
  id: Scalars['ID']
  /** The lookup input group ID (no FK constraint) */
  lookupInputGroupId: Scalars['ID']
  /** The table row ID (no FK constraint) */
  tableRowId: Scalars['ID']
}

/** A form page is a collection of form categories each made up of form fields */
export type FormPage = {
  __typename: 'FormPage'
  /** The form fields on this page */
  categories: Array<FormCategory>
  form: Form
  id: Scalars['ID']
  name: Scalars['String']
  order: Scalars['Int']
  /** The slug of the page. This is automatically generated when the name is set. */
  slug: Scalars['String']
}

/**
 * Enum for form submission redirect targets. Used to configure where the user should be redirected
 * after successfully submitting a form. If `CUSTOM_PATH` is chosen, the form's
 * `redirectCustomPath` field may be used to store the path (e.g. `/projects/123/summary`).
 */
export enum FormRedirectTarget {
  /** Browser Back (Default) */
  BROWSER_BACK_LEGACY = 'BROWSER_BACK_LEGACY',
  /** Use the custom path stored in `redirectCustomPath` */
  CUSTOM_PATH = 'CUSTOM_PATH',
  /** Redirect to the forms list page ('/forms') */
  FORMS_HOME = 'FORMS_HOME',
  /** Redirect to the application home page ('/') */
  HOME = 'HOME',
  /** Stay on the form page after submission */
  STAY_ON_FORM = 'STAY_ON_FORM',
}

/** The form input block that is the child block of a row */
export type FormRowChildBlockInput = {
  existingInputBlockId?: InputMaybe<Scalars['ID']>
  newInputBlock?: InputMaybe<CreateFormInputBlockInput>
}

/**
 * A form is a collection of visual elements and input elements that can be filled out by a user.
 * Input elements can have visual grouping as well as data relationships to other input elements.
 */
export type FormV2 = {
  __typename: 'FormV2'
  /** A list of all the form blocks in this form */
  blocks: Array<FormBlock>
  /** A list of buttons that can be used to trigger the form */
  buttons: Array<WorkspaceButton>
  id: Scalars['ID']
  /** A list of form input groups in this form */
  inputGroups: Array<FormInputGroup>
  /** A list of form inputs in this form */
  inputs: Array<FormInput>
  /** If there is a permission for SUBMIT_FORM on the formV2 on the EXTERNAL role, this will be true */
  isShareable: Scalars['Boolean']
  /** The table that this form is linked to for data entry */
  linkedTable: Maybe<Table>
  /** A list of form lookup input groups in this form */
  lookupInputGroups: Array<FormLookupInputGroup>
  name: Scalars['String']
  /** The organization that owns this form */
  organization: Organization
  /** A list of permissions that control access to this form */
  permissions: Array<Permission>
  /** Optional custom path (used when redirectTarget = CUSTOM_PATH). Should be a path beginning with '/'. */
  redirectCustomPath: Maybe<Scalars['String']>
  /** When set, indicates where to redirect the user after successful submission */
  redirectTarget: FormRedirectTarget
  /** The slug of the form. This is automatically generated when the name is set. */
  slug: Scalars['String']
  /** If the formV2 was created from a formV1, the formV1Id will be set */
  sourceForm: Maybe<Form>
  /** A list of variants for this form with pre-configured values */
  variants: Array<FormVariant>
  /** Version history for this form's JSON definitions */
  versions: Array<EntityVersionHistory>
  /** The views that embed this form in a workspace */
  views: Array<View>
  /** A list of visibility conditions for this form */
  visibilityConditions: Array<FormVisibilityCondition>
  /** Gets the workflows that are triggered by a form's submission */
  workflows: Array<Workflow>
}

/** A file that is generated from a form v2 */
export type FormV2File = {
  __typename: 'FormV2File'
  formV2: FormV2
  mappings: Array<FormV2FileMapping>
  name: Maybe<Scalars['String']>
  type: GeneratedFileType
}

export type FormV2FileMapping = {
  __typename: 'FormV2FileMapping'
  fileFieldId: Scalars['ID']
  formInputId: Scalars['ID']
}

/** Represents a single validation error found during FormV2 JSON validation */
export type FormV2JsonValidationError = {
  __typename: 'FormV2JsonValidationError'
  /** Human-readable error message */
  message: Scalars['String']
  /** The JSON path where the error occurred (e.g., 'sections[0].childBlocks[1].input.lookupColumn') */
  path: Scalars['String']
}

/** A form validation condition is a logical expression that much pass in order for the associated input to be considered valid for submission. */
export type FormValidationCondition = {
  __typename: 'FormValidationCondition'
  conditionExpression: LogicExpression
  id: Scalars['ID']
  /** The form input this validation condition applies to */
  inputAppliedTo: Maybe<FormInput>
  /** Message shown to user in form filler if this expression is false */
  validationMessage: Maybe<Scalars['String']>
}

export type FormValidationConditionInput = {
  conditionExpression: ParentLogicExpressionInput
  /** Message shown to user in form filler if this expression is false */
  validationMessage?: InputMaybe<Scalars['String']>
}

/**
 * A form variant represents a pre-configured version of a form with pre-filled values for specific inputs.
 * Variants allow creating multiple "templates" of the same form for different use cases.
 * Example: A purchase order form might have variants for different vendors, each with vendor details pre-filled.
 */
export type FormVariant = {
  __typename: 'FormVariant'
  /** Buttons that can be used to trigger the form with this variant */
  buttons: Array<WorkspaceButton>
  /** Optional description explaining when to use this variant */
  description: Maybe<Scalars['String']>
  /** The form this variant belongs to */
  form: FormV2
  id: Scalars['ID']
  /** The name of the variant (e.g., 'Vendor A Template', 'New Employee Onboarding') */
  name: Scalars['String']
  /** Pre-filled values for specific form inputs in this variant */
  variantInputs: Array<FormVariantInput>
}

/** Defines a pre-filled value for a specific form input within a form variant. */
export type FormVariantInput = {
  __typename: 'FormVariantInput'
  /** The pre-filled value for this input in this variant */
  defaultValue: Scalars['JSONObject']
  id: Scalars['ID']
  /** The form input that will be pre-filled */
  input: FormInput
  /** Determines if the input is read only, default false */
  isReadOnly: Scalars['Boolean']
  /** The variant this pre-filled value belongs to */
  variant: FormVariant
}

/** A form visibility condition is a logical expression that much pass in order for the associated block to render. */
export type FormVisibilityCondition = {
  __typename: 'FormVisibilityCondition'
  controlledFormBlocks: Array<FormBlock>
  expression: LogicExpression
  formV2: FormV2
  id: Scalars['ID']
  /** Supports selections in workflow mapping & easy reuse handle */
  name: Maybe<Scalars['String']>
  /** The slug of the form visibility condition. This is automatically generated when the name is set. */
  slug: Scalars['String']
}

export type FormVisibilityConditionInput = {
  expression: ParentLogicExpressionInput
  id?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
}

export enum FormatPreset {
  DATE_CUSTOM = 'DATE_CUSTOM',
  NUMBER_CURRENCY = 'NUMBER_CURRENCY',
  NUMBER_DECIMAL = 'NUMBER_DECIMAL',
  NUMBER_INTEGER = 'NUMBER_INTEGER',
  NUMBER_PERCENT = 'NUMBER_PERCENT',
  NUMBER_PLAIN = 'NUMBER_PLAIN',
  NUMBER_UNIT = 'NUMBER_UNIT',
}

/** Formula to generate data for a column */
export type Formula = {
  __typename: 'Formula'
  /** The logical expression used to filter cells for a column based formula operation */
  columnOperationFilter: Maybe<LogicExpression>
  /** If defined, the condition that must evaluate to true for the formula to be applied */
  condition: Maybe<FormulaCondition>
  /**
   * The formula's surface syntax: `formulaString` when stored, else printed from the structured
   * tree. Some programmatic creation paths never wrote `formulaString`. Null when the tree uses
   * shapes the surface grammar cannot spell.
   */
  derivedFormulaString: Maybe<Scalars['String']>
  /** If defined, the logic expression that uses this formula */
  expressionValue: Maybe<LogicExpressionValue>
  /** The formula as a string, only present on the root formula */
  formulaString: Maybe<Scalars['String']>
  /** If defined, the parent formula value */
  formulaValue: Maybe<FormulaValue>
  /** All the formula values within a formula, excluding the initial formula value, if one exists */
  formulaValues: Array<FormulaValue>
  id: Scalars['ID']
  operator: FormulaOperator
  organization: Organization
  /**
   * The resolved output type of this formula, derived and set by the backend from the
   * formula's operator/structure. Not settable via FormulaInput/ParentFormulaInput —
   * accepting this as client input would let it drift out of sync with the formula's
   * actual configuration (and API/agent callers don't go through UI-side validation).
   */
  outputType: DataType
  parentColumn: Maybe<TableColumn>
  parentFormInput: Maybe<FormInput>
}

/** A single condition for a formula value */
export type FormulaCondition = {
  __typename: 'FormulaCondition'
  /** The logical expression to evaluate for the condition to be true */
  conditionExpression: LogicExpression
  /** The formula that is applied if the expression evaluates to true */
  formula: Formula
  id: Scalars['ID']
  /** The order in which to evaluate the conditions */
  order: Scalars['Int']
  /** The formula value that this condition belongs to */
  parentFormulaValue: FormulaValue
}

export type FormulaConditionInput = {
  condition: LogicExpressionInput
  formula: FormulaInput
  order: Scalars['Int']
}

/**
 * The type of row operation that triggered the invocation of the formula engine.
 *
 * Create or update operations have similar behavior in the formula engine, whereas delete operations
 * only update dependent formulas in tables other than the input table.
 */
export enum FormulaEngineOperation {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
}

export type FormulaInput = {
  columnOperationFilter?: InputMaybe<LogicExpressionInput>
  formulaValues: Array<FormulaValueInput>
  operator: FormulaOperator
}

/** Operators that can be used in a formula */
export enum FormulaOperator {
  ADDITION = 'ADDITION',
  /** logical combinators */
  AND = 'AND',
  AVERAGE = 'AVERAGE',
  CEIL = 'CEIL',
  /** text concatenation function */
  CONCAT = 'CONCAT',
  /** array/scalar input CONDITION scalar value */
  CONTAINS = 'CONTAINS',
  CONTAINS_ALL = 'CONTAINS_ALL',
  /** array input CONDITION array value */
  CONTAINS_ANY = 'CONTAINS_ANY',
  COUNT = 'COUNT',
  COUNT_DISTINCT = 'COUNT_DISTINCT',
  /** date construction function */
  DATE = 'DATE',
  /** date arithmetic function */
  DATEADD = 'DATEADD',
  /** date difference function */
  DATEDIFF = 'DATEDIFF',
  /** date extraction function */
  DAY = 'DAY',
  DIVISION = 'DIVISION',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  DOES_NOT_CONTAIN_ANY = 'DOES_NOT_CONTAIN_ANY',
  /** scalar input CONDITION scalar value */
  EQUAL = 'EQUAL',
  FLOOR = 'FLOOR',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  /** scalar input CONDITION array/scalar value */
  IN = 'IN',
  /** unary conditions */
  IS_EMPTY = 'IS_EMPTY',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
  /** text extraction function */
  LEFT = 'LEFT',
  /** text measurement function */
  LEN = 'LEN',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  /** text transformation function */
  LOWER = 'LOWER',
  MAX = 'MAX',
  /** text extraction function */
  MID = 'MID',
  MIN = 'MIN',
  /** date extraction function */
  MONTH = 'MONTH',
  MULTIPLICATION = 'MULTIPLICATION',
  NOT = 'NOT',
  NOT_EQUAL = 'NOT_EQUAL',
  NOT_IN = 'NOT_IN',
  OR = 'OR',
  /** text extraction function */
  RIGHT = 'RIGHT',
  ROUND = 'ROUND',
  /** text replacement function */
  SUBSTITUTE = 'SUBSTITUTE',
  SUBTRACTION = 'SUBTRACTION',
  SUM = 'SUM',
  /** sum of the element-wise product of two or more columns on one source table */
  SUMPRODUCT = 'SUMPRODUCT',
  /** type conversion to date */
  TO_DATE = 'TO_DATE',
  /** type conversion to number */
  TO_NUMBER = 'TO_NUMBER',
  /** type conversion to text */
  TO_TEXT = 'TO_TEXT',
  /** text transformation function */
  TRIM = 'TRIM',
  /** text transformation function */
  UPPER = 'UPPER',
  /** date extraction function */
  YEAR = 'YEAR',
}

/**
 * One value within a formula. Can just be a float number or can resolve to a number from a formula,
 * table column, or a list of conditions
 */
export type FormulaValue = {
  __typename: 'FormulaValue'
  /**
   * If specified, an if/else-if/else set of conditions that evaluate to a number. If none of the
   * conditions evaluate to true and no else condition exists, this value will resolve to 0
   */
  conditions: Array<FormulaCondition>
  /** if specified, the form input that evaluates to a number */
  formInput: Maybe<FormInput>
  /** If specified, the formula that evaluates to a number */
  formula: Maybe<Formula>
  id: Scalars['ID']
  /** The order in which to evaluate the formula values */
  order: Scalars['Int']
  /** The parent formula which this formula value feeds into */
  parentFormula: Formula
  /** If specified, the table column that evaluates to a number */
  tableColumn: Maybe<TableColumn>
  /**
   * If specified, the number value that is used for the formulaValue
   * @deprecated Use valueNumber.
   */
  value: Maybe<Scalars['Float']>
  valueBoolean: Maybe<Scalars['Boolean']>
  valueDate: Maybe<Scalars['DateTime']>
  valueDateTime: Maybe<Scalars['DateTime']>
  valueNumber: Maybe<Scalars['Float']>
  valueString: Maybe<Scalars['String']>
}

export type FormulaValueInput = {
  conditions?: InputMaybe<Array<FormulaConditionInput>>
  formInputId?: InputMaybe<Scalars['ID']>
  formula?: InputMaybe<FormulaInput>
  order: Scalars['Int']
  tableColumnId?: InputMaybe<Scalars['ID']>
  /** @deprecated Use valueNumber. Kept for backward compatibility with older clients. */
  value?: InputMaybe<Scalars['Float']>
  valueNumber?: InputMaybe<Scalars['Float']>
  valueString?: InputMaybe<Scalars['String']>
}

export type FrequencyInput = {
  daysOfWeek: Array<Scalars['Int']>
  repeatNumber: Scalars['Int']
  repeatUnit: CalendarUnit
  startAt: Scalars['DateTime']
}

/** Field on a generated file from a form */
export type GeneratedFileField = {
  __typename: 'GeneratedFileField'
  fieldName: Scalars['String']
  generatedFileFieldMappings: Array<GeneratedFileFieldMapping>
  id: Scalars['ID']
  type: GeneratedFileType
}

/** Mapping set of form field to file field for a generated file */
export type GeneratedFileFieldMapping = {
  __typename: 'GeneratedFileFieldMapping'
  /** The field on the file that is being mapped to */
  fileField: GeneratedFileField
  /** The field from the form that is being mapped */
  formField: FormField
  /** The file on which the mapping is happening */
  formFile: FormFile
  id: Scalars['ID']
}

export enum GeneratedFileType {
  /** File templates for ABA Engineering */
  ABA_REPORT_INSPECTION = 'ABA_REPORT_INSPECTION',
  /** File templates for Ark Foods */
  ARK_FOODS_BILL_OF_LADING = 'ARK_FOODS_BILL_OF_LADING',
  ARK_FOODS_INVOICE = 'ARK_FOODS_INVOICE',
  /** File templates for Ark Foods */
  ARK_FOODS_ORDER_CONFIRMATION = 'ARK_FOODS_ORDER_CONFIRMATION',
  ARK_FOODS_PASSING_SHEET = 'ARK_FOODS_PASSING_SHEET',
  ARK_FOODS_PURCHASE_ORDER = 'ARK_FOODS_PURCHASE_ORDER',
  ARK_FOODS_QC_INSPECTION = 'ARK_FOODS_QC_INSPECTION',
  ARK_FOODS_TRADER_JOES_PACKING_SLIP = 'ARK_FOODS_TRADER_JOES_PACKING_SLIP',
  /** File templates for Athena Club */
  ATHENA_CLUB_BOM_EXPORT_XLSX = 'ATHENA_CLUB_BOM_EXPORT_XLSX',
  ATHENA_CLUB_CO_MAN_EOM_INVENTORY_RECONCILIATION_XLSX = 'ATHENA_CLUB_CO_MAN_EOM_INVENTORY_RECONCILIATION_XLSX',
  ATHENA_CLUB_PURCHASE_ORDER = 'ATHENA_CLUB_PURCHASE_ORDER',
  ATHENA_CLUB_WORK_ORDER = 'ATHENA_CLUB_WORK_ORDER',
  /** Generic PDFs */
  BALANCE_SHEET = 'BALANCE_SHEET',
  /** Generic XLSX */
  BALANCE_SHEET_SINGLE_PERIOD_XLSX = 'BALANCE_SHEET_SINGLE_PERIOD_XLSX',
  BILLING_STATEMENT = 'BILLING_STATEMENT',
  /** Reusable 4x6 generic GS1-128 pallet/case label (contents table + (420) postal + SSCC). */
  BIOM_GENERIC_GS1_128_LABEL = 'BIOM_GENERIC_GS1_128_LABEL',
  /** Reusable US Letter (landscape) generic packing list (DOSS PO-v4 design); mapped identity. */
  BIOM_GENERIC_PACKING_LIST = 'BIOM_GENERIC_PACKING_LIST',
  /** Reusable 4x6 Grove case-pack label (UPC-A + carton SSCC barcodes); mapped identity. */
  BIOM_GROVE_CASE_PACK_LABEL = 'BIOM_GROVE_CASE_PACK_LABEL',
  /** Reusable 4x6 Grove multi-SKU pallet label (repeating SKU pairs, GS1-128 Pallet SSCC). */
  BIOM_GROVE_MULTI_SKU_PALLET_LABEL = 'BIOM_GROVE_MULTI_SKU_PALLET_LABEL',
  /** Reusable 4x6 Grove single-SKU pallet label (GS1-128 Pallet SSCC); mapped identity. */
  BIOM_GROVE_ONE_SKU_PALLET_LABEL = 'BIOM_GROVE_ONE_SKU_PALLET_LABEL',
  /** Reusable US Letter (landscape) Grove Collaborative packing list (DOSS PO-v4 design); mapped identity. */
  BIOM_GROVE_PACKING_LIST = 'BIOM_GROVE_PACKING_LIST',
  /** Generalized customer invoice in the DOSS PO-family design (reusable across partners). */
  BIOM_INVOICE = 'BIOM_INVOICE',
  /** Reusable 4x6 warehouse license-plate label (SKU + LPN barcodes); mapped customer identity. */
  BIOM_LICENSE_PLATE_LABEL = 'BIOM_LICENSE_PLATE_LABEL',
  /** Reusable 4x6 Target carton SSCC-18 label (GS1-128 + (420) postal barcodes); mapped identity. */
  BIOM_TARGET_CARTON_SSCC_LABEL = 'BIOM_TARGET_CARTON_SSCC_LABEL',
  /** Reusable US Letter (landscape) Target packing list (DOSS PO-v4 design); mapped identity. */
  BIOM_TARGET_PACKING_LIST = 'BIOM_TARGET_PACKING_LIST',
  /** Reusable 4x6 Target pallet SSCC-18 (Tare) label (GS1-128 + (420) postal); mapped identity. */
  BIOM_TARGET_PALLET_SSCC_LABEL = 'BIOM_TARGET_PALLET_SSCC_LABEL',
  /** Reusable US Letter (landscape) Thrive Market packing list (DOSS PO-v4 design); mapped identity. */
  BIOM_THRIVE_PACKING_LIST = 'BIOM_THRIVE_PACKING_LIST',
  /** Reusable 4x6 Thrive carton/pallet GS1-128 SSCC label (CARTON|PALLET state); mapped identity. */
  BIOM_THRIVE_SSCC_LABEL = 'BIOM_THRIVE_SSCC_LABEL',
  /** Reusable US Letter (landscape) UNFI packing list (DOSS PO-v4 design); mapped identity. */
  BIOM_UNFI_PACKING_LIST = 'BIOM_UNFI_PACKING_LIST',
  /** Reusable US Letter UNFI pallet placard (prominent DC/PO/pallet + item table); no barcodes. */
  BIOM_UNFI_PALLET_PLACARD = 'BIOM_UNFI_PALLET_PLACARD',
  /** Reusable US Letter VICS Bill of Lading (parties, order + carrier tables, signatures). */
  BIOM_VICS_BILL_OF_LADING = 'BIOM_VICS_BILL_OF_LADING',
  /** Reusable US Letter VICS Master BOL (consolidator, commodity summary + supplement pages). */
  BIOM_VICS_MASTER_BILL_OF_LADING = 'BIOM_VICS_MASTER_BILL_OF_LADING',
  /** Reusable landscape (6x4) warehouse bin/location address label (bold location code + barcode with caption). */
  BIOM_WAREHOUSE_ADDRESS_LABEL = 'BIOM_WAREHOUSE_ADDRESS_LABEL',
  /** Reusable US Letter (portrait) warehouse picking slip with hand-fill columns; mapped identity. */
  BIOM_WAREHOUSE_PICKING_SLIP = 'BIOM_WAREHOUSE_PICKING_SLIP',
  /** File templates for BNZ */
  BNZ_BRIEFING = 'BNZ_BRIEFING',
  BNZ_EMPLOYEE_SAFETY = 'BNZ_EMPLOYEE_SAFETY',
  BNZ_PROJECT_SUBMISSION = 'BNZ_PROJECT_SUBMISSION',
  BNZ_WORK_DIARY = 'BNZ_WORK_DIARY',
  CAULIPUFFS_COPACK_PURCHASE_ORDER = 'CAULIPUFFS_COPACK_PURCHASE_ORDER',
  /** File templates for Caulipuffs */
  CAULIPUFFS_INVOICE = 'CAULIPUFFS_INVOICE',
  COMMERCIAL_INVOICE = 'COMMERCIAL_INVOICE',
  CREDIT_MEMO = 'CREDIT_MEMO',
  /** Generic CSV */
  CSV = 'CSV',
  /** File templates for Denim Tears */
  DENIM_TEARS_PURCHASE_ORDER = 'DENIM_TEARS_PURCHASE_ORDER',
  DENIM_TEARS_PURCHASE_ORDER_V2 = 'DENIM_TEARS_PURCHASE_ORDER_V2',
  /** File templates for De Soi */
  DE_SOI_PRODUCT_INFORMATION_WORKSHEET_CAN_XLSX = 'DE_SOI_PRODUCT_INFORMATION_WORKSHEET_CAN_XLSX',
  DE_SOI_PURCHASE_ORDER = 'DE_SOI_PURCHASE_ORDER',
  DIVERSIFIED_BOTANICALS_INVENTORY_LABEL = 'DIVERSIFIED_BOTANICALS_INVENTORY_LABEL',
  /** File templates for Diversified Botanicals */
  DIVERSIFIED_BOTANICALS_PURCHASE_ORDER = 'DIVERSIFIED_BOTANICALS_PURCHASE_ORDER',
  DIVERSIFIED_BOTANICALS_SALES_ORDER = 'DIVERSIFIED_BOTANICALS_SALES_ORDER',
  /** File templates for Dr. Noze Best */
  DNB_PURCHASE_ORDER = 'DNB_PURCHASE_ORDER',
  /** File templates for Eight Sleep */
  EIGHT_SLEEP_PURCHASE_ORDER = 'EIGHT_SLEEP_PURCHASE_ORDER',
  EIGHT_SLEEP_PURCHASE_ORDER_BILINGUAL = 'EIGHT_SLEEP_PURCHASE_ORDER_BILINGUAL',
  EIGHT_SLEEP_PURCHASE_ORDER_RMB = 'EIGHT_SLEEP_PURCHASE_ORDER_RMB',
  /** File templates for Factor Form */
  FACTOR_FORM_PURCHASE_ORDER = 'FACTOR_FORM_PURCHASE_ORDER',
  FIRSTBASE_CP_RECEIPT = 'FIRSTBASE_CP_RECEIPT',
  /** File templates for Firstbase */
  FIRSTBASE_PO_IMPORT = 'FIRSTBASE_PO_IMPORT',
  FIRSTBASE_PURCHASE_ORDER = 'FIRSTBASE_PURCHASE_ORDER',
  FIRSTBASE_REQUEST_FOR_QUOTE = 'FIRSTBASE_REQUEST_FOR_QUOTE',
  /** PO template for Golden Goods */
  GG_PURCHASE_ORDER_XLSX = 'GG_PURCHASE_ORDER_XLSX',
  /** File templates for Grace Farms */
  GRACE_FARMS_PACKING_SLIP = 'GRACE_FARMS_PACKING_SLIP',
  INCOME_STATEMENT = 'INCOME_STATEMENT',
  INCOME_STATEMENT_SINGLE_PERIOD_XLSX = 'INCOME_STATEMENT_SINGLE_PERIOD_XLSX',
  INCOME_STATEMENT_XLSX = 'INCOME_STATEMENT_XLSX',
  /** File templates for Instant Hydration */
  INSTANT_HYDRATION_PURCHASE_ORDER = 'INSTANT_HYDRATION_PURCHASE_ORDER',
  INVOICE = 'INVOICE',
  K1893_FREIGHT_QUOTE = 'K1893_FREIGHT_QUOTE',
  K1893_INVOICE = 'K1893_INVOICE',
  K1893_INVOICE_MEIJER = 'K1893_INVOICE_MEIJER',
  K1893_INVOICE_TJS = 'K1893_INVOICE_TJS',
  K1893_INVOICE_UNFI = 'K1893_INVOICE_UNFI',
  K1893_PALLET_INSTRUCTIONS = 'K1893_PALLET_INSTRUCTIONS',
  /** File templates for Kahawa */
  K1893_PURCHASE_ORDER = 'K1893_PURCHASE_ORDER',
  K1893_PURCHASE_ORDER_OVG = 'K1893_PURCHASE_ORDER_OVG',
  /** File templates for Little Beast */
  LITTLE_BEAST_PURCHASE_ORDER = 'LITTLE_BEAST_PURCHASE_ORDER',
  /** File templates for MagicMind */
  MAGIC_MIND_PACKING_SLIP = 'MAGIC_MIND_PACKING_SLIP',
  MAGIC_MIND_PURCHASE_ORDER = 'MAGIC_MIND_PURCHASE_ORDER',
  /** Mezcla packing list: mapped title, shipment details under Ship To, pallet and gross weight totals. */
  MEZCLA_PACKING_LIST = 'MEZCLA_PACKING_LIST',
  /** File templates for Mezcla */
  MEZCLA_PURCHASE_ORDER = 'MEZCLA_PURCHASE_ORDER',
  /** Mezcla default purchase order — letterhead, PO header box, bars/cases item table, bars-by-product-group summary. */
  MEZCLA_PURCHASE_ORDER_V2 = 'MEZCLA_PURCHASE_ORDER_V2',
  /** File templates for Noodles */
  NOODLES_COMPLAINT = 'NOODLES_COMPLAINT',
  NOODLES_CREDIT_NOTE = 'NOODLES_CREDIT_NOTE',
  NOODLES_DELIVERY_NOTE = 'NOODLES_DELIVERY_NOTE',
  NOODLES_INVOICE = 'NOODLES_INVOICE',
  NOODLES_MIDABO_SUPPLIER_ORDER = 'NOODLES_MIDABO_SUPPLIER_ORDER',
  NOODLES_ORDER = 'NOODLES_ORDER',
  NOODLES_QUOTE = 'NOODLES_QUOTE',
  NOODLES_SUPPLIER_ORDER = 'NOODLES_SUPPLIER_ORDER',
  PALLET_LABEL = 'PALLET_LABEL',
  /** File templates for Pavoi */
  PAVOI_COMMERCIAL_INVOICE = 'PAVOI_COMMERCIAL_INVOICE',
  PICK_TICKET = 'PICK_TICKET',
  /** File templates for Popdarts */
  POPDARTS_COMMISSION_INVOICE_XLSX = 'POPDARTS_COMMISSION_INVOICE_XLSX',
  PURCHASE_ORDER = 'PURCHASE_ORDER',
  PURCHASE_ORDER_V2 = 'PURCHASE_ORDER_V2',
  PURCHASE_ORDER_V3 = 'PURCHASE_ORDER_V3',
  PURCHASE_ORDER_V4 = 'PURCHASE_ORDER_V4',
  QUOTE = 'QUOTE',
  /** File templates for Reflor */
  REFLOR_PURCHASE_ORDER = 'REFLOR_PURCHASE_ORDER',
  REFLOR_WORK_ORDER = 'REFLOR_WORK_ORDER',
  REMITTANCE_ADVICE = 'REMITTANCE_ADVICE',
  SALES_ORDER = 'SALES_ORDER',
  /** File templates for Selkirk */
  SELKIRK_PURCHASE_ORDER = 'SELKIRK_PURCHASE_ORDER',
  /** File templates for SL Munson */
  SL_MUNSON_1099_FORM = 'SL_MUNSON_1099_FORM',
  SL_MUNSON_PACKING_SLIP = 'SL_MUNSON_PACKING_SLIP',
  SMASH_FOODS_BLANKET_PURCHASE_ORDER = 'SMASH_FOODS_BLANKET_PURCHASE_ORDER',
  /** File templates for Smash Foods */
  SMASH_FOODS_PURCHASE_ORDER = 'SMASH_FOODS_PURCHASE_ORDER',
  /** File templates for Snackwise */
  SNACKWISE_INVOICE = 'SNACKWISE_INVOICE',
  SNACKWISE_PICK_TICKET = 'SNACKWISE_PICK_TICKET',
  SOS_BUDGET = 'SOS_BUDGET',
  /** File templates for SOS */
  SOS_PROPOSAL = 'SOS_PROPOSAL',
  /** File templates for Sourcify */
  SOURCIFY_CUSTOMER_QUOTE_APPROVAL = 'SOURCIFY_CUSTOMER_QUOTE_APPROVAL',
  SOURCIFY_CUSTOMER_QUOTE_DETAILS_APPROVAL = 'SOURCIFY_CUSTOMER_QUOTE_DETAILS_APPROVAL',
  SOURCIFY_REQUEST_FOR_PRICING = 'SOURCIFY_REQUEST_FOR_PRICING',
  /** File templates for Spread The Love */
  STL_PACKING_SLIP = 'STL_PACKING_SLIP',
  STL_PURCHASE_ORDER = 'STL_PURCHASE_ORDER',
  /** File templates for Superhumn */
  SUPERHUMN_IMPORTER_SECURITY_FILING = 'SUPERHUMN_IMPORTER_SECURITY_FILING',
  /** File templates for Tagwall */
  TAGWALL_ACCOUNTS_PAYABLE_AGING_XLSX = 'TAGWALL_ACCOUNTS_PAYABLE_AGING_XLSX',
  TAGWALL_ACCOUNTS_RECEIVABLE_AGING_XLSX = 'TAGWALL_ACCOUNTS_RECEIVABLE_AGING_XLSX',
  TAGWALL_BILL_OF_LADING = 'TAGWALL_BILL_OF_LADING',
  TAGWALL_CONFIGURABLE_REPORT_XLSX = 'TAGWALL_CONFIGURABLE_REPORT_XLSX',
  TAGWALL_DELIVERY_TICKET = 'TAGWALL_DELIVERY_TICKET',
  TAGWALL_INVOICE = 'TAGWALL_INVOICE',
  TAGWALL_PICK_TICKET = 'TAGWALL_PICK_TICKET',
  TAGWALL_PURCHASE_ORDER = 'TAGWALL_PURCHASE_ORDER',
  TAGWALL_RECEIVING_TICKET = 'TAGWALL_RECEIVING_TICKET',
  /** File templates for Tersus */
  TERSUS_CONTAINER_BARCODE = 'TERSUS_CONTAINER_BARCODE',
  /** File templates for Toom */
  TOOM_PURCHASE_ORDER_PROCUREMENT = 'TOOM_PURCHASE_ORDER_PROCUREMENT',
  TOOM_PURCHASE_ORDER_PRODUCTION = 'TOOM_PURCHASE_ORDER_PRODUCTION',
  /** File templates for Verve Coffee */
  VERVE_COFFEE_CERTIFICATE_OF_ANALYSIS = 'VERVE_COFFEE_CERTIFICATE_OF_ANALYSIS',
  VERVE_COFFEE_PICK_TICKET = 'VERVE_COFFEE_PICK_TICKET',
  VERVE_COFFEE_PICK_TICKET_BARCODE = 'VERVE_COFFEE_PICK_TICKET_BARCODE',
  VERVE_COFFEE_REQUEST_FOR_COFFEE_PROCUREMENT = 'VERVE_COFFEE_REQUEST_FOR_COFFEE_PROCUREMENT',
  VERVE_COFFEE_SALES_ORDER_SHIPPING_LABEL = 'VERVE_COFFEE_SALES_ORDER_SHIPPING_LABEL',
  VERVE_COFFEE_SUPERSACK_LABEL = 'VERVE_COFFEE_SUPERSACK_LABEL',
  VERVE_COFFEE_TRANSFER_SHIPPING_LABEL = 'VERVE_COFFEE_TRANSFER_SHIPPING_LABEL',
  WORK_ORDER = 'WORK_ORDER',
}

export type GetIntegrationAuthorizationUriInput = {
  isStaging?: InputMaybe<Scalars['Boolean']>
  organization?: InputMaybe<Scalars['String']>
  region?: InputMaybe<Scalars['String']>
  scopes?: InputMaybe<Array<Scalars['String']>>
  type: IntegrationType
}

export type GroupByMetadata = {
  bounds?: InputMaybe<Scalars['JSONObject']>
  dimensionType?: InputMaybe<PivotDimensionType>
  interval?: InputMaybe<Scalars['Int']>
  intervalCalendarUnit?: InputMaybe<CalendarUnit>
  offset?: InputMaybe<Scalars['Int']>
  offsetUnit?: InputMaybe<CalendarUnit>
  order?: InputMaybe<Scalars['Int']>
  showTotals?: InputMaybe<Scalars['Boolean']>
  stringBuckets?: InputMaybe<Array<Scalars['String']>>
}

/** A link out of a guest app, by logical id */
export type GuestDestinationInput = {
  /** table, form, chart, dashboard or app — the frame's destination kinds */
  kind: Scalars['String']
  /** The target's logical id; for APP, the id declared at application('…') */
  logicalId: Scalars['String']
  /** APP only: the route within the app */
  path?: InputMaybe<Scalars['String']>
  /** APP only: '' or '?…' */
  search?: InputMaybe<Scalars['String']>
}

/** Icon that can be associated with a table */
export type Icon = {
  __typename: 'Icon'
  embedding: Scalars['Vector']
  /** Enum options that use the icon */
  enumOptions: Array<EnumOption>
  id: Scalars['ID']
  /** The DossIcon asset filename, e.g. `check.svg` */
  name: Scalars['String']
  /** Tables that use the icon */
  tables: Array<Table>
  /** Workspace buttons that use the icon */
  workspaceButtons: Array<WorkspaceButton>
}

/**
 * Used to indicate what database indexes should be created for a model.
 * These should contain the names of any properties that should be added to the index.
 */
export type IndexDefinition = {
  fields: Array<Scalars['String']>
  ops?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}

/** The type of the index value used in a column, NONE if not an index column */
export enum IndexType {
  NONE = 'NONE',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
}

/** An integration to a 3rd party system */
export type Integration = {
  __typename: 'Integration'
  /** Any action steps that are associated with this integration */
  actionSteps: Array<ActionStep>
  /** The authentication methods configured for this integration (e.g. ['oauth', 'api_key']) */
  authType: Maybe<Array<Maybe<Scalars['String']>>>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  installLink: Maybe<Scalars['String']>
  /** Certain metadata is associated with each type of integration */
  metadata: Scalars['JSONObject']
  /** Any object store table operations that are associated with this integration */
  objectStoreTableOperations: Array<ObjectStoreTableSync>
  organization: Organization
  slug: Scalars['String']
  status: IntegrationStatus
  syncs: Array<IntegrationSync>
  type: IntegrationType
  /** Certain integrations are associated with a specific user in which case this is set */
  user: Maybe<Membership>
  /** Deprecated: The user string ID is now a UUID */
  userId_deprecated: Maybe<Scalars['String']>
}

export type IntegrationCredentialInput = {
  metadata?: InputMaybe<Scalars['JSONObject']>
  password: Scalars['String']
  username: Scalars['String']
}

/** The status of an individual integration */
export enum IntegrationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type IntegrationSync = {
  __typename: 'IntegrationSync'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  integration: Integration
  metadata: Maybe<Scalars['JSONObject']>
  status: IntegrationSyncStatus
}

/** The status of an individual integration sync */
export enum IntegrationSyncStatus {
  CANCELED = 'CANCELED',
  ERROR = 'ERROR',
  NOT_PROCESSED = 'NOT_PROCESSED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  SYNCING = 'SYNCING',
}

/** Result of testing an integration */
export type IntegrationTestResult = {
  __typename: 'IntegrationTestResult'
  /** If invalid, the reason why */
  invalidReason: Maybe<Scalars['String']>
  /** Whether the integration is valid and working */
  isValid: Scalars['Boolean']
}

export enum IntegrationType {
  /** Doss-managed integrations */
  A2B_FULFILLMENT = 'A2B_FULFILLMENT',
  AIRTABLE = 'AIRTABLE',
  AMAZON_SELLER = 'AMAZON_SELLER',
  ARAMEX = 'ARAMEX',
  BEPRODUCT = 'BEPRODUCT',
  BILL = 'BILL',
  BREX = 'BREX',
  /** Customer Integrations */
  BRND_SUPPLIER = 'BRND_SUPPLIER',
  BRND_WHOLESALE = 'BRND_WHOLESALE',
  BUHO = 'BUHO',
  BYRD = 'BYRD',
  CAMPFIRE = 'CAMPFIRE',
  /** CartonCloud 3PL/WMS integration */
  CARTONCLOUD = 'CARTONCLOUD',
  CROPSTER = 'CROPSTER',
  CRSTL = 'CRSTL',
  D2 = 'D2',
  DEPOSCO = 'DEPOSCO',
  /** Doss Banking uses Stripe under the hood to link customer bank accounts */
  DOSS_BANKING = 'DOSS_BANKING',
  /** Doss Bill Pay operates using Bill.com in a whitelabeled manner */
  DOSS_BILL_PAY = 'DOSS_BILL_PAY',
  /** Doss Exchange Rates uses Exchange Rates API under the hood to get exchange rates */
  DOSS_EXCHANGE_RATES = 'DOSS_EXCHANGE_RATES',
  EASYPOST = 'EASYPOST',
  ECHO_SHIP = 'ECHO_SHIP',
  EXTENSIV = 'EXTENSIV',
  EXTRON = 'EXTRON',
  FAIRE = 'FAIRE',
  FENO = 'FENO',
  FIRSTBASE = 'FIRSTBASE',
  FLEXPORT = 'FLEXPORT',
  FORTY_SEAS = 'FORTY_SEAS',
  FOSDICK = 'FOSDICK',
  FTP = 'FTP',
  G2MINT = 'G2MINT',
  GMAIL = 'GMAIL',
  GNOSIS = 'GNOSIS',
  GOBOLT = 'GOBOLT',
  GOFREIGHT = 'GOFREIGHT',
  GOOGLE_CLOUD_STORAGE = 'GOOGLE_CLOUD_STORAGE',
  HTTP_ENDPOINT = 'HTTP_ENDPOINT',
  HUBSPOT = 'HUBSPOT',
  INGRAM_MICRO = 'INGRAM_MICRO',
  ITS_LOGISTICS = 'ITS_LOGISTICS',
  JAY_GROUP = 'JAY_GROUP',
  JAZZ = 'JAZZ',
  JIGSAW = 'JIGSAW',
  LAZADA = 'LAZADA',
  LOCAD = 'LOCAD',
  LOGIWA = 'LOGIWA',
  LOOP_RETURNS = 'LOOP_RETURNS',
  MAINFREIGHT = 'MAINFREIGHT',
  MARKETTIME = 'MARKETTIME',
  MAYA = 'MAYA',
  MEDUSA = 'MEDUSA',
  MINTSOFT = 'MINTSOFT',
  MISFITS_MARKET = 'MISFITS_MARKET',
  NAVISPHERE = 'NAVISPHERE',
  NETSUITE = 'NETSUITE',
  NOK_RECOMMERCE = 'NOK_RECOMMERCE',
  NTG_WMS = 'NTG_WMS',
  ONE_WORLD_DIRECT = 'ONE_WORLD_DIRECT',
  ORDERFUL = 'ORDERFUL',
  OUTLOOK = 'OUTLOOK',
  POSTGRES = 'POSTGRES',
  PRO_PAC = 'PRO_PAC',
  QUICKBOOKS = 'QUICKBOOKS',
  RAMP = 'RAMP',
  RAPID_PACK = 'RAPID_PACK',
  RILLET = 'RILLET',
  ROUTABLE = 'ROUTABLE',
  SALSIFY = 'SALSIFY',
  SHIPBOB = 'SHIPBOB',
  SHIPHERO = 'SHIPHERO',
  SHIPMONK = 'SHIPMONK',
  SHIPSIDEKICK = 'SHIPSIDEKICK',
  SHIPSTATION = 'SHIPSTATION',
  SHIPWIRE = 'SHIPWIRE',
  SHOPEE = 'SHOPEE',
  SHOPIFY = 'SHOPIFY',
  SILQ = 'SILQ',
  SNAPFULFIL = 'SNAPFULFIL',
  SPS_COMMERCE = 'SPS_COMMERCE',
  STORD = 'STORD',
  STRIPE = 'STRIPE',
  TD_SYNNEX = 'TD_SYNNEX',
  TD_SYNNEX_XML = 'TD_SYNNEX_XML',
  THINK_LOGISTICS = 'THINK_LOGISTICS',
  TIKTOK_SHOP = 'TIKTOK_SHOP',
  TOAST = 'TOAST',
  /** TQL Freight (Total Quality Logistics) - freight integration for Mezcla */
  TQL_FREIGHT = 'TQL_FREIGHT',
  UNIS = 'UNIS',
  USA_SUPPLY = 'USA_SUPPLY',
  VERACORE = 'VERACORE',
  WALMART = 'WALMART',
  WAREHANCE = 'WAREHANCE',
  WESTERN_POST = 'WESTERN_POST',
  WOO_COMMERCE = 'WOO_COMMERCE',
  XERO = 'XERO',
}

/**
 * One Radar issue per organization and fingerprint: the thing teams assign, prioritize and
 * resolve. Occurrences are its evidence; history is its audit trail. Rows are only ever created
 * by the Radar grouper, which looks them up by (organizationId, fingerprint).
 */
export type Issue = {
  __typename: 'Issue'
  createdAt: Scalars['DateTime']
  /** The DossError template, or the scrubbed message when the failure had no template */
  errorTemplate: Scalars['String']
  /**
   * sha256 over where it failed, what operation failed and why. Issues are never
   * re-fingerprinted: a rule change starts new issues.
   */
  fingerprint: Scalars['String']
  history: Array<IssueHistory>
  id: Scalars['ID']
  impactedEntityId: Maybe<Scalars['ID']>
  /**
   * The entity to fix, as a SystemEventEntityType value; stored as text, as above.
   * This is different from the origin failure's entityType/entityId. E.g. the origin
   * failure could be TABLE_CELL, but the impacted entity would be the TABLE that the
   * cell belongs to.
   */
  impactedEntityType: Scalars['String']
  /**
   * Per-organization sequence behind the human-readable key ("ISS-214"), assigned by the grouper
   * when the issue is created. Two organizations can each have an ISS-214.
   */
  issueNumber: Scalars['Int']
  issueOriginId: Maybe<Scalars['ID']>
  /**
   * The workflow or object sync the failure ran inside, as a SystemEventEntityType value. Stored as
   * text because that enum is generated from the event catalog and is not a Prisma enum.
   */
  issueOriginType: Maybe<Scalars['String']>
  /** The timestamp of the latest occurrence */
  lastSeenAt: Scalars['DateTime']
  occurrences: Array<IssueOccurrence>
  organization: Organization
  owner: Maybe<Membership>
  priority: IssuePriority
  /** Why it was RESOLVED or IGNORED: the reason on the latest history row that set one */
  resolutionReason: Maybe<Scalars['String']>
  status: IssueStatus
  title: Scalars['String']
  updatedAt: Scalars['DateTime']
}

/**
 * One append-only row per issue change, by the system or a user. Each row copies the issue's
 * state after the change, so a regression and who reopened or resolved it can be read without
 * replaying. Exactly one cause is set: the user who made the change, or the occurrence that did.
 */
export type IssueHistory = {
  __typename: 'IssueHistory'
  causedByOccurrence: Maybe<IssueOccurrence>
  causedByUser: Maybe<Membership>
  /** Which of the fields above changed; null on the row written when the issue was created */
  changedFields: Maybe<Array<Scalars['String']>>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  issue: Issue
  organization: Organization
  /** The owner after this change; a plain id so deleting a user does not rewrite the audit trail */
  ownerId: Maybe<Scalars['ID']>
  priority: IssuePriority
  resolutionReason: Maybe<Scalars['String']>
  /** The issue's state after this change */
  status: IssueStatus
}

/**
 * One immutable row per qualifying FAIL system event. The evidence behind an issue: it stores
 * only the keys back into ClickHouse, never the payload.
 *
 * The error message and the originating failure event id are not denormalized here. Storing
 * them would let an occurrence list show its message without a ClickHouse read, but they
 * already live on the system event reachable via systemEventId, so copying them duplicates
 * per-occurrence payload in Postgres and can drift from the source. The issue's errorTemplate
 * and title cover what lists need today. A nullable column can be added later if the read
 * cost becomes a problem.
 */
export type IssueOccurrence = {
  __typename: 'IssueOccurrence'
  /** Here for referential integrity reasons, cannot be queried directly */
  causedHistory: Array<IssueHistory>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  issue: Issue
  organization: Organization
  /**
   * uuidv7 of the ClickHouse system_events row that the grouper consumed: the source FAIL event
   * for the workflow or object sync, not the nested event where the failure originated.
   * Unique, so a redelivered event is a no-op.
   */
  systemEventId: Scalars['ID']
  /** The event's own timestamp, which bounds the ClickHouse read that fetches it */
  systemEventTimestamp: Scalars['DateTime']
}

export enum IssuePriority {
  P0 = 'P0',
  P1 = 'P1',
  P2 = 'P2',
}

export enum IssueStatus {
  /** Understood and needs no action. A matching failure does not reopen it. */
  IGNORED = 'IGNORED',
  /** Assigned and being looked at */
  INVESTIGATING = 'INVESTIGATING',
  /** New, or reopened by a regression; nobody has picked it up */
  OPEN = 'OPEN',
  /** Root cause fixed. A matching failure reopens it. */
  RESOLVED = 'RESOLVED',
}

/**
 * A saved filter and sort over the Radar issue list, shown as a tab. Personal to its creator.
 * Anchored on the organization the page is opened in; the organizations the view spans live
 * inside filters.organizationIds. Name is unique per creator within an organization, so two
 * people may both have a "P1 issues".
 */
export type IssueView = {
  __typename: 'IssueView'
  createdAt: Scalars['DateTime']
  createdBy: Membership
  /**
   * PaginatedIssuesInput minus pagination: statuses, priorities, ownerIds, unassigned,
   * organizationIds, searchString, firstSeenBetween, lastSeenBetween. Zod-validated on write.
   */
  filters: Scalars['JSONObject']
  id: Scalars['ID']
  name: Scalars['String']
  /** Tab position among the creator's views */
  order: Scalars['Int']
  organization: Organization
  /** { field: IssueSortField, direction: SortDirection }; null means the default sort */
  sort: Maybe<Scalars['JSONObject']>
  updatedAt: Scalars['DateTime']
}

/** A generic JSON Schema used for defining action step inputs or validating selections */
export type JsonSchema = {
  __typename: 'JSONSchema'
  schema: Scalars['JSONObject']
}

/**
 * One product-analytics event recorded by Jitsu.
 *
 * Scoping comes from the caller's session.
 */
export type JitsuEvent = {
  __typename: 'JitsuEvent'
  /** Set on events from a browser session that was never identified */
  anonymousId: Scalars['String']
  contextPagePath: Scalars['String']
  contextPageUrl: Scalars['String']
  /** Segment event name, e.g. "Viewed" or "Table Search Used" */
  event: Scalars['String']
  /** Jitsu's per-event id; unique and always populated */
  messageId: Scalars['ID']
  timestamp: Scalars['DateTime']
  /** The identifier the event was recorded under: a Doss user id on newer events, a Firebase uid on older ones */
  userId: Scalars['ID']
}

/**
 * Window over the organization's Jitsu product-analytics events. The organization is taken from the
 * caller's session.
 */
export type JitsuEventsInput = {
  /** Segment event names to keep, e.g. "Table Search Used". Omit for every event in the window. */
  eventNames?: InputMaybe<Array<Scalars['String']>>
  /** Start of the window, inclusive */
  from: Scalars['DateTime']
  /** How many events to return, newest first. Defaults to 1000, capped at 10000. */
  limit?: InputMaybe<Scalars['Int']>
  /** End of the window, inclusive */
  to: Scalars['DateTime']
}

/** Standalone Kafka topics not derived from ActionAutoTriggerType */
export enum KafkaTopics {
  WEBHOOKS_DLQ = 'WEBHOOKS_DLQ',
  WEBHOOKS_INTAKE = 'WEBHOOKS_INTAKE',
}

export type LineChartAggregation = {
  __typename: 'LineChartAggregation'
  data: Array<LineChartCoordinate>
  id: Scalars['String']
}

export type LineChartCoordinate = {
  __typename: 'LineChartCoordinate'
  xFloat: Maybe<Scalars['Float']>
  xString: Maybe<Scalars['String']>
  yFloat: Maybe<Scalars['Float']>
  yString: Maybe<Scalars['String']>
}

export enum Locale {
  DE_DE = 'DE_DE',
  EN_CA = 'EN_CA',
  EN_GB = 'EN_GB',
  EN_IE = 'EN_IE',
  EN_NZ = 'EN_NZ',
  EN_US = 'EN_US',
  ES_ES = 'ES_ES',
  ES_MX = 'ES_MX',
  FR_CA = 'FR_CA',
  FR_FR = 'FR_FR',
  HE_IL = 'HE_IL',
  NL_NL = 'NL_NL',
  ZH_HK = 'ZH_HK',
  ZH_SG = 'ZH_SG',
}

/**
 * Logical expressions used in formulas and other areas. Replica of branch action step metadata.
 * - For AND and OR types, the values are the child expressions.
 * - For NOT types, there is only one expression value.
 * - For BOOLEAN types, there is a boolean value.
 * - For COMPARISON types, there is a condition and a list of values of length two (left and right).
 * - For UNARY types, there is a condition and a single value
 */
export type LogicExpression = {
  __typename: 'LogicExpression'
  /**
   * The button transition that uses this expression as its transition condition.
   * Determines if a row should follow this transition when updated.
   */
  buttonTransition: Maybe<TableButtonTransition>
  /** For COMPARISON or UNARY types, specify the condition */
  condition: Maybe<LogicExpressionCondition>
  id: Scalars['ID']
  /**
   * The logic expression as a string (only present on root logic expression).
   * Required for the logic expression builder UI.
   * Example: "status = 'sent' AND sentAt IS NOT NULL"
   */
  logicExpressionString: Maybe<Scalars['String']>
  /** The parent expression value that this expression belongs to */
  parentExpressionValue: Maybe<LogicExpressionValue>
  /** The form input group that uses this logic expression to filter lookup rows (FormV2) */
  parentFormLookupGroupMapping: Maybe<FormLookupInputGroup>
  /** The form field that uses this logic expression to filter lookup columns (FormV1) */
  parentFormLookupMapping: Maybe<FormField>
  /** The form validation condition that uses this logic expression */
  parentFormValidationCondition: Maybe<FormValidationCondition>
  /** The form visibility condition that uses this logic expression */
  parentFormVisibilityCondition: Maybe<FormVisibilityCondition>
  /** The formula that uses this logic expression to filter column operations */
  parentFormula: Maybe<Formula>
  /** The formula condition that uses this logic expression */
  parentFormulaCondition: Maybe<FormulaCondition>
  /** The table column that uses this logic expression to filter lookup columns */
  parentTableLookupMapping: Maybe<TableColumn>
  /** The type of the expression */
  type: LogicExpressionType
  /** The values this expression is comprised of */
  values: Array<LogicExpressionValue>
}

export enum LogicExpressionCondition {
  /** array/scalar input CONDITION scalar value */
  CONTAINS = 'CONTAINS',
  CONTAINS_ALL = 'CONTAINS_ALL',
  /** array input CONDITION array value */
  CONTAINS_ANY = 'CONTAINS_ANY',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  DOES_NOT_CONTAIN_ANY = 'DOES_NOT_CONTAIN_ANY',
  /** scalar input CONDITION scalar value */
  EQUAL = 'EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  /** scalar input CONDITION array/scalar value */
  IN = 'IN',
  /** unary conditions */
  IS_EMPTY = 'IS_EMPTY',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  NOT_IN = 'NOT_IN',
}

export type LogicExpressionInput = {
  condition?: InputMaybe<LogicExpressionCondition>
  logicExpressionString?: InputMaybe<Scalars['String']>
  type: LogicExpressionType
  values: Array<LogicExpressionValueInput>
}

export enum LogicExpressionType {
  AND = 'AND',
  BOOLEAN = 'BOOLEAN',
  COMPARISON = 'COMPARISON',
  NOT = 'NOT',
  OR = 'OR',
  UNARY = 'UNARY',
}

/** Single value in a logic expression */
export type LogicExpressionValue = {
  __typename: 'LogicExpressionValue'
  /** The value of the expression if it is a column (gets the column value for the current row) */
  column: Maybe<TableColumn>
  /** The value of the expression if it is the user-entered value in a form field (FormV1) */
  formField: Maybe<FormField>
  /** The value of the expression if it is the user-entered value in a form input (FormV2) */
  formInput: Maybe<FormInput>
  /** The value of the expression if it is a formula (resolves the formula value) */
  formula: Maybe<Formula>
  id: Scalars['ID']
  /** The value of the expression if it is a nested expression (computes the nested expression value) */
  nestedExpression: Maybe<LogicExpression>
  /** The order of the value in the expression */
  order: Scalars['Int']
  /** The expression that this value belongs to */
  parentExpression: LogicExpression
  /** The value of the expression if a scalar (same type as TableCell.data) */
  value: Maybe<Scalars['JSONObject']>
}

export type LogicExpressionValueInput = {
  columnId?: InputMaybe<Scalars['ID']>
  formFieldId?: InputMaybe<Scalars['ID']>
  formInputId?: InputMaybe<Scalars['ID']>
  formula?: InputMaybe<FormulaInput>
  nestedExpression?: InputMaybe<LogicExpressionInput>
  order: Scalars['Int']
  /** Exactly one of the following values should be set to represent the logic expression value */
  value?: InputMaybe<Scalars['JSONObject']>
}

/**
 * The logical-identity registry: maps an authored logical id — stable across renames — to the
 * physical entity it names. Scope is the parent-binding chain, mirroring entity ownership, so a
 * column's binding hangs under its table's and resolution walks org → table → column. The target is
 * a bare id plus kind, no foreign key: the registry outlives UI deletes (swept by deploy and pull),
 * and one table serves every kind.
 */
export type LogicalBinding = {
  __typename: 'LogicalBinding'
  children: Array<LogicalBinding>
  createdAt: Scalars['DateTime']
  entityKind: LogicalEntityKind
  id: Scalars['ID']
  /** The authored logical id — unique within (organization, parent, kind); frozen at mint */
  localId: Scalars['String']
  organization: Organization
  /** The parent binding that scopes this one; null for a top-level entity */
  parent: Maybe<LogicalBinding>
  /** The bound entity's row id — a bare id, resolved by kind; never a foreign key */
  physicalId: Scalars['ID']
  /** The authored file that homes this entity in a configbase; null until a pull or deploy sets it */
  provenance: Maybe<Scalars['String']>
}

/**
 * The kind of platform entity a LogicalBinding names. Scoped kinds resolve under a parent binding
 * (COLUMN and STATE under their TABLE, TRIGGER under its WORKFLOW, WORKSPACE_BUTTON under the
 * ROOT_WORKSPACE, DASHBOARD, TABLE or STATE that places it, DASHBOARD under its container); the rest
 * are top-level within the organization. ROOT_WORKSPACE is the organization-parented Workspace row
 * (the product's "project"); DASHBOARD is a nested one.
 */
export enum LogicalEntityKind {
  APP = 'APP',
  CHART = 'CHART',
  COLUMN = 'COLUMN',
  CONNECTION = 'CONNECTION',
  DASHBOARD = 'DASHBOARD',
  ENDPOINT = 'ENDPOINT',
  FORM = 'FORM',
  LOOKUP_GROUP = 'LOOKUP_GROUP',
  ROOT_WORKSPACE = 'ROOT_WORKSPACE',
  STATE = 'STATE',
  TABLE = 'TABLE',
  TRIGGER = 'TRIGGER',
  WORKFLOW = 'WORKFLOW',
  WORKSPACE_BUTTON = 'WORKSPACE_BUTTON',
}

/**
 * Represents a grouping of columns. Used primarily to group together columns that do lookups on the
 * same row.
 */
export type LookupTableColumnGroup = {
  __typename: 'LookupTableColumnGroup'
  /** The name of the backlink lookup table */
  backlinkName: Maybe<Scalars['String']>
  /** Column versions tracking schema evolution for this lookup column group */
  columnVersions: Array<TableColumnVersion>
  /** The columns that are part of this group */
  columns: Array<TableColumn>
  id: Scalars['ID']
  /** The table that contains the columns that are looked up by the columns in this group */
  lookupTable: Table
  /** If true, the column group will show the inverse relation of this lookup on the lookup table */
  showBacklink: Maybe<Scalars['Boolean']>
  /** Stable, owning-table-scoped slug identifying this lookup relationship, derived from the group's members and disambiguated on collision. Null for member-less groups and for groups predating the field until backfilled. */
  slug: Maybe<Scalars['String']>
}

/**
 * If a user has an account, it means they can log into Doss and use it, as long as their status
 * is ACTIVE. If they do not, there will instead by a Contact for display which is pulled from emails
 * and other data sources
 */
export type Membership = {
  __typename: 'Membership'
  /** The agent chats that the user has created */
  agentChats: Array<DossbotChat>
  /** Radar issue changes this user made */
  causedIssueHistory: Array<IssueHistory>
  comments: Array<Comment>
  /** The documents that the user has created */
  createdDocuments: Array<Document>
  /** The endpoint versions the user has published */
  createdEndpointVersions: Array<EndpointVersion>
  /** Radar issue views this user saved */
  createdIssueViews: Array<IssueView>
  /** Here for referential integrity reasons, cannot be queried directly */
  createdTableRows: Array<TableRow>
  /** The Workflows V2 program versions the user has published */
  createdWorkflowV2Versions: Array<WorkflowV2Version>
  /** The workspaces that the user has created */
  createdWorkspaces: Array<Workspace>
  /** The user's selected default signature, if any */
  defaultSignature: Maybe<Signature>
  email: Maybe<Scalars['String']>
  /** The ID of the matching Organization Membership in WorkOS */
  externalMembershipId: Maybe<Scalars['String']>
  /** External auth provider user ID (e.g., WorkOS) for authentication lookup. */
  externalUserId: Maybe<Scalars['String']>
  /** Firebase ID for the user */
  firebaseUid: Maybe<Scalars['String']>
  firstName: Scalars['String']
  id: Scalars['ID']
  integrations: Array<Integration>
  /** The membership (in this organization) of whoever sent the invitation, if anyone */
  invitedBy: Maybe<Membership>
  /** Memberships this membership invited */
  invitedMemberships: Array<Membership>
  /** Indicates if this user account is a Robopmo account for programmatic access */
  isRobopmoAccount: Maybe<Scalars['Boolean']>
  lastName: Scalars['String']
  locale: Maybe<Locale>
  notifications: Array<Notification>
  /** The deploys the user has run against their organization's schema */
  orgSchemaVersions: Array<OrgSchemaVersion>
  organization: Organization
  /** Organization-wide exports created by this user */
  organizationExports: Array<OrganizationExport>
  orientation: ApplicationOrientation
  /** Radar issues this user owns */
  ownedIssues: Array<Issue>
  phoneNumber: Maybe<Scalars['String']>
  policiesAcceptedAt: Maybe<Scalars['DateTime']>
  /** The user's profile picture, if any */
  profilePicture: Maybe<Document>
  /** When this membership was revoked. Set if and only if the membership is INACTIVE. */
  revokedAt: Maybe<Scalars['DateTime']>
  /** The roles that the user has */
  roles: Array<Role>
  signatures: Array<Signature>
  status: MembershipStatus
  /** CSV exports created by this user */
  tableExports: Array<TableExport>
  timeZone: Scalars['String']
  /** Transition records triggered by this user's actions */
  triggeredButtonTransitionHistory: Array<TableButtonTransitionHistory>
  updatedDocuments: Array<Document>
  /** Here for referential integrity reasons, cannot be queried directly */
  updatedTableRows: Array<TableRow>
  updatedWorkspaces: Array<Workspace>
  /** The person this membership belongs to */
  user: User
}

/** Status of a user's membership in a single organization */
export enum MembershipStatus {
  ACTIVE = 'ACTIVE',
  /** User's organization membership has been deactivated. It can be reactivated if needed */
  INACTIVE = 'INACTIVE',
  /** User has been invited to organization but has not accepted yet */
  PENDING = 'PENDING',
}

/** A model from a provider that can be used for generation */
export type ModelOption = {
  __typename: 'ModelOption'
  /** Price in USD per 1M cache-read (cached input) tokens. Null until the model is priced. */
  cacheReadUsdPerMtok: Maybe<Scalars['Float']>
  /** Price in USD per 1M cache-write (cache-creation) tokens. Null until the model is priced. */
  cacheWriteUsdPerMtok: Maybe<Scalars['Float']>
  id: Scalars['ID']
  /** Price in USD per 1M uncached input tokens. Null until the model is priced. */
  inputUsdPerMtok: Maybe<Scalars['Float']>
  /** The name of the model from the provider's API */
  modelName: Scalars['String']
  /** The model specifications that use this model */
  modelSpecs: Array<ModelSpecification>
  /** Price in USD per 1M output tokens. Null until the model is priced. */
  outputUsdPerMtok: Maybe<Scalars['Float']>
  provider: ModelProvider
}

export enum ModelProvider {
  ANTHROPIC = 'ANTHROPIC',
  OPENAI = 'OPENAI',
}

/** The spec used for any model invocation. It has an associated system prompt, an AI model to use. */
export type ModelSpecification = {
  __typename: 'ModelSpecification'
  id: Scalars['ID']
  /** The maximum number of steps the agent can take before it is aborted */
  maxSteps: Scalars['Int']
  /** The model this model specification uses */
  model: ModelOption
  name: Scalars['String']
  /** The runs of this model specification */
  runs: Array<AgentRun>
  /** The system prompts that are registered with this agent. Only chooses the latest version. */
  systemPrompts: Array<SystemPrompt>
  /** The tool run steps that use this model specification */
  toolRunSteps: Array<ToolRunStep>
}

export enum Month {
  APRIL = 'April',
  AUGUST = 'August',
  DECEMBER = 'December',
  FEBRUARY = 'February',
  JANUARY = 'January',
  JULY = 'July',
  JUNE = 'June',
  MARCH = 'March',
  MAY = 'May',
  NOVEMBER = 'November',
  OCTOBER = 'October',
  SEPTEMBER = 'September',
}

export type MoveTableColumnGroupMemberInput = {
  tableColumnGroupMemberId: Scalars['ID']
  targetTableColumnGroupId: Scalars['ID']
}

export type MoveTableColumnGroupMembersInput = {
  tableColumnGroupMemberIds: Array<Scalars['ID']>
  targetTableColumnGroupId: Scalars['ID']
}

export type MoveWorkspaceInput = {
  newParentWorkspaceId: Scalars['ID']
  objectId: Scalars['ID']
  objectType: ViewableObjectType
  oldParentWorkspaceId: Scalars['ID']
}

export type Mutation = {
  __typename: 'Mutation'
  /** Accepts terms and conditions */
  acceptTermsAndConditions: Membership
  /** Approve OAuth2 authorization request for app OAuth flow */
  authorizeAppOAuth2Request: AuthorizeOAuth2Result
  /** Authorize an integration installation request */
  authorizeIntegration: Integration
  /** Deletes multiple table rows in bulk */
  bulkDeleteTableRows: BulkDeleteTableRowsResult
  /** Duplicates multiple table rows in bulk */
  bulkDuplicateTableRows: BulkDuplicateTableRowsResult
  /** Call a deployed endpoint and wait for its output. Authorized per call: the endpoint exists, is enabled, is not internal, and the caller's role may call it. */
  callEndpoint: CallEndpointResult
  /** Cancels an dossbot run */
  cancelDossbotChatRun: DossbotChatRun
  /** Cancels an invitation that hasn't been accepted yet */
  cancelInvite: Membership
  /** Creates an empty action */
  createAction: Action
  /** Creates a frequency-based trigger for an action like a cron task */
  createActionFrequencyTrigger: ActionFrequencyTrigger
  /** Creates a manual trigger button for an action */
  createActionManualTrigger: ActionManualTrigger
  /** Create OAuth2 authorization request for app OAuth flow */
  createAppOAuth2AuthorizationRequest: CreateOAuth2AuthorizationResult
  /** Creates multiple workspace buttons for a button node */
  createButtonNodeWorkspaceButtons: Array<WorkspaceButton>
  /** Creates a chart */
  createChart: Chart
  /** Creates a new child table */
  createChildTable: Table
  /** Creates a comment */
  createComment: Comment
  /** Creates a document in a view */
  createDocumentView: Document
  /** Creates a new dossbot chat */
  createDossbotChat: DossbotChat
  /** Creates a new dossbot run */
  createDossbotChatRun: DossbotChatRun
  /** Creates a form */
  createForm: Form
  /** Creates a form category */
  createFormCategory: FormCategory
  /** Creates a form page field */
  createFormField: FormField
  /** Creates a form input block */
  createFormInputBlock: FormBlock
  /** Creates a layout-type form block, SECTION, TEXT_ELEMENT, DIVIDER */
  createFormLayoutBlock: FormBlock
  /** Creates a form page */
  createFormPage: FormPage
  /** Creates a row along with any children that are new blocks */
  createFormRowBlock: FormBlock
  /** Creates a form table block */
  createFormTableBlock: FormBlock
  /** Creates a blank, untitled form with an empty first section */
  createFormV2: FormV2
  /** Creates a new form variant with pre-filled values */
  createFormVariant: FormVariant
  /** Creates a visibility condition and links it to the specified form blocks */
  createFormVisibilityCondition: FormVisibilityCondition
  /** Creates a new integration */
  createIntegration: Integration
  /** Creates an object store table transfer for scheduled import/export */
  createObjectStoreTableSync: ObjectStoreTableSync
  /** Creates an organization-wide export that bundles every table's CSV into a single zip */
  createOrganizationExport: OrganizationExport
  /** Creates a role */
  createRole: Role
  /** Creates a signature */
  createSignature: Signature
  /** Creates an empty Stripe account during user Stripe integration onboarding */
  createStripeAccount: Scalars['String']
  /** Creates a Stripe Financial Connections Customer and returns the account id */
  createStripeFinancialConnectionsCustomer: Scalars['String']
  /** Creates a Stripe Financial Connections Session and returns the client secret */
  createStripeFinancialConnectionsSession: Scalars['String']
  /** Creates a new table */
  createTable: Table
  /** Creates a new button node */
  createTableButtonNode: TableButtonNode
  /** Creates a new button node transition */
  createTableButtonTransition: TableButtonTransition
  /** Creates a new table column */
  createTableColumn: TableColumn
  /** Creates a new table column filter */
  createTableColumnFilter: TableColumnFilter
  /** Creates a new table column group */
  createTableColumnGroup: TableColumnGroup
  /** Creates a new table column group member */
  createTableColumnGroupMember: TableColumnGroupMember
  /** Creates multiple new table column group members */
  createTableColumnGroupMembers: Array<TableColumnGroupMember>
  /** Creates a CSV export job for a table */
  createTableExport: TableExport
  /** Creates a new table row */
  createTableRow: TableRow
  /** Creates a new table tab */
  createTableTab: TableTab
  /** Creates a new table tab column mapping */
  createTableTabColumn: TableTabColumn
  /** Creates a new table tab sort */
  createTableTabSort: TableTabSort
  /** Creates and asynchronously activates a unique constraint over one or more table columns */
  createTableUniqueConstraint: TableUniqueConstraint
  /** Invites someone to the organization (their membership stays PENDING until they accept) */
  createUser: Membership
  /** Creates a new view */
  createView: View
  /** Creates a workspace */
  createWorkspace: Workspace
  /** Creates a workspace button */
  createWorkspaceButton: WorkspaceButton
  /** Deletes an action and associated steps or triggers */
  deleteAction: Action
  /** Deletes an automatic trigger for an action */
  deleteActionAutoTrigger: ActionAutoTrigger
  /** Deletes a frequency-based trigger for an action */
  deleteActionFrequencyTrigger: ActionFrequencyTrigger
  /** Deletes a manual trigger for an action */
  deleteActionManualTrigger: ActionManualTrigger
  /** Deletes an action step */
  deleteActionStep: ActionStep
  /** Deletes a chart and all its associated views */
  deleteChart: Chart
  /** Deletes a comment */
  deleteComment: Comment
  /** Deletes a directory workspace */
  deleteDirectoryWorkspace: Workspace
  /** Deletes a document */
  deleteDocument: Document
  /** Deletes a form */
  deleteForm: Form
  /** Deletes a form block and all of its nested elements */
  deleteFormBlock: FormBlock
  /** Deletes a form category */
  deleteFormCategory: FormCategory
  /** Deletes a form page field */
  deleteFormField: FormField
  /** Deletes a form page */
  deleteFormPage: FormPage
  /** Deletes a form and all of its nested elements */
  deleteFormV2: FormV2
  /** Deletes a form variant */
  deleteFormVariant: FormVariant
  /** Deletes a visibility condition and disconnects all form blocks */
  deleteFormVisibilityCondition: FormVisibilityCondition
  /** Delete integration */
  deleteIntegration: Integration
  /** Deletes an object store table transfer */
  deleteObjectStoreTableSync: ObjectStoreTableSync
  /** Deletes a role */
  deleteRole: Role
  /** Deletes a table and associated data by ID */
  deleteTable: Table
  /** Deletes a button node */
  deleteTableButtonNode: TableButtonNode
  /** Deletes a button node transition */
  deleteTableButtonTransition: TableButtonTransition
  /** Deletes a table column by ID */
  deleteTableColumn: TableColumn
  /** Deletes a table column filter */
  deleteTableColumnFilter: TableColumnFilter
  /** Deletes a table column group */
  deleteTableColumnGroup: TableColumnGroup
  /** Deletes a table column group member */
  deleteTableColumnGroupMember: TableColumnGroupMember
  /** Deletes multiple table column group members */
  deleteTableColumnGroupMembers: Array<TableColumnGroupMember>
  /** Deletes multiple table columns by ID */
  deleteTableColumns: Array<TableColumn>
  /** Deletes a table row by ID */
  deleteTableRow: TableRow
  /** Deletes a table row by ID and returns row-level blocker details instead of throwing */
  deleteTableRowWithResult: DeleteTableRowResult
  /** Deletes table rows by row IDs and/or parent row IDs, returns the number of deleted rows */
  deleteTableRows: Scalars['Int']
  /** Deletes a table tab */
  deleteTableTab: TableTab
  /** Deletes a table tab column mapping */
  deleteTableTabColumn: TableTabColumn
  /** Deletes a table tab sort */
  deleteTableTabSort: TableTabSort
  /** Deletes a table unique constraint and asynchronously removes its index when necessary */
  deleteTableUniqueConstraint: TableUniqueConstraint
  /** Deletes a pre-filled value for a specific input in a variant */
  deleteVariantInputValue: FormVariantInput
  /** Deletes a view and associated data by ID */
  deleteView: View
  /** Deletes a workspace */
  deleteWorkspace: Workspace
  /** Deletes a workspace button */
  deleteWorkspaceButton: WorkspaceButton
  /** Moves a top-level folder into another folder or a table, returning its new view */
  demoteRootWorkspace: View
  /** Disable all the actions in a workflow */
  disableWorkflow: Workflow
  /** Disconnects a form block from a visibility condition, deleting the condition if orphaned */
  disconnectFormBlockFromVisibilityCondition: FormVisibilityCondition
  /** Creates a zip file of all documents within the workspace recursively. Returns the GCS path. */
  downloadWorkspaceDocuments: Scalars['String']
  /** Duplicates a chart */
  duplicateChart: Chart
  /** Duplicates a form and all of its pages, categories, and fields */
  duplicateForm: Form
  /**
   * Duplicates a form v2 and all of its blocks, inputs, input groups, lookup input groups,
   * visibility conditions, and validation conditions
   */
  duplicateFormV2: FormV2
  /** Duplicates a role */
  duplicateRole: Role
  /** Duplicates a table row by ID */
  duplicateTableRow: TableRow
  /** Duplicates a view and associated data */
  duplicateView: View
  /** Deploys built dynamic apps to the calling user's organization; refuses if planHash no longer matches */
  dynamicAppDeploy: DynamicAppDeployResult
  /** Enable all the actions in a workflow */
  enableWorkflow: Workflow
  /** Executes the action associated with a manual trigger */
  executeActionManualTrigger: ActionManualTrigger
  /** Executes an action on multiple rows in bulk */
  executeBulkAction: ExecuteBulkActionResult
  /** Gets the account secret for the Stripe account that was created */
  getStripeAccountSecret: Scalars['String']
  markAllNotificationsAsRead: Array<Notification>
  markNotificationAsArchived: Notification
  markNotificationAsRead: Notification
  markNotificationAsUnread: Notification
  /**
   * Generates a form v2 from a form v1 and updates the form's action auto trigger to be triggered
   * by the formV2 submission. The action auto trigger's action's action steps mappings will be updated
   * to reflect the new formV2.
   */
  migrateFormV1ToV2: Form
  /** Moves the provided table column group member from its current table column group to the target */
  moveTableColumnGroupMember: TableColumnGroupMember
  /** Moves the provided table column group members from their current table column group to the target */
  moveTableColumnGroupMembers: Array<TableColumnGroupMember>
  /** Moves a workspace to a new parent workspace */
  moveWorkspace: Workspace
  /** Atomically replace the calling organization's navigation and source snapshot pointer. */
  navigationDeploy: NavigationDeployResult
  /** Moves a nested folder to the top level, taking it out of every folder it's in */
  promoteToRootWorkspace: Workspace
  /** Regenerates the certificate pair for a Netsuite integration */
  regenerateNetsuiteCertificate: NetsuitePublicKey
  /** Reorders the provided child table */
  reorderChildTable: Table
  /** Moves a form block to a new order or parent block */
  reorderFormBlock: FormBlock
  /** Reorders the provided form category */
  reorderFormCategory: FormCategory
  /** Reorders the provided form field */
  reorderFormField: FormField
  /** Reorders the provided form page */
  reorderFormPage: FormPage
  /** Reorders the provided table column */
  reorderTableColumn: TableColumn
  /** Reorders the provided table column group */
  reorderTableColumnGroup: TableColumnGroup
  /** Reorders the provided table column group member */
  reorderTableColumnGroupMember: TableColumnGroupMember
  /** Reorders the provided table columns as one block */
  reorderTableColumns: Array<TableColumn>
  /** Reorders the provided table tab */
  reorderTableTab: Array<TableTab>
  /** Reorders the provided workspace button */
  reorderWorkspaceButton: WorkspaceButton
  /** Requests a 2FA code for the provided integration */
  requestIntegration2FACode: Integration
  /** Emails an invitation that hasn't been accepted yet again, with a new link */
  resendInvite: Membership
  /** Respond to a tool confirmation request (approve or reject) from Dossbot chat workflow */
  respondToDossbotToolConfirmation: ToolRunStep
  /** Retries validation and activation after a conflict or infrastructure error */
  retryTableUniqueConstraintActivation: TableUniqueConstraint
  /**
   * For a formV2 generated from a formV1, this will revert the changes to the formV1 and its original
   * action auto trigger and related action's action steps
   */
  rollbackFormV1ToV2Migration: Form
  /** Searches recursively in a workspace by name */
  searchWorkspace: SearchWorkspaceResult
  /** Sends an email */
  sendEmail: Scalars['Boolean']
  /** Enables or disables a Workflows V2 program: toggles its frequency schedules and gates dispatch */
  setWorkflowV2Enabled: WorkflowV2
  /** Shares a form v2 with external users by creating SUBMIT_FORM permission for EXTERNAL role */
  shareFormV2: FormV2
  /** Submits a form */
  submitForm: Form
  /** Submits a form */
  submitFormV2: FormV2
  /** Triggers the re-evaluation of the button nodes for all the rows in a table */
  triggerTableButtonNodeEvaluation: TableButtonNodeEvaluationResult
  /** Restricts access to a form v2 by removing SUBMIT_FORM permission for EXTERNAL role */
  unshareFormV2: FormV2
  /** Updates an action's metadata */
  updateAction: Action
  /** Updates a chart */
  updateChart: Chart
  /** Updates the name of a chart */
  updateChartName: Chart
  /** Updates a document's name */
  updateDocument: Document
  /** Updates the name of an embed */
  updateEmbedName: Embed
  /** Attaches versioned guest content to an embed (or detaches it when viewContentId is null) */
  updateEmbedViewContent: Embed
  /** Updates a form */
  updateForm: Form
  /** Updates a form category */
  updateFormCategory: FormCategory
  /** Updates a form page field */
  updateFormField: FormField
  /** Updates the properties of a form input block, does not allow reordering */
  updateFormInputBlock: FormBlock
  /** Updates a layout-type form block */
  updateFormLayoutBlock: FormBlock
  /** Updates a form page */
  updateFormPage: FormPage
  /** Updates the properites of a form table, such as input group label, ordering of columns, and other metadata */
  updateFormTableBlock: FormBlock
  /** Updates a form v2 (name, redirect settings, etc.) */
  updateFormV2: FormV2
  /** Updates a form variant's name and description */
  updateFormVariant: FormVariant
  /** Updates a visibility condition's name and expression */
  updateFormVisibilityCondition: FormVisibilityCondition
  /** Updates an integration */
  updateIntegration: Integration
  /** Creates or updates credentials for the provided integration */
  updateIntegrationCredentials: Integration
  /** Updates an object store table transfer */
  updateObjectStoreTableSync: ObjectStoreTableSync
  /** Updates a role */
  updateRole: Role
  /** Updates a role's table permissions */
  updateRoleTablePermissions: Role
  /** Updates the current button nodes for a table row */
  updateRowCurrentNodes: TableRow
  /** Updates a table */
  updateTable: Table
  /** Updates a button node */
  updateTableButtonNode: TableButtonNode
  /** Updates a button node transition */
  updateTableButtonTransition: TableButtonTransition
  /** Updates a table cell with the provided input data */
  updateTableCell: TableCell
  /** Updates a new table column */
  updateTableColumn: TableColumn
  /** Updates a table column filter */
  updateTableColumnFilter: TableColumnFilter
  /** Updates the table column filters */
  updateTableColumnFilters: Array<TableColumnFilter>
  /** Updates a table column group */
  updateTableColumnGroup: TableColumnGroup
  /** Change visibility of table columns */
  updateTableColumnsVisibility: Array<TableColumn>
  /** Updates a table row */
  updateTableRow: TableRow
  /** Updates a table tab */
  updateTableTab: TableTab
  /** Updates a table tab column mapping */
  updateTableTabColumn: TableTabColumn
  /** Updates the table tab columns */
  updateTableTabColumns: Array<TableTabColumn>
  /** Updates a table tab sort */
  updateTableTabSort: TableTabSort
  /** Updates the table tab sorts */
  updateTableTabSorts: Array<TableTabSort>
  /** Updates an existing user */
  updateUser: Membership
  /** Updates a user's profile picture */
  updateUserProfilePicture: Membership
  /** Updates a user's roles */
  updateUserRoles: Membership
  /** Sets a pre-filled value for a specific input in a variant */
  updateVariantInputValue: FormVariantInput
  /** Updates a view */
  updateView: View
  /** Updates a workspace */
  updateWorkspace: Workspace
  /** Updates a workspace button */
  updateWorkspaceButton: WorkspaceButton
  /** Updates the height of a workspace row */
  updateWorkspaceRowHeight: Workspace
  /** Upload CSV of table data */
  uploadTableDataCsv: Table
  /** Creates the transition between two nodes, or updates the existing one between them */
  upsertTableButtonTransition: TableButtonTransition
  /** Create a ViewContent (omit id) or append a new version (supply id). Returns the latest state. */
  upsertViewContent: ViewContent
  /** Deploys built workflow artifacts to the calling user's organization; refuses if planHash no longer matches */
  workflowsV2Deploy: WorkflowsV2DeployResult
  /** Fires a deployed Workflows V2 program's trigger with a supplied payload — the `doss trigger` backend */
  workflowsV2Trigger: WorkflowsV2TriggerResult
  /** Stages source file bytes in the org's content-addressed source store; hashes are verified server-side */
  workflowsV2UploadSourceFiles: Scalars['Boolean']
}

export type MutationAuthorizeAppOAuth2RequestArgs = {
  requestId: Scalars['ID']
}

export type MutationAuthorizeIntegrationArgs = {
  input: AuthorizeIntegrationInput
}

export type MutationBulkDeleteTableRowsArgs = {
  input: BulkDeleteTableRowsInput
}

export type MutationBulkDuplicateTableRowsArgs = {
  input: BulkDuplicateTableRowsInput
}

export type MutationCallEndpointArgs = {
  input: CallEndpointInput
}

export type MutationCancelDossbotChatRunArgs = {
  runId: Scalars['ID']
}

export type MutationCancelInviteArgs = {
  membershipId: Scalars['ID']
}

export type MutationCreateActionArgs = {
  input: CreateActionInput
}

export type MutationCreateActionFrequencyTriggerArgs = {
  input: CreateActionFrequencyTriggerInput
}

export type MutationCreateActionManualTriggerArgs = {
  input: CreateActionManualTriggerInput
}

export type MutationCreateAppOAuth2AuthorizationRequestArgs = {
  input: CreateAppOAuth2AuthorizationRequestInput
}

export type MutationCreateButtonNodeWorkspaceButtonsArgs = {
  input: CreateButtonNodeWorkspaceButtonsInput
}

export type MutationCreateChartArgs = {
  input: CreateChartInput
}

export type MutationCreateChildTableArgs = {
  input: CreateChildTableInput
}

export type MutationCreateCommentArgs = {
  input: CreateCommentInput
}

export type MutationCreateDocumentViewArgs = {
  input: CreateDocumentViewInput
}

export type MutationCreateDossbotChatArgs = {
  input: CreateDossbotChatInput
}

export type MutationCreateDossbotChatRunArgs = {
  input: CreateDossbotChatRunInput
}

export type MutationCreateFormArgs = {
  input: CreateFormInput
}

export type MutationCreateFormCategoryArgs = {
  input: CreateFormCategoryInput
}

export type MutationCreateFormFieldArgs = {
  input: CreateFormFieldInput
}

export type MutationCreateFormInputBlockArgs = {
  input: CreateFormInputBlockInput
}

export type MutationCreateFormLayoutBlockArgs = {
  input: CreateFormLayoutBlockInput
}

export type MutationCreateFormPageArgs = {
  input: CreateFormPageInput
}

export type MutationCreateFormRowBlockArgs = {
  input: CreateFormRowBlockInput
}

export type MutationCreateFormTableBlockArgs = {
  input: CreateFormTableBlockInput
}

export type MutationCreateFormVariantArgs = {
  input: CreateFormVariantInput
}

export type MutationCreateFormVisibilityConditionArgs = {
  input: CreateFormVisibilityConditionInput
}

export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput
}

export type MutationCreateObjectStoreTableSyncArgs = {
  input: CreateObjectStoreTableSyncInput
}

export type MutationCreateRoleArgs = {
  input: CreateRoleInput
}

export type MutationCreateSignatureArgs = {
  input: CreateSignatureInput
}

export type MutationCreateStripeAccountArgs = {
  isStaging: Scalars['Boolean']
}

export type MutationCreateStripeFinancialConnectionsCustomerArgs = {
  organizationId: Scalars['String']
}

export type MutationCreateStripeFinancialConnectionsSessionArgs = {
  customerId: Scalars['String']
}

export type MutationCreateTableArgs = {
  input: CreateTableInput
}

export type MutationCreateTableButtonNodeArgs = {
  input: CreateButtonNodeInput
}

export type MutationCreateTableButtonTransitionArgs = {
  input: CreateButtonTransitionInput
}

export type MutationCreateTableColumnArgs = {
  input: CreateTableColumnInput
}

export type MutationCreateTableColumnFilterArgs = {
  input: CreateTableColumnFilterInput
}

export type MutationCreateTableColumnGroupArgs = {
  input: CreateTableColumnGroupInput
}

export type MutationCreateTableColumnGroupMemberArgs = {
  input: CreateTableColumnGroupMemberInput
}

export type MutationCreateTableColumnGroupMembersArgs = {
  input: CreateTableColumnGroupMembersInput
}

export type MutationCreateTableExportArgs = {
  input: CreateTableExportInput
}

export type MutationCreateTableRowArgs = {
  input: CreateTableRowInput
}

export type MutationCreateTableTabArgs = {
  input: CreateTableTabInput
}

export type MutationCreateTableTabColumnArgs = {
  input: CreateTableTabColumnInput
}

export type MutationCreateTableTabSortArgs = {
  input: CreateTableTabSortInput
}

export type MutationCreateTableUniqueConstraintArgs = {
  input: CreateTableUniqueConstraintInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationCreateViewArgs = {
  input: CreateViewInput
}

export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceInput
}

export type MutationCreateWorkspaceButtonArgs = {
  input: CreateWorkspaceButtonInput
}

export type MutationDeleteActionArgs = {
  actionId: Scalars['ID']
}

export type MutationDeleteActionAutoTriggerArgs = {
  actionAutoTriggerId: Scalars['ID']
}

export type MutationDeleteActionFrequencyTriggerArgs = {
  actionFrequencyTriggerId: Scalars['ID']
}

export type MutationDeleteActionManualTriggerArgs = {
  actionManualTriggerId: Scalars['ID']
}

export type MutationDeleteActionStepArgs = {
  stepId: Scalars['ID']
}

export type MutationDeleteChartArgs = {
  chartId: Scalars['ID']
}

export type MutationDeleteCommentArgs = {
  commentId: Scalars['ID']
}

export type MutationDeleteDirectoryWorkspaceArgs = {
  workspaceId: Scalars['ID']
}

export type MutationDeleteDocumentArgs = {
  documentId: Scalars['ID']
}

export type MutationDeleteFormArgs = {
  input: DeleteFormInput
}

export type MutationDeleteFormBlockArgs = {
  formBlockId: Scalars['ID']
}

export type MutationDeleteFormCategoryArgs = {
  formCategoryId: Scalars['ID']
}

export type MutationDeleteFormFieldArgs = {
  formFieldId: Scalars['ID']
}

export type MutationDeleteFormPageArgs = {
  formPageId: Scalars['ID']
}

export type MutationDeleteFormV2Args = {
  formId: Scalars['ID']
}

export type MutationDeleteFormVariantArgs = {
  variantId: Scalars['ID']
}

export type MutationDeleteFormVisibilityConditionArgs = {
  formVisibilityConditionId: Scalars['ID']
}

export type MutationDeleteIntegrationArgs = {
  integrationId: Scalars['ID']
}

export type MutationDeleteObjectStoreTableSyncArgs = {
  objectStoreTableSyncId: Scalars['ID']
}

export type MutationDeleteRoleArgs = {
  roleId: Scalars['ID']
}

export type MutationDeleteTableArgs = {
  tableId: Scalars['ID']
}

export type MutationDeleteTableButtonNodeArgs = {
  tableButtonNodeId: Scalars['ID']
}

export type MutationDeleteTableButtonTransitionArgs = {
  tableButtonTransitionId: Scalars['ID']
}

export type MutationDeleteTableColumnArgs = {
  input: DeleteTableColumnInput
}

export type MutationDeleteTableColumnFilterArgs = {
  tableColumnFilterId: Scalars['ID']
}

export type MutationDeleteTableColumnGroupArgs = {
  tableColumnGroupId: Scalars['ID']
}

export type MutationDeleteTableColumnGroupMemberArgs = {
  tableColumnGroupMemberId: Scalars['ID']
}

export type MutationDeleteTableColumnGroupMembersArgs = {
  input: DeleteTableColumnGroupMembersInput
}

export type MutationDeleteTableColumnsArgs = {
  input: DeleteTableColumnsInput
}

export type MutationDeleteTableRowArgs = {
  tableRowId: Scalars['ID']
}

export type MutationDeleteTableRowWithResultArgs = {
  tableRowId: Scalars['ID']
}

export type MutationDeleteTableRowsArgs = {
  input: DeleteTableRowsInput
}

export type MutationDeleteTableTabArgs = {
  tableTabId: Scalars['ID']
}

export type MutationDeleteTableTabColumnArgs = {
  tableColumnFilterId: Scalars['ID']
}

export type MutationDeleteTableTabSortArgs = {
  tableTabSortId: Scalars['ID']
}

export type MutationDeleteTableUniqueConstraintArgs = {
  tableUniqueConstraintId: Scalars['ID']
}

export type MutationDeleteVariantInputValueArgs = {
  inputId: Scalars['ID']
  variantId: Scalars['ID']
}

export type MutationDeleteViewArgs = {
  viewId: Scalars['ID']
}

export type MutationDeleteWorkspaceArgs = {
  workspaceId: Scalars['ID']
}

export type MutationDeleteWorkspaceButtonArgs = {
  workspaceButtonId: Scalars['ID']
}

export type MutationDemoteRootWorkspaceArgs = {
  parentWorkspaceId: Scalars['ID']
  workspaceId: Scalars['ID']
}

export type MutationDisableWorkflowArgs = {
  workflowId: Scalars['ID']
}

export type MutationDisconnectFormBlockFromVisibilityConditionArgs = {
  input: DisconnectFormBlockFromVisibilityConditionInput
}

export type MutationDownloadWorkspaceDocumentsArgs = {
  workspaceId: Scalars['ID']
}

export type MutationDuplicateChartArgs = {
  input: DuplicateChartInput
}

export type MutationDuplicateFormArgs = {
  formId: Scalars['ID']
}

export type MutationDuplicateFormV2Args = {
  formV2Id: Scalars['ID']
}

export type MutationDuplicateRoleArgs = {
  roleId: Scalars['ID']
}

export type MutationDuplicateTableRowArgs = {
  tableRowId: Scalars['ID']
}

export type MutationDuplicateViewArgs = {
  input: DuplicateViewInput
}

export type MutationDynamicAppDeployArgs = {
  input: DynamicAppDeployInput
  planHash?: InputMaybe<Scalars['String']>
}

export type MutationEnableWorkflowArgs = {
  workflowId: Scalars['ID']
}

export type MutationExecuteActionManualTriggerArgs = {
  input: ExecuteActionManualTriggerInput
}

export type MutationExecuteBulkActionArgs = {
  input: ExecuteBulkActionInput
}

export type MutationGetStripeAccountSecretArgs = {
  accountId: Scalars['String']
  isStaging: Scalars['Boolean']
}

export type MutationMarkNotificationAsArchivedArgs = {
  notificationId: Scalars['ID']
}

export type MutationMarkNotificationAsReadArgs = {
  notificationId: Scalars['ID']
}

export type MutationMarkNotificationAsUnreadArgs = {
  notificationId: Scalars['ID']
}

export type MutationMigrateFormV1ToV2Args = {
  formId: Scalars['ID']
}

export type MutationMoveTableColumnGroupMemberArgs = {
  input: MoveTableColumnGroupMemberInput
}

export type MutationMoveTableColumnGroupMembersArgs = {
  input: MoveTableColumnGroupMembersInput
}

export type MutationMoveWorkspaceArgs = {
  input: MoveWorkspaceInput
}

export type MutationNavigationDeployArgs = {
  input: NavigationDeployInput
  planHash: Scalars['String']
}

export type MutationPromoteToRootWorkspaceArgs = {
  workspaceId: Scalars['ID']
}

export type MutationRegenerateNetsuiteCertificateArgs = {
  integrationId: Scalars['ID']
}

export type MutationReorderChildTableArgs = {
  input: ReorderChildTableInput
}

export type MutationReorderFormBlockArgs = {
  input: ReorderFormBlockInput
}

export type MutationReorderFormCategoryArgs = {
  input: ReorderFormCategoryInput
}

export type MutationReorderFormFieldArgs = {
  input: ReorderFormFieldInput
}

export type MutationReorderFormPageArgs = {
  input: ReorderFormPageInput
}

export type MutationReorderTableColumnArgs = {
  input: ReorderTableColumnInput
}

export type MutationReorderTableColumnGroupArgs = {
  input: ReorderTableColumnGroupInput
}

export type MutationReorderTableColumnGroupMemberArgs = {
  input: ReorderTableColumnGroupMemberInput
}

export type MutationReorderTableColumnsArgs = {
  input: ReorderTableColumnsInput
}

export type MutationReorderTableTabArgs = {
  input: ReorderTableTabInput
}

export type MutationReorderWorkspaceButtonArgs = {
  input: ReorderWorkspaceButtonInput
}

export type MutationRequestIntegration2FaCodeArgs = {
  input: RequestIntegration2FaCodeInput
}

export type MutationResendInviteArgs = {
  membershipId: Scalars['ID']
}

export type MutationRespondToDossbotToolConfirmationArgs = {
  input: RespondToDossbotToolConfirmationInput
}

export type MutationRetryTableUniqueConstraintActivationArgs = {
  tableUniqueConstraintId: Scalars['ID']
}

export type MutationRollbackFormV1ToV2MigrationArgs = {
  formId: Scalars['ID']
}

export type MutationSearchWorkspaceArgs = {
  input: SearchWorkspaceInput
}

export type MutationSendEmailArgs = {
  input: SendEmailInput
}

export type MutationSetWorkflowV2EnabledArgs = {
  input: SetWorkflowV2EnabledInput
}

export type MutationShareFormV2Args = {
  input: ShareFormV2Input
}

export type MutationSubmitFormArgs = {
  input: SubmitFormInput
}

export type MutationSubmitFormV2Args = {
  input: SubmitFormV2Input
}

export type MutationTriggerTableButtonNodeEvaluationArgs = {
  tableId: Scalars['ID']
}

export type MutationUnshareFormV2Args = {
  input: UnshareFormV2Input
}

export type MutationUpdateActionArgs = {
  input: UpdateActionInput
}

export type MutationUpdateChartArgs = {
  input: UpdateChartInput
}

export type MutationUpdateChartNameArgs = {
  chartId: Scalars['ID']
  name: Scalars['String']
}

export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput
}

export type MutationUpdateEmbedNameArgs = {
  embedId: Scalars['ID']
  name: Scalars['String']
}

export type MutationUpdateEmbedViewContentArgs = {
  embedId: Scalars['ID']
  viewContentId?: InputMaybe<Scalars['ID']>
}

export type MutationUpdateFormArgs = {
  input: UpdateFormInput
}

export type MutationUpdateFormCategoryArgs = {
  input: UpdateFormCategoryInput
}

export type MutationUpdateFormFieldArgs = {
  input: UpdateFormFieldInput
}

export type MutationUpdateFormInputBlockArgs = {
  input: UpdateFormInputBlockInput
}

export type MutationUpdateFormLayoutBlockArgs = {
  input: UpdateFormLayoutBlockInput
}

export type MutationUpdateFormPageArgs = {
  input: UpdateFormPageInput
}

export type MutationUpdateFormTableBlockArgs = {
  input: UpdateFormTableBlockInput
}

export type MutationUpdateFormV2Args = {
  input: UpdateFormV2Input
}

export type MutationUpdateFormVariantArgs = {
  input: UpdateFormVariantInput
}

export type MutationUpdateFormVisibilityConditionArgs = {
  input: UpdateFormVisibilityConditionInput
}

export type MutationUpdateIntegrationArgs = {
  input: UpdateIntegrationInput
}

export type MutationUpdateIntegrationCredentialsArgs = {
  input: UpdateIntegrationCredentialsInput
}

export type MutationUpdateObjectStoreTableSyncArgs = {
  input: UpdateObjectStoreTableSyncInput
}

export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput
}

export type MutationUpdateRoleTablePermissionsArgs = {
  input: UpdateRoleTablePermissionsInput
  tableId: Scalars['ID']
}

export type MutationUpdateRowCurrentNodesArgs = {
  input: UpdateRowCurrentNodesInput
}

export type MutationUpdateTableArgs = {
  input: UpdateTableInput
}

export type MutationUpdateTableButtonNodeArgs = {
  input: UpdateButtonNodeInput
}

export type MutationUpdateTableButtonTransitionArgs = {
  input: UpdateButtonTransitionInput
}

export type MutationUpdateTableCellArgs = {
  input: UpdateTableCellInput
}

export type MutationUpdateTableColumnArgs = {
  input: UpdateTableColumnInput
}

export type MutationUpdateTableColumnFilterArgs = {
  input: UpdateTableColumnFilterInput
}

export type MutationUpdateTableColumnFiltersArgs = {
  input: UpdateTableColumnFiltersInput
}

export type MutationUpdateTableColumnGroupArgs = {
  input: UpdateTableColumnGroupInput
}

export type MutationUpdateTableColumnsVisibilityArgs = {
  input: UpdateTableColumnsVisibilityInput
}

export type MutationUpdateTableRowArgs = {
  input: UpdateTableRowInput
}

export type MutationUpdateTableTabArgs = {
  input: UpdateTableTabInput
}

export type MutationUpdateTableTabColumnArgs = {
  input: UpdateTableTabColumnInput
}

export type MutationUpdateTableTabColumnsArgs = {
  input: UpdateTableTabColumnsInput
}

export type MutationUpdateTableTabSortArgs = {
  input: UpdateTableTabSortInput
}

export type MutationUpdateTableTabSortsArgs = {
  input: UpdateTableTabSortsInput
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationUpdateUserProfilePictureArgs = {
  input?: InputMaybe<UpdateUserProfilePictureInput>
}

export type MutationUpdateUserRolesArgs = {
  input: UpdateUserRolesInput
}

export type MutationUpdateVariantInputValueArgs = {
  input: UpdateVariantInputValueInput
}

export type MutationUpdateViewArgs = {
  input: UpdateViewInput
}

export type MutationUpdateWorkspaceArgs = {
  input: UpdateWorkspaceInput
}

export type MutationUpdateWorkspaceButtonArgs = {
  input: UpdateWorkspaceButtonInput
}

export type MutationUpdateWorkspaceRowHeightArgs = {
  input: UpdateWorkspaceRowHeightInput
}

export type MutationUploadTableDataCsvArgs = {
  input: UploadTableDataCsvInput
}

export type MutationUpsertTableButtonTransitionArgs = {
  input: UpsertTableButtonTransitionInput
}

export type MutationUpsertViewContentArgs = {
  input: UpsertViewContentInput
}

export type MutationWorkflowsV2DeployArgs = {
  input: WorkflowsV2DeployInput
  planHash?: InputMaybe<Scalars['String']>
}

export type MutationWorkflowsV2TriggerArgs = {
  input: WorkflowsV2TriggerInput
}

export type MutationWorkflowsV2UploadSourceFilesArgs = {
  files: Array<WorkflowsV2SourceFileInput>
}

/** Authored resource identity of a navigation destination. */
export type NavigationBindingReferenceInput = {
  logicalId: Scalars['String']
  /** A table tab's table. */
  tableLogicalId?: InputMaybe<Scalars['String']>
  type: NavigationDestinationType
}

export type NavigationDeployAction = {
  __typename: 'NavigationDeployAction'
  detail: Scalars['JSONObject']
  kind: NavigationDeployActionKind
}

export enum NavigationDeployActionKind {
  NAVIGATION_NOOP = 'NAVIGATION_NOOP',
  NAVIGATION_UPDATE = 'NAVIGATION_UPDATE',
}

/** No route checks run on the server. */
export type NavigationDeployDestinationInput = {
  link?: InputMaybe<Scalars['String']>
  /** The authored identity, resolved by the platform at plan and again at apply */
  reference: NavigationBindingReferenceInput
}

export type NavigationDeployDiagnostic = {
  __typename: 'NavigationDeployDiagnostic'
  code: NavigationDeployDiagnosticCode
  message: Scalars['String']
  severity: WorkflowV2DiagnosticSeverity
}

export enum NavigationDeployDiagnosticCode {
  INVALID_NAVIGATION = 'INVALID_NAVIGATION',
  PLAN_CHANGED = 'PLAN_CHANGED',
  SNAPSHOT_INCOMPLETE = 'SNAPSHOT_INCOMPLETE',
}

export type NavigationDeployInput = {
  /** App logical ids the same `doss deploy` publishes first; the plan accepts references to them before they resolve */
  deployingApps?: InputMaybe<Array<Scalars['String']>>
  /** Omitted/null leaves navigation unchanged; an empty list clears it. */
  items?: InputMaybe<Array<NavigationDeployItemInput>>
  /** Required when replacing navigation, including clearing it. */
  sdkVersion?: InputMaybe<Scalars['String']>
  /** Required for replacement and must include root nav.ts. Source bytes are uploaded separately. */
  snapshot?: InputMaybe<WorkflowsV2SnapshotInput>
}

/** Array position determines sibling order. Missing destination denotes a header. */
export type NavigationDeployItemInput = {
  children?: InputMaybe<Array<NavigationDeployItemInput>>
  destination?: InputMaybe<NavigationDeployDestinationInput>
  icon?: InputMaybe<Scalars['String']>
  label: Scalars['String']
}

export type NavigationDeployOutcome = {
  __typename: 'NavigationDeployOutcome'
  kind: NavigationDeployActionKind
  message: Maybe<Scalars['String']>
  status: NavigationDeployOutcomeStatus
}

export enum NavigationDeployOutcomeStatus {
  APPLIED = 'APPLIED',
  FAILED = 'FAILED',
}

export type NavigationDeployPlan = {
  __typename: 'NavigationDeployPlan'
  actions: Array<NavigationDeployAction>
  diagnostics: Array<NavigationDeployDiagnostic>
  planHash: Scalars['String']
}

export type NavigationDeployResult = {
  __typename: 'NavigationDeployResult'
  outcomes: Array<NavigationDeployOutcome>
  plan: NavigationDeployPlan
}

/** The existing resource behind an authorized navigation item. Dashboards are Workspaces. */
export type NavigationDestination = Embed | FormV2 | Table | TableTab | Workspace

/**
 * The kind of platform object a navigation link opens. Names the table `NavigationItem.destinationId`
 * points into: APP is an Embed, TABLE a Table, TABLE_TAB a TableTab, FORM a FormV2, DASHBOARD a
 * Workspace. Null on a header.
 */
export enum NavigationDestinationType {
  APP = 'APP',
  DASHBOARD = 'DASHBOARD',
  ENDPOINT = 'ENDPOINT',
  FORM = 'FORM',
  LOOKUP_GROUP = 'LOOKUP_GROUP',
  TABLE = 'TABLE',
  TABLE_TAB = 'TABLE_TAB',
}

/**
 * One item of an organization's primary navigation, deployed from the configbase's `nav.ts`.
 *
 * An item is either a header (no destination, groups its children) or a link. A link names its
 * destination by type + id and may carry `link`, a fully resolved path and query appended to the
 * destination's mount (e.g. `/orders?status=open`); the host prepends the mount when it serves the
 * navigation. Every path and search param is bound at deploy, so nothing in `link` is a
 * placeholder. A link that opens the destination itself, which is every native destination today
 * (Table, TableTab, FormV2, Dashboard), has a null `link`; a TableTab's mount is its table's URL
 * with the tab selected in the query string.
 *
 * `destinationId` is deliberately not a foreign key: a deploy of `nav.ts` replaces the org's rows
 * wholesale, organizations are cloned by redeploying their configbase rather than copying rows, and a
 * deleted destination is simply pruned from the navigation. A later migration moves it to a logical
 * identifier. Route templates and typed search params live in each App's build manifest and are
 * checked by the doss CLI at deploy; the backend stores and serves these rows without validating them.
 */
export type NavigationItem = {
  __typename: 'NavigationItem'
  children: Array<NavigationItem>
  createdAt: Scalars['DateTime']
  /** The destination row's id in the table named by `destinationType`. Not a foreign key. */
  destinationId: Maybe<Scalars['ID']>
  destinationType: Maybe<NavigationDestinationType>
  /** An icon token the shell maps to a component; null shows no icon. */
  icon: Maybe<Scalars['String']>
  id: Scalars['ID']
  label: Scalars['String']
  /**
   * Fully resolved path and query appended to the destination's mount; null opens the destination
   * itself. Always null on a header.
   */
  link: Maybe<Scalars['String']>
  /** Position among siblings under the same parent, from 0. */
  order: Scalars['Int']
  /** The organization whose navigation this item belongs to. */
  organization: Organization
  /** The item this one is nested under; null for a top-level item. */
  parentItem: Maybe<NavigationItem>
  updatedAt: Scalars['DateTime']
}

/** Public key information for a Netsuite integration (Client Credentials flow) */
export type NetsuitePublicKey = {
  __typename: 'NetsuitePublicKey'
  /** Certificate expiration date */
  certificateExpiresAt: Maybe<Scalars['DateTime']>
  /** Warning message if certificate is expiring soon or expired */
  expirationWarning: Maybe<Scalars['String']>
  /** The public key in PEM format for upload to Netsuite dashboard */
  publicKey: Scalars['String']
}

/** Node used to track the relations between workflows, forms, and tables */
export type Node = {
  __typename: 'Node'
  id: Scalars['ID']
  sourceEdges: Array<Edge>
  sourceId: Scalars['ID']
  sourceType: NodeType
  targetEdges: Array<Edge>
}

export enum NodeType {
  ACTION_STEP = 'ACTION_STEP',
  FORM_FIELD = 'FORM_FIELD',
  FORM_INPUT = 'FORM_INPUT',
  TABLE = 'TABLE',
  TABLE_COLUMN = 'TABLE_COLUMN',
}

/**
 * A notification for a user for a comment either because the user was @ mentioned, the user was the
 * author of the parent comment of the thread, or the user has alerts turned on for the parent comment
 * of the thread
 */
export type Notification = {
  __typename: 'Notification'
  comment: Maybe<Comment>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  isArchived: Scalars['Boolean']
  isRead: Scalars['Boolean']
  /** Metadata field for notification action steps */
  metadata: Maybe<Scalars['JSONObject']>
  notificationType: NotificationType
  user: Membership
  /** Deprecated: The user string ID is now a UUID */
  userId_deprecated: Maybe<Scalars['String']>
}

export enum NotificationType {
  /** Action step notification */
  ACTION_STEP_NOTIFICATION = 'ACTION_STEP_NOTIFICATION',
  /** User selected to get alerts whenever a user comments in a thread */
  ALERT = 'ALERT',
  /** User was @mentioned in comment */
  MENTION = 'MENTION',
  /** User is the author of the parent comment of the thread */
  THREAD_REPLY = 'THREAD_REPLY',
  /** A workflows-as-code workflow stopped running because it no longer fits the organization */
  WORKFLOW_V2_INVALIDATED = 'WORKFLOW_V2_INVALIDATED',
}

export type NotificationsInput = {
  isArchived?: InputMaybe<Scalars['Boolean']>
}

/** Information about an OAuth2 token */
export type OAuth2TokenInfo = {
  __typename: 'OAuth2TokenInfo'
  /** Admin user for admin OAuth tokens (null for app tokens) */
  adminUser: Maybe<AdminUser>
  /** App user for app OAuth tokens (null for admin tokens) */
  appUser: Maybe<AppUserInfo>
  /** Email of the user who authorized this token (app tokens) */
  authorizedByEmail: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  /** IP address (admin tokens) */
  ipAddress: Maybe<Scalars['String']>
  lastUsedAt: Maybe<Scalars['DateTime']>
  /** OAuth state parameter (app tokens) */
  state: Maybe<Scalars['String']>
  status: OAuth2TokenStatus
  /** User agent string (admin tokens) */
  userAgent: Maybe<Scalars['String']>
}

/** Status of an OAuth2 token */
export enum OAuth2TokenStatus {
  AUTHORIZED = 'AUTHORIZED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  REVOKED = 'REVOKED',
}

/** An operation to transfer data between a table and an object store */
export type ObjectStoreTableSync = {
  __typename: 'ObjectStoreTableSync'
  createdAt: Scalars['DateTime']
  daysOfWeek: Maybe<Array<Scalars['Int']>>
  /** The direction to transfer the data */
  direction: ObjectStoreTransferDirection
  /**
   * If importing, the file pattern to read data from.
   * If exporting, the file name to write data to.
   */
  filePattern: Scalars['String']
  /** The file type to transfer */
  fileType: ObjectStoreTransferFileType
  id: Scalars['ID']
  /** If true, ignore missing columns during import and fill them as empty/null */
  ignoreMissingColumns: Scalars['Boolean']
  /** The integration to transfer data to or from */
  integration: Integration
  /** Frequency to execute the operation */
  repeatNumber: Scalars['Int']
  repeatUnit: CalendarUnit
  startAt: Scalars['DateTime']
  /** The table to transfer data to or from */
  table: Table
  updatedAt: Scalars['DateTime']
}

/**
 * The direction to transfer the data. Importing means transferring data from object store to table.
 * Exporting means transferring data from table to object store.
 */
export enum ObjectStoreTransferDirection {
  EXPORT = 'EXPORT',
  IMPORT = 'IMPORT',
}

export enum ObjectStoreTransferFileType {
  CSV = 'CSV',
  PARQUET = 'PARQUET',
}

/**
 * One deploy against an organization's schema: the exclusive lease that refuses UI schema edits while
 * it is live (fencing token + TTL), and the who/why audit. Mutable only while the deploy is in
 * flight, then sealed and immutable. `seq` is the organization schema seq the deploy's first schema
 * change produced, stamped in that change's transaction; a deploy that changes nothing keeps it null.
 * A lease is live while unsealed and unexpired; a crashed holder stops excluding once it lapses.
 */
export type OrgSchemaVersion = {
  __typename: 'OrgSchemaVersion'
  /** The user who deployed; null for a service or CI actor */
  actor: Maybe<Membership>
  /** Why the lease was opened: { kind: 'deploy', deployId, planHash } */
  cause: Scalars['JSONObject']
  createdAt: Scalars['DateTime']
  /** When the lease lapses unless renewed; cleared at seal */
  expiresAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  organization: Organization
  /** Set once, when the deploy is sealed; null while in flight */
  outcome: Maybe<OrgSchemaVersionOutcome>
  sealedAt: Maybe<Scalars['DateTime']>
  /** The organization schema seq this deploy produced; null until its first change commits */
  seq: Maybe<Scalars['Int']>
  startedAt: Scalars['DateTime']
}

/**
 * How a deploy lease ended. Null while the deploy is in flight. A crashed deploy never sets one: its
 * unsealed, expired row is its own record.
 */
export enum OrgSchemaVersionOutcome {
  /** Acquired, committed nothing on purpose: an empty plan or a cancel */
  ABANDONED = 'ABANDONED',
  /** Every change succeeded */
  APPLIED = 'APPLIED',
  /** Ran, committed nothing */
  FAILED = 'FAILED',
  /** Some changes committed, others failed or were skipped */
  PARTIAL = 'PARTIAL',
}

/** An organization is a customer of Doss */
export type Organization = {
  __typename: 'Organization'
  actionApiTriggers: Array<ActionApiTrigger>
  actionAutoTriggers: Array<ActionAutoTrigger>
  actionFrequencyTriggers: Array<ActionFrequencyTrigger>
  actionManualTriggers: Array<ActionManualTrigger>
  charts: Array<Chart>
  childOrganizations: Array<Organization>
  comprehensionEdges: Array<ComprehensionEdge>
  currency: Currency
  documents: Array<Document>
  endpoints: Array<Endpoint>
  enumSets: Array<EnumSet>
  /** The ID of the matching Organization in WorkOS */
  externalOrganizationId: Maybe<Scalars['String']>
  /** Feature flags for this organization. Keys are flag names, values are booleans. */
  featureFlags: Maybe<Scalars['JSONObject']>
  forms: Array<Form>
  formsV2: Array<FormV2>
  formulas: Array<Formula>
  /** Data layout generation: 1 (OrgV1) or 2 (OrgV2). Set at creation; see organization-generation.ts. */
  generation: Scalars['Int']
  /** Returns whether this organization has an API key */
  hasApiKey: Scalars['Boolean']
  id: Scalars['ID']
  integrations: Array<Integration>
  /** Here for referential integrity reasons, cannot be queried directly */
  issueHistory: Array<IssueHistory>
  /** Here for referential integrity reasons, cannot be queried directly */
  issueOccurrences: Array<IssueOccurrence>
  issueViews: Array<IssueView>
  /** Radar issues: grouped failures teams assign, prioritize and resolve */
  issues: Array<Issue>
  locale: Locale
  /** The logical-identity registry: every referable entity's authored id → its row */
  logicalBindings: Array<LogicalBinding>
  logo: Maybe<Document>
  memberships: Array<Membership>
  name: Scalars['String']
  /** Content-addressed source snapshot of the current nav.ts deployment, including an empty navigation. */
  navigationConfigbaseHash: Maybe<Scalars['String']>
  /** The organization's primary navigation items, deployed from its configbase `nav.ts`. */
  navigationItems: Array<NavigationItem>
  /** Every deploy lease — lease, seq stamp and audit — opened against this organization */
  orgSchemaVersions: Array<OrgSchemaVersion>
  /** Organization-wide table exports for this organization */
  organizationExports: Array<OrganizationExport>
  /** Any organization can optionally have a parent organization. */
  parentOrganization: Maybe<Organization>
  roles: Array<Role>
  /** Top-level (root) workspaces of this organization, sorted by order */
  rootWorkspaces: Array<Workspace>
  /** The slug of the organization. This is automatically generated when the name is set. */
  slug: Scalars['String']
  startOfFiscalYearMonth: Month
  startOfWeekDay: DayOfWeek
  status: OrganizationStatus
  /** Column versions for z-tables schema versioning */
  tableColumnVersions: Array<TableColumnVersion>
  /** Schema versions for z-tables schema versioning */
  tableSchemaVersions: Array<TableSchemaVersion>
  tables: Array<Table>
  timeZone: Scalars['String']
  /** The version number of the organization instance */
  version: Maybe<Scalars['String']>
  /** The workflows that belong to this organization */
  workflows: Array<Workflow>
  workflowsV2: Array<WorkflowV2>
  workspaces: Array<Workspace>
}

/** An export of every table in an organization, bundled into a single zip of CSVs */
export type OrganizationExport = {
  __typename: 'OrganizationExport'
  /** Execution backend selected when this export was dispatched; null for historical exports */
  backend: Maybe<ExportBackend>
  /** Number of per-table exports that finished successfully */
  completedTableCount: Scalars['Int']
  createdAt: Scalars['DateTime']
  /** The user who initiated the export */
  createdBy: Membership
  /** The generated document containing the zip of CSV files */
  document: Maybe<Document>
  /** Error message if the export failed */
  errorMessage: Maybe<Scalars['String']>
  /** Number of per-table exports that failed */
  failedTableCount: Scalars['Int']
  id: Scalars['ID']
  /** The organization being exported */
  organization: Organization
  /** Current status of the export job */
  status: OrganizationExportStatus
  /** The per-table CSV exports created by this organization export */
  tableExports: Array<TableExport>
  /** Number of tables in the export, set when the per-table jobs are dispatched */
  totalTableCount: Scalars['Int']
  updatedAt: Scalars['DateTime']
}

/** Status of an organization-wide table export job */
export enum OrganizationExportStatus {
  COMPLETED = 'COMPLETED',
  COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  ZIPPING = 'ZIPPING',
}

export enum OrganizationStatus {
  ACTIVE = 'ACTIVE',
  DEMO = 'DEMO',
  INACTIVE = 'INACTIVE',
  ONBOARDING = 'ONBOARDING',
}

/** An activity feed entry, with the object whose page it links to. */
export type PaginatedActivityFeedEvent = {
  __typename: 'PaginatedActivityFeedEvent'
  event: ActivityFeedEvent
  objectId: Scalars['ID']
  objectName: Scalars['String']
  objectType: BreadcrumbObjectType
}

export type PaginatedBacklinkRowsInput = {
  /** The Lookup column that the backlink is on */
  backlinkColumnId: Scalars['ID']
  /** The row ID to backlink */
  backlinkRowId: Scalars['ID']
  filterBooleanOperator?: InputMaybe<BooleanOperator>
  filters: Array<TableFilterInput>
  pagination: PaginatedInput
  searchString?: InputMaybe<Scalars['String']>
  sorts: Array<TableSortInput>
  tableId: Scalars['ID']
}

/** Paginated ClickHouse execution payload records */
export type PaginatedClickHouseExecutionPayloads = {
  __typename: 'PaginatedClickHouseExecutionPayloads'
  executionPayloads: Array<ClickHouseExecutionPayload>
  hasNext: Scalars['Boolean']
  offset: Maybe<Scalars['Int']>
  /** Exact total for the filters; only computed when the input sets includeTotalCount */
  totalCount: Maybe<Scalars['Int']>
}

export type PaginatedCommentWithChildren = {
  __typename: 'PaginatedCommentWithChildren'
  childComments: Array<PaginatedCommentWithChildren>
  comment: Comment
  objectId: Scalars['ID']
  objectName: Scalars['String']
  objectType: BreadcrumbObjectType
}

/** Paginated root comments for a single workspace, read from Postgres. */
export type PaginatedComments = {
  __typename: 'PaginatedComments'
  /** Root comments sorted by most recent first, each with its child comments sorted oldest first. */
  comments: Array<PaginatedCommentWithChildren>
  /** Opaque cursor for the next (older) page, or null when there are no more comments */
  cursor: Maybe<Scalars['String']>
  /** False when there are no more comments to fetch */
  hasNext: Scalars['Boolean']
}

export type PaginatedCommentsInput = {
  /** Opaque keyset cursor returned by a previous page. Omit to start from the most recent comment. */
  cursor?: InputMaybe<Scalars['String']>
  /** How many root comments to return */
  limit: Scalars['Int']
  objectId: Scalars['ID']
  objectType: BreadcrumbObjectType
}

export type PaginatedCsvExportInput = {
  backlinkColumnId?: InputMaybe<Scalars['ID']>
  backlinkRowId?: InputMaybe<Scalars['ID']>
  columnIds: Array<Scalars['ID']>
  /** If true, the child rows will be exported with the parent row data flattened */
  exportChildWithParentRow: Scalars['Boolean']
  filterBooleanOperator?: InputMaybe<BooleanOperator>
  filters: Array<TableFilterInput>
  pagination: PaginatedInput
  parentRowId?: InputMaybe<Scalars['ID']>
  sorts: Array<TableSortInput>
  tableId: Scalars['ID']
  tableTabId?: InputMaybe<Scalars['ID']>
}

/** Paginated documents */
export type PaginatedDocuments = {
  __typename: 'PaginatedDocuments'
  documents: Array<Document>
  /** Has next is false if there are no more results to query for */
  hasNext: Scalars['Boolean']
  offset: Scalars['Int']
}

/** Paginated entity version history records */
export type PaginatedEntityVersionHistories = {
  __typename: 'PaginatedEntityVersionHistories'
  hasNext: Scalars['Boolean']
  offset: Scalars['Int']
  totalCount: Scalars['Int']
  versions: Array<EntityVersionHistory>
}

export type PaginatedEvent = {
  __typename: 'PaginatedEvent'
  event: Event
  objectId: Scalars['ID']
  objectName: Scalars['String']
  objectType: BreadcrumbObjectType
}

/**
 * Paginated activity-feed events for a single object, read from ClickHouse. Cursor is an opaque
 * keyset over (timestamp, id); pass it back as the next page's cursor.
 */
export type PaginatedEvents = {
  __typename: 'PaginatedEvents'
  /** Opaque cursor for the next (older) page, or null when there are no more events */
  cursor: Maybe<Scalars['String']>
  /** Events sorted by most recent first */
  events: Array<PaginatedActivityFeedEvent>
  /** False when there are no more events to fetch */
  hasNext: Scalars['Boolean']
}

export type PaginatedEventsInput = {
  /** Opaque keyset cursor returned by a previous page. Omit to start from the most recent event. */
  cursor?: InputMaybe<Scalars['String']>
  /** For a top-level TABLE, also include events from the table's own rows. Ignored otherwise. */
  includeRowEvents?: InputMaybe<Scalars['Boolean']>
  /** How many events to return */
  limit: Scalars['Int']
  objectId: Scalars['ID']
  objectType: BreadcrumbObjectType
  /** Parent record (table row) when reading a child table's record-scoped events */
  parentRowId?: InputMaybe<Scalars['ID']>
}

/** Paginated action step run results */
export type PaginatedExecutionInstances = {
  __typename: 'PaginatedExecutionInstances'
  executionInstances: Array<ExecutionInstance>
  hasNext: Scalars['Boolean']
  offset: Maybe<Scalars['Int']>
  totalCount: Scalars['Int']
}

/** Paginated forms */
export type PaginatedForms = {
  __typename: 'PaginatedForms'
  forms: Array<Form>
  /** Has next is false if there are no more results to query for */
  hasNext: Scalars['Boolean']
  offset: Scalars['Int']
}

/** Paginated forms (v2) */
export type PaginatedFormsV2 = {
  __typename: 'PaginatedFormsV2'
  formsV2: Array<FormV2>
  /** Has next is false if there are no more results to query for */
  hasNext: Scalars['Boolean']
  offset: Scalars['Int']
}

export type PaginatedInput = {
  /** How many items to return */
  limit: Scalars['Int']
  /** How many items to offset by. If not specified, start from the beginning. */
  offset?: InputMaybe<Scalars['Int']>
}

/** One page of Radar issues */
export type PaginatedIssues = {
  __typename: 'PaginatedIssues'
  /** False when there are no more results after this page */
  hasNext: Scalars['Boolean']
  issues: Array<Issue>
  /** The offset that was requested */
  offset: Scalars['Int']
  totalCount: Scalars['Int']
}

/**
 * Filters for the Radar issue list. Every list filter is "any of"; an omitted filter matches
 * everything. The two owner filters are OR'd together: an issue matches when its owner is one of
 * ownerIds, or (unassigned) it has no owner.
 */
export type PaginatedIssuesInput = {
  impactedEntityIds?: InputMaybe<Array<Scalars['ID']>>
  impactedEntityTypes?: InputMaybe<Array<SystemEventEntityType>>
  issueOriginIds?: InputMaybe<Array<Scalars['ID']>>
  issueOriginTypes?: InputMaybe<Array<SystemEventEntityType>>
  /** Restrict to these organizations. Each must be one the caller is an ACTIVE member of. */
  organizationIds?: InputMaybe<Array<Scalars['ID']>>
  /** Owner Membership ids. A person has one Membership per organization, so pass one id per org. */
  ownerIds?: InputMaybe<Array<Scalars['ID']>>
  /** limit is capped at 100; a larger value is rejected. A limit of 0 returns only totalCount. */
  pagination: PaginatedInput
  priorities?: InputMaybe<Array<IssuePriority>>
  /** Case-insensitive substring match on title or errorTemplate */
  searchString?: InputMaybe<Scalars['String']>
  statuses?: InputMaybe<Array<IssueStatus>>
  /** Include issues that have no owner */
  unassigned?: InputMaybe<Scalars['Boolean']>
}

export type PaginatedLookupRowsInput = {
  filterBooleanOperator?: InputMaybe<BooleanOperator>
  /**
   * Optional column filters applied in addition to lookupFilterExpressionId (AND). Not persisted;
   * used for ad-hoc refinement (e.g. bulk lookup modal).
   */
  filters?: InputMaybe<Array<TableFilterInput>>
  lookupFilterExpressionId?: InputMaybe<Scalars['ID']>
  pagination: PaginatedInput
  /** If specified, the paginated rows will be filtered down to rows with this parent id */
  parentRowId?: InputMaybe<Scalars['ID']>
  /** If specified, represents the row from which the query originates */
  queriedFromRowId?: InputMaybe<Scalars['ID']>
  searchString?: InputMaybe<Scalars['String']>
  sorts?: InputMaybe<Array<TableSortInput>>
  tableId: Scalars['ID']
  /**
   * If filtering is on form data or in an add new record form, this is specified as a mapping of
   * column or form field ID to user-entered data so that it can be used in the logic expression
   */
  userEnteredData?: InputMaybe<Scalars['JSONObject']>
}

/** Paginated notifications */
export type PaginatedNotifications = {
  __typename: 'PaginatedNotifications'
  /** Has next is false if there are no more results to query for */
  hasNext: Scalars['Boolean']
  notifications: Array<Notification>
  offset: Scalars['Int']
  totalCount: Scalars['Int']
  totalUnreadCount: Scalars['Int']
}

export type PaginatedNotificationsInput = {
  isArchived?: InputMaybe<Scalars['Boolean']>
  pagination: PaginatedInput
}

export type PaginatedSearchInput = {
  pagination: PaginatedInput
  searchString: Scalars['String']
}

/** Paginated table rows */
export type PaginatedTableRows = {
  __typename: 'PaginatedTableRows'
  /** Has next is false if there are no more results to query for */
  hasNext: Scalars['Boolean']
  offset: Scalars['Int']
  rows: Array<TableRow>
  /** Total number of rows in the table */
  totalCount: Scalars['Int']
}

export type PaginatedTableRowsInput = {
  /** If specified, the paginated rows will only include the data within the specified column IDs */
  columnIds?: InputMaybe<Array<Scalars['ID']>>
  filterBooleanOperator?: InputMaybe<BooleanOperator>
  filters?: InputMaybe<Array<TableFilterInput>>
  pagination: PaginatedInput
  parentRowId?: InputMaybe<Scalars['ID']>
  searchString?: InputMaybe<Scalars['String']>
  sorts?: InputMaybe<Array<TableSortInput>>
  tableId: Scalars['ID']
  tableTabId?: InputMaybe<Scalars['ID']>
}

/** Paginated tables */
export type PaginatedTables = {
  __typename: 'PaginatedTables'
  /** Has next is false if there are no more results to query for */
  hasNext: Scalars['Boolean']
  offset: Scalars['Int']
  tables: Array<Table>
}

/** Paginated z-table rows */
export type PaginatedZTableRows = {
  __typename: 'PaginatedZTableRows'
  /** Has next is false if there are no more results to query for */
  hasNext: Scalars['Boolean']
  offset: Scalars['Int']
  rows: Array<ZTableRow>
}

export type ParentFormulaInput = {
  columnOperationFilter?: InputMaybe<LogicExpressionInput>
  formulaString: Scalars['String']
  formulaValues: Array<FormulaValueInput>
  operator: FormulaOperator
}

/** The root logic expression input - includes logic expression string */
export type ParentLogicExpressionInput = {
  condition?: InputMaybe<LogicExpressionCondition>
  logicExpressionString: Scalars['String']
  type: LogicExpressionType
  values: Array<LogicExpressionValueInput>
}

export type Permission = {
  __typename: 'Permission'
  createdAt: Scalars['DateTime']
  /** The embed (dynamic app) a VIEW_EMBED grant targets. */
  embed: Maybe<Embed>
  endpoint: Maybe<Endpoint>
  form: Maybe<Form>
  formV2: Maybe<FormV2>
  id: Scalars['ID']
  manualTrigger: Maybe<ActionManualTrigger>
  objectType: PermissionObjectType
  permissionType: PermissionType
  role: Role
  table: Maybe<Table>
  tableColumn: Maybe<TableColumn>
  tableTab: Maybe<TableTab>
  updatedAt: Scalars['DateTime']
  workspace: Maybe<Workspace>
}

export type PermissionInput = {
  /** Set to true when the permission is for a Form V2 (only applicable when permissionObjectType is FORM) */
  isFormV2?: InputMaybe<Scalars['Boolean']>
  permissionObjectId: Scalars['ID']
  permissionObjectType: PermissionObjectType
  permissionType: PermissionType
}

export enum PermissionObjectType {
  EMBED = 'EMBED',
  ENDPOINT = 'ENDPOINT',
  FORM = 'FORM',
  MANUAL_TRIGGER = 'MANUAL_TRIGGER',
  TABLE = 'TABLE',
  TABLE_COLUMN = 'TABLE_COLUMN',
  TABLE_TAB = 'TABLE_TAB',
  WORKSPACE = 'WORKSPACE',
}

export enum PermissionType {
  /** General Table Permissions */
  ADD_ROW = 'ADD_ROW',
  /** Endpoint Permissions */
  CALL_ENDPOINT = 'CALL_ENDPOINT',
  CONFIGURE_PIVOT_TABLES = 'CONFIGURE_PIVOT_TABLES',
  CONFIGURE_TABLE_TABS = 'CONFIGURE_TABLE_TABS',
  DELETE_ROW = 'DELETE_ROW',
  EDIT_ALL_TABLE_CELLS = 'EDIT_ALL_TABLE_CELLS',
  EDIT_CELL = 'EDIT_CELL',
  EDIT_WORKSAPCE = 'EDIT_WORKSAPCE',
  /** Form Permissions */
  SUBMIT_FORM = 'SUBMIT_FORM',
  /** Manual Trigger Permissions */
  SUBMIT_MANUAL_TRIGGER = 'SUBMIT_MANUAL_TRIGGER',
  /** Full Table Permission */
  VIEW_ALL_TABLE_CELLS = 'VIEW_ALL_TABLE_CELLS',
  /** Column Permissions */
  VIEW_COLUMN = 'VIEW_COLUMN',
  /**
   * Embed (dynamic app) Permissions. A direct grant on one embed, for apps placed outside a
   * dashboard where no VIEW_WORKSPACE grant can reach them. Embeds inside a dashboard also inherit
   * VIEW_WORKSPACE from that dashboard, so the embed read gates honor both paths.
   */
  VIEW_EMBED = 'VIEW_EMBED',
  /** Table Tab Permissions */
  VIEW_TABLE_TAB_ROWS = 'VIEW_TABLE_TAB_ROWS',
  /** Workspace Permissions */
  VIEW_WORKSPACE = 'VIEW_WORKSPACE',
}

export type PieChartAggregation = {
  __typename: 'PieChartAggregation'
  id: Scalars['String']
  label: Scalars['String']
  value: Scalars['Float']
}

export type PivotDimension = {
  __typename: 'PivotDimension'
  displayName: Scalars['String']
  groupByIds: Array<Scalars['ID']>
  id: Scalars['ID']
  level: Scalars['Int']
  path: Array<Scalars['String']>
}

export enum PivotDimensionType {
  COLUMN = 'COLUMN',
  ROW = 'ROW',
}

export type PivotTableAggregation = {
  __typename: 'PivotTableAggregation'
  cells: Scalars['JSONObject']
  columns: Array<PivotDimension>
  grandTotals: Scalars['JSONObject']
  rows: Array<PivotDimension>
}

export type PreviewCellsInput = {
  limit?: InputMaybe<Scalars['Int']>
  tableColumnId: Scalars['ID']
  tableId: Scalars['ID']
}

export type PushActivityFeedEventInput = {
  /** For a top-level TABLE, also stream events from the table's own rows. Ignored otherwise. */
  includeRowEvents?: InputMaybe<Scalars['Boolean']>
  objectId: Scalars['ID']
  objectType: BreadcrumbObjectType
  /** Parent record (table row) when subscribing to a child table's record-scoped feed */
  parentRowId?: InputMaybe<Scalars['ID']>
}

export type Query = {
  __typename: 'Query'
  /** Gets an action by ID */
  action: Action
  /** Gets an action auto trigger by ID */
  actionAutoTrigger: ActionAutoTrigger
  /** Gets flattened json for an action */
  actionJson: Maybe<Scalars['JSONObject']>
  /** Gets an action manual trigger by ID */
  actionManualTrigger: ActionManualTrigger
  /** Gets all action manual triggers for the logged in user's organization */
  actionManualTriggers: Array<ActionManualTrigger>
  /** Gets an action step by ID */
  actionStep: ActionStep
  /** Gets an action step group by ID */
  actionStepGroup: ActionStepGroup
  /** Gets a list of all actions for a workflow */
  actions: Array<Action>
  /** Returns all active users for the provided organization */
  activeUsers: Array<Membership>
  /** Aggregates all rows in a table column with optional filters */
  aggregateTableColumn: ColumnAggregationResult
  /** Gets all the forms for a user's organization (v2) */
  allFormsV2: Array<FormV2>
  /** Gets all the workflows-as-code workflows for a user's organization */
  allWorkflowsV2: Array<WorkflowV2>
  /** The distinct values of one column among the rows an App's read matches, as the caller */
  appTableDistinct: AppTableDistinctValues
  /** A page of a table's rows for a Dynamic App, through the table search as the current user */
  appTableRows: AppTableRowPage
  /** Gets the breadcrumbs up to a given workspace sorted from root (project) to leaf (direct parent) */
  breadcrumbs: Array<Breadcrumb>
  /** Gets eligibility counts for bulk actions on selected rows */
  bulkActionEligibilityCounts: BulkActionEligibilityCountsResult
  /** Gets a chart's configuration */
  chart: Chart
  /** Gets a chart's visualization data */
  chartVisualizationData: ChartAggregation
  /** Gets a list of all comments in a workspace */
  comments: Array<Comment>
  /** Gets upstream entities the given entity depends on (reverse traversal) */
  comprehensionDependencies: ComprehensionGraphResult
  /** Gets downstream entities affected by the given entity (forward traversal) */
  comprehensionImpact: ComprehensionGraphResult
  /** Get the currently logged in user */
  currentUser: Membership
  /** Gets every folder, table and chart view in the user's organization, flat and sorted by order */
  dataSourceViews: Array<View>
  /** Pre-flight check for delete blocking references on selected rows */
  deleteBlockingCheck: DeleteBlockingCheckResult
  /** Gets a document by ID */
  document: Document
  /** Gets an dossbot chat by id */
  dossbotChat: DossbotChat
  /** Gets all dossbot chats for the logged in user */
  dossbotChats: Array<DossbotChat>
  /** Dry-run: what deploying these apps to the calling user's organization would do */
  dynamicAppDeployPlan: DynamicAppDeployPlan
  /** The org's dynamic apps and their latest source. `doss pull` materializes these */
  dynamicAppSources: Array<DynamicAppSource>
  /** One embed with its attached content reference. */
  embed: Embed
  /** Every endpoint deployed in the logged in user's organization, by logical id */
  endpoints: Array<Endpoint>
  /** Gets a form by ID */
  form: Form
  /** Gets a form block by ID */
  formBlock: FormBlock
  /** Gets a form field by ID */
  formField: FormField
  /** Gets a form input by ID */
  formInput: FormInput
  /** Gets a form by ID (v2), optionally with variant values pre-populated */
  formV2: FormV2
  /** Gets a list of all the files for a form v2 */
  formV2Files: Array<FormV2File>
  /** Gets a form variant by ID */
  formVariant: FormVariant
  /** Gets all variants for a specific form */
  formVariants: Array<FormVariant>
  /** Gets a list of all the forms for a user's organization */
  forms: Array<Form>
  /** Gets a formula by ID */
  formula: Formula
  /** Gets a tree for the formula */
  formulaJson: Maybe<Scalars['JSONObject']>
  /** Gets the public key for a Netsuite integration (for Client Credentials flow) */
  getNetsuitePublicKey: NetsuitePublicKey
  /** The host route a guest's link out of its app names by logical id — a platform object, or another app's route. Null when the viewer cannot read the target or it does not exist */
  guestDestinationHref: Maybe<Scalars['String']>
  /** Gets a list of all icons */
  icons: Array<Icon>
  /** Gets an integration by ID */
  integration: Integration
  /** Gets the authorization URI for adding a new integration by integration type */
  integrationAuthorizationUri: Scalars['String']
  /** Returns all integrations for the provided organization */
  integrations: Array<Integration>
  /** The organization's Jitsu product-analytics events for a time window, newest first */
  jitsuEvents: Array<JitsuEvent>
  /** Get tree for a logic expression by ID */
  logicExpressionJson: Maybe<Scalars['JSONObject']>
  /** Gets a table column group */
  lookupTableColumnGroup: LookupTableColumnGroup
  /** Dry-run org navigation replacement; apply requires this exact plan hash. */
  navigationDeployPlan: NavigationDeployPlan
  /** The calling user's organization navigation, with inaccessible destinations and their descendants removed. */
  navigationItems: Array<ResolvedNavigationItem>
  /** Get all notifications for the logged in user */
  notifications: Array<Notification>
  /** Gets an organization by ID */
  organization: Organization
  /** Gets organization-wide table exports for the logged in user's organization, newest first */
  organizationExports: Array<OrganizationExport>
  /** Gets filtered rows for a backlink column based on the specified input */
  paginatedBacklinkRows: PaginatedTableRows
  /** Paginated root comments for a single workspace, read from Postgres */
  paginatedComments: PaginatedComments
  /** Gets paginated row for CSV Export */
  paginatedCsvExport: PaginatedTableRows
  /**
   * Paginated events read from ClickHouse. Without parentRowId this covers only the object's own
   * workspace (not child workspaces). With parentRowId, objectId is interpreted as a child table id
   * and the feed includes that record's scoped child row events plus the child table's own events.
   */
  paginatedEvents: PaginatedEvents
  /**
   * Radar issues across every organization the caller is an ACTIVE member of, newest first by
   * createdAt. An optional organization filter narrows the list to some of those organizations.
   */
  paginatedIssues: PaginatedIssues
  /** Gets filtered rows for a lookup column based on the specified input */
  paginatedLookupRows: PaginatedTableRows
  /** Gets paginated notifications for a user */
  paginatedNotifications: PaginatedNotifications
  /** Gets paginated table rows */
  paginatedTableRows: PaginatedTableRows
  /** Returns invitations to the user's organization that haven't been accepted yet */
  pendingInvites: Array<Membership>
  /** Get preview cells for a table column */
  previewCells: Array<TableCell>
  /** Gets ActionSteps related to an entity, categorized by read/write behavior */
  relatedActionSteps: RelatedActionStepsResult
  /** Gets ActionSteps related to multiple entities at once, categorized by read/write behavior */
  relatedActionStepsForEntities: RelatedActionStepsForEntitiesResult
  /** Gets all entities related to a source entity */
  relatedEntities: RelatedEntitiesResult
  /** Gets a role by id */
  role: Role
  /** Gets all roles for the logged in user's organization */
  roles: Array<Role>
  /**
   * The logged in user's organization's root workspaces (what used to be projects), sorted by order.
   * Non-admins only see roots that contain at least one view; admins also see empty roots so they
   * can add views to them.
   */
  rootWorkspaces: Array<Workspace>
  /** Runs read-only SQL as the current user and returns one page */
  runUdsSql: UdsSqlResult
  /** Runs several SQL queries against one authorization snapshot */
  runUdsSqlBatch: UdsSqlBatchResult
  /** Gets paginated documents for search */
  searchDocuments: PaginatedDocuments
  /** Gets paginated forms for search */
  searchForms: PaginatedForms
  /** Gets paginated v2 forms for search */
  searchFormsV2: PaginatedFormsV2
  /** Get icons by search paramater */
  searchIcons: Array<Icon>
  /** Get paginated records for search */
  searchTableRows: PaginatedTableRows
  /** Gets paginated tables for search */
  searchTables: PaginatedTables
  /** Generates a ShipStation Direct Login URL so a partner-onboarded customer can manage their carriers and wallet in ShipStation's hosted portal */
  shipStationDirectLoginUrl: Scalars['String']
  /** The organizations the logged in person can switch to, including the current one */
  switchableOrganizations: Array<SwitchableOrganization>
  /** Gets a table by ID */
  table: Table
  /** Get all button nodes */
  tableButtonNodes: Array<TableButtonNode>
  /** Gets a table cell by ID */
  tableCell: TableCell
  /** Gets a table column by ID */
  tableColumn: TableColumn
  /** Gets a list of all table columns for the logged in user */
  tableColumns: Array<TableColumn>
  /** Gets a list of all table columns for a specific table by its ID */
  tableColumnsById: Array<TableColumn>
  /** Gets CSV exports for a table */
  tableExports: Array<TableExport>
  /** Gets a table row by ID */
  tableRow: TableRow
  /** Returns table rows */
  tableRows: Array<TableRow>
  /** Gets all the tables for a user's organization */
  tables: Array<Table>
  /** Tests an integration to verify it is working correctly */
  testIntegration: IntegrationTestResult
  /** The organization's embeds placed in no workspace, which only a direct VIEW_EMBED grant shares */
  unplacedEmbeds: Array<Embed>
  /** Gets all variants that have an override for a specific input */
  variantsWithInputOverride: Array<FormVariant>
  /** Verify an integration installation request (required for some OAuth2 integrations like Shopify) */
  verifyIntegrationRequest: Scalars['String']
  /** Gets a view by ID */
  view: View
  /** Latest content for one ViewContent id. */
  viewContent: ViewContent
  /** Fetch one specific stored version, e.g. to recover it. */
  viewContentVersion: ViewContentVersion
  /** Version history (metadata) for one ViewContent, oldest first. */
  viewContentVersions: Array<ViewContentVersion>
  /** Gets a workflow by ID */
  workflow: Workflow
  /** Gets a list of all workflows for an organization */
  workflows: Array<Workflow>
  /** Gets a list of all workflows that are triggered by a form */
  workflowsByForm: Array<Workflow>
  /** The org's app catalog — the containment typegen recipe's input */
  workflowsV2AppsManifest: WorkflowsV2AppsManifest
  /**
   * Workflows-as-code workflows that reference an entity, for warning before a destructive change.
   *
   * A reference, NOT a prediction: the build manifest records a table's whole shape rather than the
   * columns a workflow's code touches, so this says "these workflows reach it", never "these will
   * break". Only the type-check can say the latter.
   */
  workflowsV2Dependents: Array<WorkflowV2>
  /** Dry-run: what deploying these artifacts to the calling user's organization would do */
  workflowsV2DeployPlan: WorkflowsV2DeployPlan
  /** The org's deployed source, merged across deploy families — null when it has never deployed; `doss pull` materializes these */
  workflowsV2DeployedSource: Maybe<Array<WorkflowsV2DeployedSourceFile>>
  /** The org's FormV2 manifest — the forms typegen recipe's input */
  workflowsV2FormsManifest: WorkflowsV2FormsManifest
  /** The org's integrations manifest — the integrations typegen recipe's input. providerAllowlist names providers to generate even when unconnected, by author-facing namespace; it is unioned with the org's connections, never a filter on them. defaultConnections pins a provider's default to one of its connections */
  workflowsV2IntegrationsManifest: WorkflowsV2IntegrationsManifest
  /** The subset of these hashes absent from the org's source store — upload exactly these before deploying */
  workflowsV2MissingSourceFiles: Array<Scalars['String']>
  /** The platform objects manifest — the platform-objects typegen recipe's input */
  workflowsV2PlatformObjectsManifest: WorkflowsV2PlatformObjectsManifest
  /** Gets a published WaC shim release by version (latest when omitted) */
  workflowsV2Shim: WorkflowsV2Shim
  /** Renders the generated TS (business objects) for the calling user's organization. providerAllowlist and defaultConnections are forwarded to the recipe input queries; see workflowsV2IntegrationsManifest */
  workflowsV2Typegen: WorkflowsV2Typegen
  /** Gets a workspace by ID */
  workspace: Workspace
  /** Gets a workspace by object ID + object type */
  workspaceByObject: Workspace
  /** Gets all workspaces for a users organization */
  workspaces: Array<Workspace>
}

export type QueryActionArgs = {
  actionId: Scalars['ID']
}

export type QueryActionAutoTriggerArgs = {
  actionAutoTriggerId: Scalars['ID']
}

export type QueryActionJsonArgs = {
  actionId: Scalars['ID']
}

export type QueryActionManualTriggerArgs = {
  actionManualTriggerId: Scalars['ID']
}

export type QueryActionStepArgs = {
  actionStepId: Scalars['ID']
}

export type QueryActionStepGroupArgs = {
  actionStepGroupId: Scalars['ID']
}

export type QueryActionsArgs = {
  workflowId: Scalars['ID']
}

export type QueryAggregateTableColumnArgs = {
  input: AggregateTableColumnInput
}

export type QueryAppTableDistinctArgs = {
  input: AppTableDistinctInput
}

export type QueryAppTableRowsArgs = {
  input: AppTableRowsInput
}

export type QueryBreadcrumbsArgs = {
  input: BreadcrumbsInput
}

export type QueryBulkActionEligibilityCountsArgs = {
  input: BulkActionEligibilityCountsInput
}

export type QueryChartArgs = {
  chartId: Scalars['ID']
}

export type QueryChartVisualizationDataArgs = {
  input: ChartVisualizationDataInput
}

export type QueryCommentsArgs = {
  workspaceId: Scalars['ID']
}

export type QueryComprehensionDependenciesArgs = {
  input: ComprehensionGraphInput
}

export type QueryComprehensionImpactArgs = {
  input: ComprehensionGraphInput
}

export type QueryDeleteBlockingCheckArgs = {
  input: DeleteBlockingCheckInput
}

export type QueryDocumentArgs = {
  documentId: Scalars['ID']
}

export type QueryDossbotChatArgs = {
  chatId: Scalars['ID']
}

export type QueryDynamicAppDeployPlanArgs = {
  input: DynamicAppDeployInput
}

export type QueryEmbedArgs = {
  embedId: Scalars['ID']
}

export type QueryFormArgs = {
  formId: Scalars['ID']
}

export type QueryFormBlockArgs = {
  formBlockId: Scalars['ID']
}

export type QueryFormFieldArgs = {
  formFieldId: Scalars['ID']
}

export type QueryFormInputArgs = {
  formInputId: Scalars['ID']
}

export type QueryFormV2Args = {
  formId: Scalars['ID']
  variantId?: InputMaybe<Scalars['ID']>
}

export type QueryFormV2FilesArgs = {
  formV2Id: Scalars['ID']
}

export type QueryFormVariantArgs = {
  variantId: Scalars['ID']
}

export type QueryFormVariantsArgs = {
  formId: Scalars['ID']
}

export type QueryFormulaArgs = {
  formulaId: Scalars['ID']
}

export type QueryFormulaJsonArgs = {
  formulaId: Scalars['ID']
}

export type QueryGetNetsuitePublicKeyArgs = {
  integrationId: Scalars['ID']
}

export type QueryGuestDestinationHrefArgs = {
  input: GuestDestinationInput
}

export type QueryIntegrationArgs = {
  integrationId: Scalars['ID']
}

export type QueryIntegrationAuthorizationUriArgs = {
  input: GetIntegrationAuthorizationUriInput
}

export type QueryIntegrationsArgs = {
  organizationId: Scalars['ID']
}

export type QueryJitsuEventsArgs = {
  input: JitsuEventsInput
}

export type QueryLogicExpressionJsonArgs = {
  logicExpressionId: Scalars['ID']
}

export type QueryLookupTableColumnGroupArgs = {
  lookupTableColumnGroupId: Scalars['ID']
}

export type QueryNavigationDeployPlanArgs = {
  input: NavigationDeployInput
}

export type QueryNotificationsArgs = {
  input: NotificationsInput
}

export type QueryOrganizationArgs = {
  organizationId: Scalars['ID']
}

export type QueryPaginatedBacklinkRowsArgs = {
  input: PaginatedBacklinkRowsInput
}

export type QueryPaginatedCommentsArgs = {
  input: PaginatedCommentsInput
}

export type QueryPaginatedCsvExportArgs = {
  input: PaginatedCsvExportInput
}

export type QueryPaginatedEventsArgs = {
  input: PaginatedEventsInput
}

export type QueryPaginatedIssuesArgs = {
  input: PaginatedIssuesInput
}

export type QueryPaginatedLookupRowsArgs = {
  input: PaginatedLookupRowsInput
}

export type QueryPaginatedNotificationsArgs = {
  input: PaginatedNotificationsInput
}

export type QueryPaginatedTableRowsArgs = {
  input: PaginatedTableRowsInput
}

export type QueryPreviewCellsArgs = {
  input: PreviewCellsInput
}

export type QueryRelatedActionStepsArgs = {
  input: RelatedEntitiesInput
}

export type QueryRelatedActionStepsForEntitiesArgs = {
  input: RelatedActionStepsForEntitiesInput
}

export type QueryRelatedEntitiesArgs = {
  input: RelatedEntitiesInput
}

export type QueryRoleArgs = {
  roleId: Scalars['ID']
}

export type QueryRunUdsSqlArgs = {
  includeTotalCount?: InputMaybe<Scalars['Boolean']>
  page?: InputMaybe<UdsSqlPageInput>
  sql: Scalars['String']
}

export type QueryRunUdsSqlBatchArgs = {
  statements: Array<UdsSqlStatementInput>
}

export type QuerySearchDocumentsArgs = {
  input: PaginatedSearchInput
}

export type QuerySearchFormsArgs = {
  input: PaginatedSearchInput
}

export type QuerySearchFormsV2Args = {
  input: PaginatedSearchInput
}

export type QuerySearchIconsArgs = {
  input: Scalars['String']
}

export type QuerySearchTableRowsArgs = {
  input: PaginatedSearchInput
}

export type QuerySearchTablesArgs = {
  input: PaginatedSearchInput
}

export type QueryShipStationDirectLoginUrlArgs = {
  integrationId: Scalars['ID']
}

export type QueryTableArgs = {
  tableId: Scalars['ID']
}

export type QueryTableButtonNodesArgs = {
  tableId: Scalars['ID']
}

export type QueryTableCellArgs = {
  tableCellId: Scalars['ID']
}

export type QueryTableColumnArgs = {
  tableColumnId: Scalars['ID']
}

export type QueryTableColumnsByIdArgs = {
  tableId: Scalars['ID']
}

export type QueryTableExportsArgs = {
  tableId: Scalars['ID']
}

export type QueryTableRowArgs = {
  tableRowId: Scalars['ID']
}

export type QueryTableRowsArgs = {
  rowIds: Array<Scalars['ID']>
}

export type QueryTablesArgs = {
  input?: InputMaybe<TablesInput>
}

export type QueryTestIntegrationArgs = {
  integrationId: Scalars['ID']
}

export type QueryVariantsWithInputOverrideArgs = {
  inputId: Scalars['ID']
}

export type QueryVerifyIntegrationRequestArgs = {
  input: VerifyIntegrationRequestInput
}

export type QueryViewArgs = {
  viewId: Scalars['ID']
}

export type QueryViewContentArgs = {
  id: Scalars['ID']
}

export type QueryViewContentVersionArgs = {
  id: Scalars['ID']
  version: Scalars['Int']
}

export type QueryViewContentVersionsArgs = {
  id: Scalars['ID']
}

export type QueryWorkflowArgs = {
  workflowId: Scalars['ID']
}

export type QueryWorkflowsByFormArgs = {
  formId: Scalars['ID']
}

export type QueryWorkflowsV2DependentsArgs = {
  input: WorkflowsV2DependentsInput
}

export type QueryWorkflowsV2DeployPlanArgs = {
  input: WorkflowsV2DeployInput
}

export type QueryWorkflowsV2IntegrationsManifestArgs = {
  defaultConnections?: InputMaybe<Array<WorkflowsV2DefaultConnectionInput>>
  providerAllowlist?: InputMaybe<Array<Scalars['String']>>
}

export type QueryWorkflowsV2MissingSourceFilesArgs = {
  hashes: Array<Scalars['String']>
}

export type QueryWorkflowsV2ShimArgs = {
  version?: InputMaybe<Scalars['String']>
}

export type QueryWorkflowsV2TypegenArgs = {
  defaultConnections?: InputMaybe<Array<WorkflowsV2DefaultConnectionInput>>
  preflight?: InputMaybe<Scalars['Boolean']>
  providerAllowlist?: InputMaybe<Array<Scalars['String']>>
}

export type QueryWorkspaceArgs = {
  workspaceId: Scalars['ID']
}

export type QueryWorkspaceByObjectArgs = {
  input: BreadcrumbsInput
}

/** Indicates the action that should be taken when a referenced entity is updated or deleted. */
export enum ReferentialAction {
  /** Delete this entity (and remove the relation) if the referenced entity is deleted */
  CASCADE = 'CASCADE',
  /**
   * Fail deleting the referenced entity if the relation still exists. The check runs at the end of
   * the statement, or at COMMIT when the transaction ran SET CONSTRAINTS ALL DEFERRED. This is the
   * default for required relations. There is deliberately no RESTRICT: it rejects the same deletes
   * but can never be deferred.
   */
  NO_ACTION = 'NO_ACTION',
  /** Remove the relation if the referenced entity is deleted */
  SET_NULL = 'SET_NULL',
}

/** Input for querying related action steps for multiple entities at once */
export type RelatedActionStepsForEntitiesInput = {
  /** Array of source entity IDs to query for related action steps */
  sourceIds: Array<Scalars['ID']>
  /** Type of the source entities (all must be same type) */
  sourceType: NodeType
}

/** Result containing related action steps for multiple entities */
export type RelatedActionStepsForEntitiesResult = {
  __typename: 'RelatedActionStepsForEntitiesResult'
  /** Array of related action steps items, one per source ID */
  items: Array<RelatedActionStepsForEntityItem>
}

/** Result item containing related action steps for a single entity */
export type RelatedActionStepsForEntityItem = {
  __typename: 'RelatedActionStepsForEntityItem'
  /** Related action steps for this source */
  relatedActionSteps: RelatedActionStepsResult
  /** The source entity ID */
  sourceId: Scalars['ID']
}

/** Result containing ActionSteps related to an entity, categorized by read/write behavior */
export type RelatedActionStepsResult = {
  __typename: 'RelatedActionStepsResult'
  readSteps: Array<ActionStep>
  writeSteps: Array<ActionStep>
}

/** Input for querying entities related to a source entity */
export type RelatedEntitiesInput = {
  sourceId: Scalars['ID']
  sourceType: NodeType
}

/** Result containing all entities related to a source entity */
export type RelatedEntitiesResult = {
  __typename: 'RelatedEntitiesResult'
  actionSteps: Array<ActionStep>
  formFields: Array<FormField>
  formInputs: Array<FormInput>
  tableColumns: Array<TableColumn>
  tables: Array<Table>
}

export type ReorderChildTableInput = {
  childTableId: Scalars['ID']
  newOrder: Scalars['Int']
}

export type ReorderFormBlockInput = {
  formBlockId: Scalars['ID']
  newOrder: Scalars['Int']
  newParentBlockId?: InputMaybe<Scalars['ID']>
}

export type ReorderFormCategoryInput = {
  formCategoryId: Scalars['ID']
  formPageId?: InputMaybe<Scalars['ID']>
  newOrder: Scalars['Int']
}

export type ReorderFormFieldInput = {
  formCategoryId?: InputMaybe<Scalars['ID']>
  formFieldId: Scalars['ID']
  newOrder: Scalars['Int']
}

export type ReorderFormPageInput = {
  formPageId: Scalars['ID']
  newOrder: Scalars['Int']
}

export type ReorderTableColumnGroupInput = {
  newOrder: Scalars['Int']
  tableColumnGroupId: Scalars['ID']
}

export type ReorderTableColumnGroupMemberInput = {
  newOrder: Scalars['Int']
  tableColumnGroupMemberId: Scalars['ID']
}

export type ReorderTableColumnInput = {
  newOrder: Scalars['Int']
  /** PHYSICAL uses the stored order. LOGICAL uses a zero-based position, counting each lookup group once. */
  positionMode?: InputMaybe<TableColumnPositionMode>
  tableColumnId: Scalars['ID']
}

export type ReorderTableColumnsInput = {
  /** The column the user dragged. Must be one of tableColumnIds. Defaults to the first one by order */
  anchorTableColumnId?: InputMaybe<Scalars['ID']>
  /** Order of the column the block was dropped onto */
  newOrder: Scalars['Int']
  /** Columns to move together as one block. Their current relative order is preserved */
  tableColumnIds: Array<Scalars['ID']>
}

export type ReorderTableTabInput = {
  newOrder: Scalars['Int']
  tableTabId: Scalars['ID']
}

export type ReorderWorkspaceButtonInput = {
  newOrder: Scalars['Int']
  workspaceButtonId: Scalars['ID']
}

export type RequestIntegration2FaCodeInput = {
  customMetadata?: InputMaybe<Scalars['JSONObject']>
  integrationId: Scalars['ID']
  phase?: InputMaybe<Scalars['String']>
}

/** An authorized navigation item. Headers have no href or destination; parents retain the authored hierarchy. */
export type ResolvedNavigationItem = {
  __typename: 'ResolvedNavigationItem'
  destination: Maybe<NavigationDestination>
  href: Maybe<Scalars['String']>
  icon: Maybe<Scalars['String']>
  id: Scalars['ID']
  label: Scalars['String']
  order: Scalars['Int']
  parentId: Maybe<Scalars['ID']>
}

/** Information about a resolved table column, including its transformed data type. */
export type ResolvedTableColumnInfo = {
  __typename: 'ResolvedTableColumnInfo'
  /** The final column in the lookup chain. For non-lookup columns, returns the column itself. */
  column: TableColumn
  /** Data type after unwrapping lookups/arrays and converting ID to NUMBER/STRING. */
  resolvedType: DataType
}

export type RespondToDossbotToolConfirmationInput = {
  response: ToolUserResponse
  toolRunStepId: Scalars['ID']
  userRejectionReason?: InputMaybe<Scalars['String']>
}

export enum RetryExecutionInstanceMode {
  FROM_FAILURE_POINT = 'FROM_FAILURE_POINT',
  FROM_SCRATCH = 'FROM_SCRATCH',
}

export type Role = {
  __typename: 'Role'
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  memberships: Array<Membership>
  name: Scalars['String']
  organization: Organization
  /** The permissions that are associated with this role */
  permissions: Array<Permission>
  roleType: RoleType
  /** The slug of the role. This is automatically generated when the name is set. */
  slug: Scalars['String']
  /** The permissions that are associated with this role for a specific table */
  tablePermissions: Array<Permission>
  updatedAt: Scalars['DateTime']
}

export type RoleTablePermissionsArgs = {
  tableId: Scalars['ID']
}

export enum RoleType {
  ADMIN = 'ADMIN',
  EXTERNAL = 'EXTERNAL',
  /** Including a DOSS role for the support+@doss.com emails, so we can easily exclude them from certain queries */
  INTERNAL_DOSS = 'INTERNAL_DOSS',
  MEMBER = 'MEMBER',
}

/** Pre-flight delete blocking info for a single row */
export type RowDeleteBlockingInfo = {
  __typename: 'RowDeleteBlockingInfo'
  /** References blocking the delete, with column and table context */
  blockingReferences: Array<DeleteBlockingReference>
  /** Whether the row can be deleted (no blocking references) */
  canDelete: Scalars['Boolean']
  /** The row being checked */
  rowId: Scalars['ID']
  /** Name of the row being checked */
  rowName: Scalars['String']
}

/** The result of a search on admin */
export type SearchResult = {
  __typename: 'SearchResult'
  /** The admin URL path to the object */
  adminPath: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
  /** If the returned object is not an organization, this will be set */
  organizationId: Maybe<Scalars['ID']>
  type: BreadcrumbObjectType
}

export type SearchWorkspaceInput = {
  searchString: Scalars['String']
  workspaceId: Scalars['ID']
}

export type SearchWorkspaceResult = {
  __typename: 'SearchWorkspaceResult'
  documents: Array<Document>
  workspaces: Array<Workspace>
}

export type SendEmailInput = {
  body: Scalars['String']
  subject: Scalars['String']
  to: Scalars['String']
}

export type SetWorkflowV2EnabledInput = {
  enabled: Scalars['Boolean']
  workflowV2Id: Scalars['String']
}

export type ShareFormV2Input = {
  formV2Id: Scalars['ID']
}

/** A signature for a user. A user can have multiple signatures, but only one can be the default. */
export type Signature = {
  __typename: 'Signature'
  createdAt: Scalars['DateTime']
  /** A pointer if this signature is the default signature for the user */
  defaultSignatureUser: Maybe<Membership>
  id: Scalars['ID']
  /** The file that represents the signature */
  signatureFile: Document
  /** Which User created this signature (if any) */
  user: Maybe<Membership>
  /** Deprecated: The user string ID is now a UUID */
  userId_deprecated: Maybe<Scalars['String']>
}

/** Sort directions for a table */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SubmitFormFileInput = {
  file: Scalars['FileInput']
  fileType: GeneratedFileType
}

export type SubmitFormInput = {
  files: Array<SubmitFormFileInput>
  formId: Scalars['ID']
  formSubmissionData: Scalars['JSONObject']
}

export type SubmitFormV2Input = {
  formId: Scalars['ID']
  formSubmissionData: Scalars['JSONObject']
}

export type Subscription = {
  __typename: 'Subscription'
  /** When rows are inserted via csv upload, push the number of rows inserted to the front end */
  csvInsertedTableRow: FileProgress
  /** When a row is deleted from a table an App reads, push its id */
  deletedAppTableRow: Scalars['ID']
  /** When table column is deleted, it is pushed to the front-end */
  deletedTableColumn: Scalars['ID']
  /** When a table row is deleted, notify the front-end */
  deletedTableRow: Scalars['ID']
  /** Pushes new events for the subscribed object, or a child table's record-scoped feed when parentRowId is provided; matches paginatedEvents */
  pushActivityFeedEvent: PaginatedActivityFeedEvent
  /** When a row is created in a table an App reads, push its id */
  pushAppTableRow: Scalars['ID']
  /** When new comments are created for the provided input, they are pushed to the front-end */
  pushComment: PaginatedCommentWithChildren
  /** When new comments notifications are created for the logged in user, they are pushed to the front-end */
  pushCommentNotification: Notification
  /** When a dossbot event is created, it is pushed to the front-end */
  pushDossbotEvent: DossbotEvent
  /** When new events are created for the provided input, they are pushed to the front-end */
  pushEvent: PaginatedEvent
  /** When new notifications are created for the logged in user, they are pushed to the front-end */
  pushNotification: PaginatedEvent
  /** When a table row is created or updated, push the row's current + processing button nodes to the frontend */
  pushRowButtonNodes: TableRow
  /** When new table column is created, it is pushed to the front-end */
  pushTableColumn: TableColumn
  /** When a table exported, push the progress of the export to the front end */
  pushTableExportProgress: FileProgress
  /** When new table row is created (i.e. in INSERT_TABLE_ROW), it is pushed to the front-end */
  pushTableRow: TableRow
  /** When a new table tab is created, push to the front-end */
  pushTableTab: TableTab
  /** When a row an App shows is updated, push it as the viewer reads it; null once they can't see it */
  updatedAppTableRow: Maybe<AppTableRow>
  /** When a form is updated, it is pushed to the front end */
  updatedForm: Form
  /** When a table row is updated at the record level (i.e. in another tab), it is pushed to the front-end */
  updatedTableRowDetails: TableRow
  /** Push an update to web whenever the provided user is modified */
  updatedUser: Membership
  /** Fires the latest ViewContent whenever it is created or a new version is saved. */
  updatedViewContent: ViewContent
  /** When a workspace is deleted, push the progress of the deletion of its children and itself to the front end */
  workspaceDeletionProgress: WorkspaceDeletionProgress
}

export type SubscriptionCsvInsertedTableRowArgs = {
  input: TableCsvInsertedSubscriptionInput
}

export type SubscriptionDeletedAppTableRowArgs = {
  input: AppTableSubscriptionInput
}

export type SubscriptionDeletedTableColumnArgs = {
  tableId: Scalars['ID']
}

export type SubscriptionDeletedTableRowArgs = {
  input: TableSubscriptionInput
}

export type SubscriptionPushActivityFeedEventArgs = {
  input: PushActivityFeedEventInput
}

export type SubscriptionPushAppTableRowArgs = {
  input: AppTableSubscriptionInput
}

export type SubscriptionPushCommentArgs = {
  input: BreadcrumbsInput
}

export type SubscriptionPushDossbotEventArgs = {
  chatId: Scalars['ID']
}

export type SubscriptionPushEventArgs = {
  input: BreadcrumbsInput
}

export type SubscriptionPushRowButtonNodesArgs = {
  input: TableRowSubscriptionInput
}

export type SubscriptionPushTableColumnArgs = {
  tableId: Scalars['ID']
}

export type SubscriptionPushTableExportProgressArgs = {
  tableId: Scalars['ID']
}

export type SubscriptionPushTableRowArgs = {
  input: TableSubscriptionInput
}

export type SubscriptionPushTableTabArgs = {
  tableId: Scalars['ID']
}

export type SubscriptionUpdatedAppTableRowArgs = {
  input: AppTableRowSubscriptionInput
}

export type SubscriptionUpdatedFormArgs = {
  formId: Scalars['ID']
}

export type SubscriptionUpdatedTableRowDetailsArgs = {
  tableRowId: Scalars['ID']
}

export type SubscriptionUpdatedUserArgs = {
  id: Scalars['ID']
}

export type SubscriptionUpdatedViewContentArgs = {
  id: Scalars['ID']
}

export type SubscriptionWorkspaceDeletionProgressArgs = {
  userId: Scalars['ID']
}

/** An organization the logged in person can switch to */
export type SwitchableOrganization = {
  __typename: 'SwitchableOrganization'
  /** Whether this is the organization the session is signed in to */
  isCurrent: Scalars['Boolean']
  /** A signed URL for the organization's logo, or null when it has none */
  logoUrl: Maybe<Scalars['String']>
  /** The person's membership in this organization. Null when switching in without one, e.g. global read. */
  membershipId: Maybe<Scalars['ID']>
  organizationId: Scalars['ID']
  organizationName: Scalars['String']
}

/**
 * Operator-tunable runtime configuration, one row per (key, scopeType, scopeId). `value` holds a
 * PARTIAL override object validated in code by the domain's registered Zod schema (see
 * defineSystemConfig in common-backend); full defaults live in code, never in this table. A null
 * scopeType/scopeId is the global row for that key. Read through an in-memory snapshot refreshed on
 * an interval — changes take effect within ~30s without a deploy.
 */
export type SystemConfig = {
  __typename: 'SystemConfig'
  id: Scalars['ID']
  /** Config domain, e.g. "uds-performance-limits" */
  key: Scalars['String']
  /** Id of the scoped entity (e.g. an Organization id); null = the global row for this key */
  scopeId: Maybe<Scalars['ID']>
  /** Kind of entity this row is scoped to; null = the global row for this key */
  scopeType: Maybe<SystemConfigScopeType>
  /** Partial override object for this scope, validated by the domain's registered schema */
  value: Scalars['JSONObject']
}

/** The kind of entity a SystemConfig row is scoped to. */
export enum SystemConfigScopeType {
  ORGANIZATION = 'ORGANIZATION',
}

/**
 * The object a system event acted on.
 * Members are generated by `yarn codegen` from systemEventEntityTypeSchema in @doss/common-all;
 * edit the catalog, not this list.
 */
export enum SystemEventEntityType {
  ACTION = 'ACTION',
  ACTION_STEP = 'ACTION_STEP',
  BUTTON = 'BUTTON',
  CHART = 'CHART',
  COMMENT = 'COMMENT',
  FORM = 'FORM',
  FORM_INPUT = 'FORM_INPUT',
  INTEGRATION = 'INTEGRATION',
  MEMBERSHIP = 'MEMBERSHIP',
  OBJECT_SYNC = 'OBJECT_SYNC',
  ORGANIZATION = 'ORGANIZATION',
  ROLE = 'ROLE',
  TABLE = 'TABLE',
  TABLE_CELL = 'TABLE_CELL',
  TABLE_COLUMN = 'TABLE_COLUMN',
  TABLE_ROW = 'TABLE_ROW',
  TABLE_TAB = 'TABLE_TAB',
  TRIGGER = 'TRIGGER',
  USER = 'USER',
  WEBHOOK = 'WEBHOOK',
  WORKFLOW = 'WORKFLOW',
  WORKFLOW_V2 = 'WORKFLOW_V2',
}

/** system_events.originator_type. Who or what the action is attributed to. */
export enum SystemEventOriginatorType {
  FREQUENCY_TRIGGER = 'FREQUENCY_TRIGGER',
  NO_CONTEXT = 'NO_CONTEXT',
  SYSTEM = 'SYSTEM',
  USER = 'USER',
  WEBHOOK = 'WEBHOOK',
}

export enum SystemEventStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
}

/**
 * system_events.substrate. Describes the current hop, not the origin, so it flips as a cascade
 * moves from a click into a workflow step while attribution carries through unchanged.
 */
export enum SystemEventSubstrate {
  SYSTEM = 'SYSTEM',
  UI = 'UI',
  WORKFLOW = 'WORKFLOW',
}

/**
 * Members are generated by `yarn codegen` from the event catalog in @doss/common-all; add a
 * definition there, not here. A RUN_*_STARTED event is its own successful fact; the matching
 * RUN_* event records the outcome.
 */
export enum SystemEventType {
  AUTH_INTEGRATION = 'AUTH_INTEGRATION',
  CHANGE_USER_PASSWORD = 'CHANGE_USER_PASSWORD',
  CLEAR_TABLE = 'CLEAR_TABLE',
  CLICK_BUTTON = 'CLICK_BUTTON',
  CREATE_ACTION = 'CREATE_ACTION',
  CREATE_ACTION_STEP = 'CREATE_ACTION_STEP',
  CREATE_CHART = 'CREATE_CHART',
  CREATE_COMMENT = 'CREATE_COMMENT',
  CREATE_FORM = 'CREATE_FORM',
  CREATE_FORM_INPUT = 'CREATE_FORM_INPUT',
  CREATE_INTEGRATION = 'CREATE_INTEGRATION',
  CREATE_MEMBERSHIP = 'CREATE_MEMBERSHIP',
  CREATE_OBJECT_SYNC = 'CREATE_OBJECT_SYNC',
  CREATE_ORGANIZATION = 'CREATE_ORGANIZATION',
  CREATE_ROLE = 'CREATE_ROLE',
  CREATE_TABLE = 'CREATE_TABLE',
  CREATE_TABLE_COLUMN = 'CREATE_TABLE_COLUMN',
  CREATE_TABLE_ROW = 'CREATE_TABLE_ROW',
  CREATE_TABLE_TAB = 'CREATE_TABLE_TAB',
  CREATE_TRIGGER = 'CREATE_TRIGGER',
  CREATE_USER = 'CREATE_USER',
  CREATE_WORKFLOW = 'CREATE_WORKFLOW',
  CREATE_WORKFLOW_V2 = 'CREATE_WORKFLOW_V2',
  DELETE_ACTION = 'DELETE_ACTION',
  DELETE_ACTION_STEP = 'DELETE_ACTION_STEP',
  DELETE_CHART = 'DELETE_CHART',
  DELETE_COMMENT = 'DELETE_COMMENT',
  DELETE_FORM = 'DELETE_FORM',
  DELETE_FORM_INPUT = 'DELETE_FORM_INPUT',
  DELETE_INTEGRATION = 'DELETE_INTEGRATION',
  DELETE_OBJECT_SYNC = 'DELETE_OBJECT_SYNC',
  DELETE_ORGANIZATION = 'DELETE_ORGANIZATION',
  DELETE_ROLE = 'DELETE_ROLE',
  DELETE_TABLE = 'DELETE_TABLE',
  DELETE_TABLE_COLUMN = 'DELETE_TABLE_COLUMN',
  DELETE_TABLE_ROW = 'DELETE_TABLE_ROW',
  DELETE_TABLE_TAB = 'DELETE_TABLE_TAB',
  DELETE_TRIGGER = 'DELETE_TRIGGER',
  DELETE_USER = 'DELETE_USER',
  DELETE_WORKFLOW = 'DELETE_WORKFLOW',
  DELETE_WORKFLOW_V2 = 'DELETE_WORKFLOW_V2',
  FIRE_TRIGGER = 'FIRE_TRIGGER',
  IMPORT_OBJECT_SYNC_FILE = 'IMPORT_OBJECT_SYNC_FILE',
  LOGIN_USER = 'LOGIN_USER',
  LOGOUT_USER = 'LOGOUT_USER',
  MERGE_FORMULA_RECOMPUTE = 'MERGE_FORMULA_RECOMPUTE',
  READ_INTEGRATION = 'READ_INTEGRATION',
  RECEIVE_WEBHOOK = 'RECEIVE_WEBHOOK',
  RECOMPUTE_FORMULAS = 'RECOMPUTE_FORMULAS',
  RECOMPUTE_FORMULAS_STARTED = 'RECOMPUTE_FORMULAS_STARTED',
  RUN_ACTION = 'RUN_ACTION',
  RUN_ACTION_STARTED = 'RUN_ACTION_STARTED',
  RUN_ACTION_STEP = 'RUN_ACTION_STEP',
  RUN_ACTION_STEP_STARTED = 'RUN_ACTION_STEP_STARTED',
  RUN_OBJECT_SYNC = 'RUN_OBJECT_SYNC',
  RUN_OBJECT_SYNC_STARTED = 'RUN_OBJECT_SYNC_STARTED',
  RUN_WORKFLOW_V2 = 'RUN_WORKFLOW_V2',
  RUN_WORKFLOW_V2_STARTED = 'RUN_WORKFLOW_V2_STARTED',
  SEND_EMAIL = 'SEND_EMAIL',
  SUBMIT_FORM = 'SUBMIT_FORM',
  TRIGGER_OBJECT_SYNC = 'TRIGGER_OBJECT_SYNC',
  UPDATE_ACTION = 'UPDATE_ACTION',
  UPDATE_ACTION_STEP = 'UPDATE_ACTION_STEP',
  UPDATE_CHART = 'UPDATE_CHART',
  UPDATE_FORM = 'UPDATE_FORM',
  UPDATE_FORM_INPUT = 'UPDATE_FORM_INPUT',
  UPDATE_MEMBERSHIP = 'UPDATE_MEMBERSHIP',
  UPDATE_OBJECT_SYNC = 'UPDATE_OBJECT_SYNC',
  UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION',
  UPDATE_ROLE = 'UPDATE_ROLE',
  UPDATE_TABLE = 'UPDATE_TABLE',
  UPDATE_TABLE_CELL = 'UPDATE_TABLE_CELL',
  UPDATE_TABLE_COLUMN = 'UPDATE_TABLE_COLUMN',
  UPDATE_TABLE_TAB = 'UPDATE_TABLE_TAB',
  UPDATE_TRIGGER = 'UPDATE_TRIGGER',
  UPDATE_USER = 'UPDATE_USER',
  UPDATE_WORKFLOW = 'UPDATE_WORKFLOW',
  UPDATE_WORKFLOW_V2 = 'UPDATE_WORKFLOW_V2',
  UPLOAD_CSV = 'UPLOAD_CSV',
  UPLOAD_CSV_STARTED = 'UPLOAD_CSV_STARTED',
  UPSERT_TABLE_ROWS = 'UPSERT_TABLE_ROWS',
  WRITE_INTEGRATION = 'WRITE_INTEGRATION',
}

/** Identifies a system-generated table column (not a real TableColumn) for filters/sorts. */
export enum SystemGeneratedTableColumnType {
  CREATED_AT = 'CREATED_AT',
  CREATED_BY = 'CREATED_BY',
  UPDATED_AT = 'UPDATED_AT',
  UPDATED_BY = 'UPDATED_BY',
}

/** The primary system prompt that the drives the agent "You are an agent ..." */
export type SystemPrompt = {
  __typename: 'SystemPrompt'
  /** The runs of the assocaited agent that used this system prompt */
  agentRuns: Array<AgentRun>
  id: Scalars['ID']
  /** The model specification this system prompt belongs to */
  modelSpec: ModelSpecification
  /** The prompt that is used for generation, can use Handlebar templates to inject variables */
  prompt: Scalars['String']
  version: Scalars['Int']
}

/**
 * A table view.
 *
 * The data for the table is stored in generic table rows. The headers of the table
 * columns will be stored as a string array. To extract the data from the rows, we
 * will parse the data into an object with the keys extracted from the column
 * headers.
 */
export type Table = {
  __typename: 'Table'
  /** Forms that are linked to this table for adding records */
  addRecordForms: Array<FormV2>
  /**
   * Configuration for this table's button-based state machine.
   * Designates which TableButtonNode serves as the root/starting node.
   * Every table must have a state machine configuration.
   */
  buttonStateMachineConfig: Maybe<TableButtonStateMachineConfig>
  charts: Array<Chart>
  /** Any table can optionally have a linked set of child tables. */
  childTables: Array<Table>
  /** Number of columns the current user can see */
  columnCount: Scalars['Int']
  /** Any column groups associated with the table */
  columnGroups: Array<TableColumnGroup>
  columns: Array<TableColumn>
  description: Maybe<Scalars['String']>
  /** A list of form lookup groups that perform lookups for autofill on rows from this table. (FormV2) */
  formLookupInputGroups: Array<FormLookupInputGroup>
  /** Indicates whether the table has any row workspace objects */
  hasRowWorkspaceObjects: Scalars['Boolean']
  /**
   * Checks if the table has at least one row, useful for data integrity checks before adding or
   * deleting columns for the table.
   */
  hasRows: Scalars['Boolean']
  /** Optional icon associated with the table */
  icon: Maybe<Icon>
  id: Scalars['ID']
  /** Checks if the table has at least one table tab that has isShareable set to true */
  isShareable: Scalars['Boolean']
  /**
   * Any tables that have a lookup column group that is looking up to columns in this table and is set
   * to show backlink as a child table
   */
  lookupBacklinkTables: Array<Table>
  /** Any lookup column groups whose columns are looking up to columns in this table */
  lookupColumnGroups: Array<LookupTableColumnGroup>
  /** A list of form categories that perform lookups for autofill on rows from this table. (FormV1) */
  lookupFormCategories: Array<FormCategory>
  name: Scalars['String']
  /** Any object store table operations that are associated with this table */
  objectStoreTableOperations: Array<ObjectStoreTableSync>
  /** The order in which the child table appears on the record details page */
  orderOnRecordDetails: Maybe<Scalars['Int']>
  organization: Organization
  parentTable: Maybe<Table>
  /** The permissions that control access to this table */
  permissions: Array<Permission>
  /** The placing view created with a parent table; only populated on creation results */
  placingViewId: Maybe<Scalars['ID']>
  /** Rows the current user can see. Null when the count is unavailable */
  recordCount: Maybe<Scalars['Int']>
  /** The root state created with the table; only populated on creation results */
  rootButtonNodeId: Maybe<Scalars['ID']>
  /** The workspace that contains this table as its root view */
  rootWorkspace: Workspace
  rows: Array<TableRow>
  /** Boolean to determine whether to show the file workspace in the record page */
  showRowWorkspace: Scalars['Boolean']
  /** The slug of the table. This is automatically generated when the name is set. */
  slug: Scalars['String']
  /**
   * The button nodes for this table.
   * Defines the state machine that controls which buttons are visible for each row.
   */
  tableButtonNodes: Array<TableButtonNode>
  /** Column versions for z-tables schema versioning */
  tableColumnVersions: Array<TableColumnVersion>
  /** CSV export jobs for this table */
  tableExports: Array<TableExport>
  /** Schema versions for z-tables schema versioning */
  tableSchemaVersions: Array<TableSchemaVersion>
  tableTabs: Array<TableTab>
  /**
   * The `__doss_*` infrastructure columns the UDS SQL catalog exposes for this table, in catalog
   * order. Mirrors the in-process UDS catalog so clients can present the queryable schema without
   * a dedicated catalog query.
   */
  udsSystemColumns: Array<UdsSystemColumn>
  /** Unique constraints configured for this table */
  uniqueConstraints: Array<TableUniqueConstraint>
  /** Version history for this table's JSON definitions */
  versions: Array<EntityVersionHistory>
  /** The views backed by this table */
  views: Array<View>
}

/**
 * Represents a node in the button state machine. Each node may have zero or more workspace buttons that should be displayed when a table row has this node. Rows transition between nodes based on field value changes that satisfy transition conditions.
 * Example: "Draft Invoice" state with [Edit, Send, Delete] buttons
 */
export type TableButtonNode = {
  __typename: 'TableButtonNode'
  /** Table rows currently pointing to this node */
  currentRows: Array<TableRow>
  id: Scalars['ID']
  /** History of transitions that ended at this node */
  incomingHistory: Array<TableButtonTransitionHistory>
  /** Transitions TO this node FROM other nodes. */
  incomingTransitions: Array<TableButtonTransition>
  /**
   * The state's logical id: the table-scoped authored identifier from its logical binding. Null for
   * a node the binding registry does not know yet (created before the registry and not backfilled).
   */
  logicalId: Maybe<Scalars['String']>
  /** Display name for this state (e.g., 'Draft Invoice', 'Pending Payment') which must be unique within its parent table */
  name: Scalars['String']
  /** History of transitions that originated from this node */
  outgoingHistory: Array<TableButtonTransitionHistory>
  /**
   * Transitions FROM this node TO other nodes. Evaluated when a row at this node is updated.
   * The all transitions whose condition evaluate to true are taken.
   */
  outgoingTransitions: Array<TableButtonTransition>
  /** The table rows that have this node as a pending node to be evaluated when it's button stops processing */
  pendingRows: Array<TableRow>
  /** Present only if this button node is designated as the root/starting node for its parent table's state machine. Most button nodes will not have this set. */
  rootButtonNodeConfig: Maybe<TableButtonStateMachineConfig>
  table: Table
  /** The workspace buttons displayed when a row is pointing at this node */
  workspaceButtons: Array<WorkspaceButton>
}

export type TableButtonNodeEvaluationResult = {
  __typename: 'TableButtonNodeEvaluationResult'
  jobId: Maybe<Scalars['ID']>
  jobUrl: Maybe<Scalars['String']>
  message: Scalars['String']
  success: Scalars['Boolean']
}

/** Configuration for a Table's button-based state machine. */
export type TableButtonStateMachineConfig = {
  __typename: 'TableButtonStateMachineConfig'
  id: Scalars['ID']
  /** This is the first node and should be used to evaluate what the row's current button nodes should be at row creation. It can potentially have incoming transitions, if configured to do so */
  rootButtonNode: TableButtonNode
  table: Table
}

/**
 * Represents a conditional transition between two table button nodes. When a row is updated, the system evaluates outgoing transitions from the current node in order and follows all transitions whose condition is satisfied.
 * Example: Draft → Sent when "status = 'sent' AND sentAt IS NOT NULL"
 */
export type TableButtonTransition = {
  __typename: 'TableButtonTransition'
  /**
   * The logical condition that must evaluate to true for this transition to be followed.
   * Evaluated against the row's field values after an update.
   * Example: "amountPaid >= totalAmount" or "status = 'cancelled'"
   */
  condition: LogicExpression
  /** The transition histories associated with this transition */
  history: Array<TableButtonTransitionHistory>
  id: Scalars['ID']
  /** Optional human-readable name for this transition (e.g., 'Invoice sent to customer') */
  name: Maybe<Scalars['String']>
  /** The node this transition starts from */
  sourceNode: TableButtonNode
  /** The node this transition goes to */
  targetNode: TableButtonNode
}

/** Records when a row transitions from one button node to another. */
export type TableButtonTransitionHistory = {
  __typename: 'TableButtonTransitionHistory'
  /** The action that caused the change. Will be null if the change occured due to a user updating the row directly */
  action: Maybe<Action>
  /** When this transition occurred */
  createdAt: Scalars['DateTime']
  /** The node that the transition started from, optional in case the node was deleted */
  fromNode: Maybe<TableButtonNode>
  /** The name of the from node used in case the node was deleted */
  fromNodeName: Scalars['String']
  id: Scalars['ID']
  /** The stringified logic expression that evaluated to true to cause this transition */
  logicExpressionString: Scalars['String']
  /** The row that transitioned */
  tableRow: TableRow
  /** The node that the transition ended at, optional in case the node was deleted */
  toNode: Maybe<TableButtonNode>
  /** The name of the to node used in case the node was deleted */
  toNodeName: Scalars['String']
  /** The transition that the row made, optional in case the transition was deleted */
  transition: Maybe<TableButtonTransition>
  /**
   * The user that caused the change - could have updated the row directly or triggered an action that updated the row.
   * Will be null if the change was made via action that was triggered by a webhook or frequency trigger
   */
  user: Maybe<Membership>
  /** Deprecated: The user string ID is now a UUID */
  userId_deprecated: Maybe<Scalars['String']>
}

/** A cell of a table. API contract type served from z-tables (no backing DB table — see @notAnEntity). */
export type TableCell = {
  __typename: 'TableCell'
  /** The column this cell is contained in */
  column: TableColumn
  /** The JSONB data stored in this cell. This can be null only if the associated column is nullable */
  data: Maybe<Scalars['JSONObject']>
  /** A list of documents associated with this table cell */
  documents: Array<Document>
  /** The formula error code for this cell, non null for errors in formula columns */
  formulaError: Maybe<Scalars['Int']>
  id: Scalars['ID']
  /**
   * Cell that this cell uses for setting data. If specified, the data in this cell is the same as the
   * lookupCell
   */
  lookupCells: Array<TableCell>
  /** The row this cell is contained in */
  row: TableRow
  updatedAt: Scalars['DateTime']
  /** The stringified user-visible value of the cell computed based on the data */
  userVisibleValue: Maybe<Scalars['String']>
  /** A list of users associated with this table cell */
  users: Array<Membership>
}

/**
 * The metadata about a specific table column. This includes the name of the
 * column, what order the columns are in in the table, and what type of data is
 * stored.
 */
export type TableColumn = {
  __typename: 'TableColumn'
  /** The chart aggregation columns that use the column as the data source */
  chartAggregations: Array<ChartAggregationColumn>
  chartsForXAxis: Array<Chart>
  chartsForYAxis: Array<Chart>
  /** Column versions tracking schema evolution for this column */
  columnVersions: Array<TableColumnVersion>
  description: Maybe<Scalars['String']>
  /**
   * For file url types or array of file url types, indicates if images should be displayed inline
   * within the table cell
   */
  displayImagesInline: Scalars['Boolean']
  /** List of options available for an ENUM type column */
  enumOptions: Maybe<Array<Scalars['String']>>
  /** The relational option set backing this ENUM column, source of the enumOptions mirror */
  enumSet: Maybe<EnumSet>
  /** A list of form fields that use this column for lookups (FormV1) */
  formFieldLookups: Maybe<Array<FormField>>
  /** A list of form inputs that use this column for lookups (FormV2) */
  formInputLookups: Maybe<Array<FormInput>>
  /**
   * Variant-specific format configuration whose shape depends on formatPreset. Validated
   * at the application boundary via the shared Zod schema in common-all. NULL iff
   * formatPreset is NULL.
   */
  formatOptions: Maybe<Scalars['JSONObject']>
  /**
   * Format preset for NUMBER/FORMULA/DATE/DATE_TIME columns. Pairs with formatOptions
   * to describe how cell values should be rendered. NULL on column types that do not
   * support formatting.
   */
  formatPreset: Maybe<FormatPreset>
  /** If defined, the formula that this column uses for setting data */
  formula: Maybe<Formula>
  /** A list of formulas that use this column as an input */
  formulaValueInputs: Array<FormulaValue>
  /** The group member that this column belongs to, if any */
  group: Maybe<TableColumnGroupMember>
  groupBys: Array<ChartGroupBy>
  /**
   * Returns true if the column has at least 1 non-null or non-empty cell. Useful for data integrity checks before
   * modifications like changing data types.
   */
  hasNonNullCells: Scalars['Boolean']
  /**
   * Returns true if the column has at least 1 null or empty cell. Useful for data integrity checks before
   * modifications like changing is nullable.
   */
  hasNullCells: Scalars['Boolean']
  id: Scalars['ID']
  /** If the column is an index column, then this determines whether the index value is autogenerated */
  indexAutogenerate: Scalars['Boolean']
  /** If the column is an index column, this is the prefix to use for the index */
  indexPrefix: Scalars['String']
  /** If the column is an index column, this is the suffix to use for the index */
  indexSuffix: Scalars['String']
  /** The data type of the index value if it is an index column */
  indexType: IndexType
  innerType: Maybe<DataType>
  /**
   * NUMBER columns only: workflows-as-code reads and writes this column as an exact decimal
   * instead of a floating-point number. Storage is already exact (Postgres numeric); every other
   * consumer (web, legacy workflows, search) keeps treating it as an ordinary number.
   */
  isDecimal: Scalars['Boolean']
  /** If the data can be null or must be specified. */
  isNullable: Scalars['Boolean']
  /** If data cannot be modified */
  isReadOnly: Scalars['Boolean']
  /** If the column is visible on the left side of the record details page */
  isVisibleOnRecordDetails: Scalars['Boolean']
  /**
   * Form inputs that are linked to this column as their source.
   * Excludes lookup-type relationships (use formInputLookups for those).
   */
  linkedFormInputs: Array<FormInput>
  /** A list of logical expression values that use this column as an input */
  logicalExpressionValues: Array<LogicExpressionValue>
  /**
   * Column that this column uses for setting data. If specified, all data in this column must match
   * data in the lookupColumn
   */
  lookupColumn: Maybe<TableColumn>
  /** A list of columns using this column for lookups */
  lookupColumnChildren: Array<TableColumn>
  /** If defined, the lookup group this column is in */
  lookupColumnGroup: Maybe<LookupTableColumnGroup>
  /** If defined, the filter expression that this column uses for lookups */
  lookupFilterExpression: Maybe<LogicExpression>
  /** The name of the column, which must be unique within its parent table, case-insensitively */
  name: Scalars['String']
  order: Scalars['Int']
  /** A list of permissions that control access to this column */
  permissions: Array<Permission>
  /**
   * Returns the enum options from the final resolved column (for lookup chains ending in ENUM type)
   *
   * @deprecated Use resolvedSourceColumn.column.enumOptions instead
   */
  resolvedEnumOptions: Maybe<Array<Scalars['String']>>
  /** Resolves lookup chains to the final target column and its transformed data type. */
  resolvedSourceColumn: ResolvedTableColumnInfo
  /**
   * Returns the resolved data type by recursively resolving lookup columns and array inner types.
   *
   * @deprecated Use resolvedSourceColumn.resolvedType instead
   */
  resolvedSourceType: DataType
  /** The slug of the column. This is automatically generated when the name is set. */
  slug: Scalars['String']
  table: Table
  /** A list of table column filters referencing this column */
  tableColumnFilters: Array<TableColumnFilter>
  /** A list of table tab sorts referencing this column */
  tableTabSorts: Array<TableTabSort>
  /** A list of table tab columns referencing this column */
  tableTabs: Array<TableTabColumn>
  type: DataType
  /**
   * The PostgreSQL type name the UDS SQL catalog reports for this column, as shown by UDS
   * information_schema.columns (e.g. text, numeric, date). A compatibility display name,
   * not a storage guarantee.
   */
  udsDataType: Scalars['String']
  /** Unique constraints that include this column */
  uniqueConstraintMemberships: Array<TableUniqueConstraintColumn>
}

/**
 * A saved filter applied to a table column for a table tab or chart.
 * This includes the table column on which the filter,
 * the operator used to apply the filter, and the operand.
 */
export type TableColumnFilter = {
  __typename: 'TableColumnFilter'
  chart: Maybe<Chart>
  filterableObjectType: FilterableObjectType
  id: Scalars['ID']
  operand: Maybe<Scalars['JSONObject']>
  operator: FilterOperator
  systemGeneratedColumnType: Maybe<SystemGeneratedTableColumnType>
  tableColumn: Maybe<TableColumn>
  tableTab: Maybe<TableTab>
}

export type TableColumnFilterInput = {
  operand: Scalars['JSONObject']
  operator: FilterOperator
  /** System-generated column to filter on (e.g. Created at). Omit when filtering on a table column. */
  systemGeneratedColumnType?: InputMaybe<SystemGeneratedTableColumnType>
  /** Table column to filter on. Omit when filtering on a system-generated column. */
  tableColumnId?: InputMaybe<Scalars['ID']>
}

/** A group of table columns on a table */
export type TableColumnGroup = {
  __typename: 'TableColumnGroup'
  /** The columns in the group */
  columns: Array<TableColumnGroupMember>
  id: Scalars['ID']
  name: Scalars['String']
  order: Scalars['Int']
  /** The table on which the group exists */
  table: Table
}

/**
 * A table column in a table column grouping. This includes the order of the
 * table column in the group
 */
export type TableColumnGroupMember = {
  __typename: 'TableColumnGroupMember'
  id: Scalars['ID']
  order: Scalars['Int']
  /** The table column referenced by the group member */
  tableColumn: TableColumn
  /** The table column group to which the group member belongs */
  tableColumnGroup: TableColumnGroup
}

/** Whether a column reorder uses physical order or a logical position with lookup groups counted once */
export enum TableColumnPositionMode {
  LOGICAL = 'LOGICAL',
  PHYSICAL = 'PHYSICAL',
}

/** Whether a column version is stored as a physical column or a join table */
export enum TableColumnStorageType {
  COLUMN = 'COLUMN',
  JOIN_TABLE = 'JOIN_TABLE',
}

/** Tracks physical column/join-table versions for z-tables, enabling schema evolution and historical column resolution */
export type TableColumnVersion = {
  __typename: 'TableColumnVersion'
  /** When this version became the active version */
  activatedAt: Scalars['DateTime']
  /** Value applied to existing rows when this column was created (JSON-encoded). Used by readers for events that predate this column. */
  backfillValue: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  /** Application-level column type (STRING, NUMBER, LOOKUP, ARRAY, etc.) */
  dataType: DataType
  /** When this version was superseded (NULL while active) */
  deactivatedAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** Index type for this column (NONE, UNIQUE, etc.). NULL for join table storage. */
  indexType: Maybe<IndexType>
  /** Inner type for ARRAY columns (LOOKUP, USER, FILE_URL). NULL for non-array columns. */
  innerDataType: Maybe<DataType>
  /** Whether this column version allows NULL values */
  isNullable: Scalars['Boolean']
  /** The lookup column group this version belongs to (NULL for non-lookup columns, set NULL on group deletion) */
  lookupColumnGroup: Maybe<LookupTableColumnGroup>
  organization: Maybe<Organization>
  /** PostgreSQL type (e.g., text, integer, numeric, uuid). NULL for join table storage. */
  pgType: Maybe<Scalars['Regtype']>
  /** Physical column name in the history table (e.g., col_123__v1, col_123__v2) or join table name (e.g., lookup_<groupId>). Version suffixes only appear on history table columns. */
  physicalName: Scalars['String']
  /** Schema versions that include this column version */
  schemaVersions: Array<TableSchemaVersion>
  /** Stable logical column identifier that survives TableColumn deletion */
  stableColumnId: Scalars['ID']
  /** Snapshot of the column name at version time (survives deletion and renames) */
  stableColumnName: Scalars['String']
  /** Snapshot of the column slug at version time (survives deletion and renames) */
  stableColumnSlug: Scalars['String']
  /** Snapshot of the lookup display column ID at version time (survives group deletion) */
  stableLookupColumnId: Maybe<Scalars['ID']>
  /** Snapshot of the lookup column group ID at version time (survives group deletion) */
  stableLookupTableColumnGroupId: Maybe<Scalars['ID']>
  /** Snapshot of the lookup target table ID at version time (survives group deletion) */
  stableLookupTableId: Maybe<Scalars['ID']>
  /** Stable table identifier that survives Table deletion */
  stableTableId: Scalars['ID']
  /** Snapshot of the table name at version time (survives deletion and renames) */
  stableTableName: Scalars['String']
  /** Snapshot of the table slug at version time (survives deletion and renames) */
  stableTableSlug: Scalars['String']
  /** Whether this version is stored as a column or a join table */
  storageType: TableColumnStorageType
  table: Maybe<Table>
  tableColumn: Maybe<TableColumn>
  /** Monotonically increasing version number for this logical column */
  versionNumber: Scalars['Int']
}

export type TableCsvInsertedSubscriptionInput = {
  parentRowId?: InputMaybe<Scalars['ID']>
  tableId: Scalars['ID']
  userId: Scalars['ID']
}

/** A CSV export job for a table */
export type TableExport = {
  __typename: 'TableExport'
  /** Execution backend selected when this export was dispatched; null for historical exports */
  backend: Maybe<ExportBackend>
  createdAt: Scalars['DateTime']
  /** The user who initiated the export */
  createdBy: Membership
  /** Deprecated: The user string ID is now a UUID */
  createdById_deprecated: Maybe<Scalars['String']>
  /** The generated document containing the CSV file */
  document: Maybe<Document>
  /** Error message if the export failed */
  errorMessage: Maybe<Scalars['String']>
  /** Export configuration including column IDs, filters, sorts, and locale settings */
  exportConfig: Scalars['JSONValue']
  /** Name of the exported file */
  fileName: Scalars['String']
  id: Scalars['ID']
  /** The organization-wide export this export belongs to, if it was created by one */
  organizationExport: Maybe<OrganizationExport>
  /** Number of rows exported */
  rowCount: Maybe<Scalars['Int']>
  /** Current status of the export job */
  status: TableExportStatus
  /** The table being exported */
  table: Table
  updatedAt: Scalars['DateTime']
}

/** Status of a table CSV export job */
export enum TableExportStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
}

export type TableFilterInput = {
  columnId: Scalars['ID']
  filterArray?: InputMaybe<Array<Scalars['String']>>
  /** Either a filter string or filter array or operand should be supplied */
  filterString?: InputMaybe<Scalars['String']>
  operand?: InputMaybe<Scalars['JSONObject']>
  operator: FilterOperator
}

/** Represents a single validation error found during Table JSON validation */
export type TableJsonValidationError = {
  __typename: 'TableJsonValidationError'
  /** Human-readable error message */
  message: Scalars['String']
  /** The JSON path where the error occurred (e.g., 'columns[0].lookupColumn.table') */
  path: Scalars['String']
}

/**
 * A row of the table. This is a generic component with the row data stored in
 * cells. TableRow is also a type of View.
 */
export type TableRow = {
  __typename: 'TableRow'
  /** Complete history of button transitions for this row. */
  buttonTransitionHistory: Array<TableButtonTransitionHistory>
  /** Cells in this row. Resolver-served from z-tables; not a DB relation (TableCell is dropped). */
  cells: Array<TableCell>
  childRows: Array<TableRow>
  createdAt: Scalars['DateTime']
  /** The user that created this row, null if created by the system */
  createdBy: Maybe<Membership>
  /** Deprecated: The user string ID is now a UUID */
  createdById_deprecated: Maybe<Scalars['String']>
  /** The current visible button nodes for this row. Determines which buttons are visible and what transitions are available. */
  currentButtonNodes: Array<TableButtonNode>
  hasChildRows: Scalars['Boolean']
  id: Scalars['ID']
  /** The name of a table row is the value of the ID column if one exists, else the first column */
  name: Scalars['String']
  /** @deprecated Use createdAt for ordering instead. */
  order: Maybe<Scalars['Int']>
  parentRow: Maybe<TableRow>
  /** The pending visible button nodes for this row. Determines which nodes should be evaluated when the table row's processing workspace button is unset" */
  pendingButtonNodes: Array<TableButtonNode>
  /** The workspace button currently processing on this row. If this is set, all visible buttons for the row should be disabled */
  processingWorkspaceButton: Maybe<WorkspaceButton>
  /** The workspace that contains this table row as its root view */
  rootWorkspace: Workspace
  table: Table
  updatedAt: Scalars['DateTime']
  /** The user that last updated this row or any cell within it, null if updated by the system */
  updatedBy: Maybe<Membership>
  updatedById_deprecated: Maybe<Scalars['String']>
  /** The views backed by this table row */
  views: Array<View>
}

export type TableRowSubscriptionInput = {
  rowId?: InputMaybe<Scalars['ID']>
  tableId?: InputMaybe<Scalars['ID']>
}

/** Atomic snapshot of a table's schema — all column versions active at a point in time */
export type TableSchemaVersion = {
  __typename: 'TableSchemaVersion'
  /** When this schema version became active */
  activatedAt: Scalars['DateTime']
  /** The column versions that constitute this schema snapshot */
  columnVersions: Array<TableColumnVersion>
  createdAt: Scalars['DateTime']
  /** When this schema version was superseded (NULL while active) */
  deactivatedAt: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  organization: Maybe<Organization>
  /** Stable table identifier that survives Table deletion */
  stableTableId: Scalars['ID']
  table: Maybe<Table>
  /** Monotonically increasing schema version number for this table */
  versionNumber: Scalars['Int']
}

export type TableSortInput = {
  columnId: Scalars['ID']
  direction: SortDirection
}

export type TableSubscriptionInput = {
  parentRowId?: InputMaybe<Scalars['ID']>
  tableId: Scalars['ID']
}

/**
 * A tab of the table. This includes the name and order of the tab
 * and its filters and sort criteria
 */
export type TableTab = {
  __typename: 'TableTab'
  /** For now, will be the same across all table column filters on a table tab */
  booleanOperator: Maybe<BooleanOperator>
  columns: Array<TableTabColumn>
  filters: Array<TableColumnFilter>
  id: Scalars['ID']
  /** Allow a table to be accessed without authentication */
  isShareable: Scalars['Boolean']
  name: Scalars['String']
  order: Scalars['Int']
  /** The permissions that control access to this table tab */
  permissions: Array<Permission>
  /** The slug of the tab. This is automatically generated when the name is set. */
  slug: Scalars['String']
  /** For now, will limit to just one sort but can implement multiple sorts in the future */
  sorts: Array<TableTabSort>
  /** The table on which the tab exists */
  table: Table
}

/**
 * A table column header on a table tab. This includes the order of the
 * table column header on the tab
 */
export type TableTabColumn = {
  __typename: 'TableTabColumn'
  id: Scalars['ID']
  isFrozen: Scalars['Boolean']
  order: Scalars['Int']
  systemGeneratedColumnType: Maybe<SystemGeneratedTableColumnType>
  tableColumn: Maybe<TableColumn>
  tableTab: TableTab
}

export type TableTabColumnInput = {
  order: Scalars['Int']
  /** System-generated column to show (e.g. Created at). Omit when adding a table column. */
  systemGeneratedColumnType?: InputMaybe<SystemGeneratedTableColumnType>
  /** Table column to show. Omit when adding a system-generated column. */
  tableColumnId?: InputMaybe<Scalars['ID']>
}

/**
 * A sort applied to a table tab. This includes the table column on which the sort
 * is occuring and the sort direction
 */
export type TableTabSort = {
  __typename: 'TableTabSort'
  direction: SortDirection
  id: Scalars['ID']
  systemGeneratedColumnType: Maybe<SystemGeneratedTableColumnType>
  tableColumn: Maybe<TableColumn>
  tableTab: TableTab
}

export type TableTabSortInput = {
  direction: SortDirection
  systemGeneratedColumnType?: InputMaybe<SystemGeneratedTableColumnType>
  tableColumnId?: InputMaybe<Scalars['ID']>
}

/** A unique constraint over one or more columns in a table */
export type TableUniqueConstraint = {
  __typename: 'TableUniqueConstraint'
  columns: Array<TableUniqueConstraintColumn>
  /** Raw stored sample; prefer the typed `conflicts` field. Cleared once ACTIVE. */
  conflictSample: Maybe<Scalars['JSONValue']>
  /** Reported conflict groups; check `conflictsTruncated` to detect capping. */
  conflictedKeyGroupCount: Maybe<Scalars['Int']>
  /** Conflicting keys found by the last probe, ordered by key. */
  conflicts: Array<TableUniqueConstraintConflict>
  /** When the duplicate probe last ran. */
  conflictsCheckedAt: Maybe<Scalars['DateTime']>
  /** True when the table holds more conflicting key groups than the sample reports. */
  conflictsTruncated: Maybe<Scalars['Boolean']>
  /** Failed activation attempts since the last success or user-initiated retry. */
  failedAttempts: Scalars['Int']
  id: Scalars['ID']
  lastErrorCode: Maybe<TableUniqueConstraintErrorCode>
  lastErrorMessage: Maybe<Scalars['String']>
  lastFailedAt: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  nullsDistinct: Scalars['Boolean']
  scope: TableUniqueConstraintScope
  status: TableUniqueConstraintStatus
  table: Table
}

/** An ordered column membership in a table unique constraint */
export type TableUniqueConstraintColumn = {
  __typename: 'TableUniqueConstraintColumn'
  column: TableColumn
  constraint: TableUniqueConstraint
  id: Scalars['ID']
  position: Scalars['Int']
}

/**
 * One conflicting key and a bounded sample of the rows that share it. A point-in-time snapshot taken
 * at `conflictsCheckedAt`, not live state; reading it never re-scans the table.
 */
export type TableUniqueConstraintConflict = {
  __typename: 'TableUniqueConstraintConflict'
  /** A capped sample of the rows sharing this key. */
  exampleRowIds: Array<Scalars['ID']>
  /** Member column values in index-key order, as text. Excludes the PARENT scope prefix. */
  keyValues: Scalars['JSONValue']
  /** The parent row this conflict is scoped to; null for TABLE scope. */
  parentRowId: Maybe<Scalars['ID']>
  /** Live rows sharing this key when the probe ran, which may exceed `exampleRowIds`. */
  rowCount: Scalars['Int']
}

/** User-facing activation failure categories, intentionally coarser than SQLSTATE. */
export enum TableUniqueConstraintErrorCode {
  /** The activation job ran out of its wall-clock budget. */
  DDL_TIMEOUT = 'DDL_TIMEOUT',
  /** CREATE UNIQUE INDEX CONCURRENTLY failed for a reason other than a duplicate key. */
  INDEX_BUILD_FAILED = 'INDEX_BUILD_FAILED',
  /** The constraint's columns or scope no longer satisfy the eligibility rules. */
  INELIGIBLE = 'INELIGIBLE',
  /** The duplicate probe could not complete. */
  PROBE_FAILED = 'PROBE_FAILED',
}

export enum TableUniqueConstraintScope {
  PARENT = 'PARENT',
  TABLE = 'TABLE',
}

export enum TableUniqueConstraintStatus {
  ACTIVE = 'ACTIVE',
  BUILDING = 'BUILDING',
  CONFLICTED = 'CONFLICTED',
  DELETING = 'DELETING',
  ERROR = 'ERROR',
  VALIDATING = 'VALIDATING',
}

export type TablesInput = {
  fullViewAccess?: InputMaybe<Scalars['Boolean']>
  tableIds?: InputMaybe<Array<Scalars['ID']>>
}

export enum ToolRunStatus {
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}

/** A single tool call's information as a part of a run */
export type ToolRunStep = {
  __typename: 'ToolRunStep'
  /** The agent run that this tool run step is associated with */
  agentRun: AgentRun
  completedAt: Maybe<Scalars['DateTime']>
  /** The message provided to the user when user confirmation is required to execute the tool */
  confirmationMessage: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  events: Array<DossbotEvent>
  id: Scalars['ID']
  /** What the agent generated and passed to the tool */
  input: Scalars['JSONValue']
  /** The model specification used by this tool run, if the tool is non-deterministic */
  modelSpec: Maybe<ModelSpecification>
  /** What the tool returned */
  output: Maybe<Scalars['JSONValue']>
  status: ToolRunStatus
  /** The agent-generated ID of the tool call */
  toolCallId: Scalars['String']
  /** The name of the tool */
  toolName: Scalars['String']
  /** The optional reason provided by the user for rejecting the tool execution */
  userRejectionReason: Maybe<Scalars['String']>
}

export enum ToolUserResponse {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum TraceEngine {
  V1 = 'V1',
  V2 = 'V2',
}

export enum TraceNodeType {
  ACTIVITY_FEED_EVENT = 'ACTIVITY_FEED_EVENT',
  WORKFLOW_EXECUTION = 'WORKFLOW_EXECUTION',
}

/** The source a causal chain is assembled from. */
export enum TraceSource {
  /** execution_payloads and events, on the primary ClickHouse service */
  PRIMARY = 'PRIMARY',
  /** workflow_v2_payloads, on the workflows-v2 ClickHouse service */
  WORKFLOWS_V2 = 'WORKFLOWS_V2',
}

export type TransferIntegrationError = {
  __typename: 'TransferIntegrationError'
  error: Scalars['String']
  integrationId: Scalars['ID']
}

export type TransferIntegrationsResult = {
  __typename: 'TransferIntegrationsResult'
  failedIntegrationIds: Array<TransferIntegrationError>
  failedTransfers: Scalars['Int']
  success: Scalars['Boolean']
  successfulTransfers: Scalars['Int']
  totalIntegrations: Scalars['Int']
  transferredIntegrationIds: Array<Scalars['ID']>
}

export type TransferUserError = {
  __typename: 'TransferUserError'
  error: Scalars['String']
  userId: Scalars['ID']
}

export type TransferUsersResult = {
  __typename: 'TransferUsersResult'
  failedTransfers: Scalars['Int']
  failedUserIds: Array<TransferUserError>
  success: Scalars['Boolean']
  successfulTransfers: Scalars['Int']
  totalUsers: Scalars['Int']
  transferredUserIds: Array<Scalars['ID']>
}

/** Represents a triumvirate validation error for an action step */
export type TriumvirateError = {
  __typename: 'TriumvirateError'
  /** The ID of the action step that failed validation */
  actionStepId: Scalars['ID']
  /** The slug of the action step that failed validation */
  actionStepSlug: Scalars['String']
  /** The validation error message */
  message: Scalars['String']
  /** The type of validation message */
  type: TriumvirateValidationMessageType
}

/** A message posted by the Triumvirate validation process for an entity */
export type TriumvirateValidationMessage = {
  __typename: 'TriumvirateValidationMessage'
  /** The action that this validation message is associated with */
  action: Maybe<Action>
  /** The action auto trigger that this validation message is associated with */
  actionAutoTrigger: Maybe<ActionAutoTrigger>
  /** The action step that this validation message is associated with */
  actionStep: Maybe<ActionStep>
  /** The action step group that this validation message is associated with */
  actionStepGroup: Maybe<ActionStepGroup>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  /** The validation message text */
  message: Scalars['String']
  /** The type of the validation message */
  type: TriumvirateValidationMessageType
}

/**
 * The type of a validation message posted by the Triumvirate validation process for ActionSteps and
 * ActionAutoTriggers
 */
export enum TriumvirateValidationMessageType {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}

/**
 * Results from one authorization snapshot. Statement errors do not discard successful siblings, but
 * exceeding the batch's combined 4 MiB result limit fails the entire request.
 */
export type UdsSqlBatchResult = {
  __typename: 'UdsSqlBatchResult'
  statements: Array<UdsSqlStatementResult>
}

/**
 * Selects a result page. Omit cursor and offset on the first request; the server chooses the strongest
 * supported mode. Send the returned cursor or offset unchanged to request the next page.
 */
export type UdsSqlPageInput = {
  /** Opaque value returned by the previous keyset page. Cannot be combined with offset. */
  cursor?: InputMaybe<Scalars['String']>
  /** Maximum rows to return, up to the platform limit of 10,000 */
  limit: Scalars['Int']
  /** Zero-based position for offset pagination. Set to 0 to explicitly start in offset mode. */
  offset?: InputMaybe<Scalars['Int']>
}

/** One page returned by a read-only SQL query */
export type UdsSqlResult = {
  __typename: 'UdsSqlResult'
  /** Value to pass as page.cursor for the next page; null when unavailable */
  cursor: Maybe<Scalars['String']>
  /** Whether at least one more matching row exists */
  hasNext: Scalars['Boolean']
  /** Value to pass as page.offset for the next page; null when unavailable */
  offset: Maybe<Scalars['Int']>
  /** Size of the JSON-encoded rows in UTF-8 bytes */
  resultBytes: Scalars['Int']
  /** Rows in SQL result order, keyed by column name */
  rows: Array<Scalars['JSONObject']>
  /**
   * Total matching rows. Returned only when includeTotalCount is true. The query fails when the count
   * exceeds GraphQL's maximum Int value of 2,147,483,647.
   */
  totalCount: Maybe<Scalars['Int']>
}

/** Safe metadata returned for one failed SQL query */
export type UdsSqlStatementError = {
  __typename: 'UdsSqlStatementError'
  /** Stable error classification, when available */
  code: Maybe<Scalars['String']>
  /** Maximum result size in bytes, when the result was too large */
  limitBytes: Maybe<Scalars['Int']>
  /** Maximum allowed row count */
  maxRows: Maybe<Scalars['Int']>
  /** Readable error message */
  message: Scalars['String']
  /** Input whose requested row count exceeded its limit */
  parameter: Maybe<Scalars['String']>
  /** Requested row count */
  requestedRows: Maybe<Scalars['Int']>
  /** Measured result size in bytes, when the result was too large */
  resultBytes: Maybe<Scalars['Int']>
}

/** One read-only SQL query in a dashboard render */
export type UdsSqlStatementInput = {
  /** Whether to also count all matching rows. Requires page and runs an additional query. Default: false. */
  includeTotalCount?: InputMaybe<Scalars['Boolean']>
  /** Page to return. Omit to use the default page size. */
  page?: InputMaybe<UdsSqlPageInput>
  /** SQL query to run */
  sql: Scalars['String']
}

/** One statement outcome. Exactly one of result and error is present. */
export type UdsSqlStatementResult = {
  __typename: 'UdsSqlStatementResult'
  error: Maybe<UdsSqlStatementError>
  result: Maybe<UdsSqlResult>
}

/** An infrastructure (__doss_*) column exposed by the UDS SQL catalog for a table */
export type UdsSystemColumn = {
  __typename: 'UdsSystemColumn'
  /** PostgreSQL type name as reported by the UDS catalog */
  dataType: Scalars['String']
  /** Whether the UDS catalog reports the column as nullable */
  isNullable: Scalars['Boolean']
  /** User-facing slug, e.g. __doss_id */
  slug: Scalars['String']
}

export type UnshareFormV2Input = {
  formV2Id: Scalars['ID']
  /** Optional: specify which lookup tables to unshare when restricting access */
  unshareTableIds?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateActionInput = {
  actionId: Scalars['ID']
  alertSlack?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  order?: InputMaybe<Scalars['Int']>
  showNotification?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<ActionStatus>
}

/** Result of updating an action via JSON */
export type UpdateActionJsonResult = {
  __typename: 'UpdateActionJsonResult'
  /** The updated action */
  action: Action
  /** List of schema validation errors caught during triumvirate validation */
  schemaValidationErrors: Array<ActionJsonValidationError>
  /** List of triumvirate validation errors encountered during update */
  triumvirateErrors: Array<TriumvirateError>
}

export type UpdateButtonNodeInput = {
  buttonNodeId: Scalars['ID']
  /** Authored identity adoption is limited to the table's root node */
  logicalId?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
}

export type UpdateButtonTransitionInput = {
  logicExpression?: InputMaybe<ParentLogicExpressionInput>
  name?: InputMaybe<Scalars['String']>
  sourceNodeId?: InputMaybe<Scalars['ID']>
  targetNodeId?: InputMaybe<Scalars['ID']>
  transitionId: Scalars['ID']
}

export type UpdateChartInput = {
  aggregationColumns?: InputMaybe<Array<ChartAggregationColumnInput>>
  aggregationOperation?: InputMaybe<AggregationOperation>
  chartId: Scalars['ID']
  chartSubType: ChartSubType
  filters?: InputMaybe<Array<TableColumnFilterInput>>
  filtersBooleanOperator?: InputMaybe<BooleanOperator>
  groupBys?: InputMaybe<Array<CreateGroupByInput>>
  name: Scalars['String']
  thresholds?: InputMaybe<Array<Scalars['Float']>>
  xAxisColumnId?: InputMaybe<Scalars['ID']>
  yAxisColumnId?: InputMaybe<Scalars['ID']>
}

export type UpdateDocumentInput = {
  documentId: Scalars['ID']
  name: Scalars['String']
}

export type UpdateFormCategoryInput = {
  formCategoryId: Scalars['ID']
  isArray?: InputMaybe<Scalars['Boolean']>
  lookupTableId?: InputMaybe<Scalars['ID']>
  name?: InputMaybe<Scalars['String']>
  order?: InputMaybe<Scalars['Int']>
  unsharePreviousLookupTable?: InputMaybe<Scalars['Boolean']>
}

export type UpdateFormFieldInput = {
  defaultValue?: InputMaybe<Scalars['JSONObject']>
  description?: InputMaybe<Scalars['String']>
  displayImagesInline?: InputMaybe<Scalars['Boolean']>
  fieldOptions?: InputMaybe<Array<Scalars['String']>>
  formFieldId: Scalars['ID']
  isArray?: InputMaybe<Scalars['Boolean']>
  isEditable?: InputMaybe<Scalars['Boolean']>
  isFrozen?: InputMaybe<Scalars['Boolean']>
  isRequired?: InputMaybe<Scalars['Boolean']>
  isVisible?: InputMaybe<Scalars['Boolean']>
  lookupColumnId?: InputMaybe<Scalars['ID']>
  metadata?: InputMaybe<Scalars['JSONObject']>
  name?: InputMaybe<Scalars['String']>
  order?: InputMaybe<Scalars['Int']>
  type?: InputMaybe<FormFieldType>
}

export type UpdateFormInput = {
  actionTriggerIds?: InputMaybe<Array<Scalars['ID']>>
  formId: Scalars['ID']
  isShareable?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  redirectCustomPath?: InputMaybe<Scalars['String']>
  redirectTarget?: InputMaybe<FormRedirectTarget>
  unshareTableIds?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateFormInputBlockInput = {
  defaultValue?: InputMaybe<Scalars['JSONObject']>
  description?: InputMaybe<Scalars['String']>
  /** Provide the id of an existing lookup input group, if applicable */
  existingLookupInputGroupId?: InputMaybe<Scalars['ID']>
  formBlockId: Scalars['ID']
  /** Variant-specific format configuration whose shape depends on formatPreset. */
  formatOptions?: InputMaybe<Scalars['JSONObject']>
  /** Display-only number/date format preset. Pairs with formatOptions; must be cleared together. */
  formatPreset?: InputMaybe<FormatPreset>
  /** Provide the formula that computes this input's value, when inputType = FORMULA */
  formulaInput?: InputMaybe<ParentFormulaInput>
  inputMetadata?: InputMaybe<Scalars['JSONObject']>
  inputType?: InputMaybe<FormInputType>
  isAutoFill?: InputMaybe<Scalars['Boolean']>
  isFrozen?: InputMaybe<Scalars['Boolean']>
  isMultiSelect?: InputMaybe<Scalars['Boolean']>
  isReadOnly?: InputMaybe<Scalars['Boolean']>
  isRequired?: InputMaybe<Scalars['Boolean']>
  isVisible?: InputMaybe<Scalars['Boolean']>
  label?: InputMaybe<Scalars['String']>
  /** Provide the input for the lookup filter expression, if applicable */
  lookupFilterExpressionInput?: InputMaybe<ParentLogicExpressionInput>
  /** Provide the source table column for the lookup, if applicable */
  lookupTableColumnId?: InputMaybe<Scalars['ID']>
  /** Link this form input to a table column to auto-sync properties */
  sourceTableColumnId?: InputMaybe<Scalars['ID']>
  /** Provide any dynamic validation rules */
  validationRules: Array<FormValidationConditionInput>
  /** Provide any visibility conditions - either reference to existing by id or create a new one by value */
  visibilityConditions: Array<FormVisibilityConditionInput>
}

export type UpdateFormLayoutBlockInput = {
  formBlockId: Scalars['ID']
  formBlockMetadata?: InputMaybe<Scalars['JSONObject']>
  formBlockType: FormBlockType
  /** Provide any visibility conditions - either reference to existing by id or create a new one by value */
  visibilityConditions: Array<FormVisibilityConditionInput>
}

export type UpdateFormPageInput = {
  formPageId: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  order?: InputMaybe<Scalars['Int']>
}

export type UpdateFormTableBlockInput = {
  formBlockId: Scalars['ID']
  formInputGroupLabel?: InputMaybe<Scalars['String']>
  orderedChildBlockIds?: InputMaybe<Array<Scalars['ID']>>
  /** Provide any visibility conditions - either reference to existing by id or create a new one by value */
  visibilityConditions: Array<FormVisibilityConditionInput>
}

export type UpdateFormV2Input = {
  formV2Id: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  /** If redirectTarget = CUSTOM_PATH, this field stores the target path (e.g. '/projects/123/summary') */
  redirectCustomPath?: InputMaybe<Scalars['String']>
  /** Optional redirect behaviour after successful submission */
  redirectTarget?: InputMaybe<FormRedirectTarget>
}

export type UpdateFormVariantInput = {
  description?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  variantId: Scalars['ID']
}

export type UpdateFormVisibilityConditionInput = {
  expression: ParentLogicExpressionInput
  formVisibilityConditionId: Scalars['ID']
  name: Scalars['String']
}

export type UpdateIntegrationCredentialsInput = {
  integrationId: Scalars['ID']
  metadata?: InputMaybe<Scalars['JSONObject']>
  password?: InputMaybe<Scalars['String']>
  username?: InputMaybe<Scalars['String']>
}

export type UpdateIntegrationInput = {
  credentials?: InputMaybe<IntegrationCredentialInput>
  customMetadata?: InputMaybe<Scalars['JSONObject']>
  integrationId: Scalars['ID']
  isWebhookSubscriptionUpdate?: InputMaybe<Scalars['Boolean']>
  metadata?: InputMaybe<Scalars['JSONObject']>
}

export type UpdateObjectStoreTableSyncInput = {
  daysOfWeek?: InputMaybe<Array<Scalars['Int']>>
  filePattern?: InputMaybe<Scalars['String']>
  ignoreMissingColumns?: InputMaybe<Scalars['Boolean']>
  objectStoreTableSyncId: Scalars['ID']
  repeatNumber?: InputMaybe<Scalars['Int']>
  repeatUnit?: InputMaybe<CalendarUnit>
  startAt?: InputMaybe<Scalars['DateTime']>
}

export type UpdateRoleInput = {
  name?: InputMaybe<Scalars['String']>
  permissions?: InputMaybe<Array<PermissionInput>>
  roleId: Scalars['ID']
}

export type UpdateRoleTablePermissionsInput = {
  permissions?: InputMaybe<Array<PermissionInput>>
  roleId: Scalars['ID']
  tableId: Scalars['ID']
}

export type UpdateRowCurrentNodesInput = {
  buttonNodeIds: Array<Scalars['ID']>
  rowId: Scalars['ID']
}

export type UpdateTableCellInput = {
  data?: InputMaybe<Scalars['JSONObject']>
  documentIds?: InputMaybe<Array<Scalars['ID']>>
  id: Scalars['ID']
  lookupCellIds?: InputMaybe<Array<Scalars['ID']>>
  userIds?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateTableColumnFilterInput = {
  operand?: InputMaybe<Scalars['JSONObject']>
  operator?: InputMaybe<FilterOperator>
  systemGeneratedColumnType?: InputMaybe<SystemGeneratedTableColumnType>
  tableColumnFilterId: Scalars['ID']
  tableColumnId?: InputMaybe<Scalars['ID']>
}

export type UpdateTableColumnFiltersInput = {
  booleanOperator?: InputMaybe<BooleanOperator>
  filtersToCreate?: InputMaybe<Array<TableColumnFilterInput>>
  filtersToDelete?: InputMaybe<Array<Scalars['ID']>>
  filtersToUpdate?: InputMaybe<Array<UpdateTableColumnFilterInput>>
  tableTabId: Scalars['ID']
}

export type UpdateTableColumnGroupInput = {
  columns?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  tableColumnGroupId: Scalars['ID']
}

export type UpdateTableColumnInput = {
  description?: InputMaybe<Scalars['String']>
  displayImagesInline?: InputMaybe<Scalars['Boolean']>
  enumOptionInputs?: InputMaybe<Array<EnumOptionInput>>
  /** @deprecated Use enumOptionInputs, which also carries per-option color and order. */
  enumOptions?: InputMaybe<Array<Scalars['String']>>
  formatOptions?: InputMaybe<Scalars['JSONObject']>
  formatPreset?: InputMaybe<FormatPreset>
  /** For DataType = Formula, specify the input to create the associated formula */
  formula?: InputMaybe<ParentFormulaInput>
  indexAutogenerate?: InputMaybe<Scalars['Boolean']>
  indexPrefix?: InputMaybe<Scalars['String']>
  indexSuffix?: InputMaybe<Scalars['String']>
  indexType?: InputMaybe<IndexType>
  innerType?: InputMaybe<DataType>
  /** NUMBER columns only: read and written as an exact decimal by workflows-as-code. */
  isDecimal?: InputMaybe<Scalars['Boolean']>
  isNullable?: InputMaybe<Scalars['Boolean']>
  isReadOnly?: InputMaybe<Scalars['Boolean']>
  lookupBacklinkName?: InputMaybe<Scalars['String']>
  lookupColumnGroupId?: InputMaybe<Scalars['ID']>
  lookupColumnId?: InputMaybe<Scalars['ID']>
  lookupFilterExpression?: InputMaybe<ParentLogicExpressionInput>
  lookupTableId?: InputMaybe<Scalars['ID']>
  name?: InputMaybe<Scalars['String']>
  order?: InputMaybe<Scalars['Int']>
  showLookupBacklink?: InputMaybe<Scalars['Boolean']>
  tableColumnId: Scalars['ID']
  type?: InputMaybe<DataType>
}

export type UpdateTableColumnsVisibilityInput = {
  isVisible: Scalars['Boolean']
  tableColumnIds: Array<Scalars['ID']>
  tableId: Scalars['ID']
}

export type UpdateTableInput = {
  description?: InputMaybe<Scalars['String']>
  iconId?: InputMaybe<Scalars['ID']>
  name?: InputMaybe<Scalars['String']>
  showRowWorkspace?: InputMaybe<Scalars['Boolean']>
  tableId: Scalars['ID']
}

/** Result of updating a table via JSON */
export type UpdateTableJsonResult = {
  __typename: 'UpdateTableJsonResult'
  /** The updated table */
  table: Table
}

export type UpdateTableRowInput = {
  cells?: InputMaybe<Array<CreateOrUpdateTableCellInput>>
  tableRowId: Scalars['ID']
}

export type UpdateTableTabColumnInput = {
  isFrozen?: InputMaybe<Scalars['Boolean']>
  order?: InputMaybe<Scalars['Int']>
  tableColumnFilterId: Scalars['ID']
}

export type UpdateTableTabColumnsInput = {
  columnsToCreate?: InputMaybe<Array<TableTabColumnInput>>
  tabColumnIdsToDelete?: InputMaybe<Array<Scalars['ID']>>
  tableTabId: Scalars['ID']
}

export type UpdateTableTabInput = {
  booleanOperator?: InputMaybe<BooleanOperator>
  name?: InputMaybe<Scalars['String']>
  order?: InputMaybe<Scalars['Int']>
  tableTabId: Scalars['ID']
}

export type UpdateTableTabSortInput = {
  direction?: InputMaybe<SortDirection>
  systemGeneratedColumnType?: InputMaybe<SystemGeneratedTableColumnType>
  tableColumnId?: InputMaybe<Scalars['ID']>
  tableTabSortId: Scalars['ID']
}

export type UpdateTableTabSortsInput = {
  sortsToCreate?: InputMaybe<Array<TableTabSortInput>>
  tableTabId: Scalars['ID']
}

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']>
  id: Scalars['ID']
  lastName?: InputMaybe<Scalars['String']>
}

export type UpdateUserProfilePictureInput = {
  file: Scalars['FileInput']
}

export type UpdateUserRolesInput = {
  roleIds: Array<Scalars['ID']>
  userId: Scalars['ID']
}

export type UpdateVariantInputValueInput = {
  defaultValue?: InputMaybe<Scalars['JSONObject']>
  inputId: Scalars['ID']
  /** Override whether this input should be read-only in this variant */
  isReadOnly?: InputMaybe<Scalars['Boolean']>
  variantId: Scalars['ID']
}

export type UpdateViewInput = {
  /**
   * Internal only: place the view right after this view in its (new) parent workspace.
   * Every view after that one shifts down one.
   * Takes at most one of `order`, `insertBeforeViewId` and `insertAfterViewId`
   */
  insertAfterViewId?: InputMaybe<Scalars['ID']>
  /**
   * Internal only: place the view right before this view in its (new) parent workspace.
   * That view and every view after it shift down one.
   * Takes at most one of `order`, `insertBeforeViewId` and `insertAfterViewId`
   */
  insertBeforeViewId?: InputMaybe<Scalars['ID']>
  order?: InputMaybe<Scalars['Int']>
  /** Internal only: move the view to another workspace, at the end unless `order` is set */
  parentWorkspaceId?: InputMaybe<Scalars['ID']>
  properties?: InputMaybe<Scalars['JSONObject']>
  rowNumber?: InputMaybe<Scalars['Int']>
  unitHeight?: InputMaybe<Scalars['Int']>
  unitWidth?: InputMaybe<Scalars['Int']>
  viewId: Scalars['ID']
}

export type UpdateWorkspaceButtonInput = {
  buttonConfiguration?: InputMaybe<Scalars['JSONObject']>
  buttonNodeId?: InputMaybe<Scalars['ID']>
  confirmationMessage?: InputMaybe<Scalars['String']>
  formId?: InputMaybe<Scalars['ID']>
  formV2Id?: InputMaybe<Scalars['ID']>
  iconId?: InputMaybe<Scalars['ID']>
  manualTriggerId?: InputMaybe<Scalars['ID']>
  name?: InputMaybe<Scalars['String']>
  parentWorkspaceId?: InputMaybe<Scalars['ID']>
  requiresConfirmation?: InputMaybe<Scalars['Boolean']>
  /** Position among tracked siblings with a workflow or form destination */
  trackedPosition?: InputMaybe<Scalars['Int']>
  workspaceButtonId: Scalars['ID']
}

export type UpdateWorkspaceInput = {
  isReorder?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  newOrder?: InputMaybe<Scalars['Int']>
  newRowNumber?: InputMaybe<Scalars['Int']>
  /** Position among the organization's bound root workspaces */
  rootPosition?: InputMaybe<Scalars['Int']>
  viewIdToReorder?: InputMaybe<Scalars['ID']>
  viewPosition?: InputMaybe<WorkspaceViewPositionInput>
  /** The views to put first, in this order; unselected views follow in their current order */
  viewSequence?: InputMaybe<Array<WorkspaceViewSelectorInput>>
  views?: InputMaybe<Array<UpdateViewInput>>
  workspaceId: Scalars['ID']
}

export type UpdateWorkspaceRowHeightInput = {
  rowNumber: Scalars['Int']
  unitHeight: Scalars['Int']
  workspaceId: Scalars['ID']
}

/** Result of creating an action via JSON synchronously */
export type UploadActionJsonSyncResult = {
  __typename: 'UploadActionJsonSyncResult'
  /** The created action */
  action: Action
  /** IDs of action steps with invalid slug references */
  actionStepsWithInvalidIds: Array<Scalars['ID']>
  /** List of schema validation errors caught during triumvirate validation */
  schemaValidationErrors: Array<ActionJsonValidationError>
  /** List of triumvirate validation errors encountered during creation */
  triumvirateErrors: Array<TriumvirateError>
}

export type UploadTableDataCsvInput = {
  dateLocale: Scalars['String']
  delimiter: Scalars['String']
  file: Scalars['FileInput']
  numberLocale: Scalars['String']
  /** If this is a child table, specify the parent row ID to link the new rows to. */
  parentRowId?: InputMaybe<Scalars['ID']>
  tableId: Scalars['ID']
}

export type UpsertTableButtonTransitionInput = {
  logicExpression: ParentLogicExpressionInput
  name?: InputMaybe<Scalars['String']>
  sourceNodeId: Scalars['ID']
  targetNodeId: Scalars['ID']
}

export type UpsertViewContentInput = {
  /** The content bytes as text. */
  content: Scalars['String']
  /** Content format; defaults to react-tsx. Only applied when creating new content. */
  contentType?: InputMaybe<Scalars['String']>
  /** Omit to create new content (server mints the id); supply to append a version. Appending to content `doss deploy` manages is refused. */
  id?: InputMaybe<Scalars['ID']>
}

/**
 * A person who can log into Doss, independent of any organization.
 * Their access to each organization is a Membership.
 */
export type User = {
  __typename: 'User'
  email: Scalars['String']
  /** External auth provider user ID (e.g., WorkOS) for authentication lookup. */
  externalUserId: Maybe<Scalars['String']>
  firstName: Scalars['String']
  /** Access to every organization. Null means NONE. Set from web-admin. */
  globalAccess: Maybe<UserGlobalAccess>
  id: Scalars['ID']
  /** Indicates if this user is a Robopmo account for programmatic access */
  isRobopmoAccount: Maybe<Scalars['Boolean']>
  lastName: Scalars['String']
  locale: Maybe<Locale>
  /** The organizations this user belongs to */
  memberships: Array<Membership>
  orientation: ApplicationOrientation
  phoneNumber: Maybe<Scalars['String']>
  policiesAcceptedAt: Maybe<Scalars['DateTime']>
  /** ACTIVE if the user has at least one active membership. Computed from the memberships, not stored. */
  status: UserStatus
  timeZone: Scalars['String']
}

/** A person's access to every organization */
export enum UserGlobalAccess {
  GLOBAL_WRITE = 'GLOBAL_WRITE',
  NONE = 'NONE',
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

/** Result of validating an Action JSON payload */
export type ValidateActionJsonResult = {
  __typename: 'ValidateActionJsonResult'
  /** List of all validation errors and warnings found */
  errors: Array<ActionJsonValidationError>
  /** Whether the Action JSON is valid (no errors, warnings allowed) */
  isValid: Scalars['Boolean']
}

/** Result of validating a FormV2 JSON payload */
export type ValidateFormV2JsonResult = {
  __typename: 'ValidateFormV2JsonResult'
  /** List of all validation errors found */
  errors: Array<FormV2JsonValidationError>
  /** Whether the FormV2 JSON is valid (no errors) */
  isValid: Scalars['Boolean']
}

/** Result of validating a Table JSON payload */
export type ValidateTableJsonResult = {
  __typename: 'ValidateTableJsonResult'
  /** List of all validation errors found */
  errors: Array<TableJsonValidationError>
  /** Whether the Table JSON is valid (no errors) */
  isValid: Scalars['Boolean']
}

export type VariantInputValue = {
  defaultValue: Scalars['JSONObject']
  inputId: Scalars['ID']
  /** Override whether this input should be read-only in this variant */
  isReadOnly: Scalars['Boolean']
}

export type VerifyIntegrationRequestInput = {
  organizationId: Scalars['String']
  type: IntegrationType
  verificationParams: Scalars['JSONObject']
}

/** A View is an object that is visible in a workspace. */
export type View = {
  __typename: 'View'
  chart: Maybe<Chart>
  document: Maybe<Document>
  embed: Maybe<Embed>
  formV2: Maybe<FormV2>
  id: Scalars['ID']
  /** The global ordering of views in a workspace (no duplicate values should be allowed) */
  order: Scalars['Int']
  /** The workspace this view is contained in */
  parentWorkspace: Workspace
  /**
   * The row placement of the view in the workspace
   * If the parentWorkspace is a root workspace, it defaults to the value of order, since there is only one column
   */
  rowNumber: Scalars['Int']
  /** The object that this view corresponds to (exactly one must be set for a view) */
  table: Maybe<Table>
  tableRow: Maybe<TableRow>
  unitHeight: Scalars['Int']
  /** @deprecated New design will use order and rowNumber to infer flexible width */
  unitWidth: Scalars['Int']
  viewableObjectType: ViewableObjectType
  workspace: Maybe<Workspace>
}

/** An addressable, versioned piece of front-end content. Engine-agnostic (React, dashboards, etc.). */
export type ViewContent = {
  __typename: 'ViewContent'
  /** The pinned SDK patch's graph for the latest version, resolved in this deployment's SDK environment; null for legacy versions. */
  appSdkGraph: Maybe<Scalars['JSONObject']>
  /** Latest content bytes, resolved from the latest version's GCS object. Null if no version yet. */
  content: Maybe<Scalars['String']>
  /** SHA-256 of the latest version's stored compiled module bytes; null for legacy versions. */
  contentHash: Maybe<Scalars['String']>
  /** The content format, e.g. "react-tsx". Lets the store hold other formats later. */
  contentType: Scalars['String']
  /** Signed GCS URL for the latest content, mirroring Document.storageUrl. Null if no version yet. */
  contentUrl: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  id: Scalars['ID']
  /** Current version number; 0 until the first upload. A plain int pointer, not an FK. */
  latestVersion: Scalars['Int']
  /**
   * The app's logical id from its APP binding: the id the code declared for deployed content, or
   * the one minted from its embed's name for UI-authored content. Null for content the registry does
   * not know yet (predates it and not backfilled) or that no embed presents.
   */
  logicalId: Maybe<Scalars['String']>
  /** The organization that owns this content. */
  organization: Organization
  /** The latest version's exact SDK pin; null for legacy (UI-authored) versions. */
  sdkVersion: Maybe<Scalars['String']>
  /**
   * Supplied by the author at code writing time. Currently exists only when the ViewContent was
   * created through the CLI and `doss deploy`.
   */
  slug: Maybe<Scalars['String']>
  /** Current authoring representation marker, resolved from version metadata without reading source storage. */
  sourceSnapshotHash: Maybe<Scalars['String']>
  /** The latest version's deploy-resolved table mappings (`TableMappings`); null for versions from before apps carried them. */
  tableMappings: Maybe<Scalars['JSONObject']>
  updatedAt: Scalars['DateTime']
  /** Immutable stored versions of this content. */
  versions: Array<ViewContentVersion>
}

/**
 * Immutable metadata for one stored version of a ViewContent. Bytes live in GCS; `storagePath` is
 * unique — every version row owns exactly one object, never shared across orgs or versions. Org
 * duplication copies only the version named by `latestVersion` (with a freshly minted storagePath;
 * the dup job copies the bytes), so `latestVersion` is clamped to the max copied version.
 */
export type ViewContentVersion = {
  __typename: 'ViewContentVersion'
  /** The pinned SDK patch's graph, resolved in this deployment's SDK environment; null for legacy versions. */
  appSdkGraph: Maybe<Scalars['JSONObject']>
  /**
   * sha256 of the configbase snapshot this version was built from.
   * Null when the version was not deployed from a configbase.
   */
  configbaseHash: Maybe<Scalars['String']>
  /** Content bytes for this specific version, resolved from GCS on demand. */
  content: Maybe<Scalars['String']>
  /** sha256 of the deployed artifact. Null on versions stored as uncompiled source. */
  contentHash: Maybe<Scalars['String']>
  contentUrl: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  /** The user who authored this version, null if created by the system. */
  createdBy: Maybe<Membership>
  /** The author's user id (scalar convenience over the createdBy relation). */
  createdById: Maybe<Scalars['ID']>
  /** Logical ids of the endpoints this version's bundle calls. Null on versions from before apps could call endpoints. */
  endpoints: Maybe<Array<Scalars['String']>>
  id: Scalars['ID']
  /** The deploy-resolved table mappings (`TableMappings`) the frame boots with. Null on versions from before apps carried them. */
  mappings: Maybe<Scalars['JSONObject']>
  /** SDK version this version was built against. Null when it was authored in the UI. */
  sdkVersion: Maybe<Scalars['String']>
  sizeBytes: Scalars['Int']
  /** Persisted GCS object key, e.g. view-content/{orgId}/{viewContentId}/{version}. */
  storagePath: Scalars['String']
  /** Monotonic version number, unique per viewContentId. */
  version: Scalars['Int']
  /** The ViewContent this version belongs to. */
  viewContent: ViewContent
}

export type ViewInput = {
  order?: InputMaybe<Scalars['Int']>
  /** The workspace that this view is to be created in */
  parentWorkspaceId: Scalars['ID']
  rowNumber?: InputMaybe<Scalars['Int']>
  unitHeight?: InputMaybe<Scalars['Int']>
  unitWidth?: InputMaybe<Scalars['Int']>
}

export enum ViewableObjectType {
  CHART = 'CHART',
  DOCUMENT = 'DOCUMENT',
  EMBED = 'EMBED',
  FORM_V2 = 'FORM_V2',
  TABLE = 'TABLE',
  TABLE_ROW = 'TABLE_ROW',
  WORKSPACE = 'WORKSPACE',
}

/**
 * A workflow is a collection of actions made mostly as a visual abstraction for the user. Each action
 * still has its own unique triggers.
 */
export type Workflow = {
  __typename: 'Workflow'
  /** The actions that compose the workflow */
  actions: Array<Action>
  createdAt: Scalars['DateTime']
  description: Maybe<Scalars['String']>
  id: Scalars['ID']
  /** Determines if the workflow is visible to the user */
  isUserVisible: Scalars['Boolean']
  name: Scalars['String']
  /** The organization this workflow is part of */
  organization: Organization
  /** The slug of the workflow. This is automatically generated when the name is set. */
  slug: Scalars['String']
  status: WorkflowStatus
  updatedAt: Scalars['DateTime']
}

export enum WorkflowStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

/**
 * A code-defined workflow (Workflows V2), owned by an Organization and addressed by an org-unique
 * slug. Source bytes live in GCS (content-addressed artifact folders under
 * workflows-v2/<orgId>/<workflowV2Id>/sources/); these rows are only the version pointer.
 */
export type WorkflowV2 = {
  __typename: 'WorkflowV2'
  autoTriggers: Array<ActionAutoTrigger>
  diagnostics: Array<WorkflowV2Diagnostic>
  /**
   * Whether the workflow may run. Disabling stops its frequency schedules and short-circuits
   * auto/manual dispatch before anything reaches the interpreter; deploys to a disabled workflow
   * still sync trigger rows without starting schedules.
   */
  enabled: Scalars['Boolean']
  frequencyTriggers: Array<ActionFrequencyTrigger>
  id: Scalars['ID']
  /** One-line summary for the runtime failure; the diagnostics carry the detail. */
  invalidReason: Maybe<Scalars['String']>
  /**
   * Set only when enforcement is on: the interpreter refuses to run a workflow with this set, so it
   * is deliberately separate from the verdict. A workflow can be INVALID with this null, meaning the
   * verdict was reached while enforcement was disabled.
   */
  invalidatedAt: Maybe<Scalars['DateTime']>
  /** When that verification ran, whatever its verdict. */
  lastVerifiedAt: Maybe<Scalars['DateTime']>
  /** The version new executions pin at dispatch; repointed atomically on publish. */
  latestVersion: Maybe<WorkflowV2Version>
  /** The WORKFLOW binding's authored identity; null when no binding exists. */
  logicalId: Maybe<Scalars['String']>
  manualTriggers: Array<ActionManualTrigger>
  /** Authoritative tenancy — WorkflowV2 has no relation to Action or Workflow. */
  organization: Organization
  /** Org-unique authoring address; GCS paths key by id, so slug renames never orphan bytes. */
  slug: Scalars['String']
  /**
   * Result of the last re-check of latestVersion against the organization's current schema. Null
   * until a verification has run. A verdict is a cache: it is always recomputable from the version's
   * source snapshot plus the live org.
   */
  verificationStatus: Maybe<WorkflowV2VerificationStatus>
  versions: Array<WorkflowV2Version>
}

/**
 * One diagnostic from the last verification of a WorkflowV2. Rewritten wholesale per verification —
 * these describe the current version only, so there is no history to keep.
 */
export type WorkflowV2Diagnostic = {
  __typename: 'WorkflowV2Diagnostic'
  /** `WAC####` for our own rules, `TS####` for a surfaced TypeScript diagnostic. */
  code: Scalars['String']
  /**
   * The organization entities this diagnostic is about, as [{ entityType, entityId }], so the UI can
   * link through to them. Null when nothing could be resolved.
   */
  entityRefs: Maybe<Scalars['JSONValue']>
  id: Scalars['ID']
  message: Scalars['String']
  severity: WorkflowV2DiagnosticSeverity
  source: WorkflowV2DiagnosticSource
  spanColumn: Maybe<Scalars['Int']>
  spanEnd: Maybe<Scalars['Int']>
  /** Configbase-relative path; null for a project-level diagnostic with no span. */
  spanFile: Maybe<Scalars['String']>
  /** 1-based, for display. */
  spanLine: Maybe<Scalars['Int']>
  /** 0-based character offsets into the file. */
  spanStart: Maybe<Scalars['Int']>
  workflowV2: WorkflowV2
}

export enum WorkflowV2DiagnosticSeverity {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}

/** Which engine produced a diagnostic — for filtering and display, never for semantics. */
export enum WorkflowV2DiagnosticSource {
  DOSS = 'DOSS',
  ESLINT = 'ESLINT',
  TSC = 'TSC',
}

/**
 * One keyed fire of a workflow's manual trigger, kept for 24 hours so a repeat under the same key is
 * dropped instead of running again. Scoped to the workflow, not its version, so a repeat across a
 * redeploy is dropped too. Dispatch claims the row before it sends the run. A repeat that finds it
 * CLAIMED re-sends under the stored executionId, which Restate dedupes; one that finds it SENT is
 * dropped. An expired row under the same key is taken over by the next fire, and a daily sweeper
 * deletes the rest. Nothing archives or replicates them.
 */
export type WorkflowV2IdempotencyKey = {
  __typename: 'WorkflowV2IdempotencyKey'
  /** The execution the first fire dispatched: its run's Restate idempotency key, which a repeat re-sends under. */
  executionId: Scalars['ID']
  /** The retention's end, 24 hours from the claim. */
  expiresAt: Scalars['DateTime']
  id: Scalars['ID']
  /** Canonical hash of the input the key was first fired with; a different input under the same key is rejected. */
  inputHash: Scalars['String']
  /** The fire's key, read off its input at the path the manual trigger declares. */
  key: Scalars['String']
  /** CLAIMED from the claim until the send lands; SENT after. */
  status: WorkflowV2IdempotencyKeyStatus
  workflowV2: WorkflowV2
}

/** Whether a keyed fire's run has reached Restate: a claimed key may still be sending, a sent one drops a repeat. */
export enum WorkflowV2IdempotencyKeyStatus {
  CLAIMED = 'CLAIMED',
  SENT = 'SENT',
}

/** Verdict of re-checking a WorkflowV2's current version against the live organization. */
export enum WorkflowV2VerificationStatus {
  /** Does not compile. `diagnostics` holds the errors. */
  INVALID = 'INVALID',
  /**
   * Pinned to a compiler or shim major the server no longer re-checks against, so no verdict can be
   * reached without redeploying. Neither valid nor invalid.
   */
  NEEDS_MIGRATION = 'NEEDS_MIGRATION',
  /** Deployed before source snapshots existed, so there is nothing to re-check. */
  SKIPPED_NO_SOURCE = 'SKIPPED_NO_SOURCE',
  /** Compiles against the organization as it is now. */
  VERIFIED = 'VERIFIED',
}

/**
 * Immutable deployed build of one WorkflowV2. Publishing inserts a version and repoints
 * latestVersion in one transaction; rows are never mutated. In-flight executions stay pinned to
 * the contentHash they journaled at dispatch.
 */
export type WorkflowV2Version = {
  __typename: 'WorkflowV2Version'
  /**
   * Compiler version this source was checked by, semver. A MAJOR bump means the compiler may report a
   * diagnostic on source that previously passed, so re-checking across one proves nothing and the
   * version is reported NEEDS_MIGRATION instead. Null on versions published before the pin existed.
   */
  compilerVersion: Maybe<Scalars['String']>
  /** sha256 of the configbase snapshot manifest this version was built from (workflows-v2/<orgId>/snapshots/<hash>.json in GCS); null on versions deployed before source snapshots existed. */
  configbaseHash: Maybe<Scalars['String']>
  /** sha256 of manifest.json — the content address of the deployment bundle (manifest carries hashes for out.js and the shim). */
  contentHash: Scalars['String']
  createdAt: Scalars['DateTime']
  createdBy: Maybe<Membership>
  /** Engine provenance (constant v1 — the engine is version-agnostic). */
  engineVersion: Scalars['String']
  id: Scalars['ID']
  /** Set on the WorkflowV2 whose latestVersion points here. */
  latestOf: Maybe<WorkflowV2>
  /**
   * sha256 of the resolved mappings this version was published with. The only durable record that a
   * re-resolution rewrote mappings.json, which is otherwise overwritten in place at the same
   * contentHash; also what lets the runtime cache that object.
   */
  mappingsHash: Maybe<Scalars['String']>
  /** sha256 of the shim bytes — verified at fetch so a version label can never alias different bytes. */
  shimHash: Scalars['String']
  /** Guest shim version this source was bundled against. */
  shimVersion: Scalars['String']
  /**
   * sha256 of out.js.map, the debug map beside the bundle. Outside contentHash and rewritten on every
   * deploy of this content: the map follows the authored source (a sibling's edit moves lines), the
   * bundle does not. Null on versions published before the map left the manifest.
   */
  sourceMapHash: Maybe<Scalars['String']>
  /** Monotonic per WorkflowV2. */
  version: Scalars['Int']
  workflowV2: WorkflowV2
}

/** The org's app catalog — the containment typegen recipe's source for `workspaces/apps.ts` */
export type WorkflowsV2AppsManifest = {
  __typename: 'WorkflowsV2AppsManifest'
  /**
   * The logical id of every app deployed to the organization that the caller may see, sorted. An app's
   * logical id is what it declares with `application('<id>')`. Empty — not an error — for a caller who
   * cannot read embeds, so a pull without embed access simply renders no app handles.
   */
  logicalIds: Array<Scalars['String']>
}

/** One workflow's or endpoint's built artifacts, exactly as `doss build` wrote them */
export type WorkflowsV2ArtifactInput = {
  /** The build manifest (manifest.json), verbatim bytes */
  manifestJson: Scalars['String']
  /** The exact org-unique logical id declared at workflow('…') / endpoint('…') */
  name: Scalars['String']
  /** The compiled bundle (out.js) — accepted as-is, the server never compiles */
  outJs: Scalars['String']
  /** The bundle's external source map (out.js.map) — hash-pinned in the manifest, fetched at failure time to map guest stacks */
  sourceMap: Scalars['String']
}

/** One doss.json defaultConnections entry: the connection a provider's <TYPE>_DEFAULT names */
export type WorkflowsV2DefaultConnectionInput = {
  /** camelCase provider namespace (e.g. tiktokShop) */
  provider: Scalars['String']
  /** The pinned connection slug */
  slug: Scalars['String']
}

/** Input for querying comprehension graph dependencies */
export type WorkflowsV2DependentsInput = {
  entityId: Scalars['ID']
  entityType: ComprehensionEntityType
  organizationId: Scalars['ID']
}

/** A single planned deploy step */
export type WorkflowsV2DeployAction = {
  __typename: 'WorkflowsV2DeployAction'
  detail: Scalars['JSONObject']
  kind: WorkflowsV2DeployActionKind
  /** The workflow or endpoint logical id the step targets */
  workflow: Scalars['String']
}

export enum WorkflowsV2DeployActionKind {
  ENDPOINT_CREATE = 'ENDPOINT_CREATE',
  ENDPOINT_DESTROY = 'ENDPOINT_DESTROY',
  ENDPOINT_NOOP = 'ENDPOINT_NOOP',
  ENDPOINT_ORPHANED = 'ENDPOINT_ORPHANED',
  ENDPOINT_PUBLISH = 'ENDPOINT_PUBLISH',
  TRIGGER_CREATE = 'TRIGGER_CREATE',
  TRIGGER_DESTROY = 'TRIGGER_DESTROY',
  TRIGGER_NOOP = 'TRIGGER_NOOP',
  TRIGGER_ORPHANED = 'TRIGGER_ORPHANED',
  TRIGGER_UPDATE = 'TRIGGER_UPDATE',
  WORKFLOW_CREATE = 'WORKFLOW_CREATE',
  WORKFLOW_DESTROY = 'WORKFLOW_DESTROY',
  WORKFLOW_NOOP = 'WORKFLOW_NOOP',
  WORKFLOW_ORPHANED = 'WORKFLOW_ORPHANED',
  WORKFLOW_PUBLISH = 'WORKFLOW_PUBLISH',
}

/** A deploy finding. A WARNING is advisory and leaves the action list intact; anything else blocks. */
export type WorkflowsV2DeployDiagnostic = {
  __typename: 'WorkflowsV2DeployDiagnostic'
  code: WorkflowsV2DeployDiagnosticCode
  message: Scalars['String']
  /** WARNING is advisory — the deploy still applies; ERROR empties the action list. */
  severity: WorkflowV2DiagnosticSeverity
  /** The workflow or endpoint logical id, or null for project-level findings */
  workflow: Maybe<Scalars['String']>
}

export enum WorkflowsV2DeployDiagnosticCode {
  ARTIFACT_UNLOADABLE = 'ARTIFACT_UNLOADABLE',
  ENDPOINT_IN_USE = 'ENDPOINT_IN_USE',
  INVALID_ENDPOINT = 'INVALID_ENDPOINT',
  INVALID_TRIGGER = 'INVALID_TRIGGER',
  INVALID_WORKFLOW = 'INVALID_WORKFLOW',
  KIND_DRIFT = 'KIND_DRIFT',
  MANIFEST_INVALID = 'MANIFEST_INVALID',
  PLAN_CHANGED = 'PLAN_CHANGED',
  SHIM_STALE = 'SHIM_STALE',
  SNAPSHOT_INCOMPLETE = 'SNAPSHOT_INCOMPLETE',
  SNAPSHOT_INVALID = 'SNAPSHOT_INVALID',
  UNRESOLVED_COLUMN = 'UNRESOLVED_COLUMN',
  UNRESOLVED_CONNECTION = 'UNRESOLVED_CONNECTION',
  UNRESOLVED_ENDPOINT = 'UNRESOLVED_ENDPOINT',
  UNRESOLVED_FORM = 'UNRESOLVED_FORM',
  UNRESOLVED_TABLE = 'UNRESOLVED_TABLE',
}

export type WorkflowsV2DeployInput = {
  /** Permit WORKFLOW_DESTROY and ENDPOINT_DESTROY actions for configbase-absent definitions */
  allowDestructive?: InputMaybe<Scalars['Boolean']>
  /** The selection: endpoints to deploy (absent from CLIs predating endpoints) */
  endpoints?: InputMaybe<Array<WorkflowsV2ArtifactInput>>
  /** Every endpoint identity in the configbase; absent means no opinion — nothing is orphaned or destroyed */
  presentEndpoints?: InputMaybe<Array<Scalars['String']>>
  /** Every workflow identity in the configbase — keeps orphan detection correct under a filtered selection */
  presentWorkflows: Array<Scalars['String']>
  /** The configbase's pinned shim version; deploy requires the platform's latest */
  shimVersion: Scalars['String']
  /** The configbase source snapshot; absent on deploys from CLIs predating source snapshots */
  snapshot?: InputMaybe<WorkflowsV2SnapshotInput>
  /** The selection: workflows to deploy */
  workflows: Array<WorkflowsV2ArtifactInput>
}

/** One executed action's outcome; failures do not halt later actions — re-running converges */
export type WorkflowsV2DeployOutcome = {
  __typename: 'WorkflowsV2DeployOutcome'
  kind: WorkflowsV2DeployActionKind
  message: Maybe<Scalars['String']>
  status: WorkflowsV2DeployOutcomeStatus
  workflow: Scalars['String']
}

export enum WorkflowsV2DeployOutcomeStatus {
  APPLIED = 'APPLIED',
  FAILED = 'FAILED',
}

/** What a deploy would do — apply executes exactly this plan or refuses */
export type WorkflowsV2DeployPlan = {
  __typename: 'WorkflowsV2DeployPlan'
  actions: Array<WorkflowsV2DeployAction>
  diagnostics: Array<WorkflowsV2DeployDiagnostic>
  planHash: Scalars['String']
  shimVersion: Scalars['String']
}

export type WorkflowsV2DeployResult = {
  __typename: 'WorkflowsV2DeployResult'
  outcomes: Array<WorkflowsV2DeployOutcome>
  plan: WorkflowsV2DeployPlan
}

/** One deployed source file, configbase-relative — the bytes `doss pull` writes to disk */
export type WorkflowsV2DeployedSourceFile = {
  __typename: 'WorkflowsV2DeployedSourceFile'
  contents: Scalars['String']
  path: Scalars['String']
}

/** One FormV2 form of the org's forms manifest */
export type WorkflowsV2Form = {
  __typename: 'WorkflowsV2Form'
  groups: Array<WorkflowsV2FormInputGroup>
  id: Scalars['ID']
  /** Inputs that are not part of a group */
  inputs: Array<WorkflowsV2FormInput>
  name: Scalars['String']
  slug: Scalars['String']
}

/** One FormV2 input of the org's forms manifest — the forms typegen recipe's vocabulary */
export type WorkflowsV2FormInput = {
  __typename: 'WorkflowsV2FormInput'
  dataType: DataType
  description: Maybe<Scalars['String']>
  /** Enum options mirrored from the input's source column; null when not enum-typed */
  enumOptions: Maybe<Array<Scalars['String']>>
  id: Scalars['ID']
  innerDataType: Maybe<DataType>
  isRequired: Scalars['Boolean']
  label: Scalars['String']
  /**
   * When the bound column is ITSELF a lookup, the table its chain ultimately resolves to — what
   * the platform reports as the pick's resolved leaf. Null when the bound column is not a lookup,
   * in which case the leaf is the picked row itself.
   */
  lookupResolvedTableId: Maybe<Scalars['ID']>
  /** The table a lookup-backed input references rows of; null for every other input */
  lookupTableId: Maybe<Scalars['ID']>
  /**
   * The kind of the column a lookup-backed input is bound to — the type of the value each pick
   * delivers. Null for every other input.
   */
  lookupValueDataType: Maybe<DataType>
  /** Enum cases of that bound column, when it is enum-typed */
  lookupValueEnumOptions: Maybe<Array<Scalars['String']>>
  slug: Scalars['String']
}

/** A repeating group of form inputs */
export type WorkflowsV2FormInputGroup = {
  __typename: 'WorkflowsV2FormInputGroup'
  id: Scalars['ID']
  inputs: Array<WorkflowsV2FormInput>
  label: Scalars['String']
  slug: Scalars['String']
}

/** The org's FormV2 manifest: every form with its typed inputs */
export type WorkflowsV2FormsManifest = {
  __typename: 'WorkflowsV2FormsManifest'
  forms: Array<WorkflowsV2Form>
}

/** One entity's supported ops for a provider */
export type WorkflowsV2IntegrationEntity = {
  __typename: 'WorkflowsV2IntegrationEntity'
  /** The exact SCREAMING_SNAKE wire enum (e.g. ORDERS) */
  entity: Scalars['String']
  /** camelCase entity key used to build method names (e.g. orders) */
  entityKey: Scalars['String']
  read: Maybe<WorkflowsV2IntegrationRead>
  writes: Array<WorkflowsV2IntegrationWrite>
}

/** One webhook event a provider can fire */
export type WorkflowsV2IntegrationEvent = {
  __typename: 'WorkflowsV2IntegrationEvent'
  /** The topic's body schema (RJSF fragment); null when the provider does not type it */
  payload: Maybe<Scalars['JSONObject']>
  /** Whether a trigger on this event can name one connection; false where the platform matches every connection regardless */
  supportsConnection: Scalars['Boolean']
  /** The exact wire topic (e.g. orders/create) */
  topic: Scalars['String']
  /** The platform auto-trigger type that fires it (e.g. SHOPIFY_WEBHOOK) */
  triggerType: Scalars['String']
}

/** One connected provider's whole surface for the calling user's organization */
export type WorkflowsV2IntegrationProvider = {
  __typename: 'WorkflowsV2IntegrationProvider'
  /** The metadata field name identifying one connection of this type (e.g. shopUrl); null when the platform curates none for it */
  connectionIdentifier: Maybe<Scalars['String']>
  /** The connection slug doss.json pins as this provider's default; null when unpinned */
  defaultConnection: Maybe<Scalars['String']>
  entities: Array<WorkflowsV2IntegrationEntity>
  /** The provider's webhook events; empty when the provider fires none */
  events: Array<WorkflowsV2IntegrationEvent>
  /** The exact SCREAMING_SNAKE integration type enum (e.g. AMAZON_SELLER) */
  integrationType: Scalars['String']
  /** camelCase provider namespace the author calls (e.g. amazonSeller) */
  namespace: Scalars['String']
  /** This org's connection slugs for this integration type */
  slugs: Array<Scalars['String']>
}

/** One read op's org-resolved schemas (RJSF fragments; null when unresolvable) */
export type WorkflowsV2IntegrationRead = {
  __typename: 'WorkflowsV2IntegrationRead'
  input: Maybe<Scalars['JSONObject']>
  output: Maybe<Scalars['JSONObject']>
}

/** One write op's org-resolved schemas */
export type WorkflowsV2IntegrationWrite = {
  __typename: 'WorkflowsV2IntegrationWrite'
  input: Maybe<Scalars['JSONObject']>
  mode: Scalars['String']
  output: Maybe<Scalars['JSONObject']>
}

/** The org's integrations manifest: connected providers, their ops, and org-resolved schemas */
export type WorkflowsV2IntegrationsManifest = {
  __typename: 'WorkflowsV2IntegrationsManifest'
  providers: Array<WorkflowsV2IntegrationProvider>
}

/** A platform entity (User, Document, Role) exposed to authoring, and the columns it exposes */
export type WorkflowsV2PlatformObject = {
  __typename: 'WorkflowsV2PlatformObject'
  columns: Array<WorkflowsV2PlatformObjectColumn>
  name: Scalars['String']
}

/** One exposed column of a platform object */
export type WorkflowsV2PlatformObjectColumn = {
  __typename: 'WorkflowsV2PlatformObjectColumn'
  /** Cases mirrored from the platform enum behind this column; null for every other kind */
  enumCases: Maybe<Array<Scalars['String']>>
  /** The column kind: string | number | boolean | datetime | enum */
  kind: Scalars['String']
  name: Scalars['String']
  nullable: Scalars['Boolean']
}

/**
 * The platform objects available to authoring. Resolved server-side from the platform-object
 * selection, which is type-checked against the underlying models — so the wire carries resolved
 * column specs rather than names, and exposing an object differently per organization later needs
 * no change here.
 */
export type WorkflowsV2PlatformObjectsManifest = {
  __typename: 'WorkflowsV2PlatformObjectsManifest'
  objects: Array<WorkflowsV2PlatformObject>
}

/** The published WaC shim release: version, content hashes, and the doss.d.ts authoring contract */
export type WorkflowsV2Shim = {
  __typename: 'WorkflowsV2Shim'
  /** Complete ESM App graph for this patch, null for historical Workflow-only patches */
  appSdk: Maybe<Scalars['JSONObject']>
  /** The `doss` package (guest runtime + doss/testing) as canonical JSON: { format, files } */
  dossPackage: Scalars['String']
  /** sha256 of `dossPackage` */
  dossPackageHash: Scalars['String']
  dts: Scalars['String']
  dtsHash: Scalars['String']
  shimHash: Scalars['String']
  version: Scalars['String']
}

/** One configbase file reference: its root-relative path and the sha256 of its bytes */
export type WorkflowsV2SnapshotFileInput = {
  /** sha256 hex digest of the file's UTF-8 bytes */
  hash: Scalars['String']
  /** Configbase-relative posix path (doss.json or a .ts file under a layout directory) */
  path: Scalars['String']
}

/** The configbase source snapshot this deploy was built from */
export type WorkflowsV2SnapshotInput = {
  /** Every file in the configbase, path → hash; the bytes must already be uploaded */
  files: Array<WorkflowsV2SnapshotFileInput>
}

/** One source file's bytes for the org's content-addressed source store */
export type WorkflowsV2SourceFileInput = {
  /** The file's UTF-8 contents */
  contents: Scalars['String']
  /** sha256 hex digest of contents — verified server-side before the write */
  hash: Scalars['String']
}

export type WorkflowsV2TriggerInput = {
  /** The trigger's `data` payload as JSON — the general case; server wraps it with the resolved slug/kind */
  dataJson?: InputMaybe<Scalars['String']>
  /** Convenience for table triggers: a row id the server fetches and shapes into `data.row` */
  rowId?: InputMaybe<Scalars['String']>
  /** Which trigger to fire; optional when the workflow declares exactly one */
  triggerSlug?: InputMaybe<Scalars['String']>
  /** The workflow (directory / slug) to fire */
  workflowSlug: Scalars['String']
}

export type WorkflowsV2TriggerResult = {
  __typename: 'WorkflowsV2TriggerResult'
  /** The dispatched interpreter execution (virtual-object key) */
  executionId: Scalars['String']
}

/** Generated TS for the calling user's organization, rendered against the current shim */
export type WorkflowsV2Typegen = {
  __typename: 'WorkflowsV2Typegen'
  recipes: Array<WorkflowsV2TypegenRecipe>
  shimVersion: Scalars['String']
}

/** One generated file of a typegen recipe, configbase-relative */
export type WorkflowsV2TypegenFile = {
  __typename: 'WorkflowsV2TypegenFile'
  contents: Scalars['String']
  path: Scalars['String']
}

/** One typegen recipe's rendered output */
export type WorkflowsV2TypegenRecipe = {
  __typename: 'WorkflowsV2TypegenRecipe'
  files: Array<WorkflowsV2TypegenFile>
  name: Scalars['String']
  /** Messages naming what the recipe left out of its files */
  warnings: Array<Scalars['String']>
}

/** A workspace is a collection of views and actions */
export type Workspace = {
  __typename: 'Workspace'
  /** All the clickable header actions for a workspace */
  actionButtons: Array<WorkspaceButton>
  chart: Maybe<Chart>
  comments: Array<Comment>
  createdAt: Scalars['DateTime']
  /** The user that created this workspace, null if created by the system or before property was added */
  createdBy: Maybe<Membership>
  /** Deprecated: The user string ID is now a UUID */
  createdById_deprecated: Maybe<Scalars['String']>
  document: Maybe<Document>
  id: Scalars['ID']
  /** The views backed by (pointing to) this workspace */
  linkedViews: Array<View>
  /**
   * The container's logical id from its logical binding: a ROOT_WORKSPACE binding for an
   * organization-parented workspace, a DASHBOARD binding for a nested one. Null for a workspace that
   * is neither a container (a table's, chart's, row's or document's own surface carries no container
   * identity) or that the binding registry does not know yet (predates it and not backfilled).
   */
  logicalId: Maybe<Scalars['String']>
  /** The optionally defined name of the workspace, shown when the workspace is visible via a view */
  name: Maybe<Scalars['String']>
  /** Sort position among the organization's root workspaces. Null for nested workspaces. */
  order: Maybe<Scalars['Int']>
  /** The organization that this workspace belongs to */
  organization: Organization
  /** The name and id/type of the primary object associated with the workspace (null if the workspace has no root object) */
  parentObject: Maybe<WorkspaceParentObject>
  /**
   * Set only on root (top-level) workspaces: the organization is this workspace's parent.
   * Null for nested workspaces, whose parent is a View. Replaces the Project wrapper row.
   * NO_ACTION never fires (organizationId already blocks org deletion); it is chosen so both
   * FKs from Workspace to Organization agree.
   */
  parentOrganization: Maybe<Organization>
  /** The permissions that control access to this workspace */
  permissions: Array<Permission>
  /** The view created with a nested workspace; only populated on creation results */
  placingViewId: Maybe<Scalars['ID']>
  /** The slug of the workspace. This is automatically generated when the name is set. */
  slug: Maybe<Scalars['String']>
  /**
   * The primary object associated with this Workspace (exactly one must be set
   * for a workspace)
   */
  table: Maybe<Table>
  tableRow: Maybe<TableRow>
  updatedAt: Scalars['DateTime']
  updatedBy: Maybe<Membership>
  updatedById_deprecated: Maybe<Scalars['String']>
  /** All the views contained in this workspace */
  views: Array<View>
}

/**
 * Similar to a View but for buttons in a workspace. Executes the manual trigger or opens the form,
 * whichever is defined.
 */
export type WorkspaceButton = {
  __typename: 'WorkspaceButton'
  /** Stores the styling details about the button. For now, just has property colorVariant */
  buttonConfiguration: Maybe<Scalars['JSONObject']>
  /** The button node this button belongs to. */
  buttonNode: Maybe<TableButtonNode>
  /** The text to display within the confirmation dialog */
  confirmationMessage: Maybe<Scalars['String']>
  form: Maybe<Form>
  formV2: Maybe<FormV2>
  /** If set, opening this form will use the specified variant's pre-filled values */
  formVariant: Maybe<FormVariant>
  /** Optional icon associated with the workspace button */
  icon: Maybe<Icon>
  id: Scalars['ID']
  /**
   * The button's logical id: the authored identifier from its logical binding, scoped to the
   * container, table or state that places it. Null for a button the binding registry does not know yet
   * (created before the registry and not backfilled).
   */
  logicalId: Maybe<Scalars['String']>
  manualTrigger: Maybe<ActionManualTrigger>
  name: Scalars['String']
  order: Scalars['Int']
  /** The workspace this button is contained in */
  parentWorkspace: Maybe<Workspace>
  /** Table rows where this button is currently running/processing */
  processingRows: Array<TableRow>
  requiresConfirmation: Scalars['Boolean']
}

export type WorkspaceDeletionProgress = {
  __typename: 'WorkspaceDeletionProgress'
  completedCount: Scalars['Int']
  objectId: Scalars['ID']
  totalCount: Scalars['Int']
}

export type WorkspaceParentObject = {
  __typename: 'WorkspaceParentObject'
  name: Scalars['String']
  objectId: Scalars['String']
  objectType: BreadcrumbObjectType
}

export type WorkspaceViewPositionInput = {
  /** Position among the workspace's authored view kinds; runtime views keep their places */
  authoredIndex: Scalars['Int']
  viewId: Scalars['ID']
}

export type WorkspaceViewSelectorInput = {
  kind: ViewableObjectType
  /** The shown object; for EMBED, its ViewContent id */
  objectId: Scalars['ID']
}

/** Workspace with all its child workspaces */
export type WorkspaceWithChildren = {
  __typename: 'WorkspaceWithChildren'
  childWorkspaces: Array<Workspace>
  workspace: Workspace
}

/** Z-table cell data with embedded column info for display */
export type ZTableCell = {
  __typename: 'ZTableCell'
  columnId: Scalars['ID']
  /** Column name for display label */
  columnName: Scalars['String']
  /** Column order for sorting */
  columnOrder: Scalars['Int']
  /** Column type for display formatting */
  columnType: DataType
  data: Maybe<Scalars['JSONObject']>
  formattedValue: Maybe<Scalars['String']>
  id: Scalars['ID']
  lookupCells: Array<ZTableLookupCell>
}

/** Z-table lookup cell reference */
export type ZTableLookupCell = {
  __typename: 'ZTableLookupCell'
  columnId: Scalars['ID']
  id: Scalars['ID']
  rowId: Scalars['ID']
}

/** Z-table row data */
export type ZTableRow = {
  __typename: 'ZTableRow'
  cells: Array<ZTableCell>
  createdAt: Scalars['String']
  id: Scalars['ID']
  parentRowId: Maybe<Scalars['ID']>
  /** Table ID this row belongs to */
  tableId: Scalars['ID']
  /** Table name for display */
  tableName: Scalars['String']
}

/** Z-table row with child rows for detail view */
export type ZTableRowDetail = {
  __typename: 'ZTableRowDetail'
  cells: Array<ZTableCell>
  /** Child rows of this row (from child tables) */
  childRows: Array<ZTableRow>
  createdAt: Scalars['String']
  id: Scalars['ID']
  parentRowId: Maybe<Scalars['ID']>
  /** Table ID this row belongs to */
  tableId: Scalars['ID']
  /** Table name for display */
  tableName: Scalars['String']
}

export type RenderErrorBoundaryTestRolesQueryVariables = Exact<{ [key: string]: never }>

export type RenderErrorBoundaryTestRolesQuery = {
  __typename: 'Query'
  roles: Array<{ __typename: 'Role'; id: ID }>
}

export type GetUserOrientationQueryVariables = Exact<{ [key: string]: never }>

export type GetUserOrientationQuery = {
  __typename: 'Query'
  currentUser: {
    __typename: 'Membership'
    id: ID
    locale: Locale | null
    orientation: ApplicationOrientation
  }
}

export type GetSimpleUserQueryVariables = Exact<{ [key: string]: never }>

export type GetSimpleUserQuery = {
  __typename: 'Query'
  currentUser: {
    __typename: 'Membership'
    id: ID
    firstName: String
    lastName: String
    email: String | null
    phoneNumber: String | null
    policiesAcceptedAt: DateTime | null
    orientation: ApplicationOrientation
    organization: {
      __typename: 'Organization'
      id: ID
      name: String
      locale: Locale
      currency: Currency
      timeZone: String
      startOfWeekDay: DayOfWeek
      version: String | null
      featureFlags: JSONObject | null
      logo: { __typename: 'Document'; id: ID; name: String; storageUrl: String } | null
    }
    profilePicture: { __typename: 'Document'; id: ID; name: String; storageUrl: String } | null
    roles: Array<{
      __typename: 'Role'
      id: ID
      roleType: RoleType
      permissions: Array<{
        __typename: 'Permission'
        id: ID
        permissionType: PermissionType
        objectType: PermissionObjectType
        manualTrigger: { __typename: 'ActionManualTrigger'; id: ID } | null
        table: { __typename: 'Table'; id: ID } | null
        tableColumn: {
          __typename: 'TableColumn'
          id: ID
          table: { __typename: 'Table'; id: ID }
        } | null
        tableTab: { __typename: 'TableTab'; id: ID; table: { __typename: 'Table'; id: ID } } | null
        form: { __typename: 'Form'; id: ID } | null
        workspace: { __typename: 'Workspace'; id: ID } | null
      }>
    }>
    defaultSignature: {
      __typename: 'Signature'
      id: ID
      signatureFile: { __typename: 'Document'; id: ID; storageUrl: String }
    } | null
  }
}

export type GetPaginatedIssuesQueryVariables = Exact<{
  input: PaginatedIssuesInput
}>

export type GetPaginatedIssuesQuery = {
  __typename: 'Query'
  paginatedIssues: {
    __typename: 'PaginatedIssues'
    totalCount: Int
    hasNext: Boolean
    offset: Int
    issues: Array<{
      __typename: 'Issue'
      id: ID
      title: String
      errorTemplate: String
      status: IssueStatus
      priority: IssuePriority
      createdAt: DateTime
      lastSeenAt: DateTime
      resolutionReason: String | null
      issueOriginType: String | null
      issueOriginId: ID | null
      impactedEntityType: String
      impactedEntityId: ID | null
      organization: { __typename: 'Organization'; id: ID; name: String }
      owner: { __typename: 'Membership'; id: ID; firstName: String; lastName: String } | null
    }>
  }
}

export type GetPaginatedNotificationsQueryVariables = Exact<{
  input: PaginatedNotificationsInput
}>

export type GetPaginatedNotificationsQuery = {
  __typename: 'Query'
  paginatedNotifications: {
    __typename: 'PaginatedNotifications'
    totalCount: Int
    totalUnreadCount: Int
    hasNext: Boolean
    offset: Int
    notifications: Array<{
      __typename: 'Notification'
      id: ID
      isRead: Boolean
      isArchived: Boolean
      notificationType: NotificationType
      createdAt: DateTime
      metadata: JSONObject | null
      comment: {
        __typename: 'Comment'
        id: ID
        createdAt: DateTime
        text: String
        parsedText: String
        author: { __typename: 'Membership'; id: ID; firstName: String; lastName: String }
        workspace: {
          __typename: 'Workspace'
          id: ID
          parentObject: {
            __typename: 'WorkspaceParentObject'
            objectId: String
            objectType: BreadcrumbObjectType
            name: String
          } | null
        }
      } | null
    }>
  }
}

export type DirectoryUploadTableWorkspaceObjectsFragment = {
  __typename: 'Table'
  hasRowWorkspaceObjects: Boolean
}

export type WorkspaceCreationTableWorkspaceObjectsFragment = {
  __typename: 'Table'
  hasRowWorkspaceObjects: Boolean
}

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput
}>

export type CreateCommentMutation = {
  __typename: 'Mutation'
  createComment: {
    __typename: 'Comment'
    id: ID
    createdAt: DateTime
    text: String
    parsedText: String
    author: { __typename: 'Membership'; id: ID; firstName: String; lastName: String }
  }
}

export type CommentDataFragment = {
  __typename: 'Comment'
  id: ID
  createdAt: DateTime
  text: String
  parsedText: String
  author: { __typename: 'Membership'; id: ID; firstName: String; lastName: String }
}

export type ActivityFeedEventDataFragment = {
  __typename: 'ActivityFeedEvent'
  id: ID
  timestamp: DateTime
  eventType: SystemEventType
  eventStatus: SystemEventStatus
  substrate: SystemEventSubstrate | null
  agentId: ID | null
  originatorType: SystemEventOriginatorType
  originatorName: String
  impersonatedUserName: String | null
  entityType: SystemEventEntityType | null
  entityId: ID | null
  data: JSONObject
}

export type GetPaginatedEventsQueryVariables = Exact<{
  input: PaginatedEventsInput
}>

export type GetPaginatedEventsQuery = {
  __typename: 'Query'
  paginatedEvents: {
    __typename: 'PaginatedEvents'
    cursor: String | null
    hasNext: Boolean
    events: Array<{
      __typename: 'PaginatedActivityFeedEvent'
      objectId: ID
      objectType: BreadcrumbObjectType
      objectName: String
      event: {
        __typename: 'ActivityFeedEvent'
        id: ID
        timestamp: DateTime
        eventType: SystemEventType
        eventStatus: SystemEventStatus
        substrate: SystemEventSubstrate | null
        agentId: ID | null
        originatorType: SystemEventOriginatorType
        originatorName: String
        impersonatedUserName: String | null
        entityType: SystemEventEntityType | null
        entityId: ID | null
        data: JSONObject
      }
    }>
  }
}

export type GetPaginatedCommentsQueryVariables = Exact<{
  input: PaginatedCommentsInput
}>

export type GetPaginatedCommentsQuery = {
  __typename: 'Query'
  paginatedComments: {
    __typename: 'PaginatedComments'
    cursor: String | null
    hasNext: Boolean
    comments: Array<{
      __typename: 'PaginatedCommentWithChildren'
      objectId: ID
      objectType: BreadcrumbObjectType
      objectName: String
      comment: {
        __typename: 'Comment'
        id: ID
        createdAt: DateTime
        text: String
        parsedText: String
        author: { __typename: 'Membership'; id: ID; firstName: String; lastName: String }
      }
      childComments: Array<{
        __typename: 'PaginatedCommentWithChildren'
        comment: {
          __typename: 'Comment'
          id: ID
          createdAt: DateTime
          text: String
          parsedText: String
          author: { __typename: 'Membership'; id: ID; firstName: String; lastName: String }
        }
      }>
    }>
  }
}

export type GetActivityFeedRowScopesQueryVariables = Exact<{
  tableRowId: Scalars['ID']
}>

export type GetActivityFeedRowScopesQuery = {
  __typename: 'Query'
  tableRow: {
    __typename: 'TableRow'
    id: ID
    name: String
    table: {
      __typename: 'Table'
      id: ID
      childTables: Array<{
        __typename: 'Table'
        id: ID
        name: String
        orderOnRecordDetails: Int | null
        icon: { __typename: 'Icon'; id: ID; name: String } | null
      }>
    }
  }
}

export type PushCommentSubscriptionVariables = Exact<{
  input: BreadcrumbsInput
}>

export type PushCommentSubscription = {
  __typename: 'Subscription'
  pushComment: {
    __typename: 'PaginatedCommentWithChildren'
    objectId: ID
    objectType: BreadcrumbObjectType
    objectName: String
    comment: {
      __typename: 'Comment'
      id: ID
      createdAt: DateTime
      text: String
      parsedText: String
      author: { __typename: 'Membership'; id: ID; firstName: String; lastName: String }
    }
    childComments: Array<{
      __typename: 'PaginatedCommentWithChildren'
      comment: {
        __typename: 'Comment'
        id: ID
        createdAt: DateTime
        text: String
        parsedText: String
        author: { __typename: 'Membership'; id: ID; firstName: String; lastName: String }
      }
    }>
  }
}

export type PushActivityFeedEventSubscriptionVariables = Exact<{
  input: PushActivityFeedEventInput
}>

export type PushActivityFeedEventSubscription = {
  __typename: 'Subscription'
  pushActivityFeedEvent: {
    __typename: 'PaginatedActivityFeedEvent'
    objectId: ID
    objectType: BreadcrumbObjectType
    objectName: String
    event: {
      __typename: 'ActivityFeedEvent'
      id: ID
      timestamp: DateTime
      eventType: SystemEventType
      eventStatus: SystemEventStatus
      substrate: SystemEventSubstrate | null
      agentId: ID | null
      originatorType: SystemEventOriginatorType
      originatorName: String
      impersonatedUserName: String | null
      entityType: SystemEventEntityType | null
      entityId: ID | null
      data: JSONObject
    }
  }
}

export type GetChartVisualizationDataQueryVariables = Exact<{
  input: ChartVisualizationDataInput
}>

export type GetChartVisualizationDataQuery = {
  __typename: 'Query'
  chartVisualizationData: {
    __typename: 'ChartAggregation'
    metricAggregation: Float | null
    totalHits: Int | null
    pieChartAggregation: Array<{
      __typename: 'PieChartAggregation'
      id: String
      label: String
      value: Float
    }> | null
    barChartAggregation: {
      __typename: 'BarChartAggregation'
      data: Array<JSONObject>
      indexBy: String
      keys: Array<String>
    } | null
    lineChartAggregation: Array<{
      __typename: 'LineChartAggregation'
      id: String
      data: Array<{
        __typename: 'LineChartCoordinate'
        xString: String | null
        xFloat: Float | null
        yString: String | null
        yFloat: Float | null
      }>
    }> | null
    scatterplotAggregation: Array<{
      __typename: 'LineChartAggregation'
      id: String
      data: Array<{
        __typename: 'LineChartCoordinate'
        xString: String | null
        xFloat: Float | null
        yString: String | null
        yFloat: Float | null
      }>
    }> | null
    pivotTableAggregation: {
      __typename: 'PivotTableAggregation'
      cells: JSONObject
      grandTotals: JSONObject
      rows: Array<{
        __typename: 'PivotDimension'
        id: ID
        path: Array<String>
        displayName: String
        level: Int
        groupByIds: Array<ID>
      }>
      columns: Array<{
        __typename: 'PivotDimension'
        id: ID
        path: Array<String>
        displayName: String
        level: Int
        groupByIds: Array<ID>
      }>
    } | null
  }
}

export type GetDetailedChartQueryVariables = Exact<{
  chartId: Scalars['ID']
}>

export type GetDetailedChartQuery = {
  __typename: 'Query'
  chart: {
    __typename: 'Chart'
    id: ID
    name: String
    aggregationOperation: AggregationOperation
    chartType: ChartType
    chartSubType: ChartSubType
    thresholds: Array<Float> | null
    styling: JSONObject | null
    views: Array<{
      __typename: 'View'
      id: ID
      parentWorkspace: { __typename: 'Workspace'; id: ID; name: String | null }
    }>
    table: {
      __typename: 'Table'
      id: ID
      name: String
      parentTable: { __typename: 'Table'; id: ID; name: String } | null
    }
    xAxis: {
      __typename: 'TableColumn'
      id: ID
      order: Int
      name: String
      type: DataType
      indexType: IndexType
      innerType: DataType | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      resolvedSourceType: DataType
      resolvedEnumOptions: Array<String> | null
      table: { __typename: 'Table'; id: ID; name: String }
      lookupColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        indexType: IndexType
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
      } | null
    } | null
    yAxis: {
      __typename: 'TableColumn'
      id: ID
      order: Int
      name: String
      type: DataType
      indexType: IndexType
      innerType: DataType | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      resolvedSourceType: DataType
      resolvedEnumOptions: Array<String> | null
      table: { __typename: 'Table'; id: ID; name: String }
      lookupColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        indexType: IndexType
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
      } | null
    }
    aggregationColumns: Array<{
      __typename: 'ChartAggregationColumn'
      id: ID
      order: Int
      aggregationOperation: AggregationOperation
      valueDisplayType: ChartValueDisplayType
      tableColumn: {
        __typename: 'TableColumn'
        id: ID
        order: Int
        name: String
        type: DataType
        innerType: DataType | null
        indexType: IndexType
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        resolvedSourceType: DataType
        resolvedEnumOptions: Array<String> | null
        lookupColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          indexType: IndexType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
        } | null
      }
      aggregationSorts: Array<{
        __typename: 'ChartGroupBySort'
        id: ID
        direction: SortDirection
        sortType: ChartGroupBySortType
      }>
    }>
    groupBys: Array<{
      __typename: 'ChartGroupBy'
      type: ChartGroupByType
      metadata: JSONObject | null
      tableColumn: {
        __typename: 'TableColumn'
        id: ID
        order: Int
        name: String
        type: DataType
        innerType: DataType | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        indexType: IndexType
        resolvedSourceType: DataType
        resolvedEnumOptions: Array<String> | null
        table: { __typename: 'Table'; id: ID; name: String }
        lookupColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          indexType: IndexType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
        } | null
      }
      sort: {
        __typename: 'ChartGroupBySort'
        direction: SortDirection
        sortType: ChartGroupBySortType
      } | null
    }>
    filters: Array<{
      __typename: 'TableColumnFilter'
      id: ID
      operator: FilterOperator
      operand: JSONObject | null
      tableColumn: {
        __typename: 'TableColumn'
        id: ID
        order: Int
        name: String
        type: DataType
        innerType: DataType | null
        indexType: IndexType
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        resolvedSourceType: DataType
        resolvedEnumOptions: Array<String> | null
        table: { __typename: 'Table'; id: ID; name: String }
        lookupColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          indexType: IndexType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
        } | null
      } | null
    }>
  }
}

export type CreateChartMutationVariables = Exact<{
  chart: CreateChartInput
}>

export type CreateChartMutation = {
  __typename: 'Mutation'
  createChart: {
    __typename: 'Chart'
    id: ID
    name: String
    chartType: ChartType
    table: { __typename: 'Table'; id: ID }
  }
}

export type UpdateChartMutationVariables = Exact<{
  chart: UpdateChartInput
}>

export type UpdateChartMutation = {
  __typename: 'Mutation'
  updateChart: { __typename: 'Chart'; id: ID }
}

export type UpdateChartNameMutationVariables = Exact<{
  chartId: Scalars['ID']
  name: Scalars['String']
}>

export type UpdateChartNameMutation = {
  __typename: 'Mutation'
  updateChartName: { __typename: 'Chart'; id: ID; name: String }
}

export type DeleteChartMutationVariables = Exact<{
  chartId: Scalars['ID']
}>

export type DeleteChartMutation = {
  __typename: 'Mutation'
  deleteChart: { __typename: 'Chart'; id: ID }
}

export type DuplicateChartMutationVariables = Exact<{
  input: DuplicateChartInput
}>

export type DuplicateChartMutation = {
  __typename: 'Mutation'
  duplicateChart: { __typename: 'Chart'; id: ID; name: String; chartType: ChartType }
}

export type GetTableChartsQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetTableChartsQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    charts: Array<{ __typename: 'Chart'; id: ID; name: String; chartType: ChartType }>
  }
}

export type GetChartForXlsxExportQueryVariables = Exact<{
  chartId: Scalars['ID']
}>

export type GetChartForXlsxExportQuery = {
  __typename: 'Query'
  chart: {
    __typename: 'Chart'
    id: ID
    chartType: ChartType
    chartSubType: ChartSubType
    aggregationColumns: Array<{
      __typename: 'ChartAggregationColumn'
      id: ID
      order: Int
      aggregationOperation: AggregationOperation
      valueDisplayType: ChartValueDisplayType
      tableColumn: { __typename: 'TableColumn'; id: ID }
    }>
    groupBys: Array<{
      __typename: 'ChartGroupBy'
      type: ChartGroupByType
      metadata: JSONObject | null
      tableColumn: { __typename: 'TableColumn'; id: ID; table: { __typename: 'Table'; id: ID } }
      sort: {
        __typename: 'ChartGroupBySort'
        id: ID
        direction: SortDirection
        sortType: ChartGroupBySortType
        aggregationColumn: {
          __typename: 'ChartAggregationColumn'
          id: ID
          aggregationOperation: AggregationOperation
          tableColumn: { __typename: 'TableColumn'; id: ID }
        } | null
      } | null
    }>
    filters: Array<{
      __typename: 'TableColumnFilter'
      id: ID
      operator: FilterOperator
      operand: JSONObject | null
      tableColumn: {
        __typename: 'TableColumn'
        id: ID
        type: DataType
        indexType: IndexType
        resolvedSourceType: DataType
        resolvedEnumOptions: Array<String> | null
        lookupColumn: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          indexType: IndexType
        } | null
        table: { __typename: 'Table'; id: ID }
      } | null
    }>
  }
}

export type GetTableForChartSetupQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetTableForChartSetupQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    name: String
    parentTable: {
      __typename: 'Table'
      id: ID
      name: String
      icon: { __typename: 'Icon'; id: ID; name: String } | null
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        description: String | null
        order: Int
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        isReadOnly: Boolean
        isDecimal: Boolean
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        indexAutogenerate: Boolean
        enumOptions: Array<String> | null
        displayImagesInline: Boolean
        isVisibleOnRecordDetails: Boolean
        resolvedSourceType: DataType
        resolvedEnumOptions: Array<String> | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        lookupColumn: {
          __typename: 'TableColumn'
          name: String
          order: Int
          innerType: DataType | null
          indexType: IndexType
          indexPrefix: String
          indexSuffix: String
          enumOptions: Array<String> | null
          id: ID
          type: DataType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
          resolvedSourceColumn: {
            __typename: 'ResolvedTableColumnInfo'
            column: {
              __typename: 'TableColumn'
              id: ID
              type: DataType
              innerType: DataType | null
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              enumSet: {
                __typename: 'EnumSet'
                id: ID
                options: Array<{
                  __typename: 'EnumOption'
                  id: ID
                  label: String
                  colorPreset: EnumColorPreset | null
                  colorCustom: String | null
                  iconName: String | null
                  order: Int
                  icon: { __typename: 'Icon'; id: ID } | null
                }>
              } | null
            }
          }
        } | null
        lookupColumnChildren: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          table: { __typename: 'Table'; id: ID }
          lookupColumnGroup: {
            __typename: 'LookupTableColumnGroup'
            id: ID
            showBacklink: Boolean | null
            backlinkName: String | null
          } | null
        }>
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          showBacklink: Boolean | null
          backlinkName: String | null
        } | null
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
        formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
        chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }>
    } | null
    childTables: Array<{
      __typename: 'Table'
      id: ID
      name: String
      icon: { __typename: 'Icon'; id: ID; name: String } | null
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        description: String | null
        order: Int
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        isReadOnly: Boolean
        isDecimal: Boolean
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        indexAutogenerate: Boolean
        enumOptions: Array<String> | null
        displayImagesInline: Boolean
        isVisibleOnRecordDetails: Boolean
        resolvedSourceType: DataType
        resolvedEnumOptions: Array<String> | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        lookupColumn: {
          __typename: 'TableColumn'
          name: String
          order: Int
          innerType: DataType | null
          indexType: IndexType
          indexPrefix: String
          indexSuffix: String
          enumOptions: Array<String> | null
          id: ID
          type: DataType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
          resolvedSourceColumn: {
            __typename: 'ResolvedTableColumnInfo'
            column: {
              __typename: 'TableColumn'
              id: ID
              type: DataType
              innerType: DataType | null
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              enumSet: {
                __typename: 'EnumSet'
                id: ID
                options: Array<{
                  __typename: 'EnumOption'
                  id: ID
                  label: String
                  colorPreset: EnumColorPreset | null
                  colorCustom: String | null
                  iconName: String | null
                  order: Int
                  icon: { __typename: 'Icon'; id: ID } | null
                }>
              } | null
            }
          }
        } | null
        lookupColumnChildren: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          table: { __typename: 'Table'; id: ID }
          lookupColumnGroup: {
            __typename: 'LookupTableColumnGroup'
            id: ID
            showBacklink: Boolean | null
            backlinkName: String | null
          } | null
        }>
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          showBacklink: Boolean | null
          backlinkName: String | null
        } | null
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
        formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
        chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }>
    }>
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      description: String | null
      order: Int
      type: DataType
      innerType: DataType | null
      isNullable: Boolean
      isReadOnly: Boolean
      isDecimal: Boolean
      indexType: IndexType
      indexPrefix: String
      indexSuffix: String
      indexAutogenerate: Boolean
      enumOptions: Array<String> | null
      displayImagesInline: Boolean
      isVisibleOnRecordDetails: Boolean
      resolvedSourceType: DataType
      resolvedEnumOptions: Array<String> | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      lookupColumn: {
        __typename: 'TableColumn'
        name: String
        order: Int
        innerType: DataType | null
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        enumOptions: Array<String> | null
        id: ID
        type: DataType
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
      } | null
      lookupColumnChildren: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID }
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          showBacklink: Boolean | null
          backlinkName: String | null
        } | null
      }>
      lookupColumnGroup: {
        __typename: 'LookupTableColumnGroup'
        id: ID
        showBacklink: Boolean | null
        backlinkName: String | null
      } | null
      lookupFilterExpression: {
        __typename: 'LogicExpression'
        id: ID
        logicExpressionString: String | null
      } | null
      formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
      chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
      resolvedSourceColumn: {
        __typename: 'ResolvedTableColumnInfo'
        column: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          innerType: DataType | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }
      }
      enumSet: {
        __typename: 'EnumSet'
        id: ID
        options: Array<{
          __typename: 'EnumOption'
          id: ID
          label: String
          colorPreset: EnumColorPreset | null
          colorCustom: String | null
          iconName: String | null
          order: Int
          icon: { __typename: 'Icon'; id: ID } | null
        }>
      } | null
    }>
  }
}

export type GetDataSourceTreeQueryVariables = Exact<{ [key: string]: never }>

export type GetDataSourceTreeQuery = {
  __typename: 'Query'
  rootWorkspaces: Array<{
    __typename: 'Workspace'
    id: ID
    name: String | null
    views: Array<{ __typename: 'View'; id: ID }>
  }>
  dataSourceViews: Array<{
    __typename: 'View'
    id: ID
    order: Int
    parentWorkspace: { __typename: 'Workspace'; id: ID }
    workspace: {
      __typename: 'Workspace'
      id: ID
      name: String | null
      views: Array<{ __typename: 'View'; id: ID }>
    } | null
    table: {
      __typename: 'Table'
      id: ID
      name: String
      icon: { __typename: 'Icon'; id: ID; name: String } | null
      rootWorkspace: { __typename: 'Workspace'; id: ID }
    } | null
    chart: {
      __typename: 'Chart'
      id: ID
      name: String
      chartType: ChartType
      table: { __typename: 'Table'; id: ID }
    } | null
  }>
}

export type GetDataSourceCountsQueryVariables = Exact<{ [key: string]: never }>

export type GetDataSourceCountsQuery = {
  __typename: 'Query'
  dataSourceViews: Array<{
    __typename: 'View'
    id: ID
    table: { __typename: 'Table'; id: ID; recordCount: Int | null; columnCount: Int } | null
  }>
}

export type MoveDataSourceViewMutationVariables = Exact<{
  viewId: Scalars['ID']
  parentWorkspaceId: Scalars['ID']
  insertBeforeViewId?: InputMaybe<Scalars['ID']>
  insertAfterViewId?: InputMaybe<Scalars['ID']>
}>

export type MoveDataSourceViewMutation = {
  __typename: 'Mutation'
  updateView: {
    __typename: 'View'
    id: ID
    order: Int
    parentWorkspace: {
      __typename: 'Workspace'
      id: ID
      views: Array<{ __typename: 'View'; id: ID; order: Int }>
    }
  }
}

export type PromoteDataSourceFolderMutationVariables = Exact<{
  workspaceId: Scalars['ID']
}>

export type PromoteDataSourceFolderMutation = {
  __typename: 'Mutation'
  promoteToRootWorkspace: { __typename: 'Workspace'; id: ID }
}

export type DemoteDataSourceFolderMutationVariables = Exact<{
  workspaceId: Scalars['ID']
  parentWorkspaceId: Scalars['ID']
}>

export type DemoteDataSourceFolderMutation = {
  __typename: 'Mutation'
  demoteRootWorkspace: { __typename: 'View'; id: ID }
}

export type DeleteDataSourceFolderMutationVariables = Exact<{
  workspaceId: Scalars['ID']
}>

export type DeleteDataSourceFolderMutation = {
  __typename: 'Mutation'
  deleteWorkspace: { __typename: 'Workspace'; id: ID }
}

export type DeleteDataSourceChartMutationVariables = Exact<{
  chartId: Scalars['ID']
}>

export type DeleteDataSourceChartMutation = {
  __typename: 'Mutation'
  deleteChart: { __typename: 'Chart'; id: ID }
}

export type ComprehensionEntityFieldsFragment = {
  __typename: 'ComprehensionGraphResult'
  truncated: Boolean
  truncatedAtDepth: Int | null
  maxEdges: Int
  returnedEdgeCount: Int
  returnedNodeCount: Int
  edges: Array<{
    __typename: 'ComprehensionTraversalEdge'
    fromEntityType: ComprehensionEntityType
    fromEntityId: ID
    toEntityType: ComprehensionEntityType
    toEntityId: ID
    edgeType: ComprehensionEdgeType
    relationshipKey: String
    depth: Int
  }>
  tables: Array<{ __typename: 'Table'; id: ID; name: String }>
  tableColumns: Array<{
    __typename: 'TableColumn'
    id: ID
    name: String
    table: { __typename: 'Table'; name: String }
  }>
  actions: Array<{
    __typename: 'Action'
    id: ID
    name: String
    autoTrigger: { __typename: 'ActionAutoTrigger'; type: ActionAutoTriggerType } | null
    manualTriggers: Array<{ __typename: 'ActionManualTrigger'; id: ID }>
    apiTrigger: { __typename: 'ActionApiTrigger'; id: ID } | null
    frequencyTriggers: Array<{ __typename: 'ActionFrequencyTrigger'; id: ID }>
  }>
  actionSteps: Array<{
    __typename: 'ActionStep'
    id: ID
    name: String
    type: ActionStepType
    rootAction: { __typename: 'Action'; name: String }
  }>
  actionStepGroups: Array<{
    __typename: 'ActionStepGroup'
    id: ID
    name: String
    rootAction: { __typename: 'Action'; name: String }
  }>
  autoTriggers: Array<{
    __typename: 'ActionAutoTrigger'
    id: ID
    type: ActionAutoTriggerType
    action: { __typename: 'Action'; name: String } | null
  }>
  manualTriggers: Array<{
    __typename: 'ActionManualTrigger'
    id: ID
    name: String
    organization: { __typename: 'Organization'; name: String }
  }>
  integrations: Array<{ __typename: 'Integration'; id: ID; type: IntegrationType }>
  forms: Array<{ __typename: 'Form'; id: ID; name: String }>
  formsV2: Array<{ __typename: 'FormV2'; id: ID; name: String }>
  formInputs: Array<{
    __typename: 'FormInput'
    id: ID
    label: String
    form: { __typename: 'FormV2'; name: String }
  }>
  formFields: Array<{
    __typename: 'FormField'
    id: ID
    name: String
    form: { __typename: 'Form'; name: String }
  }>
  workflowsV2: Array<{ __typename: 'WorkflowV2'; id: ID; name: String }>
}

export type ComprehensionGraphQueryVariables = Exact<{
  impactInput: ComprehensionGraphInput
  dependenciesInput: ComprehensionGraphInput
}>

export type ComprehensionGraphQuery = {
  __typename: 'Query'
  comprehensionImpact: {
    __typename: 'ComprehensionGraphResult'
    truncated: Boolean
    truncatedAtDepth: Int | null
    maxEdges: Int
    returnedEdgeCount: Int
    returnedNodeCount: Int
    edges: Array<{
      __typename: 'ComprehensionTraversalEdge'
      fromEntityType: ComprehensionEntityType
      fromEntityId: ID
      toEntityType: ComprehensionEntityType
      toEntityId: ID
      edgeType: ComprehensionEdgeType
      relationshipKey: String
      depth: Int
    }>
    tables: Array<{ __typename: 'Table'; id: ID; name: String }>
    tableColumns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      table: { __typename: 'Table'; name: String }
    }>
    actions: Array<{
      __typename: 'Action'
      id: ID
      name: String
      autoTrigger: { __typename: 'ActionAutoTrigger'; type: ActionAutoTriggerType } | null
      manualTriggers: Array<{ __typename: 'ActionManualTrigger'; id: ID }>
      apiTrigger: { __typename: 'ActionApiTrigger'; id: ID } | null
      frequencyTriggers: Array<{ __typename: 'ActionFrequencyTrigger'; id: ID }>
    }>
    actionSteps: Array<{
      __typename: 'ActionStep'
      id: ID
      name: String
      type: ActionStepType
      rootAction: { __typename: 'Action'; name: String }
    }>
    actionStepGroups: Array<{
      __typename: 'ActionStepGroup'
      id: ID
      name: String
      rootAction: { __typename: 'Action'; name: String }
    }>
    autoTriggers: Array<{
      __typename: 'ActionAutoTrigger'
      id: ID
      type: ActionAutoTriggerType
      action: { __typename: 'Action'; name: String } | null
    }>
    manualTriggers: Array<{
      __typename: 'ActionManualTrigger'
      id: ID
      name: String
      organization: { __typename: 'Organization'; name: String }
    }>
    integrations: Array<{ __typename: 'Integration'; id: ID; type: IntegrationType }>
    forms: Array<{ __typename: 'Form'; id: ID; name: String }>
    formsV2: Array<{ __typename: 'FormV2'; id: ID; name: String }>
    formInputs: Array<{
      __typename: 'FormInput'
      id: ID
      label: String
      form: { __typename: 'FormV2'; name: String }
    }>
    formFields: Array<{
      __typename: 'FormField'
      id: ID
      name: String
      form: { __typename: 'Form'; name: String }
    }>
    workflowsV2: Array<{ __typename: 'WorkflowV2'; id: ID; name: String }>
  }
  comprehensionDependencies: {
    __typename: 'ComprehensionGraphResult'
    truncated: Boolean
    truncatedAtDepth: Int | null
    maxEdges: Int
    returnedEdgeCount: Int
    returnedNodeCount: Int
    edges: Array<{
      __typename: 'ComprehensionTraversalEdge'
      fromEntityType: ComprehensionEntityType
      fromEntityId: ID
      toEntityType: ComprehensionEntityType
      toEntityId: ID
      edgeType: ComprehensionEdgeType
      relationshipKey: String
      depth: Int
    }>
    tables: Array<{ __typename: 'Table'; id: ID; name: String }>
    tableColumns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      table: { __typename: 'Table'; name: String }
    }>
    actions: Array<{
      __typename: 'Action'
      id: ID
      name: String
      autoTrigger: { __typename: 'ActionAutoTrigger'; type: ActionAutoTriggerType } | null
      manualTriggers: Array<{ __typename: 'ActionManualTrigger'; id: ID }>
      apiTrigger: { __typename: 'ActionApiTrigger'; id: ID } | null
      frequencyTriggers: Array<{ __typename: 'ActionFrequencyTrigger'; id: ID }>
    }>
    actionSteps: Array<{
      __typename: 'ActionStep'
      id: ID
      name: String
      type: ActionStepType
      rootAction: { __typename: 'Action'; name: String }
    }>
    actionStepGroups: Array<{
      __typename: 'ActionStepGroup'
      id: ID
      name: String
      rootAction: { __typename: 'Action'; name: String }
    }>
    autoTriggers: Array<{
      __typename: 'ActionAutoTrigger'
      id: ID
      type: ActionAutoTriggerType
      action: { __typename: 'Action'; name: String } | null
    }>
    manualTriggers: Array<{
      __typename: 'ActionManualTrigger'
      id: ID
      name: String
      organization: { __typename: 'Organization'; name: String }
    }>
    integrations: Array<{ __typename: 'Integration'; id: ID; type: IntegrationType }>
    forms: Array<{ __typename: 'Form'; id: ID; name: String }>
    formsV2: Array<{ __typename: 'FormV2'; id: ID; name: String }>
    formInputs: Array<{
      __typename: 'FormInput'
      id: ID
      label: String
      form: { __typename: 'FormV2'; name: String }
    }>
    formFields: Array<{
      __typename: 'FormField'
      id: ID
      name: String
      form: { __typename: 'Form'; name: String }
    }>
    workflowsV2: Array<{ __typename: 'WorkflowV2'; id: ID; name: String }>
  }
}

export type TableDetailsQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type TableDetailsQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    name: String
    childTables: Array<{ __typename: 'Table'; id: ID; name: String }>
  }
}

export type ActionDetailsQueryVariables = Exact<{
  actionId: Scalars['ID']
}>

export type ActionDetailsQuery = {
  __typename: 'Query'
  action: {
    __typename: 'Action'
    id: ID
    name: String
    status: ActionStatus
    workflow: { __typename: 'Workflow'; id: ID; name: String }
  }
}

export type ActionStepDetailsQueryVariables = Exact<{
  actionStepId: Scalars['ID']
}>

export type ActionStepDetailsQuery = {
  __typename: 'Query'
  actionStep: {
    __typename: 'ActionStep'
    id: ID
    name: String
    order: Int
    type: ActionStepType
    status: ActionStepStatus
    rootAction: {
      __typename: 'Action'
      id: ID
      name: String
      workflow: { __typename: 'Workflow'; id: ID; name: String }
    }
  }
}

export type ActionStepGroupDetailsQueryVariables = Exact<{
  actionStepGroupId: Scalars['ID']
}>

export type ActionStepGroupDetailsQuery = {
  __typename: 'Query'
  actionStepGroup: {
    __typename: 'ActionStepGroup'
    id: ID
    name: String
    order: Int
    parentActionStep: { __typename: 'ActionStep'; id: ID; name: String; type: ActionStepType }
    rootAction: {
      __typename: 'Action'
      id: ID
      name: String
      workflow: { __typename: 'Workflow'; id: ID; name: String }
    }
  }
}

export type FormDetailsQueryVariables = Exact<{
  formId: Scalars['ID']
}>

export type FormDetailsQuery = {
  __typename: 'Query'
  form: { __typename: 'Form'; id: ID; name: String; isShareable: Boolean }
}

export type FormV2DetailsQueryVariables = Exact<{
  formId: Scalars['ID']
}>

export type FormV2DetailsQuery = {
  __typename: 'Query'
  formV2: { __typename: 'FormV2'; id: ID; name: String; isShareable: Boolean }
}

export type TableColumnDetailsQueryVariables = Exact<{
  tableColumnId: Scalars['ID']
}>

export type TableColumnDetailsQuery = {
  __typename: 'Query'
  tableColumn: {
    __typename: 'TableColumn'
    id: ID
    name: String
    type: DataType
    isNullable: Boolean
    table: { __typename: 'Table'; id: ID; name: String }
  }
}

export type FormInputDetailsQueryVariables = Exact<{
  formInputId: Scalars['ID']
}>

export type FormInputDetailsQuery = {
  __typename: 'Query'
  formInput: {
    __typename: 'FormInput'
    id: ID
    label: String
    inputType: FormInputType
    isRequired: Boolean
    group: { __typename: 'FormInputGroup'; id: ID; label: String } | null
    lookupGroup: {
      __typename: 'FormLookupInputGroup'
      id: ID
      lookupTable: { __typename: 'Table'; id: ID; name: String }
    } | null
    form: { __typename: 'FormV2'; id: ID; name: String }
  }
}

export type FormFieldDetailsQueryVariables = Exact<{
  formFieldId: Scalars['ID']
}>

export type FormFieldDetailsQuery = {
  __typename: 'Query'
  formField: {
    __typename: 'FormField'
    id: ID
    name: String
    type: FormFieldType
    isRequired: Boolean
    category: {
      __typename: 'FormCategory'
      id: ID
      name: String
      page: { __typename: 'FormPage'; id: ID; name: String }
    }
    form: { __typename: 'Form'; id: ID; name: String }
  }
}

export type AutoTriggerDetailsQueryVariables = Exact<{
  actionAutoTriggerId: Scalars['ID']
}>

export type AutoTriggerDetailsQuery = {
  __typename: 'Query'
  actionAutoTrigger: {
    __typename: 'ActionAutoTrigger'
    id: ID
    type: ActionAutoTriggerType
    filterExpression: JSONObject | null
    slugifiedTriggerMetadata: JSONObject
    action: {
      __typename: 'Action'
      id: ID
      name: String
      workflow: { __typename: 'Workflow'; id: ID }
    } | null
  }
}

export type ManualTriggerDetailsQueryVariables = Exact<{
  actionManualTriggerId: Scalars['ID']
}>

export type ManualTriggerDetailsQuery = {
  __typename: 'Query'
  actionManualTrigger: {
    __typename: 'ActionManualTrigger'
    id: ID
    name: String
    buttons: Array<{
      __typename: 'WorkspaceButton'
      name: String
      parentWorkspace: { __typename: 'Workspace'; id: ID; name: String | null } | null
    }>
    action: {
      __typename: 'Action'
      id: ID
      name: String
      workflow: { __typename: 'Workflow'; id: ID }
    } | null
  }
}

export type IntegrationDetailsQueryVariables = Exact<{
  integrationId: Scalars['ID']
}>

export type IntegrationDetailsQuery = {
  __typename: 'Query'
  integration: {
    __typename: 'Integration'
    id: ID
    type: IntegrationType
    status: IntegrationStatus
  }
}

export type DrillDownTablesQueryVariables = Exact<{ [key: string]: never }>

export type DrillDownTablesQuery = {
  __typename: 'Query'
  tables: Array<{ __typename: 'Table'; id: ID; name: String }>
}

export type DrillDownActionsQueryVariables = Exact<{ [key: string]: never }>

export type DrillDownActionsQuery = {
  __typename: 'Query'
  workflows: Array<{
    __typename: 'Workflow'
    id: ID
    name: String
    actions: Array<{
      __typename: 'Action'
      id: ID
      name: String
      nestedSteps: Array<{ __typename: 'ActionStep'; id: ID }>
      nestedGroups: Array<{ __typename: 'ActionStepGroup'; id: ID }>
      autoTrigger: { __typename: 'ActionAutoTrigger'; id: ID; type: ActionAutoTriggerType } | null
      manualTriggers: Array<{ __typename: 'ActionManualTrigger'; id: ID }>
    }>
  }>
}

export type DrillDownFormsQueryVariables = Exact<{ [key: string]: never }>

export type DrillDownFormsQuery = {
  __typename: 'Query'
  forms: Array<{ __typename: 'Form'; id: ID; name: String }>
}

export type DrillDownFormsV2QueryVariables = Exact<{ [key: string]: never }>

export type DrillDownFormsV2Query = {
  __typename: 'Query'
  allFormsV2: Array<{ __typename: 'FormV2'; id: ID; name: String }>
}

export type DrillDownWorkflowsV2QueryVariables = Exact<{ [key: string]: never }>

export type DrillDownWorkflowsV2Query = {
  __typename: 'Query'
  allWorkflowsV2: Array<{ __typename: 'WorkflowV2'; id: ID; name: String }>
}

export type DrillDownTableColumnsQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type DrillDownTableColumnsQuery = {
  __typename: 'Query'
  tableColumnsById: Array<{ __typename: 'TableColumn'; id: ID; name: String }>
}

export type DrillDownActionStepsQueryVariables = Exact<{
  actionId: Scalars['ID']
}>

export type DrillDownActionStepsQuery = {
  __typename: 'Query'
  action: {
    __typename: 'Action'
    id: ID
    nestedSteps: Array<{ __typename: 'ActionStep'; id: ID; name: String }>
  }
}

export type DrillDownActionStepGroupsQueryVariables = Exact<{
  actionId: Scalars['ID']
}>

export type DrillDownActionStepGroupsQuery = {
  __typename: 'Query'
  action: {
    __typename: 'Action'
    id: ID
    nestedGroups: Array<{ __typename: 'ActionStepGroup'; id: ID; name: String }>
  }
}

export type DrillDownManualTriggersQueryVariables = Exact<{
  actionId: Scalars['ID']
}>

export type DrillDownManualTriggersQuery = {
  __typename: 'Query'
  action: {
    __typename: 'Action'
    id: ID
    manualTriggers: Array<{ __typename: 'ActionManualTrigger'; id: ID; name: String }>
  }
}

export type DrillDownFormFieldsQueryVariables = Exact<{
  formId: Scalars['ID']
}>

export type DrillDownFormFieldsQuery = {
  __typename: 'Query'
  form: {
    __typename: 'Form'
    id: ID
    fields: Array<{ __typename: 'FormField'; id: ID; name: String }>
  }
}

export type DrillDownFormInputsQueryVariables = Exact<{
  formId: Scalars['ID']
}>

export type DrillDownFormInputsQuery = {
  __typename: 'Query'
  formV2: {
    __typename: 'FormV2'
    id: ID
    inputs: Array<{ __typename: 'FormInput'; id: ID; label: String }>
  }
}

export type DossbotEventDataFragment = {
  __typename: 'DossbotEvent'
  id: ID
  type: DossbotEventType
  payload: JSONObject
  createdAt: DateTime
}

export type DossbotChatsQueryVariables = Exact<{ [key: string]: never }>

export type DossbotChatsQuery = {
  __typename: 'Query'
  dossbotChats: Array<{ __typename: 'DossbotChat'; id: ID; title: String; summary: String | null }>
}

export type DossbotChatQueryVariables = Exact<{
  chatId: Scalars['ID']
}>

export type DossbotChatQuery = {
  __typename: 'Query'
  dossbotChat: {
    __typename: 'DossbotChat'
    id: ID
    summary: String | null
    title: String
    runs: Array<{
      __typename: 'DossbotChatRun'
      id: ID
      inputPrompt: String
      response: String | null
      status: DossbotChatRunStatus
      createdAt: DateTime
      completedAt: DateTime | null
      events: Array<{
        __typename: 'DossbotEvent'
        id: ID
        type: DossbotEventType
        payload: JSONObject
        createdAt: DateTime
      }>
      agentRuns: Array<{
        __typename: 'AgentRun'
        id: ID
        summary: String | null
        events: Array<{
          __typename: 'DossbotEvent'
          id: ID
          type: DossbotEventType
          payload: JSONObject
          createdAt: DateTime
        }>
        toolRunSteps: Array<{
          __typename: 'ToolRunStep'
          id: ID
          confirmationMessage: String | null
          events: Array<{
            __typename: 'DossbotEvent'
            id: ID
            type: DossbotEventType
            payload: JSONObject
            createdAt: DateTime
          }>
        }>
      }>
    }>
  }
}

export type CreateDossbotChatMutationVariables = Exact<{
  input: CreateDossbotChatInput
}>

export type CreateDossbotChatMutation = {
  __typename: 'Mutation'
  createDossbotChat: {
    __typename: 'DossbotChat'
    id: ID
    summary: String | null
    title: String
    runs: Array<{
      __typename: 'DossbotChatRun'
      id: ID
      inputPrompt: String
      response: String | null
      status: DossbotChatRunStatus
      createdAt: DateTime
      completedAt: DateTime | null
    }>
  }
}

export type CreateDossbotChatRunMutationVariables = Exact<{
  input: CreateDossbotChatRunInput
}>

export type CreateDossbotChatRunMutation = {
  __typename: 'Mutation'
  createDossbotChatRun: {
    __typename: 'DossbotChatRun'
    id: ID
    inputPrompt: String
    response: String | null
    status: DossbotChatRunStatus
    createdAt: DateTime
    completedAt: DateTime | null
  }
}

export type CancelDossbotChatRunMutationVariables = Exact<{
  runId: Scalars['ID']
}>

export type CancelDossbotChatRunMutation = {
  __typename: 'Mutation'
  cancelDossbotChatRun: {
    __typename: 'DossbotChatRun'
    id: ID
    status: DossbotChatRunStatus
    completedAt: DateTime | null
  }
}

export type PushDossbotEventSubscriptionVariables = Exact<{
  chatId: Scalars['ID']
}>

export type PushDossbotEventSubscription = {
  __typename: 'Subscription'
  pushDossbotEvent: {
    __typename: 'DossbotEvent'
    id: ID
    type: DossbotEventType
    payload: JSONObject
    chatRun: {
      __typename: 'DossbotChatRun'
      id: ID
      status: DossbotChatRunStatus
      response: String | null
    } | null
    agentRun: {
      __typename: 'AgentRun'
      id: ID
      status: AgentRunStatus
      summary: String | null
    } | null
    toolRunStep: {
      __typename: 'ToolRunStep'
      id: ID
      status: ToolRunStatus
      toolName: String
      confirmationMessage: String | null
    } | null
  }
}

export type RespondToDossbotToolConfirmationMutationVariables = Exact<{
  input: RespondToDossbotToolConfirmationInput
}>

export type RespondToDossbotToolConfirmationMutation = {
  __typename: 'Mutation'
  respondToDossbotToolConfirmation: { __typename: 'ToolRunStep'; id: ID; status: ToolRunStatus }
}

export type UpdateFormMutationVariables = Exact<{
  input: UpdateFormInput
}>

export type UpdateFormMutation = {
  __typename: 'Mutation'
  updateForm: {
    __typename: 'Form'
    id: ID
    name: String
    isShareable: Boolean
    formFiles: Array<{ __typename: 'FormFile'; id: ID; type: GeneratedFileType }>
    pages: Array<{
      __typename: 'FormPage'
      id: ID
      categories: Array<{
        __typename: 'FormCategory'
        id: ID
        lookupTable: { __typename: 'Table'; id: ID; name: String; isShareable: Boolean } | null
      }>
    }>
    buttons: Array<{
      __typename: 'WorkspaceButton'
      id: ID
      name: String
      parentWorkspace: {
        __typename: 'Workspace'
        id: ID
        chart: { __typename: 'Chart'; id: ID; name: String } | null
      } | null
      buttonNode: {
        __typename: 'TableButtonNode'
        id: ID
        table: { __typename: 'Table'; id: ID }
      } | null
    }>
  }
}

export type UpdateFormV2MutationVariables = Exact<{
  input: UpdateFormV2Input
}>

export type UpdateFormV2Mutation = {
  __typename: 'Mutation'
  updateFormV2: {
    __typename: 'FormV2'
    id: ID
    name: String
    redirectTarget: FormRedirectTarget
    redirectCustomPath: String | null
  }
}

export type GetSimpleFormQueryVariables = Exact<{
  formId: Scalars['ID']
}>

export type GetSimpleFormQuery = {
  __typename: 'Query'
  form: {
    __typename: 'Form'
    id: ID
    name: String
    isShareable: Boolean
    formFiles: Array<{ __typename: 'FormFile'; id: ID; type: GeneratedFileType }>
    pages: Array<{
      __typename: 'FormPage'
      id: ID
      categories: Array<{
        __typename: 'FormCategory'
        id: ID
        lookupTable: {
          __typename: 'Table'
          id: ID
          name: String
          isShareable: Boolean
          lookupFormCategories: Array<{
            __typename: 'FormCategory'
            id: ID
            name: String
            page: {
              __typename: 'FormPage'
              id: ID
              form: { __typename: 'Form'; id: ID; isShareable: Boolean }
            }
          }>
          formLookupInputGroups: Array<{
            __typename: 'FormLookupInputGroup'
            id: ID
            form: {
              __typename: 'FormV2'
              id: ID
              permissions: Array<{
                __typename: 'Permission'
                id: ID
                permissionType: PermissionType
                role: { __typename: 'Role'; id: ID; roleType: RoleType }
              }>
            }
          }>
        } | null
      }>
    }>
    buttons: Array<{
      __typename: 'WorkspaceButton'
      id: ID
      name: String
      parentWorkspace: {
        __typename: 'Workspace'
        id: ID
        name: String | null
        parentOrganization: { __typename: 'Organization'; id: ID } | null
        table: { __typename: 'Table'; id: ID; name: String } | null
        tableRow: {
          __typename: 'TableRow'
          id: ID
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        document: { __typename: 'Document'; id: ID; name: String } | null
        chart: { __typename: 'Chart'; id: ID; name: String } | null
      } | null
      buttonNode: {
        __typename: 'TableButtonNode'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
    }>
    formV2: { __typename: 'FormV2'; id: ID; name: String } | null
  }
}

export type DuplicateFormMutationVariables = Exact<{
  formId: Scalars['ID']
}>

export type DuplicateFormMutation = {
  __typename: 'Mutation'
  duplicateForm: {
    __typename: 'Form'
    id: ID
    name: String
    isShareable: Boolean
    formFiles: Array<{ __typename: 'FormFile'; id: ID; type: GeneratedFileType }>
    buttons: Array<{
      __typename: 'WorkspaceButton'
      id: ID
      name: String
      parentWorkspace: {
        __typename: 'Workspace'
        id: ID
        name: String | null
        parentOrganization: { __typename: 'Organization'; id: ID } | null
        table: { __typename: 'Table'; id: ID; name: String } | null
        tableRow: {
          __typename: 'TableRow'
          id: ID
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        document: { __typename: 'Document'; id: ID; name: String } | null
        chart: { __typename: 'Chart'; id: ID; name: String } | null
      } | null
      buttonNode: {
        __typename: 'TableButtonNode'
        id: ID
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
    }>
  }
}

export type DuplicateFormV2MutationVariables = Exact<{
  formV2Id: Scalars['ID']
}>

export type DuplicateFormV2Mutation = {
  __typename: 'Mutation'
  duplicateFormV2: { __typename: 'FormV2'; id: ID; name: String }
}

export type GetWorkflowsByFormQueryVariables = Exact<{
  formId: Scalars['ID']
}>

export type GetWorkflowsByFormQuery = {
  __typename: 'Query'
  workflowsByForm: Array<{
    __typename: 'Workflow'
    id: ID
    name: String
    status: WorkflowStatus
    isUserVisible: Boolean
    organization: { __typename: 'Organization'; id: ID }
  }>
}

export type GetWorkspacesQueryVariables = Exact<{ [key: string]: never }>

export type GetWorkspacesQuery = {
  __typename: 'Query'
  workspaces: Array<{
    __typename: 'Workspace'
    id: ID
    name: String | null
    parentOrganization: { __typename: 'Organization'; id: ID } | null
    table: {
      __typename: 'Table'
      id: ID
      name: String
      icon: { __typename: 'Icon'; id: ID; name: String } | null
    } | null
    tableRow: {
      __typename: 'TableRow'
      id: ID
      name: String
      table: { __typename: 'Table'; id: ID; name: String }
    } | null
    document: { __typename: 'Document'; id: ID; name: String } | null
    chart: { __typename: 'Chart'; id: ID; name: String } | null
  }>
}

export type CreateWorkspaceButtonMutationVariables = Exact<{
  input: CreateWorkspaceButtonInput
}>

export type CreateWorkspaceButtonMutation = {
  __typename: 'Mutation'
  createWorkspaceButton: {
    __typename: 'WorkspaceButton'
    id: ID
    order: Int
    name: String
    manualTrigger: {
      __typename: 'ActionManualTrigger'
      id: ID
      name: String
      action: { __typename: 'Action'; id: ID; name: String } | null
    } | null
    form: { __typename: 'Form'; id: ID; name: String } | null
    formV2: { __typename: 'FormV2'; id: ID; name: String } | null
    parentWorkspace: {
      __typename: 'Workspace'
      id: ID
      name: String | null
      parentOrganization: { __typename: 'Organization'; id: ID } | null
      table: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
      } | null
      tableRow: {
        __typename: 'TableRow'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      document: { __typename: 'Document'; id: ID; name: String } | null
      chart: { __typename: 'Chart'; id: ID; name: String } | null
    } | null
    buttonNode: {
      __typename: 'TableButtonNode'
      id: ID
      table: { __typename: 'Table'; id: ID; name: String }
    } | null
  }
}

export type DeleteWorkspaceButtonMutationVariables = Exact<{
  workspaceButtonId: Scalars['ID']
}>

export type DeleteWorkspaceButtonMutation = {
  __typename: 'Mutation'
  deleteWorkspaceButton: { __typename: 'WorkspaceButton'; id: ID }
}

export type DeleteFormMutationVariables = Exact<{
  input: DeleteFormInput
}>

export type DeleteFormMutation = {
  __typename: 'Mutation'
  deleteForm: { __typename: 'Form'; id: ID }
}

export type UpdateWorkspaceButtonMutationVariables = Exact<{
  input: UpdateWorkspaceButtonInput
}>

export type UpdateWorkspaceButtonMutation = {
  __typename: 'Mutation'
  updateWorkspaceButton: {
    __typename: 'WorkspaceButton'
    id: ID
    order: Int
    name: String
    manualTrigger: {
      __typename: 'ActionManualTrigger'
      id: ID
      name: String
      action: { __typename: 'Action'; id: ID; name: String } | null
    } | null
    form: { __typename: 'Form'; id: ID; name: String } | null
    formV2: { __typename: 'FormV2'; id: ID; name: String } | null
    parentWorkspace: {
      __typename: 'Workspace'
      id: ID
      name: String | null
      parentOrganization: { __typename: 'Organization'; id: ID } | null
      table: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
      } | null
      tableRow: {
        __typename: 'TableRow'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      document: { __typename: 'Document'; id: ID; name: String } | null
      chart: { __typename: 'Chart'; id: ID; name: String } | null
    } | null
    buttonNode: {
      __typename: 'TableButtonNode'
      id: ID
      table: { __typename: 'Table'; id: ID; name: String }
    } | null
  }
}

export type MigrateFormV1ToV2MutationVariables = Exact<{
  formId: Scalars['ID']
}>

export type MigrateFormV1ToV2Mutation = {
  __typename: 'Mutation'
  migrateFormV1ToV2: {
    __typename: 'Form'
    id: ID
    name: String
    formV2: { __typename: 'FormV2'; id: ID; name: String } | null
  }
}

export type RollbackFormV1ToV2MigrationMutationVariables = Exact<{
  formId: Scalars['ID']
}>

export type RollbackFormV1ToV2MigrationMutation = {
  __typename: 'Mutation'
  rollbackFormV1ToV2Migration: {
    __typename: 'Form'
    id: ID
    name: String
    formV2: { __typename: 'FormV2'; id: ID; name: String } | null
  }
}

export type UpdateFormPageMutationVariables = Exact<{
  input: UpdateFormPageInput
}>

export type UpdateFormPageMutation = {
  __typename: 'Mutation'
  updateFormPage: { __typename: 'FormPage'; id: ID; name: String; order: Int }
}

export type DeleteFormPageMutationVariables = Exact<{
  formPageId: Scalars['ID']
}>

export type DeleteFormPageMutation = {
  __typename: 'Mutation'
  deleteFormPage: { __typename: 'FormPage'; id: ID }
}

export type CreateFormPageMutationVariables = Exact<{
  input: CreateFormPageInput
}>

export type CreateFormPageMutation = {
  __typename: 'Mutation'
  createFormPage: { __typename: 'FormPage'; id: ID; name: String; order: Int }
}

export type ReorderFormPageMutationVariables = Exact<{
  input: ReorderFormPageInput
}>

export type ReorderFormPageMutation = {
  __typename: 'Mutation'
  reorderFormPage: { __typename: 'FormPage'; id: ID; order: Int }
}

export type UpdateFormCategoryMutationVariables = Exact<{
  input: UpdateFormCategoryInput
}>

export type UpdateFormCategoryMutation = {
  __typename: 'Mutation'
  updateFormCategory: {
    __typename: 'FormCategory'
    id: ID
    name: String
    order: Int
    isArray: Boolean
    lookupTable: {
      __typename: 'Table'
      id: ID
      name: String
      icon: { __typename: 'Icon'; id: ID; name: String } | null
    } | null
  }
}

export type DeleteFormCategoryMutationVariables = Exact<{
  formCategoryId: Scalars['ID']
}>

export type DeleteFormCategoryMutation = {
  __typename: 'Mutation'
  deleteFormCategory: { __typename: 'FormCategory'; id: ID }
}

export type CreateFormCategoryMutationVariables = Exact<{
  input: CreateFormCategoryInput
}>

export type CreateFormCategoryMutation = {
  __typename: 'Mutation'
  createFormCategory: {
    __typename: 'FormCategory'
    id: ID
    name: String
    order: Int
    isArray: Boolean
    lookupTable: {
      __typename: 'Table'
      id: ID
      name: String
      icon: { __typename: 'Icon'; id: ID; name: String } | null
    } | null
  }
}

export type ReorderFormCategoryMutationVariables = Exact<{
  input: ReorderFormCategoryInput
}>

export type ReorderFormCategoryMutation = {
  __typename: 'Mutation'
  reorderFormCategory: { __typename: 'FormCategory'; id: ID; order: Int }
}

export type UpdateFormFieldMutationVariables = Exact<{
  input: UpdateFormFieldInput
}>

export type UpdateFormFieldMutation = {
  __typename: 'Mutation'
  updateFormField: {
    __typename: 'FormField'
    id: ID
    name: String
    description: String | null
    type: FormFieldType
    order: Int
    isRequired: Boolean
    isEditable: Boolean
    isVisible: Boolean
    isArray: Boolean | null
    isFrozen: Boolean
    defaultValue: JSONObject | null
    fieldOptions: Array<String> | null
    metadata: JSONObject | null
    lookupColumn: {
      __typename: 'TableColumn'
      id: ID
      name: String
      type: DataType
      innerType: DataType | null
    } | null
    lookupFilterExpression: { __typename: 'LogicExpression'; id: ID } | null
  }
}

export type DeleteFormFieldMutationVariables = Exact<{
  formFieldId: Scalars['ID']
}>

export type DeleteFormFieldMutation = {
  __typename: 'Mutation'
  deleteFormField: { __typename: 'FormField'; id: ID }
}

export type CreateFormFieldMutationVariables = Exact<{
  input: CreateFormFieldInput
}>

export type CreateFormFieldMutation = {
  __typename: 'Mutation'
  createFormField: {
    __typename: 'FormField'
    id: ID
    name: String
    type: FormFieldType
    description: String | null
    order: Int
    defaultValue: JSONObject | null
    isEditable: Boolean
    isRequired: Boolean
    isVisible: Boolean
    isArray: Boolean | null
    isFrozen: Boolean
    fieldOptions: Array<String> | null
    lookupColumn: {
      __typename: 'TableColumn'
      id: ID
      name: String
      type: DataType
      innerType: DataType | null
      table: { __typename: 'Table'; id: ID; name: String }
    } | null
  }
}

export type ReorderFormFieldMutationVariables = Exact<{
  input: ReorderFormFieldInput
}>

export type ReorderFormFieldMutation = {
  __typename: 'Mutation'
  reorderFormField: { __typename: 'FormField'; id: ID; order: Int }
}

export type LeanFormBlockFragment = {
  __typename: 'FormBlock'
  id: ID
  order: Int
  type: FormBlockType
  metadata: JSONObject | null
  input: { __typename: 'FormInput'; id: ID; label: String } | null
  inputGroup: { __typename: 'FormInputGroup'; id: ID; label: String } | null
}

export type DetailedFormBlockFragment = {
  __typename: 'FormBlock'
  id: ID
  order: Int
  type: FormBlockType
  metadata: JSONObject | null
  visibilityConditions: Array<{
    __typename: 'FormVisibilityCondition'
    id: ID
    name: String | null
    slug: String
    expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
  }>
  input: {
    __typename: 'FormInput'
    id: ID
    label: String
    description: String | null
    inputType: FormInputType
    dataType: DataType
    innerDataType: DataType | null
    indexDataType: IndexType
    isReadOnly: Boolean
    isRequired: Boolean
    isVisible: Boolean
    isFrozen: Boolean
    isMultiSelect: Boolean | null
    defaultValue: JSONObject | null
    metadata: JSONObject | null
    formatPreset: FormatPreset | null
    formatOptions: JSONObject | null
    formula: {
      __typename: 'Formula'
      id: ID
      formulaString: String | null
      outputType: DataType
    } | null
    lookupTableColumn: {
      __typename: 'TableColumn'
      id: ID
      name: String
      type: DataType
      table: { __typename: 'Table'; id: ID; name: String }
    } | null
    sourceTableColumn: {
      __typename: 'TableColumn'
      id: ID
      name: String
      type: DataType
      innerType: DataType | null
      isNullable: Boolean
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      table: { __typename: 'Table'; id: ID; name: String }
    } | null
    lookupGroup: {
      __typename: 'FormLookupInputGroup'
      id: ID
      isAutoFill: Boolean
      lookupFilterExpression: {
        __typename: 'LogicExpression'
        id: ID
        logicExpressionString: String | null
      } | null
    } | null
    validationRules: Array<{
      __typename: 'FormValidationCondition'
      validationMessage: String | null
      conditionExpression: {
        __typename: 'LogicExpression'
        condition: LogicExpressionCondition | null
        logicExpressionString: String | null
      }
    }>
  } | null
  inputGroup: {
    __typename: 'FormInputGroup'
    id: ID
    label: String
    formInputs: Array<{
      __typename: 'FormInput'
      id: ID
      label: String
      description: String | null
      inputType: FormInputType
      dataType: DataType
      innerDataType: DataType | null
      indexDataType: IndexType
      isReadOnly: Boolean
      isRequired: Boolean
      isVisible: Boolean
      isFrozen: Boolean
      isMultiSelect: Boolean | null
      defaultValue: JSONObject | null
      metadata: JSONObject | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      formBlock: {
        __typename: 'FormBlock'
        id: ID
        order: Int
        visibilityConditions: Array<{
          __typename: 'FormVisibilityCondition'
          id: ID
          name: String | null
          slug: String
          expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
        }>
      } | null
      formula: {
        __typename: 'Formula'
        id: ID
        formulaString: String | null
        outputType: DataType
      } | null
      lookupTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      sourceTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      lookupGroup: {
        __typename: 'FormLookupInputGroup'
        id: ID
        isAutoFill: Boolean
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
      } | null
      logicExpressionValues: Array<{
        __typename: 'LogicExpressionValue'
        id: ID
        order: Int
        value: JSONObject | null
      }>
      validationRules: Array<{
        __typename: 'FormValidationCondition'
        validationMessage: String | null
        conditionExpression: {
          __typename: 'LogicExpression'
          condition: LogicExpressionCondition | null
          logicExpressionString: String | null
        }
      }>
    }>
  } | null
}

export type GetFormBlockQueryVariables = Exact<{
  formBlockId: Scalars['ID']
}>

export type GetFormBlockQuery = {
  __typename: 'Query'
  formBlock: {
    __typename: 'FormBlock'
    id: ID
    order: Int
    type: FormBlockType
    metadata: JSONObject | null
    parentBlock: {
      __typename: 'FormBlock'
      id: ID
      order: Int
      type: FormBlockType
      metadata: JSONObject | null
      input: { __typename: 'FormInput'; id: ID; label: String } | null
      inputGroup: { __typename: 'FormInputGroup'; id: ID; label: String } | null
    } | null
    childBlocks: Array<{
      __typename: 'FormBlock'
      id: ID
      order: Int
      type: FormBlockType
      metadata: JSONObject | null
      input: { __typename: 'FormInput'; id: ID; label: String } | null
      inputGroup: { __typename: 'FormInputGroup'; id: ID; label: String } | null
    }>
    form: { __typename: 'FormV2'; id: ID; name: String }
    visibilityConditions: Array<{
      __typename: 'FormVisibilityCondition'
      id: ID
      name: String | null
      slug: String
      expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
    }>
    input: {
      __typename: 'FormInput'
      id: ID
      label: String
      description: String | null
      inputType: FormInputType
      dataType: DataType
      innerDataType: DataType | null
      indexDataType: IndexType
      isReadOnly: Boolean
      isRequired: Boolean
      isVisible: Boolean
      isFrozen: Boolean
      isMultiSelect: Boolean | null
      defaultValue: JSONObject | null
      metadata: JSONObject | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      formula: {
        __typename: 'Formula'
        id: ID
        formulaString: String | null
        outputType: DataType
      } | null
      lookupTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      sourceTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      lookupGroup: {
        __typename: 'FormLookupInputGroup'
        id: ID
        isAutoFill: Boolean
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
      } | null
      validationRules: Array<{
        __typename: 'FormValidationCondition'
        validationMessage: String | null
        conditionExpression: {
          __typename: 'LogicExpression'
          condition: LogicExpressionCondition | null
          logicExpressionString: String | null
        }
      }>
    } | null
    inputGroup: {
      __typename: 'FormInputGroup'
      id: ID
      label: String
      formInputs: Array<{
        __typename: 'FormInput'
        id: ID
        label: String
        description: String | null
        inputType: FormInputType
        dataType: DataType
        innerDataType: DataType | null
        indexDataType: IndexType
        isReadOnly: Boolean
        isRequired: Boolean
        isVisible: Boolean
        isFrozen: Boolean
        isMultiSelect: Boolean | null
        defaultValue: JSONObject | null
        metadata: JSONObject | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        formBlock: {
          __typename: 'FormBlock'
          id: ID
          order: Int
          visibilityConditions: Array<{
            __typename: 'FormVisibilityCondition'
            id: ID
            name: String | null
            slug: String
            expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
          }>
        } | null
        formula: {
          __typename: 'Formula'
          id: ID
          formulaString: String | null
          outputType: DataType
        } | null
        lookupTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        sourceTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          isNullable: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        lookupGroup: {
          __typename: 'FormLookupInputGroup'
          id: ID
          isAutoFill: Boolean
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        } | null
        logicExpressionValues: Array<{
          __typename: 'LogicExpressionValue'
          id: ID
          order: Int
          value: JSONObject | null
        }>
        validationRules: Array<{
          __typename: 'FormValidationCondition'
          validationMessage: String | null
          conditionExpression: {
            __typename: 'LogicExpression'
            condition: LogicExpressionCondition | null
            logicExpressionString: String | null
          }
        }>
      }>
    } | null
  }
}

export type GetFormV2QueryVariables = Exact<{
  formId: Scalars['ID']
  variantId?: InputMaybe<Scalars['ID']>
}>

export type GetFormV2Query = {
  __typename: 'Query'
  formV2: {
    __typename: 'FormV2'
    id: ID
    name: String
    slug: String
    redirectTarget: FormRedirectTarget
    redirectCustomPath: String | null
    organization: { __typename: 'Organization'; id: ID }
    blocks: Array<{
      __typename: 'FormBlock'
      id: ID
      order: Int
      type: FormBlockType
      metadata: JSONObject | null
      parentBlock: {
        __typename: 'FormBlock'
        id: ID
        order: Int
        type: FormBlockType
        metadata: JSONObject | null
        input: { __typename: 'FormInput'; id: ID; label: String } | null
        inputGroup: { __typename: 'FormInputGroup'; id: ID; label: String } | null
      } | null
      childBlocks: Array<{
        __typename: 'FormBlock'
        id: ID
        order: Int
        type: FormBlockType
        metadata: JSONObject | null
        visibilityConditions: Array<{
          __typename: 'FormVisibilityCondition'
          id: ID
          name: String | null
          slug: String
          expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
        }>
        input: {
          __typename: 'FormInput'
          id: ID
          label: String
          description: String | null
          inputType: FormInputType
          dataType: DataType
          innerDataType: DataType | null
          indexDataType: IndexType
          isReadOnly: Boolean
          isRequired: Boolean
          isVisible: Boolean
          isFrozen: Boolean
          isMultiSelect: Boolean | null
          defaultValue: JSONObject | null
          metadata: JSONObject | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          formula: {
            __typename: 'Formula'
            id: ID
            formulaString: String | null
            outputType: DataType
          } | null
          lookupTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          sourceTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            isNullable: Boolean
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          lookupGroup: {
            __typename: 'FormLookupInputGroup'
            id: ID
            isAutoFill: Boolean
            lookupFilterExpression: {
              __typename: 'LogicExpression'
              id: ID
              logicExpressionString: String | null
            } | null
          } | null
          validationRules: Array<{
            __typename: 'FormValidationCondition'
            validationMessage: String | null
            conditionExpression: {
              __typename: 'LogicExpression'
              condition: LogicExpressionCondition | null
              logicExpressionString: String | null
            }
          }>
        } | null
        inputGroup: {
          __typename: 'FormInputGroup'
          id: ID
          label: String
          formInputs: Array<{
            __typename: 'FormInput'
            id: ID
            label: String
            description: String | null
            inputType: FormInputType
            dataType: DataType
            innerDataType: DataType | null
            indexDataType: IndexType
            isReadOnly: Boolean
            isRequired: Boolean
            isVisible: Boolean
            isFrozen: Boolean
            isMultiSelect: Boolean | null
            defaultValue: JSONObject | null
            metadata: JSONObject | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            formBlock: {
              __typename: 'FormBlock'
              id: ID
              order: Int
              visibilityConditions: Array<{
                __typename: 'FormVisibilityCondition'
                id: ID
                name: String | null
                slug: String
                expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
              }>
            } | null
            formula: {
              __typename: 'Formula'
              id: ID
              formulaString: String | null
              outputType: DataType
            } | null
            lookupTableColumn: {
              __typename: 'TableColumn'
              id: ID
              name: String
              type: DataType
              table: { __typename: 'Table'; id: ID; name: String }
            } | null
            sourceTableColumn: {
              __typename: 'TableColumn'
              id: ID
              name: String
              type: DataType
              innerType: DataType | null
              isNullable: Boolean
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              table: { __typename: 'Table'; id: ID; name: String }
            } | null
            lookupGroup: {
              __typename: 'FormLookupInputGroup'
              id: ID
              isAutoFill: Boolean
              lookupFilterExpression: {
                __typename: 'LogicExpression'
                id: ID
                logicExpressionString: String | null
              } | null
            } | null
            logicExpressionValues: Array<{
              __typename: 'LogicExpressionValue'
              id: ID
              order: Int
              value: JSONObject | null
            }>
            validationRules: Array<{
              __typename: 'FormValidationCondition'
              validationMessage: String | null
              conditionExpression: {
                __typename: 'LogicExpression'
                condition: LogicExpressionCondition | null
                logicExpressionString: String | null
              }
            }>
          }>
        } | null
      }>
      visibilityConditions: Array<{
        __typename: 'FormVisibilityCondition'
        id: ID
        name: String | null
        slug: String
        expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
      }>
      input: {
        __typename: 'FormInput'
        id: ID
        label: String
        description: String | null
        inputType: FormInputType
        dataType: DataType
        innerDataType: DataType | null
        indexDataType: IndexType
        isReadOnly: Boolean
        isRequired: Boolean
        isVisible: Boolean
        isFrozen: Boolean
        isMultiSelect: Boolean | null
        defaultValue: JSONObject | null
        metadata: JSONObject | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        formula: {
          __typename: 'Formula'
          id: ID
          formulaString: String | null
          outputType: DataType
        } | null
        lookupTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        sourceTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          isNullable: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        lookupGroup: {
          __typename: 'FormLookupInputGroup'
          id: ID
          isAutoFill: Boolean
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        } | null
        validationRules: Array<{
          __typename: 'FormValidationCondition'
          validationMessage: String | null
          conditionExpression: {
            __typename: 'LogicExpression'
            condition: LogicExpressionCondition | null
            logicExpressionString: String | null
          }
        }>
      } | null
      inputGroup: {
        __typename: 'FormInputGroup'
        id: ID
        label: String
        formInputs: Array<{
          __typename: 'FormInput'
          id: ID
          label: String
          description: String | null
          inputType: FormInputType
          dataType: DataType
          innerDataType: DataType | null
          indexDataType: IndexType
          isReadOnly: Boolean
          isRequired: Boolean
          isVisible: Boolean
          isFrozen: Boolean
          isMultiSelect: Boolean | null
          defaultValue: JSONObject | null
          metadata: JSONObject | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          formBlock: {
            __typename: 'FormBlock'
            id: ID
            order: Int
            visibilityConditions: Array<{
              __typename: 'FormVisibilityCondition'
              id: ID
              name: String | null
              slug: String
              expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
            }>
          } | null
          formula: {
            __typename: 'Formula'
            id: ID
            formulaString: String | null
            outputType: DataType
          } | null
          lookupTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          sourceTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            isNullable: Boolean
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          lookupGroup: {
            __typename: 'FormLookupInputGroup'
            id: ID
            isAutoFill: Boolean
            lookupFilterExpression: {
              __typename: 'LogicExpression'
              id: ID
              logicExpressionString: String | null
            } | null
          } | null
          logicExpressionValues: Array<{
            __typename: 'LogicExpressionValue'
            id: ID
            order: Int
            value: JSONObject | null
          }>
          validationRules: Array<{
            __typename: 'FormValidationCondition'
            validationMessage: String | null
            conditionExpression: {
              __typename: 'LogicExpression'
              condition: LogicExpressionCondition | null
              logicExpressionString: String | null
            }
          }>
        }>
      } | null
    }>
    buttons: Array<{
      __typename: 'WorkspaceButton'
      id: ID
      name: String
      parentWorkspace: {
        __typename: 'Workspace'
        id: ID
        name: String | null
        parentOrganization: { __typename: 'Organization'; id: ID } | null
        table: { __typename: 'Table'; id: ID; name: String } | null
        tableRow: {
          __typename: 'TableRow'
          id: ID
          name: String
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        document: { __typename: 'Document'; id: ID; name: String } | null
        chart: { __typename: 'Chart'; id: ID; name: String } | null
      } | null
      buttonNode: {
        __typename: 'TableButtonNode'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
    }>
    lookupInputGroups: Array<{
      __typename: 'FormLookupInputGroup'
      id: ID
      isAutoFill: Boolean
      lookupTable: {
        __typename: 'Table'
        id: ID
        name: String
        isShareable: Boolean
        icon: { __typename: 'Icon'; id: ID; name: String } | null
      }
      lookupFilterExpression: {
        __typename: 'LogicExpression'
        id: ID
        logicExpressionString: String | null
      } | null
      defaultRows: Array<{ __typename: 'TableRow'; id: ID }>
      formInputs: Array<{ __typename: 'FormInput'; id: ID; label: String }>
    }>
    visibilityConditions: Array<{
      __typename: 'FormVisibilityCondition'
      id: ID
      name: String | null
      slug: String
      expression: { __typename: 'LogicExpression'; id: ID; logicExpressionString: String | null }
      controlledFormBlocks: Array<{
        __typename: 'FormBlock'
        id: ID
        type: FormBlockType
        metadata: JSONObject | null
        input: { __typename: 'FormInput'; id: ID; label: String } | null
        inputGroup: { __typename: 'FormInputGroup'; id: ID; label: String } | null
      }>
    }>
    sourceForm: { __typename: 'Form'; id: ID; name: String } | null
  }
}

export type GetFormV2ForSettingsPageQueryVariables = Exact<{
  formId: Scalars['ID']
  variantId?: InputMaybe<Scalars['ID']>
}>

export type GetFormV2ForSettingsPageQuery = {
  __typename: 'Query'
  formV2: {
    __typename: 'FormV2'
    id: ID
    name: String
    slug: String
    redirectTarget: FormRedirectTarget
    redirectCustomPath: String | null
    organization: { __typename: 'Organization'; id: ID }
    blocks: Array<{
      __typename: 'FormBlock'
      id: ID
      order: Int
      type: FormBlockType
      metadata: JSONObject | null
      parentBlock: {
        __typename: 'FormBlock'
        id: ID
        order: Int
        type: FormBlockType
        metadata: JSONObject | null
        input: { __typename: 'FormInput'; id: ID; label: String } | null
        inputGroup: { __typename: 'FormInputGroup'; id: ID; label: String } | null
      } | null
      childBlocks: Array<{
        __typename: 'FormBlock'
        id: ID
        order: Int
        type: FormBlockType
        metadata: JSONObject | null
        visibilityConditions: Array<{
          __typename: 'FormVisibilityCondition'
          id: ID
          name: String | null
          slug: String
          expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
        }>
        input: {
          __typename: 'FormInput'
          id: ID
          label: String
          description: String | null
          inputType: FormInputType
          dataType: DataType
          innerDataType: DataType | null
          indexDataType: IndexType
          isReadOnly: Boolean
          isRequired: Boolean
          isVisible: Boolean
          isFrozen: Boolean
          isMultiSelect: Boolean | null
          defaultValue: JSONObject | null
          metadata: JSONObject | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          formula: {
            __typename: 'Formula'
            id: ID
            formulaString: String | null
            outputType: DataType
          } | null
          lookupTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          sourceTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            isNullable: Boolean
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          lookupGroup: {
            __typename: 'FormLookupInputGroup'
            id: ID
            isAutoFill: Boolean
            lookupFilterExpression: {
              __typename: 'LogicExpression'
              id: ID
              logicExpressionString: String | null
            } | null
          } | null
          validationRules: Array<{
            __typename: 'FormValidationCondition'
            validationMessage: String | null
            conditionExpression: {
              __typename: 'LogicExpression'
              condition: LogicExpressionCondition | null
              logicExpressionString: String | null
            }
          }>
        } | null
        inputGroup: {
          __typename: 'FormInputGroup'
          id: ID
          label: String
          formInputs: Array<{
            __typename: 'FormInput'
            id: ID
            label: String
            description: String | null
            inputType: FormInputType
            dataType: DataType
            innerDataType: DataType | null
            indexDataType: IndexType
            isReadOnly: Boolean
            isRequired: Boolean
            isVisible: Boolean
            isFrozen: Boolean
            isMultiSelect: Boolean | null
            defaultValue: JSONObject | null
            metadata: JSONObject | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            formBlock: {
              __typename: 'FormBlock'
              id: ID
              order: Int
              visibilityConditions: Array<{
                __typename: 'FormVisibilityCondition'
                id: ID
                name: String | null
                slug: String
                expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
              }>
            } | null
            formula: {
              __typename: 'Formula'
              id: ID
              formulaString: String | null
              outputType: DataType
            } | null
            lookupTableColumn: {
              __typename: 'TableColumn'
              id: ID
              name: String
              type: DataType
              table: { __typename: 'Table'; id: ID; name: String }
            } | null
            sourceTableColumn: {
              __typename: 'TableColumn'
              id: ID
              name: String
              type: DataType
              innerType: DataType | null
              isNullable: Boolean
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              table: { __typename: 'Table'; id: ID; name: String }
            } | null
            lookupGroup: {
              __typename: 'FormLookupInputGroup'
              id: ID
              isAutoFill: Boolean
              lookupFilterExpression: {
                __typename: 'LogicExpression'
                id: ID
                logicExpressionString: String | null
              } | null
            } | null
            logicExpressionValues: Array<{
              __typename: 'LogicExpressionValue'
              id: ID
              order: Int
              value: JSONObject | null
            }>
            validationRules: Array<{
              __typename: 'FormValidationCondition'
              validationMessage: String | null
              conditionExpression: {
                __typename: 'LogicExpression'
                condition: LogicExpressionCondition | null
                logicExpressionString: String | null
              }
            }>
          }>
        } | null
      }>
      visibilityConditions: Array<{
        __typename: 'FormVisibilityCondition'
        id: ID
        name: String | null
        slug: String
        expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
      }>
      input: {
        __typename: 'FormInput'
        id: ID
        label: String
        description: String | null
        inputType: FormInputType
        dataType: DataType
        innerDataType: DataType | null
        indexDataType: IndexType
        isReadOnly: Boolean
        isRequired: Boolean
        isVisible: Boolean
        isFrozen: Boolean
        isMultiSelect: Boolean | null
        defaultValue: JSONObject | null
        metadata: JSONObject | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        formula: {
          __typename: 'Formula'
          id: ID
          formulaString: String | null
          outputType: DataType
        } | null
        lookupTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        sourceTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          isNullable: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        lookupGroup: {
          __typename: 'FormLookupInputGroup'
          id: ID
          isAutoFill: Boolean
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        } | null
        validationRules: Array<{
          __typename: 'FormValidationCondition'
          validationMessage: String | null
          conditionExpression: {
            __typename: 'LogicExpression'
            condition: LogicExpressionCondition | null
            logicExpressionString: String | null
          }
        }>
      } | null
      inputGroup: {
        __typename: 'FormInputGroup'
        id: ID
        label: String
        formInputs: Array<{
          __typename: 'FormInput'
          id: ID
          label: String
          description: String | null
          inputType: FormInputType
          dataType: DataType
          innerDataType: DataType | null
          indexDataType: IndexType
          isReadOnly: Boolean
          isRequired: Boolean
          isVisible: Boolean
          isFrozen: Boolean
          isMultiSelect: Boolean | null
          defaultValue: JSONObject | null
          metadata: JSONObject | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          formBlock: {
            __typename: 'FormBlock'
            id: ID
            order: Int
            visibilityConditions: Array<{
              __typename: 'FormVisibilityCondition'
              id: ID
              name: String | null
              slug: String
              expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
            }>
          } | null
          formula: {
            __typename: 'Formula'
            id: ID
            formulaString: String | null
            outputType: DataType
          } | null
          lookupTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          sourceTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            isNullable: Boolean
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          lookupGroup: {
            __typename: 'FormLookupInputGroup'
            id: ID
            isAutoFill: Boolean
            lookupFilterExpression: {
              __typename: 'LogicExpression'
              id: ID
              logicExpressionString: String | null
            } | null
          } | null
          logicExpressionValues: Array<{
            __typename: 'LogicExpressionValue'
            id: ID
            order: Int
            value: JSONObject | null
          }>
          validationRules: Array<{
            __typename: 'FormValidationCondition'
            validationMessage: String | null
            conditionExpression: {
              __typename: 'LogicExpression'
              condition: LogicExpressionCondition | null
              logicExpressionString: String | null
            }
          }>
        }>
      } | null
    }>
    buttons: Array<{
      __typename: 'WorkspaceButton'
      id: ID
      name: String
      parentWorkspace: {
        __typename: 'Workspace'
        id: ID
        name: String | null
        parentOrganization: { __typename: 'Organization'; id: ID } | null
        table: { __typename: 'Table'; id: ID; name: String } | null
        tableRow: {
          __typename: 'TableRow'
          id: ID
          name: String
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        document: { __typename: 'Document'; id: ID; name: String } | null
        chart: { __typename: 'Chart'; id: ID; name: String } | null
      } | null
      buttonNode: {
        __typename: 'TableButtonNode'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
    }>
    lookupInputGroups: Array<{
      __typename: 'FormLookupInputGroup'
      id: ID
      isAutoFill: Boolean
      lookupTable: {
        __typename: 'Table'
        id: ID
        name: String
        isShareable: Boolean
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        formLookupInputGroups: Array<{
          __typename: 'FormLookupInputGroup'
          id: ID
          form: {
            __typename: 'FormV2'
            id: ID
            permissions: Array<{
              __typename: 'Permission'
              id: ID
              permissionType: PermissionType
              role: { __typename: 'Role'; id: ID; roleType: RoleType }
            }>
          }
        }>
        lookupFormCategories: Array<{
          __typename: 'FormCategory'
          id: ID
          name: String
          page: {
            __typename: 'FormPage'
            id: ID
            form: { __typename: 'Form'; id: ID; isShareable: Boolean }
          }
        }>
      }
      lookupFilterExpression: {
        __typename: 'LogicExpression'
        id: ID
        logicExpressionString: String | null
      } | null
      defaultRows: Array<{ __typename: 'TableRow'; id: ID }>
      formInputs: Array<{ __typename: 'FormInput'; id: ID; label: String }>
    }>
    sourceForm: { __typename: 'Form'; id: ID; name: String } | null
    visibilityConditions: Array<{
      __typename: 'FormVisibilityCondition'
      id: ID
      name: String | null
      slug: String
      expression: { __typename: 'LogicExpression'; id: ID; logicExpressionString: String | null }
      controlledFormBlocks: Array<{
        __typename: 'FormBlock'
        id: ID
        type: FormBlockType
        metadata: JSONObject | null
        input: { __typename: 'FormInput'; id: ID; label: String } | null
        inputGroup: { __typename: 'FormInputGroup'; id: ID; label: String } | null
      }>
    }>
    permissions: Array<{
      __typename: 'Permission'
      id: ID
      permissionType: PermissionType
      role: { __typename: 'Role'; id: ID; roleType: RoleType }
    }>
  }
}

export type GetFormV2SharedQueryVariables = Exact<{
  formId: Scalars['ID']
  variantId?: InputMaybe<Scalars['ID']>
}>

export type GetFormV2SharedQuery = {
  __typename: 'Query'
  formV2: {
    __typename: 'FormV2'
    id: ID
    name: String
    slug: String
    redirectTarget: FormRedirectTarget
    redirectCustomPath: String | null
    organization: { __typename: 'Organization'; id: ID }
    blocks: Array<{
      __typename: 'FormBlock'
      id: ID
      order: Int
      type: FormBlockType
      metadata: JSONObject | null
      parentBlock: {
        __typename: 'FormBlock'
        id: ID
        order: Int
        type: FormBlockType
        metadata: JSONObject | null
        input: { __typename: 'FormInput'; id: ID; label: String } | null
        inputGroup: { __typename: 'FormInputGroup'; id: ID; label: String } | null
      } | null
      childBlocks: Array<{
        __typename: 'FormBlock'
        id: ID
        order: Int
        type: FormBlockType
        metadata: JSONObject | null
        visibilityConditions: Array<{
          __typename: 'FormVisibilityCondition'
          id: ID
          name: String | null
          slug: String
          expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
        }>
        input: {
          __typename: 'FormInput'
          id: ID
          label: String
          description: String | null
          inputType: FormInputType
          dataType: DataType
          innerDataType: DataType | null
          indexDataType: IndexType
          isReadOnly: Boolean
          isRequired: Boolean
          isVisible: Boolean
          isFrozen: Boolean
          isMultiSelect: Boolean | null
          defaultValue: JSONObject | null
          metadata: JSONObject | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          formula: {
            __typename: 'Formula'
            id: ID
            formulaString: String | null
            outputType: DataType
          } | null
          lookupTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          sourceTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            isNullable: Boolean
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          lookupGroup: {
            __typename: 'FormLookupInputGroup'
            id: ID
            isAutoFill: Boolean
            lookupFilterExpression: {
              __typename: 'LogicExpression'
              id: ID
              logicExpressionString: String | null
            } | null
          } | null
          validationRules: Array<{
            __typename: 'FormValidationCondition'
            validationMessage: String | null
            conditionExpression: {
              __typename: 'LogicExpression'
              condition: LogicExpressionCondition | null
              logicExpressionString: String | null
            }
          }>
        } | null
        inputGroup: {
          __typename: 'FormInputGroup'
          id: ID
          label: String
          formInputs: Array<{
            __typename: 'FormInput'
            id: ID
            label: String
            description: String | null
            inputType: FormInputType
            dataType: DataType
            innerDataType: DataType | null
            indexDataType: IndexType
            isReadOnly: Boolean
            isRequired: Boolean
            isVisible: Boolean
            isFrozen: Boolean
            isMultiSelect: Boolean | null
            defaultValue: JSONObject | null
            metadata: JSONObject | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            formBlock: {
              __typename: 'FormBlock'
              id: ID
              order: Int
              visibilityConditions: Array<{
                __typename: 'FormVisibilityCondition'
                id: ID
                name: String | null
                slug: String
                expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
              }>
            } | null
            formula: {
              __typename: 'Formula'
              id: ID
              formulaString: String | null
              outputType: DataType
            } | null
            lookupTableColumn: {
              __typename: 'TableColumn'
              id: ID
              name: String
              type: DataType
              table: { __typename: 'Table'; id: ID; name: String }
            } | null
            sourceTableColumn: {
              __typename: 'TableColumn'
              id: ID
              name: String
              type: DataType
              innerType: DataType | null
              isNullable: Boolean
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              table: { __typename: 'Table'; id: ID; name: String }
            } | null
            lookupGroup: {
              __typename: 'FormLookupInputGroup'
              id: ID
              isAutoFill: Boolean
              lookupFilterExpression: {
                __typename: 'LogicExpression'
                id: ID
                logicExpressionString: String | null
              } | null
            } | null
            logicExpressionValues: Array<{
              __typename: 'LogicExpressionValue'
              id: ID
              order: Int
              value: JSONObject | null
            }>
            validationRules: Array<{
              __typename: 'FormValidationCondition'
              validationMessage: String | null
              conditionExpression: {
                __typename: 'LogicExpression'
                condition: LogicExpressionCondition | null
                logicExpressionString: String | null
              }
            }>
          }>
        } | null
      }>
      visibilityConditions: Array<{
        __typename: 'FormVisibilityCondition'
        id: ID
        name: String | null
        slug: String
        expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
      }>
      input: {
        __typename: 'FormInput'
        id: ID
        label: String
        description: String | null
        inputType: FormInputType
        dataType: DataType
        innerDataType: DataType | null
        indexDataType: IndexType
        isReadOnly: Boolean
        isRequired: Boolean
        isVisible: Boolean
        isFrozen: Boolean
        isMultiSelect: Boolean | null
        defaultValue: JSONObject | null
        metadata: JSONObject | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        formula: {
          __typename: 'Formula'
          id: ID
          formulaString: String | null
          outputType: DataType
        } | null
        lookupTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        sourceTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          isNullable: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        lookupGroup: {
          __typename: 'FormLookupInputGroup'
          id: ID
          isAutoFill: Boolean
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        } | null
        validationRules: Array<{
          __typename: 'FormValidationCondition'
          validationMessage: String | null
          conditionExpression: {
            __typename: 'LogicExpression'
            condition: LogicExpressionCondition | null
            logicExpressionString: String | null
          }
        }>
      } | null
      inputGroup: {
        __typename: 'FormInputGroup'
        id: ID
        label: String
        formInputs: Array<{
          __typename: 'FormInput'
          id: ID
          label: String
          description: String | null
          inputType: FormInputType
          dataType: DataType
          innerDataType: DataType | null
          indexDataType: IndexType
          isReadOnly: Boolean
          isRequired: Boolean
          isVisible: Boolean
          isFrozen: Boolean
          isMultiSelect: Boolean | null
          defaultValue: JSONObject | null
          metadata: JSONObject | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          formBlock: {
            __typename: 'FormBlock'
            id: ID
            order: Int
            visibilityConditions: Array<{
              __typename: 'FormVisibilityCondition'
              id: ID
              name: String | null
              slug: String
              expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
            }>
          } | null
          formula: {
            __typename: 'Formula'
            id: ID
            formulaString: String | null
            outputType: DataType
          } | null
          lookupTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          sourceTableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            isNullable: Boolean
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          lookupGroup: {
            __typename: 'FormLookupInputGroup'
            id: ID
            isAutoFill: Boolean
            lookupFilterExpression: {
              __typename: 'LogicExpression'
              id: ID
              logicExpressionString: String | null
            } | null
          } | null
          logicExpressionValues: Array<{
            __typename: 'LogicExpressionValue'
            id: ID
            order: Int
            value: JSONObject | null
          }>
          validationRules: Array<{
            __typename: 'FormValidationCondition'
            validationMessage: String | null
            conditionExpression: {
              __typename: 'LogicExpression'
              condition: LogicExpressionCondition | null
              logicExpressionString: String | null
            }
          }>
        }>
      } | null
    }>
    buttons: Array<{
      __typename: 'WorkspaceButton'
      id: ID
      name: String
      parentWorkspace: {
        __typename: 'Workspace'
        id: ID
        name: String | null
        parentOrganization: { __typename: 'Organization'; id: ID } | null
        table: { __typename: 'Table'; id: ID; name: String } | null
        tableRow: {
          __typename: 'TableRow'
          id: ID
          name: String
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        document: { __typename: 'Document'; id: ID; name: String } | null
        chart: { __typename: 'Chart'; id: ID; name: String } | null
      } | null
      buttonNode: {
        __typename: 'TableButtonNode'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
    }>
    lookupInputGroups: Array<{
      __typename: 'FormLookupInputGroup'
      id: ID
      isAutoFill: Boolean
      lookupTable: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
      }
      lookupFilterExpression: {
        __typename: 'LogicExpression'
        id: ID
        logicExpressionString: String | null
      } | null
      defaultRows: Array<{ __typename: 'TableRow'; id: ID }>
      formInputs: Array<{ __typename: 'FormInput'; id: ID; label: String }>
    }>
    visibilityConditions: Array<{
      __typename: 'FormVisibilityCondition'
      id: ID
      name: String | null
      expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
    }>
  }
}

export type GetAllFormsV2QueryVariables = Exact<{ [key: string]: never }>

export type GetAllFormsV2Query = {
  __typename: 'Query'
  allFormsV2: Array<{
    __typename: 'FormV2'
    id: ID
    name: String
    isShareable: Boolean
    inputs: Array<{ __typename: 'FormInput'; id: ID; label: String }>
    workflows: Array<{ __typename: 'Workflow'; id: ID; name: String }>
  }>
}

export type CreateFormV2MutationVariables = Exact<{ [key: string]: never }>

export type CreateFormV2Mutation = {
  __typename: 'Mutation'
  createFormV2: {
    __typename: 'FormV2'
    id: ID
    name: String
    blocks: Array<{
      __typename: 'FormBlock'
      id: ID
      type: FormBlockType
      metadata: JSONObject | null
    }>
  }
}

export type CreateFormInputBlockMutationVariables = Exact<{
  input: CreateFormInputBlockInput
}>

export type CreateFormInputBlockMutation = {
  __typename: 'Mutation'
  createFormInputBlock: {
    __typename: 'FormBlock'
    id: ID
    order: Int
    type: FormBlockType
    metadata: JSONObject | null
    form: { __typename: 'FormV2'; id: ID; name: String }
    visibilityConditions: Array<{
      __typename: 'FormVisibilityCondition'
      id: ID
      name: String | null
      slug: String
      expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
    }>
    input: {
      __typename: 'FormInput'
      id: ID
      label: String
      description: String | null
      inputType: FormInputType
      dataType: DataType
      innerDataType: DataType | null
      indexDataType: IndexType
      isReadOnly: Boolean
      isRequired: Boolean
      isVisible: Boolean
      isFrozen: Boolean
      isMultiSelect: Boolean | null
      defaultValue: JSONObject | null
      metadata: JSONObject | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      formula: {
        __typename: 'Formula'
        id: ID
        formulaString: String | null
        outputType: DataType
      } | null
      lookupTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      sourceTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      lookupGroup: {
        __typename: 'FormLookupInputGroup'
        id: ID
        isAutoFill: Boolean
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
      } | null
      validationRules: Array<{
        __typename: 'FormValidationCondition'
        validationMessage: String | null
        conditionExpression: {
          __typename: 'LogicExpression'
          condition: LogicExpressionCondition | null
          logicExpressionString: String | null
        }
      }>
    } | null
    inputGroup: {
      __typename: 'FormInputGroup'
      id: ID
      label: String
      formInputs: Array<{
        __typename: 'FormInput'
        id: ID
        label: String
        description: String | null
        inputType: FormInputType
        dataType: DataType
        innerDataType: DataType | null
        indexDataType: IndexType
        isReadOnly: Boolean
        isRequired: Boolean
        isVisible: Boolean
        isFrozen: Boolean
        isMultiSelect: Boolean | null
        defaultValue: JSONObject | null
        metadata: JSONObject | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        formBlock: {
          __typename: 'FormBlock'
          id: ID
          order: Int
          visibilityConditions: Array<{
            __typename: 'FormVisibilityCondition'
            id: ID
            name: String | null
            slug: String
            expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
          }>
        } | null
        formula: {
          __typename: 'Formula'
          id: ID
          formulaString: String | null
          outputType: DataType
        } | null
        lookupTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        sourceTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          isNullable: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        lookupGroup: {
          __typename: 'FormLookupInputGroup'
          id: ID
          isAutoFill: Boolean
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        } | null
        logicExpressionValues: Array<{
          __typename: 'LogicExpressionValue'
          id: ID
          order: Int
          value: JSONObject | null
        }>
        validationRules: Array<{
          __typename: 'FormValidationCondition'
          validationMessage: String | null
          conditionExpression: {
            __typename: 'LogicExpression'
            condition: LogicExpressionCondition | null
            logicExpressionString: String | null
          }
        }>
      }>
    } | null
  }
}

export type UpdateFormInputBlockMutationVariables = Exact<{
  input: UpdateFormInputBlockInput
}>

export type UpdateFormInputBlockMutation = {
  __typename: 'Mutation'
  updateFormInputBlock: {
    __typename: 'FormBlock'
    id: ID
    order: Int
    type: FormBlockType
    metadata: JSONObject | null
    form: { __typename: 'FormV2'; id: ID; name: String }
    visibilityConditions: Array<{
      __typename: 'FormVisibilityCondition'
      id: ID
      name: String | null
      slug: String
      expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
    }>
    input: {
      __typename: 'FormInput'
      id: ID
      label: String
      description: String | null
      inputType: FormInputType
      dataType: DataType
      innerDataType: DataType | null
      indexDataType: IndexType
      isReadOnly: Boolean
      isRequired: Boolean
      isVisible: Boolean
      isFrozen: Boolean
      isMultiSelect: Boolean | null
      defaultValue: JSONObject | null
      metadata: JSONObject | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      formula: {
        __typename: 'Formula'
        id: ID
        formulaString: String | null
        outputType: DataType
      } | null
      lookupTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      sourceTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      lookupGroup: {
        __typename: 'FormLookupInputGroup'
        id: ID
        isAutoFill: Boolean
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
      } | null
      validationRules: Array<{
        __typename: 'FormValidationCondition'
        validationMessage: String | null
        conditionExpression: {
          __typename: 'LogicExpression'
          condition: LogicExpressionCondition | null
          logicExpressionString: String | null
        }
      }>
    } | null
    inputGroup: {
      __typename: 'FormInputGroup'
      id: ID
      label: String
      formInputs: Array<{
        __typename: 'FormInput'
        id: ID
        label: String
        description: String | null
        inputType: FormInputType
        dataType: DataType
        innerDataType: DataType | null
        indexDataType: IndexType
        isReadOnly: Boolean
        isRequired: Boolean
        isVisible: Boolean
        isFrozen: Boolean
        isMultiSelect: Boolean | null
        defaultValue: JSONObject | null
        metadata: JSONObject | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        formBlock: {
          __typename: 'FormBlock'
          id: ID
          order: Int
          visibilityConditions: Array<{
            __typename: 'FormVisibilityCondition'
            id: ID
            name: String | null
            slug: String
            expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
          }>
        } | null
        formula: {
          __typename: 'Formula'
          id: ID
          formulaString: String | null
          outputType: DataType
        } | null
        lookupTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        sourceTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          isNullable: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        lookupGroup: {
          __typename: 'FormLookupInputGroup'
          id: ID
          isAutoFill: Boolean
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        } | null
        logicExpressionValues: Array<{
          __typename: 'LogicExpressionValue'
          id: ID
          order: Int
          value: JSONObject | null
        }>
        validationRules: Array<{
          __typename: 'FormValidationCondition'
          validationMessage: String | null
          conditionExpression: {
            __typename: 'LogicExpression'
            condition: LogicExpressionCondition | null
            logicExpressionString: String | null
          }
        }>
      }>
    } | null
  }
}

export type ReorderFormBlockMutationVariables = Exact<{
  input: ReorderFormBlockInput
}>

export type ReorderFormBlockMutation = {
  __typename: 'Mutation'
  reorderFormBlock: {
    __typename: 'FormBlock'
    id: ID
    order: Int
    type: FormBlockType
    metadata: JSONObject | null
    form: { __typename: 'FormV2'; id: ID; name: String }
    input: { __typename: 'FormInput'; id: ID; label: String } | null
    inputGroup: { __typename: 'FormInputGroup'; id: ID; label: String } | null
  }
}

export type CreateFormLayoutBlockMutationVariables = Exact<{
  input: CreateFormLayoutBlockInput
}>

export type CreateFormLayoutBlockMutation = {
  __typename: 'Mutation'
  createFormLayoutBlock: {
    __typename: 'FormBlock'
    id: ID
    order: Int
    type: FormBlockType
    metadata: JSONObject | null
    form: { __typename: 'FormV2'; id: ID; name: String }
    visibilityConditions: Array<{
      __typename: 'FormVisibilityCondition'
      id: ID
      name: String | null
      slug: String
      expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
    }>
    input: {
      __typename: 'FormInput'
      id: ID
      label: String
      description: String | null
      inputType: FormInputType
      dataType: DataType
      innerDataType: DataType | null
      indexDataType: IndexType
      isReadOnly: Boolean
      isRequired: Boolean
      isVisible: Boolean
      isFrozen: Boolean
      isMultiSelect: Boolean | null
      defaultValue: JSONObject | null
      metadata: JSONObject | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      formula: {
        __typename: 'Formula'
        id: ID
        formulaString: String | null
        outputType: DataType
      } | null
      lookupTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      sourceTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      lookupGroup: {
        __typename: 'FormLookupInputGroup'
        id: ID
        isAutoFill: Boolean
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
      } | null
      validationRules: Array<{
        __typename: 'FormValidationCondition'
        validationMessage: String | null
        conditionExpression: {
          __typename: 'LogicExpression'
          condition: LogicExpressionCondition | null
          logicExpressionString: String | null
        }
      }>
    } | null
    inputGroup: {
      __typename: 'FormInputGroup'
      id: ID
      label: String
      formInputs: Array<{
        __typename: 'FormInput'
        id: ID
        label: String
        description: String | null
        inputType: FormInputType
        dataType: DataType
        innerDataType: DataType | null
        indexDataType: IndexType
        isReadOnly: Boolean
        isRequired: Boolean
        isVisible: Boolean
        isFrozen: Boolean
        isMultiSelect: Boolean | null
        defaultValue: JSONObject | null
        metadata: JSONObject | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        formBlock: {
          __typename: 'FormBlock'
          id: ID
          order: Int
          visibilityConditions: Array<{
            __typename: 'FormVisibilityCondition'
            id: ID
            name: String | null
            slug: String
            expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
          }>
        } | null
        formula: {
          __typename: 'Formula'
          id: ID
          formulaString: String | null
          outputType: DataType
        } | null
        lookupTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        sourceTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          isNullable: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        lookupGroup: {
          __typename: 'FormLookupInputGroup'
          id: ID
          isAutoFill: Boolean
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        } | null
        logicExpressionValues: Array<{
          __typename: 'LogicExpressionValue'
          id: ID
          order: Int
          value: JSONObject | null
        }>
        validationRules: Array<{
          __typename: 'FormValidationCondition'
          validationMessage: String | null
          conditionExpression: {
            __typename: 'LogicExpression'
            condition: LogicExpressionCondition | null
            logicExpressionString: String | null
          }
        }>
      }>
    } | null
  }
}

export type UpdateFormLayoutBlockMutationVariables = Exact<{
  input: UpdateFormLayoutBlockInput
}>

export type UpdateFormLayoutBlockMutation = {
  __typename: 'Mutation'
  updateFormLayoutBlock: {
    __typename: 'FormBlock'
    id: ID
    order: Int
    type: FormBlockType
    metadata: JSONObject | null
    form: { __typename: 'FormV2'; id: ID; name: String }
    visibilityConditions: Array<{
      __typename: 'FormVisibilityCondition'
      id: ID
      name: String | null
      slug: String
      expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
    }>
    input: {
      __typename: 'FormInput'
      id: ID
      label: String
      description: String | null
      inputType: FormInputType
      dataType: DataType
      innerDataType: DataType | null
      indexDataType: IndexType
      isReadOnly: Boolean
      isRequired: Boolean
      isVisible: Boolean
      isFrozen: Boolean
      isMultiSelect: Boolean | null
      defaultValue: JSONObject | null
      metadata: JSONObject | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      formula: {
        __typename: 'Formula'
        id: ID
        formulaString: String | null
        outputType: DataType
      } | null
      lookupTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      sourceTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      lookupGroup: {
        __typename: 'FormLookupInputGroup'
        id: ID
        isAutoFill: Boolean
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
      } | null
      validationRules: Array<{
        __typename: 'FormValidationCondition'
        validationMessage: String | null
        conditionExpression: {
          __typename: 'LogicExpression'
          condition: LogicExpressionCondition | null
          logicExpressionString: String | null
        }
      }>
    } | null
    inputGroup: {
      __typename: 'FormInputGroup'
      id: ID
      label: String
      formInputs: Array<{
        __typename: 'FormInput'
        id: ID
        label: String
        description: String | null
        inputType: FormInputType
        dataType: DataType
        innerDataType: DataType | null
        indexDataType: IndexType
        isReadOnly: Boolean
        isRequired: Boolean
        isVisible: Boolean
        isFrozen: Boolean
        isMultiSelect: Boolean | null
        defaultValue: JSONObject | null
        metadata: JSONObject | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        formBlock: {
          __typename: 'FormBlock'
          id: ID
          order: Int
          visibilityConditions: Array<{
            __typename: 'FormVisibilityCondition'
            id: ID
            name: String | null
            slug: String
            expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
          }>
        } | null
        formula: {
          __typename: 'Formula'
          id: ID
          formulaString: String | null
          outputType: DataType
        } | null
        lookupTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        sourceTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          isNullable: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        lookupGroup: {
          __typename: 'FormLookupInputGroup'
          id: ID
          isAutoFill: Boolean
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        } | null
        logicExpressionValues: Array<{
          __typename: 'LogicExpressionValue'
          id: ID
          order: Int
          value: JSONObject | null
        }>
        validationRules: Array<{
          __typename: 'FormValidationCondition'
          validationMessage: String | null
          conditionExpression: {
            __typename: 'LogicExpression'
            condition: LogicExpressionCondition | null
            logicExpressionString: String | null
          }
        }>
      }>
    } | null
  }
}

export type CreateFormTableBlockMutationVariables = Exact<{
  input: CreateFormTableBlockInput
}>

export type CreateFormTableBlockMutation = {
  __typename: 'Mutation'
  createFormTableBlock: {
    __typename: 'FormBlock'
    id: ID
    order: Int
    type: FormBlockType
    metadata: JSONObject | null
    form: { __typename: 'FormV2'; id: ID; name: String }
    visibilityConditions: Array<{
      __typename: 'FormVisibilityCondition'
      id: ID
      name: String | null
      slug: String
      expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
    }>
    input: {
      __typename: 'FormInput'
      id: ID
      label: String
      description: String | null
      inputType: FormInputType
      dataType: DataType
      innerDataType: DataType | null
      indexDataType: IndexType
      isReadOnly: Boolean
      isRequired: Boolean
      isVisible: Boolean
      isFrozen: Boolean
      isMultiSelect: Boolean | null
      defaultValue: JSONObject | null
      metadata: JSONObject | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      formula: {
        __typename: 'Formula'
        id: ID
        formulaString: String | null
        outputType: DataType
      } | null
      lookupTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      sourceTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      lookupGroup: {
        __typename: 'FormLookupInputGroup'
        id: ID
        isAutoFill: Boolean
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
      } | null
      validationRules: Array<{
        __typename: 'FormValidationCondition'
        validationMessage: String | null
        conditionExpression: {
          __typename: 'LogicExpression'
          condition: LogicExpressionCondition | null
          logicExpressionString: String | null
        }
      }>
    } | null
    inputGroup: {
      __typename: 'FormInputGroup'
      id: ID
      label: String
      formInputs: Array<{
        __typename: 'FormInput'
        id: ID
        label: String
        description: String | null
        inputType: FormInputType
        dataType: DataType
        innerDataType: DataType | null
        indexDataType: IndexType
        isReadOnly: Boolean
        isRequired: Boolean
        isVisible: Boolean
        isFrozen: Boolean
        isMultiSelect: Boolean | null
        defaultValue: JSONObject | null
        metadata: JSONObject | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        formBlock: {
          __typename: 'FormBlock'
          id: ID
          order: Int
          visibilityConditions: Array<{
            __typename: 'FormVisibilityCondition'
            id: ID
            name: String | null
            slug: String
            expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
          }>
        } | null
        formula: {
          __typename: 'Formula'
          id: ID
          formulaString: String | null
          outputType: DataType
        } | null
        lookupTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        sourceTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          isNullable: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        lookupGroup: {
          __typename: 'FormLookupInputGroup'
          id: ID
          isAutoFill: Boolean
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        } | null
        logicExpressionValues: Array<{
          __typename: 'LogicExpressionValue'
          id: ID
          order: Int
          value: JSONObject | null
        }>
        validationRules: Array<{
          __typename: 'FormValidationCondition'
          validationMessage: String | null
          conditionExpression: {
            __typename: 'LogicExpression'
            condition: LogicExpressionCondition | null
            logicExpressionString: String | null
          }
        }>
      }>
    } | null
  }
}

export type UpdateFormTableBlockMutationVariables = Exact<{
  input: UpdateFormTableBlockInput
}>

export type UpdateFormTableBlockMutation = {
  __typename: 'Mutation'
  updateFormTableBlock: {
    __typename: 'FormBlock'
    id: ID
    order: Int
    type: FormBlockType
    metadata: JSONObject | null
    form: { __typename: 'FormV2'; id: ID; name: String }
    visibilityConditions: Array<{
      __typename: 'FormVisibilityCondition'
      id: ID
      name: String | null
      slug: String
      expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
    }>
    input: {
      __typename: 'FormInput'
      id: ID
      label: String
      description: String | null
      inputType: FormInputType
      dataType: DataType
      innerDataType: DataType | null
      indexDataType: IndexType
      isReadOnly: Boolean
      isRequired: Boolean
      isVisible: Boolean
      isFrozen: Boolean
      isMultiSelect: Boolean | null
      defaultValue: JSONObject | null
      metadata: JSONObject | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      formula: {
        __typename: 'Formula'
        id: ID
        formulaString: String | null
        outputType: DataType
      } | null
      lookupTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      sourceTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      lookupGroup: {
        __typename: 'FormLookupInputGroup'
        id: ID
        isAutoFill: Boolean
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
      } | null
      validationRules: Array<{
        __typename: 'FormValidationCondition'
        validationMessage: String | null
        conditionExpression: {
          __typename: 'LogicExpression'
          condition: LogicExpressionCondition | null
          logicExpressionString: String | null
        }
      }>
    } | null
    inputGroup: {
      __typename: 'FormInputGroup'
      id: ID
      label: String
      formInputs: Array<{
        __typename: 'FormInput'
        id: ID
        label: String
        description: String | null
        inputType: FormInputType
        dataType: DataType
        innerDataType: DataType | null
        indexDataType: IndexType
        isReadOnly: Boolean
        isRequired: Boolean
        isVisible: Boolean
        isFrozen: Boolean
        isMultiSelect: Boolean | null
        defaultValue: JSONObject | null
        metadata: JSONObject | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        formBlock: {
          __typename: 'FormBlock'
          id: ID
          order: Int
          visibilityConditions: Array<{
            __typename: 'FormVisibilityCondition'
            id: ID
            name: String | null
            slug: String
            expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
          }>
        } | null
        formula: {
          __typename: 'Formula'
          id: ID
          formulaString: String | null
          outputType: DataType
        } | null
        lookupTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        sourceTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          isNullable: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        lookupGroup: {
          __typename: 'FormLookupInputGroup'
          id: ID
          isAutoFill: Boolean
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        } | null
        logicExpressionValues: Array<{
          __typename: 'LogicExpressionValue'
          id: ID
          order: Int
          value: JSONObject | null
        }>
        validationRules: Array<{
          __typename: 'FormValidationCondition'
          validationMessage: String | null
          conditionExpression: {
            __typename: 'LogicExpression'
            condition: LogicExpressionCondition | null
            logicExpressionString: String | null
          }
        }>
      }>
    } | null
  }
}

export type DeleteFormV2MutationVariables = Exact<{
  formId: Scalars['ID']
}>

export type DeleteFormV2Mutation = {
  __typename: 'Mutation'
  deleteFormV2: { __typename: 'FormV2'; id: ID; name: String }
}

export type DeleteFormBlockMutationVariables = Exact<{
  formBlockId: Scalars['ID']
}>

export type DeleteFormBlockMutation = {
  __typename: 'Mutation'
  deleteFormBlock: { __typename: 'FormBlock'; id: ID }
}

export type CreateFormRowBlockMutationVariables = Exact<{
  input: CreateFormRowBlockInput
}>

export type CreateFormRowBlockMutation = {
  __typename: 'Mutation'
  createFormRowBlock: {
    __typename: 'FormBlock'
    id: ID
    order: Int
    type: FormBlockType
    metadata: JSONObject | null
    form: { __typename: 'FormV2'; id: ID; name: String }
    visibilityConditions: Array<{
      __typename: 'FormVisibilityCondition'
      id: ID
      name: String | null
      slug: String
      expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
    }>
    input: {
      __typename: 'FormInput'
      id: ID
      label: String
      description: String | null
      inputType: FormInputType
      dataType: DataType
      innerDataType: DataType | null
      indexDataType: IndexType
      isReadOnly: Boolean
      isRequired: Boolean
      isVisible: Boolean
      isFrozen: Boolean
      isMultiSelect: Boolean | null
      defaultValue: JSONObject | null
      metadata: JSONObject | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      formula: {
        __typename: 'Formula'
        id: ID
        formulaString: String | null
        outputType: DataType
      } | null
      lookupTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      sourceTableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      lookupGroup: {
        __typename: 'FormLookupInputGroup'
        id: ID
        isAutoFill: Boolean
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
      } | null
      validationRules: Array<{
        __typename: 'FormValidationCondition'
        validationMessage: String | null
        conditionExpression: {
          __typename: 'LogicExpression'
          condition: LogicExpressionCondition | null
          logicExpressionString: String | null
        }
      }>
    } | null
    inputGroup: {
      __typename: 'FormInputGroup'
      id: ID
      label: String
      formInputs: Array<{
        __typename: 'FormInput'
        id: ID
        label: String
        description: String | null
        inputType: FormInputType
        dataType: DataType
        innerDataType: DataType | null
        indexDataType: IndexType
        isReadOnly: Boolean
        isRequired: Boolean
        isVisible: Boolean
        isFrozen: Boolean
        isMultiSelect: Boolean | null
        defaultValue: JSONObject | null
        metadata: JSONObject | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        formBlock: {
          __typename: 'FormBlock'
          id: ID
          order: Int
          visibilityConditions: Array<{
            __typename: 'FormVisibilityCondition'
            id: ID
            name: String | null
            slug: String
            expression: { __typename: 'LogicExpression'; logicExpressionString: String | null }
          }>
        } | null
        formula: {
          __typename: 'Formula'
          id: ID
          formulaString: String | null
          outputType: DataType
        } | null
        lookupTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        sourceTableColumn: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          isNullable: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
        } | null
        lookupGroup: {
          __typename: 'FormLookupInputGroup'
          id: ID
          isAutoFill: Boolean
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        } | null
        logicExpressionValues: Array<{
          __typename: 'LogicExpressionValue'
          id: ID
          order: Int
          value: JSONObject | null
        }>
        validationRules: Array<{
          __typename: 'FormValidationCondition'
          validationMessage: String | null
          conditionExpression: {
            __typename: 'LogicExpression'
            condition: LogicExpressionCondition | null
            logicExpressionString: String | null
          }
        }>
      }>
    } | null
  }
}

export type GetTablesForFormColumnLinkQueryVariables = Exact<{ [key: string]: never }>

export type GetTablesForFormColumnLinkQuery = {
  __typename: 'Query'
  tables: Array<{
    __typename: 'Table'
    id: ID
    name: String
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      description: String | null
      order: Int
      type: DataType
      innerType: DataType | null
      isNullable: Boolean
      isReadOnly: Boolean
      isDecimal: Boolean
      enumOptions: Array<String> | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      lookupColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      lookupColumnGroup: {
        __typename: 'LookupTableColumnGroup'
        id: ID
        lookupTable: { __typename: 'Table'; id: ID; name: String }
      } | null
      enumSet: {
        __typename: 'EnumSet'
        id: ID
        options: Array<{
          __typename: 'EnumOption'
          id: ID
          label: String
          colorPreset: EnumColorPreset | null
          colorCustom: String | null
          iconName: String | null
          order: Int
          icon: { __typename: 'Icon'; id: ID } | null
        }>
      } | null
    }>
  }>
}

export type GetFormVariantsQueryVariables = Exact<{
  formId: Scalars['ID']
}>

export type GetFormVariantsQuery = {
  __typename: 'Query'
  formVariants: Array<{
    __typename: 'FormVariant'
    id: ID
    name: String
    description: String | null
    form: { __typename: 'FormV2'; id: ID; name: String }
  }>
}

export type GetFormVariantQueryVariables = Exact<{
  variantId: Scalars['ID']
}>

export type GetFormVariantQuery = {
  __typename: 'Query'
  formVariant: {
    __typename: 'FormVariant'
    id: ID
    name: String
    description: String | null
    form: { __typename: 'FormV2'; id: ID; name: String }
    variantInputs: Array<{
      __typename: 'FormVariantInput'
      id: ID
      defaultValue: JSONObject
      isReadOnly: Boolean
      input: {
        __typename: 'FormInput'
        id: ID
        label: String
        inputType: FormInputType
        formBlock: { __typename: 'FormBlock'; id: ID } | null
      }
    }>
  }
}

export type GetVariantsWithInputOverrideQueryVariables = Exact<{
  inputId: Scalars['ID']
}>

export type GetVariantsWithInputOverrideQuery = {
  __typename: 'Query'
  variantsWithInputOverride: Array<{ __typename: 'FormVariant'; id: ID; name: String }>
}

export type CreateFormVariantMutationVariables = Exact<{
  input: CreateFormVariantInput
}>

export type CreateFormVariantMutation = {
  __typename: 'Mutation'
  createFormVariant: {
    __typename: 'FormVariant'
    id: ID
    name: String
    description: String | null
    form: { __typename: 'FormV2'; id: ID; name: String }
  }
}

export type UpdateFormVariantMutationVariables = Exact<{
  input: UpdateFormVariantInput
}>

export type UpdateFormVariantMutation = {
  __typename: 'Mutation'
  updateFormVariant: { __typename: 'FormVariant'; id: ID; name: String; description: String | null }
}

export type DeleteFormVariantMutationVariables = Exact<{
  variantId: Scalars['ID']
}>

export type DeleteFormVariantMutation = {
  __typename: 'Mutation'
  deleteFormVariant: { __typename: 'FormVariant'; id: ID; name: String }
}

export type UpdateVariantInputValueMutationVariables = Exact<{
  input: UpdateVariantInputValueInput
}>

export type UpdateVariantInputValueMutation = {
  __typename: 'Mutation'
  updateVariantInputValue: {
    __typename: 'FormVariantInput'
    id: ID
    defaultValue: JSONObject
    isReadOnly: Boolean
    input: { __typename: 'FormInput'; id: ID; label: String }
  }
}

export type DeleteVariantInputValueMutationVariables = Exact<{
  variantId: Scalars['ID']
  inputId: Scalars['ID']
}>

export type DeleteVariantInputValueMutation = {
  __typename: 'Mutation'
  deleteVariantInputValue: { __typename: 'FormVariantInput'; id: ID }
}

export type GetFormInputRelatedActionStepsQueryVariables = Exact<{
  input: RelatedEntitiesInput
}>

export type GetFormInputRelatedActionStepsQuery = {
  __typename: 'Query'
  relatedActionSteps: {
    __typename: 'RelatedActionStepsResult'
    readSteps: Array<{
      __typename: 'ActionStep'
      id: ID
      name: String
      type: ActionStepType
      status: ActionStepStatus
      rootAction: {
        __typename: 'Action'
        id: ID
        name: String
        status: ActionStatus
        workflow: { __typename: 'Workflow'; id: ID; name: String }
      }
    }>
    writeSteps: Array<{
      __typename: 'ActionStep'
      id: ID
      name: String
      type: ActionStepType
      status: ActionStepStatus
      rootAction: {
        __typename: 'Action'
        id: ID
        name: String
        status: ActionStatus
        workflow: { __typename: 'Workflow'; id: ID; name: String }
      }
    }>
  }
}

export type SubmitFormV2MutationVariables = Exact<{
  input: SubmitFormV2Input
}>

export type SubmitFormV2Mutation = {
  __typename: 'Mutation'
  submitFormV2: {
    __typename: 'FormV2'
    id: ID
    name: String
    redirectTarget: FormRedirectTarget
    redirectCustomPath: String | null
  }
}

export type FormV2FilesQueryVariables = Exact<{
  formV2Id: Scalars['ID']
}>

export type FormV2FilesQuery = {
  __typename: 'Query'
  formV2Files: Array<{
    __typename: 'FormV2File'
    type: GeneratedFileType
    name: String | null
    mappings: Array<{ __typename: 'FormV2FileMapping'; formInputId: ID; fileFieldId: ID }>
  }>
}

export type DetailedFormFragment = {
  __typename: 'Form'
  id: ID
  name: String
  isShareable: Boolean
  redirectTarget: FormRedirectTarget
  redirectCustomPath: String | null
  organization: { __typename: 'Organization'; id: ID }
  pages: Array<{
    __typename: 'FormPage'
    id: ID
    name: String
    order: Int
    categories: Array<{
      __typename: 'FormCategory'
      id: ID
      name: String
      order: Int
      isArray: Boolean
      allowFillAll: Boolean
      fields: Array<{
        __typename: 'FormField'
        id: ID
        name: String
        description: String | null
        type: FormFieldType
        order: Int
        isRequired: Boolean
        isEditable: Boolean
        isVisible: Boolean
        isArray: Boolean | null
        isFrozen: Boolean
        displayImagesInline: Boolean
        defaultValue: JSONObject | null
        fieldOptions: Array<String> | null
        metadata: JSONObject | null
        lookupColumn: { __typename: 'TableColumn'; id: ID; name: String; type: DataType } | null
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
      }>
      lookupTable: {
        __typename: 'Table'
        id: ID
        name: String
        columns: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          order: Int
          enumOptions: Array<String> | null
          isNullable: Boolean
          displayImagesInline: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          lookupColumn: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
          } | null
          resolvedSourceColumn: {
            __typename: 'ResolvedTableColumnInfo'
            column: {
              __typename: 'TableColumn'
              id: ID
              type: DataType
              innerType: DataType | null
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              enumSet: {
                __typename: 'EnumSet'
                id: ID
                options: Array<{
                  __typename: 'EnumOption'
                  id: ID
                  label: String
                  colorPreset: EnumColorPreset | null
                  colorCustom: String | null
                  iconName: String | null
                  order: Int
                  icon: { __typename: 'Icon'; id: ID } | null
                }>
              } | null
            }
          }
        }>
        parentTable: { __typename: 'Table'; id: ID } | null
      } | null
    }>
  }>
  formFiles: Array<{
    __typename: 'FormFile'
    id: ID
    type: GeneratedFileType
    nameField: {
      __typename: 'FormField'
      id: ID
      category: { __typename: 'FormCategory'; id: ID; page: { __typename: 'FormPage'; id: ID } }
      lookupColumn: { __typename: 'TableColumn'; id: ID } | null
    } | null
    fieldMappings: Array<{
      __typename: 'GeneratedFileFieldMapping'
      id: ID
      formField: { __typename: 'FormField'; id: ID }
      fileField: { __typename: 'GeneratedFileField'; id: ID }
    }> | null
    formCategory: { __typename: 'FormCategory'; id: ID } | null
  }>
  formV2: { __typename: 'FormV2'; id: ID; name: String } | null
}

export type GetFormQueryVariables = Exact<{
  formId: Scalars['ID']
}>

export type GetFormQuery = {
  __typename: 'Query'
  form: {
    __typename: 'Form'
    id: ID
    name: String
    isShareable: Boolean
    redirectTarget: FormRedirectTarget
    redirectCustomPath: String | null
    organization: { __typename: 'Organization'; id: ID }
    pages: Array<{
      __typename: 'FormPage'
      id: ID
      name: String
      order: Int
      categories: Array<{
        __typename: 'FormCategory'
        id: ID
        name: String
        order: Int
        isArray: Boolean
        allowFillAll: Boolean
        fields: Array<{
          __typename: 'FormField'
          id: ID
          name: String
          description: String | null
          type: FormFieldType
          order: Int
          isRequired: Boolean
          isEditable: Boolean
          isVisible: Boolean
          isArray: Boolean | null
          isFrozen: Boolean
          displayImagesInline: Boolean
          defaultValue: JSONObject | null
          fieldOptions: Array<String> | null
          metadata: JSONObject | null
          lookupColumn: { __typename: 'TableColumn'; id: ID; name: String; type: DataType } | null
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        }>
        lookupTable: {
          __typename: 'Table'
          id: ID
          name: String
          columns: Array<{
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            order: Int
            enumOptions: Array<String> | null
            isNullable: Boolean
            displayImagesInline: Boolean
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            lookupColumn: {
              __typename: 'TableColumn'
              id: ID
              type: DataType
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
            } | null
            resolvedSourceColumn: {
              __typename: 'ResolvedTableColumnInfo'
              column: {
                __typename: 'TableColumn'
                id: ID
                type: DataType
                innerType: DataType | null
                formatPreset: FormatPreset | null
                formatOptions: JSONObject | null
                enumSet: {
                  __typename: 'EnumSet'
                  id: ID
                  options: Array<{
                    __typename: 'EnumOption'
                    id: ID
                    label: String
                    colorPreset: EnumColorPreset | null
                    colorCustom: String | null
                    iconName: String | null
                    order: Int
                    icon: { __typename: 'Icon'; id: ID } | null
                  }>
                } | null
              }
            }
          }>
          parentTable: { __typename: 'Table'; id: ID } | null
        } | null
      }>
    }>
    formFiles: Array<{
      __typename: 'FormFile'
      id: ID
      type: GeneratedFileType
      nameField: {
        __typename: 'FormField'
        id: ID
        category: { __typename: 'FormCategory'; id: ID; page: { __typename: 'FormPage'; id: ID } }
        lookupColumn: { __typename: 'TableColumn'; id: ID } | null
      } | null
      fieldMappings: Array<{
        __typename: 'GeneratedFileFieldMapping'
        id: ID
        formField: { __typename: 'FormField'; id: ID }
        fileField: { __typename: 'GeneratedFileField'; id: ID }
      }> | null
      formCategory: { __typename: 'FormCategory'; id: ID } | null
    }>
    formV2: { __typename: 'FormV2'; id: ID; name: String } | null
  }
}

export type GetSimpleFormV2QueryVariables = Exact<{
  formId: Scalars['ID']
}>

export type GetSimpleFormV2Query = {
  __typename: 'Query'
  formV2: { __typename: 'FormV2'; id: ID; name: String }
}

export type UpdatedFormSubscriptionVariables = Exact<{
  formId: Scalars['ID']
}>

export type UpdatedFormSubscription = {
  __typename: 'Subscription'
  updatedForm: {
    __typename: 'Form'
    id: ID
    name: String
    isShareable: Boolean
    redirectTarget: FormRedirectTarget
    redirectCustomPath: String | null
    organization: { __typename: 'Organization'; id: ID }
    pages: Array<{
      __typename: 'FormPage'
      id: ID
      name: String
      order: Int
      categories: Array<{
        __typename: 'FormCategory'
        id: ID
        name: String
        order: Int
        isArray: Boolean
        allowFillAll: Boolean
        fields: Array<{
          __typename: 'FormField'
          id: ID
          name: String
          description: String | null
          type: FormFieldType
          order: Int
          isRequired: Boolean
          isEditable: Boolean
          isVisible: Boolean
          isArray: Boolean | null
          isFrozen: Boolean
          displayImagesInline: Boolean
          defaultValue: JSONObject | null
          fieldOptions: Array<String> | null
          metadata: JSONObject | null
          lookupColumn: { __typename: 'TableColumn'; id: ID; name: String; type: DataType } | null
          lookupFilterExpression: {
            __typename: 'LogicExpression'
            id: ID
            logicExpressionString: String | null
          } | null
        }>
        lookupTable: {
          __typename: 'Table'
          id: ID
          name: String
          columns: Array<{
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            order: Int
            enumOptions: Array<String> | null
            isNullable: Boolean
            displayImagesInline: Boolean
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            lookupColumn: {
              __typename: 'TableColumn'
              id: ID
              type: DataType
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
            } | null
            resolvedSourceColumn: {
              __typename: 'ResolvedTableColumnInfo'
              column: {
                __typename: 'TableColumn'
                id: ID
                type: DataType
                innerType: DataType | null
                formatPreset: FormatPreset | null
                formatOptions: JSONObject | null
                enumSet: {
                  __typename: 'EnumSet'
                  id: ID
                  options: Array<{
                    __typename: 'EnumOption'
                    id: ID
                    label: String
                    colorPreset: EnumColorPreset | null
                    colorCustom: String | null
                    iconName: String | null
                    order: Int
                    icon: { __typename: 'Icon'; id: ID } | null
                  }>
                } | null
              }
            }
          }>
          parentTable: { __typename: 'Table'; id: ID } | null
        } | null
      }>
    }>
    formFiles: Array<{
      __typename: 'FormFile'
      id: ID
      type: GeneratedFileType
      nameField: {
        __typename: 'FormField'
        id: ID
        category: { __typename: 'FormCategory'; id: ID; page: { __typename: 'FormPage'; id: ID } }
        lookupColumn: { __typename: 'TableColumn'; id: ID } | null
      } | null
      fieldMappings: Array<{
        __typename: 'GeneratedFileFieldMapping'
        id: ID
        formField: { __typename: 'FormField'; id: ID }
        fileField: { __typename: 'GeneratedFileField'; id: ID }
      }> | null
      formCategory: { __typename: 'FormCategory'; id: ID } | null
    }>
    formV2: { __typename: 'FormV2'; id: ID; name: String } | null
  }
}

export type SubmitFormMutationVariables = Exact<{
  input: SubmitFormInput
}>

export type SubmitFormMutation = {
  __typename: 'Mutation'
  submitForm: {
    __typename: 'Form'
    id: ID
    name: String
    redirectTarget: FormRedirectTarget
    redirectCustomPath: String | null
  }
}

export type GetLookupCellQueryVariables = Exact<{
  tableCellId: Scalars['ID']
}>

export type GetLookupCellQuery = {
  __typename: 'Query'
  tableCell: {
    __typename: 'TableCell'
    id: ID
    userVisibleValue: String | null
    data: JSONObject | null
    column: {
      __typename: 'TableColumn'
      id: ID
      name: String
      type: DataType
      order: Int
      enumOptions: Array<String> | null
      innerType: DataType | null
      isNullable: Boolean
      displayImagesInline: Boolean
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      resolvedSourceColumn: {
        __typename: 'ResolvedTableColumnInfo'
        column: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          innerType: DataType | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }
      }
    }
    row: { __typename: 'TableRow'; id: ID }
    documents: Array<{ __typename: 'Document'; id: ID }>
  }
}

export type CreateFormMutationVariables = Exact<{
  input: CreateFormInput
}>

export type CreateFormMutation = {
  __typename: 'Mutation'
  createForm: {
    __typename: 'Form'
    id: ID
    name: String
    buttons: Array<{ __typename: 'WorkspaceButton'; id: ID; name: String }>
    pages: Array<{
      __typename: 'FormPage'
      id: ID
      name: String
      categories: Array<{
        __typename: 'FormCategory'
        id: ID
        name: String
        fields: Array<{ __typename: 'FormField'; id: ID; name: String }>
      }>
    }>
  }
}

export type CreateSignatureMutationVariables = Exact<{
  input: CreateSignatureInput
}>

export type CreateSignatureMutation = {
  __typename: 'Mutation'
  createSignature: {
    __typename: 'Signature'
    id: ID
    signatureFile: { __typename: 'Document'; id: ID }
  }
}

export type ShareFormV2MutationVariables = Exact<{
  input: ShareFormV2Input
}>

export type ShareFormV2Mutation = {
  __typename: 'Mutation'
  shareFormV2: {
    __typename: 'FormV2'
    id: ID
    name: String
    slug: String
    redirectTarget: FormRedirectTarget
    redirectCustomPath: String | null
    lookupInputGroups: Array<{
      __typename: 'FormLookupInputGroup'
      id: ID
      lookupTable: { __typename: 'Table'; id: ID; isShareable: Boolean }
    }>
    permissions: Array<{
      __typename: 'Permission'
      id: ID
      permissionType: PermissionType
      role: { __typename: 'Role'; id: ID; roleType: RoleType }
    }>
  }
}

export type UnshareFormV2MutationVariables = Exact<{
  input: UnshareFormV2Input
}>

export type UnshareFormV2Mutation = {
  __typename: 'Mutation'
  unshareFormV2: {
    __typename: 'FormV2'
    id: ID
    name: String
    slug: String
    redirectTarget: FormRedirectTarget
    redirectCustomPath: String | null
    lookupInputGroups: Array<{
      __typename: 'FormLookupInputGroup'
      id: ID
      lookupTable: { __typename: 'Table'; id: ID; isShareable: Boolean }
    }>
    permissions: Array<{
      __typename: 'Permission'
      id: ID
      permissionType: PermissionType
      role: { __typename: 'Role'; id: ID; roleType: RoleType }
    }>
  }
}

export type GetFormulaQueryVariables = Exact<{
  formulaId: Scalars['ID']
}>

export type GetFormulaQuery = {
  __typename: 'Query'
  formula: {
    __typename: 'Formula'
    id: ID
    operator: FormulaOperator
    formulaValues: Array<{
      __typename: 'FormulaValue'
      id: ID
      order: Int
      tableColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
      formula: { __typename: 'Formula'; id: ID } | null
    }>
  }
}

export type GetFormulaJsonQueryVariables = Exact<{
  formulaId: Scalars['ID']
}>

export type GetFormulaJsonQuery = { __typename: 'Query'; formulaJson: JSONObject | null }

export type GetFormulaPopoverQueryVariables = Exact<{
  formulaId: Scalars['ID']
}>

export type GetFormulaPopoverQuery = {
  __typename: 'Query'
  formulaJson: JSONObject | null
  formula: { __typename: 'Formula'; id: ID; formulaString: String | null }
}

export type GuestDestinationHrefQueryVariables = Exact<{
  input: GuestDestinationInput
}>

export type GuestDestinationHrefQuery = { __typename: 'Query'; guestDestinationHref: String | null }

export type CreateStripeAccountMutationVariables = Exact<{
  isStaging: Scalars['Boolean']
}>

export type CreateStripeAccountMutation = { __typename: 'Mutation'; createStripeAccount: String }

export type GetStripeAccountSecretMutationVariables = Exact<{
  accountId: Scalars['String']
  isStaging: Scalars['Boolean']
}>

export type GetStripeAccountSecretMutation = {
  __typename: 'Mutation'
  getStripeAccountSecret: String
}

export type CreateStripeFinancialConnectionsCustomerMutationVariables = Exact<{
  organizationId: Scalars['String']
}>

export type CreateStripeFinancialConnectionsCustomerMutation = {
  __typename: 'Mutation'
  createStripeFinancialConnectionsCustomer: String
}

export type CreateStripeFinancialConnectionsSessionMutationVariables = Exact<{
  customerId: Scalars['String']
}>

export type CreateStripeFinancialConnectionsSessionMutation = {
  __typename: 'Mutation'
  createStripeFinancialConnectionsSession: String
}

export type RequestIntegration2FaCodeMutationVariables = Exact<{
  input: RequestIntegration2FaCodeInput
}>

export type RequestIntegration2FaCodeMutation = {
  __typename: 'Mutation'
  requestIntegration2FACode: { __typename: 'Integration'; id: ID }
}

export type GetNetsuitePublicKeyQueryVariables = Exact<{
  integrationId: Scalars['ID']
}>

export type GetNetsuitePublicKeyQuery = {
  __typename: 'Query'
  getNetsuitePublicKey: {
    __typename: 'NetsuitePublicKey'
    publicKey: String
    certificateExpiresAt: DateTime | null
    expirationWarning: String | null
  }
}

export type ShipStationDirectLoginUrlQueryVariables = Exact<{
  integrationId: Scalars['ID']
}>

export type ShipStationDirectLoginUrlQuery = {
  __typename: 'Query'
  shipStationDirectLoginUrl: String
}

export type UpdateIntegrationCredentialsMutationVariables = Exact<{
  input: UpdateIntegrationCredentialsInput
}>

export type UpdateIntegrationCredentialsMutation = {
  __typename: 'Mutation'
  updateIntegrationCredentials: { __typename: 'Integration'; id: ID }
}

export type RegenerateNetsuiteCertificateMutationVariables = Exact<{
  integrationId: Scalars['ID']
}>

export type RegenerateNetsuiteCertificateMutation = {
  __typename: 'Mutation'
  regenerateNetsuiteCertificate: {
    __typename: 'NetsuitePublicKey'
    publicKey: String
    certificateExpiresAt: DateTime | null
    expirationWarning: String | null
  }
}

export type CreateIntegrationMutationVariables = Exact<{
  input: CreateIntegrationInput
}>

export type CreateIntegrationMutation = {
  __typename: 'Mutation'
  createIntegration: { __typename: 'Integration'; id: ID; status: IntegrationStatus }
}

export type UpdateIntegrationMutationVariables = Exact<{
  input: UpdateIntegrationInput
}>

export type UpdateIntegrationMutation = {
  __typename: 'Mutation'
  updateIntegration: {
    __typename: 'Integration'
    id: ID
    metadata: JSONObject
    status: IntegrationStatus
  }
}

export type DeleteIntegrationMutationVariables = Exact<{
  integrationId: Scalars['ID']
}>

export type DeleteIntegrationMutation = {
  __typename: 'Mutation'
  deleteIntegration: { __typename: 'Integration'; id: ID }
}

export type AuthorizeIntegrationMutationVariables = Exact<{
  input: AuthorizeIntegrationInput
}>

export type AuthorizeIntegrationMutation = {
  __typename: 'Mutation'
  authorizeIntegration: {
    __typename: 'Integration'
    id: ID
    type: IntegrationType
    status: IntegrationStatus
    metadata: JSONObject
    installLink: String | null
    authType: Array<String | null> | null
  }
}

export type GetIntegrationsQueryVariables = Exact<{
  organizationId: Scalars['ID']
}>

export type GetIntegrationsQuery = {
  __typename: 'Query'
  integrations: Array<{
    __typename: 'Integration'
    id: ID
    type: IntegrationType
    metadata: JSONObject
    status: IntegrationStatus
    installLink: String | null
    authType: Array<String | null> | null
  }>
}

export type GetIntegrationAuthUriQueryVariables = Exact<{
  input: GetIntegrationAuthorizationUriInput
}>

export type GetIntegrationAuthUriQuery = {
  __typename: 'Query'
  integrationAuthorizationUri: String
}

export type VerifyIntegrationRequestQueryVariables = Exact<{
  input: VerifyIntegrationRequestInput
}>

export type VerifyIntegrationRequestQuery = {
  __typename: 'Query'
  verifyIntegrationRequest: String
}

export type TestIntegrationQueryVariables = Exact<{
  integrationId: Scalars['ID']
}>

export type TestIntegrationQuery = {
  __typename: 'Query'
  testIntegration: {
    __typename: 'IntegrationTestResult'
    isValid: Boolean
    invalidReason: String | null
  }
}

export type NavigationItemsQueryVariables = Exact<{ [key: string]: never }>

export type NavigationItemsQuery = {
  __typename: 'Query'
  navigationItems: Array<{
    __typename: 'ResolvedNavigationItem'
    id: ID
    parentId: ID | null
    order: Int
    label: String
    icon: String | null
    href: String | null
    destination:
      | { __typename: 'Embed' }
      | { __typename: 'FormV2' }
      | { __typename: 'Table' }
      | { __typename: 'TableTab' }
      | { __typename: 'Workspace' }
      | null
  }>
}

export type GetRootWorkspacesQueryVariables = Exact<{ [key: string]: never }>

export type GetRootWorkspacesQuery = {
  __typename: 'Query'
  rootWorkspaces: Array<{ __typename: 'Workspace'; id: ID; name: String | null; order: Int | null }>
}

export type GetSwitchableOrganizationsQueryVariables = Exact<{ [key: string]: never }>

export type GetSwitchableOrganizationsQuery = {
  __typename: 'Query'
  switchableOrganizations: Array<{
    __typename: 'SwitchableOrganization'
    organizationId: ID
    organizationName: String
    logoUrl: String | null
    isCurrent: Boolean
  }>
}

export type GetLogicExpressionJsonQueryVariables = Exact<{
  logicExpressionId: Scalars['ID']
}>

export type GetLogicExpressionJsonQuery = {
  __typename: 'Query'
  logicExpressionJson: JSONObject | null
}

export type GetBreadcrumbsQueryVariables = Exact<{
  input: BreadcrumbsInput
}>

export type GetBreadcrumbsQuery = {
  __typename: 'Query'
  breadcrumbs: Array<{
    __typename: 'Breadcrumb'
    objectId: ID
    type: BreadcrumbObjectType
    name: String
    iconName: String | null
  }>
}

export type SearchQueryVariables = Exact<{
  searchString: Scalars['String']
}>

export type SearchQuery = {
  __typename: 'Query'
  rows: {
    __typename: 'PaginatedTableRows'
    rows: Array<{
      __typename: 'TableRow'
      id: ID
      name: String
      cells: Array<{
        __typename: 'TableCell'
        id: ID
        userVisibleValue: String | null
        column: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          indexType: IndexType
          indexPrefix: String
          indexSuffix: String
          order: Int
          name: String
        }
      }>
      table: { __typename: 'Table'; id: ID; name: String }
      parentRow: { __typename: 'TableRow'; id: ID } | null
    }>
  }
  tables: {
    __typename: 'PaginatedTables'
    tables: Array<{ __typename: 'Table'; id: ID; name: String }>
  }
  documents: {
    __typename: 'PaginatedDocuments'
    documents: Array<{ __typename: 'Document'; id: ID; name: String; storageUrl: String }>
  }
  forms: {
    __typename: 'PaginatedForms'
    forms: Array<{
      __typename: 'Form'
      id: ID
      name: String
      buttons: Array<{ __typename: 'WorkspaceButton'; id: ID; name: String }>
    }>
  }
  formsV2: {
    __typename: 'PaginatedFormsV2'
    formsV2: Array<{
      __typename: 'FormV2'
      id: ID
      name: String
      buttons: Array<{ __typename: 'WorkspaceButton'; id: ID; name: String }>
    }>
  }
}

export type GetWorkflowNameQueryVariables = Exact<{
  workflowId: Scalars['ID']
}>

export type GetWorkflowNameQuery = {
  __typename: 'Query'
  workflow: {
    __typename: 'Workflow'
    id: ID
    name: String
    actions: Array<{ __typename: 'Action'; id: ID; name: String }>
  }
}

export type GetWorkspaceByObjectQueryVariables = Exact<{
  input: BreadcrumbsInput
}>

export type GetWorkspaceByObjectQuery = {
  __typename: 'Query'
  workspaceByObject: {
    __typename: 'Workspace'
    id: ID
    actionButtons: Array<{
      __typename: 'WorkspaceButton'
      id: ID
      name: String
      order: Int
      manualTrigger: {
        __typename: 'ActionManualTrigger'
        id: ID
        action: {
          __typename: 'Action'
          id: ID
          status: ActionStatus
          workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
        } | null
      } | null
      form: { __typename: 'Form'; id: ID } | null
      formV2: { __typename: 'FormV2'; id: ID } | null
    }>
    views: Array<{
      __typename: 'View'
      id: ID
      order: Int
      viewableObjectType: ViewableObjectType
      chart: { __typename: 'Chart'; id: ID; name: String; chartType: ChartType } | null
      workspace: { __typename: 'Workspace'; id: ID; name: String | null } | null
      table: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        tableTabs: Array<{ __typename: 'TableTab'; id: ID; order: Int }>
      } | null
      tableRow: { __typename: 'TableRow'; id: ID; name: String } | null
      document: { __typename: 'Document'; id: ID; name: String } | null
      embed: { __typename: 'Embed'; id: ID; name: String } | null
    }>
  }
}

export type PushCommentNotificationSubscriptionVariables = Exact<{ [key: string]: never }>

export type PushCommentNotificationSubscription = {
  __typename: 'Subscription'
  pushCommentNotification: {
    __typename: 'Notification'
    id: ID
    notificationType: NotificationType
    isRead: Boolean
    isArchived: Boolean
    comment: { __typename: 'Comment'; id: ID } | null
    user: { __typename: 'Membership'; id: ID; firstName: String; lastName: String }
  }
}

export type MarkNotificationAsReadMutationVariables = Exact<{
  notificationId: Scalars['ID']
}>

export type MarkNotificationAsReadMutation = {
  __typename: 'Mutation'
  markNotificationAsRead: { __typename: 'Notification'; id: ID }
}

export type MarkNotificationAsUnreadMutationVariables = Exact<{
  notificationId: Scalars['ID']
}>

export type MarkNotificationAsUnreadMutation = {
  __typename: 'Mutation'
  markNotificationAsUnread: { __typename: 'Notification'; id: ID }
}

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never }>

export type MarkAllNotificationsAsReadMutation = {
  __typename: 'Mutation'
  markAllNotificationsAsRead: Array<{ __typename: 'Notification'; id: ID }>
}

export type MarkNotificationAsArchivedMutationVariables = Exact<{
  notificationId: Scalars['ID']
}>

export type MarkNotificationAsArchivedMutation = {
  __typename: 'Mutation'
  markNotificationAsArchived: { __typename: 'Notification'; id: ID }
}

export type PushRowButtonNodesSubscriptionVariables = Exact<{
  input: TableRowSubscriptionInput
}>

export type PushRowButtonNodesSubscription = {
  __typename: 'Subscription'
  pushRowButtonNodes: {
    __typename: 'TableRow'
    id: ID
    currentButtonNodes: Array<{
      __typename: 'TableButtonNode'
      id: ID
      name: String
      workspaceButtons: Array<{
        __typename: 'WorkspaceButton'
        id: ID
        name: String
        order: Int
        buttonConfiguration: JSONObject | null
        requiresConfirmation: Boolean
        confirmationMessage: String | null
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        manualTrigger: {
          __typename: 'ActionManualTrigger'
          id: ID
          name: String
          action: {
            __typename: 'Action'
            id: ID
            status: ActionStatus
            description: String | null
            workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
          } | null
        } | null
        form: { __typename: 'Form'; id: ID; name: String } | null
        formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      }>
    }>
    processingWorkspaceButton: { __typename: 'WorkspaceButton'; id: ID; name: String } | null
  }
}

export type CreateAppOAuth2AuthorizationRequestMutationVariables = Exact<{
  input: CreateAppOAuth2AuthorizationRequestInput
}>

export type CreateAppOAuth2AuthorizationRequestMutation = {
  __typename: 'Mutation'
  createAppOAuth2AuthorizationRequest: {
    __typename: 'CreateOAuth2AuthorizationResult'
    success: Boolean
    requestId: String | null
    error: String | null
  }
}

export type AuthorizeAppOAuth2RequestMutationVariables = Exact<{
  requestId: Scalars['ID']
}>

export type AuthorizeAppOAuth2RequestMutation = {
  __typename: 'Mutation'
  authorizeAppOAuth2Request: {
    __typename: 'AuthorizeOAuth2Result'
    success: Boolean
    authorizationCode: String | null
    redirectUri: String | null
    state: String | null
    error: String | null
  }
}

export type PushNotificationSubscriptionVariables = Exact<{ [key: string]: never }>

export type PushNotificationSubscription = {
  __typename: 'Subscription'
  pushNotification: {
    __typename: 'PaginatedEvent'
    objectId: ID
    objectType: BreadcrumbObjectType
    objectName: String
    event: {
      __typename: 'Event'
      id: ID
      createdAt: DateTime
      type: EventType
      data: JSONObject | null
      createdBy: { __typename: 'Membership'; id: ID; firstName: String; lastName: String } | null
    }
  }
}

export type AcceptTermsAndConditionsMutationVariables = Exact<{ [key: string]: never }>

export type AcceptTermsAndConditionsMutation = {
  __typename: 'Mutation'
  acceptTermsAndConditions: {
    __typename: 'Membership'
    id: ID
    policiesAcceptedAt: DateTime | null
  }
}

export type RecordDetailsDirectoryTableWorkspaceObjectsFragment = {
  __typename: 'Table'
  hasRowWorkspaceObjects: Boolean
}

export type GetRecordWorkspaceDetailsQueryVariables = Exact<{
  workspaceId: Scalars['ID']
}>

export type GetRecordWorkspaceDetailsQuery = {
  __typename: 'Query'
  workspace: {
    __typename: 'Workspace'
    id: ID
    name: String | null
    views: Array<{
      __typename: 'View'
      id: ID
      order: Int
      unitHeight: Int
      unitWidth: Int
      rowNumber: Int
      viewableObjectType: ViewableObjectType
      workspace: {
        __typename: 'Workspace'
        id: ID
        name: String | null
        updatedAt: DateTime
        updatedBy: { __typename: 'Membership'; id: ID; firstName: String; lastName: String } | null
      } | null
      chart: { __typename: 'Chart'; id: ID; name: String } | null
      table: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        tableTabs: Array<{ __typename: 'TableTab'; id: ID; order: Int }>
      } | null
      document: {
        __typename: 'Document'
        id: ID
        name: String
        documentType: DocumentType
        updatedAt: DateTime
        storageUrl: String
        updatedBy: { __typename: 'Membership'; id: ID; firstName: String; lastName: String } | null
      } | null
      tableRow: {
        __typename: 'TableRow'
        id: ID
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
    }>
  }
}

export type DeleteWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['ID']
}>

export type DeleteWorkspaceMutation = {
  __typename: 'Mutation'
  deleteWorkspace: { __typename: 'Workspace'; id: ID }
}

export type DeleteDirectoryWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['ID']
}>

export type DeleteDirectoryWorkspaceMutation = {
  __typename: 'Mutation'
  deleteDirectoryWorkspace: { __typename: 'Workspace'; id: ID }
}

export type UpdateDocumentMutationVariables = Exact<{
  input: UpdateDocumentInput
}>

export type UpdateDocumentMutation = {
  __typename: 'Mutation'
  updateDocument: { __typename: 'Document'; id: ID; name: String }
}

export type DownloadWorkspaceDocumentsMutationVariables = Exact<{
  workspaceId: Scalars['ID']
}>

export type DownloadWorkspaceDocumentsMutation = {
  __typename: 'Mutation'
  downloadWorkspaceDocuments: String
}

export type MoveWorkspaceMutationVariables = Exact<{
  input: MoveWorkspaceInput
}>

export type MoveWorkspaceMutation = {
  __typename: 'Mutation'
  moveWorkspace: { __typename: 'Workspace'; id: ID }
}

export type SearchWorkspaceMutationVariables = Exact<{
  input: SearchWorkspaceInput
}>

export type SearchWorkspaceMutation = {
  __typename: 'Mutation'
  searchWorkspace: {
    __typename: 'SearchWorkspaceResult'
    workspaces: Array<{
      __typename: 'Workspace'
      id: ID
      name: String | null
      updatedAt: DateTime
      updatedBy: { __typename: 'Membership'; id: ID; firstName: String; lastName: String } | null
    }>
    documents: Array<{
      __typename: 'Document'
      id: ID
      name: String
      documentType: DocumentType
      updatedAt: DateTime
      storageUrl: String
      updatedBy: { __typename: 'Membership'; id: ID; firstName: String; lastName: String } | null
    }>
  }
}

export type WorkspaceDeletionProgressSubscriptionVariables = Exact<{
  userId: Scalars['ID']
}>

export type WorkspaceDeletionProgressSubscription = {
  __typename: 'Subscription'
  workspaceDeletionProgress: {
    __typename: 'WorkspaceDeletionProgress'
    objectId: ID
    completedCount: Int
    totalCount: Int
  }
}

export type AddRecordGetTableDetailsQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type AddRecordGetTableDetailsQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    name: String
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      order: Int
      type: DataType
      innerType: DataType | null
      isNullable: Boolean
      isReadOnly: Boolean
      indexType: IndexType
      indexPrefix: String
      indexSuffix: String
      indexAutogenerate: Boolean
      enumOptions: Array<String> | null
      displayImagesInline: Boolean
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      lookupColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        table: { __typename: 'Table'; id: ID }
      } | null
      lookupFilterExpression: {
        __typename: 'LogicExpression'
        id: ID
        logicExpressionString: String | null
      } | null
      lookupColumnGroup: { __typename: 'LookupTableColumnGroup'; id: ID } | null
      enumSet: {
        __typename: 'EnumSet'
        id: ID
        options: Array<{
          __typename: 'EnumOption'
          id: ID
          label: String
          colorPreset: EnumColorPreset | null
          colorCustom: String | null
          iconName: String | null
          order: Int
          icon: { __typename: 'Icon'; id: ID } | null
        }>
      } | null
    }>
    childTables: Array<{
      __typename: 'Table'
      id: ID
      orderOnRecordDetails: Int | null
      icon: { __typename: 'Icon'; id: ID; name: String } | null
    }>
  }
}

export type CreateTableRowMutationVariables = Exact<{
  input: CreateTableRowInput
}>

export type CreateTableRowMutation = {
  __typename: 'Mutation'
  createTableRow: { __typename: 'TableRow'; id: ID }
}

export type UpdateTableCellMutationVariables = Exact<{
  input: UpdateTableCellInput
}>

export type UpdateTableCellMutation = {
  __typename: 'Mutation'
  updateTableCell: {
    __typename: 'TableCell'
    id: ID
    data: JSONObject | null
    userVisibleValue: String | null
    formulaError: Int | null
    updatedAt: DateTime
    column: {
      __typename: 'TableColumn'
      id: ID
      formatOptions: JSONObject | null
      formatPreset: FormatPreset | null
      type: DataType
      lookupColumn: { __typename: 'TableColumn'; id: ID; type: DataType } | null
    }
    documents: Array<{ __typename: 'Document'; id: ID; name: String }>
    users: Array<{
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      email: String | null
    }>
    lookupCells: Array<{
      __typename: 'TableCell'
      id: ID
      formulaError: Int | null
      row: { __typename: 'TableRow'; id: ID }
      documents: Array<{ __typename: 'Document'; id: ID }>
    }>
  }
}

export type UpdateTableRowMutationVariables = Exact<{
  input: UpdateTableRowInput
}>

export type UpdateTableRowMutation = {
  __typename: 'Mutation'
  updateTableRow: {
    __typename: 'TableRow'
    id: ID
    updatedAt: DateTime
    updatedBy: {
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      email: String | null
    } | null
    cells: Array<{
      __typename: 'TableCell'
      id: ID
      data: JSONObject | null
      userVisibleValue: String | null
      formulaError: Int | null
      updatedAt: DateTime
      column: {
        __typename: 'TableColumn'
        id: ID
        formatOptions: JSONObject | null
        formatPreset: FormatPreset | null
        type: DataType
        lookupColumn: { __typename: 'TableColumn'; id: ID; type: DataType } | null
      }
      lookupCells: Array<{
        __typename: 'TableCell'
        id: ID
        userVisibleValue: String | null
        formulaError: Int | null
        documents: Array<{ __typename: 'Document'; id: ID }>
        row: { __typename: 'TableRow'; id: ID }
      }>
      documents: Array<{ __typename: 'Document'; id: ID; name: String }>
      users: Array<{
        __typename: 'Membership'
        id: ID
        firstName: String
        lastName: String
        email: String | null
      }>
    }>
    table: {
      __typename: 'Table'
      columns: Array<{
        __typename: 'TableColumn'
        lookupColumnChildren: Array<{
          __typename: 'TableColumn'
          id: ID
          table: { __typename: 'Table'; id: ID }
          lookupColumnGroup: {
            __typename: 'LookupTableColumnGroup'
            id: ID
            showBacklink: Boolean | null
          } | null
        }>
      }>
    }
    currentButtonNodes: Array<{
      __typename: 'TableButtonNode'
      id: ID
      name: String
      workspaceButtons: Array<{
        __typename: 'WorkspaceButton'
        id: ID
        name: String
        order: Int
        buttonConfiguration: JSONObject | null
        requiresConfirmation: Boolean
        confirmationMessage: String | null
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        manualTrigger: {
          __typename: 'ActionManualTrigger'
          id: ID
          name: String
          action: {
            __typename: 'Action'
            id: ID
            status: ActionStatus
            description: String | null
            workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
          } | null
        } | null
        form: { __typename: 'Form'; id: ID; name: String } | null
        formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      }>
    }>
    processingWorkspaceButton: { __typename: 'WorkspaceButton'; id: ID; name: String } | null
  }
}

export type DuplicateTableRowMutationVariables = Exact<{
  tableRowId: Scalars['ID']
}>

export type DuplicateTableRowMutation = {
  __typename: 'Mutation'
  duplicateTableRow: { __typename: 'TableRow'; id: ID }
}

export type GetTableRowQueryVariables = Exact<{
  tableRowId: Scalars['ID']
}>

export type GetTableRowQuery = {
  __typename: 'Query'
  tableRow: {
    __typename: 'TableRow'
    id: ID
    name: String
    createdAt: DateTime
    updatedAt: DateTime
    createdBy: {
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      email: String | null
    } | null
    updatedBy: {
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      email: String | null
    } | null
    rootWorkspace: {
      __typename: 'Workspace'
      id: ID
      actionButtons: Array<{
        __typename: 'WorkspaceButton'
        id: ID
        name: String
        order: Int
        manualTrigger: {
          __typename: 'ActionManualTrigger'
          id: ID
          action: {
            __typename: 'Action'
            id: ID
            status: ActionStatus
            workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
          } | null
        } | null
        form: { __typename: 'Form'; id: ID } | null
        formV2: { __typename: 'FormV2'; id: ID } | null
      }>
    }
    cells: Array<{
      __typename: 'TableCell'
      id: ID
      data: JSONObject | null
      userVisibleValue: String | null
      formulaError: Int | null
      updatedAt: DateTime
      lookupCells: Array<{
        __typename: 'TableCell'
        id: ID
        formulaError: Int | null
        row: { __typename: 'TableRow'; id: ID }
        documents: Array<{ __typename: 'Document'; id: ID }>
      }>
      documents: Array<{ __typename: 'Document'; id: ID; name: String }>
      users: Array<{
        __typename: 'Membership'
        id: ID
        firstName: String
        lastName: String
        email: String | null
      }>
      column: {
        __typename: 'TableColumn'
        id: ID
        order: Int
        name: String
        description: String | null
        type: DataType
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        enumOptions: Array<String> | null
        innerType: DataType | null
        isNullable: Boolean
        isReadOnly: Boolean
        indexAutogenerate: Boolean
        displayImagesInline: Boolean
        isVisibleOnRecordDetails: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        lookupColumn: {
          __typename: 'TableColumn'
          name: String
          id: ID
          type: DataType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
        } | null
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
        formula: { __typename: 'Formula'; id: ID } | null
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          lookupTable: { __typename: 'Table'; id: ID; name: String }
        } | null
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
      }
    }>
    table: {
      __typename: 'Table'
      id: ID
      name: String
      showRowWorkspace: Boolean
      childTables: Array<{
        __typename: 'Table'
        id: ID
        name: String
        orderOnRecordDetails: Int | null
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        columns: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          order: Int
          type: DataType
          indexType: IndexType
          indexPrefix: String
          indexSuffix: String
          innerType: DataType | null
          isNullable: Boolean
          isReadOnly: Boolean
          enumOptions: Array<String> | null
          displayImagesInline: Boolean
          isVisibleOnRecordDetails: Boolean
          lookupColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }>
      }>
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        isNullable: Boolean
        indexAutogenerate: Boolean
        type: DataType
        lookupColumnChildren: Array<{
          __typename: 'TableColumn'
          id: ID
          table: {
            __typename: 'Table'
            id: ID
            name: String
            orderOnRecordDetails: Int | null
            icon: { __typename: 'Icon'; id: ID; name: String } | null
            columns: Array<{
              __typename: 'TableColumn'
              id: ID
              name: String
              order: Int
              type: DataType
              indexType: IndexType
              indexPrefix: String
              indexSuffix: String
              innerType: DataType | null
              isNullable: Boolean
              isReadOnly: Boolean
              enumOptions: Array<String> | null
              displayImagesInline: Boolean
              isVisibleOnRecordDetails: Boolean
              lookupColumn: {
                __typename: 'TableColumn'
                id: ID
                name: String
                table: { __typename: 'Table'; id: ID; name: String }
              } | null
              enumSet: {
                __typename: 'EnumSet'
                id: ID
                options: Array<{
                  __typename: 'EnumOption'
                  id: ID
                  label: String
                  colorPreset: EnumColorPreset | null
                  colorCustom: String | null
                  iconName: String | null
                  order: Int
                  icon: { __typename: 'Icon'; id: ID } | null
                }>
              } | null
            }>
          }
          lookupColumnGroup: {
            __typename: 'LookupTableColumnGroup'
            id: ID
            showBacklink: Boolean | null
          } | null
        }>
      }>
      columnGroups: Array<{
        __typename: 'TableColumnGroup'
        id: ID
        name: String
        order: Int
        columns: Array<{
          __typename: 'TableColumnGroupMember'
          id: ID
          order: Int
          tableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            description: String | null
            order: Int
            type: DataType
            innerType: DataType | null
            isNullable: Boolean
            isReadOnly: Boolean
            isDecimal: Boolean
            indexType: IndexType
            indexPrefix: String
            indexSuffix: String
            indexAutogenerate: Boolean
            enumOptions: Array<String> | null
            displayImagesInline: Boolean
            isVisibleOnRecordDetails: Boolean
            resolvedSourceType: DataType
            resolvedEnumOptions: Array<String> | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            lookupColumnGroup: {
              __typename: 'LookupTableColumnGroup'
              id: ID
              showBacklink: Boolean | null
              backlinkName: String | null
            } | null
            lookupColumn: {
              __typename: 'TableColumn'
              name: String
              order: Int
              innerType: DataType | null
              indexType: IndexType
              indexPrefix: String
              indexSuffix: String
              enumOptions: Array<String> | null
              id: ID
              type: DataType
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              table: { __typename: 'Table'; id: ID; name: String }
              resolvedSourceColumn: {
                __typename: 'ResolvedTableColumnInfo'
                column: {
                  __typename: 'TableColumn'
                  id: ID
                  type: DataType
                  innerType: DataType | null
                  formatPreset: FormatPreset | null
                  formatOptions: JSONObject | null
                  enumSet: {
                    __typename: 'EnumSet'
                    id: ID
                    options: Array<{
                      __typename: 'EnumOption'
                      id: ID
                      label: String
                      colorPreset: EnumColorPreset | null
                      colorCustom: String | null
                      iconName: String | null
                      order: Int
                      icon: { __typename: 'Icon'; id: ID } | null
                    }>
                  } | null
                }
              }
            } | null
            lookupColumnChildren: Array<{
              __typename: 'TableColumn'
              id: ID
              name: String
              table: { __typename: 'Table'; id: ID }
              lookupColumnGroup: {
                __typename: 'LookupTableColumnGroup'
                id: ID
                showBacklink: Boolean | null
                backlinkName: String | null
              } | null
            }>
            lookupFilterExpression: {
              __typename: 'LogicExpression'
              id: ID
              logicExpressionString: String | null
            } | null
            formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
            chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
            resolvedSourceColumn: {
              __typename: 'ResolvedTableColumnInfo'
              column: {
                __typename: 'TableColumn'
                id: ID
                type: DataType
                innerType: DataType | null
                formatPreset: FormatPreset | null
                formatOptions: JSONObject | null
                enumSet: {
                  __typename: 'EnumSet'
                  id: ID
                  options: Array<{
                    __typename: 'EnumOption'
                    id: ID
                    label: String
                    colorPreset: EnumColorPreset | null
                    colorCustom: String | null
                    iconName: String | null
                    order: Int
                    icon: { __typename: 'Icon'; id: ID } | null
                  }>
                } | null
              }
            }
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }>
      }>
    }
    currentButtonNodes: Array<{
      __typename: 'TableButtonNode'
      id: ID
      name: String
      workspaceButtons: Array<{
        __typename: 'WorkspaceButton'
        id: ID
        name: String
        order: Int
        buttonConfiguration: JSONObject | null
        requiresConfirmation: Boolean
        confirmationMessage: String | null
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        manualTrigger: {
          __typename: 'ActionManualTrigger'
          id: ID
          name: String
          action: {
            __typename: 'Action'
            id: ID
            status: ActionStatus
            description: String | null
            workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
          } | null
        } | null
        form: { __typename: 'Form'; id: ID; name: String } | null
        formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      }>
    }>
    processingWorkspaceButton: { __typename: 'WorkspaceButton'; id: ID; name: String } | null
  }
}

export type GetLookupColumnGroupQueryVariables = Exact<{
  lookupTableColumnGroupId: Scalars['ID']
}>

export type GetLookupColumnGroupQuery = {
  __typename: 'Query'
  lookupTableColumnGroup: {
    __typename: 'LookupTableColumnGroup'
    id: ID
    lookupTable: {
      __typename: 'Table'
      id: ID
      name: String
      parentTable: {
        __typename: 'Table'
        id: ID
        name: String
        columns: Array<{ __typename: 'TableColumn'; id: ID; name: String }>
      } | null
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        order: Int
        type: DataType
        innerType: DataType | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        lookupColumn: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
        } | null
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
      }>
      childTables: Array<{
        __typename: 'Table'
        id: ID
        name: String
        columns: Array<{ __typename: 'TableColumn'; id: ID; name: String }>
      }>
    }
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      lookupColumn: { __typename: 'TableColumn'; id: ID } | null
    }>
  }
}

export type GetLookupTableRowsQueryVariables = Exact<{
  input: PaginatedLookupRowsInput
}>

export type GetLookupTableRowsQuery = {
  __typename: 'Query'
  paginatedLookupRows: {
    __typename: 'PaginatedTableRows'
    offset: Int
    hasNext: Boolean
    totalCount: Int
    rows: Array<{
      __typename: 'TableRow'
      id: ID
      name: String
      cells: Array<{
        __typename: 'TableCell'
        id: ID
        data: JSONObject | null
        userVisibleValue: String | null
        formulaError: Int | null
        column: {
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          order: Int
          enumOptions: Array<String> | null
          innerType: DataType | null
          isNullable: Boolean
          displayImagesInline: Boolean
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          resolvedSourceColumn: {
            __typename: 'ResolvedTableColumnInfo'
            column: {
              __typename: 'TableColumn'
              id: ID
              type: DataType
              innerType: DataType | null
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              enumSet: {
                __typename: 'EnumSet'
                id: ID
                options: Array<{
                  __typename: 'EnumOption'
                  id: ID
                  label: String
                  colorPreset: EnumColorPreset | null
                  colorCustom: String | null
                  iconName: String | null
                  order: Int
                  icon: { __typename: 'Icon'; id: ID } | null
                }>
              } | null
            }
          }
        }
        row: { __typename: 'TableRow'; id: ID }
        documents: Array<{ __typename: 'Document'; id: ID }>
      }>
      currentButtonNodes: Array<{
        __typename: 'TableButtonNode'
        id: ID
        name: String
        workspaceButtons: Array<{
          __typename: 'WorkspaceButton'
          id: ID
          name: String
          order: Int
          buttonConfiguration: JSONObject | null
          requiresConfirmation: Boolean
          confirmationMessage: String | null
          icon: { __typename: 'Icon'; id: ID; name: String } | null
          manualTrigger: {
            __typename: 'ActionManualTrigger'
            id: ID
            name: String
            action: {
              __typename: 'Action'
              id: ID
              status: ActionStatus
              description: String | null
              workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
            } | null
          } | null
          form: { __typename: 'Form'; id: ID; name: String } | null
          formV2: { __typename: 'FormV2'; id: ID; name: String } | null
        }>
      }>
      processingWorkspaceButton: { __typename: 'WorkspaceButton'; id: ID; name: String } | null
    }>
  }
}

export type GetTableRowDetailedColumnHeaderFragment = {
  __typename: 'TableColumn'
  id: ID
  name: String
  order: Int
  type: DataType
  indexType: IndexType
  indexPrefix: String
  indexSuffix: String
  innerType: DataType | null
  isNullable: Boolean
  isReadOnly: Boolean
  enumOptions: Array<String> | null
  displayImagesInline: Boolean
  isVisibleOnRecordDetails: Boolean
  lookupColumn: {
    __typename: 'TableColumn'
    id: ID
    name: String
    table: { __typename: 'Table'; id: ID; name: String }
  } | null
  enumSet: {
    __typename: 'EnumSet'
    id: ID
    options: Array<{
      __typename: 'EnumOption'
      id: ID
      label: String
      colorPreset: EnumColorPreset | null
      colorCustom: String | null
      iconName: String | null
      order: Int
      icon: { __typename: 'Icon'; id: ID } | null
    }>
  } | null
}

export type UpdatedTableRowDetailsSubscriptionVariables = Exact<{
  tableRowId: Scalars['ID']
}>

export type UpdatedTableRowDetailsSubscription = {
  __typename: 'Subscription'
  updatedTableRowDetails: {
    __typename: 'TableRow'
    id: ID
    name: String
    createdAt: DateTime
    updatedAt: DateTime
    createdBy: {
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      email: String | null
    } | null
    updatedBy: {
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      email: String | null
    } | null
    rootWorkspace: {
      __typename: 'Workspace'
      id: ID
      actionButtons: Array<{
        __typename: 'WorkspaceButton'
        id: ID
        name: String
        order: Int
        manualTrigger: {
          __typename: 'ActionManualTrigger'
          id: ID
          action: {
            __typename: 'Action'
            id: ID
            status: ActionStatus
            workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
          } | null
        } | null
        form: { __typename: 'Form'; id: ID } | null
        formV2: { __typename: 'FormV2'; id: ID } | null
      }>
    }
    cells: Array<{
      __typename: 'TableCell'
      id: ID
      data: JSONObject | null
      userVisibleValue: String | null
      formulaError: Int | null
      updatedAt: DateTime
      lookupCells: Array<{
        __typename: 'TableCell'
        id: ID
        userVisibleValue: String | null
        formulaError: Int | null
        documents: Array<{ __typename: 'Document'; id: ID }>
        row: { __typename: 'TableRow'; id: ID }
      }>
      documents: Array<{ __typename: 'Document'; id: ID; name: String }>
      users: Array<{
        __typename: 'Membership'
        id: ID
        firstName: String
        lastName: String
        email: String | null
      }>
      column: {
        __typename: 'TableColumn'
        id: ID
        order: Int
        name: String
        description: String | null
        type: DataType
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        enumOptions: Array<String> | null
        innerType: DataType | null
        isNullable: Boolean
        isReadOnly: Boolean
        indexAutogenerate: Boolean
        displayImagesInline: Boolean
        isVisibleOnRecordDetails: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        lookupColumn: {
          __typename: 'TableColumn'
          name: String
          id: ID
          type: DataType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
        } | null
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
        formula: { __typename: 'Formula'; id: ID } | null
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          lookupTable: { __typename: 'Table'; id: ID; name: String }
        } | null
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
      }
    }>
    table: {
      __typename: 'Table'
      id: ID
      name: String
      showRowWorkspace: Boolean
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        isNullable: Boolean
        indexAutogenerate: Boolean
        type: DataType
        lookupColumnChildren: Array<{
          __typename: 'TableColumn'
          id: ID
          table: {
            __typename: 'Table'
            id: ID
            name: String
            orderOnRecordDetails: Int | null
            icon: { __typename: 'Icon'; id: ID; name: String } | null
            columns: Array<{
              __typename: 'TableColumn'
              id: ID
              name: String
              order: Int
              type: DataType
              indexType: IndexType
              indexPrefix: String
              indexSuffix: String
              innerType: DataType | null
              isNullable: Boolean
              isReadOnly: Boolean
              enumOptions: Array<String> | null
              displayImagesInline: Boolean
              isVisibleOnRecordDetails: Boolean
              lookupColumn: {
                __typename: 'TableColumn'
                id: ID
                name: String
                table: { __typename: 'Table'; id: ID; name: String }
              } | null
              enumSet: {
                __typename: 'EnumSet'
                id: ID
                options: Array<{
                  __typename: 'EnumOption'
                  id: ID
                  label: String
                  colorPreset: EnumColorPreset | null
                  colorCustom: String | null
                  iconName: String | null
                  order: Int
                  icon: { __typename: 'Icon'; id: ID } | null
                }>
              } | null
            }>
          }
          lookupColumnGroup: {
            __typename: 'LookupTableColumnGroup'
            id: ID
            showBacklink: Boolean | null
          } | null
        }>
      }>
      childTables: Array<{
        __typename: 'Table'
        id: ID
        name: String
        orderOnRecordDetails: Int | null
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        columns: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          order: Int
          type: DataType
          indexType: IndexType
          indexPrefix: String
          indexSuffix: String
          innerType: DataType | null
          isNullable: Boolean
          isReadOnly: Boolean
          enumOptions: Array<String> | null
          displayImagesInline: Boolean
          isVisibleOnRecordDetails: Boolean
          lookupColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            table: { __typename: 'Table'; id: ID; name: String }
          } | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }>
      }>
      columnGroups: Array<{
        __typename: 'TableColumnGroup'
        id: ID
        name: String
        order: Int
        columns: Array<{
          __typename: 'TableColumnGroupMember'
          id: ID
          order: Int
          tableColumn: {
            __typename: 'TableColumn'
            id: ID
            name: String
            description: String | null
            order: Int
            type: DataType
            innerType: DataType | null
            isNullable: Boolean
            isReadOnly: Boolean
            isDecimal: Boolean
            indexType: IndexType
            indexPrefix: String
            indexSuffix: String
            indexAutogenerate: Boolean
            enumOptions: Array<String> | null
            displayImagesInline: Boolean
            isVisibleOnRecordDetails: Boolean
            resolvedSourceType: DataType
            resolvedEnumOptions: Array<String> | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            lookupColumnGroup: {
              __typename: 'LookupTableColumnGroup'
              id: ID
              showBacklink: Boolean | null
              backlinkName: String | null
            } | null
            lookupColumn: {
              __typename: 'TableColumn'
              name: String
              order: Int
              innerType: DataType | null
              indexType: IndexType
              indexPrefix: String
              indexSuffix: String
              enumOptions: Array<String> | null
              id: ID
              type: DataType
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              table: { __typename: 'Table'; id: ID; name: String }
              resolvedSourceColumn: {
                __typename: 'ResolvedTableColumnInfo'
                column: {
                  __typename: 'TableColumn'
                  id: ID
                  type: DataType
                  innerType: DataType | null
                  formatPreset: FormatPreset | null
                  formatOptions: JSONObject | null
                  enumSet: {
                    __typename: 'EnumSet'
                    id: ID
                    options: Array<{
                      __typename: 'EnumOption'
                      id: ID
                      label: String
                      colorPreset: EnumColorPreset | null
                      colorCustom: String | null
                      iconName: String | null
                      order: Int
                      icon: { __typename: 'Icon'; id: ID } | null
                    }>
                  } | null
                }
              }
            } | null
            lookupColumnChildren: Array<{
              __typename: 'TableColumn'
              id: ID
              name: String
              table: { __typename: 'Table'; id: ID }
              lookupColumnGroup: {
                __typename: 'LookupTableColumnGroup'
                id: ID
                showBacklink: Boolean | null
                backlinkName: String | null
              } | null
            }>
            lookupFilterExpression: {
              __typename: 'LogicExpression'
              id: ID
              logicExpressionString: String | null
            } | null
            formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
            chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
            resolvedSourceColumn: {
              __typename: 'ResolvedTableColumnInfo'
              column: {
                __typename: 'TableColumn'
                id: ID
                type: DataType
                innerType: DataType | null
                formatPreset: FormatPreset | null
                formatOptions: JSONObject | null
                enumSet: {
                  __typename: 'EnumSet'
                  id: ID
                  options: Array<{
                    __typename: 'EnumOption'
                    id: ID
                    label: String
                    colorPreset: EnumColorPreset | null
                    colorCustom: String | null
                    iconName: String | null
                    order: Int
                    icon: { __typename: 'Icon'; id: ID } | null
                  }>
                } | null
              }
            }
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }>
      }>
    }
    currentButtonNodes: Array<{
      __typename: 'TableButtonNode'
      id: ID
      name: String
      workspaceButtons: Array<{
        __typename: 'WorkspaceButton'
        id: ID
        name: String
        order: Int
        buttonConfiguration: JSONObject | null
        requiresConfirmation: Boolean
        confirmationMessage: String | null
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        manualTrigger: {
          __typename: 'ActionManualTrigger'
          id: ID
          name: String
          action: {
            __typename: 'Action'
            id: ID
            status: ActionStatus
            description: String | null
            workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
          } | null
        } | null
        form: { __typename: 'Form'; id: ID; name: String } | null
        formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      }>
    }>
    processingWorkspaceButton: { __typename: 'WorkspaceButton'; id: ID; name: String } | null
  }
}

export type GetSelectedLookupRowsQueryVariables = Exact<{
  rowIds: Array<Scalars['ID']> | Scalars['ID']
}>

export type GetSelectedLookupRowsQuery = {
  __typename: 'Query'
  tableRows: Array<{
    __typename: 'TableRow'
    id: ID
    name: String
    cells: Array<{
      __typename: 'TableCell'
      id: ID
      userVisibleValue: String | null
      formulaError: Int | null
      data: JSONObject | null
      column: {
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        order: Int
        enumOptions: Array<String> | null
        innerType: DataType | null
        isNullable: Boolean
        displayImagesInline: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
      }
      row: { __typename: 'TableRow'; id: ID }
      documents: Array<{ __typename: 'Document'; id: ID }>
    }>
    currentButtonNodes: Array<{
      __typename: 'TableButtonNode'
      id: ID
      name: String
      workspaceButtons: Array<{
        __typename: 'WorkspaceButton'
        id: ID
        name: String
        order: Int
        buttonConfiguration: JSONObject | null
        requiresConfirmation: Boolean
        confirmationMessage: String | null
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        manualTrigger: {
          __typename: 'ActionManualTrigger'
          id: ID
          name: String
          action: {
            __typename: 'Action'
            id: ID
            status: ActionStatus
            description: String | null
            workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
          } | null
        } | null
        form: { __typename: 'Form'; id: ID; name: String } | null
        formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      }>
    }>
    processingWorkspaceButton: { __typename: 'WorkspaceButton'; id: ID; name: String } | null
  }>
}

export type CreateFileCellDocumentViewMutationVariables = Exact<{
  input: CreateDocumentViewInput
}>

export type CreateFileCellDocumentViewMutation = {
  __typename: 'Mutation'
  createDocumentView: {
    __typename: 'Document'
    id: ID
    name: String
    documentType: DocumentType
    storageUrl: String
  }
}

export type GetFileCellDocumentQueryVariables = Exact<{
  documentId: Scalars['ID']
}>

export type GetFileCellDocumentQuery = {
  __typename: 'Query'
  document: {
    __typename: 'Document'
    id: ID
    name: String
    documentType: DocumentType
    storageUrl: String
    signature: {
      __typename: 'Signature'
      id: ID
      createdAt: DateTime
      user: { __typename: 'Membership'; id: ID; firstName: String; lastName: String } | null
    } | null
  }
}

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']
}>

export type DeleteDocumentMutation = {
  __typename: 'Mutation'
  deleteDocument: { __typename: 'Document'; id: ID }
}

export type GetEmbedQueryVariables = Exact<{
  embedId: Scalars['ID']
}>

export type GetEmbedQuery = {
  __typename: 'Query'
  embed: {
    __typename: 'Embed'
    id: ID
    name: String
    betaWatermarkDisabled: Boolean | null
    viewContent: { __typename: 'ViewContent'; id: ID } | null
  }
}

export type GetViewContentForEmbedQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type GetViewContentForEmbedQuery = {
  __typename: 'Query'
  viewContent: {
    __typename: 'ViewContent'
    id: ID
    contentType: String
    latestVersion: Int
    sourceSnapshotHash: String | null
    content: String | null
    sdkVersion: String | null
    contentHash: String | null
    appSdkGraph: JSONObject | null
    tableMappings: JSONObject | null
  }
}

export type UpsertViewContentMutationVariables = Exact<{
  input: UpsertViewContentInput
}>

export type UpsertViewContentMutation = {
  __typename: 'Mutation'
  upsertViewContent: {
    __typename: 'ViewContent'
    id: ID
    contentType: String
    latestVersion: Int
    sourceSnapshotHash: String | null
    content: String | null
    sdkVersion: String | null
    contentHash: String | null
    appSdkGraph: JSONObject | null
  }
}

export type UpdateEmbedViewContentMutationVariables = Exact<{
  embedId: Scalars['ID']
  viewContentId?: InputMaybe<Scalars['ID']>
}>

export type UpdateEmbedViewContentMutation = {
  __typename: 'Mutation'
  updateEmbedViewContent: {
    __typename: 'Embed'
    id: ID
    viewContent: { __typename: 'ViewContent'; id: ID } | null
  }
}

export type RunUdsSqlQueryVariables = Exact<{
  sql: Scalars['String']
  page?: InputMaybe<UdsSqlPageInput>
  includeTotalCount?: InputMaybe<Scalars['Boolean']>
}>

export type RunUdsSqlQuery = {
  __typename: 'Query'
  runUdsSql: {
    __typename: 'UdsSqlResult'
    rows: Array<JSONObject>
    resultBytes: Int
    hasNext: Boolean
    offset: Int | null
    cursor: String | null
    totalCount: Int | null
  }
}

export type RunUdsSqlBatchQueryVariables = Exact<{
  statements: Array<UdsSqlStatementInput> | UdsSqlStatementInput
}>

export type RunUdsSqlBatchQuery = {
  __typename: 'Query'
  runUdsSqlBatch: {
    __typename: 'UdsSqlBatchResult'
    statements: Array<{
      __typename: 'UdsSqlStatementResult'
      result: {
        __typename: 'UdsSqlResult'
        rows: Array<JSONObject>
        resultBytes: Int
        hasNext: Boolean
        offset: Int | null
        cursor: String | null
        totalCount: Int | null
      } | null
      error: {
        __typename: 'UdsSqlStatementError'
        message: String
        code: String | null
        limitBytes: Int | null
        resultBytes: Int | null
        parameter: String | null
        requestedRows: Int | null
        maxRows: Int | null
      } | null
    }>
  }
}

export type GetUdsSchemaForEmbedQueryVariables = Exact<{ [key: string]: never }>

export type GetUdsSchemaForEmbedQuery = {
  __typename: 'Query'
  tables: Array<{
    __typename: 'Table'
    id: ID
    slug: String
    udsSystemColumns: Array<{
      __typename: 'UdsSystemColumn'
      slug: String
      dataType: String
      isNullable: Boolean
    }>
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      slug: String
      order: Int
      udsDataType: String
      isNullable: Boolean
    }>
  }>
}

export type AppTableRowFieldsFragment = {
  __typename: 'AppTableRow'
  id: ID
  createdAt: DateTime
  updatedAt: DateTime
  createdBy: JSONValue | null
  updatedBy: JSONValue | null
  parentRowId: ID | null
  cells: Array<{
    __typename: 'AppTableCell'
    id: ID
    at: DateTime | null
    value: JSONValue | null
    display: String | null
    targets: Array<{
      __typename: 'AppTableTarget'
      rowId: ID
      cells: Array<{
        __typename: 'AppTableCell'
        id: ID
        at: DateTime | null
        value: JSONValue | null
        display: String | null
      }>
    }>
  }>
}

export type AppTableRowsQueryVariables = Exact<{
  input: AppTableRowsInput
}>

export type AppTableRowsQuery = {
  __typename: 'Query'
  appTableRows: {
    __typename: 'AppTableRowPage'
    hasNext: Boolean
    totalCount: Int
    rows: Array<{
      __typename: 'AppTableRow'
      id: ID
      createdAt: DateTime
      updatedAt: DateTime
      createdBy: JSONValue | null
      updatedBy: JSONValue | null
      parentRowId: ID | null
      cells: Array<{
        __typename: 'AppTableCell'
        id: ID
        at: DateTime | null
        value: JSONValue | null
        display: String | null
        targets: Array<{
          __typename: 'AppTableTarget'
          rowId: ID
          cells: Array<{
            __typename: 'AppTableCell'
            id: ID
            at: DateTime | null
            value: JSONValue | null
            display: String | null
          }>
        }>
      }>
    }>
    select: Array<{ __typename: 'AppTableSelectField'; as: String; field: String }> | null
  }
}

export type AppTableRowCountQueryVariables = Exact<{
  input: AppTableRowsInput
}>

export type AppTableRowCountQuery = {
  __typename: 'Query'
  appTableRows: { __typename: 'AppTableRowPage'; totalCount: Int }
}

export type AppTableDistinctQueryVariables = Exact<{
  input: AppTableDistinctInput
}>

export type AppTableDistinctQuery = {
  __typename: 'Query'
  appTableDistinct: {
    __typename: 'AppTableDistinctValues'
    truncated: Boolean
    values: Array<{
      __typename: 'AppTableDistinctValue'
      value: JSONValue | null
      display: String | null
      rowCount: Int
    }>
  }
}

export type UpdatedAppTableRowSubscriptionVariables = Exact<{
  input: AppTableRowSubscriptionInput
}>

export type UpdatedAppTableRowSubscription = {
  __typename: 'Subscription'
  updatedAppTableRow: {
    __typename: 'AppTableRow'
    id: ID
    createdAt: DateTime
    updatedAt: DateTime
    createdBy: JSONValue | null
    updatedBy: JSONValue | null
    parentRowId: ID | null
    cells: Array<{
      __typename: 'AppTableCell'
      id: ID
      at: DateTime | null
      value: JSONValue | null
      display: String | null
      targets: Array<{
        __typename: 'AppTableTarget'
        rowId: ID
        cells: Array<{
          __typename: 'AppTableCell'
          id: ID
          at: DateTime | null
          value: JSONValue | null
          display: String | null
        }>
      }>
    }>
  } | null
}

export type PushAppTableRowSubscriptionVariables = Exact<{
  input: AppTableSubscriptionInput
}>

export type PushAppTableRowSubscription = { __typename: 'Subscription'; pushAppTableRow: ID }

export type DeletedAppTableRowSubscriptionVariables = Exact<{
  input: AppTableSubscriptionInput
}>

export type DeletedAppTableRowSubscription = { __typename: 'Subscription'; deletedAppTableRow: ID }

export type UpdatedViewContentSubscriptionVariables = Exact<{
  id: Scalars['ID']
}>

export type UpdatedViewContentSubscription = {
  __typename: 'Subscription'
  updatedViewContent: {
    __typename: 'ViewContent'
    id: ID
    contentType: String
    latestVersion: Int
    sourceSnapshotHash: String | null
    content: String | null
    sdkVersion: String | null
    contentHash: String | null
    appSdkGraph: JSONObject | null
    tableMappings: JSONObject | null
  }
}

export type CallEndpointMutationVariables = Exact<{
  input: CallEndpointInput
}>

export type CallEndpointMutation = {
  __typename: 'Mutation'
  callEndpoint: { __typename: 'CallEndpointResult'; output: JSONValue | null }
}

export type WorkspaceViewFragment = {
  __typename: 'View'
  id: ID
  order: Int
  unitHeight: Int
  unitWidth: Int
  rowNumber: Int
  viewableObjectType: ViewableObjectType
  workspace: { __typename: 'Workspace'; id: ID; name: String | null } | null
  chart: { __typename: 'Chart'; id: ID; name: String; chartType: ChartType } | null
  table: {
    __typename: 'Table'
    id: ID
    name: String
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    tableTabs: Array<{ __typename: 'TableTab'; id: ID; order: Int }>
  } | null
  document: { __typename: 'Document'; id: ID; name: String } | null
  tableRow: {
    __typename: 'TableRow'
    id: ID
    table: { __typename: 'Table'; id: ID; name: String }
  } | null
  embed: {
    __typename: 'Embed'
    id: ID
    name: String
    betaWatermarkDisabled: Boolean | null
    viewContent: { __typename: 'ViewContent'; id: ID } | null
  } | null
  formV2: { __typename: 'FormV2'; id: ID; name: String } | null
}

export type GetDetailedWorkspaceQueryVariables = Exact<{
  workspaceId: Scalars['ID']
}>

export type GetDetailedWorkspaceQuery = {
  __typename: 'Query'
  workspace: {
    __typename: 'Workspace'
    id: ID
    name: String | null
    views: Array<{
      __typename: 'View'
      id: ID
      order: Int
      unitHeight: Int
      unitWidth: Int
      rowNumber: Int
      viewableObjectType: ViewableObjectType
      workspace: { __typename: 'Workspace'; id: ID; name: String | null } | null
      chart: { __typename: 'Chart'; id: ID; name: String; chartType: ChartType } | null
      table: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        tableTabs: Array<{ __typename: 'TableTab'; id: ID; order: Int }>
      } | null
      document: { __typename: 'Document'; id: ID; name: String } | null
      tableRow: {
        __typename: 'TableRow'
        id: ID
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
      embed: {
        __typename: 'Embed'
        id: ID
        name: String
        betaWatermarkDisabled: Boolean | null
        viewContent: { __typename: 'ViewContent'; id: ID } | null
      } | null
      formV2: { __typename: 'FormV2'; id: ID; name: String } | null
    }>
    actionButtons: Array<{
      __typename: 'WorkspaceButton'
      id: ID
      name: String
      order: Int
      manualTrigger: {
        __typename: 'ActionManualTrigger'
        id: ID
        action: {
          __typename: 'Action'
          id: ID
          status: ActionStatus
          workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
        } | null
      } | null
      form: { __typename: 'Form'; id: ID } | null
      formV2: { __typename: 'FormV2'; id: ID } | null
    }>
  }
}

export type GetFormsQueryVariables = Exact<{ [key: string]: never }>

export type GetFormsQuery = {
  __typename: 'Query'
  forms: Array<{
    __typename: 'Form'
    id: ID
    name: String
    isShareable: Boolean
    pages: Array<{
      __typename: 'FormPage'
      id: ID
      categories: Array<{
        __typename: 'FormCategory'
        id: ID
        fields: Array<{ __typename: 'FormField'; id: ID }>
      }>
    }>
    workflows: Array<{ __typename: 'Workflow'; id: ID; name: String }>
  }>
}

export type ExecuteActionManualTriggerMutationVariables = Exact<{
  input: ExecuteActionManualTriggerInput
}>

export type ExecuteActionManualTriggerMutation = {
  __typename: 'Mutation'
  executeActionManualTrigger: { __typename: 'ActionManualTrigger'; id: ID }
}

export type GetTablesForPermissionsQueryVariables = Exact<{ [key: string]: never }>

export type GetTablesForPermissionsQuery = {
  __typename: 'Query'
  tables: Array<{
    __typename: 'Table'
    id: ID
    name: String
    parentTable: { __typename: 'Table'; id: ID } | null
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      order: Int
      isReadOnly: Boolean
      isNullable: Boolean
      type: DataType
      indexAutogenerate: Boolean
      lookupColumnGroup: { __typename: 'LookupTableColumnGroup'; id: ID } | null
    }>
    tableTabs: Array<{ __typename: 'TableTab'; id: ID; name: String; order: Int }>
    childTables: Array<{
      __typename: 'Table'
      id: ID
      name: String
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        order: Int
        isReadOnly: Boolean
        isNullable: Boolean
        type: DataType
        indexAutogenerate: Boolean
        lookupColumnGroup: { __typename: 'LookupTableColumnGroup'; id: ID } | null
      }>
      tableTabs: Array<{ __typename: 'TableTab'; id: ID; name: String; order: Int }>
    }>
  }>
}

export type GetFormsForPermissionsQueryVariables = Exact<{ [key: string]: never }>

export type GetFormsForPermissionsQuery = {
  __typename: 'Query'
  forms: Array<{
    __typename: 'Form'
    id: ID
    name: String
    pages: Array<{
      __typename: 'FormPage'
      id: ID
      categories: Array<{
        __typename: 'FormCategory'
        id: ID
        lookupTable: {
          __typename: 'Table'
          id: ID
          name: String
          parentTable: { __typename: 'Table'; id: ID } | null
          columns: Array<{
            __typename: 'TableColumn'
            id: ID
            name: String
            order: Int
            isReadOnly: Boolean
            isNullable: Boolean
            type: DataType
            indexAutogenerate: Boolean
            lookupColumnGroup: { __typename: 'LookupTableColumnGroup'; id: ID } | null
          }>
          tableTabs: Array<{ __typename: 'TableTab'; id: ID; order: Int; name: String }>
          childTables: Array<{
            __typename: 'Table'
            id: ID
            name: String
            columns: Array<{
              __typename: 'TableColumn'
              id: ID
              name: String
              order: Int
              isReadOnly: Boolean
              isNullable: Boolean
              type: DataType
              indexAutogenerate: Boolean
              lookupColumnGroup: { __typename: 'LookupTableColumnGroup'; id: ID } | null
            }>
            tableTabs: Array<{ __typename: 'TableTab'; id: ID; name: String; order: Int }>
          }>
        } | null
      }>
    }>
  }>
}

export type GetFormsV2ForPermissionsQueryVariables = Exact<{ [key: string]: never }>

export type GetFormsV2ForPermissionsQuery = {
  __typename: 'Query'
  allFormsV2: Array<{
    __typename: 'FormV2'
    id: ID
    name: String
    lookupInputGroups: Array<{
      __typename: 'FormLookupInputGroup'
      id: ID
      lookupTable: {
        __typename: 'Table'
        id: ID
        name: String
        parentTable: { __typename: 'Table'; id: ID } | null
        columns: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          order: Int
          isReadOnly: Boolean
          isNullable: Boolean
          type: DataType
          indexAutogenerate: Boolean
          lookupColumnGroup: { __typename: 'LookupTableColumnGroup'; id: ID } | null
        }>
        tableTabs: Array<{ __typename: 'TableTab'; id: ID; name: String; order: Int }>
        childTables: Array<{
          __typename: 'Table'
          id: ID
          name: String
          columns: Array<{
            __typename: 'TableColumn'
            id: ID
            name: String
            order: Int
            isReadOnly: Boolean
            isNullable: Boolean
            type: DataType
            indexAutogenerate: Boolean
            lookupColumnGroup: { __typename: 'LookupTableColumnGroup'; id: ID } | null
          }>
          tableTabs: Array<{ __typename: 'TableTab'; id: ID; name: String; order: Int }>
        }>
      }
    }>
  }>
}

export type GetManualTriggersQueryVariables = Exact<{ [key: string]: never }>

export type GetManualTriggersQuery = {
  __typename: 'Query'
  actionManualTriggers: Array<{ __typename: 'ActionManualTrigger'; id: ID; name: String }>
}

export type GetEndpointsForPermissionsQueryVariables = Exact<{ [key: string]: never }>

export type GetEndpointsForPermissionsQuery = {
  __typename: 'Query'
  endpoints: Array<{ __typename: 'Endpoint'; id: ID; slug: String; internal: Boolean }>
}

export type GetUnplacedEmbedsForPermissionsQueryVariables = Exact<{ [key: string]: never }>

export type GetUnplacedEmbedsForPermissionsQuery = {
  __typename: 'Query'
  unplacedEmbeds: Array<{ __typename: 'Embed'; id: ID; name: String }>
}

export type GetWorkspacesForPermissionsQueryVariables = Exact<{ [key: string]: never }>

export type GetWorkspacesForPermissionsQuery = {
  __typename: 'Query'
  workspaces: Array<{
    __typename: 'Workspace'
    id: ID
    name: String | null
    parentObject: { __typename: 'WorkspaceParentObject'; name: String } | null
    views: Array<{
      __typename: 'View'
      id: ID
      viewableObjectType: ViewableObjectType
      workspace: { __typename: 'Workspace'; id: ID; name: String | null } | null
      embed: { __typename: 'Embed'; id: ID; name: String } | null
    }>
    linkedViews: Array<{
      __typename: 'View'
      id: ID
      viewableObjectType: ViewableObjectType
      workspace: { __typename: 'Workspace'; id: ID; name: String | null } | null
    }>
  }>
}

export type UpdatedUserFragment = {
  __typename: 'Membership'
  id: ID
  profilePicture: {
    __typename: 'Document'
    id: ID
    name: String
    storagePath: String
    documentType: DocumentType
  } | null
}

export type GetActiveUsersQueryVariables = Exact<{ [key: string]: never }>

export type GetActiveUsersQuery = {
  __typename: 'Query'
  activeUsers: Array<{
    __typename: 'Membership'
    id: ID
    firstName: String
    lastName: String
    email: String | null
    phoneNumber: String | null
    roles: Array<{ __typename: 'Role'; id: ID; name: String }>
    profilePicture: { __typename: 'Document'; id: ID; name: String; storageUrl: String } | null
  }>
}

export type GetOrganizationRolesQueryVariables = Exact<{ [key: string]: never }>

export type GetOrganizationRolesQuery = {
  __typename: 'Query'
  roles: Array<{
    __typename: 'Role'
    id: ID
    name: String
    roleType: RoleType
    permissions: Array<{
      __typename: 'Permission'
      id: ID
      permissionType: PermissionType
      objectType: PermissionObjectType
      manualTrigger: { __typename: 'ActionManualTrigger'; id: ID; name: String } | null
      endpoint: { __typename: 'Endpoint'; id: ID; slug: String } | null
      table: { __typename: 'Table'; id: ID; name: String } | null
      tableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID }
      } | null
      tableTab: {
        __typename: 'TableTab'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID }
      } | null
      form: { __typename: 'Form'; id: ID; name: String } | null
      formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      workspace: { __typename: 'Workspace'; id: ID; name: String | null } | null
    }>
    users: Array<{
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      status: MembershipStatus
      profilePicture: { __typename: 'Document'; id: ID; name: String; storageUrl: String } | null
    }>
  }>
}

export type GetRoleQueryVariables = Exact<{
  roleId: Scalars['ID']
}>

export type GetRoleQuery = {
  __typename: 'Query'
  role: {
    __typename: 'Role'
    id: ID
    name: String
    roleType: RoleType
    permissions: Array<{
      __typename: 'Permission'
      id: ID
      permissionType: PermissionType
      objectType: PermissionObjectType
      manualTrigger: { __typename: 'ActionManualTrigger'; id: ID; name: String } | null
      endpoint: { __typename: 'Endpoint'; id: ID; slug: String } | null
      table: { __typename: 'Table'; id: ID; name: String } | null
      tableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID }
      } | null
      tableTab: {
        __typename: 'TableTab'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID }
      } | null
      form: { __typename: 'Form'; id: ID; name: String } | null
      formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      workspace: { __typename: 'Workspace'; id: ID; name: String | null } | null
      embed: { __typename: 'Embed'; id: ID; name: String } | null
    }>
  }
}

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['ID']
}>

export type DeleteRoleMutation = {
  __typename: 'Mutation'
  deleteRole: { __typename: 'Role'; id: ID }
}

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput
}>

export type CreateRoleMutation = {
  __typename: 'Mutation'
  createRole: {
    __typename: 'Role'
    id: ID
    name: String
    roleType: RoleType
    permissions: Array<{
      __typename: 'Permission'
      id: ID
      permissionType: PermissionType
      objectType: PermissionObjectType
      manualTrigger: { __typename: 'ActionManualTrigger'; id: ID; name: String } | null
      table: { __typename: 'Table'; id: ID; name: String } | null
      tableColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
      tableTab: { __typename: 'TableTab'; id: ID; name: String } | null
      form: { __typename: 'Form'; id: ID; name: String } | null
      formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      workspace: { __typename: 'Workspace'; id: ID; name: String | null } | null
    }>
    users: Array<{ __typename: 'Membership'; id: ID; firstName: String; lastName: String }>
  }
}

export type DuplicateRoleMutationVariables = Exact<{
  roleId: Scalars['ID']
}>

export type DuplicateRoleMutation = {
  __typename: 'Mutation'
  duplicateRole: {
    __typename: 'Role'
    id: ID
    name: String
    roleType: RoleType
    permissions: Array<{
      __typename: 'Permission'
      id: ID
      permissionType: PermissionType
      objectType: PermissionObjectType
      manualTrigger: { __typename: 'ActionManualTrigger'; id: ID; name: String } | null
      table: { __typename: 'Table'; id: ID; name: String } | null
      tableColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
      tableTab: { __typename: 'TableTab'; id: ID; name: String } | null
      form: { __typename: 'Form'; id: ID; name: String } | null
      formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      workspace: { __typename: 'Workspace'; id: ID; name: String | null } | null
    }>
    users: Array<{ __typename: 'Membership'; id: ID; firstName: String; lastName: String }>
  }
}

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRoleInput
}>

export type UpdateRoleMutation = {
  __typename: 'Mutation'
  updateRole: {
    __typename: 'Role'
    id: ID
    name: String
    roleType: RoleType
    permissions: Array<{
      __typename: 'Permission'
      id: ID
      permissionType: PermissionType
      objectType: PermissionObjectType
      manualTrigger: { __typename: 'ActionManualTrigger'; id: ID; name: String } | null
      table: { __typename: 'Table'; id: ID; name: String } | null
      tableColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
      tableTab: { __typename: 'TableTab'; id: ID; name: String } | null
      form: { __typename: 'Form'; id: ID; name: String } | null
      formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      workspace: { __typename: 'Workspace'; id: ID; name: String | null } | null
    }>
    users: Array<{ __typename: 'Membership'; id: ID; firstName: String; lastName: String }>
  }
}

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput
}>

export type CreateUserMutation = {
  __typename: 'Mutation'
  createUser: {
    __typename: 'Membership'
    id: ID
    firstName: String
    lastName: String
    email: String | null
    phoneNumber: String | null
    roles: Array<{ __typename: 'Role'; id: ID; name: String }>
  }
}

export type GetPendingInvitesQueryVariables = Exact<{ [key: string]: never }>

export type GetPendingInvitesQuery = {
  __typename: 'Query'
  pendingInvites: Array<{
    __typename: 'Membership'
    id: ID
    firstName: String
    lastName: String
    email: String | null
    phoneNumber: String | null
    roles: Array<{ __typename: 'Role'; id: ID; name: String }>
  }>
}

export type CancelInviteMutationVariables = Exact<{
  membershipId: Scalars['ID']
}>

export type CancelInviteMutation = {
  __typename: 'Mutation'
  cancelInvite: { __typename: 'Membership'; id: ID }
}

export type ResendInviteMutationVariables = Exact<{
  membershipId: Scalars['ID']
}>

export type ResendInviteMutation = {
  __typename: 'Mutation'
  resendInvite: { __typename: 'Membership'; id: ID }
}

export type UpdateUserRolesMutationVariables = Exact<{
  input: UpdateUserRolesInput
}>

export type UpdateUserRolesMutation = {
  __typename: 'Mutation'
  updateUserRoles: {
    __typename: 'Membership'
    id: ID
    firstName: String
    lastName: String
    email: String | null
    roles: Array<{ __typename: 'Role'; id: ID; name: String }>
  }
}

export type UpdateUserProfilePictureMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserProfilePictureInput>
}>

export type UpdateUserProfilePictureMutation = {
  __typename: 'Mutation'
  updateUserProfilePicture: {
    __typename: 'Membership'
    id: ID
    profilePicture: { __typename: 'Document'; id: ID; name: String; storageUrl: String } | null
  }
}

export type GetOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']
}>

export type GetOrganizationQuery = {
  __typename: 'Query'
  organization: {
    __typename: 'Organization'
    id: ID
    name: String
    users: Array<{
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      email: String | null
      status: MembershipStatus
    }>
  }
}

export type GetOrganizationExportsQueryVariables = Exact<{ [key: string]: never }>

export type GetOrganizationExportsQuery = {
  __typename: 'Query'
  organizationExports: Array<{
    __typename: 'OrganizationExport'
    id: ID
    createdAt: DateTime
    status: OrganizationExportStatus
    totalTableCount: Int
    completedTableCount: Int
    failedTableCount: Int
    document: { __typename: 'Document'; id: ID; name: String; storageUrl: String } | null
  }>
}

export type CreateOrganizationExportMutationVariables = Exact<{ [key: string]: never }>

export type CreateOrganizationExportMutation = {
  __typename: 'Mutation'
  createOrganizationExport: {
    __typename: 'OrganizationExport'
    id: ID
    status: OrganizationExportStatus
  }
}

export type SendEmailMutationVariables = Exact<{
  input: SendEmailInput
}>

export type SendEmailMutation = { __typename: 'Mutation'; sendEmail: Boolean }

export type TableTabColumnsFragmentFragment = {
  __typename: 'TableTab'
  id: ID
  columns: Array<{
    __typename: 'TableTabColumn'
    id: ID
    order: Int
    isFrozen: Boolean
    systemGeneratedColumnType: SystemGeneratedTableColumnType | null
    tableColumn: {
      __typename: 'TableColumn'
      id: ID
      name: String
      order: Int
      type: DataType
      isNullable: Boolean
      enumOptions: Array<String> | null
      lookupColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID; name: String }
      } | null
    } | null
  }>
}

export type TableColumnFiltersFragmentFragment = {
  __typename: 'TableTab'
  id: ID
  booleanOperator: BooleanOperator | null
  filters: Array<{
    __typename: 'TableColumnFilter'
    id: ID
    operator: FilterOperator
    operand: JSONObject | null
    systemGeneratedColumnType: SystemGeneratedTableColumnType | null
    tableColumn: { __typename: 'TableColumn'; id: ID } | null
  }>
}

export type TableTabSortsFragmentFragment = {
  __typename: 'TableTab'
  id: ID
  sorts: Array<{
    __typename: 'TableTabSort'
    id: ID
    direction: SortDirection
    systemGeneratedColumnType: SystemGeneratedTableColumnType | null
    tableColumn: { __typename: 'TableColumn'; id: ID } | null
  }>
}

export type GetCsvExportTableRowsQueryVariables = Exact<{
  input: PaginatedCsvExportInput
}>

export type GetCsvExportTableRowsQuery = {
  __typename: 'Query'
  paginatedCsvExport: {
    __typename: 'PaginatedTableRows'
    offset: Int
    hasNext: Boolean
    totalCount: Int
    rows: Array<{
      __typename: 'TableRow'
      id: ID
      createdAt: DateTime
      updatedAt: DateTime
      parentRow: { __typename: 'TableRow'; id: ID } | null
      createdBy: {
        __typename: 'Membership'
        id: ID
        firstName: String
        lastName: String
        email: String | null
      } | null
      updatedBy: {
        __typename: 'Membership'
        id: ID
        firstName: String
        lastName: String
        email: String | null
      } | null
      cells: Array<{
        __typename: 'TableCell'
        id: ID
        userVisibleValue: String | null
        data: JSONObject | null
        column: { __typename: 'TableColumn'; id: ID }
      }>
      childRows: Array<{
        __typename: 'TableRow'
        id: ID
        createdAt: DateTime
        updatedAt: DateTime
        parentRow: { __typename: 'TableRow'; id: ID } | null
        createdBy: {
          __typename: 'Membership'
          id: ID
          firstName: String
          lastName: String
          email: String | null
        } | null
        updatedBy: {
          __typename: 'Membership'
          id: ID
          firstName: String
          lastName: String
          email: String | null
        } | null
        cells: Array<{
          __typename: 'TableCell'
          id: ID
          userVisibleValue: String | null
          data: JSONObject | null
          column: { __typename: 'TableColumn'; id: ID }
        }>
      }>
    }>
  }
}

export type GetBulkActionEligibilityCountsQueryVariables = Exact<{
  input: BulkActionEligibilityCountsInput
}>

export type GetBulkActionEligibilityCountsQuery = {
  __typename: 'Query'
  bulkActionEligibilityCounts: {
    __typename: 'BulkActionEligibilityCountsResult'
    totalSelectedCount: Int
    buttonEligibilityCounts: Array<{
      __typename: 'ButtonEligibilityCount'
      id: ID
      name: String
      order: Int
      eligibleCount: Int
      hasMore: Boolean
      eligibleRowIds: Array<ID>
      buttonConfiguration: JSONObject | null
      requiresConfirmation: Boolean
      confirmationMessage: String | null
      icon: { __typename: 'Icon'; name: String } | null
      manualTrigger: { __typename: 'ActionManualTrigger'; id: ID } | null
    }>
  }
}

export type GetDeleteBlockingCheckQueryVariables = Exact<{
  input: DeleteBlockingCheckInput
}>

export type GetDeleteBlockingCheckQuery = {
  __typename: 'Query'
  deleteBlockingCheck: {
    __typename: 'DeleteBlockingCheckResult'
    totalCount: Int
    deletableCount: Int
    blockedCount: Int
    blockedRows: Array<{
      __typename: 'RowDeleteBlockingInfo'
      rowId: ID
      rowName: String
      canDelete: Boolean
      blockingReferences: Array<{
        __typename: 'DeleteBlockingReference'
        columnId: ID
        columnName: String
        tableId: ID
        tableName: String
        row: { __typename: 'TableRow'; id: ID; name: String }
      }>
    }>
  }
}

export type ExecuteBulkActionMutationVariables = Exact<{
  input: ExecuteBulkActionInput
}>

export type ExecuteBulkActionMutation = {
  __typename: 'Mutation'
  executeBulkAction: {
    __typename: 'ExecuteBulkActionResult'
    executedCount: Int
    skippedCount: Int
    executedRowIds: Array<ID>
    errors: Array<{ __typename: 'BulkActionError'; rowId: ID; message: String }> | null
  }
}

export type BulkDeleteTableRowsMutationVariables = Exact<{
  input: BulkDeleteTableRowsInput
}>

export type BulkDeleteTableRowsMutation = {
  __typename: 'Mutation'
  bulkDeleteTableRows: {
    __typename: 'BulkDeleteTableRowsResult'
    deletedCount: Int
    skippedCount: Int
    errors: Array<{
      __typename: 'BulkActionError'
      rowId: ID
      rowName: String | null
      message: String
      blockingRows: Array<{ __typename: 'TableRow'; id: ID; name: String }> | null
      blockingReferences: Array<{
        __typename: 'DeleteBlockingReference'
        columnId: ID
        columnName: String
        tableId: ID
        tableName: String
        row: { __typename: 'TableRow'; id: ID; name: String }
      }> | null
    }> | null
  }
}

export type BulkDuplicateTableRowsMutationVariables = Exact<{
  input: BulkDuplicateTableRowsInput
}>

export type BulkDuplicateTableRowsMutation = {
  __typename: 'Mutation'
  bulkDuplicateTableRows: {
    __typename: 'BulkDuplicateTableRowsResult'
    duplicatedCount: Int
    errors: Array<{ __typename: 'BulkActionError'; rowId: ID; message: String }> | null
  }
}

export type ColumnFormattingFragment = {
  __typename: 'TableColumn'
  formatPreset: FormatPreset | null
  formatOptions: JSONObject | null
}

export type EnumSetFieldsFragment = {
  __typename: 'TableColumn'
  enumSet: {
    __typename: 'EnumSet'
    id: ID
    options: Array<{
      __typename: 'EnumOption'
      id: ID
      label: String
      colorPreset: EnumColorPreset | null
      colorCustom: String | null
      iconName: String | null
      order: Int
      icon: { __typename: 'Icon'; id: ID } | null
    }>
  } | null
}

export type LookupProviderColumnFragment = {
  __typename: 'TableColumn'
  id: ID
  type: DataType
  formatPreset: FormatPreset | null
  formatOptions: JSONObject | null
}

export type ResolvedSourceColumnFragment = {
  __typename: 'TableColumn'
  resolvedSourceColumn: {
    __typename: 'ResolvedTableColumnInfo'
    column: {
      __typename: 'TableColumn'
      id: ID
      type: DataType
      innerType: DataType | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      enumSet: {
        __typename: 'EnumSet'
        id: ID
        options: Array<{
          __typename: 'EnumOption'
          id: ID
          label: String
          colorPreset: EnumColorPreset | null
          colorCustom: String | null
          iconName: String | null
          order: Int
          icon: { __typename: 'Icon'; id: ID } | null
        }>
      } | null
    }
  }
}

export type GetTableColumnsByIdQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetTableColumnsByIdQuery = {
  __typename: 'Query'
  tableColumnsById: Array<{
    __typename: 'TableColumn'
    id: ID
    name: String
    description: String | null
    order: Int
    type: DataType
    innerType: DataType | null
    isNullable: Boolean
    isReadOnly: Boolean
    isDecimal: Boolean
    indexType: IndexType
    indexPrefix: String
    indexSuffix: String
    indexAutogenerate: Boolean
    enumOptions: Array<String> | null
    displayImagesInline: Boolean
    isVisibleOnRecordDetails: Boolean
    resolvedSourceType: DataType
    resolvedEnumOptions: Array<String> | null
    formatPreset: FormatPreset | null
    formatOptions: JSONObject | null
    lookupColumn: {
      __typename: 'TableColumn'
      name: String
      order: Int
      innerType: DataType | null
      indexType: IndexType
      indexPrefix: String
      indexSuffix: String
      enumOptions: Array<String> | null
      id: ID
      type: DataType
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      table: { __typename: 'Table'; id: ID; name: String }
      resolvedSourceColumn: {
        __typename: 'ResolvedTableColumnInfo'
        column: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          innerType: DataType | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }
      }
    } | null
    lookupColumnChildren: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      table: { __typename: 'Table'; id: ID }
      lookupColumnGroup: {
        __typename: 'LookupTableColumnGroup'
        id: ID
        showBacklink: Boolean | null
        backlinkName: String | null
      } | null
    }>
    lookupColumnGroup: {
      __typename: 'LookupTableColumnGroup'
      id: ID
      showBacklink: Boolean | null
      backlinkName: String | null
    } | null
    lookupFilterExpression: {
      __typename: 'LogicExpression'
      id: ID
      logicExpressionString: String | null
    } | null
    formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
    chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
    resolvedSourceColumn: {
      __typename: 'ResolvedTableColumnInfo'
      column: {
        __typename: 'TableColumn'
        id: ID
        type: DataType
        innerType: DataType | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }
    }
    enumSet: {
      __typename: 'EnumSet'
      id: ID
      options: Array<{
        __typename: 'EnumOption'
        id: ID
        label: String
        colorPreset: EnumColorPreset | null
        colorCustom: String | null
        iconName: String | null
        order: Int
        icon: { __typename: 'Icon'; id: ID } | null
      }>
    } | null
  }>
}

export type CreateTableColumnMutationVariables = Exact<{
  input: CreateTableColumnInput
}>

export type CreateTableColumnMutation = {
  __typename: 'Mutation'
  createTableColumn: {
    __typename: 'TableColumn'
    hasNonNullCells: Boolean
    hasNullCells: Boolean
    id: ID
    name: String
    description: String | null
    order: Int
    type: DataType
    innerType: DataType | null
    isNullable: Boolean
    isReadOnly: Boolean
    isDecimal: Boolean
    indexType: IndexType
    indexPrefix: String
    indexSuffix: String
    indexAutogenerate: Boolean
    enumOptions: Array<String> | null
    displayImagesInline: Boolean
    isVisibleOnRecordDetails: Boolean
    resolvedSourceType: DataType
    resolvedEnumOptions: Array<String> | null
    formatPreset: FormatPreset | null
    formatOptions: JSONObject | null
    lookupColumnGroup: {
      __typename: 'LookupTableColumnGroup'
      id: ID
      showBacklink: Boolean | null
      backlinkName: String | null
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        lookupColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
      }>
      lookupTable: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
      }
    } | null
    tableTabs: Array<{
      __typename: 'TableTabColumn'
      id: ID
      order: Int
      isFrozen: Boolean
      tableTab: { __typename: 'TableTab'; id: ID }
    }>
    lookupColumn: {
      __typename: 'TableColumn'
      name: String
      order: Int
      innerType: DataType | null
      indexType: IndexType
      indexPrefix: String
      indexSuffix: String
      enumOptions: Array<String> | null
      id: ID
      type: DataType
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      table: { __typename: 'Table'; id: ID; name: String }
      resolvedSourceColumn: {
        __typename: 'ResolvedTableColumnInfo'
        column: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          innerType: DataType | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }
      }
    } | null
    lookupColumnChildren: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      table: { __typename: 'Table'; id: ID }
      lookupColumnGroup: {
        __typename: 'LookupTableColumnGroup'
        id: ID
        showBacklink: Boolean | null
        backlinkName: String | null
      } | null
    }>
    lookupFilterExpression: {
      __typename: 'LogicExpression'
      id: ID
      logicExpressionString: String | null
    } | null
    formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
    chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
    resolvedSourceColumn: {
      __typename: 'ResolvedTableColumnInfo'
      column: {
        __typename: 'TableColumn'
        id: ID
        type: DataType
        innerType: DataType | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }
    }
    enumSet: {
      __typename: 'EnumSet'
      id: ID
      options: Array<{
        __typename: 'EnumOption'
        id: ID
        label: String
        colorPreset: EnumColorPreset | null
        colorCustom: String | null
        iconName: String | null
        order: Int
        icon: { __typename: 'Icon'; id: ID } | null
      }>
    } | null
  }
}

export type UpdateTableColumnMutationVariables = Exact<{
  input: UpdateTableColumnInput
}>

export type UpdateTableColumnMutation = {
  __typename: 'Mutation'
  updateTableColumn: {
    __typename: 'TableColumn'
    hasNonNullCells: Boolean
    hasNullCells: Boolean
    id: ID
    name: String
    description: String | null
    order: Int
    type: DataType
    innerType: DataType | null
    isNullable: Boolean
    isReadOnly: Boolean
    isDecimal: Boolean
    indexType: IndexType
    indexPrefix: String
    indexSuffix: String
    indexAutogenerate: Boolean
    enumOptions: Array<String> | null
    displayImagesInline: Boolean
    isVisibleOnRecordDetails: Boolean
    resolvedSourceType: DataType
    resolvedEnumOptions: Array<String> | null
    formatPreset: FormatPreset | null
    formatOptions: JSONObject | null
    lookupColumnGroup: {
      __typename: 'LookupTableColumnGroup'
      id: ID
      showBacklink: Boolean | null
      backlinkName: String | null
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        lookupColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
      }>
      lookupTable: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
      }
    } | null
    tableTabs: Array<{ __typename: 'TableTabColumn'; id: ID }>
    lookupColumn: {
      __typename: 'TableColumn'
      name: String
      order: Int
      innerType: DataType | null
      indexType: IndexType
      indexPrefix: String
      indexSuffix: String
      enumOptions: Array<String> | null
      id: ID
      type: DataType
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      table: { __typename: 'Table'; id: ID; name: String }
      resolvedSourceColumn: {
        __typename: 'ResolvedTableColumnInfo'
        column: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          innerType: DataType | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }
      }
    } | null
    lookupColumnChildren: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      table: { __typename: 'Table'; id: ID }
      lookupColumnGroup: {
        __typename: 'LookupTableColumnGroup'
        id: ID
        showBacklink: Boolean | null
        backlinkName: String | null
      } | null
    }>
    lookupFilterExpression: {
      __typename: 'LogicExpression'
      id: ID
      logicExpressionString: String | null
    } | null
    formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
    chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
    resolvedSourceColumn: {
      __typename: 'ResolvedTableColumnInfo'
      column: {
        __typename: 'TableColumn'
        id: ID
        type: DataType
        innerType: DataType | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }
    }
    enumSet: {
      __typename: 'EnumSet'
      id: ID
      options: Array<{
        __typename: 'EnumOption'
        id: ID
        label: String
        colorPreset: EnumColorPreset | null
        colorCustom: String | null
        iconName: String | null
        order: Int
        icon: { __typename: 'Icon'; id: ID } | null
      }>
    } | null
  }
}

export type DeleteTableColumnMutationVariables = Exact<{
  input: DeleteTableColumnInput
}>

export type DeleteTableColumnMutation = {
  __typename: 'Mutation'
  deleteTableColumn: { __typename: 'TableColumn'; id: ID }
}

export type DeleteTableColumnsMutationVariables = Exact<{
  input: DeleteTableColumnsInput
}>

export type DeleteTableColumnsMutation = {
  __typename: 'Mutation'
  deleteTableColumns: Array<{ __typename: 'TableColumn'; id: ID }>
}

export type AddTableColumnGetTableDetailsQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type AddTableColumnGetTableDetailsQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    name: String
    description: String | null
    hasRows: Boolean
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    parentTable: { __typename: 'Table'; id: ID } | null
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      description: String | null
      order: Int
      type: DataType
      innerType: DataType | null
      isNullable: Boolean
      isReadOnly: Boolean
      isDecimal: Boolean
      indexType: IndexType
      indexPrefix: String
      indexSuffix: String
      indexAutogenerate: Boolean
      enumOptions: Array<String> | null
      displayImagesInline: Boolean
      hasNonNullCells: Boolean
      hasNullCells: Boolean
      tableTabs: Array<{ __typename: 'TableTabColumn'; id: ID }>
      formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
      lookupColumn: {
        __typename: 'TableColumn'
        id: ID
        type: DataType
        table: { __typename: 'Table'; id: ID }
        lookupColumnGroup: { __typename: 'LookupTableColumnGroup'; id: ID } | null
      } | null
      enumSet: {
        __typename: 'EnumSet'
        id: ID
        options: Array<{
          __typename: 'EnumOption'
          id: ID
          label: String
          colorPreset: EnumColorPreset | null
          colorCustom: String | null
          iconName: String | null
          order: Int
          icon: { __typename: 'Icon'; id: ID } | null
        }>
      } | null
    }>
    childTables: Array<{
      __typename: 'Table'
      id: ID
      name: String
      description: String | null
      hasRows: Boolean
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        description: String | null
        order: Int
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        isReadOnly: Boolean
        isDecimal: Boolean
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        indexAutogenerate: Boolean
        enumOptions: Array<String> | null
        displayImagesInline: Boolean
        hasNonNullCells: Boolean
        hasNullCells: Boolean
        tableTabs: Array<{ __typename: 'TableTabColumn'; id: ID }>
        formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
        lookupColumn: { __typename: 'TableColumn'; id: ID; type: DataType } | null
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }>
    }>
    lookupColumnGroups: Array<{
      __typename: 'LookupTableColumnGroup'
      id: ID
      lookupTable: { __typename: 'Table'; id: ID; name: String }
    }>
  }
}

export type ReorderTableColumnsMutationVariables = Exact<{
  input: ReorderTableColumnsInput
}>

export type ReorderTableColumnsMutation = {
  __typename: 'Mutation'
  reorderTableColumns: Array<{ __typename: 'TableColumn'; id: ID; order: Int }>
}

export type GetOrganizationRolesWithTablePermissionsQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetOrganizationRolesWithTablePermissionsQuery = {
  __typename: 'Query'
  roles: Array<{
    __typename: 'Role'
    id: ID
    name: String
    roleType: RoleType
    tablePermissions: Array<{
      __typename: 'Permission'
      id: ID
      permissionType: PermissionType
      objectType: PermissionObjectType
      table: { __typename: 'Table'; id: ID; name: String } | null
      tableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID }
      } | null
      tableTab: {
        __typename: 'TableTab'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID }
      } | null
    }>
  }>
}

export type UpdateRoleTablePermissionsMutationVariables = Exact<{
  input: UpdateRoleTablePermissionsInput
  tableId: Scalars['ID']
}>

export type UpdateRoleTablePermissionsMutation = {
  __typename: 'Mutation'
  updateRoleTablePermissions: {
    __typename: 'Role'
    id: ID
    name: String
    tablePermissions: Array<{
      __typename: 'Permission'
      id: ID
      permissionType: PermissionType
      objectType: PermissionObjectType
      table: { __typename: 'Table'; id: ID; name: String } | null
      tableColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
      tableTab: { __typename: 'TableTab'; id: ID; name: String } | null
    }>
  }
}

export type GetTableColumnsTabsChildTablesQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetTableColumnsTabsChildTablesQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    name: String
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      order: Int
      type: DataType
      indexAutogenerate: Boolean
      isNullable: Boolean
    }>
    tableTabs: Array<{ __typename: 'TableTab'; id: ID; order: Int }>
    childTables: Array<{
      __typename: 'Table'
      id: ID
      name: String
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        order: Int
        type: DataType
        indexAutogenerate: Boolean
        isNullable: Boolean
      }>
      tableTabs: Array<{ __typename: 'TableTab'; id: ID; order: Int }>
    }>
  }
}

export type GetTableColumnRelatedActionStepsQueryVariables = Exact<{
  input: RelatedEntitiesInput
}>

export type GetTableColumnRelatedActionStepsQuery = {
  __typename: 'Query'
  relatedActionSteps: {
    __typename: 'RelatedActionStepsResult'
    readSteps: Array<{
      __typename: 'ActionStep'
      id: ID
      name: String
      type: ActionStepType
      status: ActionStepStatus
      rootAction: {
        __typename: 'Action'
        id: ID
        name: String
        status: ActionStatus
        workflow: { __typename: 'Workflow'; id: ID; name: String }
      }
    }>
    writeSteps: Array<{
      __typename: 'ActionStep'
      id: ID
      name: String
      type: ActionStepType
      status: ActionStepStatus
      rootAction: {
        __typename: 'Action'
        id: ID
        name: String
        status: ActionStatus
        workflow: { __typename: 'Workflow'; id: ID; name: String }
      }
    }>
  }
}

export type GetTableButtonNodesQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetTableButtonNodesQuery = {
  __typename: 'Query'
  tableButtonNodes: Array<{
    __typename: 'TableButtonNode'
    id: ID
    name: String
    workspaceButtons: Array<{
      __typename: 'WorkspaceButton'
      id: ID
      name: String
      order: Int
      buttonConfiguration: JSONObject | null
      requiresConfirmation: Boolean
      confirmationMessage: String | null
      icon: { __typename: 'Icon'; id: ID; name: String } | null
      manualTrigger: {
        __typename: 'ActionManualTrigger'
        id: ID
        name: String
        action: {
          __typename: 'Action'
          id: ID
          description: String | null
          workflow: { __typename: 'Workflow'; id: ID }
        } | null
        permissions: Array<{
          __typename: 'Permission'
          id: ID
          role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
        }>
      } | null
      form: {
        __typename: 'Form'
        id: ID
        name: String
        permissions: Array<{
          __typename: 'Permission'
          id: ID
          role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
        }>
      } | null
      formV2: {
        __typename: 'FormV2'
        id: ID
        name: String
        permissions: Array<{
          __typename: 'Permission'
          id: ID
          role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
        }>
      } | null
    }>
    outgoingTransitions: Array<{
      __typename: 'TableButtonTransition'
      id: ID
      name: String | null
      targetNode: { __typename: 'TableButtonNode'; id: ID }
      condition: { __typename: 'LogicExpression'; id: ID; logicExpressionString: String | null }
    }>
    incomingTransitions: Array<{
      __typename: 'TableButtonTransition'
      id: ID
      name: String | null
      condition: { __typename: 'LogicExpression'; id: ID; logicExpressionString: String | null }
    }>
    rootButtonNodeConfig: {
      __typename: 'TableButtonStateMachineConfig'
      id: ID
      rootButtonNode: { __typename: 'TableButtonNode'; id: ID }
    } | null
  }>
}

export type CreateTableButtonNodeMutationVariables = Exact<{
  input: CreateButtonNodeInput
}>

export type CreateTableButtonNodeMutation = {
  __typename: 'Mutation'
  createTableButtonNode: {
    __typename: 'TableButtonNode'
    id: ID
    name: String
    workspaceButtons: Array<{
      __typename: 'WorkspaceButton'
      id: ID
      name: String
      order: Int
      buttonConfiguration: JSONObject | null
      requiresConfirmation: Boolean
      confirmationMessage: String | null
      icon: { __typename: 'Icon'; id: ID; name: String } | null
      manualTrigger: {
        __typename: 'ActionManualTrigger'
        id: ID
        name: String
        action: {
          __typename: 'Action'
          id: ID
          description: String | null
          workflow: { __typename: 'Workflow'; id: ID }
        } | null
        permissions: Array<{
          __typename: 'Permission'
          id: ID
          role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
        }>
      } | null
      form: {
        __typename: 'Form'
        id: ID
        name: String
        permissions: Array<{
          __typename: 'Permission'
          id: ID
          role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
        }>
      } | null
      formV2: {
        __typename: 'FormV2'
        id: ID
        name: String
        permissions: Array<{
          __typename: 'Permission'
          id: ID
          role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
        }>
      } | null
    }>
    outgoingTransitions: Array<{
      __typename: 'TableButtonTransition'
      id: ID
      name: String | null
      targetNode: { __typename: 'TableButtonNode'; id: ID }
      condition: { __typename: 'LogicExpression'; id: ID; logicExpressionString: String | null }
    }>
    incomingTransitions: Array<{
      __typename: 'TableButtonTransition'
      id: ID
      name: String | null
      condition: { __typename: 'LogicExpression'; id: ID; logicExpressionString: String | null }
    }>
    rootButtonNodeConfig: {
      __typename: 'TableButtonStateMachineConfig'
      id: ID
      rootButtonNode: { __typename: 'TableButtonNode'; id: ID }
    } | null
  }
}

export type UpdateTableButtonNodeMutationVariables = Exact<{
  input: UpdateButtonNodeInput
}>

export type UpdateTableButtonNodeMutation = {
  __typename: 'Mutation'
  updateTableButtonNode: {
    __typename: 'TableButtonNode'
    id: ID
    name: String
    workspaceButtons: Array<{
      __typename: 'WorkspaceButton'
      id: ID
      name: String
      order: Int
      buttonConfiguration: JSONObject | null
      requiresConfirmation: Boolean
      confirmationMessage: String | null
      icon: { __typename: 'Icon'; id: ID; name: String } | null
      manualTrigger: {
        __typename: 'ActionManualTrigger'
        id: ID
        name: String
        action: {
          __typename: 'Action'
          id: ID
          description: String | null
          workflow: { __typename: 'Workflow'; id: ID }
        } | null
        permissions: Array<{
          __typename: 'Permission'
          id: ID
          role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
        }>
      } | null
      form: {
        __typename: 'Form'
        id: ID
        name: String
        permissions: Array<{
          __typename: 'Permission'
          id: ID
          role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
        }>
      } | null
      formV2: {
        __typename: 'FormV2'
        id: ID
        name: String
        permissions: Array<{
          __typename: 'Permission'
          id: ID
          role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
        }>
      } | null
    }>
    outgoingTransitions: Array<{
      __typename: 'TableButtonTransition'
      id: ID
      name: String | null
      targetNode: { __typename: 'TableButtonNode'; id: ID }
      condition: { __typename: 'LogicExpression'; id: ID; logicExpressionString: String | null }
    }>
    incomingTransitions: Array<{
      __typename: 'TableButtonTransition'
      id: ID
      name: String | null
      condition: { __typename: 'LogicExpression'; id: ID; logicExpressionString: String | null }
    }>
    rootButtonNodeConfig: {
      __typename: 'TableButtonStateMachineConfig'
      id: ID
      rootButtonNode: { __typename: 'TableButtonNode'; id: ID }
    } | null
  }
}

export type DeleteTableButtonNodeMutationVariables = Exact<{
  tableButtonNodeId: Scalars['ID']
}>

export type DeleteTableButtonNodeMutation = {
  __typename: 'Mutation'
  deleteTableButtonNode: { __typename: 'TableButtonNode'; id: ID }
}

export type DeleteTableButtonTransitionMutationVariables = Exact<{
  tableButtonTransitionId: Scalars['ID']
}>

export type DeleteTableButtonTransitionMutation = {
  __typename: 'Mutation'
  deleteTableButtonTransition: { __typename: 'TableButtonTransition'; id: ID }
}

export type CreateTableButtonTransitionMutationVariables = Exact<{
  input: CreateButtonTransitionInput
}>

export type CreateTableButtonTransitionMutation = {
  __typename: 'Mutation'
  createTableButtonTransition: {
    __typename: 'TableButtonTransition'
    id: ID
    name: String | null
    condition: { __typename: 'LogicExpression'; id: ID; logicExpressionString: String | null }
  }
}

export type UpdateTableButtonTransitionMutationVariables = Exact<{
  input: UpdateButtonTransitionInput
}>

export type UpdateTableButtonTransitionMutation = {
  __typename: 'Mutation'
  updateTableButtonTransition: {
    __typename: 'TableButtonTransition'
    id: ID
    name: String | null
    condition: { __typename: 'LogicExpression'; id: ID; logicExpressionString: String | null }
  }
}

export type CreateButtonNodeWorkspaceButtonsMutationVariables = Exact<{
  input: CreateButtonNodeWorkspaceButtonsInput
}>

export type CreateButtonNodeWorkspaceButtonsMutation = {
  __typename: 'Mutation'
  createButtonNodeWorkspaceButtons: Array<{
    __typename: 'WorkspaceButton'
    id: ID
    name: String
    order: Int
    buttonConfiguration: JSONObject | null
    requiresConfirmation: Boolean
    confirmationMessage: String | null
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    manualTrigger: {
      __typename: 'ActionManualTrigger'
      id: ID
      name: String
      permissions: Array<{
        __typename: 'Permission'
        id: ID
        role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
      }>
    } | null
    form: {
      __typename: 'Form'
      id: ID
      name: String
      permissions: Array<{
        __typename: 'Permission'
        id: ID
        role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
      }>
    } | null
    formV2: {
      __typename: 'FormV2'
      id: ID
      name: String
      permissions: Array<{
        __typename: 'Permission'
        id: ID
        role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
      }>
    } | null
  }>
}

export type UpdateButtonNodeWorkspaceButtonMutationVariables = Exact<{
  input: UpdateWorkspaceButtonInput
}>

export type UpdateButtonNodeWorkspaceButtonMutation = {
  __typename: 'Mutation'
  updateWorkspaceButton: {
    __typename: 'WorkspaceButton'
    id: ID
    name: String
    order: Int
    buttonConfiguration: JSONObject | null
    requiresConfirmation: Boolean
    confirmationMessage: String | null
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    manualTrigger: {
      __typename: 'ActionManualTrigger'
      id: ID
      name: String
      permissions: Array<{
        __typename: 'Permission'
        id: ID
        role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
      }>
    } | null
    form: {
      __typename: 'Form'
      id: ID
      name: String
      permissions: Array<{
        __typename: 'Permission'
        id: ID
        role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
      }>
    } | null
    formV2: {
      __typename: 'FormV2'
      id: ID
      name: String
      permissions: Array<{
        __typename: 'Permission'
        id: ID
        role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
      }>
    } | null
  }
}

export type ReorderWorkspaceButtonMutationVariables = Exact<{
  input: ReorderWorkspaceButtonInput
}>

export type ReorderWorkspaceButtonMutation = {
  __typename: 'Mutation'
  reorderWorkspaceButton: {
    __typename: 'WorkspaceButton'
    id: ID
    name: String
    order: Int
    buttonConfiguration: JSONObject | null
    requiresConfirmation: Boolean
    confirmationMessage: String | null
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    manualTrigger: {
      __typename: 'ActionManualTrigger'
      id: ID
      name: String
      permissions: Array<{
        __typename: 'Permission'
        id: ID
        role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
      }>
    } | null
    form: {
      __typename: 'Form'
      id: ID
      name: String
      permissions: Array<{
        __typename: 'Permission'
        id: ID
        role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
      }>
    } | null
    formV2: {
      __typename: 'FormV2'
      id: ID
      name: String
      permissions: Array<{
        __typename: 'Permission'
        id: ID
        role: { __typename: 'Role'; id: ID; name: String; roleType: RoleType }
      }>
    } | null
  }
}

export type TriggerTableButtonNodeEvaluationMutationVariables = Exact<{
  tableId: Scalars['ID']
}>

export type TriggerTableButtonNodeEvaluationMutation = {
  __typename: 'Mutation'
  triggerTableButtonNodeEvaluation: {
    __typename: 'TableButtonNodeEvaluationResult'
    success: Boolean
    message: String
    jobId: ID | null
    jobUrl: String | null
  }
}

export type UpdateRowCurrentNodesMutationVariables = Exact<{
  input: UpdateRowCurrentNodesInput
}>

export type UpdateRowCurrentNodesMutation = {
  __typename: 'Mutation'
  updateRowCurrentNodes: {
    __typename: 'TableRow'
    id: ID
    currentButtonNodes: Array<{
      __typename: 'TableButtonNode'
      id: ID
      name: String
      workspaceButtons: Array<{
        __typename: 'WorkspaceButton'
        id: ID
        name: String
        order: Int
        buttonConfiguration: JSONObject | null
        requiresConfirmation: Boolean
        confirmationMessage: String | null
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        manualTrigger: {
          __typename: 'ActionManualTrigger'
          id: ID
          name: String
          action: {
            __typename: 'Action'
            id: ID
            status: ActionStatus
            description: String | null
            workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
          } | null
        } | null
        form: { __typename: 'Form'; id: ID; name: String } | null
        formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      }>
    }>
    processingWorkspaceButton: { __typename: 'WorkspaceButton'; id: ID; name: String } | null
  }
}

export type ReorderTableColumnGroupMemberMutationVariables = Exact<{
  input: ReorderTableColumnGroupMemberInput
}>

export type ReorderTableColumnGroupMemberMutation = {
  __typename: 'Mutation'
  reorderTableColumnGroupMember: { __typename: 'TableColumnGroupMember'; id: ID; order: Int }
}

export type DeleteTableColumnGroupMemberMutationVariables = Exact<{
  tableColumnGroupMemberId: Scalars['ID']
}>

export type DeleteTableColumnGroupMemberMutation = {
  __typename: 'Mutation'
  deleteTableColumnGroupMember: { __typename: 'TableColumnGroupMember'; id: ID }
}

export type DeleteTableColumnGroupMembersMutationVariables = Exact<{
  input: DeleteTableColumnGroupMembersInput
}>

export type DeleteTableColumnGroupMembersMutation = {
  __typename: 'Mutation'
  deleteTableColumnGroupMembers: Array<{ __typename: 'TableColumnGroupMember'; id: ID }>
}

export type MoveTableColumnGroupMemberMutationVariables = Exact<{
  input: MoveTableColumnGroupMemberInput
}>

export type MoveTableColumnGroupMemberMutation = {
  __typename: 'Mutation'
  moveTableColumnGroupMember: {
    __typename: 'TableColumnGroupMember'
    id: ID
    order: Int
    tableColumn: { __typename: 'TableColumn'; id: ID }
  }
}

export type ReorderTableColumnGroupMutationVariables = Exact<{
  input: ReorderTableColumnGroupInput
}>

export type ReorderTableColumnGroupMutation = {
  __typename: 'Mutation'
  reorderTableColumnGroup: { __typename: 'TableColumnGroup'; id: ID; order: Int }
}

export type ReorderChildTableMutationVariables = Exact<{
  input: ReorderChildTableInput
}>

export type ReorderChildTableMutation = {
  __typename: 'Mutation'
  reorderChildTable: { __typename: 'Table'; id: ID; orderOnRecordDetails: Int | null }
}

export type UpdateTableColumnsVisibilityMutationVariables = Exact<{
  input: UpdateTableColumnsVisibilityInput
}>

export type UpdateTableColumnsVisibilityMutation = {
  __typename: 'Mutation'
  updateTableColumnsVisibility: Array<{
    __typename: 'TableColumn'
    id: ID
    isVisibleOnRecordDetails: Boolean
  }>
}

export type GetTablesQueryVariables = Exact<{ [key: string]: never }>

export type GetTablesQuery = {
  __typename: 'Query'
  tables: Array<{
    __typename: 'Table'
    id: ID
    name: String
    isShareable: Boolean
    rootWorkspace: { __typename: 'Workspace'; id: ID }
    parentTable: { __typename: 'Table'; id: ID; name: String } | null
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      type: DataType
      order: Int
      innerType: DataType | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      lookupColumn: {
        __typename: 'TableColumn'
        id: ID
        type: DataType
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
      } | null
      resolvedSourceColumn: {
        __typename: 'ResolvedTableColumnInfo'
        column: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          innerType: DataType | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }
      }
    }>
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    lookupFormCategories: Array<{
      __typename: 'FormCategory'
      id: ID
      name: String
      page: {
        __typename: 'FormPage'
        id: ID
        form: { __typename: 'Form'; id: ID; isShareable: Boolean }
      }
    }>
  }>
}

export type GetTablesSimpleQueryVariables = Exact<{
  input?: InputMaybe<TablesInput>
}>

export type GetTablesSimpleQuery = {
  __typename: 'Query'
  tables: Array<{
    __typename: 'Table'
    id: ID
    name: String
    rootWorkspace: { __typename: 'Workspace'; id: ID }
    parentTable: { __typename: 'Table'; id: ID; name: String } | null
    icon: { __typename: 'Icon'; id: ID; name: String } | null
  }>
}

export type CreateTableColumnGroupMembersMutationVariables = Exact<{
  input: CreateTableColumnGroupMembersInput
}>

export type CreateTableColumnGroupMembersMutation = {
  __typename: 'Mutation'
  createTableColumnGroupMembers: Array<{
    __typename: 'TableColumnGroupMember'
    id: ID
    order: Int
    tableColumn: { __typename: 'TableColumn'; id: ID }
  }>
}

export type MoveTableColumnGroupMembersMutationVariables = Exact<{
  input: MoveTableColumnGroupMembersInput
}>

export type MoveTableColumnGroupMembersMutation = {
  __typename: 'Mutation'
  moveTableColumnGroupMembers: Array<{
    __typename: 'TableColumnGroupMember'
    id: ID
    order: Int
    tableColumn: { __typename: 'TableColumn'; id: ID }
  }>
}

export type GetPreviewCellsQueryVariables = Exact<{
  input: PreviewCellsInput
}>

export type GetPreviewCellsQuery = {
  __typename: 'Query'
  previewCells: Array<{
    __typename: 'TableCell'
    id: ID
    data: JSONObject | null
    userVisibleValue: String | null
  }>
}

export type GetSimpleFormsQueryVariables = Exact<{ [key: string]: never }>

export type GetSimpleFormsQuery = {
  __typename: 'Query'
  forms: Array<{ __typename: 'Form'; id: ID; name: String }>
}

export type GetSimpleFormsV2QueryVariables = Exact<{ [key: string]: never }>

export type GetSimpleFormsV2Query = {
  __typename: 'Query'
  allFormsV2: Array<{ __typename: 'FormV2'; id: ID; name: String }>
}

export type CreateTableExportMutationVariables = Exact<{
  input: CreateTableExportInput
}>

export type CreateTableExportMutation = {
  __typename: 'Mutation'
  createTableExport: {
    __typename: 'TableExport'
    id: ID
    status: TableExportStatus
    fileName: String
  }
}

export type GetTableExportsQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetTableExportsQuery = {
  __typename: 'Query'
  tableExports: Array<{
    __typename: 'TableExport'
    id: ID
    createdAt: DateTime
    status: TableExportStatus
    rowCount: Int | null
    fileName: String
    errorMessage: String | null
    table: { __typename: 'Table'; name: String }
    createdBy: { __typename: 'Membership'; id: ID; firstName: String; lastName: String }
    document: { __typename: 'Document'; id: ID; storageUrl: String } | null
  }>
}

export type PushTableExportProgressSubscriptionVariables = Exact<{
  tableId: Scalars['ID']
}>

export type PushTableExportProgressSubscription = {
  __typename: 'Subscription'
  pushTableExportProgress: {
    __typename: 'FileProgress'
    objectId: ID
    completedCount: Int
    totalCount: Int | null
  }
}

export type TableUniqueConstraintDetailsFragment = {
  __typename: 'TableUniqueConstraint'
  id: ID
  name: String
  status: TableUniqueConstraintStatus
  scope: TableUniqueConstraintScope
  conflictedKeyGroupCount: Int | null
  conflictsTruncated: Boolean | null
  conflictsCheckedAt: DateTime | null
  lastErrorCode: TableUniqueConstraintErrorCode | null
  lastErrorMessage: String | null
  failedAttempts: Int
  columns: Array<{
    __typename: 'TableUniqueConstraintColumn'
    id: ID
    position: Int
    column: { __typename: 'TableColumn'; id: ID; name: String; type: DataType }
  }>
  conflicts: Array<{
    __typename: 'TableUniqueConstraintConflict'
    keyValues: JSONValue
    parentRowId: ID | null
    rowCount: Int
    exampleRowIds: Array<ID>
  }>
}

export type GetTableUniqueConstraintsQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetTableUniqueConstraintsQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    name: String
    parentTable: { __typename: 'Table'; id: ID; name: String } | null
    uniqueConstraints: Array<{
      __typename: 'TableUniqueConstraint'
      id: ID
      name: String
      status: TableUniqueConstraintStatus
      scope: TableUniqueConstraintScope
      conflictedKeyGroupCount: Int | null
      conflictsTruncated: Boolean | null
      conflictsCheckedAt: DateTime | null
      lastErrorCode: TableUniqueConstraintErrorCode | null
      lastErrorMessage: String | null
      failedAttempts: Int
      columns: Array<{
        __typename: 'TableUniqueConstraintColumn'
        id: ID
        position: Int
        column: { __typename: 'TableColumn'; id: ID; name: String; type: DataType }
      }>
      conflicts: Array<{
        __typename: 'TableUniqueConstraintConflict'
        keyValues: JSONValue
        parentRowId: ID | null
        rowCount: Int
        exampleRowIds: Array<ID>
      }>
    }>
    childTables: Array<{
      __typename: 'Table'
      id: ID
      name: String
      uniqueConstraints: Array<{
        __typename: 'TableUniqueConstraint'
        id: ID
        name: String
        status: TableUniqueConstraintStatus
        scope: TableUniqueConstraintScope
        conflictedKeyGroupCount: Int | null
        conflictsTruncated: Boolean | null
        conflictsCheckedAt: DateTime | null
        lastErrorCode: TableUniqueConstraintErrorCode | null
        lastErrorMessage: String | null
        failedAttempts: Int
        columns: Array<{
          __typename: 'TableUniqueConstraintColumn'
          id: ID
          position: Int
          column: { __typename: 'TableColumn'; id: ID; name: String; type: DataType }
        }>
        conflicts: Array<{
          __typename: 'TableUniqueConstraintConflict'
          keyValues: JSONValue
          parentRowId: ID | null
          rowCount: Int
          exampleRowIds: Array<ID>
        }>
      }>
    }>
  }
}

export type CreateTableUniqueConstraintMutationVariables = Exact<{
  input: CreateTableUniqueConstraintInput
}>

export type CreateTableUniqueConstraintMutation = {
  __typename: 'Mutation'
  createTableUniqueConstraint: {
    __typename: 'TableUniqueConstraint'
    id: ID
    name: String
    status: TableUniqueConstraintStatus
    scope: TableUniqueConstraintScope
  }
}

export type DeleteTableUniqueConstraintMutationVariables = Exact<{
  tableUniqueConstraintId: Scalars['ID']
}>

export type DeleteTableUniqueConstraintMutation = {
  __typename: 'Mutation'
  deleteTableUniqueConstraint: {
    __typename: 'TableUniqueConstraint'
    id: ID
    status: TableUniqueConstraintStatus
  }
}

export type RetryTableUniqueConstraintActivationMutationVariables = Exact<{
  tableUniqueConstraintId: Scalars['ID']
}>

export type RetryTableUniqueConstraintActivationMutation = {
  __typename: 'Mutation'
  retryTableUniqueConstraintActivation: {
    __typename: 'TableUniqueConstraint'
    id: ID
    status: TableUniqueConstraintStatus
    failedAttempts: Int
  }
}

export type GetUniqueConstraintConflictRowsQueryVariables = Exact<{
  rowIds: Array<Scalars['ID']> | Scalars['ID']
}>

export type GetUniqueConstraintConflictRowsQuery = {
  __typename: 'Query'
  tableRows: Array<{ __typename: 'TableRow'; id: ID; name: String }>
}

export type GetSimpleActionManualTriggersQueryVariables = Exact<{ [key: string]: never }>

export type GetSimpleActionManualTriggersQuery = {
  __typename: 'Query'
  actionManualTriggers: Array<{
    __typename: 'ActionManualTrigger'
    id: ID
    name: String
    action: {
      __typename: 'Action'
      id: ID
      name: String
      workflow: { __typename: 'Workflow'; id: ID }
    } | null
  }>
}

export type GetTableColumnsValidationMetadataQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetTableColumnsValidationMetadataQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      hasNonNullCells: Boolean
      hasNullCells: Boolean
      uniqueConstraintMemberships: Array<{
        __typename: 'TableUniqueConstraintColumn'
        constraint: {
          __typename: 'TableUniqueConstraint'
          id: ID
          name: String
          status: TableUniqueConstraintStatus
        }
      }>
      chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
    }>
    childTables: Array<{
      __typename: 'Table'
      id: ID
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        hasNonNullCells: Boolean
        hasNullCells: Boolean
        uniqueConstraintMemberships: Array<{
          __typename: 'TableUniqueConstraintColumn'
          constraint: {
            __typename: 'TableUniqueConstraint'
            id: ID
            name: String
            status: TableUniqueConstraintStatus
          }
        }>
        chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
      }>
    }>
  }
}

export type GetTableRelatedActionStepsQueryVariables = Exact<{
  input: RelatedEntitiesInput
}>

export type GetTableRelatedActionStepsQuery = {
  __typename: 'Query'
  relatedActionSteps: {
    __typename: 'RelatedActionStepsResult'
    readSteps: Array<{
      __typename: 'ActionStep'
      id: ID
      name: String
      type: ActionStepType
      status: ActionStepStatus
      rootAction: {
        __typename: 'Action'
        id: ID
        name: String
        status: ActionStatus
        workflow: { __typename: 'Workflow'; id: ID; name: String }
      }
    }>
    writeSteps: Array<{
      __typename: 'ActionStep'
      id: ID
      name: String
      type: ActionStepType
      status: ActionStepStatus
      rootAction: {
        __typename: 'Action'
        id: ID
        name: String
        status: ActionStatus
        workflow: { __typename: 'Workflow'; id: ID; name: String }
      }
    }>
  }
}

export type GetWorkflowsV2DependentsQueryVariables = Exact<{
  input: WorkflowsV2DependentsInput
}>

export type GetWorkflowsV2DependentsQuery = {
  __typename: 'Query'
  workflowsV2Dependents: Array<{
    __typename: 'WorkflowV2'
    id: ID
    slug: String
    verificationStatus: WorkflowV2VerificationStatus | null
  }>
}

export type GetRelatedActionStepsForEntitiesQueryVariables = Exact<{
  input: RelatedActionStepsForEntitiesInput
}>

export type GetRelatedActionStepsForEntitiesQuery = {
  __typename: 'Query'
  relatedActionStepsForEntities: {
    __typename: 'RelatedActionStepsForEntitiesResult'
    items: Array<{
      __typename: 'RelatedActionStepsForEntityItem'
      sourceId: ID
      relatedActionSteps: {
        __typename: 'RelatedActionStepsResult'
        readSteps: Array<{
          __typename: 'ActionStep'
          id: ID
          name: String
          type: ActionStepType
          status: ActionStepStatus
          rootAction: {
            __typename: 'Action'
            id: ID
            name: String
            status: ActionStatus
            workflow: { __typename: 'Workflow'; id: ID; name: String }
          }
        }>
        writeSteps: Array<{
          __typename: 'ActionStep'
          id: ID
          name: String
          type: ActionStepType
          status: ActionStepStatus
          rootAction: {
            __typename: 'Action'
            id: ID
            name: String
            status: ActionStatus
            workflow: { __typename: 'Workflow'; id: ID; name: String }
          }
        }>
      }
    }>
  }
}

export type DetailedTableColumnFragment = {
  __typename: 'TableColumn'
  id: ID
  name: String
  description: String | null
  order: Int
  type: DataType
  innerType: DataType | null
  isNullable: Boolean
  isReadOnly: Boolean
  isDecimal: Boolean
  indexType: IndexType
  indexPrefix: String
  indexSuffix: String
  indexAutogenerate: Boolean
  enumOptions: Array<String> | null
  displayImagesInline: Boolean
  isVisibleOnRecordDetails: Boolean
  resolvedSourceType: DataType
  resolvedEnumOptions: Array<String> | null
  formatPreset: FormatPreset | null
  formatOptions: JSONObject | null
  lookupColumn: {
    __typename: 'TableColumn'
    name: String
    order: Int
    innerType: DataType | null
    indexType: IndexType
    indexPrefix: String
    indexSuffix: String
    enumOptions: Array<String> | null
    id: ID
    type: DataType
    formatPreset: FormatPreset | null
    formatOptions: JSONObject | null
    table: { __typename: 'Table'; id: ID; name: String }
    resolvedSourceColumn: {
      __typename: 'ResolvedTableColumnInfo'
      column: {
        __typename: 'TableColumn'
        id: ID
        type: DataType
        innerType: DataType | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }
    }
  } | null
  lookupColumnChildren: Array<{
    __typename: 'TableColumn'
    id: ID
    name: String
    table: { __typename: 'Table'; id: ID }
    lookupColumnGroup: {
      __typename: 'LookupTableColumnGroup'
      id: ID
      showBacklink: Boolean | null
      backlinkName: String | null
    } | null
  }>
  lookupColumnGroup: {
    __typename: 'LookupTableColumnGroup'
    id: ID
    showBacklink: Boolean | null
    backlinkName: String | null
  } | null
  lookupFilterExpression: {
    __typename: 'LogicExpression'
    id: ID
    logicExpressionString: String | null
  } | null
  formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
  chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
  resolvedSourceColumn: {
    __typename: 'ResolvedTableColumnInfo'
    column: {
      __typename: 'TableColumn'
      id: ID
      type: DataType
      innerType: DataType | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      enumSet: {
        __typename: 'EnumSet'
        id: ID
        options: Array<{
          __typename: 'EnumOption'
          id: ID
          label: String
          colorPreset: EnumColorPreset | null
          colorCustom: String | null
          iconName: String | null
          order: Int
          icon: { __typename: 'Icon'; id: ID } | null
        }>
      } | null
    }
  }
  enumSet: {
    __typename: 'EnumSet'
    id: ID
    options: Array<{
      __typename: 'EnumOption'
      id: ID
      label: String
      colorPreset: EnumColorPreset | null
      colorCustom: String | null
      iconName: String | null
      order: Int
      icon: { __typename: 'Icon'; id: ID } | null
    }>
  } | null
}

export type GetDetailedTableQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetDetailedTableQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    name: String
    hasRows: Boolean
    parentTable: {
      __typename: 'Table'
      id: ID
      name: String
      icon: { __typename: 'Icon'; id: ID; name: String } | null
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        lookupColumn: { __typename: 'TableColumn'; id: ID; name: String; type: DataType } | null
      }>
    } | null
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      description: String | null
      order: Int
      type: DataType
      innerType: DataType | null
      isNullable: Boolean
      isReadOnly: Boolean
      isDecimal: Boolean
      indexType: IndexType
      indexPrefix: String
      indexSuffix: String
      indexAutogenerate: Boolean
      enumOptions: Array<String> | null
      displayImagesInline: Boolean
      isVisibleOnRecordDetails: Boolean
      resolvedSourceType: DataType
      resolvedEnumOptions: Array<String> | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      lookupColumnGroup: {
        __typename: 'LookupTableColumnGroup'
        id: ID
        showBacklink: Boolean | null
        backlinkName: String | null
        columns: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          lookupColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
        }>
        lookupTable: {
          __typename: 'Table'
          id: ID
          name: String
          icon: { __typename: 'Icon'; id: ID; name: String } | null
        }
      } | null
      lookupColumn: {
        __typename: 'TableColumn'
        name: String
        order: Int
        innerType: DataType | null
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        enumOptions: Array<String> | null
        id: ID
        type: DataType
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
      } | null
      lookupColumnChildren: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID }
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          showBacklink: Boolean | null
          backlinkName: String | null
        } | null
      }>
      lookupFilterExpression: {
        __typename: 'LogicExpression'
        id: ID
        logicExpressionString: String | null
      } | null
      formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
      chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
      resolvedSourceColumn: {
        __typename: 'ResolvedTableColumnInfo'
        column: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          innerType: DataType | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }
      }
      enumSet: {
        __typename: 'EnumSet'
        id: ID
        options: Array<{
          __typename: 'EnumOption'
          id: ID
          label: String
          colorPreset: EnumColorPreset | null
          colorCustom: String | null
          iconName: String | null
          order: Int
          icon: { __typename: 'Icon'; id: ID } | null
        }>
      } | null
    }>
    tableTabs: Array<{
      __typename: 'TableTab'
      id: ID
      name: String
      order: Int
      booleanOperator: BooleanOperator | null
      filters: Array<{
        __typename: 'TableColumnFilter'
        id: ID
        operator: FilterOperator
        operand: JSONObject | null
        systemGeneratedColumnType: SystemGeneratedTableColumnType | null
        tableColumn: {
          __typename: 'TableColumn'
          id: ID
          table: { __typename: 'Table'; id: ID }
        } | null
      }>
      sorts: Array<{
        __typename: 'TableTabSort'
        id: ID
        direction: SortDirection
        systemGeneratedColumnType: SystemGeneratedTableColumnType | null
        tableColumn: { __typename: 'TableColumn'; id: ID } | null
      }>
      columns: Array<{
        __typename: 'TableTabColumn'
        id: ID
        order: Int
        isFrozen: Boolean
        systemGeneratedColumnType: SystemGeneratedTableColumnType | null
        tableColumn: { __typename: 'TableColumn'; id: ID; order: Int } | null
      }>
    }>
    charts: Array<{ __typename: 'Chart'; id: ID; name: String; chartType: ChartType }>
    childTables: Array<{
      __typename: 'Table'
      id: ID
      name: String
      orderOnRecordDetails: Int | null
      icon: { __typename: 'Icon'; id: ID; name: String } | null
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        description: String | null
        order: Int
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        isReadOnly: Boolean
        isDecimal: Boolean
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        indexAutogenerate: Boolean
        enumOptions: Array<String> | null
        displayImagesInline: Boolean
        isVisibleOnRecordDetails: Boolean
        resolvedSourceType: DataType
        resolvedEnumOptions: Array<String> | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          showBacklink: Boolean | null
          backlinkName: String | null
          columns: Array<{
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            lookupColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
          }>
          lookupTable: {
            __typename: 'Table'
            id: ID
            name: String
            icon: { __typename: 'Icon'; id: ID; name: String } | null
          }
        } | null
        lookupColumn: {
          __typename: 'TableColumn'
          name: String
          order: Int
          innerType: DataType | null
          indexType: IndexType
          indexPrefix: String
          indexSuffix: String
          enumOptions: Array<String> | null
          id: ID
          type: DataType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
          resolvedSourceColumn: {
            __typename: 'ResolvedTableColumnInfo'
            column: {
              __typename: 'TableColumn'
              id: ID
              type: DataType
              innerType: DataType | null
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              enumSet: {
                __typename: 'EnumSet'
                id: ID
                options: Array<{
                  __typename: 'EnumOption'
                  id: ID
                  label: String
                  colorPreset: EnumColorPreset | null
                  colorCustom: String | null
                  iconName: String | null
                  order: Int
                  icon: { __typename: 'Icon'; id: ID } | null
                }>
              } | null
            }
          }
        } | null
        lookupColumnChildren: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          table: { __typename: 'Table'; id: ID }
          lookupColumnGroup: {
            __typename: 'LookupTableColumnGroup'
            id: ID
            showBacklink: Boolean | null
            backlinkName: String | null
          } | null
        }>
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
        formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
        chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }>
    }>
    lookupBacklinkTables: Array<{ __typename: 'Table'; id: ID }>
    organization: { __typename: 'Organization'; id: ID }
  }
}

export type GetTableChildAndBacklinkTablesQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetTableChildAndBacklinkTablesQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    childTables: Array<{
      __typename: 'Table'
      id: ID
      name: String
      orderOnRecordDetails: Int | null
      hasRows: Boolean
      parentTable: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
      } | null
      icon: { __typename: 'Icon'; id: ID; name: String } | null
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        description: String | null
        order: Int
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        isReadOnly: Boolean
        isDecimal: Boolean
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        indexAutogenerate: Boolean
        enumOptions: Array<String> | null
        displayImagesInline: Boolean
        isVisibleOnRecordDetails: Boolean
        resolvedSourceType: DataType
        resolvedEnumOptions: Array<String> | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          showBacklink: Boolean | null
          backlinkName: String | null
          columns: Array<{
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            lookupColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
          }>
          lookupTable: {
            __typename: 'Table'
            id: ID
            name: String
            icon: { __typename: 'Icon'; id: ID; name: String } | null
          }
        } | null
        lookupColumn: {
          __typename: 'TableColumn'
          name: String
          order: Int
          innerType: DataType | null
          indexType: IndexType
          indexPrefix: String
          indexSuffix: String
          enumOptions: Array<String> | null
          id: ID
          type: DataType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
          resolvedSourceColumn: {
            __typename: 'ResolvedTableColumnInfo'
            column: {
              __typename: 'TableColumn'
              id: ID
              type: DataType
              innerType: DataType | null
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              enumSet: {
                __typename: 'EnumSet'
                id: ID
                options: Array<{
                  __typename: 'EnumOption'
                  id: ID
                  label: String
                  colorPreset: EnumColorPreset | null
                  colorCustom: String | null
                  iconName: String | null
                  order: Int
                  icon: { __typename: 'Icon'; id: ID } | null
                }>
              } | null
            }
          }
        } | null
        lookupColumnChildren: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          table: { __typename: 'Table'; id: ID }
          lookupColumnGroup: {
            __typename: 'LookupTableColumnGroup'
            id: ID
            showBacklink: Boolean | null
            backlinkName: String | null
          } | null
        }>
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
        formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
        chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }>
      tableTabs: Array<{
        __typename: 'TableTab'
        id: ID
        name: String
        order: Int
        booleanOperator: BooleanOperator | null
        filters: Array<{
          __typename: 'TableColumnFilter'
          id: ID
          operator: FilterOperator
          operand: JSONObject | null
          systemGeneratedColumnType: SystemGeneratedTableColumnType | null
          tableColumn: { __typename: 'TableColumn'; id: ID } | null
        }>
        sorts: Array<{
          __typename: 'TableTabSort'
          id: ID
          direction: SortDirection
          systemGeneratedColumnType: SystemGeneratedTableColumnType | null
          tableColumn: { __typename: 'TableColumn'; id: ID } | null
        }>
        columns: Array<{
          __typename: 'TableTabColumn'
          id: ID
          order: Int
          isFrozen: Boolean
          systemGeneratedColumnType: SystemGeneratedTableColumnType | null
          tableColumn: { __typename: 'TableColumn'; id: ID; order: Int } | null
        }>
      }>
    }>
    lookupBacklinkTables: Array<{
      __typename: 'Table'
      id: ID
      name: String
      orderOnRecordDetails: Int | null
      hasRows: Boolean
      parentTable: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
      } | null
      icon: { __typename: 'Icon'; id: ID; name: String } | null
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        description: String | null
        order: Int
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        isReadOnly: Boolean
        isDecimal: Boolean
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        indexAutogenerate: Boolean
        enumOptions: Array<String> | null
        displayImagesInline: Boolean
        isVisibleOnRecordDetails: Boolean
        resolvedSourceType: DataType
        resolvedEnumOptions: Array<String> | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          showBacklink: Boolean | null
          backlinkName: String | null
          columns: Array<{
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            lookupColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
          }>
          lookupTable: {
            __typename: 'Table'
            id: ID
            name: String
            icon: { __typename: 'Icon'; id: ID; name: String } | null
          }
        } | null
        lookupColumn: {
          __typename: 'TableColumn'
          name: String
          order: Int
          innerType: DataType | null
          indexType: IndexType
          indexPrefix: String
          indexSuffix: String
          enumOptions: Array<String> | null
          id: ID
          type: DataType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
          resolvedSourceColumn: {
            __typename: 'ResolvedTableColumnInfo'
            column: {
              __typename: 'TableColumn'
              id: ID
              type: DataType
              innerType: DataType | null
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              enumSet: {
                __typename: 'EnumSet'
                id: ID
                options: Array<{
                  __typename: 'EnumOption'
                  id: ID
                  label: String
                  colorPreset: EnumColorPreset | null
                  colorCustom: String | null
                  iconName: String | null
                  order: Int
                  icon: { __typename: 'Icon'; id: ID } | null
                }>
              } | null
            }
          }
        } | null
        lookupColumnChildren: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          table: { __typename: 'Table'; id: ID }
          lookupColumnGroup: {
            __typename: 'LookupTableColumnGroup'
            id: ID
            showBacklink: Boolean | null
            backlinkName: String | null
          } | null
        }>
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
        formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
        chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }>
      tableTabs: Array<{
        __typename: 'TableTab'
        id: ID
        name: String
        order: Int
        booleanOperator: BooleanOperator | null
        filters: Array<{
          __typename: 'TableColumnFilter'
          id: ID
          operator: FilterOperator
          operand: JSONObject | null
          systemGeneratedColumnType: SystemGeneratedTableColumnType | null
          tableColumn: { __typename: 'TableColumn'; id: ID } | null
        }>
        sorts: Array<{
          __typename: 'TableTabSort'
          id: ID
          direction: SortDirection
          systemGeneratedColumnType: SystemGeneratedTableColumnType | null
          tableColumn: { __typename: 'TableColumn'; id: ID } | null
        }>
        columns: Array<{
          __typename: 'TableTabColumn'
          id: ID
          order: Int
          isFrozen: Boolean
          systemGeneratedColumnType: SystemGeneratedTableColumnType | null
          tableColumn: { __typename: 'TableColumn'; id: ID; order: Int } | null
        }>
      }>
    }>
  }
}

export type GetTableRowsQueryVariables = Exact<{
  input: PaginatedTableRowsInput
}>

export type GetTableRowsQuery = {
  __typename: 'Query'
  paginatedTableRows: {
    __typename: 'PaginatedTableRows'
    offset: Int
    hasNext: Boolean
    totalCount: Int
    rows: Array<{
      __typename: 'TableRow'
      id: ID
      name: String
      createdAt: DateTime
      updatedAt: DateTime
      hasChildRows: Boolean
      createdBy: {
        __typename: 'Membership'
        id: ID
        firstName: String
        lastName: String
        email: String | null
      } | null
      updatedBy: {
        __typename: 'Membership'
        id: ID
        firstName: String
        lastName: String
        email: String | null
      } | null
      cells: Array<{
        __typename: 'TableCell'
        id: ID
        data: JSONObject | null
        userVisibleValue: String | null
        formulaError: Int | null
        updatedAt: DateTime
        column: {
          __typename: 'TableColumn'
          id: ID
          formatOptions: JSONObject | null
          formatPreset: FormatPreset | null
        }
        documents: Array<{ __typename: 'Document'; id: ID; name: String }>
        users: Array<{
          __typename: 'Membership'
          id: ID
          firstName: String
          lastName: String
          email: String | null
        }>
        lookupCells: Array<{
          __typename: 'TableCell'
          id: ID
          formulaError: Int | null
          row: { __typename: 'TableRow'; id: ID }
          documents: Array<{ __typename: 'Document'; id: ID }>
        }>
      }>
      rootWorkspace: { __typename: 'Workspace'; id: ID }
      currentButtonNodes: Array<{
        __typename: 'TableButtonNode'
        id: ID
        name: String
        workspaceButtons: Array<{
          __typename: 'WorkspaceButton'
          id: ID
          name: String
          order: Int
          buttonConfiguration: JSONObject | null
          requiresConfirmation: Boolean
          confirmationMessage: String | null
          icon: { __typename: 'Icon'; id: ID; name: String } | null
          manualTrigger: {
            __typename: 'ActionManualTrigger'
            id: ID
            name: String
            action: {
              __typename: 'Action'
              id: ID
              status: ActionStatus
              description: String | null
              workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
            } | null
          } | null
          form: { __typename: 'Form'; id: ID; name: String } | null
          formV2: { __typename: 'FormV2'; id: ID; name: String } | null
        }>
      }>
      processingWorkspaceButton: { __typename: 'WorkspaceButton'; id: ID; name: String } | null
    }>
  }
}

export type GetBacklinkTableRowsQueryVariables = Exact<{
  input: PaginatedBacklinkRowsInput
}>

export type GetBacklinkTableRowsQuery = {
  __typename: 'Query'
  paginatedBacklinkRows: {
    __typename: 'PaginatedTableRows'
    offset: Int
    hasNext: Boolean
    totalCount: Int
    rows: Array<{
      __typename: 'TableRow'
      id: ID
      name: String
      createdAt: DateTime
      updatedAt: DateTime
      hasChildRows: Boolean
      createdBy: {
        __typename: 'Membership'
        id: ID
        firstName: String
        lastName: String
        email: String | null
      } | null
      updatedBy: {
        __typename: 'Membership'
        id: ID
        firstName: String
        lastName: String
        email: String | null
      } | null
      cells: Array<{
        __typename: 'TableCell'
        id: ID
        data: JSONObject | null
        userVisibleValue: String | null
        formulaError: Int | null
        updatedAt: DateTime
        column: {
          __typename: 'TableColumn'
          id: ID
          formatOptions: JSONObject | null
          formatPreset: FormatPreset | null
          type: DataType
          lookupColumn: { __typename: 'TableColumn'; id: ID; type: DataType } | null
        }
        documents: Array<{ __typename: 'Document'; id: ID; name: String }>
        users: Array<{
          __typename: 'Membership'
          id: ID
          firstName: String
          lastName: String
          email: String | null
        }>
        lookupCells: Array<{
          __typename: 'TableCell'
          id: ID
          formulaError: Int | null
          row: { __typename: 'TableRow'; id: ID }
          documents: Array<{ __typename: 'Document'; id: ID }>
        }>
      }>
      rootWorkspace: { __typename: 'Workspace'; id: ID }
      table: {
        __typename: 'Table'
        columns: Array<{
          __typename: 'TableColumn'
          lookupColumnChildren: Array<{
            __typename: 'TableColumn'
            id: ID
            table: { __typename: 'Table'; id: ID; name: String }
            lookupColumnGroup: {
              __typename: 'LookupTableColumnGroup'
              id: ID
              showBacklink: Boolean | null
            } | null
          }>
        }>
      }
    }>
  }
}

export type DeleteTableRowWithResultMutationVariables = Exact<{
  tableRowId: Scalars['ID']
}>

export type DeleteTableRowWithResultMutation = {
  __typename: 'Mutation'
  deleteTableRowWithResult: {
    __typename: 'DeleteTableRowResult'
    row: { __typename: 'TableRow'; id: ID } | null
    errors: Array<{
      __typename: 'BulkActionError'
      rowId: ID
      rowName: String | null
      message: String
      blockingRows: Array<{ __typename: 'TableRow'; id: ID; name: String }> | null
      blockingReferences: Array<{
        __typename: 'DeleteBlockingReference'
        columnId: ID
        columnName: String
        tableId: ID
        tableName: String
        row: { __typename: 'TableRow'; id: ID; name: String }
      }> | null
    }> | null
    blockingRows: Array<{ __typename: 'TableRow'; id: ID; name: String }>
    blockingReferences: Array<{
      __typename: 'DeleteBlockingReference'
      columnId: ID
      columnName: String
      tableId: ID
      tableName: String
      row: { __typename: 'TableRow'; id: ID; name: String }
    }>
  }
}

export type CreateTableMutationVariables = Exact<{
  input: CreateTableInput
}>

export type CreateTableMutation = {
  __typename: 'Mutation'
  createTable: {
    __typename: 'Table'
    id: ID
    name: String
    description: String | null
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    views: Array<{
      __typename: 'View'
      id: ID
      unitWidth: Int
      unitHeight: Int
      order: Int
      viewableObjectType: ViewableObjectType
    }>
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      description: String | null
      type: DataType
    }>
  }
}

export type CreateChildTableMutationVariables = Exact<{
  input: CreateChildTableInput
}>

export type CreateChildTableMutation = {
  __typename: 'Mutation'
  createChildTable: {
    __typename: 'Table'
    id: ID
    name: String
    description: String | null
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      description: String | null
      type: DataType
    }>
  }
}

export type UpdateTableMutationVariables = Exact<{
  input: UpdateTableInput
}>

export type UpdateTableMutation = {
  __typename: 'Mutation'
  updateTable: {
    __typename: 'Table'
    id: ID
    name: String
    description: String | null
    showRowWorkspace: Boolean
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      description: String | null
      type: DataType
    }>
  }
}

export type CreateTableTabMutationVariables = Exact<{
  input: CreateTableTabInput
}>

export type CreateTableTabMutation = {
  __typename: 'Mutation'
  createTableTab: {
    __typename: 'TableTab'
    id: ID
    name: String
    order: Int
    booleanOperator: BooleanOperator | null
    filters: Array<{
      __typename: 'TableColumnFilter'
      id: ID
      operator: FilterOperator
      operand: JSONObject | null
      systemGeneratedColumnType: SystemGeneratedTableColumnType | null
      tableColumn: {
        __typename: 'TableColumn'
        id: ID
        table: { __typename: 'Table'; id: ID }
      } | null
    }>
    sorts: Array<{
      __typename: 'TableTabSort'
      id: ID
      direction: SortDirection
      systemGeneratedColumnType: SystemGeneratedTableColumnType | null
      tableColumn: { __typename: 'TableColumn'; id: ID } | null
    }>
    columns: Array<{
      __typename: 'TableTabColumn'
      id: ID
      order: Int
      isFrozen: Boolean
      systemGeneratedColumnType: SystemGeneratedTableColumnType | null
      tableColumn: {
        __typename: 'TableColumn'
        id: ID
        name: String
        description: String | null
        order: Int
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        isReadOnly: Boolean
        isDecimal: Boolean
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        indexAutogenerate: Boolean
        enumOptions: Array<String> | null
        displayImagesInline: Boolean
        isVisibleOnRecordDetails: Boolean
        resolvedSourceType: DataType
        resolvedEnumOptions: Array<String> | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        lookupColumn: {
          __typename: 'TableColumn'
          name: String
          order: Int
          innerType: DataType | null
          indexType: IndexType
          indexPrefix: String
          indexSuffix: String
          enumOptions: Array<String> | null
          id: ID
          type: DataType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          table: { __typename: 'Table'; id: ID; name: String }
          resolvedSourceColumn: {
            __typename: 'ResolvedTableColumnInfo'
            column: {
              __typename: 'TableColumn'
              id: ID
              type: DataType
              innerType: DataType | null
              formatPreset: FormatPreset | null
              formatOptions: JSONObject | null
              enumSet: {
                __typename: 'EnumSet'
                id: ID
                options: Array<{
                  __typename: 'EnumOption'
                  id: ID
                  label: String
                  colorPreset: EnumColorPreset | null
                  colorCustom: String | null
                  iconName: String | null
                  order: Int
                  icon: { __typename: 'Icon'; id: ID } | null
                }>
              } | null
            }
          }
        } | null
        lookupColumnChildren: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          table: { __typename: 'Table'; id: ID }
          lookupColumnGroup: {
            __typename: 'LookupTableColumnGroup'
            id: ID
            showBacklink: Boolean | null
            backlinkName: String | null
          } | null
        }>
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          showBacklink: Boolean | null
          backlinkName: String | null
        } | null
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
        formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
        chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      } | null
    }>
  }
}

export type UpdateTableTabMutationVariables = Exact<{
  input: UpdateTableTabInput
}>

export type UpdateTableTabMutation = {
  __typename: 'Mutation'
  updateTableTab: {
    __typename: 'TableTab'
    id: ID
    name: String
    order: Int
    booleanOperator: BooleanOperator | null
  }
}

export type DeleteTableTabMutationVariables = Exact<{
  tableTabId: Scalars['ID']
}>

export type DeleteTableTabMutation = {
  __typename: 'Mutation'
  deleteTableTab: { __typename: 'TableTab'; id: ID }
}

export type ReorderTableTabMutationVariables = Exact<{
  input: ReorderTableTabInput
}>

export type ReorderTableTabMutation = {
  __typename: 'Mutation'
  reorderTableTab: Array<{ __typename: 'TableTab'; id: ID; name: String; order: Int }>
}

export type UpdateTableTabColumnMutationVariables = Exact<{
  input: UpdateTableTabColumnInput
}>

export type UpdateTableTabColumnMutation = {
  __typename: 'Mutation'
  updateTableTabColumn: { __typename: 'TableTabColumn'; id: ID; order: Int; isFrozen: Boolean }
}

export type UpdateTableTabColumnsMutationVariables = Exact<{
  input: UpdateTableTabColumnsInput
}>

export type UpdateTableTabColumnsMutation = {
  __typename: 'Mutation'
  updateTableTabColumns: Array<{
    __typename: 'TableTabColumn'
    id: ID
    order: Int
    isFrozen: Boolean
    systemGeneratedColumnType: SystemGeneratedTableColumnType | null
    tableColumn: {
      __typename: 'TableColumn'
      id: ID
      name: String
      description: String | null
      order: Int
      type: DataType
      innerType: DataType | null
      isNullable: Boolean
      isReadOnly: Boolean
      isDecimal: Boolean
      indexType: IndexType
      indexPrefix: String
      indexSuffix: String
      indexAutogenerate: Boolean
      enumOptions: Array<String> | null
      displayImagesInline: Boolean
      isVisibleOnRecordDetails: Boolean
      resolvedSourceType: DataType
      resolvedEnumOptions: Array<String> | null
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      lookupColumn: {
        __typename: 'TableColumn'
        name: String
        order: Int
        innerType: DataType | null
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        enumOptions: Array<String> | null
        id: ID
        type: DataType
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        table: { __typename: 'Table'; id: ID; name: String }
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
      } | null
      lookupColumnChildren: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        table: { __typename: 'Table'; id: ID }
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          showBacklink: Boolean | null
          backlinkName: String | null
        } | null
      }>
      lookupColumnGroup: {
        __typename: 'LookupTableColumnGroup'
        id: ID
        showBacklink: Boolean | null
        backlinkName: String | null
      } | null
      lookupFilterExpression: {
        __typename: 'LogicExpression'
        id: ID
        logicExpressionString: String | null
      } | null
      formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
      chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
      resolvedSourceColumn: {
        __typename: 'ResolvedTableColumnInfo'
        column: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          innerType: DataType | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }
      }
      enumSet: {
        __typename: 'EnumSet'
        id: ID
        options: Array<{
          __typename: 'EnumOption'
          id: ID
          label: String
          colorPreset: EnumColorPreset | null
          colorCustom: String | null
          iconName: String | null
          order: Int
          icon: { __typename: 'Icon'; id: ID } | null
        }>
      } | null
    } | null
  }>
}

export type UpdateTableTabSortsMutationVariables = Exact<{
  input: UpdateTableTabSortsInput
}>

export type UpdateTableTabSortsMutation = {
  __typename: 'Mutation'
  updateTableTabSorts: Array<{
    __typename: 'TableTabSort'
    id: ID
    direction: SortDirection
    systemGeneratedColumnType: SystemGeneratedTableColumnType | null
    tableColumn: { __typename: 'TableColumn'; id: ID } | null
  }>
}

export type UpdateTableColumnFiltersMutationVariables = Exact<{
  input: UpdateTableColumnFiltersInput
}>

export type UpdateTableColumnFiltersMutation = {
  __typename: 'Mutation'
  updateTableColumnFilters: Array<{
    __typename: 'TableColumnFilter'
    id: ID
    operator: FilterOperator
    operand: JSONObject | null
    systemGeneratedColumnType: SystemGeneratedTableColumnType | null
    tableColumn: {
      __typename: 'TableColumn'
      id: ID
      table: { __typename: 'Table'; id: ID }
    } | null
  }>
}

export type GetTableCellQueryVariables = Exact<{
  tableCellId: Scalars['ID']
}>

export type GetTableCellQuery = {
  __typename: 'Query'
  tableCell: {
    __typename: 'TableCell'
    id: ID
    userVisibleValue: String | null
    formulaError: Int | null
    column: {
      __typename: 'TableColumn'
      id: ID
      indexPrefix: String
      indexSuffix: String
      type: DataType
    }
  }
}

export type UpdatedTableRowSubscriptionVariables = Exact<{
  tableRowId: Scalars['ID']
}>

export type UpdatedTableRowSubscription = {
  __typename: 'Subscription'
  updatedTableRowDetails: {
    __typename: 'TableRow'
    id: ID
    name: String
    createdAt: DateTime
    updatedAt: DateTime
    hasChildRows: Boolean
    createdBy: {
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      email: String | null
    } | null
    updatedBy: {
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      email: String | null
    } | null
    cells: Array<{
      __typename: 'TableCell'
      id: ID
      data: JSONObject | null
      userVisibleValue: String | null
      formulaError: Int | null
      updatedAt: DateTime
      column: {
        __typename: 'TableColumn'
        id: ID
        formatOptions: JSONObject | null
        formatPreset: FormatPreset | null
        type: DataType
        order: Int
        lookupColumn: { __typename: 'TableColumn'; id: ID; type: DataType } | null
      }
      documents: Array<{ __typename: 'Document'; id: ID; name: String }>
      users: Array<{
        __typename: 'Membership'
        id: ID
        firstName: String
        lastName: String
        email: String | null
      }>
      lookupCells: Array<{
        __typename: 'TableCell'
        id: ID
        formulaError: Int | null
        row: { __typename: 'TableRow'; id: ID }
        documents: Array<{ __typename: 'Document'; id: ID }>
      }>
    }>
    rootWorkspace: { __typename: 'Workspace'; id: ID }
    table: {
      __typename: 'Table'
      columns: Array<{
        __typename: 'TableColumn'
        lookupColumnChildren: Array<{
          __typename: 'TableColumn'
          id: ID
          table: { __typename: 'Table'; id: ID }
          lookupColumnGroup: {
            __typename: 'LookupTableColumnGroup'
            id: ID
            showBacklink: Boolean | null
          } | null
        }>
      }>
    }
    currentButtonNodes: Array<{
      __typename: 'TableButtonNode'
      id: ID
      name: String
      workspaceButtons: Array<{
        __typename: 'WorkspaceButton'
        id: ID
        name: String
        order: Int
        buttonConfiguration: JSONObject | null
        requiresConfirmation: Boolean
        confirmationMessage: String | null
        icon: { __typename: 'Icon'; id: ID; name: String } | null
        manualTrigger: {
          __typename: 'ActionManualTrigger'
          id: ID
          name: String
          action: {
            __typename: 'Action'
            id: ID
            status: ActionStatus
            description: String | null
            workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
          } | null
        } | null
        form: { __typename: 'Form'; id: ID; name: String } | null
        formV2: { __typename: 'FormV2'; id: ID; name: String } | null
      }>
    }>
    processingWorkspaceButton: { __typename: 'WorkspaceButton'; id: ID; name: String } | null
  }
}

export type PushTableRowSubscriptionVariables = Exact<{
  input: TableSubscriptionInput
}>

export type PushTableRowSubscription = {
  __typename: 'Subscription'
  pushTableRow: {
    __typename: 'TableRow'
    id: ID
    createdAt: DateTime
    updatedAt: DateTime
    hasChildRows: Boolean
    createdBy: {
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      email: String | null
    } | null
    updatedBy: {
      __typename: 'Membership'
      id: ID
      firstName: String
      lastName: String
      email: String | null
    } | null
    cells: Array<{
      __typename: 'TableCell'
      id: ID
      userVisibleValue: String | null
      formulaError: Int | null
      updatedAt: DateTime
      data: JSONObject | null
      column: {
        __typename: 'TableColumn'
        id: ID
        formatOptions: JSONObject | null
        formatPreset: FormatPreset | null
        indexPrefix: String
        indexSuffix: String
        type: DataType
      }
      row: {
        __typename: 'TableRow'
        id: ID
        createdAt: DateTime
        updatedAt: DateTime
        createdBy: {
          __typename: 'Membership'
          id: ID
          firstName: String
          lastName: String
          email: String | null
        } | null
        updatedBy: {
          __typename: 'Membership'
          id: ID
          firstName: String
          lastName: String
          email: String | null
        } | null
        rootWorkspace: { __typename: 'Workspace'; id: ID }
        currentButtonNodes: Array<{
          __typename: 'TableButtonNode'
          id: ID
          name: String
          workspaceButtons: Array<{
            __typename: 'WorkspaceButton'
            id: ID
            name: String
            order: Int
            buttonConfiguration: JSONObject | null
            requiresConfirmation: Boolean
            confirmationMessage: String | null
            icon: { __typename: 'Icon'; id: ID; name: String } | null
            manualTrigger: {
              __typename: 'ActionManualTrigger'
              id: ID
              name: String
              action: {
                __typename: 'Action'
                id: ID
                status: ActionStatus
                description: String | null
                workflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
              } | null
            } | null
            form: { __typename: 'Form'; id: ID; name: String } | null
            formV2: { __typename: 'FormV2'; id: ID; name: String } | null
          }>
        }>
        processingWorkspaceButton: { __typename: 'WorkspaceButton'; id: ID; name: String } | null
      }
      lookupCells: Array<{
        __typename: 'TableCell'
        id: ID
        data: JSONObject | null
        userVisibleValue: String | null
        formulaError: Int | null
        row: { __typename: 'TableRow'; id: ID }
        documents: Array<{ __typename: 'Document'; id: ID }>
        users: Array<{
          __typename: 'Membership'
          id: ID
          firstName: String
          lastName: String
          email: String | null
        }>
      }>
      documents: Array<{ __typename: 'Document'; id: ID }>
      users: Array<{
        __typename: 'Membership'
        id: ID
        firstName: String
        lastName: String
        email: String | null
      }>
    }>
    rootWorkspace: { __typename: 'Workspace'; id: ID }
  }
}

export type DeletedTableRowSubscriptionVariables = Exact<{
  input: TableSubscriptionInput
}>

export type DeletedTableRowSubscription = { __typename: 'Subscription'; deletedTableRow: ID }

export type PushTableColumnSubscriptionVariables = Exact<{
  tableId: Scalars['ID']
}>

export type PushTableColumnSubscription = {
  __typename: 'Subscription'
  pushTableColumn: {
    __typename: 'TableColumn'
    id: ID
    name: String
    description: String | null
    order: Int
    type: DataType
    innerType: DataType | null
    isNullable: Boolean
    isReadOnly: Boolean
    isDecimal: Boolean
    indexType: IndexType
    indexPrefix: String
    indexSuffix: String
    indexAutogenerate: Boolean
    enumOptions: Array<String> | null
    displayImagesInline: Boolean
    isVisibleOnRecordDetails: Boolean
    resolvedSourceType: DataType
    resolvedEnumOptions: Array<String> | null
    formatPreset: FormatPreset | null
    formatOptions: JSONObject | null
    tableTabs: Array<{
      __typename: 'TableTabColumn'
      id: ID
      order: Int
      isFrozen: Boolean
      systemGeneratedColumnType: SystemGeneratedTableColumnType | null
      tableTab: { __typename: 'TableTab'; id: ID }
    }>
    lookupColumnGroup: {
      __typename: 'LookupTableColumnGroup'
      id: ID
      showBacklink: Boolean | null
      backlinkName: String | null
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        lookupColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
      }>
      lookupTable: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
      }
    } | null
    lookupColumn: {
      __typename: 'TableColumn'
      name: String
      order: Int
      innerType: DataType | null
      indexType: IndexType
      indexPrefix: String
      indexSuffix: String
      enumOptions: Array<String> | null
      id: ID
      type: DataType
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      table: { __typename: 'Table'; id: ID; name: String }
      resolvedSourceColumn: {
        __typename: 'ResolvedTableColumnInfo'
        column: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          innerType: DataType | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }
      }
    } | null
    lookupColumnChildren: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      table: { __typename: 'Table'; id: ID }
      lookupColumnGroup: {
        __typename: 'LookupTableColumnGroup'
        id: ID
        showBacklink: Boolean | null
        backlinkName: String | null
      } | null
    }>
    lookupFilterExpression: {
      __typename: 'LogicExpression'
      id: ID
      logicExpressionString: String | null
    } | null
    formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
    chartsForYAxis: Array<{ __typename: 'Chart'; id: ID; name: String }>
    resolvedSourceColumn: {
      __typename: 'ResolvedTableColumnInfo'
      column: {
        __typename: 'TableColumn'
        id: ID
        type: DataType
        innerType: DataType | null
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }
    }
    enumSet: {
      __typename: 'EnumSet'
      id: ID
      options: Array<{
        __typename: 'EnumOption'
        id: ID
        label: String
        colorPreset: EnumColorPreset | null
        colorCustom: String | null
        iconName: String | null
        order: Int
        icon: { __typename: 'Icon'; id: ID } | null
      }>
    } | null
  }
}

export type DeletedTableColumnSubscriptionVariables = Exact<{
  tableId: Scalars['ID']
}>

export type DeletedTableColumnSubscription = { __typename: 'Subscription'; deletedTableColumn: ID }

export type GetSimpleWorkspaceQueryVariables = Exact<{
  workspaceId: Scalars['ID']
}>

export type GetSimpleWorkspaceQuery = {
  __typename: 'Query'
  workspace: {
    __typename: 'Workspace'
    id: ID
    name: String | null
    parentOrganization: { __typename: 'Organization'; id: ID } | null
    table: { __typename: 'Table'; id: ID; name: String } | null
    chart: { __typename: 'Chart'; id: ID; name: String; chartType: ChartType } | null
    tableRow: {
      __typename: 'TableRow'
      id: ID
      table: { __typename: 'Table'; id: ID; name: String }
    } | null
    document: { __typename: 'Document'; id: ID; name: String } | null
  }
}

export type UpdatedTableRowChildRowsSubscriptionVariables = Exact<{
  tableRowId: Scalars['ID']
}>

export type UpdatedTableRowChildRowsSubscription = {
  __typename: 'Subscription'
  updatedTableRowDetails: { __typename: 'TableRow'; id: ID; hasChildRows: Boolean }
}

export type GetSettingsPageTableDetailsQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetSettingsPageTableDetailsQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    name: String
    description: String | null
    showRowWorkspace: Boolean
    hasRowWorkspaceObjects: Boolean
    hasRows: Boolean
    rootWorkspace: {
      __typename: 'Workspace'
      id: ID
      parentObject: { __typename: 'WorkspaceParentObject'; name: String } | null
    }
    views: Array<{
      __typename: 'View'
      id: ID
      parentWorkspace: {
        __typename: 'Workspace'
        id: ID
        parentObject: { __typename: 'WorkspaceParentObject'; name: String; objectId: String } | null
      }
    }>
    parentTable: { __typename: 'Table'; id: ID } | null
    columns: Array<{
      __typename: 'TableColumn'
      id: ID
      name: String
      description: String | null
      order: Int
      type: DataType
      innerType: DataType | null
      isNullable: Boolean
      isReadOnly: Boolean
      isDecimal: Boolean
      indexType: IndexType
      indexPrefix: String
      indexSuffix: String
      indexAutogenerate: Boolean
      enumOptions: Array<String> | null
      displayImagesInline: Boolean
      isVisibleOnRecordDetails: Boolean
      formatPreset: FormatPreset | null
      formatOptions: JSONObject | null
      formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
      lookupColumnGroup: {
        __typename: 'LookupTableColumnGroup'
        id: ID
        showBacklink: Boolean | null
        backlinkName: String | null
        columns: Array<{
          __typename: 'TableColumn'
          id: ID
          name: String
          type: DataType
          innerType: DataType | null
          lookupColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
        }>
        lookupTable: {
          __typename: 'Table'
          id: ID
          name: String
          icon: { __typename: 'Icon'; id: ID; name: String } | null
        }
      } | null
      lookupColumn: {
        __typename: 'TableColumn'
        id: ID
        type: DataType
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
      } | null
      lookupFilterExpression: {
        __typename: 'LogicExpression'
        id: ID
        logicExpressionString: String | null
      } | null
      resolvedSourceColumn: {
        __typename: 'ResolvedTableColumnInfo'
        column: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          innerType: DataType | null
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
          enumSet: {
            __typename: 'EnumSet'
            id: ID
            options: Array<{
              __typename: 'EnumOption'
              id: ID
              label: String
              colorPreset: EnumColorPreset | null
              colorCustom: String | null
              iconName: String | null
              order: Int
              icon: { __typename: 'Icon'; id: ID } | null
            }>
          } | null
        }
      }
      enumSet: {
        __typename: 'EnumSet'
        id: ID
        options: Array<{
          __typename: 'EnumOption'
          id: ID
          label: String
          colorPreset: EnumColorPreset | null
          colorCustom: String | null
          iconName: String | null
          order: Int
          icon: { __typename: 'Icon'; id: ID } | null
        }>
      } | null
    }>
    childTables: Array<{
      __typename: 'Table'
      id: ID
      name: String
      description: String | null
      orderOnRecordDetails: Int | null
      hasRows: Boolean
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        description: String | null
        order: Int
        type: DataType
        innerType: DataType | null
        isNullable: Boolean
        isReadOnly: Boolean
        isDecimal: Boolean
        indexType: IndexType
        indexPrefix: String
        indexSuffix: String
        indexAutogenerate: Boolean
        enumOptions: Array<String> | null
        displayImagesInline: Boolean
        isVisibleOnRecordDetails: Boolean
        formatPreset: FormatPreset | null
        formatOptions: JSONObject | null
        lookupColumn: {
          __typename: 'TableColumn'
          id: ID
          type: DataType
          formatPreset: FormatPreset | null
          formatOptions: JSONObject | null
        } | null
        formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
        lookupFilterExpression: {
          __typename: 'LogicExpression'
          id: ID
          logicExpressionString: String | null
        } | null
        lookupColumnGroup: {
          __typename: 'LookupTableColumnGroup'
          id: ID
          showBacklink: Boolean | null
          backlinkName: String | null
          columns: Array<{
            __typename: 'TableColumn'
            id: ID
            name: String
            type: DataType
            innerType: DataType | null
            lookupColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
          }>
          lookupTable: {
            __typename: 'Table'
            id: ID
            name: String
            icon: { __typename: 'Icon'; id: ID; name: String } | null
          }
        } | null
        resolvedSourceColumn: {
          __typename: 'ResolvedTableColumnInfo'
          column: {
            __typename: 'TableColumn'
            id: ID
            type: DataType
            innerType: DataType | null
            formatPreset: FormatPreset | null
            formatOptions: JSONObject | null
            enumSet: {
              __typename: 'EnumSet'
              id: ID
              options: Array<{
                __typename: 'EnumOption'
                id: ID
                label: String
                colorPreset: EnumColorPreset | null
                colorCustom: String | null
                iconName: String | null
                order: Int
                icon: { __typename: 'Icon'; id: ID } | null
              }>
            } | null
          }
        }
        enumSet: {
          __typename: 'EnumSet'
          id: ID
          options: Array<{
            __typename: 'EnumOption'
            id: ID
            label: String
            colorPreset: EnumColorPreset | null
            colorCustom: String | null
            iconName: String | null
            order: Int
            icon: { __typename: 'Icon'; id: ID } | null
          }>
        } | null
      }>
      icon: { __typename: 'Icon'; id: ID; name: String } | null
    }>
    columnGroups: Array<{
      __typename: 'TableColumnGroup'
      id: ID
      name: String
      order: Int
      columns: Array<{
        __typename: 'TableColumnGroupMember'
        id: ID
        order: Int
        tableColumn: { __typename: 'TableColumn'; id: ID }
      }>
    }>
    icon: { __typename: 'Icon'; id: ID; name: String } | null
    organization: { __typename: 'Organization'; id: ID }
  }
}

export type UploadTableDataCsvMutationVariables = Exact<{
  input: UploadTableDataCsvInput
}>

export type UploadTableDataCsvMutation = {
  __typename: 'Mutation'
  uploadTableDataCsv: { __typename: 'Table'; id: ID }
}

export type CsvInsertedTableRowSubscriptionVariables = Exact<{
  input: TableCsvInsertedSubscriptionInput
}>

export type CsvInsertedTableRowSubscription = {
  __typename: 'Subscription'
  csvInsertedTableRow: { __typename: 'FileProgress'; objectId: ID; completedCount: Int }
}

export type GetIconsQueryVariables = Exact<{ [key: string]: never }>

export type GetIconsQuery = {
  __typename: 'Query'
  icons: Array<{ __typename: 'Icon'; id: ID; name: String }>
}

export type SearchIconsQueryVariables = Exact<{
  input: Scalars['String']
}>

export type SearchIconsQuery = {
  __typename: 'Query'
  searchIcons: Array<{ __typename: 'Icon'; id: ID; name: String }>
}

export type CreateTableColumnGroupMutationVariables = Exact<{
  input: CreateTableColumnGroupInput
}>

export type CreateTableColumnGroupMutation = {
  __typename: 'Mutation'
  createTableColumnGroup: {
    __typename: 'TableColumnGroup'
    id: ID
    name: String
    order: Int
    columns: Array<{
      __typename: 'TableColumnGroupMember'
      id: ID
      order: Int
      tableColumn: { __typename: 'TableColumn'; id: ID }
    }>
  }
}

export type GetSimpleTableQueryVariables = Exact<{
  tableId: Scalars['ID']
}>

export type GetSimpleTableQuery = {
  __typename: 'Query'
  table: {
    __typename: 'Table'
    id: ID
    name: String
    rootWorkspace: { __typename: 'Workspace'; id: ID }
    parentTable: { __typename: 'Table'; id: ID } | null
  }
}

export type UpdateTableColumnGroupMutationVariables = Exact<{
  input: UpdateTableColumnGroupInput
}>

export type UpdateTableColumnGroupMutation = {
  __typename: 'Mutation'
  updateTableColumnGroup: {
    __typename: 'TableColumnGroup'
    id: ID
    name: String
    order: Int
    columns: Array<{
      __typename: 'TableColumnGroupMember'
      id: ID
      order: Int
      tableColumn: { __typename: 'TableColumn'; id: ID }
    }>
  }
}

export type DeleteTableColumnGroupMutationVariables = Exact<{
  tableColumnGroupId: Scalars['ID']
}>

export type DeleteTableColumnGroupMutation = {
  __typename: 'Mutation'
  deleteTableColumnGroup: { __typename: 'TableColumnGroup'; id: ID }
}

export type PushTableTabSubscriptionVariables = Exact<{
  tableId: Scalars['ID']
}>

export type PushTableTabSubscription = {
  __typename: 'Subscription'
  pushTableTab: {
    __typename: 'TableTab'
    id: ID
    name: String
    order: Int
    booleanOperator: BooleanOperator | null
    filters: Array<{
      __typename: 'TableColumnFilter'
      id: ID
      operator: FilterOperator
      operand: JSONObject | null
      systemGeneratedColumnType: SystemGeneratedTableColumnType | null
      tableColumn: { __typename: 'TableColumn'; id: ID } | null
    }>
    sorts: Array<{
      __typename: 'TableTabSort'
      id: ID
      direction: SortDirection
      tableColumn: { __typename: 'TableColumn'; id: ID } | null
    }>
    columns: Array<{
      __typename: 'TableTabColumn'
      id: ID
      order: Int
      isFrozen: Boolean
      tableColumn: { __typename: 'TableColumn'; id: ID; order: Int } | null
    }>
  }
}

export type AggregateTableColumnQueryVariables = Exact<{
  input: AggregateTableColumnInput
}>

export type AggregateTableColumnQuery = {
  __typename: 'Query'
  aggregateTableColumn: {
    __typename: 'ColumnAggregationResult'
    operation: AggregationOperation
    value: Float | null
  }
}

export type TableWithColumnsFragmentFragment = {
  __typename: 'Table'
  id: ID
  columns: Array<{
    __typename: 'TableColumn'
    id: ID
    name: String
    description: String | null
    order: Int
    type: DataType
    innerType: DataType | null
    isNullable: Boolean
    isReadOnly: Boolean
    isDecimal: Boolean
    indexType: IndexType
    indexPrefix: String
    indexSuffix: String
    indexAutogenerate: Boolean
    enumOptions: Array<String> | null
    displayImagesInline: Boolean
    formula: { __typename: 'Formula'; id: ID; formulaString: String | null } | null
    lookupColumnGroup: {
      __typename: 'LookupTableColumnGroup'
      id: ID
      columns: Array<{
        __typename: 'TableColumn'
        id: ID
        name: String
        type: DataType
        innerType: DataType | null
        lookupColumn: { __typename: 'TableColumn'; id: ID; name: String } | null
      }>
      lookupTable: {
        __typename: 'Table'
        id: ID
        name: String
        icon: { __typename: 'Icon'; id: ID; name: String } | null
      }
    } | null
    lookupColumn: { __typename: 'TableColumn'; id: ID; type: DataType } | null
    enumSet: {
      __typename: 'EnumSet'
      id: ID
      options: Array<{
        __typename: 'EnumOption'
        id: ID
        label: String
        colorPreset: EnumColorPreset | null
        colorCustom: String | null
        iconName: String | null
        order: Int
        icon: { __typename: 'Icon'; id: ID } | null
      }>
    } | null
  }>
}

export type TableTabWithColumnsFragment = {
  __typename: 'TableTab'
  id: ID
  columns: Array<{
    __typename: 'TableTabColumn'
    id: ID
    order: Int
    isFrozen: Boolean
    systemGeneratedColumnType: SystemGeneratedTableColumnType | null
    tableColumn: { __typename: 'TableColumn'; id: ID; order: Int } | null
  }>
}

export type ActionJsonQueryVariables = Exact<{
  actionId: Scalars['ID']
}>

export type ActionJsonQuery = { __typename: 'Query'; actionJson: JSONObject | null }

export type WorkflowQueryVariables = Exact<{
  workflowId: Scalars['ID']
}>

export type WorkflowQuery = {
  __typename: 'Query'
  workflow: {
    __typename: 'Workflow'
    id: ID
    name: String
    description: String | null
    status: WorkflowStatus
    actions: Array<{
      __typename: 'Action'
      id: ID
      name: String
      order: Int
      status: ActionStatus
      description: String | null
      manualTriggers: Array<{ __typename: 'ActionManualTrigger'; id: ID; name: String }>
      autoTrigger: {
        __typename: 'ActionAutoTrigger'
        id: ID
        type: ActionAutoTriggerType
        triggerMetadata: JSONObject
        filterExpression: JSONObject | null
        logo: { __typename: 'Document'; id: ID; name: String; storageUrl: String } | null
      } | null
      frequencyTriggers: Array<{
        __typename: 'ActionFrequencyTrigger'
        id: ID
        repeatNumber: Int
        repeatUnit: CalendarUnit
        daysOfWeek: Array<Int> | null
        hoursOfDay: Array<Int> | null
        startAt: DateTime
      }>
      steps: Array<{
        __typename: 'ActionStep'
        id: ID
        name: String
        order: Int
        status: ActionStepStatus
        type: ActionStepType
        selectionsData: JSONObject
        slugifiedSelectionsData: JSONObject
        logo: { __typename: 'Document'; id: ID; name: String; storageUrl: String } | null
        branches: Array<{
          __typename: 'ActionStepGroup'
          id: ID
          order: Int
          name: String
          actionSteps: Array<{
            __typename: 'ActionStep'
            id: ID
            name: String
            order: Int
            status: ActionStepStatus
            type: ActionStepType
            selectionsData: JSONObject
            slugifiedSelectionsData: JSONObject
          }>
        }>
      }>
    }>
  }
}

export type EnableWorkflowMutationVariables = Exact<{
  workflowId: Scalars['ID']
}>

export type EnableWorkflowMutation = {
  __typename: 'Mutation'
  enableWorkflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
}

export type DisableWorkflowMutationVariables = Exact<{
  workflowId: Scalars['ID']
}>

export type DisableWorkflowMutation = {
  __typename: 'Mutation'
  disableWorkflow: { __typename: 'Workflow'; id: ID; status: WorkflowStatus }
}

export type WorkflowsQueryVariables = Exact<{ [key: string]: never }>

export type WorkflowsQuery = {
  __typename: 'Query'
  workflows: Array<{
    __typename: 'Workflow'
    id: ID
    name: String
    status: WorkflowStatus
    description: String | null
    isUserVisible: Boolean
    updatedAt: DateTime
    actions: Array<{
      __typename: 'Action'
      id: ID
      name: String
      manualTriggers: Array<{ __typename: 'ActionManualTrigger'; id: ID }>
      autoTrigger: {
        __typename: 'ActionAutoTrigger'
        id: ID
        type: ActionAutoTriggerType
        triggerMetadata: JSONObject
        filterExpression: JSONObject | null
        logo: { __typename: 'Document'; id: ID; name: String; storageUrl: String } | null
      } | null
      frequencyTriggers: Array<{ __typename: 'ActionFrequencyTrigger'; id: ID }>
      steps: Array<{
        __typename: 'ActionStep'
        id: ID
        name: String
        order: Int
        status: ActionStepStatus
        type: ActionStepType
        logo: { __typename: 'Document'; id: ID; name: String; storageUrl: String } | null
        branches: Array<{
          __typename: 'ActionStepGroup'
          id: ID
          order: Int
          name: String
          actionSteps: Array<{
            __typename: 'ActionStep'
            id: ID
            name: String
            order: Int
            status: ActionStepStatus
            type: ActionStepType
          }>
        }>
      }>
    }>
  }>
}

export type GetSimpleWorkspaceViewsQueryVariables = Exact<{
  workspaceId: Scalars['ID']
}>

export type GetSimpleWorkspaceViewsQuery = {
  __typename: 'Query'
  workspace: {
    __typename: 'Workspace'
    id: ID
    views: Array<{ __typename: 'View'; id: ID }>
    linkedViews: Array<{ __typename: 'View'; parentWorkspace: { __typename: 'Workspace'; id: ID } }>
  }
}

export type CreateWorkspaceMutationVariables = Exact<{
  input: CreateWorkspaceInput
}>

export type CreateWorkspaceMutation = {
  __typename: 'Mutation'
  createWorkspace: { __typename: 'Workspace'; id: ID; name: String | null }
}

export type UpdateWorkspaceMutationVariables = Exact<{
  input: UpdateWorkspaceInput
}>

export type UpdateWorkspaceMutation = {
  __typename: 'Mutation'
  updateWorkspace: {
    __typename: 'Workspace'
    id: ID
    name: String | null
    views: Array<{ __typename: 'View'; id: ID; order: Int; rowNumber: Int; unitHeight: Int }>
  }
}

export type UpdateWorkspaceRowHeightMutationVariables = Exact<{
  input: UpdateWorkspaceRowHeightInput
}>

export type UpdateWorkspaceRowHeightMutation = {
  __typename: 'Mutation'
  updateWorkspaceRowHeight: {
    __typename: 'Workspace'
    id: ID
    name: String | null
    views: Array<{ __typename: 'View'; id: ID; order: Int; rowNumber: Int; unitHeight: Int }>
  }
}

export type CreateViewMutationVariables = Exact<{
  input: CreateViewInput
}>

export type CreateViewMutation = {
  __typename: 'Mutation'
  createView: { __typename: 'View'; id: ID; embed: { __typename: 'Embed'; id: ID } | null }
}

export type DeleteViewMutationVariables = Exact<{
  viewId: Scalars['ID']
}>

export type DeleteViewMutation = {
  __typename: 'Mutation'
  deleteView: { __typename: 'View'; id: ID }
}

export type DuplicateViewMutationVariables = Exact<{
  input: DuplicateViewInput
}>

export type DuplicateViewMutation = {
  __typename: 'Mutation'
  duplicateView: { __typename: 'View'; id: ID }
}

export type UpdateEmbedNameMutationVariables = Exact<{
  embedId: Scalars['ID']
  name: Scalars['String']
}>

export type UpdateEmbedNameMutation = {
  __typename: 'Mutation'
  updateEmbedName: { __typename: 'Embed'; id: ID; name: String }
}

export const DirectoryUploadTableWorkspaceObjectsFragmentDoc = gql`
  fragment DirectoryUploadTableWorkspaceObjects on Table {
    hasRowWorkspaceObjects
  }
`
export const WorkspaceCreationTableWorkspaceObjectsFragmentDoc = gql`
  fragment WorkspaceCreationTableWorkspaceObjects on Table {
    hasRowWorkspaceObjects
  }
`
export const CommentDataFragmentDoc = gql`
  fragment CommentData on Comment {
    id
    createdAt
    text
    parsedText
    author {
      id
      firstName
      lastName
    }
  }
`
export const ActivityFeedEventDataFragmentDoc = gql`
  fragment ActivityFeedEventData on ActivityFeedEvent {
    id
    timestamp
    eventType
    eventStatus
    substrate
    agentId
    originatorType
    originatorName
    impersonatedUserName
    entityType
    entityId
    data
  }
`
export const ComprehensionEntityFieldsFragmentDoc = gql`
  fragment ComprehensionEntityFields on ComprehensionGraphResult {
    edges {
      fromEntityType
      fromEntityId
      toEntityType
      toEntityId
      edgeType
      relationshipKey
      depth
    }
    truncated
    truncatedAtDepth
    maxEdges
    returnedEdgeCount
    returnedNodeCount
    tables {
      id
      name
    }
    tableColumns {
      id
      name
      table {
        name
      }
    }
    actions {
      id
      name
      autoTrigger {
        type
      }
      manualTriggers {
        id
      }
      apiTrigger {
        id
      }
      frequencyTriggers {
        id
      }
    }
    actionSteps {
      id
      name
      type
      rootAction {
        name
      }
    }
    actionStepGroups {
      id
      name
      rootAction {
        name
      }
    }
    autoTriggers {
      id
      type
      action {
        name
      }
    }
    manualTriggers {
      id
      name
      organization {
        name
      }
    }
    integrations {
      id
      type
    }
    forms {
      id
      name
    }
    formsV2 {
      id
      name
    }
    formInputs {
      id
      label
      form {
        name
      }
    }
    formFields {
      id
      name
      form {
        name
      }
    }
    workflowsV2 {
      id
      name: slug
    }
  }
`
export const DossbotEventDataFragmentDoc = gql`
  fragment DossbotEventData on DossbotEvent {
    id
    type
    payload
    createdAt
  }
`
export const LeanFormBlockFragmentDoc = gql`
  fragment LeanFormBlock on FormBlock {
    id
    order
    type
    metadata
    input {
      id
      label
    }
    inputGroup {
      id
      label
    }
  }
`
export const DetailedFormBlockFragmentDoc = gql`
  fragment DetailedFormBlock on FormBlock {
    id
    order
    type
    metadata
    visibilityConditions {
      id
      name
      slug
      expression {
        logicExpressionString
      }
    }
    input {
      id
      label
      description
      inputType
      dataType
      innerDataType
      indexDataType
      isReadOnly
      isRequired
      isVisible
      isFrozen
      isMultiSelect
      defaultValue
      metadata
      formatPreset
      formatOptions
      formula {
        id
        formulaString
        outputType
      }
      lookupTableColumn {
        id
        name
        type
        table {
          id
          name
        }
      }
      sourceTableColumn {
        id
        name
        type
        innerType
        isNullable
        formatPreset
        formatOptions
        table {
          id
          name
        }
      }
      lookupGroup {
        id
        isAutoFill
        lookupFilterExpression {
          id
          logicExpressionString
        }
      }
      validationRules {
        conditionExpression {
          condition
          logicExpressionString
        }
        validationMessage
      }
    }
    inputGroup {
      id
      label
      formInputs {
        id
        label
        formBlock {
          id
          order
          visibilityConditions {
            id
            name
            slug
            expression {
              logicExpressionString
            }
          }
        }
        description
        inputType
        dataType
        innerDataType
        indexDataType
        isReadOnly
        isRequired
        isVisible
        isFrozen
        isMultiSelect
        defaultValue
        metadata
        formatPreset
        formatOptions
        formula {
          id
          formulaString
          outputType
        }
        lookupTableColumn {
          id
          name
          type
          table {
            id
            name
          }
        }
        sourceTableColumn {
          id
          name
          type
          innerType
          isNullable
          formatPreset
          formatOptions
          table {
            id
            name
          }
        }
        lookupGroup {
          id
          isAutoFill
          lookupFilterExpression {
            id
            logicExpressionString
          }
        }
        logicExpressionValues {
          id
          order
          value
        }
        validationRules {
          conditionExpression {
            condition
            logicExpressionString
          }
          validationMessage
        }
      }
    }
  }
`
export const ColumnFormattingFragmentDoc = gql`
  fragment ColumnFormatting on TableColumn {
    formatPreset
    formatOptions
  }
`
export const EnumSetFieldsFragmentDoc = gql`
  fragment EnumSetFields on TableColumn {
    enumSet {
      id
      options {
        id
        label
        colorPreset
        colorCustom
        iconName
        icon {
          id
        }
        order
      }
    }
  }
`
export const ResolvedSourceColumnFragmentDoc = gql`
  fragment ResolvedSourceColumn on TableColumn {
    resolvedSourceColumn {
      column {
        id
        type
        innerType
        ...ColumnFormatting
        ...EnumSetFields
      }
    }
  }
  ${ColumnFormattingFragmentDoc}
  ${EnumSetFieldsFragmentDoc}
`
export const LookupProviderColumnFragmentDoc = gql`
  fragment LookupProviderColumn on TableColumn {
    id
    type
    ...ColumnFormatting
  }
  ${ColumnFormattingFragmentDoc}
`
export const DetailedFormFragmentDoc = gql`
  fragment DetailedForm on Form {
    id
    name
    isShareable
    organization {
      id
    }
    pages {
      id
      name
      order
      categories {
        id
        name
        order
        fields {
          id
          name
          description
          type
          order
          isRequired
          isEditable
          isVisible
          isArray
          isFrozen
          displayImagesInline
          defaultValue
          fieldOptions
          lookupColumn {
            id
            name
            type
          }
          lookupFilterExpression {
            id
            logicExpressionString
          }
          metadata
        }
        lookupTable {
          id
          name
          columns {
            id
            name
            type
            innerType
            order
            enumOptions
            isNullable
            displayImagesInline
            ...ColumnFormatting
            ...ResolvedSourceColumn
            lookupColumn {
              ...LookupProviderColumn
            }
          }
          parentTable {
            id
          }
        }
        isArray
        allowFillAll
      }
    }
    formFiles {
      id
      type
      nameField {
        id
        category {
          id
          page {
            id
          }
        }
        lookupColumn {
          id
        }
      }
      fieldMappings {
        id
        formField {
          id
        }
        fileField {
          id
        }
      }
      formCategory {
        id
      }
    }
    formV2 {
      id
      name
    }
    redirectTarget
    redirectCustomPath
  }
  ${ColumnFormattingFragmentDoc}
  ${ResolvedSourceColumnFragmentDoc}
  ${LookupProviderColumnFragmentDoc}
`
export const RecordDetailsDirectoryTableWorkspaceObjectsFragmentDoc = gql`
  fragment RecordDetailsDirectoryTableWorkspaceObjects on Table {
    hasRowWorkspaceObjects
  }
`
export const GetTableRowDetailedColumnHeaderFragmentDoc = gql`
  fragment GetTableRowDetailedColumnHeader on TableColumn {
    id
    name
    order
    type
    indexType
    indexPrefix
    indexSuffix
    innerType
    isNullable
    isReadOnly
    enumOptions
    ...EnumSetFields
    displayImagesInline
    isVisibleOnRecordDetails
    lookupColumn {
      id
      name
      table {
        id
        name
      }
    }
  }
  ${EnumSetFieldsFragmentDoc}
`
export const AppTableRowFieldsFragmentDoc = gql`
  fragment AppTableRowFields on AppTableRow {
    id
    createdAt
    updatedAt
    createdBy
    updatedBy
    parentRowId
    cells {
      id
      at
      value
      display
      targets {
        rowId
        cells {
          id
          at
          value
          display
        }
      }
    }
  }
`
export const WorkspaceViewFragmentDoc = gql`
  fragment WorkspaceView on View {
    id
    order
    unitHeight
    unitWidth
    rowNumber
    viewableObjectType
    workspace {
      id
      name
    }
    chart {
      id
      name
      chartType
    }
    table {
      id
      name
      icon {
        id
        name
      }
      tableTabs {
        id
        order
      }
    }
    document {
      id
      name
    }
    tableRow {
      id
      table {
        id
        name
      }
    }
    embed {
      id
      name
      betaWatermarkDisabled
      viewContent {
        id
      }
    }
    formV2 {
      id
      name
    }
  }
`
export const UpdatedUserFragmentDoc = gql`
  fragment UpdatedUser on Membership {
    id
    profilePicture {
      id
      name
      storagePath
      documentType
    }
  }
`
export const TableTabColumnsFragmentFragmentDoc = gql`
  fragment TableTabColumnsFragment on TableTab {
    id
    columns {
      id
      order
      isFrozen
      systemGeneratedColumnType
      tableColumn {
        id
        name
        order
        type
        isNullable
        enumOptions
        lookupColumn {
          id
          name
          table {
            id
            name
          }
        }
      }
    }
  }
`
export const TableColumnFiltersFragmentFragmentDoc = gql`
  fragment TableColumnFiltersFragment on TableTab {
    id
    booleanOperator
    filters {
      tableColumn {
        id
      }
      id
      operator
      operand
      systemGeneratedColumnType
    }
  }
`
export const TableTabSortsFragmentFragmentDoc = gql`
  fragment TableTabSortsFragment on TableTab {
    id
    sorts {
      id
      direction
      tableColumn {
        id
      }
      systemGeneratedColumnType
    }
  }
`
export const TableUniqueConstraintDetailsFragmentDoc = gql`
  fragment TableUniqueConstraintDetails on TableUniqueConstraint {
    id
    name
    status
    scope
    conflictedKeyGroupCount
    conflictsTruncated
    conflictsCheckedAt
    lastErrorCode
    lastErrorMessage
    failedAttempts
    columns {
      id
      position
      column {
        id
        name
        type
      }
    }
    conflicts {
      keyValues
      parentRowId
      rowCount
      exampleRowIds
    }
  }
`
export const DetailedTableColumnFragmentDoc = gql`
  fragment DetailedTableColumn on TableColumn {
    id
    name
    description
    order
    type
    innerType
    isNullable
    isReadOnly
    isDecimal
    indexType
    indexPrefix
    indexSuffix
    indexAutogenerate
    enumOptions
    displayImagesInline
    isVisibleOnRecordDetails
    resolvedSourceType
    resolvedEnumOptions
    ...ColumnFormatting
    ...ResolvedSourceColumn
    ...EnumSetFields
    lookupColumn {
      ...LookupProviderColumn
      name
      order
      innerType
      indexType
      indexPrefix
      indexSuffix
      enumOptions
      ...ResolvedSourceColumn
      table {
        id
        name
      }
    }
    lookupColumnChildren {
      id
      name
      table {
        id
      }
      lookupColumnGroup {
        id
        showBacklink
        backlinkName
      }
    }
    lookupColumnGroup {
      id
      showBacklink
      backlinkName
    }
    lookupFilterExpression {
      id
      logicExpressionString
    }
    formula {
      id
      formulaString
    }
    chartsForYAxis {
      id
      name
    }
  }
  ${ColumnFormattingFragmentDoc}
  ${ResolvedSourceColumnFragmentDoc}
  ${EnumSetFieldsFragmentDoc}
  ${LookupProviderColumnFragmentDoc}
`
export const TableWithColumnsFragmentFragmentDoc = gql`
  fragment TableWithColumnsFragment on Table {
    id
    columns {
      id
      name
      description
      order
      type
      innerType
      isNullable
      isReadOnly
      isDecimal
      indexType
      indexPrefix
      indexSuffix
      indexAutogenerate
      enumOptions
      ...EnumSetFields
      displayImagesInline
      formula {
        id
        formulaString
      }
      lookupColumnGroup {
        id
        columns {
          id
          name
          type
          innerType
          lookupColumn {
            id
            name
          }
        }
        lookupTable {
          id
          name
          icon {
            id
            name
          }
        }
      }
      lookupColumn {
        id
        type
      }
    }
  }
  ${EnumSetFieldsFragmentDoc}
`
export const TableTabWithColumnsFragmentDoc = gql`
  fragment TableTabWithColumns on TableTab {
    id
    columns {
      id
      order
      isFrozen
      systemGeneratedColumnType
      tableColumn {
        id
        order
      }
    }
  }
`
export const RenderErrorBoundaryTestRolesDocument = gql`
  query RenderErrorBoundaryTestRoles {
    roles {
      id
    }
  }
`

/**
 * __useRenderErrorBoundaryTestRolesQuery__
 *
 * To run a query within a React component, call `useRenderErrorBoundaryTestRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderErrorBoundaryTestRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderErrorBoundaryTestRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRenderErrorBoundaryTestRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RenderErrorBoundaryTestRolesQuery,
    RenderErrorBoundaryTestRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RenderErrorBoundaryTestRolesQuery,
    RenderErrorBoundaryTestRolesQueryVariables
  >(RenderErrorBoundaryTestRolesDocument, options)
}
export function useRenderErrorBoundaryTestRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RenderErrorBoundaryTestRolesQuery,
    RenderErrorBoundaryTestRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RenderErrorBoundaryTestRolesQuery,
    RenderErrorBoundaryTestRolesQueryVariables
  >(RenderErrorBoundaryTestRolesDocument, options)
}
export type RenderErrorBoundaryTestRolesQueryHookResult = ReturnType<
  typeof useRenderErrorBoundaryTestRolesQuery
>
export type RenderErrorBoundaryTestRolesLazyQueryHookResult = ReturnType<
  typeof useRenderErrorBoundaryTestRolesLazyQuery
>
export type RenderErrorBoundaryTestRolesQueryResult = Apollo.QueryResult<
  RenderErrorBoundaryTestRolesQuery,
  RenderErrorBoundaryTestRolesQueryVariables
>
export const GetUserOrientationDocument = gql`
  query getUserOrientation {
    currentUser {
      id
      locale
      orientation
    }
  }
`

/**
 * __useGetUserOrientationQuery__
 *
 * To run a query within a React component, call `useGetUserOrientationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrientationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrientationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserOrientationQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserOrientationQuery, GetUserOrientationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserOrientationQuery, GetUserOrientationQueryVariables>(
    GetUserOrientationDocument,
    options,
  )
}
export function useGetUserOrientationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserOrientationQuery,
    GetUserOrientationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserOrientationQuery, GetUserOrientationQueryVariables>(
    GetUserOrientationDocument,
    options,
  )
}
export type GetUserOrientationQueryHookResult = ReturnType<typeof useGetUserOrientationQuery>
export type GetUserOrientationLazyQueryHookResult = ReturnType<
  typeof useGetUserOrientationLazyQuery
>
export type GetUserOrientationQueryResult = Apollo.QueryResult<
  GetUserOrientationQuery,
  GetUserOrientationQueryVariables
>
export const GetSimpleUserDocument = gql`
  query getSimpleUser {
    currentUser {
      id
      firstName
      lastName
      email
      phoneNumber
      policiesAcceptedAt
      orientation
      organization {
        id
        name
        locale
        currency
        timeZone
        startOfWeekDay
        version
        featureFlags
        logo {
          id
          name
          storageUrl
        }
      }
      profilePicture {
        id
        name
        storageUrl
      }
      roles {
        id
        roleType
        permissions {
          id
          permissionType
          objectType
          manualTrigger {
            id
          }
          table {
            id
          }
          tableColumn {
            id
            table {
              id
            }
          }
          tableTab {
            id
            table {
              id
            }
          }
          form {
            id
          }
          workspace {
            id
          }
        }
      }
      defaultSignature {
        id
        signatureFile {
          id
          storageUrl
        }
      }
    }
  }
`

/**
 * __useGetSimpleUserQuery__
 *
 * To run a query within a React component, call `useGetSimpleUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSimpleUserQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSimpleUserQuery, GetSimpleUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSimpleUserQuery, GetSimpleUserQueryVariables>(
    GetSimpleUserDocument,
    options,
  )
}
export function useGetSimpleUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleUserQuery, GetSimpleUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSimpleUserQuery, GetSimpleUserQueryVariables>(
    GetSimpleUserDocument,
    options,
  )
}
export type GetSimpleUserQueryHookResult = ReturnType<typeof useGetSimpleUserQuery>
export type GetSimpleUserLazyQueryHookResult = ReturnType<typeof useGetSimpleUserLazyQuery>
export type GetSimpleUserQueryResult = Apollo.QueryResult<
  GetSimpleUserQuery,
  GetSimpleUserQueryVariables
>
export const GetPaginatedIssuesDocument = gql`
  query getPaginatedIssues($input: PaginatedIssuesInput!) {
    paginatedIssues(input: $input) {
      totalCount
      hasNext
      offset
      issues {
        id
        title
        errorTemplate
        status
        priority
        createdAt
        lastSeenAt
        resolutionReason
        issueOriginType
        issueOriginId
        impactedEntityType
        impactedEntityId
        organization {
          id
          name
        }
        owner {
          id
          firstName
          lastName
        }
      }
    }
  }
`

/**
 * __useGetPaginatedIssuesQuery__
 *
 * To run a query within a React component, call `useGetPaginatedIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedIssuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaginatedIssuesQuery(
  baseOptions: Apollo.QueryHookOptions<GetPaginatedIssuesQuery, GetPaginatedIssuesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPaginatedIssuesQuery, GetPaginatedIssuesQueryVariables>(
    GetPaginatedIssuesDocument,
    options,
  )
}
export function useGetPaginatedIssuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaginatedIssuesQuery,
    GetPaginatedIssuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPaginatedIssuesQuery, GetPaginatedIssuesQueryVariables>(
    GetPaginatedIssuesDocument,
    options,
  )
}
export type GetPaginatedIssuesQueryHookResult = ReturnType<typeof useGetPaginatedIssuesQuery>
export type GetPaginatedIssuesLazyQueryHookResult = ReturnType<
  typeof useGetPaginatedIssuesLazyQuery
>
export type GetPaginatedIssuesQueryResult = Apollo.QueryResult<
  GetPaginatedIssuesQuery,
  GetPaginatedIssuesQueryVariables
>
export const GetPaginatedNotificationsDocument = gql`
  query getPaginatedNotifications($input: PaginatedNotificationsInput!) {
    paginatedNotifications(input: $input) {
      totalCount
      totalUnreadCount
      hasNext
      offset
      notifications {
        id
        isRead
        isArchived
        notificationType
        createdAt
        metadata
        comment {
          id
          createdAt
          text
          parsedText
          author {
            id
            firstName
            lastName
          }
          workspace {
            id
            parentObject {
              objectId
              objectType
              name
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetPaginatedNotificationsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedNotificationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaginatedNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPaginatedNotificationsQuery,
    GetPaginatedNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPaginatedNotificationsQuery, GetPaginatedNotificationsQueryVariables>(
    GetPaginatedNotificationsDocument,
    options,
  )
}
export function useGetPaginatedNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaginatedNotificationsQuery,
    GetPaginatedNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetPaginatedNotificationsQuery,
    GetPaginatedNotificationsQueryVariables
  >(GetPaginatedNotificationsDocument, options)
}
export type GetPaginatedNotificationsQueryHookResult = ReturnType<
  typeof useGetPaginatedNotificationsQuery
>
export type GetPaginatedNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetPaginatedNotificationsLazyQuery
>
export type GetPaginatedNotificationsQueryResult = Apollo.QueryResult<
  GetPaginatedNotificationsQuery,
  GetPaginatedNotificationsQueryVariables
>
export const CreateCommentDocument = gql`
  mutation createComment($input: CreateCommentInput!) {
    createComment(input: $input) {
      ...CommentData
    }
  }
  ${CommentDataFragmentDoc}
`
export type CreateCommentMutationFn = Apollo.MutationFunction<
  CreateCommentMutation,
  CreateCommentMutationVariables
>

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(
    CreateCommentDocument,
    options,
  )
}
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<
  CreateCommentMutation,
  CreateCommentMutationVariables
>
export const GetPaginatedEventsDocument = gql`
  query getPaginatedEvents($input: PaginatedEventsInput!) {
    paginatedEvents(input: $input) {
      events {
        objectId
        objectType
        objectName
        event {
          ...ActivityFeedEventData
        }
      }
      cursor
      hasNext
    }
  }
  ${ActivityFeedEventDataFragmentDoc}
`

/**
 * __useGetPaginatedEventsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaginatedEventsQuery(
  baseOptions: Apollo.QueryHookOptions<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables>(
    GetPaginatedEventsDocument,
    options,
  )
}
export function useGetPaginatedEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaginatedEventsQuery,
    GetPaginatedEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPaginatedEventsQuery, GetPaginatedEventsQueryVariables>(
    GetPaginatedEventsDocument,
    options,
  )
}
export type GetPaginatedEventsQueryHookResult = ReturnType<typeof useGetPaginatedEventsQuery>
export type GetPaginatedEventsLazyQueryHookResult = ReturnType<
  typeof useGetPaginatedEventsLazyQuery
>
export type GetPaginatedEventsQueryResult = Apollo.QueryResult<
  GetPaginatedEventsQuery,
  GetPaginatedEventsQueryVariables
>
export const GetPaginatedCommentsDocument = gql`
  query getPaginatedComments($input: PaginatedCommentsInput!) {
    paginatedComments(input: $input) {
      comments {
        objectId
        objectType
        objectName
        comment {
          ...CommentData
        }
        childComments {
          comment {
            ...CommentData
          }
        }
      }
      cursor
      hasNext
    }
  }
  ${CommentDataFragmentDoc}
`

/**
 * __useGetPaginatedCommentsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedCommentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaginatedCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPaginatedCommentsQuery,
    GetPaginatedCommentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPaginatedCommentsQuery, GetPaginatedCommentsQueryVariables>(
    GetPaginatedCommentsDocument,
    options,
  )
}
export function useGetPaginatedCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaginatedCommentsQuery,
    GetPaginatedCommentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPaginatedCommentsQuery, GetPaginatedCommentsQueryVariables>(
    GetPaginatedCommentsDocument,
    options,
  )
}
export type GetPaginatedCommentsQueryHookResult = ReturnType<typeof useGetPaginatedCommentsQuery>
export type GetPaginatedCommentsLazyQueryHookResult = ReturnType<
  typeof useGetPaginatedCommentsLazyQuery
>
export type GetPaginatedCommentsQueryResult = Apollo.QueryResult<
  GetPaginatedCommentsQuery,
  GetPaginatedCommentsQueryVariables
>
export const GetActivityFeedRowScopesDocument = gql`
  query getActivityFeedRowScopes($tableRowId: ID!) {
    tableRow(tableRowId: $tableRowId) {
      id
      name
      table {
        id
        childTables {
          id
          name
          orderOnRecordDetails
          icon {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useGetActivityFeedRowScopesQuery__
 *
 * To run a query within a React component, call `useGetActivityFeedRowScopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityFeedRowScopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityFeedRowScopesQuery({
 *   variables: {
 *      tableRowId: // value for 'tableRowId'
 *   },
 * });
 */
export function useGetActivityFeedRowScopesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActivityFeedRowScopesQuery,
    GetActivityFeedRowScopesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetActivityFeedRowScopesQuery, GetActivityFeedRowScopesQueryVariables>(
    GetActivityFeedRowScopesDocument,
    options,
  )
}
export function useGetActivityFeedRowScopesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActivityFeedRowScopesQuery,
    GetActivityFeedRowScopesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetActivityFeedRowScopesQuery, GetActivityFeedRowScopesQueryVariables>(
    GetActivityFeedRowScopesDocument,
    options,
  )
}
export type GetActivityFeedRowScopesQueryHookResult = ReturnType<
  typeof useGetActivityFeedRowScopesQuery
>
export type GetActivityFeedRowScopesLazyQueryHookResult = ReturnType<
  typeof useGetActivityFeedRowScopesLazyQuery
>
export type GetActivityFeedRowScopesQueryResult = Apollo.QueryResult<
  GetActivityFeedRowScopesQuery,
  GetActivityFeedRowScopesQueryVariables
>
export const PushCommentDocument = gql`
  subscription pushComment($input: BreadcrumbsInput!) {
    pushComment(input: $input) {
      objectId
      objectType
      objectName
      comment {
        ...CommentData
      }
      childComments {
        comment {
          ...CommentData
        }
      }
    }
  }
  ${CommentDataFragmentDoc}
`

/**
 * __usePushCommentSubscription__
 *
 * To run a query within a React component, call `usePushCommentSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushCommentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushCommentSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushCommentSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PushCommentSubscription,
    PushCommentSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<PushCommentSubscription, PushCommentSubscriptionVariables>(
    PushCommentDocument,
    options,
  )
}
export type PushCommentSubscriptionHookResult = ReturnType<typeof usePushCommentSubscription>
export type PushCommentSubscriptionResult = Apollo.SubscriptionResult<PushCommentSubscription>
export const PushActivityFeedEventDocument = gql`
  subscription pushActivityFeedEvent($input: PushActivityFeedEventInput!) {
    pushActivityFeedEvent(input: $input) {
      objectId
      objectType
      objectName
      event {
        ...ActivityFeedEventData
      }
    }
  }
  ${ActivityFeedEventDataFragmentDoc}
`

/**
 * __usePushActivityFeedEventSubscription__
 *
 * To run a query within a React component, call `usePushActivityFeedEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushActivityFeedEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushActivityFeedEventSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushActivityFeedEventSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PushActivityFeedEventSubscription,
    PushActivityFeedEventSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    PushActivityFeedEventSubscription,
    PushActivityFeedEventSubscriptionVariables
  >(PushActivityFeedEventDocument, options)
}
export type PushActivityFeedEventSubscriptionHookResult = ReturnType<
  typeof usePushActivityFeedEventSubscription
>
export type PushActivityFeedEventSubscriptionResult =
  Apollo.SubscriptionResult<PushActivityFeedEventSubscription>
export const GetChartVisualizationDataDocument = gql`
  query getChartVisualizationData($input: ChartVisualizationDataInput!) {
    chartVisualizationData(input: $input) {
      pieChartAggregation {
        id
        label
        value
      }
      barChartAggregation {
        data
        indexBy
        keys
      }
      lineChartAggregation {
        id
        data {
          xString
          xFloat
          yString
          yFloat
        }
      }
      scatterplotAggregation {
        id
        data {
          xString
          xFloat
          yString
          yFloat
        }
      }
      metricAggregation
      pivotTableAggregation {
        rows {
          id
          path
          displayName
          level
          groupByIds
        }
        columns {
          id
          path
          displayName
          level
          groupByIds
        }
        cells
        grandTotals
      }
      totalHits
    }
  }
`

/**
 * __useGetChartVisualizationDataQuery__
 *
 * To run a query within a React component, call `useGetChartVisualizationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartVisualizationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartVisualizationDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChartVisualizationDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChartVisualizationDataQuery,
    GetChartVisualizationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetChartVisualizationDataQuery, GetChartVisualizationDataQueryVariables>(
    GetChartVisualizationDataDocument,
    options,
  )
}
export function useGetChartVisualizationDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChartVisualizationDataQuery,
    GetChartVisualizationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetChartVisualizationDataQuery,
    GetChartVisualizationDataQueryVariables
  >(GetChartVisualizationDataDocument, options)
}
export type GetChartVisualizationDataQueryHookResult = ReturnType<
  typeof useGetChartVisualizationDataQuery
>
export type GetChartVisualizationDataLazyQueryHookResult = ReturnType<
  typeof useGetChartVisualizationDataLazyQuery
>
export type GetChartVisualizationDataQueryResult = Apollo.QueryResult<
  GetChartVisualizationDataQuery,
  GetChartVisualizationDataQueryVariables
>
export const GetDetailedChartDocument = gql`
  query getDetailedChart($chartId: ID!) {
    chart(chartId: $chartId) {
      id
      name
      views {
        id
        parentWorkspace {
          id
          name
        }
      }
      table {
        id
        name
        parentTable {
          id
          name
        }
      }
      xAxis {
        id
        order
        table {
          id
          name
        }
        name
        type
        indexType
        innerType
        formatPreset
        formatOptions
        resolvedSourceType
        resolvedEnumOptions
        lookupColumn {
          id
          name
          type
          innerType
          indexType
          formatPreset
          formatOptions
        }
      }
      yAxis {
        id
        order
        name
        table {
          id
          name
        }
        type
        indexType
        innerType
        formatPreset
        formatOptions
        resolvedSourceType
        resolvedEnumOptions
        lookupColumn {
          id
          name
          type
          innerType
          indexType
          formatPreset
          formatOptions
        }
      }
      aggregationColumns {
        id
        order
        tableColumn {
          id
          order
          name
          type
          innerType
          indexType
          formatPreset
          formatOptions
          resolvedSourceType
          resolvedEnumOptions
          lookupColumn {
            id
            name
            type
            innerType
            indexType
            formatPreset
            formatOptions
          }
        }
        aggregationOperation
        valueDisplayType
        aggregationSorts {
          id
          direction
          sortType
        }
      }
      groupBys {
        type
        tableColumn {
          table {
            id
            name
          }
          id
          order
          name
          type
          innerType
          formatPreset
          formatOptions
          indexType
          resolvedSourceType
          resolvedEnumOptions
          lookupColumn {
            id
            name
            type
            innerType
            indexType
            formatPreset
            formatOptions
          }
        }
        metadata
        sort {
          direction
          sortType
        }
      }
      aggregationOperation
      filters {
        id
        tableColumn {
          id
          table {
            id
            name
          }
          order
          name
          type
          innerType
          indexType
          formatPreset
          formatOptions
          resolvedSourceType
          resolvedEnumOptions
          lookupColumn {
            id
            name
            type
            innerType
            indexType
            formatPreset
            formatOptions
          }
        }
        operator
        operand
      }
      chartType
      chartSubType
      thresholds
      styling
    }
  }
`

/**
 * __useGetDetailedChartQuery__
 *
 * To run a query within a React component, call `useGetDetailedChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedChartQuery({
 *   variables: {
 *      chartId: // value for 'chartId'
 *   },
 * });
 */
export function useGetDetailedChartQuery(
  baseOptions: Apollo.QueryHookOptions<GetDetailedChartQuery, GetDetailedChartQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDetailedChartQuery, GetDetailedChartQueryVariables>(
    GetDetailedChartDocument,
    options,
  )
}
export function useGetDetailedChartLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDetailedChartQuery, GetDetailedChartQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDetailedChartQuery, GetDetailedChartQueryVariables>(
    GetDetailedChartDocument,
    options,
  )
}
export type GetDetailedChartQueryHookResult = ReturnType<typeof useGetDetailedChartQuery>
export type GetDetailedChartLazyQueryHookResult = ReturnType<typeof useGetDetailedChartLazyQuery>
export type GetDetailedChartQueryResult = Apollo.QueryResult<
  GetDetailedChartQuery,
  GetDetailedChartQueryVariables
>
export const CreateChartDocument = gql`
  mutation createChart($chart: CreateChartInput!) {
    createChart(input: $chart) {
      id
      name
      chartType
      table {
        id
      }
    }
  }
`
export type CreateChartMutationFn = Apollo.MutationFunction<
  CreateChartMutation,
  CreateChartMutationVariables
>

/**
 * __useCreateChartMutation__
 *
 * To run a mutation, you first call `useCreateChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChartMutation, { data, loading, error }] = useCreateChartMutation({
 *   variables: {
 *      chart: // value for 'chart'
 *   },
 * });
 */
export function useCreateChartMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateChartMutation, CreateChartMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateChartMutation, CreateChartMutationVariables>(
    CreateChartDocument,
    options,
  )
}
export type CreateChartMutationHookResult = ReturnType<typeof useCreateChartMutation>
export type CreateChartMutationResult = Apollo.MutationResult<CreateChartMutation>
export type CreateChartMutationOptions = Apollo.BaseMutationOptions<
  CreateChartMutation,
  CreateChartMutationVariables
>
export const UpdateChartDocument = gql`
  mutation updateChart($chart: UpdateChartInput!) {
    updateChart(input: $chart) {
      id
    }
  }
`
export type UpdateChartMutationFn = Apollo.MutationFunction<
  UpdateChartMutation,
  UpdateChartMutationVariables
>

/**
 * __useUpdateChartMutation__
 *
 * To run a mutation, you first call `useUpdateChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChartMutation, { data, loading, error }] = useUpdateChartMutation({
 *   variables: {
 *      chart: // value for 'chart'
 *   },
 * });
 */
export function useUpdateChartMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateChartMutation, UpdateChartMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateChartMutation, UpdateChartMutationVariables>(
    UpdateChartDocument,
    options,
  )
}
export type UpdateChartMutationHookResult = ReturnType<typeof useUpdateChartMutation>
export type UpdateChartMutationResult = Apollo.MutationResult<UpdateChartMutation>
export type UpdateChartMutationOptions = Apollo.BaseMutationOptions<
  UpdateChartMutation,
  UpdateChartMutationVariables
>
export const UpdateChartNameDocument = gql`
  mutation updateChartName($chartId: ID!, $name: String!) {
    updateChartName(chartId: $chartId, name: $name) {
      id
      name
    }
  }
`
export type UpdateChartNameMutationFn = Apollo.MutationFunction<
  UpdateChartNameMutation,
  UpdateChartNameMutationVariables
>

/**
 * __useUpdateChartNameMutation__
 *
 * To run a mutation, you first call `useUpdateChartNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChartNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChartNameMutation, { data, loading, error }] = useUpdateChartNameMutation({
 *   variables: {
 *      chartId: // value for 'chartId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateChartNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChartNameMutation,
    UpdateChartNameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateChartNameMutation, UpdateChartNameMutationVariables>(
    UpdateChartNameDocument,
    options,
  )
}
export type UpdateChartNameMutationHookResult = ReturnType<typeof useUpdateChartNameMutation>
export type UpdateChartNameMutationResult = Apollo.MutationResult<UpdateChartNameMutation>
export type UpdateChartNameMutationOptions = Apollo.BaseMutationOptions<
  UpdateChartNameMutation,
  UpdateChartNameMutationVariables
>
export const DeleteChartDocument = gql`
  mutation deleteChart($chartId: ID!) {
    deleteChart(chartId: $chartId) {
      id
    }
  }
`
export type DeleteChartMutationFn = Apollo.MutationFunction<
  DeleteChartMutation,
  DeleteChartMutationVariables
>

/**
 * __useDeleteChartMutation__
 *
 * To run a mutation, you first call `useDeleteChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChartMutation, { data, loading, error }] = useDeleteChartMutation({
 *   variables: {
 *      chartId: // value for 'chartId'
 *   },
 * });
 */
export function useDeleteChartMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteChartMutation, DeleteChartMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteChartMutation, DeleteChartMutationVariables>(
    DeleteChartDocument,
    options,
  )
}
export type DeleteChartMutationHookResult = ReturnType<typeof useDeleteChartMutation>
export type DeleteChartMutationResult = Apollo.MutationResult<DeleteChartMutation>
export type DeleteChartMutationOptions = Apollo.BaseMutationOptions<
  DeleteChartMutation,
  DeleteChartMutationVariables
>
export const DuplicateChartDocument = gql`
  mutation duplicateChart($input: DuplicateChartInput!) {
    duplicateChart(input: $input) {
      id
      name
      chartType
    }
  }
`
export type DuplicateChartMutationFn = Apollo.MutationFunction<
  DuplicateChartMutation,
  DuplicateChartMutationVariables
>

/**
 * __useDuplicateChartMutation__
 *
 * To run a mutation, you first call `useDuplicateChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateChartMutation, { data, loading, error }] = useDuplicateChartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateChartMutation(
  baseOptions?: Apollo.MutationHookOptions<DuplicateChartMutation, DuplicateChartMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DuplicateChartMutation, DuplicateChartMutationVariables>(
    DuplicateChartDocument,
    options,
  )
}
export type DuplicateChartMutationHookResult = ReturnType<typeof useDuplicateChartMutation>
export type DuplicateChartMutationResult = Apollo.MutationResult<DuplicateChartMutation>
export type DuplicateChartMutationOptions = Apollo.BaseMutationOptions<
  DuplicateChartMutation,
  DuplicateChartMutationVariables
>
export const GetTableChartsDocument = gql`
  query getTableCharts($tableId: ID!) {
    table(tableId: $tableId) {
      id
      charts {
        id
        name
        chartType
      }
    }
  }
`

/**
 * __useGetTableChartsQuery__
 *
 * To run a query within a React component, call `useGetTableChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableChartsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetTableChartsQuery(
  baseOptions: Apollo.QueryHookOptions<GetTableChartsQuery, GetTableChartsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTableChartsQuery, GetTableChartsQueryVariables>(
    GetTableChartsDocument,
    options,
  )
}
export function useGetTableChartsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTableChartsQuery, GetTableChartsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTableChartsQuery, GetTableChartsQueryVariables>(
    GetTableChartsDocument,
    options,
  )
}
export type GetTableChartsQueryHookResult = ReturnType<typeof useGetTableChartsQuery>
export type GetTableChartsLazyQueryHookResult = ReturnType<typeof useGetTableChartsLazyQuery>
export type GetTableChartsQueryResult = Apollo.QueryResult<
  GetTableChartsQuery,
  GetTableChartsQueryVariables
>
export const GetChartForXlsxExportDocument = gql`
  query getChartForXlsxExport($chartId: ID!) {
    chart(chartId: $chartId) {
      id
      aggregationColumns {
        id
        order
        tableColumn {
          id
        }
        aggregationOperation
        valueDisplayType
      }
      groupBys {
        type
        tableColumn {
          id
          table {
            id
          }
        }
        metadata
        sort {
          id
          direction
          sortType
          aggregationColumn {
            id
            aggregationOperation
            tableColumn {
              id
            }
          }
        }
      }
      filters {
        id
        tableColumn {
          id
          type
          indexType
          resolvedSourceType
          resolvedEnumOptions
          lookupColumn {
            id
            type
            indexType
          }
          table {
            id
          }
        }
        operator
        operand
      }
      chartType
      chartSubType
    }
  }
`

/**
 * __useGetChartForXlsxExportQuery__
 *
 * To run a query within a React component, call `useGetChartForXlsxExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartForXlsxExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartForXlsxExportQuery({
 *   variables: {
 *      chartId: // value for 'chartId'
 *   },
 * });
 */
export function useGetChartForXlsxExportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChartForXlsxExportQuery,
    GetChartForXlsxExportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetChartForXlsxExportQuery, GetChartForXlsxExportQueryVariables>(
    GetChartForXlsxExportDocument,
    options,
  )
}
export function useGetChartForXlsxExportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChartForXlsxExportQuery,
    GetChartForXlsxExportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetChartForXlsxExportQuery, GetChartForXlsxExportQueryVariables>(
    GetChartForXlsxExportDocument,
    options,
  )
}
export type GetChartForXlsxExportQueryHookResult = ReturnType<typeof useGetChartForXlsxExportQuery>
export type GetChartForXlsxExportLazyQueryHookResult = ReturnType<
  typeof useGetChartForXlsxExportLazyQuery
>
export type GetChartForXlsxExportQueryResult = Apollo.QueryResult<
  GetChartForXlsxExportQuery,
  GetChartForXlsxExportQueryVariables
>
export const GetTableForChartSetupDocument = gql`
  query getTableForChartSetup($tableId: ID!) {
    table(tableId: $tableId) {
      id
      name
      parentTable {
        id
        name
        icon {
          id
          name
        }
        columns {
          ...DetailedTableColumn
        }
      }
      childTables {
        id
        name
        icon {
          id
          name
        }
        columns {
          ...DetailedTableColumn
        }
      }
      icon {
        id
        name
      }
      columns {
        ...DetailedTableColumn
      }
    }
  }
  ${DetailedTableColumnFragmentDoc}
`

/**
 * __useGetTableForChartSetupQuery__
 *
 * To run a query within a React component, call `useGetTableForChartSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableForChartSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableForChartSetupQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetTableForChartSetupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTableForChartSetupQuery,
    GetTableForChartSetupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTableForChartSetupQuery, GetTableForChartSetupQueryVariables>(
    GetTableForChartSetupDocument,
    options,
  )
}
export function useGetTableForChartSetupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTableForChartSetupQuery,
    GetTableForChartSetupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTableForChartSetupQuery, GetTableForChartSetupQueryVariables>(
    GetTableForChartSetupDocument,
    options,
  )
}
export type GetTableForChartSetupQueryHookResult = ReturnType<typeof useGetTableForChartSetupQuery>
export type GetTableForChartSetupLazyQueryHookResult = ReturnType<
  typeof useGetTableForChartSetupLazyQuery
>
export type GetTableForChartSetupQueryResult = Apollo.QueryResult<
  GetTableForChartSetupQuery,
  GetTableForChartSetupQueryVariables
>
export const GetDataSourceTreeDocument = gql`
  query getDataSourceTree {
    rootWorkspaces {
      id
      name
      views {
        id
      }
    }
    dataSourceViews {
      id
      order
      parentWorkspace {
        id
      }
      workspace {
        id
        name
        views {
          id
        }
      }
      table {
        id
        name
        icon {
          id
          name
        }
        rootWorkspace {
          id
        }
      }
      chart {
        id
        name
        chartType
        table {
          id
        }
      }
    }
  }
`

/**
 * __useGetDataSourceTreeQuery__
 *
 * To run a query within a React component, call `useGetDataSourceTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataSourceTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataSourceTreeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDataSourceTreeQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDataSourceTreeQuery, GetDataSourceTreeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDataSourceTreeQuery, GetDataSourceTreeQueryVariables>(
    GetDataSourceTreeDocument,
    options,
  )
}
export function useGetDataSourceTreeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDataSourceTreeQuery,
    GetDataSourceTreeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDataSourceTreeQuery, GetDataSourceTreeQueryVariables>(
    GetDataSourceTreeDocument,
    options,
  )
}
export type GetDataSourceTreeQueryHookResult = ReturnType<typeof useGetDataSourceTreeQuery>
export type GetDataSourceTreeLazyQueryHookResult = ReturnType<typeof useGetDataSourceTreeLazyQuery>
export type GetDataSourceTreeQueryResult = Apollo.QueryResult<
  GetDataSourceTreeQuery,
  GetDataSourceTreeQueryVariables
>
export const GetDataSourceCountsDocument = gql`
  query getDataSourceCounts {
    dataSourceViews {
      id
      table {
        id
        recordCount
        columnCount
      }
    }
  }
`

/**
 * __useGetDataSourceCountsQuery__
 *
 * To run a query within a React component, call `useGetDataSourceCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataSourceCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataSourceCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDataSourceCountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDataSourceCountsQuery,
    GetDataSourceCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDataSourceCountsQuery, GetDataSourceCountsQueryVariables>(
    GetDataSourceCountsDocument,
    options,
  )
}
export function useGetDataSourceCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDataSourceCountsQuery,
    GetDataSourceCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDataSourceCountsQuery, GetDataSourceCountsQueryVariables>(
    GetDataSourceCountsDocument,
    options,
  )
}
export type GetDataSourceCountsQueryHookResult = ReturnType<typeof useGetDataSourceCountsQuery>
export type GetDataSourceCountsLazyQueryHookResult = ReturnType<
  typeof useGetDataSourceCountsLazyQuery
>
export type GetDataSourceCountsQueryResult = Apollo.QueryResult<
  GetDataSourceCountsQuery,
  GetDataSourceCountsQueryVariables
>
export const MoveDataSourceViewDocument = gql`
  mutation moveDataSourceView(
    $viewId: ID!
    $parentWorkspaceId: ID!
    $insertBeforeViewId: ID
    $insertAfterViewId: ID
  ) {
    updateView(
      input: {
        viewId: $viewId
        parentWorkspaceId: $parentWorkspaceId
        insertBeforeViewId: $insertBeforeViewId
        insertAfterViewId: $insertAfterViewId
      }
    ) {
      id
      order
      parentWorkspace {
        id
        views {
          id
          order
        }
      }
    }
  }
`
export type MoveDataSourceViewMutationFn = Apollo.MutationFunction<
  MoveDataSourceViewMutation,
  MoveDataSourceViewMutationVariables
>

/**
 * __useMoveDataSourceViewMutation__
 *
 * To run a mutation, you first call `useMoveDataSourceViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveDataSourceViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveDataSourceViewMutation, { data, loading, error }] = useMoveDataSourceViewMutation({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      parentWorkspaceId: // value for 'parentWorkspaceId'
 *      insertBeforeViewId: // value for 'insertBeforeViewId'
 *      insertAfterViewId: // value for 'insertAfterViewId'
 *   },
 * });
 */
export function useMoveDataSourceViewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MoveDataSourceViewMutation,
    MoveDataSourceViewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MoveDataSourceViewMutation, MoveDataSourceViewMutationVariables>(
    MoveDataSourceViewDocument,
    options,
  )
}
export type MoveDataSourceViewMutationHookResult = ReturnType<typeof useMoveDataSourceViewMutation>
export type MoveDataSourceViewMutationResult = Apollo.MutationResult<MoveDataSourceViewMutation>
export type MoveDataSourceViewMutationOptions = Apollo.BaseMutationOptions<
  MoveDataSourceViewMutation,
  MoveDataSourceViewMutationVariables
>
export const PromoteDataSourceFolderDocument = gql`
  mutation promoteDataSourceFolder($workspaceId: ID!) {
    promoteToRootWorkspace(workspaceId: $workspaceId) {
      id
    }
  }
`
export type PromoteDataSourceFolderMutationFn = Apollo.MutationFunction<
  PromoteDataSourceFolderMutation,
  PromoteDataSourceFolderMutationVariables
>

/**
 * __usePromoteDataSourceFolderMutation__
 *
 * To run a mutation, you first call `usePromoteDataSourceFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteDataSourceFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteDataSourceFolderMutation, { data, loading, error }] = usePromoteDataSourceFolderMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function usePromoteDataSourceFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PromoteDataSourceFolderMutation,
    PromoteDataSourceFolderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PromoteDataSourceFolderMutation,
    PromoteDataSourceFolderMutationVariables
  >(PromoteDataSourceFolderDocument, options)
}
export type PromoteDataSourceFolderMutationHookResult = ReturnType<
  typeof usePromoteDataSourceFolderMutation
>
export type PromoteDataSourceFolderMutationResult =
  Apollo.MutationResult<PromoteDataSourceFolderMutation>
export type PromoteDataSourceFolderMutationOptions = Apollo.BaseMutationOptions<
  PromoteDataSourceFolderMutation,
  PromoteDataSourceFolderMutationVariables
>
export const DemoteDataSourceFolderDocument = gql`
  mutation demoteDataSourceFolder($workspaceId: ID!, $parentWorkspaceId: ID!) {
    demoteRootWorkspace(workspaceId: $workspaceId, parentWorkspaceId: $parentWorkspaceId) {
      id
    }
  }
`
export type DemoteDataSourceFolderMutationFn = Apollo.MutationFunction<
  DemoteDataSourceFolderMutation,
  DemoteDataSourceFolderMutationVariables
>

/**
 * __useDemoteDataSourceFolderMutation__
 *
 * To run a mutation, you first call `useDemoteDataSourceFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDemoteDataSourceFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [demoteDataSourceFolderMutation, { data, loading, error }] = useDemoteDataSourceFolderMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      parentWorkspaceId: // value for 'parentWorkspaceId'
 *   },
 * });
 */
export function useDemoteDataSourceFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DemoteDataSourceFolderMutation,
    DemoteDataSourceFolderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DemoteDataSourceFolderMutation,
    DemoteDataSourceFolderMutationVariables
  >(DemoteDataSourceFolderDocument, options)
}
export type DemoteDataSourceFolderMutationHookResult = ReturnType<
  typeof useDemoteDataSourceFolderMutation
>
export type DemoteDataSourceFolderMutationResult =
  Apollo.MutationResult<DemoteDataSourceFolderMutation>
export type DemoteDataSourceFolderMutationOptions = Apollo.BaseMutationOptions<
  DemoteDataSourceFolderMutation,
  DemoteDataSourceFolderMutationVariables
>
export const DeleteDataSourceFolderDocument = gql`
  mutation deleteDataSourceFolder($workspaceId: ID!) {
    deleteWorkspace(workspaceId: $workspaceId) {
      id
    }
  }
`
export type DeleteDataSourceFolderMutationFn = Apollo.MutationFunction<
  DeleteDataSourceFolderMutation,
  DeleteDataSourceFolderMutationVariables
>

/**
 * __useDeleteDataSourceFolderMutation__
 *
 * To run a mutation, you first call `useDeleteDataSourceFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataSourceFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataSourceFolderMutation, { data, loading, error }] = useDeleteDataSourceFolderMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteDataSourceFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDataSourceFolderMutation,
    DeleteDataSourceFolderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDataSourceFolderMutation,
    DeleteDataSourceFolderMutationVariables
  >(DeleteDataSourceFolderDocument, options)
}
export type DeleteDataSourceFolderMutationHookResult = ReturnType<
  typeof useDeleteDataSourceFolderMutation
>
export type DeleteDataSourceFolderMutationResult =
  Apollo.MutationResult<DeleteDataSourceFolderMutation>
export type DeleteDataSourceFolderMutationOptions = Apollo.BaseMutationOptions<
  DeleteDataSourceFolderMutation,
  DeleteDataSourceFolderMutationVariables
>
export const DeleteDataSourceChartDocument = gql`
  mutation deleteDataSourceChart($chartId: ID!) {
    deleteChart(chartId: $chartId) {
      id
    }
  }
`
export type DeleteDataSourceChartMutationFn = Apollo.MutationFunction<
  DeleteDataSourceChartMutation,
  DeleteDataSourceChartMutationVariables
>

/**
 * __useDeleteDataSourceChartMutation__
 *
 * To run a mutation, you first call `useDeleteDataSourceChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataSourceChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataSourceChartMutation, { data, loading, error }] = useDeleteDataSourceChartMutation({
 *   variables: {
 *      chartId: // value for 'chartId'
 *   },
 * });
 */
export function useDeleteDataSourceChartMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDataSourceChartMutation,
    DeleteDataSourceChartMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteDataSourceChartMutation, DeleteDataSourceChartMutationVariables>(
    DeleteDataSourceChartDocument,
    options,
  )
}
export type DeleteDataSourceChartMutationHookResult = ReturnType<
  typeof useDeleteDataSourceChartMutation
>
export type DeleteDataSourceChartMutationResult =
  Apollo.MutationResult<DeleteDataSourceChartMutation>
export type DeleteDataSourceChartMutationOptions = Apollo.BaseMutationOptions<
  DeleteDataSourceChartMutation,
  DeleteDataSourceChartMutationVariables
>
export const ComprehensionGraphDocument = gql`
  query ComprehensionGraph(
    $impactInput: ComprehensionGraphInput!
    $dependenciesInput: ComprehensionGraphInput!
  ) {
    comprehensionImpact(input: $impactInput) {
      ...ComprehensionEntityFields
    }
    comprehensionDependencies(input: $dependenciesInput) {
      ...ComprehensionEntityFields
    }
  }
  ${ComprehensionEntityFieldsFragmentDoc}
`

/**
 * __useComprehensionGraphQuery__
 *
 * To run a query within a React component, call `useComprehensionGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useComprehensionGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComprehensionGraphQuery({
 *   variables: {
 *      impactInput: // value for 'impactInput'
 *      dependenciesInput: // value for 'dependenciesInput'
 *   },
 * });
 */
export function useComprehensionGraphQuery(
  baseOptions: Apollo.QueryHookOptions<ComprehensionGraphQuery, ComprehensionGraphQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ComprehensionGraphQuery, ComprehensionGraphQueryVariables>(
    ComprehensionGraphDocument,
    options,
  )
}
export function useComprehensionGraphLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ComprehensionGraphQuery,
    ComprehensionGraphQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ComprehensionGraphQuery, ComprehensionGraphQueryVariables>(
    ComprehensionGraphDocument,
    options,
  )
}
export type ComprehensionGraphQueryHookResult = ReturnType<typeof useComprehensionGraphQuery>
export type ComprehensionGraphLazyQueryHookResult = ReturnType<
  typeof useComprehensionGraphLazyQuery
>
export type ComprehensionGraphQueryResult = Apollo.QueryResult<
  ComprehensionGraphQuery,
  ComprehensionGraphQueryVariables
>
export const TableDetailsDocument = gql`
  query TableDetails($tableId: ID!) {
    table(tableId: $tableId) {
      id
      name
      childTables {
        id
        name
      }
    }
  }
`

/**
 * __useTableDetailsQuery__
 *
 * To run a query within a React component, call `useTableDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableDetailsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useTableDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<TableDetailsQuery, TableDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TableDetailsQuery, TableDetailsQueryVariables>(
    TableDetailsDocument,
    options,
  )
}
export function useTableDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TableDetailsQuery, TableDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TableDetailsQuery, TableDetailsQueryVariables>(
    TableDetailsDocument,
    options,
  )
}
export type TableDetailsQueryHookResult = ReturnType<typeof useTableDetailsQuery>
export type TableDetailsLazyQueryHookResult = ReturnType<typeof useTableDetailsLazyQuery>
export type TableDetailsQueryResult = Apollo.QueryResult<
  TableDetailsQuery,
  TableDetailsQueryVariables
>
export const ActionDetailsDocument = gql`
  query ActionDetails($actionId: ID!) {
    action(actionId: $actionId) {
      id
      name
      status
      workflow {
        id
        name
      }
    }
  }
`

/**
 * __useActionDetailsQuery__
 *
 * To run a query within a React component, call `useActionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionDetailsQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useActionDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<ActionDetailsQuery, ActionDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ActionDetailsQuery, ActionDetailsQueryVariables>(
    ActionDetailsDocument,
    options,
  )
}
export function useActionDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ActionDetailsQuery, ActionDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ActionDetailsQuery, ActionDetailsQueryVariables>(
    ActionDetailsDocument,
    options,
  )
}
export type ActionDetailsQueryHookResult = ReturnType<typeof useActionDetailsQuery>
export type ActionDetailsLazyQueryHookResult = ReturnType<typeof useActionDetailsLazyQuery>
export type ActionDetailsQueryResult = Apollo.QueryResult<
  ActionDetailsQuery,
  ActionDetailsQueryVariables
>
export const ActionStepDetailsDocument = gql`
  query ActionStepDetails($actionStepId: ID!) {
    actionStep(actionStepId: $actionStepId) {
      id
      name
      order
      type
      status
      rootAction {
        id
        name
        workflow {
          id
          name
        }
      }
    }
  }
`

/**
 * __useActionStepDetailsQuery__
 *
 * To run a query within a React component, call `useActionStepDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionStepDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionStepDetailsQuery({
 *   variables: {
 *      actionStepId: // value for 'actionStepId'
 *   },
 * });
 */
export function useActionStepDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<ActionStepDetailsQuery, ActionStepDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ActionStepDetailsQuery, ActionStepDetailsQueryVariables>(
    ActionStepDetailsDocument,
    options,
  )
}
export function useActionStepDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActionStepDetailsQuery,
    ActionStepDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ActionStepDetailsQuery, ActionStepDetailsQueryVariables>(
    ActionStepDetailsDocument,
    options,
  )
}
export type ActionStepDetailsQueryHookResult = ReturnType<typeof useActionStepDetailsQuery>
export type ActionStepDetailsLazyQueryHookResult = ReturnType<typeof useActionStepDetailsLazyQuery>
export type ActionStepDetailsQueryResult = Apollo.QueryResult<
  ActionStepDetailsQuery,
  ActionStepDetailsQueryVariables
>
export const ActionStepGroupDetailsDocument = gql`
  query ActionStepGroupDetails($actionStepGroupId: ID!) {
    actionStepGroup(actionStepGroupId: $actionStepGroupId) {
      id
      name
      order
      parentActionStep {
        id
        name
        type
      }
      rootAction {
        id
        name
        workflow {
          id
          name
        }
      }
    }
  }
`

/**
 * __useActionStepGroupDetailsQuery__
 *
 * To run a query within a React component, call `useActionStepGroupDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionStepGroupDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionStepGroupDetailsQuery({
 *   variables: {
 *      actionStepGroupId: // value for 'actionStepGroupId'
 *   },
 * });
 */
export function useActionStepGroupDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActionStepGroupDetailsQuery,
    ActionStepGroupDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ActionStepGroupDetailsQuery, ActionStepGroupDetailsQueryVariables>(
    ActionStepGroupDetailsDocument,
    options,
  )
}
export function useActionStepGroupDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActionStepGroupDetailsQuery,
    ActionStepGroupDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ActionStepGroupDetailsQuery, ActionStepGroupDetailsQueryVariables>(
    ActionStepGroupDetailsDocument,
    options,
  )
}
export type ActionStepGroupDetailsQueryHookResult = ReturnType<
  typeof useActionStepGroupDetailsQuery
>
export type ActionStepGroupDetailsLazyQueryHookResult = ReturnType<
  typeof useActionStepGroupDetailsLazyQuery
>
export type ActionStepGroupDetailsQueryResult = Apollo.QueryResult<
  ActionStepGroupDetailsQuery,
  ActionStepGroupDetailsQueryVariables
>
export const FormDetailsDocument = gql`
  query FormDetails($formId: ID!) {
    form(formId: $formId) {
      id
      name
      isShareable
    }
  }
`

/**
 * __useFormDetailsQuery__
 *
 * To run a query within a React component, call `useFormDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormDetailsQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useFormDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<FormDetailsQuery, FormDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FormDetailsQuery, FormDetailsQueryVariables>(FormDetailsDocument, options)
}
export function useFormDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FormDetailsQuery, FormDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FormDetailsQuery, FormDetailsQueryVariables>(
    FormDetailsDocument,
    options,
  )
}
export type FormDetailsQueryHookResult = ReturnType<typeof useFormDetailsQuery>
export type FormDetailsLazyQueryHookResult = ReturnType<typeof useFormDetailsLazyQuery>
export type FormDetailsQueryResult = Apollo.QueryResult<FormDetailsQuery, FormDetailsQueryVariables>
export const FormV2DetailsDocument = gql`
  query FormV2Details($formId: ID!) {
    formV2(formId: $formId) {
      id
      name
      isShareable
    }
  }
`

/**
 * __useFormV2DetailsQuery__
 *
 * To run a query within a React component, call `useFormV2DetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormV2DetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormV2DetailsQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useFormV2DetailsQuery(
  baseOptions: Apollo.QueryHookOptions<FormV2DetailsQuery, FormV2DetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FormV2DetailsQuery, FormV2DetailsQueryVariables>(
    FormV2DetailsDocument,
    options,
  )
}
export function useFormV2DetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FormV2DetailsQuery, FormV2DetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FormV2DetailsQuery, FormV2DetailsQueryVariables>(
    FormV2DetailsDocument,
    options,
  )
}
export type FormV2DetailsQueryHookResult = ReturnType<typeof useFormV2DetailsQuery>
export type FormV2DetailsLazyQueryHookResult = ReturnType<typeof useFormV2DetailsLazyQuery>
export type FormV2DetailsQueryResult = Apollo.QueryResult<
  FormV2DetailsQuery,
  FormV2DetailsQueryVariables
>
export const TableColumnDetailsDocument = gql`
  query TableColumnDetails($tableColumnId: ID!) {
    tableColumn(tableColumnId: $tableColumnId) {
      id
      name
      type
      isNullable
      table {
        id
        name
      }
    }
  }
`

/**
 * __useTableColumnDetailsQuery__
 *
 * To run a query within a React component, call `useTableColumnDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableColumnDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableColumnDetailsQuery({
 *   variables: {
 *      tableColumnId: // value for 'tableColumnId'
 *   },
 * });
 */
export function useTableColumnDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<TableColumnDetailsQuery, TableColumnDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TableColumnDetailsQuery, TableColumnDetailsQueryVariables>(
    TableColumnDetailsDocument,
    options,
  )
}
export function useTableColumnDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TableColumnDetailsQuery,
    TableColumnDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TableColumnDetailsQuery, TableColumnDetailsQueryVariables>(
    TableColumnDetailsDocument,
    options,
  )
}
export type TableColumnDetailsQueryHookResult = ReturnType<typeof useTableColumnDetailsQuery>
export type TableColumnDetailsLazyQueryHookResult = ReturnType<
  typeof useTableColumnDetailsLazyQuery
>
export type TableColumnDetailsQueryResult = Apollo.QueryResult<
  TableColumnDetailsQuery,
  TableColumnDetailsQueryVariables
>
export const FormInputDetailsDocument = gql`
  query FormInputDetails($formInputId: ID!) {
    formInput(formInputId: $formInputId) {
      id
      label
      inputType
      isRequired
      group {
        id
        label
      }
      lookupGroup {
        id
        lookupTable {
          id
          name
        }
      }
      form {
        id
        name
      }
    }
  }
`

/**
 * __useFormInputDetailsQuery__
 *
 * To run a query within a React component, call `useFormInputDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormInputDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormInputDetailsQuery({
 *   variables: {
 *      formInputId: // value for 'formInputId'
 *   },
 * });
 */
export function useFormInputDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<FormInputDetailsQuery, FormInputDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FormInputDetailsQuery, FormInputDetailsQueryVariables>(
    FormInputDetailsDocument,
    options,
  )
}
export function useFormInputDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FormInputDetailsQuery, FormInputDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FormInputDetailsQuery, FormInputDetailsQueryVariables>(
    FormInputDetailsDocument,
    options,
  )
}
export type FormInputDetailsQueryHookResult = ReturnType<typeof useFormInputDetailsQuery>
export type FormInputDetailsLazyQueryHookResult = ReturnType<typeof useFormInputDetailsLazyQuery>
export type FormInputDetailsQueryResult = Apollo.QueryResult<
  FormInputDetailsQuery,
  FormInputDetailsQueryVariables
>
export const FormFieldDetailsDocument = gql`
  query FormFieldDetails($formFieldId: ID!) {
    formField(formFieldId: $formFieldId) {
      id
      name
      type
      isRequired
      category {
        id
        name
        page {
          id
          name
        }
      }
      form {
        id
        name
      }
    }
  }
`

/**
 * __useFormFieldDetailsQuery__
 *
 * To run a query within a React component, call `useFormFieldDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormFieldDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormFieldDetailsQuery({
 *   variables: {
 *      formFieldId: // value for 'formFieldId'
 *   },
 * });
 */
export function useFormFieldDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<FormFieldDetailsQuery, FormFieldDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FormFieldDetailsQuery, FormFieldDetailsQueryVariables>(
    FormFieldDetailsDocument,
    options,
  )
}
export function useFormFieldDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FormFieldDetailsQuery, FormFieldDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FormFieldDetailsQuery, FormFieldDetailsQueryVariables>(
    FormFieldDetailsDocument,
    options,
  )
}
export type FormFieldDetailsQueryHookResult = ReturnType<typeof useFormFieldDetailsQuery>
export type FormFieldDetailsLazyQueryHookResult = ReturnType<typeof useFormFieldDetailsLazyQuery>
export type FormFieldDetailsQueryResult = Apollo.QueryResult<
  FormFieldDetailsQuery,
  FormFieldDetailsQueryVariables
>
export const AutoTriggerDetailsDocument = gql`
  query AutoTriggerDetails($actionAutoTriggerId: ID!) {
    actionAutoTrigger(actionAutoTriggerId: $actionAutoTriggerId) {
      id
      type
      filterExpression
      slugifiedTriggerMetadata
      action {
        id
        name
        workflow {
          id
        }
      }
    }
  }
`

/**
 * __useAutoTriggerDetailsQuery__
 *
 * To run a query within a React component, call `useAutoTriggerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoTriggerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoTriggerDetailsQuery({
 *   variables: {
 *      actionAutoTriggerId: // value for 'actionAutoTriggerId'
 *   },
 * });
 */
export function useAutoTriggerDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<AutoTriggerDetailsQuery, AutoTriggerDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AutoTriggerDetailsQuery, AutoTriggerDetailsQueryVariables>(
    AutoTriggerDetailsDocument,
    options,
  )
}
export function useAutoTriggerDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AutoTriggerDetailsQuery,
    AutoTriggerDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AutoTriggerDetailsQuery, AutoTriggerDetailsQueryVariables>(
    AutoTriggerDetailsDocument,
    options,
  )
}
export type AutoTriggerDetailsQueryHookResult = ReturnType<typeof useAutoTriggerDetailsQuery>
export type AutoTriggerDetailsLazyQueryHookResult = ReturnType<
  typeof useAutoTriggerDetailsLazyQuery
>
export type AutoTriggerDetailsQueryResult = Apollo.QueryResult<
  AutoTriggerDetailsQuery,
  AutoTriggerDetailsQueryVariables
>
export const ManualTriggerDetailsDocument = gql`
  query ManualTriggerDetails($actionManualTriggerId: ID!) {
    actionManualTrigger(actionManualTriggerId: $actionManualTriggerId) {
      id
      name
      buttons {
        name
        parentWorkspace {
          id
          name
        }
      }
      action {
        id
        name
        workflow {
          id
        }
      }
    }
  }
`

/**
 * __useManualTriggerDetailsQuery__
 *
 * To run a query within a React component, call `useManualTriggerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualTriggerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualTriggerDetailsQuery({
 *   variables: {
 *      actionManualTriggerId: // value for 'actionManualTriggerId'
 *   },
 * });
 */
export function useManualTriggerDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ManualTriggerDetailsQuery,
    ManualTriggerDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ManualTriggerDetailsQuery, ManualTriggerDetailsQueryVariables>(
    ManualTriggerDetailsDocument,
    options,
  )
}
export function useManualTriggerDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManualTriggerDetailsQuery,
    ManualTriggerDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ManualTriggerDetailsQuery, ManualTriggerDetailsQueryVariables>(
    ManualTriggerDetailsDocument,
    options,
  )
}
export type ManualTriggerDetailsQueryHookResult = ReturnType<typeof useManualTriggerDetailsQuery>
export type ManualTriggerDetailsLazyQueryHookResult = ReturnType<
  typeof useManualTriggerDetailsLazyQuery
>
export type ManualTriggerDetailsQueryResult = Apollo.QueryResult<
  ManualTriggerDetailsQuery,
  ManualTriggerDetailsQueryVariables
>
export const IntegrationDetailsDocument = gql`
  query IntegrationDetails($integrationId: ID!) {
    integration(integrationId: $integrationId) {
      id
      type
      status
    }
  }
`

/**
 * __useIntegrationDetailsQuery__
 *
 * To run a query within a React component, call `useIntegrationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationDetailsQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useIntegrationDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<IntegrationDetailsQuery, IntegrationDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IntegrationDetailsQuery, IntegrationDetailsQueryVariables>(
    IntegrationDetailsDocument,
    options,
  )
}
export function useIntegrationDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IntegrationDetailsQuery,
    IntegrationDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IntegrationDetailsQuery, IntegrationDetailsQueryVariables>(
    IntegrationDetailsDocument,
    options,
  )
}
export type IntegrationDetailsQueryHookResult = ReturnType<typeof useIntegrationDetailsQuery>
export type IntegrationDetailsLazyQueryHookResult = ReturnType<
  typeof useIntegrationDetailsLazyQuery
>
export type IntegrationDetailsQueryResult = Apollo.QueryResult<
  IntegrationDetailsQuery,
  IntegrationDetailsQueryVariables
>
export const DrillDownTablesDocument = gql`
  query DrillDownTables {
    tables {
      id
      name
    }
  }
`

/**
 * __useDrillDownTablesQuery__
 *
 * To run a query within a React component, call `useDrillDownTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrillDownTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrillDownTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDrillDownTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<DrillDownTablesQuery, DrillDownTablesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrillDownTablesQuery, DrillDownTablesQueryVariables>(
    DrillDownTablesDocument,
    options,
  )
}
export function useDrillDownTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DrillDownTablesQuery, DrillDownTablesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrillDownTablesQuery, DrillDownTablesQueryVariables>(
    DrillDownTablesDocument,
    options,
  )
}
export type DrillDownTablesQueryHookResult = ReturnType<typeof useDrillDownTablesQuery>
export type DrillDownTablesLazyQueryHookResult = ReturnType<typeof useDrillDownTablesLazyQuery>
export type DrillDownTablesQueryResult = Apollo.QueryResult<
  DrillDownTablesQuery,
  DrillDownTablesQueryVariables
>
export const DrillDownActionsDocument = gql`
  query DrillDownActions {
    workflows {
      id
      name
      actions {
        id
        name
        nestedSteps {
          id
        }
        nestedGroups {
          id
        }
        autoTrigger {
          id
          type
        }
        manualTriggers {
          id
        }
      }
    }
  }
`

/**
 * __useDrillDownActionsQuery__
 *
 * To run a query within a React component, call `useDrillDownActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrillDownActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrillDownActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDrillDownActionsQuery(
  baseOptions?: Apollo.QueryHookOptions<DrillDownActionsQuery, DrillDownActionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrillDownActionsQuery, DrillDownActionsQueryVariables>(
    DrillDownActionsDocument,
    options,
  )
}
export function useDrillDownActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DrillDownActionsQuery, DrillDownActionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrillDownActionsQuery, DrillDownActionsQueryVariables>(
    DrillDownActionsDocument,
    options,
  )
}
export type DrillDownActionsQueryHookResult = ReturnType<typeof useDrillDownActionsQuery>
export type DrillDownActionsLazyQueryHookResult = ReturnType<typeof useDrillDownActionsLazyQuery>
export type DrillDownActionsQueryResult = Apollo.QueryResult<
  DrillDownActionsQuery,
  DrillDownActionsQueryVariables
>
export const DrillDownFormsDocument = gql`
  query DrillDownForms {
    forms {
      id
      name
    }
  }
`

/**
 * __useDrillDownFormsQuery__
 *
 * To run a query within a React component, call `useDrillDownFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrillDownFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrillDownFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDrillDownFormsQuery(
  baseOptions?: Apollo.QueryHookOptions<DrillDownFormsQuery, DrillDownFormsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrillDownFormsQuery, DrillDownFormsQueryVariables>(
    DrillDownFormsDocument,
    options,
  )
}
export function useDrillDownFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DrillDownFormsQuery, DrillDownFormsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrillDownFormsQuery, DrillDownFormsQueryVariables>(
    DrillDownFormsDocument,
    options,
  )
}
export type DrillDownFormsQueryHookResult = ReturnType<typeof useDrillDownFormsQuery>
export type DrillDownFormsLazyQueryHookResult = ReturnType<typeof useDrillDownFormsLazyQuery>
export type DrillDownFormsQueryResult = Apollo.QueryResult<
  DrillDownFormsQuery,
  DrillDownFormsQueryVariables
>
export const DrillDownFormsV2Document = gql`
  query DrillDownFormsV2 {
    allFormsV2 {
      id
      name
    }
  }
`

/**
 * __useDrillDownFormsV2Query__
 *
 * To run a query within a React component, call `useDrillDownFormsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useDrillDownFormsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrillDownFormsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useDrillDownFormsV2Query(
  baseOptions?: Apollo.QueryHookOptions<DrillDownFormsV2Query, DrillDownFormsV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrillDownFormsV2Query, DrillDownFormsV2QueryVariables>(
    DrillDownFormsV2Document,
    options,
  )
}
export function useDrillDownFormsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DrillDownFormsV2Query, DrillDownFormsV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrillDownFormsV2Query, DrillDownFormsV2QueryVariables>(
    DrillDownFormsV2Document,
    options,
  )
}
export type DrillDownFormsV2QueryHookResult = ReturnType<typeof useDrillDownFormsV2Query>
export type DrillDownFormsV2LazyQueryHookResult = ReturnType<typeof useDrillDownFormsV2LazyQuery>
export type DrillDownFormsV2QueryResult = Apollo.QueryResult<
  DrillDownFormsV2Query,
  DrillDownFormsV2QueryVariables
>
export const DrillDownWorkflowsV2Document = gql`
  query DrillDownWorkflowsV2 {
    allWorkflowsV2 {
      id
      name: slug
    }
  }
`

/**
 * __useDrillDownWorkflowsV2Query__
 *
 * To run a query within a React component, call `useDrillDownWorkflowsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useDrillDownWorkflowsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrillDownWorkflowsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useDrillDownWorkflowsV2Query(
  baseOptions?: Apollo.QueryHookOptions<
    DrillDownWorkflowsV2Query,
    DrillDownWorkflowsV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrillDownWorkflowsV2Query, DrillDownWorkflowsV2QueryVariables>(
    DrillDownWorkflowsV2Document,
    options,
  )
}
export function useDrillDownWorkflowsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DrillDownWorkflowsV2Query,
    DrillDownWorkflowsV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrillDownWorkflowsV2Query, DrillDownWorkflowsV2QueryVariables>(
    DrillDownWorkflowsV2Document,
    options,
  )
}
export type DrillDownWorkflowsV2QueryHookResult = ReturnType<typeof useDrillDownWorkflowsV2Query>
export type DrillDownWorkflowsV2LazyQueryHookResult = ReturnType<
  typeof useDrillDownWorkflowsV2LazyQuery
>
export type DrillDownWorkflowsV2QueryResult = Apollo.QueryResult<
  DrillDownWorkflowsV2Query,
  DrillDownWorkflowsV2QueryVariables
>
export const DrillDownTableColumnsDocument = gql`
  query DrillDownTableColumns($tableId: ID!) {
    tableColumnsById(tableId: $tableId) {
      id
      name
    }
  }
`

/**
 * __useDrillDownTableColumnsQuery__
 *
 * To run a query within a React component, call `useDrillDownTableColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrillDownTableColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrillDownTableColumnsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useDrillDownTableColumnsQuery(
  baseOptions: Apollo.QueryHookOptions<
    DrillDownTableColumnsQuery,
    DrillDownTableColumnsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrillDownTableColumnsQuery, DrillDownTableColumnsQueryVariables>(
    DrillDownTableColumnsDocument,
    options,
  )
}
export function useDrillDownTableColumnsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DrillDownTableColumnsQuery,
    DrillDownTableColumnsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrillDownTableColumnsQuery, DrillDownTableColumnsQueryVariables>(
    DrillDownTableColumnsDocument,
    options,
  )
}
export type DrillDownTableColumnsQueryHookResult = ReturnType<typeof useDrillDownTableColumnsQuery>
export type DrillDownTableColumnsLazyQueryHookResult = ReturnType<
  typeof useDrillDownTableColumnsLazyQuery
>
export type DrillDownTableColumnsQueryResult = Apollo.QueryResult<
  DrillDownTableColumnsQuery,
  DrillDownTableColumnsQueryVariables
>
export const DrillDownActionStepsDocument = gql`
  query DrillDownActionSteps($actionId: ID!) {
    action(actionId: $actionId) {
      id
      nestedSteps {
        id
        name
      }
    }
  }
`

/**
 * __useDrillDownActionStepsQuery__
 *
 * To run a query within a React component, call `useDrillDownActionStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrillDownActionStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrillDownActionStepsQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useDrillDownActionStepsQuery(
  baseOptions: Apollo.QueryHookOptions<
    DrillDownActionStepsQuery,
    DrillDownActionStepsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrillDownActionStepsQuery, DrillDownActionStepsQueryVariables>(
    DrillDownActionStepsDocument,
    options,
  )
}
export function useDrillDownActionStepsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DrillDownActionStepsQuery,
    DrillDownActionStepsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrillDownActionStepsQuery, DrillDownActionStepsQueryVariables>(
    DrillDownActionStepsDocument,
    options,
  )
}
export type DrillDownActionStepsQueryHookResult = ReturnType<typeof useDrillDownActionStepsQuery>
export type DrillDownActionStepsLazyQueryHookResult = ReturnType<
  typeof useDrillDownActionStepsLazyQuery
>
export type DrillDownActionStepsQueryResult = Apollo.QueryResult<
  DrillDownActionStepsQuery,
  DrillDownActionStepsQueryVariables
>
export const DrillDownActionStepGroupsDocument = gql`
  query DrillDownActionStepGroups($actionId: ID!) {
    action(actionId: $actionId) {
      id
      nestedGroups {
        id
        name
      }
    }
  }
`

/**
 * __useDrillDownActionStepGroupsQuery__
 *
 * To run a query within a React component, call `useDrillDownActionStepGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrillDownActionStepGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrillDownActionStepGroupsQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useDrillDownActionStepGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    DrillDownActionStepGroupsQuery,
    DrillDownActionStepGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrillDownActionStepGroupsQuery, DrillDownActionStepGroupsQueryVariables>(
    DrillDownActionStepGroupsDocument,
    options,
  )
}
export function useDrillDownActionStepGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DrillDownActionStepGroupsQuery,
    DrillDownActionStepGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DrillDownActionStepGroupsQuery,
    DrillDownActionStepGroupsQueryVariables
  >(DrillDownActionStepGroupsDocument, options)
}
export type DrillDownActionStepGroupsQueryHookResult = ReturnType<
  typeof useDrillDownActionStepGroupsQuery
>
export type DrillDownActionStepGroupsLazyQueryHookResult = ReturnType<
  typeof useDrillDownActionStepGroupsLazyQuery
>
export type DrillDownActionStepGroupsQueryResult = Apollo.QueryResult<
  DrillDownActionStepGroupsQuery,
  DrillDownActionStepGroupsQueryVariables
>
export const DrillDownManualTriggersDocument = gql`
  query DrillDownManualTriggers($actionId: ID!) {
    action(actionId: $actionId) {
      id
      manualTriggers {
        id
        name
      }
    }
  }
`

/**
 * __useDrillDownManualTriggersQuery__
 *
 * To run a query within a React component, call `useDrillDownManualTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrillDownManualTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrillDownManualTriggersQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useDrillDownManualTriggersQuery(
  baseOptions: Apollo.QueryHookOptions<
    DrillDownManualTriggersQuery,
    DrillDownManualTriggersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrillDownManualTriggersQuery, DrillDownManualTriggersQueryVariables>(
    DrillDownManualTriggersDocument,
    options,
  )
}
export function useDrillDownManualTriggersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DrillDownManualTriggersQuery,
    DrillDownManualTriggersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrillDownManualTriggersQuery, DrillDownManualTriggersQueryVariables>(
    DrillDownManualTriggersDocument,
    options,
  )
}
export type DrillDownManualTriggersQueryHookResult = ReturnType<
  typeof useDrillDownManualTriggersQuery
>
export type DrillDownManualTriggersLazyQueryHookResult = ReturnType<
  typeof useDrillDownManualTriggersLazyQuery
>
export type DrillDownManualTriggersQueryResult = Apollo.QueryResult<
  DrillDownManualTriggersQuery,
  DrillDownManualTriggersQueryVariables
>
export const DrillDownFormFieldsDocument = gql`
  query DrillDownFormFields($formId: ID!) {
    form(formId: $formId) {
      id
      fields {
        id
        name
      }
    }
  }
`

/**
 * __useDrillDownFormFieldsQuery__
 *
 * To run a query within a React component, call `useDrillDownFormFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrillDownFormFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrillDownFormFieldsQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useDrillDownFormFieldsQuery(
  baseOptions: Apollo.QueryHookOptions<DrillDownFormFieldsQuery, DrillDownFormFieldsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrillDownFormFieldsQuery, DrillDownFormFieldsQueryVariables>(
    DrillDownFormFieldsDocument,
    options,
  )
}
export function useDrillDownFormFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DrillDownFormFieldsQuery,
    DrillDownFormFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrillDownFormFieldsQuery, DrillDownFormFieldsQueryVariables>(
    DrillDownFormFieldsDocument,
    options,
  )
}
export type DrillDownFormFieldsQueryHookResult = ReturnType<typeof useDrillDownFormFieldsQuery>
export type DrillDownFormFieldsLazyQueryHookResult = ReturnType<
  typeof useDrillDownFormFieldsLazyQuery
>
export type DrillDownFormFieldsQueryResult = Apollo.QueryResult<
  DrillDownFormFieldsQuery,
  DrillDownFormFieldsQueryVariables
>
export const DrillDownFormInputsDocument = gql`
  query DrillDownFormInputs($formId: ID!) {
    formV2(formId: $formId) {
      id
      inputs {
        id
        label
      }
    }
  }
`

/**
 * __useDrillDownFormInputsQuery__
 *
 * To run a query within a React component, call `useDrillDownFormInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrillDownFormInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrillDownFormInputsQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useDrillDownFormInputsQuery(
  baseOptions: Apollo.QueryHookOptions<DrillDownFormInputsQuery, DrillDownFormInputsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DrillDownFormInputsQuery, DrillDownFormInputsQueryVariables>(
    DrillDownFormInputsDocument,
    options,
  )
}
export function useDrillDownFormInputsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DrillDownFormInputsQuery,
    DrillDownFormInputsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DrillDownFormInputsQuery, DrillDownFormInputsQueryVariables>(
    DrillDownFormInputsDocument,
    options,
  )
}
export type DrillDownFormInputsQueryHookResult = ReturnType<typeof useDrillDownFormInputsQuery>
export type DrillDownFormInputsLazyQueryHookResult = ReturnType<
  typeof useDrillDownFormInputsLazyQuery
>
export type DrillDownFormInputsQueryResult = Apollo.QueryResult<
  DrillDownFormInputsQuery,
  DrillDownFormInputsQueryVariables
>
export const DossbotChatsDocument = gql`
  query dossbotChats {
    dossbotChats {
      id
      title
      summary
    }
  }
`

/**
 * __useDossbotChatsQuery__
 *
 * To run a query within a React component, call `useDossbotChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDossbotChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDossbotChatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDossbotChatsQuery(
  baseOptions?: Apollo.QueryHookOptions<DossbotChatsQuery, DossbotChatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DossbotChatsQuery, DossbotChatsQueryVariables>(
    DossbotChatsDocument,
    options,
  )
}
export function useDossbotChatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DossbotChatsQuery, DossbotChatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DossbotChatsQuery, DossbotChatsQueryVariables>(
    DossbotChatsDocument,
    options,
  )
}
export type DossbotChatsQueryHookResult = ReturnType<typeof useDossbotChatsQuery>
export type DossbotChatsLazyQueryHookResult = ReturnType<typeof useDossbotChatsLazyQuery>
export type DossbotChatsQueryResult = Apollo.QueryResult<
  DossbotChatsQuery,
  DossbotChatsQueryVariables
>
export const DossbotChatDocument = gql`
  query dossbotChat($chatId: ID!) {
    dossbotChat(chatId: $chatId) {
      id
      summary
      title
      runs {
        id
        inputPrompt
        response
        status
        createdAt
        completedAt
        events {
          ...DossbotEventData
        }
        agentRuns {
          id
          events {
            ...DossbotEventData
          }
          summary
          toolRunSteps {
            id
            events {
              ...DossbotEventData
            }
            confirmationMessage
          }
        }
      }
    }
  }
  ${DossbotEventDataFragmentDoc}
`

/**
 * __useDossbotChatQuery__
 *
 * To run a query within a React component, call `useDossbotChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useDossbotChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDossbotChatQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useDossbotChatQuery(
  baseOptions: Apollo.QueryHookOptions<DossbotChatQuery, DossbotChatQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DossbotChatQuery, DossbotChatQueryVariables>(DossbotChatDocument, options)
}
export function useDossbotChatLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DossbotChatQuery, DossbotChatQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DossbotChatQuery, DossbotChatQueryVariables>(
    DossbotChatDocument,
    options,
  )
}
export type DossbotChatQueryHookResult = ReturnType<typeof useDossbotChatQuery>
export type DossbotChatLazyQueryHookResult = ReturnType<typeof useDossbotChatLazyQuery>
export type DossbotChatQueryResult = Apollo.QueryResult<DossbotChatQuery, DossbotChatQueryVariables>
export const CreateDossbotChatDocument = gql`
  mutation createDossbotChat($input: CreateDossbotChatInput!) {
    createDossbotChat(input: $input) {
      id
      summary
      title
      runs {
        id
        inputPrompt
        response
        status
        createdAt
        completedAt
      }
    }
  }
`
export type CreateDossbotChatMutationFn = Apollo.MutationFunction<
  CreateDossbotChatMutation,
  CreateDossbotChatMutationVariables
>

/**
 * __useCreateDossbotChatMutation__
 *
 * To run a mutation, you first call `useCreateDossbotChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDossbotChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDossbotChatMutation, { data, loading, error }] = useCreateDossbotChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDossbotChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDossbotChatMutation,
    CreateDossbotChatMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDossbotChatMutation, CreateDossbotChatMutationVariables>(
    CreateDossbotChatDocument,
    options,
  )
}
export type CreateDossbotChatMutationHookResult = ReturnType<typeof useCreateDossbotChatMutation>
export type CreateDossbotChatMutationResult = Apollo.MutationResult<CreateDossbotChatMutation>
export type CreateDossbotChatMutationOptions = Apollo.BaseMutationOptions<
  CreateDossbotChatMutation,
  CreateDossbotChatMutationVariables
>
export const CreateDossbotChatRunDocument = gql`
  mutation createDossbotChatRun($input: CreateDossbotChatRunInput!) {
    createDossbotChatRun(input: $input) {
      id
      inputPrompt
      response
      status
      createdAt
      completedAt
    }
  }
`
export type CreateDossbotChatRunMutationFn = Apollo.MutationFunction<
  CreateDossbotChatRunMutation,
  CreateDossbotChatRunMutationVariables
>

/**
 * __useCreateDossbotChatRunMutation__
 *
 * To run a mutation, you first call `useCreateDossbotChatRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDossbotChatRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDossbotChatRunMutation, { data, loading, error }] = useCreateDossbotChatRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDossbotChatRunMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDossbotChatRunMutation,
    CreateDossbotChatRunMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDossbotChatRunMutation, CreateDossbotChatRunMutationVariables>(
    CreateDossbotChatRunDocument,
    options,
  )
}
export type CreateDossbotChatRunMutationHookResult = ReturnType<
  typeof useCreateDossbotChatRunMutation
>
export type CreateDossbotChatRunMutationResult = Apollo.MutationResult<CreateDossbotChatRunMutation>
export type CreateDossbotChatRunMutationOptions = Apollo.BaseMutationOptions<
  CreateDossbotChatRunMutation,
  CreateDossbotChatRunMutationVariables
>
export const CancelDossbotChatRunDocument = gql`
  mutation cancelDossbotChatRun($runId: ID!) {
    cancelDossbotChatRun(runId: $runId) {
      id
      status
      completedAt
    }
  }
`
export type CancelDossbotChatRunMutationFn = Apollo.MutationFunction<
  CancelDossbotChatRunMutation,
  CancelDossbotChatRunMutationVariables
>

/**
 * __useCancelDossbotChatRunMutation__
 *
 * To run a mutation, you first call `useCancelDossbotChatRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDossbotChatRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDossbotChatRunMutation, { data, loading, error }] = useCancelDossbotChatRunMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useCancelDossbotChatRunMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelDossbotChatRunMutation,
    CancelDossbotChatRunMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CancelDossbotChatRunMutation, CancelDossbotChatRunMutationVariables>(
    CancelDossbotChatRunDocument,
    options,
  )
}
export type CancelDossbotChatRunMutationHookResult = ReturnType<
  typeof useCancelDossbotChatRunMutation
>
export type CancelDossbotChatRunMutationResult = Apollo.MutationResult<CancelDossbotChatRunMutation>
export type CancelDossbotChatRunMutationOptions = Apollo.BaseMutationOptions<
  CancelDossbotChatRunMutation,
  CancelDossbotChatRunMutationVariables
>
export const PushDossbotEventDocument = gql`
  subscription pushDossbotEvent($chatId: ID!) {
    pushDossbotEvent(chatId: $chatId) {
      id
      type
      payload
      chatRun {
        id
        status
        response
      }
      agentRun {
        id
        status
        summary
      }
      toolRunStep {
        id
        status
        toolName
        confirmationMessage
      }
    }
  }
`

/**
 * __usePushDossbotEventSubscription__
 *
 * To run a query within a React component, call `usePushDossbotEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushDossbotEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushDossbotEventSubscription({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function usePushDossbotEventSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PushDossbotEventSubscription,
    PushDossbotEventSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    PushDossbotEventSubscription,
    PushDossbotEventSubscriptionVariables
  >(PushDossbotEventDocument, options)
}
export type PushDossbotEventSubscriptionHookResult = ReturnType<
  typeof usePushDossbotEventSubscription
>
export type PushDossbotEventSubscriptionResult =
  Apollo.SubscriptionResult<PushDossbotEventSubscription>
export const RespondToDossbotToolConfirmationDocument = gql`
  mutation respondToDossbotToolConfirmation($input: RespondToDossbotToolConfirmationInput!) {
    respondToDossbotToolConfirmation(input: $input) {
      id
      status
    }
  }
`
export type RespondToDossbotToolConfirmationMutationFn = Apollo.MutationFunction<
  RespondToDossbotToolConfirmationMutation,
  RespondToDossbotToolConfirmationMutationVariables
>

/**
 * __useRespondToDossbotToolConfirmationMutation__
 *
 * To run a mutation, you first call `useRespondToDossbotToolConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToDossbotToolConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToDossbotToolConfirmationMutation, { data, loading, error }] = useRespondToDossbotToolConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRespondToDossbotToolConfirmationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RespondToDossbotToolConfirmationMutation,
    RespondToDossbotToolConfirmationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RespondToDossbotToolConfirmationMutation,
    RespondToDossbotToolConfirmationMutationVariables
  >(RespondToDossbotToolConfirmationDocument, options)
}
export type RespondToDossbotToolConfirmationMutationHookResult = ReturnType<
  typeof useRespondToDossbotToolConfirmationMutation
>
export type RespondToDossbotToolConfirmationMutationResult =
  Apollo.MutationResult<RespondToDossbotToolConfirmationMutation>
export type RespondToDossbotToolConfirmationMutationOptions = Apollo.BaseMutationOptions<
  RespondToDossbotToolConfirmationMutation,
  RespondToDossbotToolConfirmationMutationVariables
>
export const UpdateFormDocument = gql`
  mutation updateForm($input: UpdateFormInput!) {
    updateForm(input: $input) {
      id
      name
      isShareable
      formFiles {
        id
        type
      }
      pages {
        id
        categories {
          id
          lookupTable {
            id
            name
            isShareable
          }
        }
      }
      buttons {
        id
        name
        parentWorkspace {
          id
          chart {
            id
            name
          }
        }
        buttonNode {
          id
          table {
            id
          }
        }
      }
    }
  }
`
export type UpdateFormMutationFn = Apollo.MutationFunction<
  UpdateFormMutation,
  UpdateFormMutationVariables
>

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormMutation, { data, loading, error }] = useUpdateFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateFormMutation, UpdateFormMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateFormMutation, UpdateFormMutationVariables>(
    UpdateFormDocument,
    options,
  )
}
export type UpdateFormMutationHookResult = ReturnType<typeof useUpdateFormMutation>
export type UpdateFormMutationResult = Apollo.MutationResult<UpdateFormMutation>
export type UpdateFormMutationOptions = Apollo.BaseMutationOptions<
  UpdateFormMutation,
  UpdateFormMutationVariables
>
export const UpdateFormV2Document = gql`
  mutation updateFormV2($input: UpdateFormV2Input!) {
    updateFormV2(input: $input) {
      id
      name
      redirectTarget
      redirectCustomPath
    }
  }
`
export type UpdateFormV2MutationFn = Apollo.MutationFunction<
  UpdateFormV2Mutation,
  UpdateFormV2MutationVariables
>

/**
 * __useUpdateFormV2Mutation__
 *
 * To run a mutation, you first call `useUpdateFormV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormV2Mutation, { data, loading, error }] = useUpdateFormV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateFormV2Mutation, UpdateFormV2MutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateFormV2Mutation, UpdateFormV2MutationVariables>(
    UpdateFormV2Document,
    options,
  )
}
export type UpdateFormV2MutationHookResult = ReturnType<typeof useUpdateFormV2Mutation>
export type UpdateFormV2MutationResult = Apollo.MutationResult<UpdateFormV2Mutation>
export type UpdateFormV2MutationOptions = Apollo.BaseMutationOptions<
  UpdateFormV2Mutation,
  UpdateFormV2MutationVariables
>
export const GetSimpleFormDocument = gql`
  query getSimpleForm($formId: ID!) {
    form(formId: $formId) {
      id
      name
      isShareable
      formFiles {
        id
        type
      }
      pages {
        id
        categories {
          id
          lookupTable {
            id
            name
            isShareable
            lookupFormCategories {
              id
              name
              page {
                id
                form {
                  id
                  isShareable
                }
              }
            }
            formLookupInputGroups {
              id
              form {
                id
                permissions {
                  id
                  permissionType
                  role {
                    id
                    roleType
                  }
                }
              }
            }
          }
        }
      }
      buttons {
        id
        name
        parentWorkspace {
          id
          name
          parentOrganization {
            id
          }
          table {
            id
            name
          }
          tableRow {
            id
            table {
              id
              name
            }
          }
          document {
            id
            name
          }
          chart {
            id
            name
          }
        }
        buttonNode {
          id
          name
          table {
            id
            name
          }
        }
      }
      formV2 {
        id
        name
      }
    }
  }
`

/**
 * __useGetSimpleFormQuery__
 *
 * To run a query within a React component, call `useGetSimpleFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleFormQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetSimpleFormQuery(
  baseOptions: Apollo.QueryHookOptions<GetSimpleFormQuery, GetSimpleFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSimpleFormQuery, GetSimpleFormQueryVariables>(
    GetSimpleFormDocument,
    options,
  )
}
export function useGetSimpleFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleFormQuery, GetSimpleFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSimpleFormQuery, GetSimpleFormQueryVariables>(
    GetSimpleFormDocument,
    options,
  )
}
export type GetSimpleFormQueryHookResult = ReturnType<typeof useGetSimpleFormQuery>
export type GetSimpleFormLazyQueryHookResult = ReturnType<typeof useGetSimpleFormLazyQuery>
export type GetSimpleFormQueryResult = Apollo.QueryResult<
  GetSimpleFormQuery,
  GetSimpleFormQueryVariables
>
export const DuplicateFormDocument = gql`
  mutation duplicateForm($formId: ID!) {
    duplicateForm(formId: $formId) {
      id
      name
      isShareable
      formFiles {
        id
        type
      }
      buttons {
        id
        name
        parentWorkspace {
          id
          name
          parentOrganization {
            id
          }
          table {
            id
            name
          }
          tableRow {
            id
            table {
              id
              name
            }
          }
          document {
            id
            name
          }
          chart {
            id
            name
          }
        }
        buttonNode {
          id
          table {
            id
            name
          }
        }
      }
    }
  }
`
export type DuplicateFormMutationFn = Apollo.MutationFunction<
  DuplicateFormMutation,
  DuplicateFormMutationVariables
>

/**
 * __useDuplicateFormMutation__
 *
 * To run a mutation, you first call `useDuplicateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateFormMutation, { data, loading, error }] = useDuplicateFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useDuplicateFormMutation(
  baseOptions?: Apollo.MutationHookOptions<DuplicateFormMutation, DuplicateFormMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DuplicateFormMutation, DuplicateFormMutationVariables>(
    DuplicateFormDocument,
    options,
  )
}
export type DuplicateFormMutationHookResult = ReturnType<typeof useDuplicateFormMutation>
export type DuplicateFormMutationResult = Apollo.MutationResult<DuplicateFormMutation>
export type DuplicateFormMutationOptions = Apollo.BaseMutationOptions<
  DuplicateFormMutation,
  DuplicateFormMutationVariables
>
export const DuplicateFormV2Document = gql`
  mutation duplicateFormV2($formV2Id: ID!) {
    duplicateFormV2(formV2Id: $formV2Id) {
      id
      name
    }
  }
`
export type DuplicateFormV2MutationFn = Apollo.MutationFunction<
  DuplicateFormV2Mutation,
  DuplicateFormV2MutationVariables
>

/**
 * __useDuplicateFormV2Mutation__
 *
 * To run a mutation, you first call `useDuplicateFormV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateFormV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateFormV2Mutation, { data, loading, error }] = useDuplicateFormV2Mutation({
 *   variables: {
 *      formV2Id: // value for 'formV2Id'
 *   },
 * });
 */
export function useDuplicateFormV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateFormV2Mutation,
    DuplicateFormV2MutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DuplicateFormV2Mutation, DuplicateFormV2MutationVariables>(
    DuplicateFormV2Document,
    options,
  )
}
export type DuplicateFormV2MutationHookResult = ReturnType<typeof useDuplicateFormV2Mutation>
export type DuplicateFormV2MutationResult = Apollo.MutationResult<DuplicateFormV2Mutation>
export type DuplicateFormV2MutationOptions = Apollo.BaseMutationOptions<
  DuplicateFormV2Mutation,
  DuplicateFormV2MutationVariables
>
export const GetWorkflowsByFormDocument = gql`
  query getWorkflowsByForm($formId: ID!) {
    workflowsByForm(formId: $formId) {
      id
      name
      status
      isUserVisible
      organization {
        id
      }
    }
  }
`

/**
 * __useGetWorkflowsByFormQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsByFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsByFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsByFormQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetWorkflowsByFormQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkflowsByFormQuery, GetWorkflowsByFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWorkflowsByFormQuery, GetWorkflowsByFormQueryVariables>(
    GetWorkflowsByFormDocument,
    options,
  )
}
export function useGetWorkflowsByFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowsByFormQuery,
    GetWorkflowsByFormQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWorkflowsByFormQuery, GetWorkflowsByFormQueryVariables>(
    GetWorkflowsByFormDocument,
    options,
  )
}
export type GetWorkflowsByFormQueryHookResult = ReturnType<typeof useGetWorkflowsByFormQuery>
export type GetWorkflowsByFormLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowsByFormLazyQuery
>
export type GetWorkflowsByFormQueryResult = Apollo.QueryResult<
  GetWorkflowsByFormQuery,
  GetWorkflowsByFormQueryVariables
>
export const GetWorkspacesDocument = gql`
  query getWorkspaces {
    workspaces {
      id
      name
      parentOrganization {
        id
      }
      table {
        id
        name
        icon {
          id
          name
        }
      }
      tableRow {
        id
        name
        table {
          id
          name
        }
      }
      document {
        id
        name
      }
      chart {
        id
        name
      }
    }
  }
`

/**
 * __useGetWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkspacesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetWorkspacesQuery, GetWorkspacesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWorkspacesQuery, GetWorkspacesQueryVariables>(
    GetWorkspacesDocument,
    options,
  )
}
export function useGetWorkspacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspacesQuery, GetWorkspacesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWorkspacesQuery, GetWorkspacesQueryVariables>(
    GetWorkspacesDocument,
    options,
  )
}
export type GetWorkspacesQueryHookResult = ReturnType<typeof useGetWorkspacesQuery>
export type GetWorkspacesLazyQueryHookResult = ReturnType<typeof useGetWorkspacesLazyQuery>
export type GetWorkspacesQueryResult = Apollo.QueryResult<
  GetWorkspacesQuery,
  GetWorkspacesQueryVariables
>
export const CreateWorkspaceButtonDocument = gql`
  mutation createWorkspaceButton($input: CreateWorkspaceButtonInput!) {
    createWorkspaceButton(input: $input) {
      id
      order
      name
      manualTrigger {
        id
        name
        action {
          id
          name
        }
      }
      form {
        id
        name
      }
      formV2 {
        id
        name
      }
      parentWorkspace {
        id
        name
        parentOrganization {
          id
        }
        table {
          id
          name
          icon {
            id
            name
          }
        }
        tableRow {
          id
          name
          table {
            id
            name
          }
        }
        document {
          id
          name
        }
        chart {
          id
          name
        }
      }
      buttonNode {
        id
        table {
          id
          name
        }
      }
    }
  }
`
export type CreateWorkspaceButtonMutationFn = Apollo.MutationFunction<
  CreateWorkspaceButtonMutation,
  CreateWorkspaceButtonMutationVariables
>

/**
 * __useCreateWorkspaceButtonMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceButtonMutation, { data, loading, error }] = useCreateWorkspaceButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceButtonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkspaceButtonMutation,
    CreateWorkspaceButtonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateWorkspaceButtonMutation, CreateWorkspaceButtonMutationVariables>(
    CreateWorkspaceButtonDocument,
    options,
  )
}
export type CreateWorkspaceButtonMutationHookResult = ReturnType<
  typeof useCreateWorkspaceButtonMutation
>
export type CreateWorkspaceButtonMutationResult =
  Apollo.MutationResult<CreateWorkspaceButtonMutation>
export type CreateWorkspaceButtonMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkspaceButtonMutation,
  CreateWorkspaceButtonMutationVariables
>
export const DeleteWorkspaceButtonDocument = gql`
  mutation deleteWorkspaceButton($workspaceButtonId: ID!) {
    deleteWorkspaceButton(workspaceButtonId: $workspaceButtonId) {
      id
    }
  }
`
export type DeleteWorkspaceButtonMutationFn = Apollo.MutationFunction<
  DeleteWorkspaceButtonMutation,
  DeleteWorkspaceButtonMutationVariables
>

/**
 * __useDeleteWorkspaceButtonMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceButtonMutation, { data, loading, error }] = useDeleteWorkspaceButtonMutation({
 *   variables: {
 *      workspaceButtonId: // value for 'workspaceButtonId'
 *   },
 * });
 */
export function useDeleteWorkspaceButtonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkspaceButtonMutation,
    DeleteWorkspaceButtonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteWorkspaceButtonMutation, DeleteWorkspaceButtonMutationVariables>(
    DeleteWorkspaceButtonDocument,
    options,
  )
}
export type DeleteWorkspaceButtonMutationHookResult = ReturnType<
  typeof useDeleteWorkspaceButtonMutation
>
export type DeleteWorkspaceButtonMutationResult =
  Apollo.MutationResult<DeleteWorkspaceButtonMutation>
export type DeleteWorkspaceButtonMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorkspaceButtonMutation,
  DeleteWorkspaceButtonMutationVariables
>
export const DeleteFormDocument = gql`
  mutation deleteForm($input: DeleteFormInput!) {
    deleteForm(input: $input) {
      id
    }
  }
`
export type DeleteFormMutationFn = Apollo.MutationFunction<
  DeleteFormMutation,
  DeleteFormMutationVariables
>

/**
 * __useDeleteFormMutation__
 *
 * To run a mutation, you first call `useDeleteFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormMutation, { data, loading, error }] = useDeleteFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFormMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteFormMutation, DeleteFormMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFormMutation, DeleteFormMutationVariables>(
    DeleteFormDocument,
    options,
  )
}
export type DeleteFormMutationHookResult = ReturnType<typeof useDeleteFormMutation>
export type DeleteFormMutationResult = Apollo.MutationResult<DeleteFormMutation>
export type DeleteFormMutationOptions = Apollo.BaseMutationOptions<
  DeleteFormMutation,
  DeleteFormMutationVariables
>
export const UpdateWorkspaceButtonDocument = gql`
  mutation updateWorkspaceButton($input: UpdateWorkspaceButtonInput!) {
    updateWorkspaceButton(input: $input) {
      id
      order
      name
      manualTrigger {
        id
        name
        action {
          id
          name
        }
      }
      form {
        id
        name
      }
      formV2 {
        id
        name
      }
      parentWorkspace {
        id
        name
        parentOrganization {
          id
        }
        table {
          id
          name
          icon {
            id
            name
          }
        }
        tableRow {
          id
          name
          table {
            id
            name
          }
        }
        document {
          id
          name
        }
        chart {
          id
          name
        }
      }
      buttonNode {
        id
        table {
          id
          name
        }
      }
    }
  }
`
export type UpdateWorkspaceButtonMutationFn = Apollo.MutationFunction<
  UpdateWorkspaceButtonMutation,
  UpdateWorkspaceButtonMutationVariables
>

/**
 * __useUpdateWorkspaceButtonMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceButtonMutation, { data, loading, error }] = useUpdateWorkspaceButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceButtonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkspaceButtonMutation,
    UpdateWorkspaceButtonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateWorkspaceButtonMutation, UpdateWorkspaceButtonMutationVariables>(
    UpdateWorkspaceButtonDocument,
    options,
  )
}
export type UpdateWorkspaceButtonMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceButtonMutation
>
export type UpdateWorkspaceButtonMutationResult =
  Apollo.MutationResult<UpdateWorkspaceButtonMutation>
export type UpdateWorkspaceButtonMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkspaceButtonMutation,
  UpdateWorkspaceButtonMutationVariables
>
export const MigrateFormV1ToV2Document = gql`
  mutation migrateFormV1ToV2($formId: ID!) {
    migrateFormV1ToV2(formId: $formId) {
      id
      name
      formV2 {
        id
        name
      }
    }
  }
`
export type MigrateFormV1ToV2MutationFn = Apollo.MutationFunction<
  MigrateFormV1ToV2Mutation,
  MigrateFormV1ToV2MutationVariables
>

/**
 * __useMigrateFormV1ToV2Mutation__
 *
 * To run a mutation, you first call `useMigrateFormV1ToV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateFormV1ToV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateFormV1ToV2Mutation, { data, loading, error }] = useMigrateFormV1ToV2Mutation({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useMigrateFormV1ToV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<
    MigrateFormV1ToV2Mutation,
    MigrateFormV1ToV2MutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MigrateFormV1ToV2Mutation, MigrateFormV1ToV2MutationVariables>(
    MigrateFormV1ToV2Document,
    options,
  )
}
export type MigrateFormV1ToV2MutationHookResult = ReturnType<typeof useMigrateFormV1ToV2Mutation>
export type MigrateFormV1ToV2MutationResult = Apollo.MutationResult<MigrateFormV1ToV2Mutation>
export type MigrateFormV1ToV2MutationOptions = Apollo.BaseMutationOptions<
  MigrateFormV1ToV2Mutation,
  MigrateFormV1ToV2MutationVariables
>
export const RollbackFormV1ToV2MigrationDocument = gql`
  mutation rollbackFormV1ToV2Migration($formId: ID!) {
    rollbackFormV1ToV2Migration(formId: $formId) {
      id
      name
      formV2 {
        id
        name
      }
    }
  }
`
export type RollbackFormV1ToV2MigrationMutationFn = Apollo.MutationFunction<
  RollbackFormV1ToV2MigrationMutation,
  RollbackFormV1ToV2MigrationMutationVariables
>

/**
 * __useRollbackFormV1ToV2MigrationMutation__
 *
 * To run a mutation, you first call `useRollbackFormV1ToV2MigrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRollbackFormV1ToV2MigrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rollbackFormV1ToV2MigrationMutation, { data, loading, error }] = useRollbackFormV1ToV2MigrationMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useRollbackFormV1ToV2MigrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RollbackFormV1ToV2MigrationMutation,
    RollbackFormV1ToV2MigrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RollbackFormV1ToV2MigrationMutation,
    RollbackFormV1ToV2MigrationMutationVariables
  >(RollbackFormV1ToV2MigrationDocument, options)
}
export type RollbackFormV1ToV2MigrationMutationHookResult = ReturnType<
  typeof useRollbackFormV1ToV2MigrationMutation
>
export type RollbackFormV1ToV2MigrationMutationResult =
  Apollo.MutationResult<RollbackFormV1ToV2MigrationMutation>
export type RollbackFormV1ToV2MigrationMutationOptions = Apollo.BaseMutationOptions<
  RollbackFormV1ToV2MigrationMutation,
  RollbackFormV1ToV2MigrationMutationVariables
>
export const UpdateFormPageDocument = gql`
  mutation updateFormPage($input: UpdateFormPageInput!) {
    updateFormPage(input: $input) {
      id
      name
      order
    }
  }
`
export type UpdateFormPageMutationFn = Apollo.MutationFunction<
  UpdateFormPageMutation,
  UpdateFormPageMutationVariables
>

/**
 * __useUpdateFormPageMutation__
 *
 * To run a mutation, you first call `useUpdateFormPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormPageMutation, { data, loading, error }] = useUpdateFormPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormPageMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateFormPageMutation, UpdateFormPageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateFormPageMutation, UpdateFormPageMutationVariables>(
    UpdateFormPageDocument,
    options,
  )
}
export type UpdateFormPageMutationHookResult = ReturnType<typeof useUpdateFormPageMutation>
export type UpdateFormPageMutationResult = Apollo.MutationResult<UpdateFormPageMutation>
export type UpdateFormPageMutationOptions = Apollo.BaseMutationOptions<
  UpdateFormPageMutation,
  UpdateFormPageMutationVariables
>
export const DeleteFormPageDocument = gql`
  mutation deleteFormPage($formPageId: ID!) {
    deleteFormPage(formPageId: $formPageId) {
      id
    }
  }
`
export type DeleteFormPageMutationFn = Apollo.MutationFunction<
  DeleteFormPageMutation,
  DeleteFormPageMutationVariables
>

/**
 * __useDeleteFormPageMutation__
 *
 * To run a mutation, you first call `useDeleteFormPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormPageMutation, { data, loading, error }] = useDeleteFormPageMutation({
 *   variables: {
 *      formPageId: // value for 'formPageId'
 *   },
 * });
 */
export function useDeleteFormPageMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteFormPageMutation, DeleteFormPageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFormPageMutation, DeleteFormPageMutationVariables>(
    DeleteFormPageDocument,
    options,
  )
}
export type DeleteFormPageMutationHookResult = ReturnType<typeof useDeleteFormPageMutation>
export type DeleteFormPageMutationResult = Apollo.MutationResult<DeleteFormPageMutation>
export type DeleteFormPageMutationOptions = Apollo.BaseMutationOptions<
  DeleteFormPageMutation,
  DeleteFormPageMutationVariables
>
export const CreateFormPageDocument = gql`
  mutation createFormPage($input: CreateFormPageInput!) {
    createFormPage(input: $input) {
      id
      name
      order
    }
  }
`
export type CreateFormPageMutationFn = Apollo.MutationFunction<
  CreateFormPageMutation,
  CreateFormPageMutationVariables
>

/**
 * __useCreateFormPageMutation__
 *
 * To run a mutation, you first call `useCreateFormPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormPageMutation, { data, loading, error }] = useCreateFormPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormPageMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateFormPageMutation, CreateFormPageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFormPageMutation, CreateFormPageMutationVariables>(
    CreateFormPageDocument,
    options,
  )
}
export type CreateFormPageMutationHookResult = ReturnType<typeof useCreateFormPageMutation>
export type CreateFormPageMutationResult = Apollo.MutationResult<CreateFormPageMutation>
export type CreateFormPageMutationOptions = Apollo.BaseMutationOptions<
  CreateFormPageMutation,
  CreateFormPageMutationVariables
>
export const ReorderFormPageDocument = gql`
  mutation reorderFormPage($input: ReorderFormPageInput!) {
    reorderFormPage(input: $input) {
      id
      order
    }
  }
`
export type ReorderFormPageMutationFn = Apollo.MutationFunction<
  ReorderFormPageMutation,
  ReorderFormPageMutationVariables
>

/**
 * __useReorderFormPageMutation__
 *
 * To run a mutation, you first call `useReorderFormPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderFormPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderFormPageMutation, { data, loading, error }] = useReorderFormPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderFormPageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderFormPageMutation,
    ReorderFormPageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReorderFormPageMutation, ReorderFormPageMutationVariables>(
    ReorderFormPageDocument,
    options,
  )
}
export type ReorderFormPageMutationHookResult = ReturnType<typeof useReorderFormPageMutation>
export type ReorderFormPageMutationResult = Apollo.MutationResult<ReorderFormPageMutation>
export type ReorderFormPageMutationOptions = Apollo.BaseMutationOptions<
  ReorderFormPageMutation,
  ReorderFormPageMutationVariables
>
export const UpdateFormCategoryDocument = gql`
  mutation updateFormCategory($input: UpdateFormCategoryInput!) {
    updateFormCategory(input: $input) {
      id
      name
      order
      isArray
      lookupTable {
        id
        name
        icon {
          id
          name
        }
      }
    }
  }
`
export type UpdateFormCategoryMutationFn = Apollo.MutationFunction<
  UpdateFormCategoryMutation,
  UpdateFormCategoryMutationVariables
>

/**
 * __useUpdateFormCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateFormCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormCategoryMutation, { data, loading, error }] = useUpdateFormCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFormCategoryMutation,
    UpdateFormCategoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateFormCategoryMutation, UpdateFormCategoryMutationVariables>(
    UpdateFormCategoryDocument,
    options,
  )
}
export type UpdateFormCategoryMutationHookResult = ReturnType<typeof useUpdateFormCategoryMutation>
export type UpdateFormCategoryMutationResult = Apollo.MutationResult<UpdateFormCategoryMutation>
export type UpdateFormCategoryMutationOptions = Apollo.BaseMutationOptions<
  UpdateFormCategoryMutation,
  UpdateFormCategoryMutationVariables
>
export const DeleteFormCategoryDocument = gql`
  mutation deleteFormCategory($formCategoryId: ID!) {
    deleteFormCategory(formCategoryId: $formCategoryId) {
      id
    }
  }
`
export type DeleteFormCategoryMutationFn = Apollo.MutationFunction<
  DeleteFormCategoryMutation,
  DeleteFormCategoryMutationVariables
>

/**
 * __useDeleteFormCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteFormCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormCategoryMutation, { data, loading, error }] = useDeleteFormCategoryMutation({
 *   variables: {
 *      formCategoryId: // value for 'formCategoryId'
 *   },
 * });
 */
export function useDeleteFormCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFormCategoryMutation,
    DeleteFormCategoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFormCategoryMutation, DeleteFormCategoryMutationVariables>(
    DeleteFormCategoryDocument,
    options,
  )
}
export type DeleteFormCategoryMutationHookResult = ReturnType<typeof useDeleteFormCategoryMutation>
export type DeleteFormCategoryMutationResult = Apollo.MutationResult<DeleteFormCategoryMutation>
export type DeleteFormCategoryMutationOptions = Apollo.BaseMutationOptions<
  DeleteFormCategoryMutation,
  DeleteFormCategoryMutationVariables
>
export const CreateFormCategoryDocument = gql`
  mutation createFormCategory($input: CreateFormCategoryInput!) {
    createFormCategory(input: $input) {
      id
      name
      order
      isArray
      lookupTable {
        id
        name
        icon {
          id
          name
        }
      }
    }
  }
`
export type CreateFormCategoryMutationFn = Apollo.MutationFunction<
  CreateFormCategoryMutation,
  CreateFormCategoryMutationVariables
>

/**
 * __useCreateFormCategoryMutation__
 *
 * To run a mutation, you first call `useCreateFormCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormCategoryMutation, { data, loading, error }] = useCreateFormCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFormCategoryMutation,
    CreateFormCategoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFormCategoryMutation, CreateFormCategoryMutationVariables>(
    CreateFormCategoryDocument,
    options,
  )
}
export type CreateFormCategoryMutationHookResult = ReturnType<typeof useCreateFormCategoryMutation>
export type CreateFormCategoryMutationResult = Apollo.MutationResult<CreateFormCategoryMutation>
export type CreateFormCategoryMutationOptions = Apollo.BaseMutationOptions<
  CreateFormCategoryMutation,
  CreateFormCategoryMutationVariables
>
export const ReorderFormCategoryDocument = gql`
  mutation reorderFormCategory($input: ReorderFormCategoryInput!) {
    reorderFormCategory(input: $input) {
      id
      order
    }
  }
`
export type ReorderFormCategoryMutationFn = Apollo.MutationFunction<
  ReorderFormCategoryMutation,
  ReorderFormCategoryMutationVariables
>

/**
 * __useReorderFormCategoryMutation__
 *
 * To run a mutation, you first call `useReorderFormCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderFormCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderFormCategoryMutation, { data, loading, error }] = useReorderFormCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderFormCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderFormCategoryMutation,
    ReorderFormCategoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReorderFormCategoryMutation, ReorderFormCategoryMutationVariables>(
    ReorderFormCategoryDocument,
    options,
  )
}
export type ReorderFormCategoryMutationHookResult = ReturnType<
  typeof useReorderFormCategoryMutation
>
export type ReorderFormCategoryMutationResult = Apollo.MutationResult<ReorderFormCategoryMutation>
export type ReorderFormCategoryMutationOptions = Apollo.BaseMutationOptions<
  ReorderFormCategoryMutation,
  ReorderFormCategoryMutationVariables
>
export const UpdateFormFieldDocument = gql`
  mutation updateFormField($input: UpdateFormFieldInput!) {
    updateFormField(input: $input) {
      id
      name
      description
      type
      order
      isRequired
      isEditable
      isVisible
      isArray
      isFrozen
      defaultValue
      fieldOptions
      lookupColumn {
        id
        name
        type
        innerType
      }
      lookupFilterExpression {
        id
      }
      metadata
    }
  }
`
export type UpdateFormFieldMutationFn = Apollo.MutationFunction<
  UpdateFormFieldMutation,
  UpdateFormFieldMutationVariables
>

/**
 * __useUpdateFormFieldMutation__
 *
 * To run a mutation, you first call `useUpdateFormFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormFieldMutation, { data, loading, error }] = useUpdateFormFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFormFieldMutation,
    UpdateFormFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateFormFieldMutation, UpdateFormFieldMutationVariables>(
    UpdateFormFieldDocument,
    options,
  )
}
export type UpdateFormFieldMutationHookResult = ReturnType<typeof useUpdateFormFieldMutation>
export type UpdateFormFieldMutationResult = Apollo.MutationResult<UpdateFormFieldMutation>
export type UpdateFormFieldMutationOptions = Apollo.BaseMutationOptions<
  UpdateFormFieldMutation,
  UpdateFormFieldMutationVariables
>
export const DeleteFormFieldDocument = gql`
  mutation deleteFormField($formFieldId: ID!) {
    deleteFormField(formFieldId: $formFieldId) {
      id
    }
  }
`
export type DeleteFormFieldMutationFn = Apollo.MutationFunction<
  DeleteFormFieldMutation,
  DeleteFormFieldMutationVariables
>

/**
 * __useDeleteFormFieldMutation__
 *
 * To run a mutation, you first call `useDeleteFormFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormFieldMutation, { data, loading, error }] = useDeleteFormFieldMutation({
 *   variables: {
 *      formFieldId: // value for 'formFieldId'
 *   },
 * });
 */
export function useDeleteFormFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFormFieldMutation,
    DeleteFormFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFormFieldMutation, DeleteFormFieldMutationVariables>(
    DeleteFormFieldDocument,
    options,
  )
}
export type DeleteFormFieldMutationHookResult = ReturnType<typeof useDeleteFormFieldMutation>
export type DeleteFormFieldMutationResult = Apollo.MutationResult<DeleteFormFieldMutation>
export type DeleteFormFieldMutationOptions = Apollo.BaseMutationOptions<
  DeleteFormFieldMutation,
  DeleteFormFieldMutationVariables
>
export const CreateFormFieldDocument = gql`
  mutation createFormField($input: CreateFormFieldInput!) {
    createFormField(input: $input) {
      id
      name
      type
      description
      order
      defaultValue
      isEditable
      isRequired
      isVisible
      isArray
      isFrozen
      lookupColumn {
        id
        name
        type
        innerType
        table {
          id
          name
        }
      }
      fieldOptions
    }
  }
`
export type CreateFormFieldMutationFn = Apollo.MutationFunction<
  CreateFormFieldMutation,
  CreateFormFieldMutationVariables
>

/**
 * __useCreateFormFieldMutation__
 *
 * To run a mutation, you first call `useCreateFormFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormFieldMutation, { data, loading, error }] = useCreateFormFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFormFieldMutation,
    CreateFormFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFormFieldMutation, CreateFormFieldMutationVariables>(
    CreateFormFieldDocument,
    options,
  )
}
export type CreateFormFieldMutationHookResult = ReturnType<typeof useCreateFormFieldMutation>
export type CreateFormFieldMutationResult = Apollo.MutationResult<CreateFormFieldMutation>
export type CreateFormFieldMutationOptions = Apollo.BaseMutationOptions<
  CreateFormFieldMutation,
  CreateFormFieldMutationVariables
>
export const ReorderFormFieldDocument = gql`
  mutation reorderFormField($input: ReorderFormFieldInput!) {
    reorderFormField(input: $input) {
      id
      order
    }
  }
`
export type ReorderFormFieldMutationFn = Apollo.MutationFunction<
  ReorderFormFieldMutation,
  ReorderFormFieldMutationVariables
>

/**
 * __useReorderFormFieldMutation__
 *
 * To run a mutation, you first call `useReorderFormFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderFormFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderFormFieldMutation, { data, loading, error }] = useReorderFormFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderFormFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderFormFieldMutation,
    ReorderFormFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReorderFormFieldMutation, ReorderFormFieldMutationVariables>(
    ReorderFormFieldDocument,
    options,
  )
}
export type ReorderFormFieldMutationHookResult = ReturnType<typeof useReorderFormFieldMutation>
export type ReorderFormFieldMutationResult = Apollo.MutationResult<ReorderFormFieldMutation>
export type ReorderFormFieldMutationOptions = Apollo.BaseMutationOptions<
  ReorderFormFieldMutation,
  ReorderFormFieldMutationVariables
>
export const GetFormBlockDocument = gql`
  query getFormBlock($formBlockId: ID!) {
    formBlock(formBlockId: $formBlockId) {
      ...DetailedFormBlock
      parentBlock {
        ...LeanFormBlock
      }
      childBlocks {
        ...LeanFormBlock
      }
      form {
        id
        name
      }
    }
  }
  ${DetailedFormBlockFragmentDoc}
  ${LeanFormBlockFragmentDoc}
`

/**
 * __useGetFormBlockQuery__
 *
 * To run a query within a React component, call `useGetFormBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormBlockQuery({
 *   variables: {
 *      formBlockId: // value for 'formBlockId'
 *   },
 * });
 */
export function useGetFormBlockQuery(
  baseOptions: Apollo.QueryHookOptions<GetFormBlockQuery, GetFormBlockQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormBlockQuery, GetFormBlockQueryVariables>(
    GetFormBlockDocument,
    options,
  )
}
export function useGetFormBlockLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFormBlockQuery, GetFormBlockQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormBlockQuery, GetFormBlockQueryVariables>(
    GetFormBlockDocument,
    options,
  )
}
export type GetFormBlockQueryHookResult = ReturnType<typeof useGetFormBlockQuery>
export type GetFormBlockLazyQueryHookResult = ReturnType<typeof useGetFormBlockLazyQuery>
export type GetFormBlockQueryResult = Apollo.QueryResult<
  GetFormBlockQuery,
  GetFormBlockQueryVariables
>
export const GetFormV2Document = gql`
  query getFormV2($formId: ID!, $variantId: ID) {
    formV2(formId: $formId, variantId: $variantId) {
      id
      name
      slug
      organization {
        id
      }
      redirectTarget
      redirectCustomPath
      blocks {
        ...DetailedFormBlock
        parentBlock {
          ...LeanFormBlock
        }
        childBlocks {
          ...DetailedFormBlock
        }
      }
      buttons {
        id
        name
        parentWorkspace {
          id
          name
          parentOrganization {
            id
          }
          table {
            id
            name
          }
          tableRow {
            id
            name
            table {
              id
              name
            }
          }
          document {
            id
            name
          }
          chart {
            id
            name
          }
        }
        buttonNode {
          id
          name
          table {
            id
            name
          }
        }
      }
      lookupInputGroups {
        id
        isAutoFill
        lookupTable {
          id
          name
          isShareable
          icon {
            id
            name
          }
        }
        lookupFilterExpression {
          id
          logicExpressionString
        }
        defaultRows {
          id
        }
        formInputs {
          id
          label
        }
      }
      visibilityConditions {
        id
        name
        slug
        expression {
          id
          logicExpressionString
        }
        controlledFormBlocks {
          id
          type
          input {
            id
            label
          }
          inputGroup {
            id
            label
          }
          metadata
        }
      }
      sourceForm {
        id
        name
      }
    }
  }
  ${DetailedFormBlockFragmentDoc}
  ${LeanFormBlockFragmentDoc}
`

/**
 * __useGetFormV2Query__
 *
 * To run a query within a React component, call `useGetFormV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetFormV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormV2Query({
 *   variables: {
 *      formId: // value for 'formId'
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useGetFormV2Query(
  baseOptions: Apollo.QueryHookOptions<GetFormV2Query, GetFormV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormV2Query, GetFormV2QueryVariables>(GetFormV2Document, options)
}
export function useGetFormV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFormV2Query, GetFormV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormV2Query, GetFormV2QueryVariables>(GetFormV2Document, options)
}
export type GetFormV2QueryHookResult = ReturnType<typeof useGetFormV2Query>
export type GetFormV2LazyQueryHookResult = ReturnType<typeof useGetFormV2LazyQuery>
export type GetFormV2QueryResult = Apollo.QueryResult<GetFormV2Query, GetFormV2QueryVariables>
export const GetFormV2ForSettingsPageDocument = gql`
  query getFormV2ForSettingsPage($formId: ID!, $variantId: ID) {
    formV2(formId: $formId, variantId: $variantId) {
      id
      name
      slug
      organization {
        id
      }
      redirectTarget
      redirectCustomPath
      blocks {
        ...DetailedFormBlock
        parentBlock {
          ...LeanFormBlock
        }
        childBlocks {
          ...DetailedFormBlock
        }
      }
      buttons {
        id
        name
        parentWorkspace {
          id
          name
          parentOrganization {
            id
          }
          table {
            id
            name
          }
          tableRow {
            id
            name
            table {
              id
              name
            }
          }
          document {
            id
            name
          }
          chart {
            id
            name
          }
        }
        buttonNode {
          id
          name
          table {
            id
            name
          }
        }
      }
      lookupInputGroups {
        id
        isAutoFill
        lookupTable {
          id
          name
          isShareable
          icon {
            id
            name
          }
          formLookupInputGroups {
            id
            form {
              id
              permissions {
                id
                permissionType
                role {
                  id
                  roleType
                }
              }
            }
          }
          lookupFormCategories {
            id
            name
            page {
              id
              form {
                id
                isShareable
              }
            }
          }
        }
        lookupFilterExpression {
          id
          logicExpressionString
        }
        defaultRows {
          id
        }
        formInputs {
          id
          label
        }
      }
      sourceForm {
        id
        name
      }
      visibilityConditions {
        id
        name
        slug
        expression {
          id
          logicExpressionString
        }
        controlledFormBlocks {
          id
          type
          input {
            id
            label
          }
          inputGroup {
            id
            label
          }
          metadata
        }
      }
      permissions {
        id
        permissionType
        role {
          id
          roleType
        }
      }
    }
  }
  ${DetailedFormBlockFragmentDoc}
  ${LeanFormBlockFragmentDoc}
`

/**
 * __useGetFormV2ForSettingsPageQuery__
 *
 * To run a query within a React component, call `useGetFormV2ForSettingsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormV2ForSettingsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormV2ForSettingsPageQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useGetFormV2ForSettingsPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFormV2ForSettingsPageQuery,
    GetFormV2ForSettingsPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormV2ForSettingsPageQuery, GetFormV2ForSettingsPageQueryVariables>(
    GetFormV2ForSettingsPageDocument,
    options,
  )
}
export function useGetFormV2ForSettingsPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormV2ForSettingsPageQuery,
    GetFormV2ForSettingsPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormV2ForSettingsPageQuery, GetFormV2ForSettingsPageQueryVariables>(
    GetFormV2ForSettingsPageDocument,
    options,
  )
}
export type GetFormV2ForSettingsPageQueryHookResult = ReturnType<
  typeof useGetFormV2ForSettingsPageQuery
>
export type GetFormV2ForSettingsPageLazyQueryHookResult = ReturnType<
  typeof useGetFormV2ForSettingsPageLazyQuery
>
export type GetFormV2ForSettingsPageQueryResult = Apollo.QueryResult<
  GetFormV2ForSettingsPageQuery,
  GetFormV2ForSettingsPageQueryVariables
>
export const GetFormV2SharedDocument = gql`
  query getFormV2Shared($formId: ID!, $variantId: ID) {
    formV2(formId: $formId, variantId: $variantId) {
      id
      name
      slug
      organization {
        id
      }
      redirectTarget
      redirectCustomPath
      blocks {
        ...DetailedFormBlock
        parentBlock {
          ...LeanFormBlock
        }
        childBlocks {
          ...DetailedFormBlock
        }
      }
      buttons {
        id
        name
        parentWorkspace {
          id
          name
          parentOrganization {
            id
          }
          table {
            id
            name
          }
          tableRow {
            id
            name
            table {
              id
              name
            }
          }
          document {
            id
            name
          }
          chart {
            id
            name
          }
        }
        buttonNode {
          id
          name
          table {
            id
            name
          }
        }
      }
      lookupInputGroups {
        id
        isAutoFill
        lookupTable {
          id
          name
          icon {
            id
            name
          }
        }
        lookupFilterExpression {
          id
          logicExpressionString
        }
        defaultRows {
          id
        }
        formInputs {
          id
          label
        }
      }
      visibilityConditions {
        id
        name
        expression {
          logicExpressionString
        }
      }
    }
  }
  ${DetailedFormBlockFragmentDoc}
  ${LeanFormBlockFragmentDoc}
`

/**
 * __useGetFormV2SharedQuery__
 *
 * To run a query within a React component, call `useGetFormV2SharedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormV2SharedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormV2SharedQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useGetFormV2SharedQuery(
  baseOptions: Apollo.QueryHookOptions<GetFormV2SharedQuery, GetFormV2SharedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormV2SharedQuery, GetFormV2SharedQueryVariables>(
    GetFormV2SharedDocument,
    options,
  )
}
export function useGetFormV2SharedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFormV2SharedQuery, GetFormV2SharedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormV2SharedQuery, GetFormV2SharedQueryVariables>(
    GetFormV2SharedDocument,
    options,
  )
}
export type GetFormV2SharedQueryHookResult = ReturnType<typeof useGetFormV2SharedQuery>
export type GetFormV2SharedLazyQueryHookResult = ReturnType<typeof useGetFormV2SharedLazyQuery>
export type GetFormV2SharedQueryResult = Apollo.QueryResult<
  GetFormV2SharedQuery,
  GetFormV2SharedQueryVariables
>
export const GetAllFormsV2Document = gql`
  query getAllFormsV2 {
    allFormsV2 {
      id
      name
      inputs {
        id
        label
      }
      workflows {
        id
        name
      }
      isShareable
    }
  }
`

/**
 * __useGetAllFormsV2Query__
 *
 * To run a query within a React component, call `useGetAllFormsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFormsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFormsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetAllFormsV2Query(
  baseOptions?: Apollo.QueryHookOptions<GetAllFormsV2Query, GetAllFormsV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAllFormsV2Query, GetAllFormsV2QueryVariables>(
    GetAllFormsV2Document,
    options,
  )
}
export function useGetAllFormsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAllFormsV2Query, GetAllFormsV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAllFormsV2Query, GetAllFormsV2QueryVariables>(
    GetAllFormsV2Document,
    options,
  )
}
export type GetAllFormsV2QueryHookResult = ReturnType<typeof useGetAllFormsV2Query>
export type GetAllFormsV2LazyQueryHookResult = ReturnType<typeof useGetAllFormsV2LazyQuery>
export type GetAllFormsV2QueryResult = Apollo.QueryResult<
  GetAllFormsV2Query,
  GetAllFormsV2QueryVariables
>
export const CreateFormV2Document = gql`
  mutation createFormV2 {
    createFormV2 {
      id
      name
      blocks {
        id
        type
        metadata
      }
    }
  }
`
export type CreateFormV2MutationFn = Apollo.MutationFunction<
  CreateFormV2Mutation,
  CreateFormV2MutationVariables
>

/**
 * __useCreateFormV2Mutation__
 *
 * To run a mutation, you first call `useCreateFormV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormV2Mutation, { data, loading, error }] = useCreateFormV2Mutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateFormV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<CreateFormV2Mutation, CreateFormV2MutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFormV2Mutation, CreateFormV2MutationVariables>(
    CreateFormV2Document,
    options,
  )
}
export type CreateFormV2MutationHookResult = ReturnType<typeof useCreateFormV2Mutation>
export type CreateFormV2MutationResult = Apollo.MutationResult<CreateFormV2Mutation>
export type CreateFormV2MutationOptions = Apollo.BaseMutationOptions<
  CreateFormV2Mutation,
  CreateFormV2MutationVariables
>
export const CreateFormInputBlockDocument = gql`
  mutation createFormInputBlock($input: CreateFormInputBlockInput!) {
    createFormInputBlock(input: $input) {
      ...DetailedFormBlock
      form {
        id
        name
      }
    }
  }
  ${DetailedFormBlockFragmentDoc}
`
export type CreateFormInputBlockMutationFn = Apollo.MutationFunction<
  CreateFormInputBlockMutation,
  CreateFormInputBlockMutationVariables
>

/**
 * __useCreateFormInputBlockMutation__
 *
 * To run a mutation, you first call `useCreateFormInputBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormInputBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormInputBlockMutation, { data, loading, error }] = useCreateFormInputBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormInputBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFormInputBlockMutation,
    CreateFormInputBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFormInputBlockMutation, CreateFormInputBlockMutationVariables>(
    CreateFormInputBlockDocument,
    options,
  )
}
export type CreateFormInputBlockMutationHookResult = ReturnType<
  typeof useCreateFormInputBlockMutation
>
export type CreateFormInputBlockMutationResult = Apollo.MutationResult<CreateFormInputBlockMutation>
export type CreateFormInputBlockMutationOptions = Apollo.BaseMutationOptions<
  CreateFormInputBlockMutation,
  CreateFormInputBlockMutationVariables
>
export const UpdateFormInputBlockDocument = gql`
  mutation updateFormInputBlock($input: UpdateFormInputBlockInput!) {
    updateFormInputBlock(input: $input) {
      ...DetailedFormBlock
      form {
        id
        name
      }
    }
  }
  ${DetailedFormBlockFragmentDoc}
`
export type UpdateFormInputBlockMutationFn = Apollo.MutationFunction<
  UpdateFormInputBlockMutation,
  UpdateFormInputBlockMutationVariables
>

/**
 * __useUpdateFormInputBlockMutation__
 *
 * To run a mutation, you first call `useUpdateFormInputBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormInputBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormInputBlockMutation, { data, loading, error }] = useUpdateFormInputBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormInputBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFormInputBlockMutation,
    UpdateFormInputBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateFormInputBlockMutation, UpdateFormInputBlockMutationVariables>(
    UpdateFormInputBlockDocument,
    options,
  )
}
export type UpdateFormInputBlockMutationHookResult = ReturnType<
  typeof useUpdateFormInputBlockMutation
>
export type UpdateFormInputBlockMutationResult = Apollo.MutationResult<UpdateFormInputBlockMutation>
export type UpdateFormInputBlockMutationOptions = Apollo.BaseMutationOptions<
  UpdateFormInputBlockMutation,
  UpdateFormInputBlockMutationVariables
>
export const ReorderFormBlockDocument = gql`
  mutation reorderFormBlock($input: ReorderFormBlockInput!) {
    reorderFormBlock(input: $input) {
      ...LeanFormBlock
      form {
        id
        name
      }
    }
  }
  ${LeanFormBlockFragmentDoc}
`
export type ReorderFormBlockMutationFn = Apollo.MutationFunction<
  ReorderFormBlockMutation,
  ReorderFormBlockMutationVariables
>

/**
 * __useReorderFormBlockMutation__
 *
 * To run a mutation, you first call `useReorderFormBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderFormBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderFormBlockMutation, { data, loading, error }] = useReorderFormBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderFormBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderFormBlockMutation,
    ReorderFormBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReorderFormBlockMutation, ReorderFormBlockMutationVariables>(
    ReorderFormBlockDocument,
    options,
  )
}
export type ReorderFormBlockMutationHookResult = ReturnType<typeof useReorderFormBlockMutation>
export type ReorderFormBlockMutationResult = Apollo.MutationResult<ReorderFormBlockMutation>
export type ReorderFormBlockMutationOptions = Apollo.BaseMutationOptions<
  ReorderFormBlockMutation,
  ReorderFormBlockMutationVariables
>
export const CreateFormLayoutBlockDocument = gql`
  mutation createFormLayoutBlock($input: CreateFormLayoutBlockInput!) {
    createFormLayoutBlock(input: $input) {
      ...DetailedFormBlock
      form {
        id
        name
      }
    }
  }
  ${DetailedFormBlockFragmentDoc}
`
export type CreateFormLayoutBlockMutationFn = Apollo.MutationFunction<
  CreateFormLayoutBlockMutation,
  CreateFormLayoutBlockMutationVariables
>

/**
 * __useCreateFormLayoutBlockMutation__
 *
 * To run a mutation, you first call `useCreateFormLayoutBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormLayoutBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormLayoutBlockMutation, { data, loading, error }] = useCreateFormLayoutBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormLayoutBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFormLayoutBlockMutation,
    CreateFormLayoutBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFormLayoutBlockMutation, CreateFormLayoutBlockMutationVariables>(
    CreateFormLayoutBlockDocument,
    options,
  )
}
export type CreateFormLayoutBlockMutationHookResult = ReturnType<
  typeof useCreateFormLayoutBlockMutation
>
export type CreateFormLayoutBlockMutationResult =
  Apollo.MutationResult<CreateFormLayoutBlockMutation>
export type CreateFormLayoutBlockMutationOptions = Apollo.BaseMutationOptions<
  CreateFormLayoutBlockMutation,
  CreateFormLayoutBlockMutationVariables
>
export const UpdateFormLayoutBlockDocument = gql`
  mutation updateFormLayoutBlock($input: UpdateFormLayoutBlockInput!) {
    updateFormLayoutBlock(input: $input) {
      ...DetailedFormBlock
      form {
        id
        name
      }
    }
  }
  ${DetailedFormBlockFragmentDoc}
`
export type UpdateFormLayoutBlockMutationFn = Apollo.MutationFunction<
  UpdateFormLayoutBlockMutation,
  UpdateFormLayoutBlockMutationVariables
>

/**
 * __useUpdateFormLayoutBlockMutation__
 *
 * To run a mutation, you first call `useUpdateFormLayoutBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormLayoutBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormLayoutBlockMutation, { data, loading, error }] = useUpdateFormLayoutBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormLayoutBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFormLayoutBlockMutation,
    UpdateFormLayoutBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateFormLayoutBlockMutation, UpdateFormLayoutBlockMutationVariables>(
    UpdateFormLayoutBlockDocument,
    options,
  )
}
export type UpdateFormLayoutBlockMutationHookResult = ReturnType<
  typeof useUpdateFormLayoutBlockMutation
>
export type UpdateFormLayoutBlockMutationResult =
  Apollo.MutationResult<UpdateFormLayoutBlockMutation>
export type UpdateFormLayoutBlockMutationOptions = Apollo.BaseMutationOptions<
  UpdateFormLayoutBlockMutation,
  UpdateFormLayoutBlockMutationVariables
>
export const CreateFormTableBlockDocument = gql`
  mutation createFormTableBlock($input: CreateFormTableBlockInput!) {
    createFormTableBlock(input: $input) {
      ...DetailedFormBlock
      form {
        id
        name
      }
    }
  }
  ${DetailedFormBlockFragmentDoc}
`
export type CreateFormTableBlockMutationFn = Apollo.MutationFunction<
  CreateFormTableBlockMutation,
  CreateFormTableBlockMutationVariables
>

/**
 * __useCreateFormTableBlockMutation__
 *
 * To run a mutation, you first call `useCreateFormTableBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormTableBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormTableBlockMutation, { data, loading, error }] = useCreateFormTableBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormTableBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFormTableBlockMutation,
    CreateFormTableBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFormTableBlockMutation, CreateFormTableBlockMutationVariables>(
    CreateFormTableBlockDocument,
    options,
  )
}
export type CreateFormTableBlockMutationHookResult = ReturnType<
  typeof useCreateFormTableBlockMutation
>
export type CreateFormTableBlockMutationResult = Apollo.MutationResult<CreateFormTableBlockMutation>
export type CreateFormTableBlockMutationOptions = Apollo.BaseMutationOptions<
  CreateFormTableBlockMutation,
  CreateFormTableBlockMutationVariables
>
export const UpdateFormTableBlockDocument = gql`
  mutation updateFormTableBlock($input: UpdateFormTableBlockInput!) {
    updateFormTableBlock(input: $input) {
      ...DetailedFormBlock
      form {
        id
        name
      }
    }
  }
  ${DetailedFormBlockFragmentDoc}
`
export type UpdateFormTableBlockMutationFn = Apollo.MutationFunction<
  UpdateFormTableBlockMutation,
  UpdateFormTableBlockMutationVariables
>

/**
 * __useUpdateFormTableBlockMutation__
 *
 * To run a mutation, you first call `useUpdateFormTableBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormTableBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormTableBlockMutation, { data, loading, error }] = useUpdateFormTableBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormTableBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFormTableBlockMutation,
    UpdateFormTableBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateFormTableBlockMutation, UpdateFormTableBlockMutationVariables>(
    UpdateFormTableBlockDocument,
    options,
  )
}
export type UpdateFormTableBlockMutationHookResult = ReturnType<
  typeof useUpdateFormTableBlockMutation
>
export type UpdateFormTableBlockMutationResult = Apollo.MutationResult<UpdateFormTableBlockMutation>
export type UpdateFormTableBlockMutationOptions = Apollo.BaseMutationOptions<
  UpdateFormTableBlockMutation,
  UpdateFormTableBlockMutationVariables
>
export const DeleteFormV2Document = gql`
  mutation deleteFormV2($formId: ID!) {
    deleteFormV2(formId: $formId) {
      id
      name
    }
  }
`
export type DeleteFormV2MutationFn = Apollo.MutationFunction<
  DeleteFormV2Mutation,
  DeleteFormV2MutationVariables
>

/**
 * __useDeleteFormV2Mutation__
 *
 * To run a mutation, you first call `useDeleteFormV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormV2Mutation, { data, loading, error }] = useDeleteFormV2Mutation({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useDeleteFormV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteFormV2Mutation, DeleteFormV2MutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFormV2Mutation, DeleteFormV2MutationVariables>(
    DeleteFormV2Document,
    options,
  )
}
export type DeleteFormV2MutationHookResult = ReturnType<typeof useDeleteFormV2Mutation>
export type DeleteFormV2MutationResult = Apollo.MutationResult<DeleteFormV2Mutation>
export type DeleteFormV2MutationOptions = Apollo.BaseMutationOptions<
  DeleteFormV2Mutation,
  DeleteFormV2MutationVariables
>
export const DeleteFormBlockDocument = gql`
  mutation deleteFormBlock($formBlockId: ID!) {
    deleteFormBlock(formBlockId: $formBlockId) {
      id
    }
  }
`
export type DeleteFormBlockMutationFn = Apollo.MutationFunction<
  DeleteFormBlockMutation,
  DeleteFormBlockMutationVariables
>

/**
 * __useDeleteFormBlockMutation__
 *
 * To run a mutation, you first call `useDeleteFormBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormBlockMutation, { data, loading, error }] = useDeleteFormBlockMutation({
 *   variables: {
 *      formBlockId: // value for 'formBlockId'
 *   },
 * });
 */
export function useDeleteFormBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFormBlockMutation,
    DeleteFormBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFormBlockMutation, DeleteFormBlockMutationVariables>(
    DeleteFormBlockDocument,
    options,
  )
}
export type DeleteFormBlockMutationHookResult = ReturnType<typeof useDeleteFormBlockMutation>
export type DeleteFormBlockMutationResult = Apollo.MutationResult<DeleteFormBlockMutation>
export type DeleteFormBlockMutationOptions = Apollo.BaseMutationOptions<
  DeleteFormBlockMutation,
  DeleteFormBlockMutationVariables
>
export const CreateFormRowBlockDocument = gql`
  mutation createFormRowBlock($input: CreateFormRowBlockInput!) {
    createFormRowBlock(input: $input) {
      ...DetailedFormBlock
      form {
        id
        name
      }
    }
  }
  ${DetailedFormBlockFragmentDoc}
`
export type CreateFormRowBlockMutationFn = Apollo.MutationFunction<
  CreateFormRowBlockMutation,
  CreateFormRowBlockMutationVariables
>

/**
 * __useCreateFormRowBlockMutation__
 *
 * To run a mutation, you first call `useCreateFormRowBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormRowBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormRowBlockMutation, { data, loading, error }] = useCreateFormRowBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormRowBlockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFormRowBlockMutation,
    CreateFormRowBlockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFormRowBlockMutation, CreateFormRowBlockMutationVariables>(
    CreateFormRowBlockDocument,
    options,
  )
}
export type CreateFormRowBlockMutationHookResult = ReturnType<typeof useCreateFormRowBlockMutation>
export type CreateFormRowBlockMutationResult = Apollo.MutationResult<CreateFormRowBlockMutation>
export type CreateFormRowBlockMutationOptions = Apollo.BaseMutationOptions<
  CreateFormRowBlockMutation,
  CreateFormRowBlockMutationVariables
>
export const GetTablesForFormColumnLinkDocument = gql`
  query getTablesForFormColumnLink {
    tables {
      id
      name
      icon {
        id
        name
      }
      columns {
        id
        name
        description
        order
        type
        innerType
        isNullable
        isReadOnly
        isDecimal
        enumOptions
        formatPreset
        formatOptions
        lookupColumn {
          id
          name
          type
          table {
            id
            name
          }
        }
        lookupColumnGroup {
          id
          lookupTable {
            id
            name
          }
        }
        ...EnumSetFields
      }
    }
  }
  ${EnumSetFieldsFragmentDoc}
`

/**
 * __useGetTablesForFormColumnLinkQuery__
 *
 * To run a query within a React component, call `useGetTablesForFormColumnLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTablesForFormColumnLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTablesForFormColumnLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTablesForFormColumnLinkQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTablesForFormColumnLinkQuery,
    GetTablesForFormColumnLinkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTablesForFormColumnLinkQuery, GetTablesForFormColumnLinkQueryVariables>(
    GetTablesForFormColumnLinkDocument,
    options,
  )
}
export function useGetTablesForFormColumnLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTablesForFormColumnLinkQuery,
    GetTablesForFormColumnLinkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetTablesForFormColumnLinkQuery,
    GetTablesForFormColumnLinkQueryVariables
  >(GetTablesForFormColumnLinkDocument, options)
}
export type GetTablesForFormColumnLinkQueryHookResult = ReturnType<
  typeof useGetTablesForFormColumnLinkQuery
>
export type GetTablesForFormColumnLinkLazyQueryHookResult = ReturnType<
  typeof useGetTablesForFormColumnLinkLazyQuery
>
export type GetTablesForFormColumnLinkQueryResult = Apollo.QueryResult<
  GetTablesForFormColumnLinkQuery,
  GetTablesForFormColumnLinkQueryVariables
>
export const GetFormVariantsDocument = gql`
  query getFormVariants($formId: ID!) {
    formVariants(formId: $formId) {
      id
      name
      description
      form {
        id
        name
      }
    }
  }
`

/**
 * __useGetFormVariantsQuery__
 *
 * To run a query within a React component, call `useGetFormVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormVariantsQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetFormVariantsQuery(
  baseOptions: Apollo.QueryHookOptions<GetFormVariantsQuery, GetFormVariantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormVariantsQuery, GetFormVariantsQueryVariables>(
    GetFormVariantsDocument,
    options,
  )
}
export function useGetFormVariantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFormVariantsQuery, GetFormVariantsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormVariantsQuery, GetFormVariantsQueryVariables>(
    GetFormVariantsDocument,
    options,
  )
}
export type GetFormVariantsQueryHookResult = ReturnType<typeof useGetFormVariantsQuery>
export type GetFormVariantsLazyQueryHookResult = ReturnType<typeof useGetFormVariantsLazyQuery>
export type GetFormVariantsQueryResult = Apollo.QueryResult<
  GetFormVariantsQuery,
  GetFormVariantsQueryVariables
>
export const GetFormVariantDocument = gql`
  query getFormVariant($variantId: ID!) {
    formVariant(variantId: $variantId) {
      id
      name
      description
      form {
        id
        name
      }
      variantInputs {
        id
        defaultValue
        isReadOnly
        input {
          id
          label
          inputType
          formBlock {
            id
          }
        }
      }
    }
  }
`

/**
 * __useGetFormVariantQuery__
 *
 * To run a query within a React component, call `useGetFormVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormVariantQuery({
 *   variables: {
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useGetFormVariantQuery(
  baseOptions: Apollo.QueryHookOptions<GetFormVariantQuery, GetFormVariantQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormVariantQuery, GetFormVariantQueryVariables>(
    GetFormVariantDocument,
    options,
  )
}
export function useGetFormVariantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFormVariantQuery, GetFormVariantQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormVariantQuery, GetFormVariantQueryVariables>(
    GetFormVariantDocument,
    options,
  )
}
export type GetFormVariantQueryHookResult = ReturnType<typeof useGetFormVariantQuery>
export type GetFormVariantLazyQueryHookResult = ReturnType<typeof useGetFormVariantLazyQuery>
export type GetFormVariantQueryResult = Apollo.QueryResult<
  GetFormVariantQuery,
  GetFormVariantQueryVariables
>
export const GetVariantsWithInputOverrideDocument = gql`
  query getVariantsWithInputOverride($inputId: ID!) {
    variantsWithInputOverride(inputId: $inputId) {
      id
      name
    }
  }
`

/**
 * __useGetVariantsWithInputOverrideQuery__
 *
 * To run a query within a React component, call `useGetVariantsWithInputOverrideQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVariantsWithInputOverrideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVariantsWithInputOverrideQuery({
 *   variables: {
 *      inputId: // value for 'inputId'
 *   },
 * });
 */
export function useGetVariantsWithInputOverrideQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVariantsWithInputOverrideQuery,
    GetVariantsWithInputOverrideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetVariantsWithInputOverrideQuery,
    GetVariantsWithInputOverrideQueryVariables
  >(GetVariantsWithInputOverrideDocument, options)
}
export function useGetVariantsWithInputOverrideLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVariantsWithInputOverrideQuery,
    GetVariantsWithInputOverrideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetVariantsWithInputOverrideQuery,
    GetVariantsWithInputOverrideQueryVariables
  >(GetVariantsWithInputOverrideDocument, options)
}
export type GetVariantsWithInputOverrideQueryHookResult = ReturnType<
  typeof useGetVariantsWithInputOverrideQuery
>
export type GetVariantsWithInputOverrideLazyQueryHookResult = ReturnType<
  typeof useGetVariantsWithInputOverrideLazyQuery
>
export type GetVariantsWithInputOverrideQueryResult = Apollo.QueryResult<
  GetVariantsWithInputOverrideQuery,
  GetVariantsWithInputOverrideQueryVariables
>
export const CreateFormVariantDocument = gql`
  mutation createFormVariant($input: CreateFormVariantInput!) {
    createFormVariant(input: $input) {
      id
      name
      description
      form {
        id
        name
      }
    }
  }
`
export type CreateFormVariantMutationFn = Apollo.MutationFunction<
  CreateFormVariantMutation,
  CreateFormVariantMutationVariables
>

/**
 * __useCreateFormVariantMutation__
 *
 * To run a mutation, you first call `useCreateFormVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormVariantMutation, { data, loading, error }] = useCreateFormVariantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormVariantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFormVariantMutation,
    CreateFormVariantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFormVariantMutation, CreateFormVariantMutationVariables>(
    CreateFormVariantDocument,
    options,
  )
}
export type CreateFormVariantMutationHookResult = ReturnType<typeof useCreateFormVariantMutation>
export type CreateFormVariantMutationResult = Apollo.MutationResult<CreateFormVariantMutation>
export type CreateFormVariantMutationOptions = Apollo.BaseMutationOptions<
  CreateFormVariantMutation,
  CreateFormVariantMutationVariables
>
export const UpdateFormVariantDocument = gql`
  mutation updateFormVariant($input: UpdateFormVariantInput!) {
    updateFormVariant(input: $input) {
      id
      name
      description
    }
  }
`
export type UpdateFormVariantMutationFn = Apollo.MutationFunction<
  UpdateFormVariantMutation,
  UpdateFormVariantMutationVariables
>

/**
 * __useUpdateFormVariantMutation__
 *
 * To run a mutation, you first call `useUpdateFormVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormVariantMutation, { data, loading, error }] = useUpdateFormVariantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormVariantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFormVariantMutation,
    UpdateFormVariantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateFormVariantMutation, UpdateFormVariantMutationVariables>(
    UpdateFormVariantDocument,
    options,
  )
}
export type UpdateFormVariantMutationHookResult = ReturnType<typeof useUpdateFormVariantMutation>
export type UpdateFormVariantMutationResult = Apollo.MutationResult<UpdateFormVariantMutation>
export type UpdateFormVariantMutationOptions = Apollo.BaseMutationOptions<
  UpdateFormVariantMutation,
  UpdateFormVariantMutationVariables
>
export const DeleteFormVariantDocument = gql`
  mutation deleteFormVariant($variantId: ID!) {
    deleteFormVariant(variantId: $variantId) {
      id
      name
    }
  }
`
export type DeleteFormVariantMutationFn = Apollo.MutationFunction<
  DeleteFormVariantMutation,
  DeleteFormVariantMutationVariables
>

/**
 * __useDeleteFormVariantMutation__
 *
 * To run a mutation, you first call `useDeleteFormVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormVariantMutation, { data, loading, error }] = useDeleteFormVariantMutation({
 *   variables: {
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useDeleteFormVariantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFormVariantMutation,
    DeleteFormVariantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFormVariantMutation, DeleteFormVariantMutationVariables>(
    DeleteFormVariantDocument,
    options,
  )
}
export type DeleteFormVariantMutationHookResult = ReturnType<typeof useDeleteFormVariantMutation>
export type DeleteFormVariantMutationResult = Apollo.MutationResult<DeleteFormVariantMutation>
export type DeleteFormVariantMutationOptions = Apollo.BaseMutationOptions<
  DeleteFormVariantMutation,
  DeleteFormVariantMutationVariables
>
export const UpdateVariantInputValueDocument = gql`
  mutation updateVariantInputValue($input: UpdateVariantInputValueInput!) {
    updateVariantInputValue(input: $input) {
      id
      defaultValue
      isReadOnly
      input {
        id
        label
      }
    }
  }
`
export type UpdateVariantInputValueMutationFn = Apollo.MutationFunction<
  UpdateVariantInputValueMutation,
  UpdateVariantInputValueMutationVariables
>

/**
 * __useUpdateVariantInputValueMutation__
 *
 * To run a mutation, you first call `useUpdateVariantInputValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVariantInputValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVariantInputValueMutation, { data, loading, error }] = useUpdateVariantInputValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVariantInputValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateVariantInputValueMutation,
    UpdateVariantInputValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateVariantInputValueMutation,
    UpdateVariantInputValueMutationVariables
  >(UpdateVariantInputValueDocument, options)
}
export type UpdateVariantInputValueMutationHookResult = ReturnType<
  typeof useUpdateVariantInputValueMutation
>
export type UpdateVariantInputValueMutationResult =
  Apollo.MutationResult<UpdateVariantInputValueMutation>
export type UpdateVariantInputValueMutationOptions = Apollo.BaseMutationOptions<
  UpdateVariantInputValueMutation,
  UpdateVariantInputValueMutationVariables
>
export const DeleteVariantInputValueDocument = gql`
  mutation deleteVariantInputValue($variantId: ID!, $inputId: ID!) {
    deleteVariantInputValue(variantId: $variantId, inputId: $inputId) {
      id
    }
  }
`
export type DeleteVariantInputValueMutationFn = Apollo.MutationFunction<
  DeleteVariantInputValueMutation,
  DeleteVariantInputValueMutationVariables
>

/**
 * __useDeleteVariantInputValueMutation__
 *
 * To run a mutation, you first call `useDeleteVariantInputValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVariantInputValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVariantInputValueMutation, { data, loading, error }] = useDeleteVariantInputValueMutation({
 *   variables: {
 *      variantId: // value for 'variantId'
 *      inputId: // value for 'inputId'
 *   },
 * });
 */
export function useDeleteVariantInputValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteVariantInputValueMutation,
    DeleteVariantInputValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteVariantInputValueMutation,
    DeleteVariantInputValueMutationVariables
  >(DeleteVariantInputValueDocument, options)
}
export type DeleteVariantInputValueMutationHookResult = ReturnType<
  typeof useDeleteVariantInputValueMutation
>
export type DeleteVariantInputValueMutationResult =
  Apollo.MutationResult<DeleteVariantInputValueMutation>
export type DeleteVariantInputValueMutationOptions = Apollo.BaseMutationOptions<
  DeleteVariantInputValueMutation,
  DeleteVariantInputValueMutationVariables
>
export const GetFormInputRelatedActionStepsDocument = gql`
  query getFormInputRelatedActionSteps($input: RelatedEntitiesInput!) {
    relatedActionSteps(input: $input) {
      readSteps {
        id
        name
        type
        status
        rootAction {
          id
          name
          status
          workflow {
            id
            name
          }
        }
      }
      writeSteps {
        id
        name
        type
        status
        rootAction {
          id
          name
          status
          workflow {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useGetFormInputRelatedActionStepsQuery__
 *
 * To run a query within a React component, call `useGetFormInputRelatedActionStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormInputRelatedActionStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormInputRelatedActionStepsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFormInputRelatedActionStepsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFormInputRelatedActionStepsQuery,
    GetFormInputRelatedActionStepsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetFormInputRelatedActionStepsQuery,
    GetFormInputRelatedActionStepsQueryVariables
  >(GetFormInputRelatedActionStepsDocument, options)
}
export function useGetFormInputRelatedActionStepsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormInputRelatedActionStepsQuery,
    GetFormInputRelatedActionStepsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetFormInputRelatedActionStepsQuery,
    GetFormInputRelatedActionStepsQueryVariables
  >(GetFormInputRelatedActionStepsDocument, options)
}
export type GetFormInputRelatedActionStepsQueryHookResult = ReturnType<
  typeof useGetFormInputRelatedActionStepsQuery
>
export type GetFormInputRelatedActionStepsLazyQueryHookResult = ReturnType<
  typeof useGetFormInputRelatedActionStepsLazyQuery
>
export type GetFormInputRelatedActionStepsQueryResult = Apollo.QueryResult<
  GetFormInputRelatedActionStepsQuery,
  GetFormInputRelatedActionStepsQueryVariables
>
export const SubmitFormV2Document = gql`
  mutation submitFormV2($input: SubmitFormV2Input!) {
    submitFormV2(input: $input) {
      id
      name
      redirectTarget
      redirectCustomPath
    }
  }
`
export type SubmitFormV2MutationFn = Apollo.MutationFunction<
  SubmitFormV2Mutation,
  SubmitFormV2MutationVariables
>

/**
 * __useSubmitFormV2Mutation__
 *
 * To run a mutation, you first call `useSubmitFormV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormV2Mutation, { data, loading, error }] = useSubmitFormV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitFormV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<SubmitFormV2Mutation, SubmitFormV2MutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SubmitFormV2Mutation, SubmitFormV2MutationVariables>(
    SubmitFormV2Document,
    options,
  )
}
export type SubmitFormV2MutationHookResult = ReturnType<typeof useSubmitFormV2Mutation>
export type SubmitFormV2MutationResult = Apollo.MutationResult<SubmitFormV2Mutation>
export type SubmitFormV2MutationOptions = Apollo.BaseMutationOptions<
  SubmitFormV2Mutation,
  SubmitFormV2MutationVariables
>
export const FormV2FilesDocument = gql`
  query formV2Files($formV2Id: ID!) {
    formV2Files(formV2Id: $formV2Id) {
      type
      name
      mappings {
        formInputId
        fileFieldId
      }
    }
  }
`

/**
 * __useFormV2FilesQuery__
 *
 * To run a query within a React component, call `useFormV2FilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormV2FilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormV2FilesQuery({
 *   variables: {
 *      formV2Id: // value for 'formV2Id'
 *   },
 * });
 */
export function useFormV2FilesQuery(
  baseOptions: Apollo.QueryHookOptions<FormV2FilesQuery, FormV2FilesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FormV2FilesQuery, FormV2FilesQueryVariables>(FormV2FilesDocument, options)
}
export function useFormV2FilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FormV2FilesQuery, FormV2FilesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FormV2FilesQuery, FormV2FilesQueryVariables>(
    FormV2FilesDocument,
    options,
  )
}
export type FormV2FilesQueryHookResult = ReturnType<typeof useFormV2FilesQuery>
export type FormV2FilesLazyQueryHookResult = ReturnType<typeof useFormV2FilesLazyQuery>
export type FormV2FilesQueryResult = Apollo.QueryResult<FormV2FilesQuery, FormV2FilesQueryVariables>
export const GetFormDocument = gql`
  query getForm($formId: ID!) {
    form(formId: $formId) {
      ...DetailedForm
    }
  }
  ${DetailedFormFragmentDoc}
`

/**
 * __useGetFormQuery__
 *
 * To run a query within a React component, call `useGetFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetFormQuery(
  baseOptions: Apollo.QueryHookOptions<GetFormQuery, GetFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options)
}
export function useGetFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFormQuery, GetFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options)
}
export type GetFormQueryHookResult = ReturnType<typeof useGetFormQuery>
export type GetFormLazyQueryHookResult = ReturnType<typeof useGetFormLazyQuery>
export type GetFormQueryResult = Apollo.QueryResult<GetFormQuery, GetFormQueryVariables>
export const GetSimpleFormV2Document = gql`
  query getSimpleFormV2($formId: ID!) {
    formV2(formId: $formId) {
      id
      name
    }
  }
`

/**
 * __useGetSimpleFormV2Query__
 *
 * To run a query within a React component, call `useGetSimpleFormV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleFormV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleFormV2Query({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGetSimpleFormV2Query(
  baseOptions: Apollo.QueryHookOptions<GetSimpleFormV2Query, GetSimpleFormV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSimpleFormV2Query, GetSimpleFormV2QueryVariables>(
    GetSimpleFormV2Document,
    options,
  )
}
export function useGetSimpleFormV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleFormV2Query, GetSimpleFormV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSimpleFormV2Query, GetSimpleFormV2QueryVariables>(
    GetSimpleFormV2Document,
    options,
  )
}
export type GetSimpleFormV2QueryHookResult = ReturnType<typeof useGetSimpleFormV2Query>
export type GetSimpleFormV2LazyQueryHookResult = ReturnType<typeof useGetSimpleFormV2LazyQuery>
export type GetSimpleFormV2QueryResult = Apollo.QueryResult<
  GetSimpleFormV2Query,
  GetSimpleFormV2QueryVariables
>
export const UpdatedFormDocument = gql`
  subscription updatedForm($formId: ID!) {
    updatedForm(formId: $formId) {
      ...DetailedForm
    }
  }
  ${DetailedFormFragmentDoc}
`

/**
 * __useUpdatedFormSubscription__
 *
 * To run a query within a React component, call `useUpdatedFormSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedFormSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedFormSubscription({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useUpdatedFormSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UpdatedFormSubscription,
    UpdatedFormSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<UpdatedFormSubscription, UpdatedFormSubscriptionVariables>(
    UpdatedFormDocument,
    options,
  )
}
export type UpdatedFormSubscriptionHookResult = ReturnType<typeof useUpdatedFormSubscription>
export type UpdatedFormSubscriptionResult = Apollo.SubscriptionResult<UpdatedFormSubscription>
export const SubmitFormDocument = gql`
  mutation submitForm($input: SubmitFormInput!) {
    submitForm(input: $input) {
      id
      name
      redirectTarget
      redirectCustomPath
    }
  }
`
export type SubmitFormMutationFn = Apollo.MutationFunction<
  SubmitFormMutation,
  SubmitFormMutationVariables
>

/**
 * __useSubmitFormMutation__
 *
 * To run a mutation, you first call `useSubmitFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormMutation, { data, loading, error }] = useSubmitFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitFormMutation(
  baseOptions?: Apollo.MutationHookOptions<SubmitFormMutation, SubmitFormMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SubmitFormMutation, SubmitFormMutationVariables>(
    SubmitFormDocument,
    options,
  )
}
export type SubmitFormMutationHookResult = ReturnType<typeof useSubmitFormMutation>
export type SubmitFormMutationResult = Apollo.MutationResult<SubmitFormMutation>
export type SubmitFormMutationOptions = Apollo.BaseMutationOptions<
  SubmitFormMutation,
  SubmitFormMutationVariables
>
export const GetLookupCellDocument = gql`
  query getLookupCell($tableCellId: ID!) {
    tableCell(tableCellId: $tableCellId) {
      id
      userVisibleValue
      data
      column {
        id
        name
        type
        order
        enumOptions
        innerType
        isNullable
        displayImagesInline
        ...ColumnFormatting
        ...ResolvedSourceColumn
      }
      row {
        id
      }
      documents {
        id
      }
    }
  }
  ${ColumnFormattingFragmentDoc}
  ${ResolvedSourceColumnFragmentDoc}
`

/**
 * __useGetLookupCellQuery__
 *
 * To run a query within a React component, call `useGetLookupCellQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLookupCellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLookupCellQuery({
 *   variables: {
 *      tableCellId: // value for 'tableCellId'
 *   },
 * });
 */
export function useGetLookupCellQuery(
  baseOptions: Apollo.QueryHookOptions<GetLookupCellQuery, GetLookupCellQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetLookupCellQuery, GetLookupCellQueryVariables>(
    GetLookupCellDocument,
    options,
  )
}
export function useGetLookupCellLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLookupCellQuery, GetLookupCellQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetLookupCellQuery, GetLookupCellQueryVariables>(
    GetLookupCellDocument,
    options,
  )
}
export type GetLookupCellQueryHookResult = ReturnType<typeof useGetLookupCellQuery>
export type GetLookupCellLazyQueryHookResult = ReturnType<typeof useGetLookupCellLazyQuery>
export type GetLookupCellQueryResult = Apollo.QueryResult<
  GetLookupCellQuery,
  GetLookupCellQueryVariables
>
export const CreateFormDocument = gql`
  mutation createForm($input: CreateFormInput!) {
    createForm(input: $input) {
      id
      name
      buttons {
        id
        name
      }
      pages {
        id
        name
        categories {
          id
          name
          fields {
            id
            name
          }
        }
      }
    }
  }
`
export type CreateFormMutationFn = Apollo.MutationFunction<
  CreateFormMutation,
  CreateFormMutationVariables
>

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateFormMutation, CreateFormMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFormMutation, CreateFormMutationVariables>(
    CreateFormDocument,
    options,
  )
}
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<
  CreateFormMutation,
  CreateFormMutationVariables
>
export const CreateSignatureDocument = gql`
  mutation createSignature($input: CreateSignatureInput!) {
    createSignature(input: $input) {
      id
      signatureFile {
        id
      }
    }
  }
`
export type CreateSignatureMutationFn = Apollo.MutationFunction<
  CreateSignatureMutation,
  CreateSignatureMutationVariables
>

/**
 * __useCreateSignatureMutation__
 *
 * To run a mutation, you first call `useCreateSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignatureMutation, { data, loading, error }] = useCreateSignatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSignatureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSignatureMutation,
    CreateSignatureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSignatureMutation, CreateSignatureMutationVariables>(
    CreateSignatureDocument,
    options,
  )
}
export type CreateSignatureMutationHookResult = ReturnType<typeof useCreateSignatureMutation>
export type CreateSignatureMutationResult = Apollo.MutationResult<CreateSignatureMutation>
export type CreateSignatureMutationOptions = Apollo.BaseMutationOptions<
  CreateSignatureMutation,
  CreateSignatureMutationVariables
>
export const ShareFormV2Document = gql`
  mutation shareFormV2($input: ShareFormV2Input!) {
    shareFormV2(input: $input) {
      id
      name
      slug
      redirectTarget
      redirectCustomPath
      lookupInputGroups {
        id
        lookupTable {
          id
          isShareable
        }
      }
      permissions {
        id
        permissionType
        role {
          id
          roleType
        }
      }
    }
  }
`
export type ShareFormV2MutationFn = Apollo.MutationFunction<
  ShareFormV2Mutation,
  ShareFormV2MutationVariables
>

/**
 * __useShareFormV2Mutation__
 *
 * To run a mutation, you first call `useShareFormV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareFormV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareFormV2Mutation, { data, loading, error }] = useShareFormV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareFormV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<ShareFormV2Mutation, ShareFormV2MutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ShareFormV2Mutation, ShareFormV2MutationVariables>(
    ShareFormV2Document,
    options,
  )
}
export type ShareFormV2MutationHookResult = ReturnType<typeof useShareFormV2Mutation>
export type ShareFormV2MutationResult = Apollo.MutationResult<ShareFormV2Mutation>
export type ShareFormV2MutationOptions = Apollo.BaseMutationOptions<
  ShareFormV2Mutation,
  ShareFormV2MutationVariables
>
export const UnshareFormV2Document = gql`
  mutation unshareFormV2($input: UnshareFormV2Input!) {
    unshareFormV2(input: $input) {
      id
      name
      slug
      redirectTarget
      redirectCustomPath
      lookupInputGroups {
        id
        lookupTable {
          id
          isShareable
        }
      }
      permissions {
        id
        permissionType
        role {
          id
          roleType
        }
      }
    }
  }
`
export type UnshareFormV2MutationFn = Apollo.MutationFunction<
  UnshareFormV2Mutation,
  UnshareFormV2MutationVariables
>

/**
 * __useUnshareFormV2Mutation__
 *
 * To run a mutation, you first call `useUnshareFormV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnshareFormV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unshareFormV2Mutation, { data, loading, error }] = useUnshareFormV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnshareFormV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<UnshareFormV2Mutation, UnshareFormV2MutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UnshareFormV2Mutation, UnshareFormV2MutationVariables>(
    UnshareFormV2Document,
    options,
  )
}
export type UnshareFormV2MutationHookResult = ReturnType<typeof useUnshareFormV2Mutation>
export type UnshareFormV2MutationResult = Apollo.MutationResult<UnshareFormV2Mutation>
export type UnshareFormV2MutationOptions = Apollo.BaseMutationOptions<
  UnshareFormV2Mutation,
  UnshareFormV2MutationVariables
>
export const GetFormulaDocument = gql`
  query getFormula($formulaId: ID!) {
    formula(formulaId: $formulaId) {
      id
      operator
      formulaValues {
        id
        order
        tableColumn {
          id
          name
        }
        formula {
          id
        }
      }
    }
  }
`

/**
 * __useGetFormulaQuery__
 *
 * To run a query within a React component, call `useGetFormulaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormulaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormulaQuery({
 *   variables: {
 *      formulaId: // value for 'formulaId'
 *   },
 * });
 */
export function useGetFormulaQuery(
  baseOptions: Apollo.QueryHookOptions<GetFormulaQuery, GetFormulaQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormulaQuery, GetFormulaQueryVariables>(GetFormulaDocument, options)
}
export function useGetFormulaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFormulaQuery, GetFormulaQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormulaQuery, GetFormulaQueryVariables>(GetFormulaDocument, options)
}
export type GetFormulaQueryHookResult = ReturnType<typeof useGetFormulaQuery>
export type GetFormulaLazyQueryHookResult = ReturnType<typeof useGetFormulaLazyQuery>
export type GetFormulaQueryResult = Apollo.QueryResult<GetFormulaQuery, GetFormulaQueryVariables>
export const GetFormulaJsonDocument = gql`
  query getFormulaJson($formulaId: ID!) {
    formulaJson(formulaId: $formulaId)
  }
`

/**
 * __useGetFormulaJsonQuery__
 *
 * To run a query within a React component, call `useGetFormulaJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormulaJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormulaJsonQuery({
 *   variables: {
 *      formulaId: // value for 'formulaId'
 *   },
 * });
 */
export function useGetFormulaJsonQuery(
  baseOptions: Apollo.QueryHookOptions<GetFormulaJsonQuery, GetFormulaJsonQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormulaJsonQuery, GetFormulaJsonQueryVariables>(
    GetFormulaJsonDocument,
    options,
  )
}
export function useGetFormulaJsonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFormulaJsonQuery, GetFormulaJsonQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormulaJsonQuery, GetFormulaJsonQueryVariables>(
    GetFormulaJsonDocument,
    options,
  )
}
export type GetFormulaJsonQueryHookResult = ReturnType<typeof useGetFormulaJsonQuery>
export type GetFormulaJsonLazyQueryHookResult = ReturnType<typeof useGetFormulaJsonLazyQuery>
export type GetFormulaJsonQueryResult = Apollo.QueryResult<
  GetFormulaJsonQuery,
  GetFormulaJsonQueryVariables
>
export const GetFormulaPopoverDocument = gql`
  query getFormulaPopover($formulaId: ID!) {
    formula(formulaId: $formulaId) {
      id
      formulaString
    }
    formulaJson(formulaId: $formulaId)
  }
`

/**
 * __useGetFormulaPopoverQuery__
 *
 * To run a query within a React component, call `useGetFormulaPopoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormulaPopoverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormulaPopoverQuery({
 *   variables: {
 *      formulaId: // value for 'formulaId'
 *   },
 * });
 */
export function useGetFormulaPopoverQuery(
  baseOptions: Apollo.QueryHookOptions<GetFormulaPopoverQuery, GetFormulaPopoverQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormulaPopoverQuery, GetFormulaPopoverQueryVariables>(
    GetFormulaPopoverDocument,
    options,
  )
}
export function useGetFormulaPopoverLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormulaPopoverQuery,
    GetFormulaPopoverQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormulaPopoverQuery, GetFormulaPopoverQueryVariables>(
    GetFormulaPopoverDocument,
    options,
  )
}
export type GetFormulaPopoverQueryHookResult = ReturnType<typeof useGetFormulaPopoverQuery>
export type GetFormulaPopoverLazyQueryHookResult = ReturnType<typeof useGetFormulaPopoverLazyQuery>
export type GetFormulaPopoverQueryResult = Apollo.QueryResult<
  GetFormulaPopoverQuery,
  GetFormulaPopoverQueryVariables
>
export const GuestDestinationHrefDocument = gql`
  query GuestDestinationHref($input: GuestDestinationInput!) {
    guestDestinationHref(input: $input)
  }
`

/**
 * __useGuestDestinationHrefQuery__
 *
 * To run a query within a React component, call `useGuestDestinationHrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestDestinationHrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestDestinationHrefQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuestDestinationHrefQuery(
  baseOptions: Apollo.QueryHookOptions<
    GuestDestinationHrefQuery,
    GuestDestinationHrefQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GuestDestinationHrefQuery, GuestDestinationHrefQueryVariables>(
    GuestDestinationHrefDocument,
    options,
  )
}
export function useGuestDestinationHrefLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GuestDestinationHrefQuery,
    GuestDestinationHrefQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GuestDestinationHrefQuery, GuestDestinationHrefQueryVariables>(
    GuestDestinationHrefDocument,
    options,
  )
}
export type GuestDestinationHrefQueryHookResult = ReturnType<typeof useGuestDestinationHrefQuery>
export type GuestDestinationHrefLazyQueryHookResult = ReturnType<
  typeof useGuestDestinationHrefLazyQuery
>
export type GuestDestinationHrefQueryResult = Apollo.QueryResult<
  GuestDestinationHrefQuery,
  GuestDestinationHrefQueryVariables
>
export const CreateStripeAccountDocument = gql`
  mutation createStripeAccount($isStaging: Boolean!) {
    createStripeAccount(isStaging: $isStaging)
  }
`
export type CreateStripeAccountMutationFn = Apollo.MutationFunction<
  CreateStripeAccountMutation,
  CreateStripeAccountMutationVariables
>

/**
 * __useCreateStripeAccountMutation__
 *
 * To run a mutation, you first call `useCreateStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeAccountMutation, { data, loading, error }] = useCreateStripeAccountMutation({
 *   variables: {
 *      isStaging: // value for 'isStaging'
 *   },
 * });
 */
export function useCreateStripeAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStripeAccountMutation,
    CreateStripeAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateStripeAccountMutation, CreateStripeAccountMutationVariables>(
    CreateStripeAccountDocument,
    options,
  )
}
export type CreateStripeAccountMutationHookResult = ReturnType<
  typeof useCreateStripeAccountMutation
>
export type CreateStripeAccountMutationResult = Apollo.MutationResult<CreateStripeAccountMutation>
export type CreateStripeAccountMutationOptions = Apollo.BaseMutationOptions<
  CreateStripeAccountMutation,
  CreateStripeAccountMutationVariables
>
export const GetStripeAccountSecretDocument = gql`
  mutation getStripeAccountSecret($accountId: String!, $isStaging: Boolean!) {
    getStripeAccountSecret(accountId: $accountId, isStaging: $isStaging)
  }
`
export type GetStripeAccountSecretMutationFn = Apollo.MutationFunction<
  GetStripeAccountSecretMutation,
  GetStripeAccountSecretMutationVariables
>

/**
 * __useGetStripeAccountSecretMutation__
 *
 * To run a mutation, you first call `useGetStripeAccountSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetStripeAccountSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getStripeAccountSecretMutation, { data, loading, error }] = useGetStripeAccountSecretMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      isStaging: // value for 'isStaging'
 *   },
 * });
 */
export function useGetStripeAccountSecretMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetStripeAccountSecretMutation,
    GetStripeAccountSecretMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GetStripeAccountSecretMutation,
    GetStripeAccountSecretMutationVariables
  >(GetStripeAccountSecretDocument, options)
}
export type GetStripeAccountSecretMutationHookResult = ReturnType<
  typeof useGetStripeAccountSecretMutation
>
export type GetStripeAccountSecretMutationResult =
  Apollo.MutationResult<GetStripeAccountSecretMutation>
export type GetStripeAccountSecretMutationOptions = Apollo.BaseMutationOptions<
  GetStripeAccountSecretMutation,
  GetStripeAccountSecretMutationVariables
>
export const CreateStripeFinancialConnectionsCustomerDocument = gql`
  mutation createStripeFinancialConnectionsCustomer($organizationId: String!) {
    createStripeFinancialConnectionsCustomer(organizationId: $organizationId)
  }
`
export type CreateStripeFinancialConnectionsCustomerMutationFn = Apollo.MutationFunction<
  CreateStripeFinancialConnectionsCustomerMutation,
  CreateStripeFinancialConnectionsCustomerMutationVariables
>

/**
 * __useCreateStripeFinancialConnectionsCustomerMutation__
 *
 * To run a mutation, you first call `useCreateStripeFinancialConnectionsCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeFinancialConnectionsCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeFinancialConnectionsCustomerMutation, { data, loading, error }] = useCreateStripeFinancialConnectionsCustomerMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateStripeFinancialConnectionsCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStripeFinancialConnectionsCustomerMutation,
    CreateStripeFinancialConnectionsCustomerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateStripeFinancialConnectionsCustomerMutation,
    CreateStripeFinancialConnectionsCustomerMutationVariables
  >(CreateStripeFinancialConnectionsCustomerDocument, options)
}
export type CreateStripeFinancialConnectionsCustomerMutationHookResult = ReturnType<
  typeof useCreateStripeFinancialConnectionsCustomerMutation
>
export type CreateStripeFinancialConnectionsCustomerMutationResult =
  Apollo.MutationResult<CreateStripeFinancialConnectionsCustomerMutation>
export type CreateStripeFinancialConnectionsCustomerMutationOptions = Apollo.BaseMutationOptions<
  CreateStripeFinancialConnectionsCustomerMutation,
  CreateStripeFinancialConnectionsCustomerMutationVariables
>
export const CreateStripeFinancialConnectionsSessionDocument = gql`
  mutation createStripeFinancialConnectionsSession($customerId: String!) {
    createStripeFinancialConnectionsSession(customerId: $customerId)
  }
`
export type CreateStripeFinancialConnectionsSessionMutationFn = Apollo.MutationFunction<
  CreateStripeFinancialConnectionsSessionMutation,
  CreateStripeFinancialConnectionsSessionMutationVariables
>

/**
 * __useCreateStripeFinancialConnectionsSessionMutation__
 *
 * To run a mutation, you first call `useCreateStripeFinancialConnectionsSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeFinancialConnectionsSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeFinancialConnectionsSessionMutation, { data, loading, error }] = useCreateStripeFinancialConnectionsSessionMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCreateStripeFinancialConnectionsSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStripeFinancialConnectionsSessionMutation,
    CreateStripeFinancialConnectionsSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateStripeFinancialConnectionsSessionMutation,
    CreateStripeFinancialConnectionsSessionMutationVariables
  >(CreateStripeFinancialConnectionsSessionDocument, options)
}
export type CreateStripeFinancialConnectionsSessionMutationHookResult = ReturnType<
  typeof useCreateStripeFinancialConnectionsSessionMutation
>
export type CreateStripeFinancialConnectionsSessionMutationResult =
  Apollo.MutationResult<CreateStripeFinancialConnectionsSessionMutation>
export type CreateStripeFinancialConnectionsSessionMutationOptions = Apollo.BaseMutationOptions<
  CreateStripeFinancialConnectionsSessionMutation,
  CreateStripeFinancialConnectionsSessionMutationVariables
>
export const RequestIntegration2FaCodeDocument = gql`
  mutation requestIntegration2FACode($input: RequestIntegration2FACodeInput!) {
    requestIntegration2FACode(input: $input) {
      id
    }
  }
`
export type RequestIntegration2FaCodeMutationFn = Apollo.MutationFunction<
  RequestIntegration2FaCodeMutation,
  RequestIntegration2FaCodeMutationVariables
>

/**
 * __useRequestIntegration2FaCodeMutation__
 *
 * To run a mutation, you first call `useRequestIntegration2FaCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestIntegration2FaCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestIntegration2FaCodeMutation, { data, loading, error }] = useRequestIntegration2FaCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestIntegration2FaCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestIntegration2FaCodeMutation,
    RequestIntegration2FaCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RequestIntegration2FaCodeMutation,
    RequestIntegration2FaCodeMutationVariables
  >(RequestIntegration2FaCodeDocument, options)
}
export type RequestIntegration2FaCodeMutationHookResult = ReturnType<
  typeof useRequestIntegration2FaCodeMutation
>
export type RequestIntegration2FaCodeMutationResult =
  Apollo.MutationResult<RequestIntegration2FaCodeMutation>
export type RequestIntegration2FaCodeMutationOptions = Apollo.BaseMutationOptions<
  RequestIntegration2FaCodeMutation,
  RequestIntegration2FaCodeMutationVariables
>
export const GetNetsuitePublicKeyDocument = gql`
  query getNetsuitePublicKey($integrationId: ID!) {
    getNetsuitePublicKey(integrationId: $integrationId) {
      publicKey
      certificateExpiresAt
      expirationWarning
    }
  }
`

/**
 * __useGetNetsuitePublicKeyQuery__
 *
 * To run a query within a React component, call `useGetNetsuitePublicKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetsuitePublicKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetsuitePublicKeyQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetNetsuitePublicKeyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNetsuitePublicKeyQuery,
    GetNetsuitePublicKeyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetNetsuitePublicKeyQuery, GetNetsuitePublicKeyQueryVariables>(
    GetNetsuitePublicKeyDocument,
    options,
  )
}
export function useGetNetsuitePublicKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNetsuitePublicKeyQuery,
    GetNetsuitePublicKeyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetNetsuitePublicKeyQuery, GetNetsuitePublicKeyQueryVariables>(
    GetNetsuitePublicKeyDocument,
    options,
  )
}
export type GetNetsuitePublicKeyQueryHookResult = ReturnType<typeof useGetNetsuitePublicKeyQuery>
export type GetNetsuitePublicKeyLazyQueryHookResult = ReturnType<
  typeof useGetNetsuitePublicKeyLazyQuery
>
export type GetNetsuitePublicKeyQueryResult = Apollo.QueryResult<
  GetNetsuitePublicKeyQuery,
  GetNetsuitePublicKeyQueryVariables
>
export const ShipStationDirectLoginUrlDocument = gql`
  query shipStationDirectLoginUrl($integrationId: ID!) {
    shipStationDirectLoginUrl(integrationId: $integrationId)
  }
`

/**
 * __useShipStationDirectLoginUrlQuery__
 *
 * To run a query within a React component, call `useShipStationDirectLoginUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipStationDirectLoginUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipStationDirectLoginUrlQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useShipStationDirectLoginUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShipStationDirectLoginUrlQuery,
    ShipStationDirectLoginUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ShipStationDirectLoginUrlQuery, ShipStationDirectLoginUrlQueryVariables>(
    ShipStationDirectLoginUrlDocument,
    options,
  )
}
export function useShipStationDirectLoginUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShipStationDirectLoginUrlQuery,
    ShipStationDirectLoginUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ShipStationDirectLoginUrlQuery,
    ShipStationDirectLoginUrlQueryVariables
  >(ShipStationDirectLoginUrlDocument, options)
}
export type ShipStationDirectLoginUrlQueryHookResult = ReturnType<
  typeof useShipStationDirectLoginUrlQuery
>
export type ShipStationDirectLoginUrlLazyQueryHookResult = ReturnType<
  typeof useShipStationDirectLoginUrlLazyQuery
>
export type ShipStationDirectLoginUrlQueryResult = Apollo.QueryResult<
  ShipStationDirectLoginUrlQuery,
  ShipStationDirectLoginUrlQueryVariables
>
export const UpdateIntegrationCredentialsDocument = gql`
  mutation updateIntegrationCredentials($input: UpdateIntegrationCredentialsInput!) {
    updateIntegrationCredentials(input: $input) {
      id
    }
  }
`
export type UpdateIntegrationCredentialsMutationFn = Apollo.MutationFunction<
  UpdateIntegrationCredentialsMutation,
  UpdateIntegrationCredentialsMutationVariables
>

/**
 * __useUpdateIntegrationCredentialsMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationCredentialsMutation, { data, loading, error }] = useUpdateIntegrationCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationCredentialsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateIntegrationCredentialsMutation,
    UpdateIntegrationCredentialsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateIntegrationCredentialsMutation,
    UpdateIntegrationCredentialsMutationVariables
  >(UpdateIntegrationCredentialsDocument, options)
}
export type UpdateIntegrationCredentialsMutationHookResult = ReturnType<
  typeof useUpdateIntegrationCredentialsMutation
>
export type UpdateIntegrationCredentialsMutationResult =
  Apollo.MutationResult<UpdateIntegrationCredentialsMutation>
export type UpdateIntegrationCredentialsMutationOptions = Apollo.BaseMutationOptions<
  UpdateIntegrationCredentialsMutation,
  UpdateIntegrationCredentialsMutationVariables
>
export const RegenerateNetsuiteCertificateDocument = gql`
  mutation regenerateNetsuiteCertificate($integrationId: ID!) {
    regenerateNetsuiteCertificate(integrationId: $integrationId) {
      publicKey
      certificateExpiresAt
      expirationWarning
    }
  }
`
export type RegenerateNetsuiteCertificateMutationFn = Apollo.MutationFunction<
  RegenerateNetsuiteCertificateMutation,
  RegenerateNetsuiteCertificateMutationVariables
>

/**
 * __useRegenerateNetsuiteCertificateMutation__
 *
 * To run a mutation, you first call `useRegenerateNetsuiteCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateNetsuiteCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateNetsuiteCertificateMutation, { data, loading, error }] = useRegenerateNetsuiteCertificateMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useRegenerateNetsuiteCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegenerateNetsuiteCertificateMutation,
    RegenerateNetsuiteCertificateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RegenerateNetsuiteCertificateMutation,
    RegenerateNetsuiteCertificateMutationVariables
  >(RegenerateNetsuiteCertificateDocument, options)
}
export type RegenerateNetsuiteCertificateMutationHookResult = ReturnType<
  typeof useRegenerateNetsuiteCertificateMutation
>
export type RegenerateNetsuiteCertificateMutationResult =
  Apollo.MutationResult<RegenerateNetsuiteCertificateMutation>
export type RegenerateNetsuiteCertificateMutationOptions = Apollo.BaseMutationOptions<
  RegenerateNetsuiteCertificateMutation,
  RegenerateNetsuiteCertificateMutationVariables
>
export const CreateIntegrationDocument = gql`
  mutation createIntegration($input: CreateIntegrationInput!) {
    createIntegration(input: $input) {
      id
      status
    }
  }
`
export type CreateIntegrationMutationFn = Apollo.MutationFunction<
  CreateIntegrationMutation,
  CreateIntegrationMutationVariables
>

/**
 * __useCreateIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationMutation, { data, loading, error }] = useCreateIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateIntegrationMutation,
    CreateIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateIntegrationMutation, CreateIntegrationMutationVariables>(
    CreateIntegrationDocument,
    options,
  )
}
export type CreateIntegrationMutationHookResult = ReturnType<typeof useCreateIntegrationMutation>
export type CreateIntegrationMutationResult = Apollo.MutationResult<CreateIntegrationMutation>
export type CreateIntegrationMutationOptions = Apollo.BaseMutationOptions<
  CreateIntegrationMutation,
  CreateIntegrationMutationVariables
>
export const UpdateIntegrationDocument = gql`
  mutation updateIntegration($input: UpdateIntegrationInput!) {
    updateIntegration(input: $input) {
      id
      metadata
      status
    }
  }
`
export type UpdateIntegrationMutationFn = Apollo.MutationFunction<
  UpdateIntegrationMutation,
  UpdateIntegrationMutationVariables
>

/**
 * __useUpdateIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationMutation, { data, loading, error }] = useUpdateIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateIntegrationMutation,
    UpdateIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>(
    UpdateIntegrationDocument,
    options,
  )
}
export type UpdateIntegrationMutationHookResult = ReturnType<typeof useUpdateIntegrationMutation>
export type UpdateIntegrationMutationResult = Apollo.MutationResult<UpdateIntegrationMutation>
export type UpdateIntegrationMutationOptions = Apollo.BaseMutationOptions<
  UpdateIntegrationMutation,
  UpdateIntegrationMutationVariables
>
export const DeleteIntegrationDocument = gql`
  mutation deleteIntegration($integrationId: ID!) {
    deleteIntegration(integrationId: $integrationId) {
      id
    }
  }
`
export type DeleteIntegrationMutationFn = Apollo.MutationFunction<
  DeleteIntegrationMutation,
  DeleteIntegrationMutationVariables
>

/**
 * __useDeleteIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationMutation, { data, loading, error }] = useDeleteIntegrationMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useDeleteIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteIntegrationMutation,
    DeleteIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>(
    DeleteIntegrationDocument,
    options,
  )
}
export type DeleteIntegrationMutationHookResult = ReturnType<typeof useDeleteIntegrationMutation>
export type DeleteIntegrationMutationResult = Apollo.MutationResult<DeleteIntegrationMutation>
export type DeleteIntegrationMutationOptions = Apollo.BaseMutationOptions<
  DeleteIntegrationMutation,
  DeleteIntegrationMutationVariables
>
export const AuthorizeIntegrationDocument = gql`
  mutation authorizeIntegration($input: AuthorizeIntegrationInput!) {
    authorizeIntegration(input: $input) {
      id
      type
      status
      metadata
      installLink
      authType
    }
  }
`
export type AuthorizeIntegrationMutationFn = Apollo.MutationFunction<
  AuthorizeIntegrationMutation,
  AuthorizeIntegrationMutationVariables
>

/**
 * __useAuthorizeIntegrationMutation__
 *
 * To run a mutation, you first call `useAuthorizeIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizeIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authorizeIntegrationMutation, { data, loading, error }] = useAuthorizeIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthorizeIntegrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AuthorizeIntegrationMutation,
    AuthorizeIntegrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AuthorizeIntegrationMutation, AuthorizeIntegrationMutationVariables>(
    AuthorizeIntegrationDocument,
    options,
  )
}
export type AuthorizeIntegrationMutationHookResult = ReturnType<
  typeof useAuthorizeIntegrationMutation
>
export type AuthorizeIntegrationMutationResult = Apollo.MutationResult<AuthorizeIntegrationMutation>
export type AuthorizeIntegrationMutationOptions = Apollo.BaseMutationOptions<
  AuthorizeIntegrationMutation,
  AuthorizeIntegrationMutationVariables
>
export const GetIntegrationsDocument = gql`
  query getIntegrations($organizationId: ID!) {
    integrations(organizationId: $organizationId) {
      id
      type
      metadata
      status
      installLink
      authType
    }
  }
`

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetIntegrationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(
    GetIntegrationsDocument,
    options,
  )
}
export function useGetIntegrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(
    GetIntegrationsDocument,
    options,
  )
}
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>
export type GetIntegrationsQueryResult = Apollo.QueryResult<
  GetIntegrationsQuery,
  GetIntegrationsQueryVariables
>
export const GetIntegrationAuthUriDocument = gql`
  query getIntegrationAuthUri($input: GetIntegrationAuthorizationUriInput!) {
    integrationAuthorizationUri(input: $input)
  }
`

/**
 * __useGetIntegrationAuthUriQuery__
 *
 * To run a query within a React component, call `useGetIntegrationAuthUriQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationAuthUriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationAuthUriQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIntegrationAuthUriQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIntegrationAuthUriQuery,
    GetIntegrationAuthUriQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetIntegrationAuthUriQuery, GetIntegrationAuthUriQueryVariables>(
    GetIntegrationAuthUriDocument,
    options,
  )
}
export function useGetIntegrationAuthUriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIntegrationAuthUriQuery,
    GetIntegrationAuthUriQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetIntegrationAuthUriQuery, GetIntegrationAuthUriQueryVariables>(
    GetIntegrationAuthUriDocument,
    options,
  )
}
export type GetIntegrationAuthUriQueryHookResult = ReturnType<typeof useGetIntegrationAuthUriQuery>
export type GetIntegrationAuthUriLazyQueryHookResult = ReturnType<
  typeof useGetIntegrationAuthUriLazyQuery
>
export type GetIntegrationAuthUriQueryResult = Apollo.QueryResult<
  GetIntegrationAuthUriQuery,
  GetIntegrationAuthUriQueryVariables
>
export const VerifyIntegrationRequestDocument = gql`
  query verifyIntegrationRequest($input: VerifyIntegrationRequestInput!) {
    verifyIntegrationRequest(input: $input)
  }
`

/**
 * __useVerifyIntegrationRequestQuery__
 *
 * To run a query within a React component, call `useVerifyIntegrationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyIntegrationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyIntegrationRequestQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyIntegrationRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    VerifyIntegrationRequestQuery,
    VerifyIntegrationRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<VerifyIntegrationRequestQuery, VerifyIntegrationRequestQueryVariables>(
    VerifyIntegrationRequestDocument,
    options,
  )
}
export function useVerifyIntegrationRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VerifyIntegrationRequestQuery,
    VerifyIntegrationRequestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<VerifyIntegrationRequestQuery, VerifyIntegrationRequestQueryVariables>(
    VerifyIntegrationRequestDocument,
    options,
  )
}
export type VerifyIntegrationRequestQueryHookResult = ReturnType<
  typeof useVerifyIntegrationRequestQuery
>
export type VerifyIntegrationRequestLazyQueryHookResult = ReturnType<
  typeof useVerifyIntegrationRequestLazyQuery
>
export type VerifyIntegrationRequestQueryResult = Apollo.QueryResult<
  VerifyIntegrationRequestQuery,
  VerifyIntegrationRequestQueryVariables
>
export const TestIntegrationDocument = gql`
  query testIntegration($integrationId: ID!) {
    testIntegration(integrationId: $integrationId) {
      isValid
      invalidReason
    }
  }
`

/**
 * __useTestIntegrationQuery__
 *
 * To run a query within a React component, call `useTestIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestIntegrationQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useTestIntegrationQuery(
  baseOptions: Apollo.QueryHookOptions<TestIntegrationQuery, TestIntegrationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TestIntegrationQuery, TestIntegrationQueryVariables>(
    TestIntegrationDocument,
    options,
  )
}
export function useTestIntegrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TestIntegrationQuery, TestIntegrationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TestIntegrationQuery, TestIntegrationQueryVariables>(
    TestIntegrationDocument,
    options,
  )
}
export type TestIntegrationQueryHookResult = ReturnType<typeof useTestIntegrationQuery>
export type TestIntegrationLazyQueryHookResult = ReturnType<typeof useTestIntegrationLazyQuery>
export type TestIntegrationQueryResult = Apollo.QueryResult<
  TestIntegrationQuery,
  TestIntegrationQueryVariables
>
export const NavigationItemsDocument = gql`
  query NavigationItems {
    navigationItems {
      id
      parentId
      order
      label
      icon
      href
      destination {
        __typename
      }
    }
  }
`

/**
 * __useNavigationItemsQuery__
 *
 * To run a query within a React component, call `useNavigationItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavigationItemsQuery(
  baseOptions?: Apollo.QueryHookOptions<NavigationItemsQuery, NavigationItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NavigationItemsQuery, NavigationItemsQueryVariables>(
    NavigationItemsDocument,
    options,
  )
}
export function useNavigationItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NavigationItemsQuery, NavigationItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NavigationItemsQuery, NavigationItemsQueryVariables>(
    NavigationItemsDocument,
    options,
  )
}
export type NavigationItemsQueryHookResult = ReturnType<typeof useNavigationItemsQuery>
export type NavigationItemsLazyQueryHookResult = ReturnType<typeof useNavigationItemsLazyQuery>
export type NavigationItemsQueryResult = Apollo.QueryResult<
  NavigationItemsQuery,
  NavigationItemsQueryVariables
>
export const GetRootWorkspacesDocument = gql`
  query getRootWorkspaces {
    rootWorkspaces {
      id
      name
      order
    }
  }
`

/**
 * __useGetRootWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetRootWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRootWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRootWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRootWorkspacesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRootWorkspacesQuery, GetRootWorkspacesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRootWorkspacesQuery, GetRootWorkspacesQueryVariables>(
    GetRootWorkspacesDocument,
    options,
  )
}
export function useGetRootWorkspacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRootWorkspacesQuery,
    GetRootWorkspacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRootWorkspacesQuery, GetRootWorkspacesQueryVariables>(
    GetRootWorkspacesDocument,
    options,
  )
}
export type GetRootWorkspacesQueryHookResult = ReturnType<typeof useGetRootWorkspacesQuery>
export type GetRootWorkspacesLazyQueryHookResult = ReturnType<typeof useGetRootWorkspacesLazyQuery>
export type GetRootWorkspacesQueryResult = Apollo.QueryResult<
  GetRootWorkspacesQuery,
  GetRootWorkspacesQueryVariables
>
export const GetSwitchableOrganizationsDocument = gql`
  query getSwitchableOrganizations {
    switchableOrganizations {
      organizationId
      organizationName
      logoUrl
      isCurrent
    }
  }
`

/**
 * __useGetSwitchableOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetSwitchableOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwitchableOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwitchableOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSwitchableOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSwitchableOrganizationsQuery,
    GetSwitchableOrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSwitchableOrganizationsQuery, GetSwitchableOrganizationsQueryVariables>(
    GetSwitchableOrganizationsDocument,
    options,
  )
}
export function useGetSwitchableOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSwitchableOrganizationsQuery,
    GetSwitchableOrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetSwitchableOrganizationsQuery,
    GetSwitchableOrganizationsQueryVariables
  >(GetSwitchableOrganizationsDocument, options)
}
export type GetSwitchableOrganizationsQueryHookResult = ReturnType<
  typeof useGetSwitchableOrganizationsQuery
>
export type GetSwitchableOrganizationsLazyQueryHookResult = ReturnType<
  typeof useGetSwitchableOrganizationsLazyQuery
>
export type GetSwitchableOrganizationsQueryResult = Apollo.QueryResult<
  GetSwitchableOrganizationsQuery,
  GetSwitchableOrganizationsQueryVariables
>
export const GetLogicExpressionJsonDocument = gql`
  query getLogicExpressionJson($logicExpressionId: ID!) {
    logicExpressionJson(logicExpressionId: $logicExpressionId)
  }
`

/**
 * __useGetLogicExpressionJsonQuery__
 *
 * To run a query within a React component, call `useGetLogicExpressionJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogicExpressionJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogicExpressionJsonQuery({
 *   variables: {
 *      logicExpressionId: // value for 'logicExpressionId'
 *   },
 * });
 */
export function useGetLogicExpressionJsonQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLogicExpressionJsonQuery,
    GetLogicExpressionJsonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetLogicExpressionJsonQuery, GetLogicExpressionJsonQueryVariables>(
    GetLogicExpressionJsonDocument,
    options,
  )
}
export function useGetLogicExpressionJsonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLogicExpressionJsonQuery,
    GetLogicExpressionJsonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetLogicExpressionJsonQuery, GetLogicExpressionJsonQueryVariables>(
    GetLogicExpressionJsonDocument,
    options,
  )
}
export type GetLogicExpressionJsonQueryHookResult = ReturnType<
  typeof useGetLogicExpressionJsonQuery
>
export type GetLogicExpressionJsonLazyQueryHookResult = ReturnType<
  typeof useGetLogicExpressionJsonLazyQuery
>
export type GetLogicExpressionJsonQueryResult = Apollo.QueryResult<
  GetLogicExpressionJsonQuery,
  GetLogicExpressionJsonQueryVariables
>
export const GetBreadcrumbsDocument = gql`
  query getBreadcrumbs($input: BreadcrumbsInput!) {
    breadcrumbs(input: $input) {
      objectId
      type
      name
      iconName
    }
  }
`

/**
 * __useGetBreadcrumbsQuery__
 *
 * To run a query within a React component, call `useGetBreadcrumbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBreadcrumbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBreadcrumbsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBreadcrumbsQuery(
  baseOptions: Apollo.QueryHookOptions<GetBreadcrumbsQuery, GetBreadcrumbsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetBreadcrumbsQuery, GetBreadcrumbsQueryVariables>(
    GetBreadcrumbsDocument,
    options,
  )
}
export function useGetBreadcrumbsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBreadcrumbsQuery, GetBreadcrumbsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetBreadcrumbsQuery, GetBreadcrumbsQueryVariables>(
    GetBreadcrumbsDocument,
    options,
  )
}
export type GetBreadcrumbsQueryHookResult = ReturnType<typeof useGetBreadcrumbsQuery>
export type GetBreadcrumbsLazyQueryHookResult = ReturnType<typeof useGetBreadcrumbsLazyQuery>
export type GetBreadcrumbsQueryResult = Apollo.QueryResult<
  GetBreadcrumbsQuery,
  GetBreadcrumbsQueryVariables
>
export const SearchDocument = gql`
  query search($searchString: String!) {
    rows: searchTableRows(input: { searchString: $searchString, pagination: { limit: 20 } }) {
      rows {
        id
        name
        cells {
          id
          userVisibleValue
          column {
            id
            type
            indexType
            indexPrefix
            indexSuffix
            order
            name
          }
        }
        table {
          id
          name
        }
        parentRow {
          id
        }
      }
    }
    tables: searchTables(input: { searchString: $searchString, pagination: { limit: 10 } }) {
      tables {
        id
        name
      }
    }
    documents: searchDocuments(input: { searchString: $searchString, pagination: { limit: 10 } }) {
      documents {
        id
        name
        storageUrl
      }
    }
    forms: searchForms(input: { searchString: $searchString, pagination: { limit: 10 } }) {
      forms {
        id
        name
        buttons {
          id
          name
        }
      }
    }
    formsV2: searchFormsV2(input: { searchString: $searchString, pagination: { limit: 10 } }) {
      formsV2 {
        id
        name
        buttons {
          id
          name
        }
      }
    }
  }
`

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useSearchQuery(
  baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options)
}
export function useSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options)
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>
export const GetWorkflowNameDocument = gql`
  query getWorkflowName($workflowId: ID!) {
    workflow(workflowId: $workflowId) {
      id
      name
      actions {
        id
        name
      }
    }
  }
`

/**
 * __useGetWorkflowNameQuery__
 *
 * To run a query within a React component, call `useGetWorkflowNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowNameQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useGetWorkflowNameQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkflowNameQuery, GetWorkflowNameQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWorkflowNameQuery, GetWorkflowNameQueryVariables>(
    GetWorkflowNameDocument,
    options,
  )
}
export function useGetWorkflowNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowNameQuery, GetWorkflowNameQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWorkflowNameQuery, GetWorkflowNameQueryVariables>(
    GetWorkflowNameDocument,
    options,
  )
}
export type GetWorkflowNameQueryHookResult = ReturnType<typeof useGetWorkflowNameQuery>
export type GetWorkflowNameLazyQueryHookResult = ReturnType<typeof useGetWorkflowNameLazyQuery>
export type GetWorkflowNameQueryResult = Apollo.QueryResult<
  GetWorkflowNameQuery,
  GetWorkflowNameQueryVariables
>
export const GetWorkspaceByObjectDocument = gql`
  query getWorkspaceByObject($input: BreadcrumbsInput!) {
    workspaceByObject(input: $input) {
      id
      actionButtons {
        id
        name
        order
        manualTrigger {
          id
          action {
            id
            status
            workflow {
              id
              status
            }
          }
        }
        form {
          id
        }
        formV2 {
          id
        }
      }
      views {
        id
        order
        viewableObjectType
        ... on View {
          chart {
            id
            name
            chartType
          }
          workspace {
            id
            name
          }
          table {
            id
            name
            icon {
              id
              name
            }
            tableTabs {
              id
              order
            }
          }
          tableRow {
            id
            name
          }
          document {
            id
            name
          }
          embed {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useGetWorkspaceByObjectQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceByObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceByObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceByObjectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkspaceByObjectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkspaceByObjectQuery,
    GetWorkspaceByObjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWorkspaceByObjectQuery, GetWorkspaceByObjectQueryVariables>(
    GetWorkspaceByObjectDocument,
    options,
  )
}
export function useGetWorkspaceByObjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkspaceByObjectQuery,
    GetWorkspaceByObjectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWorkspaceByObjectQuery, GetWorkspaceByObjectQueryVariables>(
    GetWorkspaceByObjectDocument,
    options,
  )
}
export type GetWorkspaceByObjectQueryHookResult = ReturnType<typeof useGetWorkspaceByObjectQuery>
export type GetWorkspaceByObjectLazyQueryHookResult = ReturnType<
  typeof useGetWorkspaceByObjectLazyQuery
>
export type GetWorkspaceByObjectQueryResult = Apollo.QueryResult<
  GetWorkspaceByObjectQuery,
  GetWorkspaceByObjectQueryVariables
>
export const PushCommentNotificationDocument = gql`
  subscription pushCommentNotification {
    pushCommentNotification {
      id
      notificationType
      isRead
      isArchived
      comment {
        id
      }
      user {
        id
        firstName
        lastName
      }
    }
  }
`

/**
 * __usePushCommentNotificationSubscription__
 *
 * To run a query within a React component, call `usePushCommentNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushCommentNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushCommentNotificationSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePushCommentNotificationSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PushCommentNotificationSubscription,
    PushCommentNotificationSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    PushCommentNotificationSubscription,
    PushCommentNotificationSubscriptionVariables
  >(PushCommentNotificationDocument, options)
}
export type PushCommentNotificationSubscriptionHookResult = ReturnType<
  typeof usePushCommentNotificationSubscription
>
export type PushCommentNotificationSubscriptionResult =
  Apollo.SubscriptionResult<PushCommentNotificationSubscription>
export const MarkNotificationAsReadDocument = gql`
  mutation markNotificationAsRead($notificationId: ID!) {
    markNotificationAsRead(notificationId: $notificationId) {
      id
    }
  }
`
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<
  MarkNotificationAsReadMutation,
  MarkNotificationAsReadMutationVariables
>

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkNotificationAsReadMutation,
    MarkNotificationAsReadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarkNotificationAsReadMutation,
    MarkNotificationAsReadMutationVariables
  >(MarkNotificationAsReadDocument, options)
}
export type MarkNotificationAsReadMutationHookResult = ReturnType<
  typeof useMarkNotificationAsReadMutation
>
export type MarkNotificationAsReadMutationResult =
  Apollo.MutationResult<MarkNotificationAsReadMutation>
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<
  MarkNotificationAsReadMutation,
  MarkNotificationAsReadMutationVariables
>
export const MarkNotificationAsUnreadDocument = gql`
  mutation markNotificationAsUnread($notificationId: ID!) {
    markNotificationAsUnread(notificationId: $notificationId) {
      id
    }
  }
`
export type MarkNotificationAsUnreadMutationFn = Apollo.MutationFunction<
  MarkNotificationAsUnreadMutation,
  MarkNotificationAsUnreadMutationVariables
>

/**
 * __useMarkNotificationAsUnreadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsUnreadMutation, { data, loading, error }] = useMarkNotificationAsUnreadMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkNotificationAsUnreadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkNotificationAsUnreadMutation,
    MarkNotificationAsUnreadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarkNotificationAsUnreadMutation,
    MarkNotificationAsUnreadMutationVariables
  >(MarkNotificationAsUnreadDocument, options)
}
export type MarkNotificationAsUnreadMutationHookResult = ReturnType<
  typeof useMarkNotificationAsUnreadMutation
>
export type MarkNotificationAsUnreadMutationResult =
  Apollo.MutationResult<MarkNotificationAsUnreadMutation>
export type MarkNotificationAsUnreadMutationOptions = Apollo.BaseMutationOptions<
  MarkNotificationAsUnreadMutation,
  MarkNotificationAsUnreadMutationVariables
>
export const MarkAllNotificationsAsReadDocument = gql`
  mutation markAllNotificationsAsRead {
    markAllNotificationsAsRead {
      id
    }
  }
`
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<
  MarkAllNotificationsAsReadMutation,
  MarkAllNotificationsAsReadMutationVariables
>

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkAllNotificationsAsReadMutation,
    MarkAllNotificationsAsReadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarkAllNotificationsAsReadMutation,
    MarkAllNotificationsAsReadMutationVariables
  >(MarkAllNotificationsAsReadDocument, options)
}
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<
  typeof useMarkAllNotificationsAsReadMutation
>
export type MarkAllNotificationsAsReadMutationResult =
  Apollo.MutationResult<MarkAllNotificationsAsReadMutation>
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<
  MarkAllNotificationsAsReadMutation,
  MarkAllNotificationsAsReadMutationVariables
>
export const MarkNotificationAsArchivedDocument = gql`
  mutation markNotificationAsArchived($notificationId: ID!) {
    markNotificationAsArchived(notificationId: $notificationId) {
      id
    }
  }
`
export type MarkNotificationAsArchivedMutationFn = Apollo.MutationFunction<
  MarkNotificationAsArchivedMutation,
  MarkNotificationAsArchivedMutationVariables
>

/**
 * __useMarkNotificationAsArchivedMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsArchivedMutation, { data, loading, error }] = useMarkNotificationAsArchivedMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkNotificationAsArchivedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkNotificationAsArchivedMutation,
    MarkNotificationAsArchivedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarkNotificationAsArchivedMutation,
    MarkNotificationAsArchivedMutationVariables
  >(MarkNotificationAsArchivedDocument, options)
}
export type MarkNotificationAsArchivedMutationHookResult = ReturnType<
  typeof useMarkNotificationAsArchivedMutation
>
export type MarkNotificationAsArchivedMutationResult =
  Apollo.MutationResult<MarkNotificationAsArchivedMutation>
export type MarkNotificationAsArchivedMutationOptions = Apollo.BaseMutationOptions<
  MarkNotificationAsArchivedMutation,
  MarkNotificationAsArchivedMutationVariables
>
export const PushRowButtonNodesDocument = gql`
  subscription pushRowButtonNodes($input: TableRowSubscriptionInput!) {
    pushRowButtonNodes(input: $input) {
      id
      currentButtonNodes {
        id
        name
        workspaceButtons {
          id
          name
          order
          buttonConfiguration
          requiresConfirmation
          confirmationMessage
          icon {
            id
            name
          }
          manualTrigger {
            id
            name
            action {
              id
              status
              description
              workflow {
                id
                status
              }
            }
          }
          form {
            id
            name
          }
          formV2 {
            id
            name
          }
        }
      }
      processingWorkspaceButton {
        id
        name
      }
    }
  }
`

/**
 * __usePushRowButtonNodesSubscription__
 *
 * To run a query within a React component, call `usePushRowButtonNodesSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushRowButtonNodesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushRowButtonNodesSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushRowButtonNodesSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PushRowButtonNodesSubscription,
    PushRowButtonNodesSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    PushRowButtonNodesSubscription,
    PushRowButtonNodesSubscriptionVariables
  >(PushRowButtonNodesDocument, options)
}
export type PushRowButtonNodesSubscriptionHookResult = ReturnType<
  typeof usePushRowButtonNodesSubscription
>
export type PushRowButtonNodesSubscriptionResult =
  Apollo.SubscriptionResult<PushRowButtonNodesSubscription>
export const CreateAppOAuth2AuthorizationRequestDocument = gql`
  mutation CreateAppOAuth2AuthorizationRequest($input: CreateAppOAuth2AuthorizationRequestInput!) {
    createAppOAuth2AuthorizationRequest(input: $input) {
      success
      requestId
      error
    }
  }
`
export type CreateAppOAuth2AuthorizationRequestMutationFn = Apollo.MutationFunction<
  CreateAppOAuth2AuthorizationRequestMutation,
  CreateAppOAuth2AuthorizationRequestMutationVariables
>

/**
 * __useCreateAppOAuth2AuthorizationRequestMutation__
 *
 * To run a mutation, you first call `useCreateAppOAuth2AuthorizationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppOAuth2AuthorizationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppOAuth2AuthorizationRequestMutation, { data, loading, error }] = useCreateAppOAuth2AuthorizationRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppOAuth2AuthorizationRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAppOAuth2AuthorizationRequestMutation,
    CreateAppOAuth2AuthorizationRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateAppOAuth2AuthorizationRequestMutation,
    CreateAppOAuth2AuthorizationRequestMutationVariables
  >(CreateAppOAuth2AuthorizationRequestDocument, options)
}
export type CreateAppOAuth2AuthorizationRequestMutationHookResult = ReturnType<
  typeof useCreateAppOAuth2AuthorizationRequestMutation
>
export type CreateAppOAuth2AuthorizationRequestMutationResult =
  Apollo.MutationResult<CreateAppOAuth2AuthorizationRequestMutation>
export type CreateAppOAuth2AuthorizationRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateAppOAuth2AuthorizationRequestMutation,
  CreateAppOAuth2AuthorizationRequestMutationVariables
>
export const AuthorizeAppOAuth2RequestDocument = gql`
  mutation AuthorizeAppOAuth2Request($requestId: ID!) {
    authorizeAppOAuth2Request(requestId: $requestId) {
      success
      authorizationCode
      redirectUri
      state
      error
    }
  }
`
export type AuthorizeAppOAuth2RequestMutationFn = Apollo.MutationFunction<
  AuthorizeAppOAuth2RequestMutation,
  AuthorizeAppOAuth2RequestMutationVariables
>

/**
 * __useAuthorizeAppOAuth2RequestMutation__
 *
 * To run a mutation, you first call `useAuthorizeAppOAuth2RequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizeAppOAuth2RequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authorizeAppOAuth2RequestMutation, { data, loading, error }] = useAuthorizeAppOAuth2RequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useAuthorizeAppOAuth2RequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AuthorizeAppOAuth2RequestMutation,
    AuthorizeAppOAuth2RequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AuthorizeAppOAuth2RequestMutation,
    AuthorizeAppOAuth2RequestMutationVariables
  >(AuthorizeAppOAuth2RequestDocument, options)
}
export type AuthorizeAppOAuth2RequestMutationHookResult = ReturnType<
  typeof useAuthorizeAppOAuth2RequestMutation
>
export type AuthorizeAppOAuth2RequestMutationResult =
  Apollo.MutationResult<AuthorizeAppOAuth2RequestMutation>
export type AuthorizeAppOAuth2RequestMutationOptions = Apollo.BaseMutationOptions<
  AuthorizeAppOAuth2RequestMutation,
  AuthorizeAppOAuth2RequestMutationVariables
>
export const PushNotificationDocument = gql`
  subscription pushNotification {
    pushNotification {
      objectId
      objectType
      objectName
      event {
        id
        createdAt
        type
        data
        createdBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`

/**
 * __usePushNotificationSubscription__
 *
 * To run a query within a React component, call `usePushNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushNotificationSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePushNotificationSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PushNotificationSubscription,
    PushNotificationSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    PushNotificationSubscription,
    PushNotificationSubscriptionVariables
  >(PushNotificationDocument, options)
}
export type PushNotificationSubscriptionHookResult = ReturnType<
  typeof usePushNotificationSubscription
>
export type PushNotificationSubscriptionResult =
  Apollo.SubscriptionResult<PushNotificationSubscription>
export const AcceptTermsAndConditionsDocument = gql`
  mutation acceptTermsAndConditions {
    acceptTermsAndConditions {
      id
      policiesAcceptedAt
    }
  }
`
export type AcceptTermsAndConditionsMutationFn = Apollo.MutationFunction<
  AcceptTermsAndConditionsMutation,
  AcceptTermsAndConditionsMutationVariables
>

/**
 * __useAcceptTermsAndConditionsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsAndConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsAndConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsAndConditionsMutation, { data, loading, error }] = useAcceptTermsAndConditionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptTermsAndConditionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptTermsAndConditionsMutation,
    AcceptTermsAndConditionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AcceptTermsAndConditionsMutation,
    AcceptTermsAndConditionsMutationVariables
  >(AcceptTermsAndConditionsDocument, options)
}
export type AcceptTermsAndConditionsMutationHookResult = ReturnType<
  typeof useAcceptTermsAndConditionsMutation
>
export type AcceptTermsAndConditionsMutationResult =
  Apollo.MutationResult<AcceptTermsAndConditionsMutation>
export type AcceptTermsAndConditionsMutationOptions = Apollo.BaseMutationOptions<
  AcceptTermsAndConditionsMutation,
  AcceptTermsAndConditionsMutationVariables
>
export const GetRecordWorkspaceDetailsDocument = gql`
  query getRecordWorkspaceDetails($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      name
      views {
        id
        order
        unitHeight
        unitWidth
        rowNumber
        viewableObjectType
        workspace {
          id
          name
          updatedAt
          updatedBy {
            id
            firstName
            lastName
          }
        }
        chart {
          id
          name
        }
        table {
          id
          name
          icon {
            id
            name
          }
          tableTabs {
            id
            order
          }
        }
        document {
          id
          name
          documentType
          updatedAt
          updatedBy {
            id
            firstName
            lastName
          }
          storageUrl
        }
        tableRow {
          id
          table {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useGetRecordWorkspaceDetailsQuery__
 *
 * To run a query within a React component, call `useGetRecordWorkspaceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordWorkspaceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordWorkspaceDetailsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetRecordWorkspaceDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRecordWorkspaceDetailsQuery,
    GetRecordWorkspaceDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRecordWorkspaceDetailsQuery, GetRecordWorkspaceDetailsQueryVariables>(
    GetRecordWorkspaceDetailsDocument,
    options,
  )
}
export function useGetRecordWorkspaceDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRecordWorkspaceDetailsQuery,
    GetRecordWorkspaceDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetRecordWorkspaceDetailsQuery,
    GetRecordWorkspaceDetailsQueryVariables
  >(GetRecordWorkspaceDetailsDocument, options)
}
export type GetRecordWorkspaceDetailsQueryHookResult = ReturnType<
  typeof useGetRecordWorkspaceDetailsQuery
>
export type GetRecordWorkspaceDetailsLazyQueryHookResult = ReturnType<
  typeof useGetRecordWorkspaceDetailsLazyQuery
>
export type GetRecordWorkspaceDetailsQueryResult = Apollo.QueryResult<
  GetRecordWorkspaceDetailsQuery,
  GetRecordWorkspaceDetailsQueryVariables
>
export const DeleteWorkspaceDocument = gql`
  mutation deleteWorkspace($workspaceId: ID!) {
    deleteWorkspace(workspaceId: $workspaceId) {
      id
    }
  }
`
export type DeleteWorkspaceMutationFn = Apollo.MutationFunction<
  DeleteWorkspaceMutation,
  DeleteWorkspaceMutationVariables
>

/**
 * __useDeleteWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceMutation, { data, loading, error }] = useDeleteWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkspaceMutation,
    DeleteWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>(
    DeleteWorkspaceDocument,
    options,
  )
}
export type DeleteWorkspaceMutationHookResult = ReturnType<typeof useDeleteWorkspaceMutation>
export type DeleteWorkspaceMutationResult = Apollo.MutationResult<DeleteWorkspaceMutation>
export type DeleteWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorkspaceMutation,
  DeleteWorkspaceMutationVariables
>
export const DeleteDirectoryWorkspaceDocument = gql`
  mutation deleteDirectoryWorkspace($workspaceId: ID!) {
    deleteDirectoryWorkspace(workspaceId: $workspaceId) {
      id
    }
  }
`
export type DeleteDirectoryWorkspaceMutationFn = Apollo.MutationFunction<
  DeleteDirectoryWorkspaceMutation,
  DeleteDirectoryWorkspaceMutationVariables
>

/**
 * __useDeleteDirectoryWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteDirectoryWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDirectoryWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDirectoryWorkspaceMutation, { data, loading, error }] = useDeleteDirectoryWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteDirectoryWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDirectoryWorkspaceMutation,
    DeleteDirectoryWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDirectoryWorkspaceMutation,
    DeleteDirectoryWorkspaceMutationVariables
  >(DeleteDirectoryWorkspaceDocument, options)
}
export type DeleteDirectoryWorkspaceMutationHookResult = ReturnType<
  typeof useDeleteDirectoryWorkspaceMutation
>
export type DeleteDirectoryWorkspaceMutationResult =
  Apollo.MutationResult<DeleteDirectoryWorkspaceMutation>
export type DeleteDirectoryWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  DeleteDirectoryWorkspaceMutation,
  DeleteDirectoryWorkspaceMutationVariables
>
export const UpdateDocumentDocument = gql`
  mutation updateDocument($input: UpdateDocumentInput!) {
    updateDocument(input: $input) {
      id
      name
    }
  }
`
export type UpdateDocumentMutationFn = Apollo.MutationFunction<
  UpdateDocumentMutation,
  UpdateDocumentMutationVariables
>

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(
    UpdateDocumentDocument,
    options,
  )
}
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<
  UpdateDocumentMutation,
  UpdateDocumentMutationVariables
>
export const DownloadWorkspaceDocumentsDocument = gql`
  mutation downloadWorkspaceDocuments($workspaceId: ID!) {
    downloadWorkspaceDocuments(workspaceId: $workspaceId)
  }
`
export type DownloadWorkspaceDocumentsMutationFn = Apollo.MutationFunction<
  DownloadWorkspaceDocumentsMutation,
  DownloadWorkspaceDocumentsMutationVariables
>

/**
 * __useDownloadWorkspaceDocumentsMutation__
 *
 * To run a mutation, you first call `useDownloadWorkspaceDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadWorkspaceDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadWorkspaceDocumentsMutation, { data, loading, error }] = useDownloadWorkspaceDocumentsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDownloadWorkspaceDocumentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DownloadWorkspaceDocumentsMutation,
    DownloadWorkspaceDocumentsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DownloadWorkspaceDocumentsMutation,
    DownloadWorkspaceDocumentsMutationVariables
  >(DownloadWorkspaceDocumentsDocument, options)
}
export type DownloadWorkspaceDocumentsMutationHookResult = ReturnType<
  typeof useDownloadWorkspaceDocumentsMutation
>
export type DownloadWorkspaceDocumentsMutationResult =
  Apollo.MutationResult<DownloadWorkspaceDocumentsMutation>
export type DownloadWorkspaceDocumentsMutationOptions = Apollo.BaseMutationOptions<
  DownloadWorkspaceDocumentsMutation,
  DownloadWorkspaceDocumentsMutationVariables
>
export const MoveWorkspaceDocument = gql`
  mutation moveWorkspace($input: MoveWorkspaceInput!) {
    moveWorkspace(input: $input) {
      id
    }
  }
`
export type MoveWorkspaceMutationFn = Apollo.MutationFunction<
  MoveWorkspaceMutation,
  MoveWorkspaceMutationVariables
>

/**
 * __useMoveWorkspaceMutation__
 *
 * To run a mutation, you first call `useMoveWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveWorkspaceMutation, { data, loading, error }] = useMoveWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<MoveWorkspaceMutation, MoveWorkspaceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MoveWorkspaceMutation, MoveWorkspaceMutationVariables>(
    MoveWorkspaceDocument,
    options,
  )
}
export type MoveWorkspaceMutationHookResult = ReturnType<typeof useMoveWorkspaceMutation>
export type MoveWorkspaceMutationResult = Apollo.MutationResult<MoveWorkspaceMutation>
export type MoveWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  MoveWorkspaceMutation,
  MoveWorkspaceMutationVariables
>
export const SearchWorkspaceDocument = gql`
  mutation searchWorkspace($input: SearchWorkspaceInput!) {
    searchWorkspace(input: $input) {
      workspaces {
        id
        name
        updatedAt
        updatedBy {
          id
          firstName
          lastName
        }
      }
      documents {
        id
        name
        documentType
        updatedAt
        updatedBy {
          id
          firstName
          lastName
        }
        storageUrl
      }
    }
  }
`
export type SearchWorkspaceMutationFn = Apollo.MutationFunction<
  SearchWorkspaceMutation,
  SearchWorkspaceMutationVariables
>

/**
 * __useSearchWorkspaceMutation__
 *
 * To run a mutation, you first call `useSearchWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchWorkspaceMutation, { data, loading, error }] = useSearchWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SearchWorkspaceMutation,
    SearchWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SearchWorkspaceMutation, SearchWorkspaceMutationVariables>(
    SearchWorkspaceDocument,
    options,
  )
}
export type SearchWorkspaceMutationHookResult = ReturnType<typeof useSearchWorkspaceMutation>
export type SearchWorkspaceMutationResult = Apollo.MutationResult<SearchWorkspaceMutation>
export type SearchWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  SearchWorkspaceMutation,
  SearchWorkspaceMutationVariables
>
export const WorkspaceDeletionProgressDocument = gql`
  subscription workspaceDeletionProgress($userId: ID!) {
    workspaceDeletionProgress(userId: $userId) {
      objectId
      completedCount
      totalCount
    }
  }
`

/**
 * __useWorkspaceDeletionProgressSubscription__
 *
 * To run a query within a React component, call `useWorkspaceDeletionProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceDeletionProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceDeletionProgressSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useWorkspaceDeletionProgressSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    WorkspaceDeletionProgressSubscription,
    WorkspaceDeletionProgressSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    WorkspaceDeletionProgressSubscription,
    WorkspaceDeletionProgressSubscriptionVariables
  >(WorkspaceDeletionProgressDocument, options)
}
export type WorkspaceDeletionProgressSubscriptionHookResult = ReturnType<
  typeof useWorkspaceDeletionProgressSubscription
>
export type WorkspaceDeletionProgressSubscriptionResult =
  Apollo.SubscriptionResult<WorkspaceDeletionProgressSubscription>
export const AddRecordGetTableDetailsDocument = gql`
  query addRecordGetTableDetails($tableId: ID!) {
    table(tableId: $tableId) {
      id
      name
      columns {
        id
        name
        order
        type
        innerType
        isNullable
        isReadOnly
        indexType
        indexPrefix
        indexSuffix
        indexAutogenerate
        enumOptions
        ...EnumSetFields
        ...ColumnFormatting
        displayImagesInline
        lookupColumn {
          id
          name
          type
          table {
            id
          }
        }
        lookupFilterExpression {
          id
          logicExpressionString
        }
        lookupColumnGroup {
          id
        }
      }
      childTables {
        id
        orderOnRecordDetails
        icon {
          id
          name
        }
      }
    }
  }
  ${EnumSetFieldsFragmentDoc}
  ${ColumnFormattingFragmentDoc}
`

/**
 * __useAddRecordGetTableDetailsQuery__
 *
 * To run a query within a React component, call `useAddRecordGetTableDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddRecordGetTableDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddRecordGetTableDetailsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useAddRecordGetTableDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AddRecordGetTableDetailsQuery,
    AddRecordGetTableDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AddRecordGetTableDetailsQuery, AddRecordGetTableDetailsQueryVariables>(
    AddRecordGetTableDetailsDocument,
    options,
  )
}
export function useAddRecordGetTableDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AddRecordGetTableDetailsQuery,
    AddRecordGetTableDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AddRecordGetTableDetailsQuery, AddRecordGetTableDetailsQueryVariables>(
    AddRecordGetTableDetailsDocument,
    options,
  )
}
export type AddRecordGetTableDetailsQueryHookResult = ReturnType<
  typeof useAddRecordGetTableDetailsQuery
>
export type AddRecordGetTableDetailsLazyQueryHookResult = ReturnType<
  typeof useAddRecordGetTableDetailsLazyQuery
>
export type AddRecordGetTableDetailsQueryResult = Apollo.QueryResult<
  AddRecordGetTableDetailsQuery,
  AddRecordGetTableDetailsQueryVariables
>
export const CreateTableRowDocument = gql`
  mutation createTableRow($input: CreateTableRowInput!) {
    createTableRow(input: $input) {
      id
    }
  }
`
export type CreateTableRowMutationFn = Apollo.MutationFunction<
  CreateTableRowMutation,
  CreateTableRowMutationVariables
>

/**
 * __useCreateTableRowMutation__
 *
 * To run a mutation, you first call `useCreateTableRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableRowMutation, { data, loading, error }] = useCreateTableRowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTableRowMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTableRowMutation, CreateTableRowMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTableRowMutation, CreateTableRowMutationVariables>(
    CreateTableRowDocument,
    options,
  )
}
export type CreateTableRowMutationHookResult = ReturnType<typeof useCreateTableRowMutation>
export type CreateTableRowMutationResult = Apollo.MutationResult<CreateTableRowMutation>
export type CreateTableRowMutationOptions = Apollo.BaseMutationOptions<
  CreateTableRowMutation,
  CreateTableRowMutationVariables
>
export const UpdateTableCellDocument = gql`
  mutation updateTableCell($input: UpdateTableCellInput!) {
    updateTableCell(input: $input) {
      id
      data
      userVisibleValue
      formulaError
      updatedAt
      column {
        id
        formatOptions
        formatPreset
        type
        lookupColumn {
          id
          type
        }
      }
      documents {
        id
        name
      }
      users {
        id
        firstName
        lastName
        email
      }
      lookupCells {
        id
        formulaError
        row {
          id
        }
        documents {
          id
        }
      }
    }
  }
`
export type UpdateTableCellMutationFn = Apollo.MutationFunction<
  UpdateTableCellMutation,
  UpdateTableCellMutationVariables
>

/**
 * __useUpdateTableCellMutation__
 *
 * To run a mutation, you first call `useUpdateTableCellMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableCellMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableCellMutation, { data, loading, error }] = useUpdateTableCellMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableCellMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTableCellMutation,
    UpdateTableCellMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTableCellMutation, UpdateTableCellMutationVariables>(
    UpdateTableCellDocument,
    options,
  )
}
export type UpdateTableCellMutationHookResult = ReturnType<typeof useUpdateTableCellMutation>
export type UpdateTableCellMutationResult = Apollo.MutationResult<UpdateTableCellMutation>
export type UpdateTableCellMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableCellMutation,
  UpdateTableCellMutationVariables
>
export const UpdateTableRowDocument = gql`
  mutation updateTableRow($input: UpdateTableRowInput!) {
    updateTableRow(input: $input) {
      id
      updatedAt
      updatedBy {
        id
        firstName
        lastName
        email
      }
      cells {
        id
        data
        userVisibleValue
        formulaError
        updatedAt
        column {
          id
          formatOptions
          formatPreset
          type
          lookupColumn {
            id
            type
          }
        }
        lookupCells {
          id
          userVisibleValue
          formulaError
          documents {
            id
          }
          row {
            id
          }
        }
        documents {
          id
          name
        }
        users {
          id
          firstName
          lastName
          email
        }
      }
      table {
        columns {
          lookupColumnChildren {
            id
            table {
              id
            }
            lookupColumnGroup {
              id
              showBacklink
            }
          }
        }
      }
      currentButtonNodes {
        id
        name
        workspaceButtons {
          id
          name
          order
          buttonConfiguration
          requiresConfirmation
          confirmationMessage
          icon {
            id
            name
          }
          manualTrigger {
            id
            name
            action {
              id
              status
              description
              workflow {
                id
                status
              }
            }
          }
          form {
            id
            name
          }
          formV2 {
            id
            name
          }
        }
      }
      processingWorkspaceButton {
        id
        name
      }
    }
  }
`
export type UpdateTableRowMutationFn = Apollo.MutationFunction<
  UpdateTableRowMutation,
  UpdateTableRowMutationVariables
>

/**
 * __useUpdateTableRowMutation__
 *
 * To run a mutation, you first call `useUpdateTableRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableRowMutation, { data, loading, error }] = useUpdateTableRowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableRowMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTableRowMutation, UpdateTableRowMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTableRowMutation, UpdateTableRowMutationVariables>(
    UpdateTableRowDocument,
    options,
  )
}
export type UpdateTableRowMutationHookResult = ReturnType<typeof useUpdateTableRowMutation>
export type UpdateTableRowMutationResult = Apollo.MutationResult<UpdateTableRowMutation>
export type UpdateTableRowMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableRowMutation,
  UpdateTableRowMutationVariables
>
export const DuplicateTableRowDocument = gql`
  mutation duplicateTableRow($tableRowId: ID!) {
    duplicateTableRow(tableRowId: $tableRowId) {
      id
    }
  }
`
export type DuplicateTableRowMutationFn = Apollo.MutationFunction<
  DuplicateTableRowMutation,
  DuplicateTableRowMutationVariables
>

/**
 * __useDuplicateTableRowMutation__
 *
 * To run a mutation, you first call `useDuplicateTableRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateTableRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateTableRowMutation, { data, loading, error }] = useDuplicateTableRowMutation({
 *   variables: {
 *      tableRowId: // value for 'tableRowId'
 *   },
 * });
 */
export function useDuplicateTableRowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateTableRowMutation,
    DuplicateTableRowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DuplicateTableRowMutation, DuplicateTableRowMutationVariables>(
    DuplicateTableRowDocument,
    options,
  )
}
export type DuplicateTableRowMutationHookResult = ReturnType<typeof useDuplicateTableRowMutation>
export type DuplicateTableRowMutationResult = Apollo.MutationResult<DuplicateTableRowMutation>
export type DuplicateTableRowMutationOptions = Apollo.BaseMutationOptions<
  DuplicateTableRowMutation,
  DuplicateTableRowMutationVariables
>
export const GetTableRowDocument = gql`
  query getTableRow($tableRowId: ID!) {
    tableRow(tableRowId: $tableRowId) {
      id
      name
      createdAt
      createdBy {
        id
        firstName
        lastName
        email
      }
      updatedAt
      updatedBy {
        id
        firstName
        lastName
        email
      }
      rootWorkspace {
        id
        actionButtons {
          id
          name
          order
          manualTrigger {
            id
            action {
              id
              status
              workflow {
                id
                status
              }
            }
          }
          form {
            id
          }
          formV2 {
            id
          }
        }
      }
      cells {
        id
        data
        userVisibleValue
        formulaError
        updatedAt
        lookupCells {
          id
          formulaError
          row {
            id
          }
          documents {
            id
          }
        }
        documents {
          id
          name
        }
        users {
          id
          firstName
          lastName
          email
        }
        column {
          id
          order
          name
          description
          type
          indexType
          indexPrefix
          indexSuffix
          enumOptions
          ...EnumSetFields
          innerType
          isNullable
          isReadOnly
          indexType
          indexAutogenerate
          displayImagesInline
          isVisibleOnRecordDetails
          ...ColumnFormatting
          ...ResolvedSourceColumn
          lookupColumn {
            ...LookupProviderColumn
            name
          }
          lookupFilterExpression {
            id
            logicExpressionString
          }
          formula {
            id
          }
          lookupColumnGroup {
            id
            lookupTable {
              id
              name
            }
          }
        }
      }
      table {
        id
        name
        showRowWorkspace
        childTables {
          id
          name
          orderOnRecordDetails
          icon {
            id
            name
          }
          columns {
            ...GetTableRowDetailedColumnHeader
          }
        }
        columns {
          id
          isNullable
          indexAutogenerate
          type
          lookupColumnChildren {
            id
            table {
              id
              name
              orderOnRecordDetails
              icon {
                id
                name
              }
              columns {
                ...GetTableRowDetailedColumnHeader
              }
            }
            lookupColumnGroup {
              id
              showBacklink
            }
          }
        }
        columnGroups {
          id
          name
          order
          columns {
            id
            order
            tableColumn {
              ...DetailedTableColumn
              lookupColumnGroup {
                id
              }
            }
          }
        }
      }
      currentButtonNodes {
        id
        name
        workspaceButtons {
          id
          name
          order
          buttonConfiguration
          requiresConfirmation
          confirmationMessage
          icon {
            id
            name
          }
          manualTrigger {
            id
            name
            action {
              id
              status
              description
              workflow {
                id
                status
              }
            }
          }
          form {
            id
            name
          }
          formV2 {
            id
            name
          }
        }
      }
      processingWorkspaceButton {
        id
        name
      }
    }
  }
  ${EnumSetFieldsFragmentDoc}
  ${ColumnFormattingFragmentDoc}
  ${ResolvedSourceColumnFragmentDoc}
  ${LookupProviderColumnFragmentDoc}
  ${GetTableRowDetailedColumnHeaderFragmentDoc}
  ${DetailedTableColumnFragmentDoc}
`

/**
 * __useGetTableRowQuery__
 *
 * To run a query within a React component, call `useGetTableRowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableRowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableRowQuery({
 *   variables: {
 *      tableRowId: // value for 'tableRowId'
 *   },
 * });
 */
export function useGetTableRowQuery(
  baseOptions: Apollo.QueryHookOptions<GetTableRowQuery, GetTableRowQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTableRowQuery, GetTableRowQueryVariables>(GetTableRowDocument, options)
}
export function useGetTableRowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTableRowQuery, GetTableRowQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTableRowQuery, GetTableRowQueryVariables>(
    GetTableRowDocument,
    options,
  )
}
export type GetTableRowQueryHookResult = ReturnType<typeof useGetTableRowQuery>
export type GetTableRowLazyQueryHookResult = ReturnType<typeof useGetTableRowLazyQuery>
export type GetTableRowQueryResult = Apollo.QueryResult<GetTableRowQuery, GetTableRowQueryVariables>
export const GetLookupColumnGroupDocument = gql`
  query getLookupColumnGroup($lookupTableColumnGroupId: ID!) {
    lookupTableColumnGroup(lookupTableColumnGroupId: $lookupTableColumnGroupId) {
      id
      lookupTable {
        id
        name
        parentTable {
          id
          name
          columns {
            id
            name
          }
        }
        columns {
          id
          name
          order
          type
          innerType
          ...ColumnFormatting
          ...ResolvedSourceColumn
          lookupColumn {
            ...LookupProviderColumn
          }
        }
        childTables {
          id
          name
          columns {
            id
            name
          }
        }
      }
      columns {
        id
        lookupColumn {
          id
        }
      }
    }
  }
  ${ColumnFormattingFragmentDoc}
  ${ResolvedSourceColumnFragmentDoc}
  ${LookupProviderColumnFragmentDoc}
`

/**
 * __useGetLookupColumnGroupQuery__
 *
 * To run a query within a React component, call `useGetLookupColumnGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLookupColumnGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLookupColumnGroupQuery({
 *   variables: {
 *      lookupTableColumnGroupId: // value for 'lookupTableColumnGroupId'
 *   },
 * });
 */
export function useGetLookupColumnGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLookupColumnGroupQuery,
    GetLookupColumnGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetLookupColumnGroupQuery, GetLookupColumnGroupQueryVariables>(
    GetLookupColumnGroupDocument,
    options,
  )
}
export function useGetLookupColumnGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLookupColumnGroupQuery,
    GetLookupColumnGroupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetLookupColumnGroupQuery, GetLookupColumnGroupQueryVariables>(
    GetLookupColumnGroupDocument,
    options,
  )
}
export type GetLookupColumnGroupQueryHookResult = ReturnType<typeof useGetLookupColumnGroupQuery>
export type GetLookupColumnGroupLazyQueryHookResult = ReturnType<
  typeof useGetLookupColumnGroupLazyQuery
>
export type GetLookupColumnGroupQueryResult = Apollo.QueryResult<
  GetLookupColumnGroupQuery,
  GetLookupColumnGroupQueryVariables
>
export const GetLookupTableRowsDocument = gql`
  query getLookupTableRows($input: PaginatedLookupRowsInput!) {
    paginatedLookupRows(input: $input) {
      offset
      hasNext
      totalCount
      rows {
        id
        name
        cells {
          id
          data
          userVisibleValue
          formulaError
          column {
            id
            name
            type
            order
            enumOptions
            innerType
            isNullable
            displayImagesInline
            ...ColumnFormatting
            ...ResolvedSourceColumn
          }
          row {
            id
          }
          documents {
            id
          }
        }
        currentButtonNodes {
          id
          name
          workspaceButtons {
            id
            name
            order
            buttonConfiguration
            requiresConfirmation
            confirmationMessage
            icon {
              id
              name
            }
            manualTrigger {
              id
              name
              action {
                id
                status
                description
                workflow {
                  id
                  status
                }
              }
            }
            form {
              id
              name
            }
            formV2 {
              id
              name
            }
          }
        }
        processingWorkspaceButton {
          id
          name
        }
      }
    }
  }
  ${ColumnFormattingFragmentDoc}
  ${ResolvedSourceColumnFragmentDoc}
`

/**
 * __useGetLookupTableRowsQuery__
 *
 * To run a query within a React component, call `useGetLookupTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLookupTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLookupTableRowsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLookupTableRowsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLookupTableRowsQuery, GetLookupTableRowsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetLookupTableRowsQuery, GetLookupTableRowsQueryVariables>(
    GetLookupTableRowsDocument,
    options,
  )
}
export function useGetLookupTableRowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLookupTableRowsQuery,
    GetLookupTableRowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetLookupTableRowsQuery, GetLookupTableRowsQueryVariables>(
    GetLookupTableRowsDocument,
    options,
  )
}
export type GetLookupTableRowsQueryHookResult = ReturnType<typeof useGetLookupTableRowsQuery>
export type GetLookupTableRowsLazyQueryHookResult = ReturnType<
  typeof useGetLookupTableRowsLazyQuery
>
export type GetLookupTableRowsQueryResult = Apollo.QueryResult<
  GetLookupTableRowsQuery,
  GetLookupTableRowsQueryVariables
>
export const UpdatedTableRowDetailsDocument = gql`
  subscription updatedTableRowDetails($tableRowId: ID!) {
    updatedTableRowDetails(tableRowId: $tableRowId) {
      id
      name
      createdAt
      createdBy {
        id
        firstName
        lastName
        email
      }
      updatedAt
      updatedBy {
        id
        firstName
        lastName
        email
      }
      rootWorkspace {
        id
        actionButtons {
          id
          name
          order
          manualTrigger {
            id
            action {
              id
              status
              workflow {
                id
                status
              }
            }
          }
          form {
            id
          }
          formV2 {
            id
          }
        }
      }
      cells {
        id
        data
        userVisibleValue
        formulaError
        updatedAt
        lookupCells {
          id
          userVisibleValue
          formulaError
          documents {
            id
          }
          row {
            id
          }
        }
        documents {
          id
          name
        }
        users {
          id
          firstName
          lastName
          email
        }
        column {
          id
          order
          name
          description
          type
          indexType
          indexPrefix
          indexSuffix
          enumOptions
          ...EnumSetFields
          innerType
          isNullable
          isReadOnly
          indexType
          indexAutogenerate
          displayImagesInline
          isVisibleOnRecordDetails
          ...ColumnFormatting
          ...ResolvedSourceColumn
          lookupColumn {
            ...LookupProviderColumn
            name
          }
          lookupFilterExpression {
            id
            logicExpressionString
          }
          formula {
            id
          }
          lookupColumnGroup {
            id
            lookupTable {
              id
              name
            }
          }
        }
      }
      table {
        id
        name
        showRowWorkspace
        columns {
          id
          isNullable
          indexAutogenerate
          type
          lookupColumnChildren {
            id
            table {
              id
              name
              orderOnRecordDetails
              icon {
                id
                name
              }
              columns {
                ...GetTableRowDetailedColumnHeader
              }
            }
            lookupColumnGroup {
              id
              showBacklink
            }
          }
        }
        childTables {
          id
          name
          orderOnRecordDetails
          icon {
            id
            name
          }
          columns {
            ...GetTableRowDetailedColumnHeader
          }
        }
        columnGroups {
          id
          name
          order
          columns {
            id
            order
            tableColumn {
              ...DetailedTableColumn
              lookupColumnGroup {
                id
              }
            }
          }
        }
      }
      currentButtonNodes {
        id
        name
        workspaceButtons {
          id
          name
          order
          buttonConfiguration
          requiresConfirmation
          confirmationMessage
          icon {
            id
            name
          }
          manualTrigger {
            id
            name
            action {
              id
              status
              description
              workflow {
                id
                status
              }
            }
          }
          form {
            id
            name
          }
          formV2 {
            id
            name
          }
        }
      }
      processingWorkspaceButton {
        id
        name
      }
    }
  }
  ${EnumSetFieldsFragmentDoc}
  ${ColumnFormattingFragmentDoc}
  ${ResolvedSourceColumnFragmentDoc}
  ${LookupProviderColumnFragmentDoc}
  ${GetTableRowDetailedColumnHeaderFragmentDoc}
  ${DetailedTableColumnFragmentDoc}
`

/**
 * __useUpdatedTableRowDetailsSubscription__
 *
 * To run a query within a React component, call `useUpdatedTableRowDetailsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedTableRowDetailsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedTableRowDetailsSubscription({
 *   variables: {
 *      tableRowId: // value for 'tableRowId'
 *   },
 * });
 */
export function useUpdatedTableRowDetailsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UpdatedTableRowDetailsSubscription,
    UpdatedTableRowDetailsSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    UpdatedTableRowDetailsSubscription,
    UpdatedTableRowDetailsSubscriptionVariables
  >(UpdatedTableRowDetailsDocument, options)
}
export type UpdatedTableRowDetailsSubscriptionHookResult = ReturnType<
  typeof useUpdatedTableRowDetailsSubscription
>
export type UpdatedTableRowDetailsSubscriptionResult =
  Apollo.SubscriptionResult<UpdatedTableRowDetailsSubscription>
export const GetSelectedLookupRowsDocument = gql`
  query getSelectedLookupRows($rowIds: [ID!]!) {
    tableRows(rowIds: $rowIds) {
      id
      name
      cells {
        id
        userVisibleValue
        formulaError
        data
        column {
          id
          name
          type
          order
          enumOptions
          innerType
          isNullable
          displayImagesInline
          ...ColumnFormatting
          ...ResolvedSourceColumn
        }
        row {
          id
        }
        documents {
          id
        }
      }
      currentButtonNodes {
        id
        name
        workspaceButtons {
          id
          name
          order
          buttonConfiguration
          requiresConfirmation
          confirmationMessage
          icon {
            id
            name
          }
          manualTrigger {
            id
            name
            action {
              id
              status
              description
              workflow {
                id
                status
              }
            }
          }
          form {
            id
            name
          }
          formV2 {
            id
            name
          }
        }
      }
      processingWorkspaceButton {
        id
        name
      }
    }
  }
  ${ColumnFormattingFragmentDoc}
  ${ResolvedSourceColumnFragmentDoc}
`

/**
 * __useGetSelectedLookupRowsQuery__
 *
 * To run a query within a React component, call `useGetSelectedLookupRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedLookupRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedLookupRowsQuery({
 *   variables: {
 *      rowIds: // value for 'rowIds'
 *   },
 * });
 */
export function useGetSelectedLookupRowsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSelectedLookupRowsQuery,
    GetSelectedLookupRowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSelectedLookupRowsQuery, GetSelectedLookupRowsQueryVariables>(
    GetSelectedLookupRowsDocument,
    options,
  )
}
export function useGetSelectedLookupRowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSelectedLookupRowsQuery,
    GetSelectedLookupRowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSelectedLookupRowsQuery, GetSelectedLookupRowsQueryVariables>(
    GetSelectedLookupRowsDocument,
    options,
  )
}
export type GetSelectedLookupRowsQueryHookResult = ReturnType<typeof useGetSelectedLookupRowsQuery>
export type GetSelectedLookupRowsLazyQueryHookResult = ReturnType<
  typeof useGetSelectedLookupRowsLazyQuery
>
export type GetSelectedLookupRowsQueryResult = Apollo.QueryResult<
  GetSelectedLookupRowsQuery,
  GetSelectedLookupRowsQueryVariables
>
export const CreateFileCellDocumentViewDocument = gql`
  mutation createFileCellDocumentView($input: CreateDocumentViewInput!) {
    createDocumentView(input: $input) {
      id
      name
      documentType
      storageUrl
    }
  }
`
export type CreateFileCellDocumentViewMutationFn = Apollo.MutationFunction<
  CreateFileCellDocumentViewMutation,
  CreateFileCellDocumentViewMutationVariables
>

/**
 * __useCreateFileCellDocumentViewMutation__
 *
 * To run a mutation, you first call `useCreateFileCellDocumentViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileCellDocumentViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileCellDocumentViewMutation, { data, loading, error }] = useCreateFileCellDocumentViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFileCellDocumentViewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFileCellDocumentViewMutation,
    CreateFileCellDocumentViewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateFileCellDocumentViewMutation,
    CreateFileCellDocumentViewMutationVariables
  >(CreateFileCellDocumentViewDocument, options)
}
export type CreateFileCellDocumentViewMutationHookResult = ReturnType<
  typeof useCreateFileCellDocumentViewMutation
>
export type CreateFileCellDocumentViewMutationResult =
  Apollo.MutationResult<CreateFileCellDocumentViewMutation>
export type CreateFileCellDocumentViewMutationOptions = Apollo.BaseMutationOptions<
  CreateFileCellDocumentViewMutation,
  CreateFileCellDocumentViewMutationVariables
>
export const GetFileCellDocumentDocument = gql`
  query getFileCellDocument($documentId: ID!) {
    document(documentId: $documentId) {
      id
      name
      documentType
      storageUrl
      signature {
        id
        createdAt
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
`

/**
 * __useGetFileCellDocumentQuery__
 *
 * To run a query within a React component, call `useGetFileCellDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileCellDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileCellDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetFileCellDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<GetFileCellDocumentQuery, GetFileCellDocumentQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFileCellDocumentQuery, GetFileCellDocumentQueryVariables>(
    GetFileCellDocumentDocument,
    options,
  )
}
export function useGetFileCellDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFileCellDocumentQuery,
    GetFileCellDocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFileCellDocumentQuery, GetFileCellDocumentQueryVariables>(
    GetFileCellDocumentDocument,
    options,
  )
}
export type GetFileCellDocumentQueryHookResult = ReturnType<typeof useGetFileCellDocumentQuery>
export type GetFileCellDocumentLazyQueryHookResult = ReturnType<
  typeof useGetFileCellDocumentLazyQuery
>
export type GetFileCellDocumentQueryResult = Apollo.QueryResult<
  GetFileCellDocumentQuery,
  GetFileCellDocumentQueryVariables
>
export const DeleteDocumentDocument = gql`
  mutation deleteDocument($documentId: ID!) {
    deleteDocument(documentId: $documentId) {
      id
    }
  }
`
export type DeleteDocumentMutationFn = Apollo.MutationFunction<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(
    DeleteDocumentDocument,
    options,
  )
}
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>
export const GetEmbedDocument = gql`
  query GetEmbed($embedId: ID!) {
    embed(embedId: $embedId) {
      id
      name
      betaWatermarkDisabled
      viewContent {
        id
      }
    }
  }
`

/**
 * __useGetEmbedQuery__
 *
 * To run a query within a React component, call `useGetEmbedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmbedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmbedQuery({
 *   variables: {
 *      embedId: // value for 'embedId'
 *   },
 * });
 */
export function useGetEmbedQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmbedQuery, GetEmbedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetEmbedQuery, GetEmbedQueryVariables>(GetEmbedDocument, options)
}
export function useGetEmbedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmbedQuery, GetEmbedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetEmbedQuery, GetEmbedQueryVariables>(GetEmbedDocument, options)
}
export type GetEmbedQueryHookResult = ReturnType<typeof useGetEmbedQuery>
export type GetEmbedLazyQueryHookResult = ReturnType<typeof useGetEmbedLazyQuery>
export type GetEmbedQueryResult = Apollo.QueryResult<GetEmbedQuery, GetEmbedQueryVariables>
export const GetViewContentForEmbedDocument = gql`
  query GetViewContentForEmbed($id: ID!) {
    viewContent(id: $id) {
      id
      contentType
      latestVersion
      sourceSnapshotHash
      content
      sdkVersion
      contentHash
      appSdkGraph
      tableMappings
    }
  }
`

/**
 * __useGetViewContentForEmbedQuery__
 *
 * To run a query within a React component, call `useGetViewContentForEmbedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewContentForEmbedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewContentForEmbedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetViewContentForEmbedQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetViewContentForEmbedQuery,
    GetViewContentForEmbedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetViewContentForEmbedQuery, GetViewContentForEmbedQueryVariables>(
    GetViewContentForEmbedDocument,
    options,
  )
}
export function useGetViewContentForEmbedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetViewContentForEmbedQuery,
    GetViewContentForEmbedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetViewContentForEmbedQuery, GetViewContentForEmbedQueryVariables>(
    GetViewContentForEmbedDocument,
    options,
  )
}
export type GetViewContentForEmbedQueryHookResult = ReturnType<
  typeof useGetViewContentForEmbedQuery
>
export type GetViewContentForEmbedLazyQueryHookResult = ReturnType<
  typeof useGetViewContentForEmbedLazyQuery
>
export type GetViewContentForEmbedQueryResult = Apollo.QueryResult<
  GetViewContentForEmbedQuery,
  GetViewContentForEmbedQueryVariables
>
export const UpsertViewContentDocument = gql`
  mutation UpsertViewContent($input: UpsertViewContentInput!) {
    upsertViewContent(input: $input) {
      id
      contentType
      latestVersion
      sourceSnapshotHash
      content
      sdkVersion
      contentHash
      appSdkGraph
    }
  }
`
export type UpsertViewContentMutationFn = Apollo.MutationFunction<
  UpsertViewContentMutation,
  UpsertViewContentMutationVariables
>

/**
 * __useUpsertViewContentMutation__
 *
 * To run a mutation, you first call `useUpsertViewContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertViewContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertViewContentMutation, { data, loading, error }] = useUpsertViewContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertViewContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertViewContentMutation,
    UpsertViewContentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertViewContentMutation, UpsertViewContentMutationVariables>(
    UpsertViewContentDocument,
    options,
  )
}
export type UpsertViewContentMutationHookResult = ReturnType<typeof useUpsertViewContentMutation>
export type UpsertViewContentMutationResult = Apollo.MutationResult<UpsertViewContentMutation>
export type UpsertViewContentMutationOptions = Apollo.BaseMutationOptions<
  UpsertViewContentMutation,
  UpsertViewContentMutationVariables
>
export const UpdateEmbedViewContentDocument = gql`
  mutation UpdateEmbedViewContent($embedId: ID!, $viewContentId: ID) {
    updateEmbedViewContent(embedId: $embedId, viewContentId: $viewContentId) {
      id
      viewContent {
        id
      }
    }
  }
`
export type UpdateEmbedViewContentMutationFn = Apollo.MutationFunction<
  UpdateEmbedViewContentMutation,
  UpdateEmbedViewContentMutationVariables
>

/**
 * __useUpdateEmbedViewContentMutation__
 *
 * To run a mutation, you first call `useUpdateEmbedViewContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmbedViewContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmbedViewContentMutation, { data, loading, error }] = useUpdateEmbedViewContentMutation({
 *   variables: {
 *      embedId: // value for 'embedId'
 *      viewContentId: // value for 'viewContentId'
 *   },
 * });
 */
export function useUpdateEmbedViewContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmbedViewContentMutation,
    UpdateEmbedViewContentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateEmbedViewContentMutation,
    UpdateEmbedViewContentMutationVariables
  >(UpdateEmbedViewContentDocument, options)
}
export type UpdateEmbedViewContentMutationHookResult = ReturnType<
  typeof useUpdateEmbedViewContentMutation
>
export type UpdateEmbedViewContentMutationResult =
  Apollo.MutationResult<UpdateEmbedViewContentMutation>
export type UpdateEmbedViewContentMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmbedViewContentMutation,
  UpdateEmbedViewContentMutationVariables
>
export const RunUdsSqlDocument = gql`
  query RunUdsSql($sql: String!, $page: UdsSqlPageInput, $includeTotalCount: Boolean = false) {
    runUdsSql(sql: $sql, page: $page, includeTotalCount: $includeTotalCount) {
      rows
      resultBytes
      hasNext
      offset
      cursor
      totalCount
    }
  }
`

/**
 * __useRunUdsSqlQuery__
 *
 * To run a query within a React component, call `useRunUdsSqlQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunUdsSqlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunUdsSqlQuery({
 *   variables: {
 *      sql: // value for 'sql'
 *      page: // value for 'page'
 *      includeTotalCount: // value for 'includeTotalCount'
 *   },
 * });
 */
export function useRunUdsSqlQuery(
  baseOptions: Apollo.QueryHookOptions<RunUdsSqlQuery, RunUdsSqlQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RunUdsSqlQuery, RunUdsSqlQueryVariables>(RunUdsSqlDocument, options)
}
export function useRunUdsSqlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RunUdsSqlQuery, RunUdsSqlQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RunUdsSqlQuery, RunUdsSqlQueryVariables>(RunUdsSqlDocument, options)
}
export type RunUdsSqlQueryHookResult = ReturnType<typeof useRunUdsSqlQuery>
export type RunUdsSqlLazyQueryHookResult = ReturnType<typeof useRunUdsSqlLazyQuery>
export type RunUdsSqlQueryResult = Apollo.QueryResult<RunUdsSqlQuery, RunUdsSqlQueryVariables>
export const RunUdsSqlBatchDocument = gql`
  query RunUdsSqlBatch($statements: [UdsSqlStatementInput!]!) {
    runUdsSqlBatch(statements: $statements) {
      statements {
        result {
          rows
          resultBytes
          hasNext
          offset
          cursor
          totalCount
        }
        error {
          message
          code
          limitBytes
          resultBytes
          parameter
          requestedRows
          maxRows
        }
      }
    }
  }
`

/**
 * __useRunUdsSqlBatchQuery__
 *
 * To run a query within a React component, call `useRunUdsSqlBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunUdsSqlBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunUdsSqlBatchQuery({
 *   variables: {
 *      statements: // value for 'statements'
 *   },
 * });
 */
export function useRunUdsSqlBatchQuery(
  baseOptions: Apollo.QueryHookOptions<RunUdsSqlBatchQuery, RunUdsSqlBatchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RunUdsSqlBatchQuery, RunUdsSqlBatchQueryVariables>(
    RunUdsSqlBatchDocument,
    options,
  )
}
export function useRunUdsSqlBatchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RunUdsSqlBatchQuery, RunUdsSqlBatchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RunUdsSqlBatchQuery, RunUdsSqlBatchQueryVariables>(
    RunUdsSqlBatchDocument,
    options,
  )
}
export type RunUdsSqlBatchQueryHookResult = ReturnType<typeof useRunUdsSqlBatchQuery>
export type RunUdsSqlBatchLazyQueryHookResult = ReturnType<typeof useRunUdsSqlBatchLazyQuery>
export type RunUdsSqlBatchQueryResult = Apollo.QueryResult<
  RunUdsSqlBatchQuery,
  RunUdsSqlBatchQueryVariables
>
export const GetUdsSchemaForEmbedDocument = gql`
  query GetUdsSchemaForEmbed {
    tables {
      id
      slug
      udsSystemColumns {
        slug
        dataType
        isNullable
      }
      columns {
        id
        slug
        order
        udsDataType
        isNullable
      }
    }
  }
`

/**
 * __useGetUdsSchemaForEmbedQuery__
 *
 * To run a query within a React component, call `useGetUdsSchemaForEmbedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUdsSchemaForEmbedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUdsSchemaForEmbedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUdsSchemaForEmbedQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUdsSchemaForEmbedQuery,
    GetUdsSchemaForEmbedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUdsSchemaForEmbedQuery, GetUdsSchemaForEmbedQueryVariables>(
    GetUdsSchemaForEmbedDocument,
    options,
  )
}
export function useGetUdsSchemaForEmbedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUdsSchemaForEmbedQuery,
    GetUdsSchemaForEmbedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUdsSchemaForEmbedQuery, GetUdsSchemaForEmbedQueryVariables>(
    GetUdsSchemaForEmbedDocument,
    options,
  )
}
export type GetUdsSchemaForEmbedQueryHookResult = ReturnType<typeof useGetUdsSchemaForEmbedQuery>
export type GetUdsSchemaForEmbedLazyQueryHookResult = ReturnType<
  typeof useGetUdsSchemaForEmbedLazyQuery
>
export type GetUdsSchemaForEmbedQueryResult = Apollo.QueryResult<
  GetUdsSchemaForEmbedQuery,
  GetUdsSchemaForEmbedQueryVariables
>
export const AppTableRowsDocument = gql`
  query AppTableRows($input: AppTableRowsInput!) {
    appTableRows(input: $input) {
      rows {
        ...AppTableRowFields
      }
      select {
        as
        field
      }
      hasNext
      totalCount
    }
  }
  ${AppTableRowFieldsFragmentDoc}
`

/**
 * __useAppTableRowsQuery__
 *
 * To run a query within a React component, call `useAppTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppTableRowsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppTableRowsQuery(
  baseOptions: Apollo.QueryHookOptions<AppTableRowsQuery, AppTableRowsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AppTableRowsQuery, AppTableRowsQueryVariables>(
    AppTableRowsDocument,
    options,
  )
}
export function useAppTableRowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AppTableRowsQuery, AppTableRowsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AppTableRowsQuery, AppTableRowsQueryVariables>(
    AppTableRowsDocument,
    options,
  )
}
export type AppTableRowsQueryHookResult = ReturnType<typeof useAppTableRowsQuery>
export type AppTableRowsLazyQueryHookResult = ReturnType<typeof useAppTableRowsLazyQuery>
export type AppTableRowsQueryResult = Apollo.QueryResult<
  AppTableRowsQuery,
  AppTableRowsQueryVariables
>
export const AppTableRowCountDocument = gql`
  query AppTableRowCount($input: AppTableRowsInput!) {
    appTableRows(input: $input) {
      totalCount
    }
  }
`

/**
 * __useAppTableRowCountQuery__
 *
 * To run a query within a React component, call `useAppTableRowCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppTableRowCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppTableRowCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppTableRowCountQuery(
  baseOptions: Apollo.QueryHookOptions<AppTableRowCountQuery, AppTableRowCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AppTableRowCountQuery, AppTableRowCountQueryVariables>(
    AppTableRowCountDocument,
    options,
  )
}
export function useAppTableRowCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AppTableRowCountQuery, AppTableRowCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AppTableRowCountQuery, AppTableRowCountQueryVariables>(
    AppTableRowCountDocument,
    options,
  )
}
export type AppTableRowCountQueryHookResult = ReturnType<typeof useAppTableRowCountQuery>
export type AppTableRowCountLazyQueryHookResult = ReturnType<typeof useAppTableRowCountLazyQuery>
export type AppTableRowCountQueryResult = Apollo.QueryResult<
  AppTableRowCountQuery,
  AppTableRowCountQueryVariables
>
export const AppTableDistinctDocument = gql`
  query AppTableDistinct($input: AppTableDistinctInput!) {
    appTableDistinct(input: $input) {
      values {
        value
        display
        rowCount
      }
      truncated
    }
  }
`

/**
 * __useAppTableDistinctQuery__
 *
 * To run a query within a React component, call `useAppTableDistinctQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppTableDistinctQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppTableDistinctQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppTableDistinctQuery(
  baseOptions: Apollo.QueryHookOptions<AppTableDistinctQuery, AppTableDistinctQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AppTableDistinctQuery, AppTableDistinctQueryVariables>(
    AppTableDistinctDocument,
    options,
  )
}
export function useAppTableDistinctLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AppTableDistinctQuery, AppTableDistinctQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AppTableDistinctQuery, AppTableDistinctQueryVariables>(
    AppTableDistinctDocument,
    options,
  )
}
export type AppTableDistinctQueryHookResult = ReturnType<typeof useAppTableDistinctQuery>
export type AppTableDistinctLazyQueryHookResult = ReturnType<typeof useAppTableDistinctLazyQuery>
export type AppTableDistinctQueryResult = Apollo.QueryResult<
  AppTableDistinctQuery,
  AppTableDistinctQueryVariables
>
export const UpdatedAppTableRowDocument = gql`
  subscription UpdatedAppTableRow($input: AppTableRowSubscriptionInput!) {
    updatedAppTableRow(input: $input) {
      ...AppTableRowFields
    }
  }
  ${AppTableRowFieldsFragmentDoc}
`

/**
 * __useUpdatedAppTableRowSubscription__
 *
 * To run a query within a React component, call `useUpdatedAppTableRowSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedAppTableRowSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedAppTableRowSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatedAppTableRowSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UpdatedAppTableRowSubscription,
    UpdatedAppTableRowSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    UpdatedAppTableRowSubscription,
    UpdatedAppTableRowSubscriptionVariables
  >(UpdatedAppTableRowDocument, options)
}
export type UpdatedAppTableRowSubscriptionHookResult = ReturnType<
  typeof useUpdatedAppTableRowSubscription
>
export type UpdatedAppTableRowSubscriptionResult =
  Apollo.SubscriptionResult<UpdatedAppTableRowSubscription>
export const PushAppTableRowDocument = gql`
  subscription PushAppTableRow($input: AppTableSubscriptionInput!) {
    pushAppTableRow(input: $input)
  }
`

/**
 * __usePushAppTableRowSubscription__
 *
 * To run a query within a React component, call `usePushAppTableRowSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushAppTableRowSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushAppTableRowSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushAppTableRowSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PushAppTableRowSubscription,
    PushAppTableRowSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<PushAppTableRowSubscription, PushAppTableRowSubscriptionVariables>(
    PushAppTableRowDocument,
    options,
  )
}
export type PushAppTableRowSubscriptionHookResult = ReturnType<
  typeof usePushAppTableRowSubscription
>
export type PushAppTableRowSubscriptionResult =
  Apollo.SubscriptionResult<PushAppTableRowSubscription>
export const DeletedAppTableRowDocument = gql`
  subscription DeletedAppTableRow($input: AppTableSubscriptionInput!) {
    deletedAppTableRow(input: $input)
  }
`

/**
 * __useDeletedAppTableRowSubscription__
 *
 * To run a query within a React component, call `useDeletedAppTableRowSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedAppTableRowSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedAppTableRowSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletedAppTableRowSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    DeletedAppTableRowSubscription,
    DeletedAppTableRowSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    DeletedAppTableRowSubscription,
    DeletedAppTableRowSubscriptionVariables
  >(DeletedAppTableRowDocument, options)
}
export type DeletedAppTableRowSubscriptionHookResult = ReturnType<
  typeof useDeletedAppTableRowSubscription
>
export type DeletedAppTableRowSubscriptionResult =
  Apollo.SubscriptionResult<DeletedAppTableRowSubscription>
export const UpdatedViewContentDocument = gql`
  subscription UpdatedViewContent($id: ID!) {
    updatedViewContent(id: $id) {
      id
      contentType
      latestVersion
      sourceSnapshotHash
      content
      sdkVersion
      contentHash
      appSdkGraph
      tableMappings
    }
  }
`

/**
 * __useUpdatedViewContentSubscription__
 *
 * To run a query within a React component, call `useUpdatedViewContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedViewContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedViewContentSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdatedViewContentSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UpdatedViewContentSubscription,
    UpdatedViewContentSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    UpdatedViewContentSubscription,
    UpdatedViewContentSubscriptionVariables
  >(UpdatedViewContentDocument, options)
}
export type UpdatedViewContentSubscriptionHookResult = ReturnType<
  typeof useUpdatedViewContentSubscription
>
export type UpdatedViewContentSubscriptionResult =
  Apollo.SubscriptionResult<UpdatedViewContentSubscription>
export const CallEndpointDocument = gql`
  mutation CallEndpoint($input: CallEndpointInput!) {
    callEndpoint(input: $input) {
      output
    }
  }
`
export type CallEndpointMutationFn = Apollo.MutationFunction<
  CallEndpointMutation,
  CallEndpointMutationVariables
>

/**
 * __useCallEndpointMutation__
 *
 * To run a mutation, you first call `useCallEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callEndpointMutation, { data, loading, error }] = useCallEndpointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCallEndpointMutation(
  baseOptions?: Apollo.MutationHookOptions<CallEndpointMutation, CallEndpointMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CallEndpointMutation, CallEndpointMutationVariables>(
    CallEndpointDocument,
    options,
  )
}
export type CallEndpointMutationHookResult = ReturnType<typeof useCallEndpointMutation>
export type CallEndpointMutationResult = Apollo.MutationResult<CallEndpointMutation>
export type CallEndpointMutationOptions = Apollo.BaseMutationOptions<
  CallEndpointMutation,
  CallEndpointMutationVariables
>
export const GetDetailedWorkspaceDocument = gql`
  query getDetailedWorkspace($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      name
      views {
        ...WorkspaceView
      }
      actionButtons {
        id
        name
        order
        manualTrigger {
          id
          action {
            id
            status
            workflow {
              id
              status
            }
          }
        }
        form {
          id
        }
        formV2 {
          id
        }
      }
    }
  }
  ${WorkspaceViewFragmentDoc}
`

/**
 * __useGetDetailedWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetDetailedWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedWorkspaceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetDetailedWorkspaceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDetailedWorkspaceQuery,
    GetDetailedWorkspaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDetailedWorkspaceQuery, GetDetailedWorkspaceQueryVariables>(
    GetDetailedWorkspaceDocument,
    options,
  )
}
export function useGetDetailedWorkspaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDetailedWorkspaceQuery,
    GetDetailedWorkspaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDetailedWorkspaceQuery, GetDetailedWorkspaceQueryVariables>(
    GetDetailedWorkspaceDocument,
    options,
  )
}
export type GetDetailedWorkspaceQueryHookResult = ReturnType<typeof useGetDetailedWorkspaceQuery>
export type GetDetailedWorkspaceLazyQueryHookResult = ReturnType<
  typeof useGetDetailedWorkspaceLazyQuery
>
export type GetDetailedWorkspaceQueryResult = Apollo.QueryResult<
  GetDetailedWorkspaceQuery,
  GetDetailedWorkspaceQueryVariables
>
export const GetFormsDocument = gql`
  query getForms {
    forms {
      id
      name
      isShareable
      pages {
        id
        categories {
          id
          fields {
            id
          }
        }
      }
      workflows {
        id
        name
      }
    }
  }
`

/**
 * __useGetFormsQuery__
 *
 * To run a query within a React component, call `useGetFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFormsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFormsQuery, GetFormsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options)
}
export function useGetFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFormsQuery, GetFormsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options)
}
export type GetFormsQueryHookResult = ReturnType<typeof useGetFormsQuery>
export type GetFormsLazyQueryHookResult = ReturnType<typeof useGetFormsLazyQuery>
export type GetFormsQueryResult = Apollo.QueryResult<GetFormsQuery, GetFormsQueryVariables>
export const ExecuteActionManualTriggerDocument = gql`
  mutation executeActionManualTrigger($input: ExecuteActionManualTriggerInput!) {
    executeActionManualTrigger(input: $input) {
      id
    }
  }
`
export type ExecuteActionManualTriggerMutationFn = Apollo.MutationFunction<
  ExecuteActionManualTriggerMutation,
  ExecuteActionManualTriggerMutationVariables
>

/**
 * __useExecuteActionManualTriggerMutation__
 *
 * To run a mutation, you first call `useExecuteActionManualTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteActionManualTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeActionManualTriggerMutation, { data, loading, error }] = useExecuteActionManualTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteActionManualTriggerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteActionManualTriggerMutation,
    ExecuteActionManualTriggerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExecuteActionManualTriggerMutation,
    ExecuteActionManualTriggerMutationVariables
  >(ExecuteActionManualTriggerDocument, options)
}
export type ExecuteActionManualTriggerMutationHookResult = ReturnType<
  typeof useExecuteActionManualTriggerMutation
>
export type ExecuteActionManualTriggerMutationResult =
  Apollo.MutationResult<ExecuteActionManualTriggerMutation>
export type ExecuteActionManualTriggerMutationOptions = Apollo.BaseMutationOptions<
  ExecuteActionManualTriggerMutation,
  ExecuteActionManualTriggerMutationVariables
>
export const GetTablesForPermissionsDocument = gql`
  query getTablesForPermissions {
    tables {
      id
      name
      parentTable {
        id
      }
      columns {
        id
        name
        order
        isReadOnly
        isNullable
        type
        indexAutogenerate
        lookupColumnGroup {
          id
        }
      }
      tableTabs {
        id
        name
        order
      }
      childTables {
        id
        name
        columns {
          id
          name
          order
          isReadOnly
          isNullable
          type
          indexAutogenerate
          lookupColumnGroup {
            id
          }
        }
        tableTabs {
          id
          name
          order
        }
      }
    }
  }
`

/**
 * __useGetTablesForPermissionsQuery__
 *
 * To run a query within a React component, call `useGetTablesForPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTablesForPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTablesForPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTablesForPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTablesForPermissionsQuery,
    GetTablesForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTablesForPermissionsQuery, GetTablesForPermissionsQueryVariables>(
    GetTablesForPermissionsDocument,
    options,
  )
}
export function useGetTablesForPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTablesForPermissionsQuery,
    GetTablesForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTablesForPermissionsQuery, GetTablesForPermissionsQueryVariables>(
    GetTablesForPermissionsDocument,
    options,
  )
}
export type GetTablesForPermissionsQueryHookResult = ReturnType<
  typeof useGetTablesForPermissionsQuery
>
export type GetTablesForPermissionsLazyQueryHookResult = ReturnType<
  typeof useGetTablesForPermissionsLazyQuery
>
export type GetTablesForPermissionsQueryResult = Apollo.QueryResult<
  GetTablesForPermissionsQuery,
  GetTablesForPermissionsQueryVariables
>
export const GetFormsForPermissionsDocument = gql`
  query getFormsForPermissions {
    forms {
      id
      name
      pages {
        id
        categories {
          id
          lookupTable {
            id
            name
            parentTable {
              id
            }
            columns {
              id
              name
              order
              isReadOnly
              isNullable
              type
              indexAutogenerate
              lookupColumnGroup {
                id
              }
            }
            tableTabs {
              id
              order
              name
            }
            childTables {
              id
              name
              columns {
                id
                name
                order
                isReadOnly
                isNullable
                type
                indexAutogenerate
                lookupColumnGroup {
                  id
                }
              }
              tableTabs {
                id
                name
                order
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetFormsForPermissionsQuery__
 *
 * To run a query within a React component, call `useGetFormsForPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormsForPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormsForPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFormsForPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFormsForPermissionsQuery,
    GetFormsForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormsForPermissionsQuery, GetFormsForPermissionsQueryVariables>(
    GetFormsForPermissionsDocument,
    options,
  )
}
export function useGetFormsForPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormsForPermissionsQuery,
    GetFormsForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormsForPermissionsQuery, GetFormsForPermissionsQueryVariables>(
    GetFormsForPermissionsDocument,
    options,
  )
}
export type GetFormsForPermissionsQueryHookResult = ReturnType<
  typeof useGetFormsForPermissionsQuery
>
export type GetFormsForPermissionsLazyQueryHookResult = ReturnType<
  typeof useGetFormsForPermissionsLazyQuery
>
export type GetFormsForPermissionsQueryResult = Apollo.QueryResult<
  GetFormsForPermissionsQuery,
  GetFormsForPermissionsQueryVariables
>
export const GetFormsV2ForPermissionsDocument = gql`
  query getFormsV2ForPermissions {
    allFormsV2 {
      id
      name
      lookupInputGroups {
        id
        lookupTable {
          id
          name
          parentTable {
            id
          }
          columns {
            id
            name
            order
            isReadOnly
            isNullable
            type
            indexAutogenerate
            lookupColumnGroup {
              id
            }
          }
          tableTabs {
            id
            name
            order
          }
          childTables {
            id
            name
            columns {
              id
              name
              order
              isReadOnly
              isNullable
              type
              indexAutogenerate
              lookupColumnGroup {
                id
              }
            }
            tableTabs {
              id
              name
              order
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetFormsV2ForPermissionsQuery__
 *
 * To run a query within a React component, call `useGetFormsV2ForPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormsV2ForPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormsV2ForPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFormsV2ForPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFormsV2ForPermissionsQuery,
    GetFormsV2ForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetFormsV2ForPermissionsQuery, GetFormsV2ForPermissionsQueryVariables>(
    GetFormsV2ForPermissionsDocument,
    options,
  )
}
export function useGetFormsV2ForPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormsV2ForPermissionsQuery,
    GetFormsV2ForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetFormsV2ForPermissionsQuery, GetFormsV2ForPermissionsQueryVariables>(
    GetFormsV2ForPermissionsDocument,
    options,
  )
}
export type GetFormsV2ForPermissionsQueryHookResult = ReturnType<
  typeof useGetFormsV2ForPermissionsQuery
>
export type GetFormsV2ForPermissionsLazyQueryHookResult = ReturnType<
  typeof useGetFormsV2ForPermissionsLazyQuery
>
export type GetFormsV2ForPermissionsQueryResult = Apollo.QueryResult<
  GetFormsV2ForPermissionsQuery,
  GetFormsV2ForPermissionsQueryVariables
>
export const GetManualTriggersDocument = gql`
  query getManualTriggers {
    actionManualTriggers {
      id
      name
    }
  }
`

/**
 * __useGetManualTriggersQuery__
 *
 * To run a query within a React component, call `useGetManualTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManualTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManualTriggersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManualTriggersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetManualTriggersQuery, GetManualTriggersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetManualTriggersQuery, GetManualTriggersQueryVariables>(
    GetManualTriggersDocument,
    options,
  )
}
export function useGetManualTriggersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManualTriggersQuery,
    GetManualTriggersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetManualTriggersQuery, GetManualTriggersQueryVariables>(
    GetManualTriggersDocument,
    options,
  )
}
export type GetManualTriggersQueryHookResult = ReturnType<typeof useGetManualTriggersQuery>
export type GetManualTriggersLazyQueryHookResult = ReturnType<typeof useGetManualTriggersLazyQuery>
export type GetManualTriggersQueryResult = Apollo.QueryResult<
  GetManualTriggersQuery,
  GetManualTriggersQueryVariables
>
export const GetEndpointsForPermissionsDocument = gql`
  query getEndpointsForPermissions {
    endpoints {
      id
      slug
      internal
    }
  }
`

/**
 * __useGetEndpointsForPermissionsQuery__
 *
 * To run a query within a React component, call `useGetEndpointsForPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEndpointsForPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEndpointsForPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEndpointsForPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEndpointsForPermissionsQuery,
    GetEndpointsForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetEndpointsForPermissionsQuery, GetEndpointsForPermissionsQueryVariables>(
    GetEndpointsForPermissionsDocument,
    options,
  )
}
export function useGetEndpointsForPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEndpointsForPermissionsQuery,
    GetEndpointsForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetEndpointsForPermissionsQuery,
    GetEndpointsForPermissionsQueryVariables
  >(GetEndpointsForPermissionsDocument, options)
}
export type GetEndpointsForPermissionsQueryHookResult = ReturnType<
  typeof useGetEndpointsForPermissionsQuery
>
export type GetEndpointsForPermissionsLazyQueryHookResult = ReturnType<
  typeof useGetEndpointsForPermissionsLazyQuery
>
export type GetEndpointsForPermissionsQueryResult = Apollo.QueryResult<
  GetEndpointsForPermissionsQuery,
  GetEndpointsForPermissionsQueryVariables
>
export const GetUnplacedEmbedsForPermissionsDocument = gql`
  query getUnplacedEmbedsForPermissions {
    unplacedEmbeds {
      id
      name
    }
  }
`

/**
 * __useGetUnplacedEmbedsForPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUnplacedEmbedsForPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnplacedEmbedsForPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnplacedEmbedsForPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnplacedEmbedsForPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUnplacedEmbedsForPermissionsQuery,
    GetUnplacedEmbedsForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetUnplacedEmbedsForPermissionsQuery,
    GetUnplacedEmbedsForPermissionsQueryVariables
  >(GetUnplacedEmbedsForPermissionsDocument, options)
}
export function useGetUnplacedEmbedsForPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUnplacedEmbedsForPermissionsQuery,
    GetUnplacedEmbedsForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetUnplacedEmbedsForPermissionsQuery,
    GetUnplacedEmbedsForPermissionsQueryVariables
  >(GetUnplacedEmbedsForPermissionsDocument, options)
}
export type GetUnplacedEmbedsForPermissionsQueryHookResult = ReturnType<
  typeof useGetUnplacedEmbedsForPermissionsQuery
>
export type GetUnplacedEmbedsForPermissionsLazyQueryHookResult = ReturnType<
  typeof useGetUnplacedEmbedsForPermissionsLazyQuery
>
export type GetUnplacedEmbedsForPermissionsQueryResult = Apollo.QueryResult<
  GetUnplacedEmbedsForPermissionsQuery,
  GetUnplacedEmbedsForPermissionsQueryVariables
>
export const GetWorkspacesForPermissionsDocument = gql`
  query getWorkspacesForPermissions {
    workspaces {
      id
      name
      parentObject {
        name
      }
      views {
        id
        viewableObjectType
        workspace {
          id
          name
        }
        embed {
          id
          name
        }
      }
      linkedViews {
        id
        viewableObjectType
        workspace {
          id
          name
        }
      }
    }
  }
`

/**
 * __useGetWorkspacesForPermissionsQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesForPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesForPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesForPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkspacesForPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWorkspacesForPermissionsQuery,
    GetWorkspacesForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetWorkspacesForPermissionsQuery,
    GetWorkspacesForPermissionsQueryVariables
  >(GetWorkspacesForPermissionsDocument, options)
}
export function useGetWorkspacesForPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkspacesForPermissionsQuery,
    GetWorkspacesForPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetWorkspacesForPermissionsQuery,
    GetWorkspacesForPermissionsQueryVariables
  >(GetWorkspacesForPermissionsDocument, options)
}
export type GetWorkspacesForPermissionsQueryHookResult = ReturnType<
  typeof useGetWorkspacesForPermissionsQuery
>
export type GetWorkspacesForPermissionsLazyQueryHookResult = ReturnType<
  typeof useGetWorkspacesForPermissionsLazyQuery
>
export type GetWorkspacesForPermissionsQueryResult = Apollo.QueryResult<
  GetWorkspacesForPermissionsQuery,
  GetWorkspacesForPermissionsQueryVariables
>
export const GetActiveUsersDocument = gql`
  query getActiveUsers {
    activeUsers {
      id
      firstName
      lastName
      email
      phoneNumber
      roles {
        id
        name
      }
      profilePicture {
        id
        name
        storageUrl
      }
    }
  }
`

/**
 * __useGetActiveUsersQuery__
 *
 * To run a query within a React component, call `useGetActiveUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetActiveUsersQuery, GetActiveUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetActiveUsersQuery, GetActiveUsersQueryVariables>(
    GetActiveUsersDocument,
    options,
  )
}
export function useGetActiveUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetActiveUsersQuery, GetActiveUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetActiveUsersQuery, GetActiveUsersQueryVariables>(
    GetActiveUsersDocument,
    options,
  )
}
export type GetActiveUsersQueryHookResult = ReturnType<typeof useGetActiveUsersQuery>
export type GetActiveUsersLazyQueryHookResult = ReturnType<typeof useGetActiveUsersLazyQuery>
export type GetActiveUsersQueryResult = Apollo.QueryResult<
  GetActiveUsersQuery,
  GetActiveUsersQueryVariables
>
export const GetOrganizationRolesDocument = gql`
  query getOrganizationRoles {
    roles {
      id
      name
      roleType
      permissions {
        id
        permissionType
        objectType
        manualTrigger {
          id
          name
        }
        endpoint {
          id
          slug
        }
        table {
          id
          name
        }
        tableColumn {
          id
          name
          table {
            id
          }
        }
        tableTab {
          id
          name
          table {
            id
          }
        }
        form {
          id
          name
        }
        formV2 {
          id
          name
        }
        workspace {
          id
          name
        }
      }
      users: memberships {
        id
        firstName
        lastName
        status
        profilePicture {
          id
          name
          storageUrl
        }
      }
    }
  }
`

/**
 * __useGetOrganizationRolesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrganizationRolesQuery,
    GetOrganizationRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOrganizationRolesQuery, GetOrganizationRolesQueryVariables>(
    GetOrganizationRolesDocument,
    options,
  )
}
export function useGetOrganizationRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationRolesQuery,
    GetOrganizationRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOrganizationRolesQuery, GetOrganizationRolesQueryVariables>(
    GetOrganizationRolesDocument,
    options,
  )
}
export type GetOrganizationRolesQueryHookResult = ReturnType<typeof useGetOrganizationRolesQuery>
export type GetOrganizationRolesLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationRolesLazyQuery
>
export type GetOrganizationRolesQueryResult = Apollo.QueryResult<
  GetOrganizationRolesQuery,
  GetOrganizationRolesQueryVariables
>
export const GetRoleDocument = gql`
  query getRole($roleId: ID!) {
    role(roleId: $roleId) {
      id
      name
      roleType
      permissions {
        id
        permissionType
        objectType
        manualTrigger {
          id
          name
        }
        endpoint {
          id
          slug
        }
        table {
          id
          name
        }
        tableColumn {
          id
          name
          table {
            id
          }
        }
        tableTab {
          id
          name
          table {
            id
          }
        }
        form {
          id
          name
        }
        formV2 {
          id
          name
        }
        workspace {
          id
          name
        }
        embed {
          id
          name
        }
      }
    }
  }
`

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetRoleQuery(
  baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options)
}
export function useGetRoleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options)
}
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>
export const DeleteRoleDocument = gql`
  mutation deleteRole($roleId: ID!) {
    deleteRole(roleId: $roleId) {
      id
    }
  }
`
export type DeleteRoleMutationFn = Apollo.MutationFunction<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDeleteRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(
    DeleteRoleDocument,
    options,
  )
}
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>
export const CreateRoleDocument = gql`
  mutation createRole($input: CreateRoleInput!) {
    createRole(input: $input) {
      id
      name
      roleType
      permissions {
        id
        permissionType
        objectType
        manualTrigger {
          id
          name
        }
        table {
          id
          name
        }
        tableColumn {
          id
          name
        }
        tableTab {
          id
          name
        }
        form {
          id
          name
        }
        formV2 {
          id
          name
        }
        workspace {
          id
          name
        }
      }
      users: memberships {
        id
        firstName
        lastName
      }
    }
  }
`
export type CreateRoleMutationFn = Apollo.MutationFunction<
  CreateRoleMutation,
  CreateRoleMutationVariables
>

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(
    CreateRoleDocument,
    options,
  )
}
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<
  CreateRoleMutation,
  CreateRoleMutationVariables
>
export const DuplicateRoleDocument = gql`
  mutation duplicateRole($roleId: ID!) {
    duplicateRole(roleId: $roleId) {
      id
      name
      roleType
      permissions {
        id
        permissionType
        objectType
        manualTrigger {
          id
          name
        }
        table {
          id
          name
        }
        tableColumn {
          id
          name
        }
        tableTab {
          id
          name
        }
        form {
          id
          name
        }
        formV2 {
          id
          name
        }
        workspace {
          id
          name
        }
      }
      users: memberships {
        id
        firstName
        lastName
      }
    }
  }
`
export type DuplicateRoleMutationFn = Apollo.MutationFunction<
  DuplicateRoleMutation,
  DuplicateRoleMutationVariables
>

/**
 * __useDuplicateRoleMutation__
 *
 * To run a mutation, you first call `useDuplicateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateRoleMutation, { data, loading, error }] = useDuplicateRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDuplicateRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<DuplicateRoleMutation, DuplicateRoleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DuplicateRoleMutation, DuplicateRoleMutationVariables>(
    DuplicateRoleDocument,
    options,
  )
}
export type DuplicateRoleMutationHookResult = ReturnType<typeof useDuplicateRoleMutation>
export type DuplicateRoleMutationResult = Apollo.MutationResult<DuplicateRoleMutation>
export type DuplicateRoleMutationOptions = Apollo.BaseMutationOptions<
  DuplicateRoleMutation,
  DuplicateRoleMutationVariables
>
export const UpdateRoleDocument = gql`
  mutation updateRole($input: UpdateRoleInput!) {
    updateRole(input: $input) {
      id
      name
      roleType
      permissions {
        id
        permissionType
        objectType
        manualTrigger {
          id
          name
        }
        table {
          id
          name
        }
        tableColumn {
          id
          name
        }
        tableTab {
          id
          name
        }
        form {
          id
          name
        }
        formV2 {
          id
          name
        }
        workspace {
          id
          name
        }
      }
      users: memberships {
        id
        firstName
        lastName
      }
    }
  }
`
export type UpdateRoleMutationFn = Apollo.MutationFunction<
  UpdateRoleMutation,
  UpdateRoleMutationVariables
>

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(
    UpdateRoleDocument,
    options,
  )
}
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<
  UpdateRoleMutation,
  UpdateRoleMutationVariables
>
export const CreateUserDocument = gql`
  mutation createUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      firstName
      lastName
      email
      phoneNumber
      roles {
        id
        name
      }
    }
  }
`
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options,
  )
}
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>
export const GetPendingInvitesDocument = gql`
  query getPendingInvites {
    pendingInvites {
      id
      firstName
      lastName
      email
      phoneNumber
      roles {
        id
        name
      }
    }
  }
`

/**
 * __useGetPendingInvitesQuery__
 *
 * To run a query within a React component, call `useGetPendingInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingInvitesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>(
    GetPendingInvitesDocument,
    options,
  )
}
export function useGetPendingInvitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPendingInvitesQuery,
    GetPendingInvitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPendingInvitesQuery, GetPendingInvitesQueryVariables>(
    GetPendingInvitesDocument,
    options,
  )
}
export type GetPendingInvitesQueryHookResult = ReturnType<typeof useGetPendingInvitesQuery>
export type GetPendingInvitesLazyQueryHookResult = ReturnType<typeof useGetPendingInvitesLazyQuery>
export type GetPendingInvitesQueryResult = Apollo.QueryResult<
  GetPendingInvitesQuery,
  GetPendingInvitesQueryVariables
>
export const CancelInviteDocument = gql`
  mutation cancelInvite($membershipId: ID!) {
    cancelInvite(membershipId: $membershipId) {
      id
    }
  }
`
export type CancelInviteMutationFn = Apollo.MutationFunction<
  CancelInviteMutation,
  CancelInviteMutationVariables
>

/**
 * __useCancelInviteMutation__
 *
 * To run a mutation, you first call `useCancelInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInviteMutation, { data, loading, error }] = useCancelInviteMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useCancelInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<CancelInviteMutation, CancelInviteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CancelInviteMutation, CancelInviteMutationVariables>(
    CancelInviteDocument,
    options,
  )
}
export type CancelInviteMutationHookResult = ReturnType<typeof useCancelInviteMutation>
export type CancelInviteMutationResult = Apollo.MutationResult<CancelInviteMutation>
export type CancelInviteMutationOptions = Apollo.BaseMutationOptions<
  CancelInviteMutation,
  CancelInviteMutationVariables
>
export const ResendInviteDocument = gql`
  mutation resendInvite($membershipId: ID!) {
    resendInvite(membershipId: $membershipId) {
      id
    }
  }
`
export type ResendInviteMutationFn = Apollo.MutationFunction<
  ResendInviteMutation,
  ResendInviteMutationVariables
>

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useResendInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<ResendInviteMutation, ResendInviteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResendInviteMutation, ResendInviteMutationVariables>(
    ResendInviteDocument,
    options,
  )
}
export type ResendInviteMutationHookResult = ReturnType<typeof useResendInviteMutation>
export type ResendInviteMutationResult = Apollo.MutationResult<ResendInviteMutation>
export type ResendInviteMutationOptions = Apollo.BaseMutationOptions<
  ResendInviteMutation,
  ResendInviteMutationVariables
>
export const UpdateUserRolesDocument = gql`
  mutation updateUserRoles($input: UpdateUserRolesInput!) {
    updateUserRoles(input: $input) {
      id
      firstName
      lastName
      email
      roles {
        id
        name
      }
    }
  }
`
export type UpdateUserRolesMutationFn = Apollo.MutationFunction<
  UpdateUserRolesMutation,
  UpdateUserRolesMutationVariables
>

/**
 * __useUpdateUserRolesMutation__
 *
 * To run a mutation, you first call `useUpdateUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRolesMutation, { data, loading, error }] = useUpdateUserRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRolesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserRolesMutation,
    UpdateUserRolesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateUserRolesMutation, UpdateUserRolesMutationVariables>(
    UpdateUserRolesDocument,
    options,
  )
}
export type UpdateUserRolesMutationHookResult = ReturnType<typeof useUpdateUserRolesMutation>
export type UpdateUserRolesMutationResult = Apollo.MutationResult<UpdateUserRolesMutation>
export type UpdateUserRolesMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserRolesMutation,
  UpdateUserRolesMutationVariables
>
export const UpdateUserProfilePictureDocument = gql`
  mutation updateUserProfilePicture($input: UpdateUserProfilePictureInput) {
    updateUserProfilePicture(input: $input) {
      id
      profilePicture {
        id
        name
        storageUrl
      }
    }
  }
`
export type UpdateUserProfilePictureMutationFn = Apollo.MutationFunction<
  UpdateUserProfilePictureMutation,
  UpdateUserProfilePictureMutationVariables
>

/**
 * __useUpdateUserProfilePictureMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfilePictureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfilePictureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfilePictureMutation, { data, loading, error }] = useUpdateUserProfilePictureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfilePictureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserProfilePictureMutation,
    UpdateUserProfilePictureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateUserProfilePictureMutation,
    UpdateUserProfilePictureMutationVariables
  >(UpdateUserProfilePictureDocument, options)
}
export type UpdateUserProfilePictureMutationHookResult = ReturnType<
  typeof useUpdateUserProfilePictureMutation
>
export type UpdateUserProfilePictureMutationResult =
  Apollo.MutationResult<UpdateUserProfilePictureMutation>
export type UpdateUserProfilePictureMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserProfilePictureMutation,
  UpdateUserProfilePictureMutationVariables
>
export const GetOrganizationDocument = gql`
  query getOrganization($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      name
      users: memberships {
        id
        firstName
        lastName
        email
        status
      }
    }
  }
`

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(
    GetOrganizationDocument,
    options,
  )
}
export function useGetOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(
    GetOrganizationDocument,
    options,
  )
}
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>
export type GetOrganizationQueryResult = Apollo.QueryResult<
  GetOrganizationQuery,
  GetOrganizationQueryVariables
>
export const GetOrganizationExportsDocument = gql`
  query getOrganizationExports {
    organizationExports {
      id
      createdAt
      status
      totalTableCount
      completedTableCount
      failedTableCount
      document {
        id
        name
        storageUrl
      }
    }
  }
`

/**
 * __useGetOrganizationExportsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationExportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationExportsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrganizationExportsQuery,
    GetOrganizationExportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOrganizationExportsQuery, GetOrganizationExportsQueryVariables>(
    GetOrganizationExportsDocument,
    options,
  )
}
export function useGetOrganizationExportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationExportsQuery,
    GetOrganizationExportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOrganizationExportsQuery, GetOrganizationExportsQueryVariables>(
    GetOrganizationExportsDocument,
    options,
  )
}
export type GetOrganizationExportsQueryHookResult = ReturnType<
  typeof useGetOrganizationExportsQuery
>
export type GetOrganizationExportsLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationExportsLazyQuery
>
export type GetOrganizationExportsQueryResult = Apollo.QueryResult<
  GetOrganizationExportsQuery,
  GetOrganizationExportsQueryVariables
>
export const CreateOrganizationExportDocument = gql`
  mutation createOrganizationExport {
    createOrganizationExport {
      id
      status
    }
  }
`
export type CreateOrganizationExportMutationFn = Apollo.MutationFunction<
  CreateOrganizationExportMutation,
  CreateOrganizationExportMutationVariables
>

/**
 * __useCreateOrganizationExportMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationExportMutation, { data, loading, error }] = useCreateOrganizationExportMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateOrganizationExportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrganizationExportMutation,
    CreateOrganizationExportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateOrganizationExportMutation,
    CreateOrganizationExportMutationVariables
  >(CreateOrganizationExportDocument, options)
}
export type CreateOrganizationExportMutationHookResult = ReturnType<
  typeof useCreateOrganizationExportMutation
>
export type CreateOrganizationExportMutationResult =
  Apollo.MutationResult<CreateOrganizationExportMutation>
export type CreateOrganizationExportMutationOptions = Apollo.BaseMutationOptions<
  CreateOrganizationExportMutation,
  CreateOrganizationExportMutationVariables
>
export const SendEmailDocument = gql`
  mutation sendEmail($input: SendEmailInput!) {
    sendEmail(input: $input)
  }
`
export type SendEmailMutationFn = Apollo.MutationFunction<
  SendEmailMutation,
  SendEmailMutationVariables
>

/**
 * __useSendEmailMutation__
 *
 * To run a mutation, you first call `useSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailMutation, { data, loading, error }] = useSendEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<SendEmailMutation, SendEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendEmailMutation, SendEmailMutationVariables>(
    SendEmailDocument,
    options,
  )
}
export type SendEmailMutationHookResult = ReturnType<typeof useSendEmailMutation>
export type SendEmailMutationResult = Apollo.MutationResult<SendEmailMutation>
export type SendEmailMutationOptions = Apollo.BaseMutationOptions<
  SendEmailMutation,
  SendEmailMutationVariables
>
export const GetCsvExportTableRowsDocument = gql`
  query getCsvExportTableRows($input: PaginatedCsvExportInput!) {
    paginatedCsvExport(input: $input) {
      offset
      hasNext
      totalCount
      rows {
        id
        parentRow {
          id
        }
        createdAt
        createdBy {
          id
          firstName
          lastName
          email
        }
        updatedAt
        updatedBy {
          id
          firstName
          lastName
          email
        }
        cells {
          id
          userVisibleValue
          data
          column {
            id
          }
        }
        childRows {
          id
          parentRow {
            id
          }
          createdAt
          createdBy {
            id
            firstName
            lastName
            email
          }
          updatedAt
          updatedBy {
            id
            firstName
            lastName
            email
          }
          cells {
            id
            userVisibleValue
            data
            column {
              id
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetCsvExportTableRowsQuery__
 *
 * To run a query within a React component, call `useGetCsvExportTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCsvExportTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCsvExportTableRowsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCsvExportTableRowsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCsvExportTableRowsQuery,
    GetCsvExportTableRowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCsvExportTableRowsQuery, GetCsvExportTableRowsQueryVariables>(
    GetCsvExportTableRowsDocument,
    options,
  )
}
export function useGetCsvExportTableRowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCsvExportTableRowsQuery,
    GetCsvExportTableRowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCsvExportTableRowsQuery, GetCsvExportTableRowsQueryVariables>(
    GetCsvExportTableRowsDocument,
    options,
  )
}
export type GetCsvExportTableRowsQueryHookResult = ReturnType<typeof useGetCsvExportTableRowsQuery>
export type GetCsvExportTableRowsLazyQueryHookResult = ReturnType<
  typeof useGetCsvExportTableRowsLazyQuery
>
export type GetCsvExportTableRowsQueryResult = Apollo.QueryResult<
  GetCsvExportTableRowsQuery,
  GetCsvExportTableRowsQueryVariables
>
export const GetBulkActionEligibilityCountsDocument = gql`
  query getBulkActionEligibilityCounts($input: BulkActionEligibilityCountsInput!) {
    bulkActionEligibilityCounts(input: $input) {
      totalSelectedCount
      buttonEligibilityCounts {
        id
        name
        order
        eligibleCount
        hasMore
        eligibleRowIds
        buttonConfiguration
        icon {
          name
        }
        manualTrigger {
          id
        }
        requiresConfirmation
        confirmationMessage
      }
    }
  }
`

/**
 * __useGetBulkActionEligibilityCountsQuery__
 *
 * To run a query within a React component, call `useGetBulkActionEligibilityCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBulkActionEligibilityCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBulkActionEligibilityCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBulkActionEligibilityCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBulkActionEligibilityCountsQuery,
    GetBulkActionEligibilityCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetBulkActionEligibilityCountsQuery,
    GetBulkActionEligibilityCountsQueryVariables
  >(GetBulkActionEligibilityCountsDocument, options)
}
export function useGetBulkActionEligibilityCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBulkActionEligibilityCountsQuery,
    GetBulkActionEligibilityCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetBulkActionEligibilityCountsQuery,
    GetBulkActionEligibilityCountsQueryVariables
  >(GetBulkActionEligibilityCountsDocument, options)
}
export type GetBulkActionEligibilityCountsQueryHookResult = ReturnType<
  typeof useGetBulkActionEligibilityCountsQuery
>
export type GetBulkActionEligibilityCountsLazyQueryHookResult = ReturnType<
  typeof useGetBulkActionEligibilityCountsLazyQuery
>
export type GetBulkActionEligibilityCountsQueryResult = Apollo.QueryResult<
  GetBulkActionEligibilityCountsQuery,
  GetBulkActionEligibilityCountsQueryVariables
>
export const GetDeleteBlockingCheckDocument = gql`
  query getDeleteBlockingCheck($input: DeleteBlockingCheckInput!) {
    deleteBlockingCheck(input: $input) {
      totalCount
      deletableCount
      blockedCount
      blockedRows {
        rowId
        rowName
        canDelete
        blockingReferences {
          row {
            id
            name
          }
          columnId
          columnName
          tableId
          tableName
        }
      }
    }
  }
`

/**
 * __useGetDeleteBlockingCheckQuery__
 *
 * To run a query within a React component, call `useGetDeleteBlockingCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeleteBlockingCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeleteBlockingCheckQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDeleteBlockingCheckQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDeleteBlockingCheckQuery,
    GetDeleteBlockingCheckQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDeleteBlockingCheckQuery, GetDeleteBlockingCheckQueryVariables>(
    GetDeleteBlockingCheckDocument,
    options,
  )
}
export function useGetDeleteBlockingCheckLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeleteBlockingCheckQuery,
    GetDeleteBlockingCheckQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDeleteBlockingCheckQuery, GetDeleteBlockingCheckQueryVariables>(
    GetDeleteBlockingCheckDocument,
    options,
  )
}
export type GetDeleteBlockingCheckQueryHookResult = ReturnType<
  typeof useGetDeleteBlockingCheckQuery
>
export type GetDeleteBlockingCheckLazyQueryHookResult = ReturnType<
  typeof useGetDeleteBlockingCheckLazyQuery
>
export type GetDeleteBlockingCheckQueryResult = Apollo.QueryResult<
  GetDeleteBlockingCheckQuery,
  GetDeleteBlockingCheckQueryVariables
>
export const ExecuteBulkActionDocument = gql`
  mutation executeBulkAction($input: ExecuteBulkActionInput!) {
    executeBulkAction(input: $input) {
      executedCount
      skippedCount
      errors {
        rowId
        message
      }
      executedRowIds
    }
  }
`
export type ExecuteBulkActionMutationFn = Apollo.MutationFunction<
  ExecuteBulkActionMutation,
  ExecuteBulkActionMutationVariables
>

/**
 * __useExecuteBulkActionMutation__
 *
 * To run a mutation, you first call `useExecuteBulkActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteBulkActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeBulkActionMutation, { data, loading, error }] = useExecuteBulkActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteBulkActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteBulkActionMutation,
    ExecuteBulkActionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ExecuteBulkActionMutation, ExecuteBulkActionMutationVariables>(
    ExecuteBulkActionDocument,
    options,
  )
}
export type ExecuteBulkActionMutationHookResult = ReturnType<typeof useExecuteBulkActionMutation>
export type ExecuteBulkActionMutationResult = Apollo.MutationResult<ExecuteBulkActionMutation>
export type ExecuteBulkActionMutationOptions = Apollo.BaseMutationOptions<
  ExecuteBulkActionMutation,
  ExecuteBulkActionMutationVariables
>
export const BulkDeleteTableRowsDocument = gql`
  mutation bulkDeleteTableRows($input: BulkDeleteTableRowsInput!) {
    bulkDeleteTableRows(input: $input) {
      deletedCount
      skippedCount
      errors {
        rowId
        rowName
        message
        blockingRows {
          id
          name
        }
        blockingReferences {
          row {
            id
            name
          }
          columnId
          columnName
          tableId
          tableName
        }
      }
    }
  }
`
export type BulkDeleteTableRowsMutationFn = Apollo.MutationFunction<
  BulkDeleteTableRowsMutation,
  BulkDeleteTableRowsMutationVariables
>

/**
 * __useBulkDeleteTableRowsMutation__
 *
 * To run a mutation, you first call `useBulkDeleteTableRowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteTableRowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteTableRowsMutation, { data, loading, error }] = useBulkDeleteTableRowsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkDeleteTableRowsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkDeleteTableRowsMutation,
    BulkDeleteTableRowsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<BulkDeleteTableRowsMutation, BulkDeleteTableRowsMutationVariables>(
    BulkDeleteTableRowsDocument,
    options,
  )
}
export type BulkDeleteTableRowsMutationHookResult = ReturnType<
  typeof useBulkDeleteTableRowsMutation
>
export type BulkDeleteTableRowsMutationResult = Apollo.MutationResult<BulkDeleteTableRowsMutation>
export type BulkDeleteTableRowsMutationOptions = Apollo.BaseMutationOptions<
  BulkDeleteTableRowsMutation,
  BulkDeleteTableRowsMutationVariables
>
export const BulkDuplicateTableRowsDocument = gql`
  mutation bulkDuplicateTableRows($input: BulkDuplicateTableRowsInput!) {
    bulkDuplicateTableRows(input: $input) {
      duplicatedCount
      errors {
        rowId
        message
      }
    }
  }
`
export type BulkDuplicateTableRowsMutationFn = Apollo.MutationFunction<
  BulkDuplicateTableRowsMutation,
  BulkDuplicateTableRowsMutationVariables
>

/**
 * __useBulkDuplicateTableRowsMutation__
 *
 * To run a mutation, you first call `useBulkDuplicateTableRowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDuplicateTableRowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDuplicateTableRowsMutation, { data, loading, error }] = useBulkDuplicateTableRowsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkDuplicateTableRowsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkDuplicateTableRowsMutation,
    BulkDuplicateTableRowsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BulkDuplicateTableRowsMutation,
    BulkDuplicateTableRowsMutationVariables
  >(BulkDuplicateTableRowsDocument, options)
}
export type BulkDuplicateTableRowsMutationHookResult = ReturnType<
  typeof useBulkDuplicateTableRowsMutation
>
export type BulkDuplicateTableRowsMutationResult =
  Apollo.MutationResult<BulkDuplicateTableRowsMutation>
export type BulkDuplicateTableRowsMutationOptions = Apollo.BaseMutationOptions<
  BulkDuplicateTableRowsMutation,
  BulkDuplicateTableRowsMutationVariables
>
export const GetTableColumnsByIdDocument = gql`
  query getTableColumnsById($tableId: ID!) {
    tableColumnsById(tableId: $tableId) {
      ...DetailedTableColumn
    }
  }
  ${DetailedTableColumnFragmentDoc}
`

/**
 * __useGetTableColumnsByIdQuery__
 *
 * To run a query within a React component, call `useGetTableColumnsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableColumnsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableColumnsByIdQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetTableColumnsByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetTableColumnsByIdQuery, GetTableColumnsByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTableColumnsByIdQuery, GetTableColumnsByIdQueryVariables>(
    GetTableColumnsByIdDocument,
    options,
  )
}
export function useGetTableColumnsByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTableColumnsByIdQuery,
    GetTableColumnsByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTableColumnsByIdQuery, GetTableColumnsByIdQueryVariables>(
    GetTableColumnsByIdDocument,
    options,
  )
}
export type GetTableColumnsByIdQueryHookResult = ReturnType<typeof useGetTableColumnsByIdQuery>
export type GetTableColumnsByIdLazyQueryHookResult = ReturnType<
  typeof useGetTableColumnsByIdLazyQuery
>
export type GetTableColumnsByIdQueryResult = Apollo.QueryResult<
  GetTableColumnsByIdQuery,
  GetTableColumnsByIdQueryVariables
>
export const CreateTableColumnDocument = gql`
  mutation createTableColumn($input: CreateTableColumnInput!) {
    createTableColumn(input: $input) {
      ...DetailedTableColumn
      lookupColumnGroup {
        id
        showBacklink
        backlinkName
        columns {
          id
          name
          type
          innerType
          lookupColumn {
            id
            name
          }
        }
        lookupTable {
          id
          name
          icon {
            id
            name
          }
        }
      }
      tableTabs {
        id
        order
        isFrozen
        tableTab {
          id
        }
      }
      hasNonNullCells
      hasNullCells
    }
  }
  ${DetailedTableColumnFragmentDoc}
`
export type CreateTableColumnMutationFn = Apollo.MutationFunction<
  CreateTableColumnMutation,
  CreateTableColumnMutationVariables
>

/**
 * __useCreateTableColumnMutation__
 *
 * To run a mutation, you first call `useCreateTableColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableColumnMutation, { data, loading, error }] = useCreateTableColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTableColumnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTableColumnMutation,
    CreateTableColumnMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTableColumnMutation, CreateTableColumnMutationVariables>(
    CreateTableColumnDocument,
    options,
  )
}
export type CreateTableColumnMutationHookResult = ReturnType<typeof useCreateTableColumnMutation>
export type CreateTableColumnMutationResult = Apollo.MutationResult<CreateTableColumnMutation>
export type CreateTableColumnMutationOptions = Apollo.BaseMutationOptions<
  CreateTableColumnMutation,
  CreateTableColumnMutationVariables
>
export const UpdateTableColumnDocument = gql`
  mutation updateTableColumn($input: UpdateTableColumnInput!) {
    updateTableColumn(input: $input) {
      ...DetailedTableColumn
      lookupColumnGroup {
        id
        showBacklink
        backlinkName
        columns {
          id
          name
          type
          innerType
          lookupColumn {
            id
            name
          }
        }
        lookupTable {
          id
          name
          icon {
            id
            name
          }
        }
      }
      hasNonNullCells
      hasNullCells
      tableTabs {
        id
      }
    }
  }
  ${DetailedTableColumnFragmentDoc}
`
export type UpdateTableColumnMutationFn = Apollo.MutationFunction<
  UpdateTableColumnMutation,
  UpdateTableColumnMutationVariables
>

/**
 * __useUpdateTableColumnMutation__
 *
 * To run a mutation, you first call `useUpdateTableColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableColumnMutation, { data, loading, error }] = useUpdateTableColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableColumnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTableColumnMutation,
    UpdateTableColumnMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTableColumnMutation, UpdateTableColumnMutationVariables>(
    UpdateTableColumnDocument,
    options,
  )
}
export type UpdateTableColumnMutationHookResult = ReturnType<typeof useUpdateTableColumnMutation>
export type UpdateTableColumnMutationResult = Apollo.MutationResult<UpdateTableColumnMutation>
export type UpdateTableColumnMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableColumnMutation,
  UpdateTableColumnMutationVariables
>
export const DeleteTableColumnDocument = gql`
  mutation deleteTableColumn($input: DeleteTableColumnInput!) {
    deleteTableColumn(input: $input) {
      id
    }
  }
`
export type DeleteTableColumnMutationFn = Apollo.MutationFunction<
  DeleteTableColumnMutation,
  DeleteTableColumnMutationVariables
>

/**
 * __useDeleteTableColumnMutation__
 *
 * To run a mutation, you first call `useDeleteTableColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableColumnMutation, { data, loading, error }] = useDeleteTableColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTableColumnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTableColumnMutation,
    DeleteTableColumnMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTableColumnMutation, DeleteTableColumnMutationVariables>(
    DeleteTableColumnDocument,
    options,
  )
}
export type DeleteTableColumnMutationHookResult = ReturnType<typeof useDeleteTableColumnMutation>
export type DeleteTableColumnMutationResult = Apollo.MutationResult<DeleteTableColumnMutation>
export type DeleteTableColumnMutationOptions = Apollo.BaseMutationOptions<
  DeleteTableColumnMutation,
  DeleteTableColumnMutationVariables
>
export const DeleteTableColumnsDocument = gql`
  mutation deleteTableColumns($input: DeleteTableColumnsInput!) {
    deleteTableColumns(input: $input) {
      id
    }
  }
`
export type DeleteTableColumnsMutationFn = Apollo.MutationFunction<
  DeleteTableColumnsMutation,
  DeleteTableColumnsMutationVariables
>

/**
 * __useDeleteTableColumnsMutation__
 *
 * To run a mutation, you first call `useDeleteTableColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableColumnsMutation, { data, loading, error }] = useDeleteTableColumnsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTableColumnsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTableColumnsMutation,
    DeleteTableColumnsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTableColumnsMutation, DeleteTableColumnsMutationVariables>(
    DeleteTableColumnsDocument,
    options,
  )
}
export type DeleteTableColumnsMutationHookResult = ReturnType<typeof useDeleteTableColumnsMutation>
export type DeleteTableColumnsMutationResult = Apollo.MutationResult<DeleteTableColumnsMutation>
export type DeleteTableColumnsMutationOptions = Apollo.BaseMutationOptions<
  DeleteTableColumnsMutation,
  DeleteTableColumnsMutationVariables
>
export const AddTableColumnGetTableDetailsDocument = gql`
  query addTableColumnGetTableDetails($tableId: ID!) {
    table(tableId: $tableId) {
      id
      name
      description
      icon {
        id
        name
      }
      parentTable {
        id
      }
      hasRows
      columns {
        id
        name
        description
        order
        type
        innerType
        isNullable
        isReadOnly
        isDecimal
        indexType
        indexPrefix
        indexSuffix
        indexAutogenerate
        enumOptions
        ...EnumSetFields
        displayImagesInline
        hasNonNullCells
        hasNullCells
        tableTabs {
          id
        }
        formula {
          id
          formulaString
        }
        lookupColumn {
          id
          type
          table {
            id
          }
          lookupColumnGroup {
            id
          }
        }
      }
      childTables {
        id
        name
        description
        hasRows
        columns {
          id
          name
          description
          order
          type
          innerType
          isNullable
          isReadOnly
          isDecimal
          indexType
          indexPrefix
          indexSuffix
          indexAutogenerate
          enumOptions
          ...EnumSetFields
          displayImagesInline
          hasNonNullCells
          hasNullCells
          tableTabs {
            id
          }
          formula {
            id
            formulaString
          }
          lookupColumn {
            id
            type
          }
        }
      }
      lookupColumnGroups {
        id
        lookupTable {
          id
          name
        }
      }
    }
  }
  ${EnumSetFieldsFragmentDoc}
`

/**
 * __useAddTableColumnGetTableDetailsQuery__
 *
 * To run a query within a React component, call `useAddTableColumnGetTableDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddTableColumnGetTableDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddTableColumnGetTableDetailsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useAddTableColumnGetTableDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AddTableColumnGetTableDetailsQuery,
    AddTableColumnGetTableDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AddTableColumnGetTableDetailsQuery,
    AddTableColumnGetTableDetailsQueryVariables
  >(AddTableColumnGetTableDetailsDocument, options)
}
export function useAddTableColumnGetTableDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AddTableColumnGetTableDetailsQuery,
    AddTableColumnGetTableDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AddTableColumnGetTableDetailsQuery,
    AddTableColumnGetTableDetailsQueryVariables
  >(AddTableColumnGetTableDetailsDocument, options)
}
export type AddTableColumnGetTableDetailsQueryHookResult = ReturnType<
  typeof useAddTableColumnGetTableDetailsQuery
>
export type AddTableColumnGetTableDetailsLazyQueryHookResult = ReturnType<
  typeof useAddTableColumnGetTableDetailsLazyQuery
>
export type AddTableColumnGetTableDetailsQueryResult = Apollo.QueryResult<
  AddTableColumnGetTableDetailsQuery,
  AddTableColumnGetTableDetailsQueryVariables
>
export const ReorderTableColumnsDocument = gql`
  mutation reorderTableColumns($input: ReorderTableColumnsInput!) {
    reorderTableColumns(input: $input) {
      id
      order
    }
  }
`
export type ReorderTableColumnsMutationFn = Apollo.MutationFunction<
  ReorderTableColumnsMutation,
  ReorderTableColumnsMutationVariables
>

/**
 * __useReorderTableColumnsMutation__
 *
 * To run a mutation, you first call `useReorderTableColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderTableColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderTableColumnsMutation, { data, loading, error }] = useReorderTableColumnsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderTableColumnsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderTableColumnsMutation,
    ReorderTableColumnsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReorderTableColumnsMutation, ReorderTableColumnsMutationVariables>(
    ReorderTableColumnsDocument,
    options,
  )
}
export type ReorderTableColumnsMutationHookResult = ReturnType<
  typeof useReorderTableColumnsMutation
>
export type ReorderTableColumnsMutationResult = Apollo.MutationResult<ReorderTableColumnsMutation>
export type ReorderTableColumnsMutationOptions = Apollo.BaseMutationOptions<
  ReorderTableColumnsMutation,
  ReorderTableColumnsMutationVariables
>
export const GetOrganizationRolesWithTablePermissionsDocument = gql`
  query getOrganizationRolesWithTablePermissions($tableId: ID!) {
    roles {
      id
      name
      roleType
      tablePermissions(tableId: $tableId) {
        id
        permissionType
        objectType
        table {
          id
          name
        }
        tableColumn {
          id
          name
          table {
            id
          }
        }
        tableTab {
          id
          name
          table {
            id
          }
        }
      }
    }
  }
`

/**
 * __useGetOrganizationRolesWithTablePermissionsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationRolesWithTablePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationRolesWithTablePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationRolesWithTablePermissionsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetOrganizationRolesWithTablePermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganizationRolesWithTablePermissionsQuery,
    GetOrganizationRolesWithTablePermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetOrganizationRolesWithTablePermissionsQuery,
    GetOrganizationRolesWithTablePermissionsQueryVariables
  >(GetOrganizationRolesWithTablePermissionsDocument, options)
}
export function useGetOrganizationRolesWithTablePermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationRolesWithTablePermissionsQuery,
    GetOrganizationRolesWithTablePermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetOrganizationRolesWithTablePermissionsQuery,
    GetOrganizationRolesWithTablePermissionsQueryVariables
  >(GetOrganizationRolesWithTablePermissionsDocument, options)
}
export type GetOrganizationRolesWithTablePermissionsQueryHookResult = ReturnType<
  typeof useGetOrganizationRolesWithTablePermissionsQuery
>
export type GetOrganizationRolesWithTablePermissionsLazyQueryHookResult = ReturnType<
  typeof useGetOrganizationRolesWithTablePermissionsLazyQuery
>
export type GetOrganizationRolesWithTablePermissionsQueryResult = Apollo.QueryResult<
  GetOrganizationRolesWithTablePermissionsQuery,
  GetOrganizationRolesWithTablePermissionsQueryVariables
>
export const UpdateRoleTablePermissionsDocument = gql`
  mutation updateRoleTablePermissions($input: UpdateRoleTablePermissionsInput!, $tableId: ID!) {
    updateRoleTablePermissions(input: $input, tableId: $tableId) {
      id
      name
      tablePermissions(tableId: $tableId) {
        id
        permissionType
        objectType
        table {
          id
          name
        }
        tableColumn {
          id
          name
        }
        tableTab {
          id
          name
        }
      }
    }
  }
`
export type UpdateRoleTablePermissionsMutationFn = Apollo.MutationFunction<
  UpdateRoleTablePermissionsMutation,
  UpdateRoleTablePermissionsMutationVariables
>

/**
 * __useUpdateRoleTablePermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateRoleTablePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleTablePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleTablePermissionsMutation, { data, loading, error }] = useUpdateRoleTablePermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useUpdateRoleTablePermissionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRoleTablePermissionsMutation,
    UpdateRoleTablePermissionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateRoleTablePermissionsMutation,
    UpdateRoleTablePermissionsMutationVariables
  >(UpdateRoleTablePermissionsDocument, options)
}
export type UpdateRoleTablePermissionsMutationHookResult = ReturnType<
  typeof useUpdateRoleTablePermissionsMutation
>
export type UpdateRoleTablePermissionsMutationResult =
  Apollo.MutationResult<UpdateRoleTablePermissionsMutation>
export type UpdateRoleTablePermissionsMutationOptions = Apollo.BaseMutationOptions<
  UpdateRoleTablePermissionsMutation,
  UpdateRoleTablePermissionsMutationVariables
>
export const GetTableColumnsTabsChildTablesDocument = gql`
  query getTableColumnsTabsChildTables($tableId: ID!) {
    table(tableId: $tableId) {
      id
      name
      columns {
        id
        name
        order
        type
        indexAutogenerate
        isNullable
      }
      tableTabs {
        id
        order
      }
      childTables {
        id
        name
        columns {
          id
          name
          order
          type
          indexAutogenerate
          isNullable
        }
        tableTabs {
          id
          order
        }
      }
    }
  }
`

/**
 * __useGetTableColumnsTabsChildTablesQuery__
 *
 * To run a query within a React component, call `useGetTableColumnsTabsChildTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableColumnsTabsChildTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableColumnsTabsChildTablesQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetTableColumnsTabsChildTablesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTableColumnsTabsChildTablesQuery,
    GetTableColumnsTabsChildTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetTableColumnsTabsChildTablesQuery,
    GetTableColumnsTabsChildTablesQueryVariables
  >(GetTableColumnsTabsChildTablesDocument, options)
}
export function useGetTableColumnsTabsChildTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTableColumnsTabsChildTablesQuery,
    GetTableColumnsTabsChildTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetTableColumnsTabsChildTablesQuery,
    GetTableColumnsTabsChildTablesQueryVariables
  >(GetTableColumnsTabsChildTablesDocument, options)
}
export type GetTableColumnsTabsChildTablesQueryHookResult = ReturnType<
  typeof useGetTableColumnsTabsChildTablesQuery
>
export type GetTableColumnsTabsChildTablesLazyQueryHookResult = ReturnType<
  typeof useGetTableColumnsTabsChildTablesLazyQuery
>
export type GetTableColumnsTabsChildTablesQueryResult = Apollo.QueryResult<
  GetTableColumnsTabsChildTablesQuery,
  GetTableColumnsTabsChildTablesQueryVariables
>
export const GetTableColumnRelatedActionStepsDocument = gql`
  query getTableColumnRelatedActionSteps($input: RelatedEntitiesInput!) {
    relatedActionSteps(input: $input) {
      readSteps {
        id
        name
        type
        status
        rootAction {
          id
          name
          status
          workflow {
            id
            name
          }
        }
      }
      writeSteps {
        id
        name
        type
        status
        rootAction {
          id
          name
          status
          workflow {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useGetTableColumnRelatedActionStepsQuery__
 *
 * To run a query within a React component, call `useGetTableColumnRelatedActionStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableColumnRelatedActionStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableColumnRelatedActionStepsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTableColumnRelatedActionStepsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTableColumnRelatedActionStepsQuery,
    GetTableColumnRelatedActionStepsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetTableColumnRelatedActionStepsQuery,
    GetTableColumnRelatedActionStepsQueryVariables
  >(GetTableColumnRelatedActionStepsDocument, options)
}
export function useGetTableColumnRelatedActionStepsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTableColumnRelatedActionStepsQuery,
    GetTableColumnRelatedActionStepsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetTableColumnRelatedActionStepsQuery,
    GetTableColumnRelatedActionStepsQueryVariables
  >(GetTableColumnRelatedActionStepsDocument, options)
}
export type GetTableColumnRelatedActionStepsQueryHookResult = ReturnType<
  typeof useGetTableColumnRelatedActionStepsQuery
>
export type GetTableColumnRelatedActionStepsLazyQueryHookResult = ReturnType<
  typeof useGetTableColumnRelatedActionStepsLazyQuery
>
export type GetTableColumnRelatedActionStepsQueryResult = Apollo.QueryResult<
  GetTableColumnRelatedActionStepsQuery,
  GetTableColumnRelatedActionStepsQueryVariables
>
export const GetTableButtonNodesDocument = gql`
  query getTableButtonNodes($tableId: ID!) {
    tableButtonNodes(tableId: $tableId) {
      id
      name
      workspaceButtons {
        id
        name
        order
        buttonConfiguration
        requiresConfirmation
        confirmationMessage
        icon {
          id
          name
        }
        manualTrigger {
          id
          name
          action {
            id
            description
            workflow {
              id
            }
          }
          permissions {
            id
            role {
              id
              name
              roleType
            }
          }
        }
        form {
          id
          name
          permissions {
            id
            role {
              id
              name
              roleType
            }
          }
        }
        formV2 {
          id
          name
          permissions {
            id
            role {
              id
              name
              roleType
            }
          }
        }
      }
      outgoingTransitions {
        id
        name
        targetNode {
          id
        }
        condition {
          id
          logicExpressionString
        }
      }
      incomingTransitions {
        id
        name
        condition {
          id
          logicExpressionString
        }
      }
      rootButtonNodeConfig {
        id
        rootButtonNode {
          id
        }
      }
    }
  }
`

/**
 * __useGetTableButtonNodesQuery__
 *
 * To run a query within a React component, call `useGetTableButtonNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableButtonNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableButtonNodesQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetTableButtonNodesQuery(
  baseOptions: Apollo.QueryHookOptions<GetTableButtonNodesQuery, GetTableButtonNodesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTableButtonNodesQuery, GetTableButtonNodesQueryVariables>(
    GetTableButtonNodesDocument,
    options,
  )
}
export function useGetTableButtonNodesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTableButtonNodesQuery,
    GetTableButtonNodesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTableButtonNodesQuery, GetTableButtonNodesQueryVariables>(
    GetTableButtonNodesDocument,
    options,
  )
}
export type GetTableButtonNodesQueryHookResult = ReturnType<typeof useGetTableButtonNodesQuery>
export type GetTableButtonNodesLazyQueryHookResult = ReturnType<
  typeof useGetTableButtonNodesLazyQuery
>
export type GetTableButtonNodesQueryResult = Apollo.QueryResult<
  GetTableButtonNodesQuery,
  GetTableButtonNodesQueryVariables
>
export const CreateTableButtonNodeDocument = gql`
  mutation createTableButtonNode($input: CreateButtonNodeInput!) {
    createTableButtonNode(input: $input) {
      id
      name
      workspaceButtons {
        id
        name
        order
        buttonConfiguration
        requiresConfirmation
        confirmationMessage
        icon {
          id
          name
        }
        manualTrigger {
          id
          name
          action {
            id
            description
            workflow {
              id
            }
          }
          permissions {
            id
            role {
              id
              name
              roleType
            }
          }
        }
        form {
          id
          name
          permissions {
            id
            role {
              id
              name
              roleType
            }
          }
        }
        formV2 {
          id
          name
          permissions {
            id
            role {
              id
              name
              roleType
            }
          }
        }
      }
      outgoingTransitions {
        id
        name
        targetNode {
          id
        }
        condition {
          id
          logicExpressionString
        }
      }
      incomingTransitions {
        id
        name
        condition {
          id
          logicExpressionString
        }
      }
      rootButtonNodeConfig {
        id
        rootButtonNode {
          id
        }
      }
    }
  }
`
export type CreateTableButtonNodeMutationFn = Apollo.MutationFunction<
  CreateTableButtonNodeMutation,
  CreateTableButtonNodeMutationVariables
>

/**
 * __useCreateTableButtonNodeMutation__
 *
 * To run a mutation, you first call `useCreateTableButtonNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableButtonNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableButtonNodeMutation, { data, loading, error }] = useCreateTableButtonNodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTableButtonNodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTableButtonNodeMutation,
    CreateTableButtonNodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTableButtonNodeMutation, CreateTableButtonNodeMutationVariables>(
    CreateTableButtonNodeDocument,
    options,
  )
}
export type CreateTableButtonNodeMutationHookResult = ReturnType<
  typeof useCreateTableButtonNodeMutation
>
export type CreateTableButtonNodeMutationResult =
  Apollo.MutationResult<CreateTableButtonNodeMutation>
export type CreateTableButtonNodeMutationOptions = Apollo.BaseMutationOptions<
  CreateTableButtonNodeMutation,
  CreateTableButtonNodeMutationVariables
>
export const UpdateTableButtonNodeDocument = gql`
  mutation updateTableButtonNode($input: UpdateButtonNodeInput!) {
    updateTableButtonNode(input: $input) {
      id
      name
      workspaceButtons {
        id
        name
        order
        buttonConfiguration
        requiresConfirmation
        confirmationMessage
        icon {
          id
          name
        }
        manualTrigger {
          id
          name
          action {
            id
            description
            workflow {
              id
            }
          }
          permissions {
            id
            role {
              id
              name
              roleType
            }
          }
        }
        form {
          id
          name
          permissions {
            id
            role {
              id
              name
              roleType
            }
          }
        }
        formV2 {
          id
          name
          permissions {
            id
            role {
              id
              name
              roleType
            }
          }
        }
      }
      outgoingTransitions {
        id
        name
        targetNode {
          id
        }
        condition {
          id
          logicExpressionString
        }
      }
      incomingTransitions {
        id
        name
        condition {
          id
          logicExpressionString
        }
      }
      rootButtonNodeConfig {
        id
        rootButtonNode {
          id
        }
      }
    }
  }
`
export type UpdateTableButtonNodeMutationFn = Apollo.MutationFunction<
  UpdateTableButtonNodeMutation,
  UpdateTableButtonNodeMutationVariables
>

/**
 * __useUpdateTableButtonNodeMutation__
 *
 * To run a mutation, you first call `useUpdateTableButtonNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableButtonNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableButtonNodeMutation, { data, loading, error }] = useUpdateTableButtonNodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableButtonNodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTableButtonNodeMutation,
    UpdateTableButtonNodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTableButtonNodeMutation, UpdateTableButtonNodeMutationVariables>(
    UpdateTableButtonNodeDocument,
    options,
  )
}
export type UpdateTableButtonNodeMutationHookResult = ReturnType<
  typeof useUpdateTableButtonNodeMutation
>
export type UpdateTableButtonNodeMutationResult =
  Apollo.MutationResult<UpdateTableButtonNodeMutation>
export type UpdateTableButtonNodeMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableButtonNodeMutation,
  UpdateTableButtonNodeMutationVariables
>
export const DeleteTableButtonNodeDocument = gql`
  mutation deleteTableButtonNode($tableButtonNodeId: ID!) {
    deleteTableButtonNode(tableButtonNodeId: $tableButtonNodeId) {
      id
    }
  }
`
export type DeleteTableButtonNodeMutationFn = Apollo.MutationFunction<
  DeleteTableButtonNodeMutation,
  DeleteTableButtonNodeMutationVariables
>

/**
 * __useDeleteTableButtonNodeMutation__
 *
 * To run a mutation, you first call `useDeleteTableButtonNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableButtonNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableButtonNodeMutation, { data, loading, error }] = useDeleteTableButtonNodeMutation({
 *   variables: {
 *      tableButtonNodeId: // value for 'tableButtonNodeId'
 *   },
 * });
 */
export function useDeleteTableButtonNodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTableButtonNodeMutation,
    DeleteTableButtonNodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTableButtonNodeMutation, DeleteTableButtonNodeMutationVariables>(
    DeleteTableButtonNodeDocument,
    options,
  )
}
export type DeleteTableButtonNodeMutationHookResult = ReturnType<
  typeof useDeleteTableButtonNodeMutation
>
export type DeleteTableButtonNodeMutationResult =
  Apollo.MutationResult<DeleteTableButtonNodeMutation>
export type DeleteTableButtonNodeMutationOptions = Apollo.BaseMutationOptions<
  DeleteTableButtonNodeMutation,
  DeleteTableButtonNodeMutationVariables
>
export const DeleteTableButtonTransitionDocument = gql`
  mutation deleteTableButtonTransition($tableButtonTransitionId: ID!) {
    deleteTableButtonTransition(tableButtonTransitionId: $tableButtonTransitionId) {
      id
    }
  }
`
export type DeleteTableButtonTransitionMutationFn = Apollo.MutationFunction<
  DeleteTableButtonTransitionMutation,
  DeleteTableButtonTransitionMutationVariables
>

/**
 * __useDeleteTableButtonTransitionMutation__
 *
 * To run a mutation, you first call `useDeleteTableButtonTransitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableButtonTransitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableButtonTransitionMutation, { data, loading, error }] = useDeleteTableButtonTransitionMutation({
 *   variables: {
 *      tableButtonTransitionId: // value for 'tableButtonTransitionId'
 *   },
 * });
 */
export function useDeleteTableButtonTransitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTableButtonTransitionMutation,
    DeleteTableButtonTransitionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteTableButtonTransitionMutation,
    DeleteTableButtonTransitionMutationVariables
  >(DeleteTableButtonTransitionDocument, options)
}
export type DeleteTableButtonTransitionMutationHookResult = ReturnType<
  typeof useDeleteTableButtonTransitionMutation
>
export type DeleteTableButtonTransitionMutationResult =
  Apollo.MutationResult<DeleteTableButtonTransitionMutation>
export type DeleteTableButtonTransitionMutationOptions = Apollo.BaseMutationOptions<
  DeleteTableButtonTransitionMutation,
  DeleteTableButtonTransitionMutationVariables
>
export const CreateTableButtonTransitionDocument = gql`
  mutation createTableButtonTransition($input: CreateButtonTransitionInput!) {
    createTableButtonTransition(input: $input) {
      id
      name
      condition {
        id
        logicExpressionString
      }
    }
  }
`
export type CreateTableButtonTransitionMutationFn = Apollo.MutationFunction<
  CreateTableButtonTransitionMutation,
  CreateTableButtonTransitionMutationVariables
>

/**
 * __useCreateTableButtonTransitionMutation__
 *
 * To run a mutation, you first call `useCreateTableButtonTransitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableButtonTransitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableButtonTransitionMutation, { data, loading, error }] = useCreateTableButtonTransitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTableButtonTransitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTableButtonTransitionMutation,
    CreateTableButtonTransitionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateTableButtonTransitionMutation,
    CreateTableButtonTransitionMutationVariables
  >(CreateTableButtonTransitionDocument, options)
}
export type CreateTableButtonTransitionMutationHookResult = ReturnType<
  typeof useCreateTableButtonTransitionMutation
>
export type CreateTableButtonTransitionMutationResult =
  Apollo.MutationResult<CreateTableButtonTransitionMutation>
export type CreateTableButtonTransitionMutationOptions = Apollo.BaseMutationOptions<
  CreateTableButtonTransitionMutation,
  CreateTableButtonTransitionMutationVariables
>
export const UpdateTableButtonTransitionDocument = gql`
  mutation updateTableButtonTransition($input: UpdateButtonTransitionInput!) {
    updateTableButtonTransition(input: $input) {
      id
      name
      condition {
        id
        logicExpressionString
      }
    }
  }
`
export type UpdateTableButtonTransitionMutationFn = Apollo.MutationFunction<
  UpdateTableButtonTransitionMutation,
  UpdateTableButtonTransitionMutationVariables
>

/**
 * __useUpdateTableButtonTransitionMutation__
 *
 * To run a mutation, you first call `useUpdateTableButtonTransitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableButtonTransitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableButtonTransitionMutation, { data, loading, error }] = useUpdateTableButtonTransitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableButtonTransitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTableButtonTransitionMutation,
    UpdateTableButtonTransitionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateTableButtonTransitionMutation,
    UpdateTableButtonTransitionMutationVariables
  >(UpdateTableButtonTransitionDocument, options)
}
export type UpdateTableButtonTransitionMutationHookResult = ReturnType<
  typeof useUpdateTableButtonTransitionMutation
>
export type UpdateTableButtonTransitionMutationResult =
  Apollo.MutationResult<UpdateTableButtonTransitionMutation>
export type UpdateTableButtonTransitionMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableButtonTransitionMutation,
  UpdateTableButtonTransitionMutationVariables
>
export const CreateButtonNodeWorkspaceButtonsDocument = gql`
  mutation createButtonNodeWorkspaceButtons($input: CreateButtonNodeWorkspaceButtonsInput!) {
    createButtonNodeWorkspaceButtons(input: $input) {
      id
      name
      order
      buttonConfiguration
      requiresConfirmation
      confirmationMessage
      icon {
        id
        name
      }
      manualTrigger {
        id
        name
        permissions {
          id
          role {
            id
            name
            roleType
          }
        }
      }
      form {
        id
        name
        permissions {
          id
          role {
            id
            name
            roleType
          }
        }
      }
      formV2 {
        id
        name
        permissions {
          id
          role {
            id
            name
            roleType
          }
        }
      }
    }
  }
`
export type CreateButtonNodeWorkspaceButtonsMutationFn = Apollo.MutationFunction<
  CreateButtonNodeWorkspaceButtonsMutation,
  CreateButtonNodeWorkspaceButtonsMutationVariables
>

/**
 * __useCreateButtonNodeWorkspaceButtonsMutation__
 *
 * To run a mutation, you first call `useCreateButtonNodeWorkspaceButtonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateButtonNodeWorkspaceButtonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createButtonNodeWorkspaceButtonsMutation, { data, loading, error }] = useCreateButtonNodeWorkspaceButtonsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateButtonNodeWorkspaceButtonsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateButtonNodeWorkspaceButtonsMutation,
    CreateButtonNodeWorkspaceButtonsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateButtonNodeWorkspaceButtonsMutation,
    CreateButtonNodeWorkspaceButtonsMutationVariables
  >(CreateButtonNodeWorkspaceButtonsDocument, options)
}
export type CreateButtonNodeWorkspaceButtonsMutationHookResult = ReturnType<
  typeof useCreateButtonNodeWorkspaceButtonsMutation
>
export type CreateButtonNodeWorkspaceButtonsMutationResult =
  Apollo.MutationResult<CreateButtonNodeWorkspaceButtonsMutation>
export type CreateButtonNodeWorkspaceButtonsMutationOptions = Apollo.BaseMutationOptions<
  CreateButtonNodeWorkspaceButtonsMutation,
  CreateButtonNodeWorkspaceButtonsMutationVariables
>
export const UpdateButtonNodeWorkspaceButtonDocument = gql`
  mutation updateButtonNodeWorkspaceButton($input: UpdateWorkspaceButtonInput!) {
    updateWorkspaceButton(input: $input) {
      id
      name
      order
      buttonConfiguration
      requiresConfirmation
      confirmationMessage
      icon {
        id
        name
      }
      manualTrigger {
        id
        name
        permissions {
          id
          role {
            id
            name
            roleType
          }
        }
      }
      form {
        id
        name
        permissions {
          id
          role {
            id
            name
            roleType
          }
        }
      }
      formV2 {
        id
        name
        permissions {
          id
          role {
            id
            name
            roleType
          }
        }
      }
    }
  }
`
export type UpdateButtonNodeWorkspaceButtonMutationFn = Apollo.MutationFunction<
  UpdateButtonNodeWorkspaceButtonMutation,
  UpdateButtonNodeWorkspaceButtonMutationVariables
>

/**
 * __useUpdateButtonNodeWorkspaceButtonMutation__
 *
 * To run a mutation, you first call `useUpdateButtonNodeWorkspaceButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateButtonNodeWorkspaceButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateButtonNodeWorkspaceButtonMutation, { data, loading, error }] = useUpdateButtonNodeWorkspaceButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateButtonNodeWorkspaceButtonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateButtonNodeWorkspaceButtonMutation,
    UpdateButtonNodeWorkspaceButtonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateButtonNodeWorkspaceButtonMutation,
    UpdateButtonNodeWorkspaceButtonMutationVariables
  >(UpdateButtonNodeWorkspaceButtonDocument, options)
}
export type UpdateButtonNodeWorkspaceButtonMutationHookResult = ReturnType<
  typeof useUpdateButtonNodeWorkspaceButtonMutation
>
export type UpdateButtonNodeWorkspaceButtonMutationResult =
  Apollo.MutationResult<UpdateButtonNodeWorkspaceButtonMutation>
export type UpdateButtonNodeWorkspaceButtonMutationOptions = Apollo.BaseMutationOptions<
  UpdateButtonNodeWorkspaceButtonMutation,
  UpdateButtonNodeWorkspaceButtonMutationVariables
>
export const ReorderWorkspaceButtonDocument = gql`
  mutation reorderWorkspaceButton($input: ReorderWorkspaceButtonInput!) {
    reorderWorkspaceButton(input: $input) {
      id
      name
      order
      buttonConfiguration
      requiresConfirmation
      confirmationMessage
      icon {
        id
        name
      }
      manualTrigger {
        id
        name
        permissions {
          id
          role {
            id
            name
            roleType
          }
        }
      }
      form {
        id
        name
        permissions {
          id
          role {
            id
            name
            roleType
          }
        }
      }
      formV2 {
        id
        name
        permissions {
          id
          role {
            id
            name
            roleType
          }
        }
      }
    }
  }
`
export type ReorderWorkspaceButtonMutationFn = Apollo.MutationFunction<
  ReorderWorkspaceButtonMutation,
  ReorderWorkspaceButtonMutationVariables
>

/**
 * __useReorderWorkspaceButtonMutation__
 *
 * To run a mutation, you first call `useReorderWorkspaceButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderWorkspaceButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderWorkspaceButtonMutation, { data, loading, error }] = useReorderWorkspaceButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderWorkspaceButtonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderWorkspaceButtonMutation,
    ReorderWorkspaceButtonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ReorderWorkspaceButtonMutation,
    ReorderWorkspaceButtonMutationVariables
  >(ReorderWorkspaceButtonDocument, options)
}
export type ReorderWorkspaceButtonMutationHookResult = ReturnType<
  typeof useReorderWorkspaceButtonMutation
>
export type ReorderWorkspaceButtonMutationResult =
  Apollo.MutationResult<ReorderWorkspaceButtonMutation>
export type ReorderWorkspaceButtonMutationOptions = Apollo.BaseMutationOptions<
  ReorderWorkspaceButtonMutation,
  ReorderWorkspaceButtonMutationVariables
>
export const TriggerTableButtonNodeEvaluationDocument = gql`
  mutation triggerTableButtonNodeEvaluation($tableId: ID!) {
    triggerTableButtonNodeEvaluation(tableId: $tableId) {
      success
      message
      jobId
      jobUrl
    }
  }
`
export type TriggerTableButtonNodeEvaluationMutationFn = Apollo.MutationFunction<
  TriggerTableButtonNodeEvaluationMutation,
  TriggerTableButtonNodeEvaluationMutationVariables
>

/**
 * __useTriggerTableButtonNodeEvaluationMutation__
 *
 * To run a mutation, you first call `useTriggerTableButtonNodeEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerTableButtonNodeEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerTableButtonNodeEvaluationMutation, { data, loading, error }] = useTriggerTableButtonNodeEvaluationMutation({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useTriggerTableButtonNodeEvaluationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TriggerTableButtonNodeEvaluationMutation,
    TriggerTableButtonNodeEvaluationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    TriggerTableButtonNodeEvaluationMutation,
    TriggerTableButtonNodeEvaluationMutationVariables
  >(TriggerTableButtonNodeEvaluationDocument, options)
}
export type TriggerTableButtonNodeEvaluationMutationHookResult = ReturnType<
  typeof useTriggerTableButtonNodeEvaluationMutation
>
export type TriggerTableButtonNodeEvaluationMutationResult =
  Apollo.MutationResult<TriggerTableButtonNodeEvaluationMutation>
export type TriggerTableButtonNodeEvaluationMutationOptions = Apollo.BaseMutationOptions<
  TriggerTableButtonNodeEvaluationMutation,
  TriggerTableButtonNodeEvaluationMutationVariables
>
export const UpdateRowCurrentNodesDocument = gql`
  mutation updateRowCurrentNodes($input: UpdateRowCurrentNodesInput!) {
    updateRowCurrentNodes(input: $input) {
      id
      currentButtonNodes {
        id
        name
        workspaceButtons {
          id
          name
          order
          buttonConfiguration
          requiresConfirmation
          confirmationMessage
          icon {
            id
            name
          }
          manualTrigger {
            id
            name
            action {
              id
              status
              description
              workflow {
                id
                status
              }
            }
          }
          form {
            id
            name
          }
          formV2 {
            id
            name
          }
        }
      }
      processingWorkspaceButton {
        id
        name
      }
    }
  }
`
export type UpdateRowCurrentNodesMutationFn = Apollo.MutationFunction<
  UpdateRowCurrentNodesMutation,
  UpdateRowCurrentNodesMutationVariables
>

/**
 * __useUpdateRowCurrentNodesMutation__
 *
 * To run a mutation, you first call `useUpdateRowCurrentNodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRowCurrentNodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRowCurrentNodesMutation, { data, loading, error }] = useUpdateRowCurrentNodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRowCurrentNodesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRowCurrentNodesMutation,
    UpdateRowCurrentNodesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateRowCurrentNodesMutation, UpdateRowCurrentNodesMutationVariables>(
    UpdateRowCurrentNodesDocument,
    options,
  )
}
export type UpdateRowCurrentNodesMutationHookResult = ReturnType<
  typeof useUpdateRowCurrentNodesMutation
>
export type UpdateRowCurrentNodesMutationResult =
  Apollo.MutationResult<UpdateRowCurrentNodesMutation>
export type UpdateRowCurrentNodesMutationOptions = Apollo.BaseMutationOptions<
  UpdateRowCurrentNodesMutation,
  UpdateRowCurrentNodesMutationVariables
>
export const ReorderTableColumnGroupMemberDocument = gql`
  mutation reorderTableColumnGroupMember($input: ReorderTableColumnGroupMemberInput!) {
    reorderTableColumnGroupMember(input: $input) {
      id
      order
    }
  }
`
export type ReorderTableColumnGroupMemberMutationFn = Apollo.MutationFunction<
  ReorderTableColumnGroupMemberMutation,
  ReorderTableColumnGroupMemberMutationVariables
>

/**
 * __useReorderTableColumnGroupMemberMutation__
 *
 * To run a mutation, you first call `useReorderTableColumnGroupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderTableColumnGroupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderTableColumnGroupMemberMutation, { data, loading, error }] = useReorderTableColumnGroupMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderTableColumnGroupMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderTableColumnGroupMemberMutation,
    ReorderTableColumnGroupMemberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ReorderTableColumnGroupMemberMutation,
    ReorderTableColumnGroupMemberMutationVariables
  >(ReorderTableColumnGroupMemberDocument, options)
}
export type ReorderTableColumnGroupMemberMutationHookResult = ReturnType<
  typeof useReorderTableColumnGroupMemberMutation
>
export type ReorderTableColumnGroupMemberMutationResult =
  Apollo.MutationResult<ReorderTableColumnGroupMemberMutation>
export type ReorderTableColumnGroupMemberMutationOptions = Apollo.BaseMutationOptions<
  ReorderTableColumnGroupMemberMutation,
  ReorderTableColumnGroupMemberMutationVariables
>
export const DeleteTableColumnGroupMemberDocument = gql`
  mutation deleteTableColumnGroupMember($tableColumnGroupMemberId: ID!) {
    deleteTableColumnGroupMember(tableColumnGroupMemberId: $tableColumnGroupMemberId) {
      id
    }
  }
`
export type DeleteTableColumnGroupMemberMutationFn = Apollo.MutationFunction<
  DeleteTableColumnGroupMemberMutation,
  DeleteTableColumnGroupMemberMutationVariables
>

/**
 * __useDeleteTableColumnGroupMemberMutation__
 *
 * To run a mutation, you first call `useDeleteTableColumnGroupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableColumnGroupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableColumnGroupMemberMutation, { data, loading, error }] = useDeleteTableColumnGroupMemberMutation({
 *   variables: {
 *      tableColumnGroupMemberId: // value for 'tableColumnGroupMemberId'
 *   },
 * });
 */
export function useDeleteTableColumnGroupMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTableColumnGroupMemberMutation,
    DeleteTableColumnGroupMemberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteTableColumnGroupMemberMutation,
    DeleteTableColumnGroupMemberMutationVariables
  >(DeleteTableColumnGroupMemberDocument, options)
}
export type DeleteTableColumnGroupMemberMutationHookResult = ReturnType<
  typeof useDeleteTableColumnGroupMemberMutation
>
export type DeleteTableColumnGroupMemberMutationResult =
  Apollo.MutationResult<DeleteTableColumnGroupMemberMutation>
export type DeleteTableColumnGroupMemberMutationOptions = Apollo.BaseMutationOptions<
  DeleteTableColumnGroupMemberMutation,
  DeleteTableColumnGroupMemberMutationVariables
>
export const DeleteTableColumnGroupMembersDocument = gql`
  mutation deleteTableColumnGroupMembers($input: DeleteTableColumnGroupMembersInput!) {
    deleteTableColumnGroupMembers(input: $input) {
      id
    }
  }
`
export type DeleteTableColumnGroupMembersMutationFn = Apollo.MutationFunction<
  DeleteTableColumnGroupMembersMutation,
  DeleteTableColumnGroupMembersMutationVariables
>

/**
 * __useDeleteTableColumnGroupMembersMutation__
 *
 * To run a mutation, you first call `useDeleteTableColumnGroupMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableColumnGroupMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableColumnGroupMembersMutation, { data, loading, error }] = useDeleteTableColumnGroupMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTableColumnGroupMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTableColumnGroupMembersMutation,
    DeleteTableColumnGroupMembersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteTableColumnGroupMembersMutation,
    DeleteTableColumnGroupMembersMutationVariables
  >(DeleteTableColumnGroupMembersDocument, options)
}
export type DeleteTableColumnGroupMembersMutationHookResult = ReturnType<
  typeof useDeleteTableColumnGroupMembersMutation
>
export type DeleteTableColumnGroupMembersMutationResult =
  Apollo.MutationResult<DeleteTableColumnGroupMembersMutation>
export type DeleteTableColumnGroupMembersMutationOptions = Apollo.BaseMutationOptions<
  DeleteTableColumnGroupMembersMutation,
  DeleteTableColumnGroupMembersMutationVariables
>
export const MoveTableColumnGroupMemberDocument = gql`
  mutation moveTableColumnGroupMember($input: MoveTableColumnGroupMemberInput!) {
    moveTableColumnGroupMember(input: $input) {
      id
      order
      tableColumn {
        id
      }
    }
  }
`
export type MoveTableColumnGroupMemberMutationFn = Apollo.MutationFunction<
  MoveTableColumnGroupMemberMutation,
  MoveTableColumnGroupMemberMutationVariables
>

/**
 * __useMoveTableColumnGroupMemberMutation__
 *
 * To run a mutation, you first call `useMoveTableColumnGroupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTableColumnGroupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTableColumnGroupMemberMutation, { data, loading, error }] = useMoveTableColumnGroupMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveTableColumnGroupMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MoveTableColumnGroupMemberMutation,
    MoveTableColumnGroupMemberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MoveTableColumnGroupMemberMutation,
    MoveTableColumnGroupMemberMutationVariables
  >(MoveTableColumnGroupMemberDocument, options)
}
export type MoveTableColumnGroupMemberMutationHookResult = ReturnType<
  typeof useMoveTableColumnGroupMemberMutation
>
export type MoveTableColumnGroupMemberMutationResult =
  Apollo.MutationResult<MoveTableColumnGroupMemberMutation>
export type MoveTableColumnGroupMemberMutationOptions = Apollo.BaseMutationOptions<
  MoveTableColumnGroupMemberMutation,
  MoveTableColumnGroupMemberMutationVariables
>
export const ReorderTableColumnGroupDocument = gql`
  mutation reorderTableColumnGroup($input: ReorderTableColumnGroupInput!) {
    reorderTableColumnGroup(input: $input) {
      id
      order
    }
  }
`
export type ReorderTableColumnGroupMutationFn = Apollo.MutationFunction<
  ReorderTableColumnGroupMutation,
  ReorderTableColumnGroupMutationVariables
>

/**
 * __useReorderTableColumnGroupMutation__
 *
 * To run a mutation, you first call `useReorderTableColumnGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderTableColumnGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderTableColumnGroupMutation, { data, loading, error }] = useReorderTableColumnGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderTableColumnGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderTableColumnGroupMutation,
    ReorderTableColumnGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ReorderTableColumnGroupMutation,
    ReorderTableColumnGroupMutationVariables
  >(ReorderTableColumnGroupDocument, options)
}
export type ReorderTableColumnGroupMutationHookResult = ReturnType<
  typeof useReorderTableColumnGroupMutation
>
export type ReorderTableColumnGroupMutationResult =
  Apollo.MutationResult<ReorderTableColumnGroupMutation>
export type ReorderTableColumnGroupMutationOptions = Apollo.BaseMutationOptions<
  ReorderTableColumnGroupMutation,
  ReorderTableColumnGroupMutationVariables
>
export const ReorderChildTableDocument = gql`
  mutation reorderChildTable($input: ReorderChildTableInput!) {
    reorderChildTable(input: $input) {
      id
      orderOnRecordDetails
    }
  }
`
export type ReorderChildTableMutationFn = Apollo.MutationFunction<
  ReorderChildTableMutation,
  ReorderChildTableMutationVariables
>

/**
 * __useReorderChildTableMutation__
 *
 * To run a mutation, you first call `useReorderChildTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderChildTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderChildTableMutation, { data, loading, error }] = useReorderChildTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderChildTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderChildTableMutation,
    ReorderChildTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReorderChildTableMutation, ReorderChildTableMutationVariables>(
    ReorderChildTableDocument,
    options,
  )
}
export type ReorderChildTableMutationHookResult = ReturnType<typeof useReorderChildTableMutation>
export type ReorderChildTableMutationResult = Apollo.MutationResult<ReorderChildTableMutation>
export type ReorderChildTableMutationOptions = Apollo.BaseMutationOptions<
  ReorderChildTableMutation,
  ReorderChildTableMutationVariables
>
export const UpdateTableColumnsVisibilityDocument = gql`
  mutation UpdateTableColumnsVisibility($input: UpdateTableColumnsVisibilityInput!) {
    updateTableColumnsVisibility(input: $input) {
      id
      isVisibleOnRecordDetails
    }
  }
`
export type UpdateTableColumnsVisibilityMutationFn = Apollo.MutationFunction<
  UpdateTableColumnsVisibilityMutation,
  UpdateTableColumnsVisibilityMutationVariables
>

/**
 * __useUpdateTableColumnsVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateTableColumnsVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableColumnsVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableColumnsVisibilityMutation, { data, loading, error }] = useUpdateTableColumnsVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableColumnsVisibilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTableColumnsVisibilityMutation,
    UpdateTableColumnsVisibilityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateTableColumnsVisibilityMutation,
    UpdateTableColumnsVisibilityMutationVariables
  >(UpdateTableColumnsVisibilityDocument, options)
}
export type UpdateTableColumnsVisibilityMutationHookResult = ReturnType<
  typeof useUpdateTableColumnsVisibilityMutation
>
export type UpdateTableColumnsVisibilityMutationResult =
  Apollo.MutationResult<UpdateTableColumnsVisibilityMutation>
export type UpdateTableColumnsVisibilityMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableColumnsVisibilityMutation,
  UpdateTableColumnsVisibilityMutationVariables
>
export const GetTablesDocument = gql`
  query getTables {
    tables {
      id
      name
      isShareable
      rootWorkspace {
        id
      }
      parentTable {
        id
        name
      }
      columns {
        id
        name
        type
        order
        innerType
        ...ColumnFormatting
        ...ResolvedSourceColumn
        lookupColumn {
          ...LookupProviderColumn
        }
      }
      icon {
        id
        name
      }
      lookupFormCategories {
        id
        name
        page {
          id
          form {
            id
            isShareable
          }
        }
      }
    }
  }
  ${ColumnFormattingFragmentDoc}
  ${ResolvedSourceColumnFragmentDoc}
  ${LookupProviderColumnFragmentDoc}
`

/**
 * __useGetTablesQuery__
 *
 * To run a query within a React component, call `useGetTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTablesQuery, GetTablesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTablesQuery, GetTablesQueryVariables>(GetTablesDocument, options)
}
export function useGetTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTablesQuery, GetTablesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTablesQuery, GetTablesQueryVariables>(GetTablesDocument, options)
}
export type GetTablesQueryHookResult = ReturnType<typeof useGetTablesQuery>
export type GetTablesLazyQueryHookResult = ReturnType<typeof useGetTablesLazyQuery>
export type GetTablesQueryResult = Apollo.QueryResult<GetTablesQuery, GetTablesQueryVariables>
export const GetTablesSimpleDocument = gql`
  query getTablesSimple($input: TablesInput) {
    tables(input: $input) {
      id
      name
      rootWorkspace {
        id
      }
      parentTable {
        id
        name
      }
      icon {
        id
        name
      }
    }
  }
`

/**
 * __useGetTablesSimpleQuery__
 *
 * To run a query within a React component, call `useGetTablesSimpleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTablesSimpleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTablesSimpleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTablesSimpleQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTablesSimpleQuery, GetTablesSimpleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTablesSimpleQuery, GetTablesSimpleQueryVariables>(
    GetTablesSimpleDocument,
    options,
  )
}
export function useGetTablesSimpleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTablesSimpleQuery, GetTablesSimpleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTablesSimpleQuery, GetTablesSimpleQueryVariables>(
    GetTablesSimpleDocument,
    options,
  )
}
export type GetTablesSimpleQueryHookResult = ReturnType<typeof useGetTablesSimpleQuery>
export type GetTablesSimpleLazyQueryHookResult = ReturnType<typeof useGetTablesSimpleLazyQuery>
export type GetTablesSimpleQueryResult = Apollo.QueryResult<
  GetTablesSimpleQuery,
  GetTablesSimpleQueryVariables
>
export const CreateTableColumnGroupMembersDocument = gql`
  mutation createTableColumnGroupMembers($input: CreateTableColumnGroupMembersInput!) {
    createTableColumnGroupMembers(input: $input) {
      id
      order
      tableColumn {
        id
      }
    }
  }
`
export type CreateTableColumnGroupMembersMutationFn = Apollo.MutationFunction<
  CreateTableColumnGroupMembersMutation,
  CreateTableColumnGroupMembersMutationVariables
>

/**
 * __useCreateTableColumnGroupMembersMutation__
 *
 * To run a mutation, you first call `useCreateTableColumnGroupMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableColumnGroupMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableColumnGroupMembersMutation, { data, loading, error }] = useCreateTableColumnGroupMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTableColumnGroupMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTableColumnGroupMembersMutation,
    CreateTableColumnGroupMembersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateTableColumnGroupMembersMutation,
    CreateTableColumnGroupMembersMutationVariables
  >(CreateTableColumnGroupMembersDocument, options)
}
export type CreateTableColumnGroupMembersMutationHookResult = ReturnType<
  typeof useCreateTableColumnGroupMembersMutation
>
export type CreateTableColumnGroupMembersMutationResult =
  Apollo.MutationResult<CreateTableColumnGroupMembersMutation>
export type CreateTableColumnGroupMembersMutationOptions = Apollo.BaseMutationOptions<
  CreateTableColumnGroupMembersMutation,
  CreateTableColumnGroupMembersMutationVariables
>
export const MoveTableColumnGroupMembersDocument = gql`
  mutation moveTableColumnGroupMembers($input: MoveTableColumnGroupMembersInput!) {
    moveTableColumnGroupMembers(input: $input) {
      id
      order
      tableColumn {
        id
      }
    }
  }
`
export type MoveTableColumnGroupMembersMutationFn = Apollo.MutationFunction<
  MoveTableColumnGroupMembersMutation,
  MoveTableColumnGroupMembersMutationVariables
>

/**
 * __useMoveTableColumnGroupMembersMutation__
 *
 * To run a mutation, you first call `useMoveTableColumnGroupMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveTableColumnGroupMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveTableColumnGroupMembersMutation, { data, loading, error }] = useMoveTableColumnGroupMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveTableColumnGroupMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MoveTableColumnGroupMembersMutation,
    MoveTableColumnGroupMembersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MoveTableColumnGroupMembersMutation,
    MoveTableColumnGroupMembersMutationVariables
  >(MoveTableColumnGroupMembersDocument, options)
}
export type MoveTableColumnGroupMembersMutationHookResult = ReturnType<
  typeof useMoveTableColumnGroupMembersMutation
>
export type MoveTableColumnGroupMembersMutationResult =
  Apollo.MutationResult<MoveTableColumnGroupMembersMutation>
export type MoveTableColumnGroupMembersMutationOptions = Apollo.BaseMutationOptions<
  MoveTableColumnGroupMembersMutation,
  MoveTableColumnGroupMembersMutationVariables
>
export const GetPreviewCellsDocument = gql`
  query getPreviewCells($input: PreviewCellsInput!) {
    previewCells(input: $input) {
      id
      data
      userVisibleValue
    }
  }
`

/**
 * __useGetPreviewCellsQuery__
 *
 * To run a query within a React component, call `useGetPreviewCellsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewCellsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewCellsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPreviewCellsQuery(
  baseOptions: Apollo.QueryHookOptions<GetPreviewCellsQuery, GetPreviewCellsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPreviewCellsQuery, GetPreviewCellsQueryVariables>(
    GetPreviewCellsDocument,
    options,
  )
}
export function useGetPreviewCellsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewCellsQuery, GetPreviewCellsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPreviewCellsQuery, GetPreviewCellsQueryVariables>(
    GetPreviewCellsDocument,
    options,
  )
}
export type GetPreviewCellsQueryHookResult = ReturnType<typeof useGetPreviewCellsQuery>
export type GetPreviewCellsLazyQueryHookResult = ReturnType<typeof useGetPreviewCellsLazyQuery>
export type GetPreviewCellsQueryResult = Apollo.QueryResult<
  GetPreviewCellsQuery,
  GetPreviewCellsQueryVariables
>
export const GetSimpleFormsDocument = gql`
  query getSimpleForms {
    forms {
      id
      name
    }
  }
`

/**
 * __useGetSimpleFormsQuery__
 *
 * To run a query within a React component, call `useGetSimpleFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSimpleFormsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSimpleFormsQuery, GetSimpleFormsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSimpleFormsQuery, GetSimpleFormsQueryVariables>(
    GetSimpleFormsDocument,
    options,
  )
}
export function useGetSimpleFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleFormsQuery, GetSimpleFormsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSimpleFormsQuery, GetSimpleFormsQueryVariables>(
    GetSimpleFormsDocument,
    options,
  )
}
export type GetSimpleFormsQueryHookResult = ReturnType<typeof useGetSimpleFormsQuery>
export type GetSimpleFormsLazyQueryHookResult = ReturnType<typeof useGetSimpleFormsLazyQuery>
export type GetSimpleFormsQueryResult = Apollo.QueryResult<
  GetSimpleFormsQuery,
  GetSimpleFormsQueryVariables
>
export const GetSimpleFormsV2Document = gql`
  query getSimpleFormsV2 {
    allFormsV2 {
      id
      name
    }
  }
`

/**
 * __useGetSimpleFormsV2Query__
 *
 * To run a query within a React component, call `useGetSimpleFormsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleFormsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleFormsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetSimpleFormsV2Query(
  baseOptions?: Apollo.QueryHookOptions<GetSimpleFormsV2Query, GetSimpleFormsV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSimpleFormsV2Query, GetSimpleFormsV2QueryVariables>(
    GetSimpleFormsV2Document,
    options,
  )
}
export function useGetSimpleFormsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleFormsV2Query, GetSimpleFormsV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSimpleFormsV2Query, GetSimpleFormsV2QueryVariables>(
    GetSimpleFormsV2Document,
    options,
  )
}
export type GetSimpleFormsV2QueryHookResult = ReturnType<typeof useGetSimpleFormsV2Query>
export type GetSimpleFormsV2LazyQueryHookResult = ReturnType<typeof useGetSimpleFormsV2LazyQuery>
export type GetSimpleFormsV2QueryResult = Apollo.QueryResult<
  GetSimpleFormsV2Query,
  GetSimpleFormsV2QueryVariables
>
export const CreateTableExportDocument = gql`
  mutation createTableExport($input: CreateTableExportInput!) {
    createTableExport(input: $input) {
      id
      status
      fileName
    }
  }
`
export type CreateTableExportMutationFn = Apollo.MutationFunction<
  CreateTableExportMutation,
  CreateTableExportMutationVariables
>

/**
 * __useCreateTableExportMutation__
 *
 * To run a mutation, you first call `useCreateTableExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableExportMutation, { data, loading, error }] = useCreateTableExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTableExportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTableExportMutation,
    CreateTableExportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTableExportMutation, CreateTableExportMutationVariables>(
    CreateTableExportDocument,
    options,
  )
}
export type CreateTableExportMutationHookResult = ReturnType<typeof useCreateTableExportMutation>
export type CreateTableExportMutationResult = Apollo.MutationResult<CreateTableExportMutation>
export type CreateTableExportMutationOptions = Apollo.BaseMutationOptions<
  CreateTableExportMutation,
  CreateTableExportMutationVariables
>
export const GetTableExportsDocument = gql`
  query getTableExports($tableId: ID!) {
    tableExports(tableId: $tableId) {
      id
      createdAt
      status
      rowCount
      fileName
      table {
        name
      }
      errorMessage
      createdBy {
        id
        firstName
        lastName
      }
      document {
        id
        storageUrl
      }
    }
  }
`

/**
 * __useGetTableExportsQuery__
 *
 * To run a query within a React component, call `useGetTableExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableExportsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetTableExportsQuery(
  baseOptions: Apollo.QueryHookOptions<GetTableExportsQuery, GetTableExportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTableExportsQuery, GetTableExportsQueryVariables>(
    GetTableExportsDocument,
    options,
  )
}
export function useGetTableExportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTableExportsQuery, GetTableExportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTableExportsQuery, GetTableExportsQueryVariables>(
    GetTableExportsDocument,
    options,
  )
}
export type GetTableExportsQueryHookResult = ReturnType<typeof useGetTableExportsQuery>
export type GetTableExportsLazyQueryHookResult = ReturnType<typeof useGetTableExportsLazyQuery>
export type GetTableExportsQueryResult = Apollo.QueryResult<
  GetTableExportsQuery,
  GetTableExportsQueryVariables
>
export const PushTableExportProgressDocument = gql`
  subscription pushTableExportProgress($tableId: ID!) {
    pushTableExportProgress(tableId: $tableId) {
      objectId
      completedCount
      totalCount
    }
  }
`

/**
 * __usePushTableExportProgressSubscription__
 *
 * To run a query within a React component, call `usePushTableExportProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushTableExportProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushTableExportProgressSubscription({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function usePushTableExportProgressSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PushTableExportProgressSubscription,
    PushTableExportProgressSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    PushTableExportProgressSubscription,
    PushTableExportProgressSubscriptionVariables
  >(PushTableExportProgressDocument, options)
}
export type PushTableExportProgressSubscriptionHookResult = ReturnType<
  typeof usePushTableExportProgressSubscription
>
export type PushTableExportProgressSubscriptionResult =
  Apollo.SubscriptionResult<PushTableExportProgressSubscription>
export const GetTableUniqueConstraintsDocument = gql`
  query getTableUniqueConstraints($tableId: ID!) {
    table(tableId: $tableId) {
      id
      name
      parentTable {
        id
        name
      }
      uniqueConstraints {
        ...TableUniqueConstraintDetails
      }
      childTables {
        id
        name
        uniqueConstraints {
          ...TableUniqueConstraintDetails
        }
      }
    }
  }
  ${TableUniqueConstraintDetailsFragmentDoc}
`

/**
 * __useGetTableUniqueConstraintsQuery__
 *
 * To run a query within a React component, call `useGetTableUniqueConstraintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableUniqueConstraintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableUniqueConstraintsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetTableUniqueConstraintsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTableUniqueConstraintsQuery,
    GetTableUniqueConstraintsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTableUniqueConstraintsQuery, GetTableUniqueConstraintsQueryVariables>(
    GetTableUniqueConstraintsDocument,
    options,
  )
}
export function useGetTableUniqueConstraintsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTableUniqueConstraintsQuery,
    GetTableUniqueConstraintsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetTableUniqueConstraintsQuery,
    GetTableUniqueConstraintsQueryVariables
  >(GetTableUniqueConstraintsDocument, options)
}
export type GetTableUniqueConstraintsQueryHookResult = ReturnType<
  typeof useGetTableUniqueConstraintsQuery
>
export type GetTableUniqueConstraintsLazyQueryHookResult = ReturnType<
  typeof useGetTableUniqueConstraintsLazyQuery
>
export type GetTableUniqueConstraintsQueryResult = Apollo.QueryResult<
  GetTableUniqueConstraintsQuery,
  GetTableUniqueConstraintsQueryVariables
>
export const CreateTableUniqueConstraintDocument = gql`
  mutation createTableUniqueConstraint($input: CreateTableUniqueConstraintInput!) {
    createTableUniqueConstraint(input: $input) {
      id
      name
      status
      scope
    }
  }
`
export type CreateTableUniqueConstraintMutationFn = Apollo.MutationFunction<
  CreateTableUniqueConstraintMutation,
  CreateTableUniqueConstraintMutationVariables
>

/**
 * __useCreateTableUniqueConstraintMutation__
 *
 * To run a mutation, you first call `useCreateTableUniqueConstraintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableUniqueConstraintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableUniqueConstraintMutation, { data, loading, error }] = useCreateTableUniqueConstraintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTableUniqueConstraintMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTableUniqueConstraintMutation,
    CreateTableUniqueConstraintMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateTableUniqueConstraintMutation,
    CreateTableUniqueConstraintMutationVariables
  >(CreateTableUniqueConstraintDocument, options)
}
export type CreateTableUniqueConstraintMutationHookResult = ReturnType<
  typeof useCreateTableUniqueConstraintMutation
>
export type CreateTableUniqueConstraintMutationResult =
  Apollo.MutationResult<CreateTableUniqueConstraintMutation>
export type CreateTableUniqueConstraintMutationOptions = Apollo.BaseMutationOptions<
  CreateTableUniqueConstraintMutation,
  CreateTableUniqueConstraintMutationVariables
>
export const DeleteTableUniqueConstraintDocument = gql`
  mutation deleteTableUniqueConstraint($tableUniqueConstraintId: ID!) {
    deleteTableUniqueConstraint(tableUniqueConstraintId: $tableUniqueConstraintId) {
      id
      status
    }
  }
`
export type DeleteTableUniqueConstraintMutationFn = Apollo.MutationFunction<
  DeleteTableUniqueConstraintMutation,
  DeleteTableUniqueConstraintMutationVariables
>

/**
 * __useDeleteTableUniqueConstraintMutation__
 *
 * To run a mutation, you first call `useDeleteTableUniqueConstraintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableUniqueConstraintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableUniqueConstraintMutation, { data, loading, error }] = useDeleteTableUniqueConstraintMutation({
 *   variables: {
 *      tableUniqueConstraintId: // value for 'tableUniqueConstraintId'
 *   },
 * });
 */
export function useDeleteTableUniqueConstraintMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTableUniqueConstraintMutation,
    DeleteTableUniqueConstraintMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteTableUniqueConstraintMutation,
    DeleteTableUniqueConstraintMutationVariables
  >(DeleteTableUniqueConstraintDocument, options)
}
export type DeleteTableUniqueConstraintMutationHookResult = ReturnType<
  typeof useDeleteTableUniqueConstraintMutation
>
export type DeleteTableUniqueConstraintMutationResult =
  Apollo.MutationResult<DeleteTableUniqueConstraintMutation>
export type DeleteTableUniqueConstraintMutationOptions = Apollo.BaseMutationOptions<
  DeleteTableUniqueConstraintMutation,
  DeleteTableUniqueConstraintMutationVariables
>
export const RetryTableUniqueConstraintActivationDocument = gql`
  mutation retryTableUniqueConstraintActivation($tableUniqueConstraintId: ID!) {
    retryTableUniqueConstraintActivation(tableUniqueConstraintId: $tableUniqueConstraintId) {
      id
      status
      failedAttempts
    }
  }
`
export type RetryTableUniqueConstraintActivationMutationFn = Apollo.MutationFunction<
  RetryTableUniqueConstraintActivationMutation,
  RetryTableUniqueConstraintActivationMutationVariables
>

/**
 * __useRetryTableUniqueConstraintActivationMutation__
 *
 * To run a mutation, you first call `useRetryTableUniqueConstraintActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryTableUniqueConstraintActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryTableUniqueConstraintActivationMutation, { data, loading, error }] = useRetryTableUniqueConstraintActivationMutation({
 *   variables: {
 *      tableUniqueConstraintId: // value for 'tableUniqueConstraintId'
 *   },
 * });
 */
export function useRetryTableUniqueConstraintActivationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetryTableUniqueConstraintActivationMutation,
    RetryTableUniqueConstraintActivationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RetryTableUniqueConstraintActivationMutation,
    RetryTableUniqueConstraintActivationMutationVariables
  >(RetryTableUniqueConstraintActivationDocument, options)
}
export type RetryTableUniqueConstraintActivationMutationHookResult = ReturnType<
  typeof useRetryTableUniqueConstraintActivationMutation
>
export type RetryTableUniqueConstraintActivationMutationResult =
  Apollo.MutationResult<RetryTableUniqueConstraintActivationMutation>
export type RetryTableUniqueConstraintActivationMutationOptions = Apollo.BaseMutationOptions<
  RetryTableUniqueConstraintActivationMutation,
  RetryTableUniqueConstraintActivationMutationVariables
>
export const GetUniqueConstraintConflictRowsDocument = gql`
  query getUniqueConstraintConflictRows($rowIds: [ID!]!) {
    tableRows(rowIds: $rowIds) {
      id
      name
    }
  }
`

/**
 * __useGetUniqueConstraintConflictRowsQuery__
 *
 * To run a query within a React component, call `useGetUniqueConstraintConflictRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueConstraintConflictRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueConstraintConflictRowsQuery({
 *   variables: {
 *      rowIds: // value for 'rowIds'
 *   },
 * });
 */
export function useGetUniqueConstraintConflictRowsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUniqueConstraintConflictRowsQuery,
    GetUniqueConstraintConflictRowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetUniqueConstraintConflictRowsQuery,
    GetUniqueConstraintConflictRowsQueryVariables
  >(GetUniqueConstraintConflictRowsDocument, options)
}
export function useGetUniqueConstraintConflictRowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUniqueConstraintConflictRowsQuery,
    GetUniqueConstraintConflictRowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetUniqueConstraintConflictRowsQuery,
    GetUniqueConstraintConflictRowsQueryVariables
  >(GetUniqueConstraintConflictRowsDocument, options)
}
export type GetUniqueConstraintConflictRowsQueryHookResult = ReturnType<
  typeof useGetUniqueConstraintConflictRowsQuery
>
export type GetUniqueConstraintConflictRowsLazyQueryHookResult = ReturnType<
  typeof useGetUniqueConstraintConflictRowsLazyQuery
>
export type GetUniqueConstraintConflictRowsQueryResult = Apollo.QueryResult<
  GetUniqueConstraintConflictRowsQuery,
  GetUniqueConstraintConflictRowsQueryVariables
>
export const GetSimpleActionManualTriggersDocument = gql`
  query getSimpleActionManualTriggers {
    actionManualTriggers {
      id
      name
      action {
        id
        name
        workflow {
          id
        }
      }
    }
  }
`

/**
 * __useGetSimpleActionManualTriggersQuery__
 *
 * To run a query within a React component, call `useGetSimpleActionManualTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleActionManualTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleActionManualTriggersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSimpleActionManualTriggersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSimpleActionManualTriggersQuery,
    GetSimpleActionManualTriggersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetSimpleActionManualTriggersQuery,
    GetSimpleActionManualTriggersQueryVariables
  >(GetSimpleActionManualTriggersDocument, options)
}
export function useGetSimpleActionManualTriggersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSimpleActionManualTriggersQuery,
    GetSimpleActionManualTriggersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetSimpleActionManualTriggersQuery,
    GetSimpleActionManualTriggersQueryVariables
  >(GetSimpleActionManualTriggersDocument, options)
}
export type GetSimpleActionManualTriggersQueryHookResult = ReturnType<
  typeof useGetSimpleActionManualTriggersQuery
>
export type GetSimpleActionManualTriggersLazyQueryHookResult = ReturnType<
  typeof useGetSimpleActionManualTriggersLazyQuery
>
export type GetSimpleActionManualTriggersQueryResult = Apollo.QueryResult<
  GetSimpleActionManualTriggersQuery,
  GetSimpleActionManualTriggersQueryVariables
>
export const GetTableColumnsValidationMetadataDocument = gql`
  query getTableColumnsValidationMetadata($tableId: ID!) {
    table(tableId: $tableId) {
      id
      columns {
        id
        hasNonNullCells
        hasNullCells
        uniqueConstraintMemberships {
          constraint {
            id
            name
            status
          }
        }
        chartsForYAxis {
          id
          name
        }
      }
      childTables {
        id
        columns {
          id
          hasNonNullCells
          hasNullCells
          uniqueConstraintMemberships {
            constraint {
              id
              name
              status
            }
          }
          chartsForYAxis {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useGetTableColumnsValidationMetadataQuery__
 *
 * To run a query within a React component, call `useGetTableColumnsValidationMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableColumnsValidationMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableColumnsValidationMetadataQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetTableColumnsValidationMetadataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTableColumnsValidationMetadataQuery,
    GetTableColumnsValidationMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetTableColumnsValidationMetadataQuery,
    GetTableColumnsValidationMetadataQueryVariables
  >(GetTableColumnsValidationMetadataDocument, options)
}
export function useGetTableColumnsValidationMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTableColumnsValidationMetadataQuery,
    GetTableColumnsValidationMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetTableColumnsValidationMetadataQuery,
    GetTableColumnsValidationMetadataQueryVariables
  >(GetTableColumnsValidationMetadataDocument, options)
}
export type GetTableColumnsValidationMetadataQueryHookResult = ReturnType<
  typeof useGetTableColumnsValidationMetadataQuery
>
export type GetTableColumnsValidationMetadataLazyQueryHookResult = ReturnType<
  typeof useGetTableColumnsValidationMetadataLazyQuery
>
export type GetTableColumnsValidationMetadataQueryResult = Apollo.QueryResult<
  GetTableColumnsValidationMetadataQuery,
  GetTableColumnsValidationMetadataQueryVariables
>
export const GetTableRelatedActionStepsDocument = gql`
  query getTableRelatedActionSteps($input: RelatedEntitiesInput!) {
    relatedActionSteps(input: $input) {
      readSteps {
        id
        name
        type
        status
        rootAction {
          id
          name
          status
          workflow {
            id
            name
          }
        }
      }
      writeSteps {
        id
        name
        type
        status
        rootAction {
          id
          name
          status
          workflow {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * __useGetTableRelatedActionStepsQuery__
 *
 * To run a query within a React component, call `useGetTableRelatedActionStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableRelatedActionStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableRelatedActionStepsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTableRelatedActionStepsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTableRelatedActionStepsQuery,
    GetTableRelatedActionStepsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTableRelatedActionStepsQuery, GetTableRelatedActionStepsQueryVariables>(
    GetTableRelatedActionStepsDocument,
    options,
  )
}
export function useGetTableRelatedActionStepsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTableRelatedActionStepsQuery,
    GetTableRelatedActionStepsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetTableRelatedActionStepsQuery,
    GetTableRelatedActionStepsQueryVariables
  >(GetTableRelatedActionStepsDocument, options)
}
export type GetTableRelatedActionStepsQueryHookResult = ReturnType<
  typeof useGetTableRelatedActionStepsQuery
>
export type GetTableRelatedActionStepsLazyQueryHookResult = ReturnType<
  typeof useGetTableRelatedActionStepsLazyQuery
>
export type GetTableRelatedActionStepsQueryResult = Apollo.QueryResult<
  GetTableRelatedActionStepsQuery,
  GetTableRelatedActionStepsQueryVariables
>
export const GetWorkflowsV2DependentsDocument = gql`
  query getWorkflowsV2Dependents($input: WorkflowsV2DependentsInput!) {
    workflowsV2Dependents(input: $input) {
      id
      slug
      verificationStatus
    }
  }
`

/**
 * __useGetWorkflowsV2DependentsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsV2DependentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsV2DependentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsV2DependentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkflowsV2DependentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkflowsV2DependentsQuery,
    GetWorkflowsV2DependentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetWorkflowsV2DependentsQuery, GetWorkflowsV2DependentsQueryVariables>(
    GetWorkflowsV2DependentsDocument,
    options,
  )
}
export function useGetWorkflowsV2DependentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkflowsV2DependentsQuery,
    GetWorkflowsV2DependentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetWorkflowsV2DependentsQuery, GetWorkflowsV2DependentsQueryVariables>(
    GetWorkflowsV2DependentsDocument,
    options,
  )
}
export type GetWorkflowsV2DependentsQueryHookResult = ReturnType<
  typeof useGetWorkflowsV2DependentsQuery
>
export type GetWorkflowsV2DependentsLazyQueryHookResult = ReturnType<
  typeof useGetWorkflowsV2DependentsLazyQuery
>
export type GetWorkflowsV2DependentsQueryResult = Apollo.QueryResult<
  GetWorkflowsV2DependentsQuery,
  GetWorkflowsV2DependentsQueryVariables
>
export const GetRelatedActionStepsForEntitiesDocument = gql`
  query getRelatedActionStepsForEntities($input: RelatedActionStepsForEntitiesInput!) {
    relatedActionStepsForEntities(input: $input) {
      items {
        sourceId
        relatedActionSteps {
          readSteps {
            id
            name
            type
            status
            rootAction {
              id
              name
              status
              workflow {
                id
                name
              }
            }
          }
          writeSteps {
            id
            name
            type
            status
            rootAction {
              id
              name
              status
              workflow {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetRelatedActionStepsForEntitiesQuery__
 *
 * To run a query within a React component, call `useGetRelatedActionStepsForEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedActionStepsForEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedActionStepsForEntitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRelatedActionStepsForEntitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRelatedActionStepsForEntitiesQuery,
    GetRelatedActionStepsForEntitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetRelatedActionStepsForEntitiesQuery,
    GetRelatedActionStepsForEntitiesQueryVariables
  >(GetRelatedActionStepsForEntitiesDocument, options)
}
export function useGetRelatedActionStepsForEntitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRelatedActionStepsForEntitiesQuery,
    GetRelatedActionStepsForEntitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetRelatedActionStepsForEntitiesQuery,
    GetRelatedActionStepsForEntitiesQueryVariables
  >(GetRelatedActionStepsForEntitiesDocument, options)
}
export type GetRelatedActionStepsForEntitiesQueryHookResult = ReturnType<
  typeof useGetRelatedActionStepsForEntitiesQuery
>
export type GetRelatedActionStepsForEntitiesLazyQueryHookResult = ReturnType<
  typeof useGetRelatedActionStepsForEntitiesLazyQuery
>
export type GetRelatedActionStepsForEntitiesQueryResult = Apollo.QueryResult<
  GetRelatedActionStepsForEntitiesQuery,
  GetRelatedActionStepsForEntitiesQueryVariables
>
export const GetDetailedTableDocument = gql`
  query getDetailedTable($tableId: ID!) {
    table(tableId: $tableId) {
      id
      name
      parentTable {
        id
        name
        icon {
          id
          name
        }
        columns {
          id
          name
          type
          innerType
          lookupColumn {
            id
            name
            type
          }
          formatPreset
          formatOptions
        }
      }
      icon {
        id
        name
      }
      columns {
        ...DetailedTableColumn
        lookupColumnGroup {
          id
          columns {
            id
            name
            type
            innerType
            lookupColumn {
              id
              name
            }
          }
          lookupTable {
            id
            name
            icon {
              id
              name
            }
          }
        }
      }
      tableTabs {
        id
        name
        order
        booleanOperator
        filters {
          id
          operator
          operand
          systemGeneratedColumnType
          tableColumn {
            id
            table {
              id
            }
          }
        }
        sorts {
          id
          direction
          systemGeneratedColumnType
          tableColumn {
            id
          }
        }
        columns {
          id
          order
          isFrozen
          systemGeneratedColumnType
          tableColumn {
            id
            order
          }
        }
      }
      charts {
        id
        name
        chartType
      }
      hasRows
      childTables {
        id
        name
        orderOnRecordDetails
        icon {
          id
          name
        }
        columns {
          ...DetailedTableColumn
          lookupColumnGroup {
            id
            columns {
              id
              name
              type
              innerType
              lookupColumn {
                id
                name
              }
            }
            lookupTable {
              id
              name
              icon {
                id
                name
              }
            }
          }
        }
      }
      lookupBacklinkTables {
        id
      }
      organization {
        id
      }
    }
  }
  ${DetailedTableColumnFragmentDoc}
`

/**
 * __useGetDetailedTableQuery__
 *
 * To run a query within a React component, call `useGetDetailedTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedTableQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetDetailedTableQuery(
  baseOptions: Apollo.QueryHookOptions<GetDetailedTableQuery, GetDetailedTableQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDetailedTableQuery, GetDetailedTableQueryVariables>(
    GetDetailedTableDocument,
    options,
  )
}
export function useGetDetailedTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDetailedTableQuery, GetDetailedTableQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDetailedTableQuery, GetDetailedTableQueryVariables>(
    GetDetailedTableDocument,
    options,
  )
}
export type GetDetailedTableQueryHookResult = ReturnType<typeof useGetDetailedTableQuery>
export type GetDetailedTableLazyQueryHookResult = ReturnType<typeof useGetDetailedTableLazyQuery>
export type GetDetailedTableQueryResult = Apollo.QueryResult<
  GetDetailedTableQuery,
  GetDetailedTableQueryVariables
>
export const GetTableChildAndBacklinkTablesDocument = gql`
  query getTableChildAndBacklinkTables($tableId: ID!) {
    table(tableId: $tableId) {
      id
      childTables {
        id
        name
        orderOnRecordDetails
        parentTable {
          id
          name
          icon {
            id
            name
          }
        }
        icon {
          id
          name
        }
        columns {
          ...DetailedTableColumn
          lookupColumnGroup {
            id
            columns {
              id
              name
              type
              innerType
              lookupColumn {
                id
                name
              }
            }
            lookupTable {
              id
              name
              icon {
                id
                name
              }
            }
          }
        }
        tableTabs {
          id
          name
          order
          booleanOperator
          filters {
            id
            operator
            operand
            systemGeneratedColumnType
            tableColumn {
              id
            }
          }
          sorts {
            id
            direction
            systemGeneratedColumnType
            tableColumn {
              id
            }
          }
          columns {
            id
            order
            isFrozen
            systemGeneratedColumnType
            tableColumn {
              id
              order
            }
          }
        }
        hasRows
      }
      lookupBacklinkTables {
        id
        name
        orderOnRecordDetails
        parentTable {
          id
          name
          icon {
            id
            name
          }
        }
        icon {
          id
          name
        }
        columns {
          ...DetailedTableColumn
          lookupColumnGroup {
            id
            columns {
              id
              name
              type
              innerType
              lookupColumn {
                id
                name
              }
            }
            lookupTable {
              id
              name
              icon {
                id
                name
              }
            }
          }
        }
        tableTabs {
          id
          name
          order
          booleanOperator
          filters {
            id
            operator
            operand
            systemGeneratedColumnType
            tableColumn {
              id
            }
          }
          sorts {
            id
            direction
            systemGeneratedColumnType
            tableColumn {
              id
            }
          }
          columns {
            id
            order
            isFrozen
            systemGeneratedColumnType
            tableColumn {
              id
              order
            }
          }
        }
        hasRows
      }
    }
  }
  ${DetailedTableColumnFragmentDoc}
`

/**
 * __useGetTableChildAndBacklinkTablesQuery__
 *
 * To run a query within a React component, call `useGetTableChildAndBacklinkTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableChildAndBacklinkTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableChildAndBacklinkTablesQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetTableChildAndBacklinkTablesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTableChildAndBacklinkTablesQuery,
    GetTableChildAndBacklinkTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetTableChildAndBacklinkTablesQuery,
    GetTableChildAndBacklinkTablesQueryVariables
  >(GetTableChildAndBacklinkTablesDocument, options)
}
export function useGetTableChildAndBacklinkTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTableChildAndBacklinkTablesQuery,
    GetTableChildAndBacklinkTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetTableChildAndBacklinkTablesQuery,
    GetTableChildAndBacklinkTablesQueryVariables
  >(GetTableChildAndBacklinkTablesDocument, options)
}
export type GetTableChildAndBacklinkTablesQueryHookResult = ReturnType<
  typeof useGetTableChildAndBacklinkTablesQuery
>
export type GetTableChildAndBacklinkTablesLazyQueryHookResult = ReturnType<
  typeof useGetTableChildAndBacklinkTablesLazyQuery
>
export type GetTableChildAndBacklinkTablesQueryResult = Apollo.QueryResult<
  GetTableChildAndBacklinkTablesQuery,
  GetTableChildAndBacklinkTablesQueryVariables
>
export const GetTableRowsDocument = gql`
  query getTableRows($input: PaginatedTableRowsInput!) {
    paginatedTableRows(input: $input) {
      offset
      hasNext
      rows {
        id
        name
        createdAt
        createdBy {
          id
          firstName
          lastName
          email
        }
        updatedAt
        updatedBy {
          id
          firstName
          lastName
          email
        }
        cells {
          id
          data
          userVisibleValue
          formulaError
          updatedAt
          column {
            id
            formatOptions
            formatPreset
          }
          documents {
            id
            name
          }
          users {
            id
            firstName
            lastName
            email
          }
          lookupCells {
            id
            formulaError
            row {
              id
            }
            documents {
              id
            }
          }
        }
        rootWorkspace {
          id
        }
        hasChildRows
        currentButtonNodes {
          id
          name
          workspaceButtons {
            id
            name
            order
            buttonConfiguration
            requiresConfirmation
            confirmationMessage
            icon {
              id
              name
            }
            manualTrigger {
              id
              name
              action {
                id
                status
                description
                workflow {
                  id
                  status
                }
              }
            }
            form {
              id
              name
            }
            formV2 {
              id
              name
            }
          }
        }
        processingWorkspaceButton {
          id
          name
        }
      }
      totalCount
    }
  }
`

/**
 * __useGetTableRowsQuery__
 *
 * To run a query within a React component, call `useGetTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableRowsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTableRowsQuery(
  baseOptions: Apollo.QueryHookOptions<GetTableRowsQuery, GetTableRowsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTableRowsQuery, GetTableRowsQueryVariables>(
    GetTableRowsDocument,
    options,
  )
}
export function useGetTableRowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTableRowsQuery, GetTableRowsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTableRowsQuery, GetTableRowsQueryVariables>(
    GetTableRowsDocument,
    options,
  )
}
export type GetTableRowsQueryHookResult = ReturnType<typeof useGetTableRowsQuery>
export type GetTableRowsLazyQueryHookResult = ReturnType<typeof useGetTableRowsLazyQuery>
export type GetTableRowsQueryResult = Apollo.QueryResult<
  GetTableRowsQuery,
  GetTableRowsQueryVariables
>
export const GetBacklinkTableRowsDocument = gql`
  query getBacklinkTableRows($input: PaginatedBacklinkRowsInput!) {
    paginatedBacklinkRows(input: $input) {
      offset
      hasNext
      rows {
        id
        name
        createdAt
        createdBy {
          id
          firstName
          lastName
          email
        }
        updatedAt
        updatedBy {
          id
          firstName
          lastName
          email
        }
        cells {
          id
          data
          userVisibleValue
          formulaError
          updatedAt
          column {
            id
            formatOptions
            formatPreset
            type
            lookupColumn {
              id
              type
            }
          }
          documents {
            id
            name
          }
          users {
            id
            firstName
            lastName
            email
          }
          lookupCells {
            id
            formulaError
            row {
              id
            }
            documents {
              id
            }
          }
        }
        rootWorkspace {
          id
        }
        hasChildRows
        table {
          columns {
            lookupColumnChildren {
              id
              table {
                id
                name
              }
              lookupColumnGroup {
                id
                showBacklink
              }
            }
          }
        }
      }
      totalCount
    }
  }
`

/**
 * __useGetBacklinkTableRowsQuery__
 *
 * To run a query within a React component, call `useGetBacklinkTableRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBacklinkTableRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBacklinkTableRowsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBacklinkTableRowsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBacklinkTableRowsQuery,
    GetBacklinkTableRowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetBacklinkTableRowsQuery, GetBacklinkTableRowsQueryVariables>(
    GetBacklinkTableRowsDocument,
    options,
  )
}
export function useGetBacklinkTableRowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBacklinkTableRowsQuery,
    GetBacklinkTableRowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetBacklinkTableRowsQuery, GetBacklinkTableRowsQueryVariables>(
    GetBacklinkTableRowsDocument,
    options,
  )
}
export type GetBacklinkTableRowsQueryHookResult = ReturnType<typeof useGetBacklinkTableRowsQuery>
export type GetBacklinkTableRowsLazyQueryHookResult = ReturnType<
  typeof useGetBacklinkTableRowsLazyQuery
>
export type GetBacklinkTableRowsQueryResult = Apollo.QueryResult<
  GetBacklinkTableRowsQuery,
  GetBacklinkTableRowsQueryVariables
>
export const DeleteTableRowWithResultDocument = gql`
  mutation deleteTableRowWithResult($tableRowId: ID!) {
    deleteTableRowWithResult(tableRowId: $tableRowId) {
      row {
        id
      }
      errors {
        rowId
        rowName
        message
        blockingRows {
          id
          name
        }
        blockingReferences {
          row {
            id
            name
          }
          columnId
          columnName
          tableId
          tableName
        }
      }
      blockingRows {
        id
        name
      }
      blockingReferences {
        row {
          id
          name
        }
        columnId
        columnName
        tableId
        tableName
      }
    }
  }
`
export type DeleteTableRowWithResultMutationFn = Apollo.MutationFunction<
  DeleteTableRowWithResultMutation,
  DeleteTableRowWithResultMutationVariables
>

/**
 * __useDeleteTableRowWithResultMutation__
 *
 * To run a mutation, you first call `useDeleteTableRowWithResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableRowWithResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableRowWithResultMutation, { data, loading, error }] = useDeleteTableRowWithResultMutation({
 *   variables: {
 *      tableRowId: // value for 'tableRowId'
 *   },
 * });
 */
export function useDeleteTableRowWithResultMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTableRowWithResultMutation,
    DeleteTableRowWithResultMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteTableRowWithResultMutation,
    DeleteTableRowWithResultMutationVariables
  >(DeleteTableRowWithResultDocument, options)
}
export type DeleteTableRowWithResultMutationHookResult = ReturnType<
  typeof useDeleteTableRowWithResultMutation
>
export type DeleteTableRowWithResultMutationResult =
  Apollo.MutationResult<DeleteTableRowWithResultMutation>
export type DeleteTableRowWithResultMutationOptions = Apollo.BaseMutationOptions<
  DeleteTableRowWithResultMutation,
  DeleteTableRowWithResultMutationVariables
>
export const CreateTableDocument = gql`
  mutation createTable($input: CreateTableInput!) {
    createTable(input: $input) {
      id
      name
      description
      icon {
        id
        name
      }
      views {
        id
        unitWidth
        unitHeight
        order
        viewableObjectType
      }
      columns {
        id
        name
        description
        type
      }
    }
  }
`
export type CreateTableMutationFn = Apollo.MutationFunction<
  CreateTableMutation,
  CreateTableMutationVariables
>

/**
 * __useCreateTableMutation__
 *
 * To run a mutation, you first call `useCreateTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableMutation, { data, loading, error }] = useCreateTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTableMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTableMutation, CreateTableMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTableMutation, CreateTableMutationVariables>(
    CreateTableDocument,
    options,
  )
}
export type CreateTableMutationHookResult = ReturnType<typeof useCreateTableMutation>
export type CreateTableMutationResult = Apollo.MutationResult<CreateTableMutation>
export type CreateTableMutationOptions = Apollo.BaseMutationOptions<
  CreateTableMutation,
  CreateTableMutationVariables
>
export const CreateChildTableDocument = gql`
  mutation createChildTable($input: CreateChildTableInput!) {
    createChildTable(input: $input) {
      id
      name
      description
      icon {
        id
        name
      }
      columns {
        id
        name
        description
        type
      }
    }
  }
`
export type CreateChildTableMutationFn = Apollo.MutationFunction<
  CreateChildTableMutation,
  CreateChildTableMutationVariables
>

/**
 * __useCreateChildTableMutation__
 *
 * To run a mutation, you first call `useCreateChildTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChildTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChildTableMutation, { data, loading, error }] = useCreateChildTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChildTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChildTableMutation,
    CreateChildTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateChildTableMutation, CreateChildTableMutationVariables>(
    CreateChildTableDocument,
    options,
  )
}
export type CreateChildTableMutationHookResult = ReturnType<typeof useCreateChildTableMutation>
export type CreateChildTableMutationResult = Apollo.MutationResult<CreateChildTableMutation>
export type CreateChildTableMutationOptions = Apollo.BaseMutationOptions<
  CreateChildTableMutation,
  CreateChildTableMutationVariables
>
export const UpdateTableDocument = gql`
  mutation updateTable($input: UpdateTableInput!) {
    updateTable(input: $input) {
      id
      name
      description
      showRowWorkspace
      icon {
        id
        name
      }
      columns {
        id
        name
        description
        type
      }
    }
  }
`
export type UpdateTableMutationFn = Apollo.MutationFunction<
  UpdateTableMutation,
  UpdateTableMutationVariables
>

/**
 * __useUpdateTableMutation__
 *
 * To run a mutation, you first call `useUpdateTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableMutation, { data, loading, error }] = useUpdateTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTableMutation, UpdateTableMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTableMutation, UpdateTableMutationVariables>(
    UpdateTableDocument,
    options,
  )
}
export type UpdateTableMutationHookResult = ReturnType<typeof useUpdateTableMutation>
export type UpdateTableMutationResult = Apollo.MutationResult<UpdateTableMutation>
export type UpdateTableMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableMutation,
  UpdateTableMutationVariables
>
export const CreateTableTabDocument = gql`
  mutation createTableTab($input: CreateTableTabInput!) {
    createTableTab(input: $input) {
      id
      name
      order
      booleanOperator
      filters {
        tableColumn {
          id
          table {
            id
          }
        }
        id
        operator
        operand
        systemGeneratedColumnType
      }
      sorts {
        tableColumn {
          id
        }
        id
        direction
        systemGeneratedColumnType
      }
      columns {
        id
        order
        isFrozen
        systemGeneratedColumnType
        tableColumn {
          ...DetailedTableColumn
        }
      }
    }
  }
  ${DetailedTableColumnFragmentDoc}
`
export type CreateTableTabMutationFn = Apollo.MutationFunction<
  CreateTableTabMutation,
  CreateTableTabMutationVariables
>

/**
 * __useCreateTableTabMutation__
 *
 * To run a mutation, you first call `useCreateTableTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableTabMutation, { data, loading, error }] = useCreateTableTabMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTableTabMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTableTabMutation, CreateTableTabMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTableTabMutation, CreateTableTabMutationVariables>(
    CreateTableTabDocument,
    options,
  )
}
export type CreateTableTabMutationHookResult = ReturnType<typeof useCreateTableTabMutation>
export type CreateTableTabMutationResult = Apollo.MutationResult<CreateTableTabMutation>
export type CreateTableTabMutationOptions = Apollo.BaseMutationOptions<
  CreateTableTabMutation,
  CreateTableTabMutationVariables
>
export const UpdateTableTabDocument = gql`
  mutation updateTableTab($input: UpdateTableTabInput!) {
    updateTableTab(input: $input) {
      id
      name
      order
      booleanOperator
    }
  }
`
export type UpdateTableTabMutationFn = Apollo.MutationFunction<
  UpdateTableTabMutation,
  UpdateTableTabMutationVariables
>

/**
 * __useUpdateTableTabMutation__
 *
 * To run a mutation, you first call `useUpdateTableTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableTabMutation, { data, loading, error }] = useUpdateTableTabMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableTabMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTableTabMutation, UpdateTableTabMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTableTabMutation, UpdateTableTabMutationVariables>(
    UpdateTableTabDocument,
    options,
  )
}
export type UpdateTableTabMutationHookResult = ReturnType<typeof useUpdateTableTabMutation>
export type UpdateTableTabMutationResult = Apollo.MutationResult<UpdateTableTabMutation>
export type UpdateTableTabMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableTabMutation,
  UpdateTableTabMutationVariables
>
export const DeleteTableTabDocument = gql`
  mutation deleteTableTab($tableTabId: ID!) {
    deleteTableTab(tableTabId: $tableTabId) {
      id
    }
  }
`
export type DeleteTableTabMutationFn = Apollo.MutationFunction<
  DeleteTableTabMutation,
  DeleteTableTabMutationVariables
>

/**
 * __useDeleteTableTabMutation__
 *
 * To run a mutation, you first call `useDeleteTableTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableTabMutation, { data, loading, error }] = useDeleteTableTabMutation({
 *   variables: {
 *      tableTabId: // value for 'tableTabId'
 *   },
 * });
 */
export function useDeleteTableTabMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTableTabMutation, DeleteTableTabMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTableTabMutation, DeleteTableTabMutationVariables>(
    DeleteTableTabDocument,
    options,
  )
}
export type DeleteTableTabMutationHookResult = ReturnType<typeof useDeleteTableTabMutation>
export type DeleteTableTabMutationResult = Apollo.MutationResult<DeleteTableTabMutation>
export type DeleteTableTabMutationOptions = Apollo.BaseMutationOptions<
  DeleteTableTabMutation,
  DeleteTableTabMutationVariables
>
export const ReorderTableTabDocument = gql`
  mutation reorderTableTab($input: ReorderTableTabInput!) {
    reorderTableTab(input: $input) {
      id
      name
      order
    }
  }
`
export type ReorderTableTabMutationFn = Apollo.MutationFunction<
  ReorderTableTabMutation,
  ReorderTableTabMutationVariables
>

/**
 * __useReorderTableTabMutation__
 *
 * To run a mutation, you first call `useReorderTableTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderTableTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderTableTabMutation, { data, loading, error }] = useReorderTableTabMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderTableTabMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderTableTabMutation,
    ReorderTableTabMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ReorderTableTabMutation, ReorderTableTabMutationVariables>(
    ReorderTableTabDocument,
    options,
  )
}
export type ReorderTableTabMutationHookResult = ReturnType<typeof useReorderTableTabMutation>
export type ReorderTableTabMutationResult = Apollo.MutationResult<ReorderTableTabMutation>
export type ReorderTableTabMutationOptions = Apollo.BaseMutationOptions<
  ReorderTableTabMutation,
  ReorderTableTabMutationVariables
>
export const UpdateTableTabColumnDocument = gql`
  mutation updateTableTabColumn($input: UpdateTableTabColumnInput!) {
    updateTableTabColumn(input: $input) {
      id
      order
      isFrozen
    }
  }
`
export type UpdateTableTabColumnMutationFn = Apollo.MutationFunction<
  UpdateTableTabColumnMutation,
  UpdateTableTabColumnMutationVariables
>

/**
 * __useUpdateTableTabColumnMutation__
 *
 * To run a mutation, you first call `useUpdateTableTabColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableTabColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableTabColumnMutation, { data, loading, error }] = useUpdateTableTabColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableTabColumnMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTableTabColumnMutation,
    UpdateTableTabColumnMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTableTabColumnMutation, UpdateTableTabColumnMutationVariables>(
    UpdateTableTabColumnDocument,
    options,
  )
}
export type UpdateTableTabColumnMutationHookResult = ReturnType<
  typeof useUpdateTableTabColumnMutation
>
export type UpdateTableTabColumnMutationResult = Apollo.MutationResult<UpdateTableTabColumnMutation>
export type UpdateTableTabColumnMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableTabColumnMutation,
  UpdateTableTabColumnMutationVariables
>
export const UpdateTableTabColumnsDocument = gql`
  mutation updateTableTabColumns($input: UpdateTableTabColumnsInput!) {
    updateTableTabColumns(input: $input) {
      id
      order
      isFrozen
      systemGeneratedColumnType
      tableColumn {
        ...DetailedTableColumn
      }
    }
  }
  ${DetailedTableColumnFragmentDoc}
`
export type UpdateTableTabColumnsMutationFn = Apollo.MutationFunction<
  UpdateTableTabColumnsMutation,
  UpdateTableTabColumnsMutationVariables
>

/**
 * __useUpdateTableTabColumnsMutation__
 *
 * To run a mutation, you first call `useUpdateTableTabColumnsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableTabColumnsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableTabColumnsMutation, { data, loading, error }] = useUpdateTableTabColumnsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableTabColumnsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTableTabColumnsMutation,
    UpdateTableTabColumnsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTableTabColumnsMutation, UpdateTableTabColumnsMutationVariables>(
    UpdateTableTabColumnsDocument,
    options,
  )
}
export type UpdateTableTabColumnsMutationHookResult = ReturnType<
  typeof useUpdateTableTabColumnsMutation
>
export type UpdateTableTabColumnsMutationResult =
  Apollo.MutationResult<UpdateTableTabColumnsMutation>
export type UpdateTableTabColumnsMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableTabColumnsMutation,
  UpdateTableTabColumnsMutationVariables
>
export const UpdateTableTabSortsDocument = gql`
  mutation updateTableTabSorts($input: UpdateTableTabSortsInput!) {
    updateTableTabSorts(input: $input) {
      tableColumn {
        id
      }
      id
      direction
      systemGeneratedColumnType
    }
  }
`
export type UpdateTableTabSortsMutationFn = Apollo.MutationFunction<
  UpdateTableTabSortsMutation,
  UpdateTableTabSortsMutationVariables
>

/**
 * __useUpdateTableTabSortsMutation__
 *
 * To run a mutation, you first call `useUpdateTableTabSortsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableTabSortsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableTabSortsMutation, { data, loading, error }] = useUpdateTableTabSortsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableTabSortsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTableTabSortsMutation,
    UpdateTableTabSortsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateTableTabSortsMutation, UpdateTableTabSortsMutationVariables>(
    UpdateTableTabSortsDocument,
    options,
  )
}
export type UpdateTableTabSortsMutationHookResult = ReturnType<
  typeof useUpdateTableTabSortsMutation
>
export type UpdateTableTabSortsMutationResult = Apollo.MutationResult<UpdateTableTabSortsMutation>
export type UpdateTableTabSortsMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableTabSortsMutation,
  UpdateTableTabSortsMutationVariables
>
export const UpdateTableColumnFiltersDocument = gql`
  mutation updateTableColumnFilters($input: UpdateTableColumnFiltersInput!) {
    updateTableColumnFilters(input: $input) {
      tableColumn {
        id
        table {
          id
        }
      }
      id
      operator
      operand
      systemGeneratedColumnType
    }
  }
`
export type UpdateTableColumnFiltersMutationFn = Apollo.MutationFunction<
  UpdateTableColumnFiltersMutation,
  UpdateTableColumnFiltersMutationVariables
>

/**
 * __useUpdateTableColumnFiltersMutation__
 *
 * To run a mutation, you first call `useUpdateTableColumnFiltersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableColumnFiltersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableColumnFiltersMutation, { data, loading, error }] = useUpdateTableColumnFiltersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableColumnFiltersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTableColumnFiltersMutation,
    UpdateTableColumnFiltersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateTableColumnFiltersMutation,
    UpdateTableColumnFiltersMutationVariables
  >(UpdateTableColumnFiltersDocument, options)
}
export type UpdateTableColumnFiltersMutationHookResult = ReturnType<
  typeof useUpdateTableColumnFiltersMutation
>
export type UpdateTableColumnFiltersMutationResult =
  Apollo.MutationResult<UpdateTableColumnFiltersMutation>
export type UpdateTableColumnFiltersMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableColumnFiltersMutation,
  UpdateTableColumnFiltersMutationVariables
>
export const GetTableCellDocument = gql`
  query getTableCell($tableCellId: ID!) {
    tableCell(tableCellId: $tableCellId) {
      id
      userVisibleValue
      formulaError
      column {
        id
        indexPrefix
        indexSuffix
        type
      }
    }
  }
`

/**
 * __useGetTableCellQuery__
 *
 * To run a query within a React component, call `useGetTableCellQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableCellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableCellQuery({
 *   variables: {
 *      tableCellId: // value for 'tableCellId'
 *   },
 * });
 */
export function useGetTableCellQuery(
  baseOptions: Apollo.QueryHookOptions<GetTableCellQuery, GetTableCellQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTableCellQuery, GetTableCellQueryVariables>(
    GetTableCellDocument,
    options,
  )
}
export function useGetTableCellLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTableCellQuery, GetTableCellQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTableCellQuery, GetTableCellQueryVariables>(
    GetTableCellDocument,
    options,
  )
}
export type GetTableCellQueryHookResult = ReturnType<typeof useGetTableCellQuery>
export type GetTableCellLazyQueryHookResult = ReturnType<typeof useGetTableCellLazyQuery>
export type GetTableCellQueryResult = Apollo.QueryResult<
  GetTableCellQuery,
  GetTableCellQueryVariables
>
export const UpdatedTableRowDocument = gql`
  subscription updatedTableRow($tableRowId: ID!) {
    updatedTableRowDetails(tableRowId: $tableRowId) {
      id
      name
      createdAt
      createdBy {
        id
        firstName
        lastName
        email
      }
      updatedAt
      updatedBy {
        id
        firstName
        lastName
        email
      }
      cells {
        id
        data
        userVisibleValue
        formulaError
        updatedAt
        column {
          id
          formatOptions
          formatPreset
          type
          order
          lookupColumn {
            id
            type
          }
        }
        documents {
          id
          name
        }
        users {
          id
          firstName
          lastName
          email
        }
        lookupCells {
          id
          formulaError
          row {
            id
          }
          documents {
            id
          }
        }
      }
      rootWorkspace {
        id
      }
      hasChildRows
      table {
        columns {
          lookupColumnChildren {
            id
            table {
              id
            }
            lookupColumnGroup {
              id
              showBacklink
            }
          }
        }
      }
      currentButtonNodes {
        id
        name
        workspaceButtons {
          id
          name
          order
          buttonConfiguration
          requiresConfirmation
          confirmationMessage
          icon {
            id
            name
          }
          manualTrigger {
            id
            name
            action {
              id
              status
              description
              workflow {
                id
                status
              }
            }
          }
          form {
            id
            name
          }
          formV2 {
            id
            name
          }
        }
      }
      processingWorkspaceButton {
        id
        name
      }
    }
  }
`

/**
 * __useUpdatedTableRowSubscription__
 *
 * To run a query within a React component, call `useUpdatedTableRowSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedTableRowSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedTableRowSubscription({
 *   variables: {
 *      tableRowId: // value for 'tableRowId'
 *   },
 * });
 */
export function useUpdatedTableRowSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UpdatedTableRowSubscription,
    UpdatedTableRowSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<UpdatedTableRowSubscription, UpdatedTableRowSubscriptionVariables>(
    UpdatedTableRowDocument,
    options,
  )
}
export type UpdatedTableRowSubscriptionHookResult = ReturnType<
  typeof useUpdatedTableRowSubscription
>
export type UpdatedTableRowSubscriptionResult =
  Apollo.SubscriptionResult<UpdatedTableRowSubscription>
export const PushTableRowDocument = gql`
  subscription pushTableRow($input: TableSubscriptionInput!) {
    pushTableRow(input: $input) {
      id
      createdAt
      createdBy {
        id
        firstName
        lastName
        email
      }
      updatedAt
      updatedBy {
        id
        firstName
        lastName
        email
      }
      cells {
        id
        userVisibleValue
        formulaError
        updatedAt
        data
        column {
          id
          formatOptions
          formatPreset
          indexPrefix
          indexSuffix
          type
        }
        row {
          id
          createdAt
          createdBy {
            id
            firstName
            lastName
            email
          }
          updatedAt
          updatedBy {
            id
            firstName
            lastName
            email
          }
          rootWorkspace {
            id
          }
          currentButtonNodes {
            id
            name
            workspaceButtons {
              id
              name
              order
              buttonConfiguration
              requiresConfirmation
              confirmationMessage
              icon {
                id
                name
              }
              manualTrigger {
                id
                name
                action {
                  id
                  status
                  description
                  workflow {
                    id
                    status
                  }
                }
              }
              form {
                id
                name
              }
              formV2 {
                id
                name
              }
            }
          }
          processingWorkspaceButton {
            id
            name
          }
        }
        lookupCells {
          id
          data
          userVisibleValue
          formulaError
          row {
            id
          }
          documents {
            id
          }
          users {
            id
            firstName
            lastName
            email
          }
        }
        documents {
          id
        }
        users {
          id
          firstName
          lastName
          email
        }
      }
      rootWorkspace {
        id
      }
      hasChildRows
    }
  }
`

/**
 * __usePushTableRowSubscription__
 *
 * To run a query within a React component, call `usePushTableRowSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushTableRowSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushTableRowSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushTableRowSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PushTableRowSubscription,
    PushTableRowSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<PushTableRowSubscription, PushTableRowSubscriptionVariables>(
    PushTableRowDocument,
    options,
  )
}
export type PushTableRowSubscriptionHookResult = ReturnType<typeof usePushTableRowSubscription>
export type PushTableRowSubscriptionResult = Apollo.SubscriptionResult<PushTableRowSubscription>
export const DeletedTableRowDocument = gql`
  subscription deletedTableRow($input: TableSubscriptionInput!) {
    deletedTableRow(input: $input)
  }
`

/**
 * __useDeletedTableRowSubscription__
 *
 * To run a query within a React component, call `useDeletedTableRowSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedTableRowSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedTableRowSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletedTableRowSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    DeletedTableRowSubscription,
    DeletedTableRowSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<DeletedTableRowSubscription, DeletedTableRowSubscriptionVariables>(
    DeletedTableRowDocument,
    options,
  )
}
export type DeletedTableRowSubscriptionHookResult = ReturnType<
  typeof useDeletedTableRowSubscription
>
export type DeletedTableRowSubscriptionResult =
  Apollo.SubscriptionResult<DeletedTableRowSubscription>
export const PushTableColumnDocument = gql`
  subscription pushTableColumn($tableId: ID!) {
    pushTableColumn(tableId: $tableId) {
      ...DetailedTableColumn
      tableTabs {
        id
        order
        isFrozen
        systemGeneratedColumnType
        tableTab {
          id
        }
      }
      lookupColumnGroup {
        id
        columns {
          id
          name
          type
          innerType
          lookupColumn {
            id
            name
          }
        }
        lookupTable {
          id
          name
          icon {
            id
            name
          }
        }
      }
    }
  }
  ${DetailedTableColumnFragmentDoc}
`

/**
 * __usePushTableColumnSubscription__
 *
 * To run a query within a React component, call `usePushTableColumnSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushTableColumnSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushTableColumnSubscription({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function usePushTableColumnSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PushTableColumnSubscription,
    PushTableColumnSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<PushTableColumnSubscription, PushTableColumnSubscriptionVariables>(
    PushTableColumnDocument,
    options,
  )
}
export type PushTableColumnSubscriptionHookResult = ReturnType<
  typeof usePushTableColumnSubscription
>
export type PushTableColumnSubscriptionResult =
  Apollo.SubscriptionResult<PushTableColumnSubscription>
export const DeletedTableColumnDocument = gql`
  subscription deletedTableColumn($tableId: ID!) {
    deletedTableColumn(tableId: $tableId)
  }
`

/**
 * __useDeletedTableColumnSubscription__
 *
 * To run a query within a React component, call `useDeletedTableColumnSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedTableColumnSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedTableColumnSubscription({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useDeletedTableColumnSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    DeletedTableColumnSubscription,
    DeletedTableColumnSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    DeletedTableColumnSubscription,
    DeletedTableColumnSubscriptionVariables
  >(DeletedTableColumnDocument, options)
}
export type DeletedTableColumnSubscriptionHookResult = ReturnType<
  typeof useDeletedTableColumnSubscription
>
export type DeletedTableColumnSubscriptionResult =
  Apollo.SubscriptionResult<DeletedTableColumnSubscription>
export const GetSimpleWorkspaceDocument = gql`
  query getSimpleWorkspace($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      name
      parentOrganization {
        id
      }
      table {
        id
        name
      }
      chart {
        id
        name
        chartType
      }
      tableRow {
        id
        table {
          id
          name
        }
      }
      document {
        id
        name
      }
    }
  }
`

/**
 * __useGetSimpleWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetSimpleWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleWorkspaceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetSimpleWorkspaceQuery(
  baseOptions: Apollo.QueryHookOptions<GetSimpleWorkspaceQuery, GetSimpleWorkspaceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSimpleWorkspaceQuery, GetSimpleWorkspaceQueryVariables>(
    GetSimpleWorkspaceDocument,
    options,
  )
}
export function useGetSimpleWorkspaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSimpleWorkspaceQuery,
    GetSimpleWorkspaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSimpleWorkspaceQuery, GetSimpleWorkspaceQueryVariables>(
    GetSimpleWorkspaceDocument,
    options,
  )
}
export type GetSimpleWorkspaceQueryHookResult = ReturnType<typeof useGetSimpleWorkspaceQuery>
export type GetSimpleWorkspaceLazyQueryHookResult = ReturnType<
  typeof useGetSimpleWorkspaceLazyQuery
>
export type GetSimpleWorkspaceQueryResult = Apollo.QueryResult<
  GetSimpleWorkspaceQuery,
  GetSimpleWorkspaceQueryVariables
>
export const UpdatedTableRowChildRowsDocument = gql`
  subscription updatedTableRowChildRows($tableRowId: ID!) {
    updatedTableRowDetails(tableRowId: $tableRowId) {
      id
      hasChildRows
    }
  }
`

/**
 * __useUpdatedTableRowChildRowsSubscription__
 *
 * To run a query within a React component, call `useUpdatedTableRowChildRowsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedTableRowChildRowsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedTableRowChildRowsSubscription({
 *   variables: {
 *      tableRowId: // value for 'tableRowId'
 *   },
 * });
 */
export function useUpdatedTableRowChildRowsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UpdatedTableRowChildRowsSubscription,
    UpdatedTableRowChildRowsSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    UpdatedTableRowChildRowsSubscription,
    UpdatedTableRowChildRowsSubscriptionVariables
  >(UpdatedTableRowChildRowsDocument, options)
}
export type UpdatedTableRowChildRowsSubscriptionHookResult = ReturnType<
  typeof useUpdatedTableRowChildRowsSubscription
>
export type UpdatedTableRowChildRowsSubscriptionResult =
  Apollo.SubscriptionResult<UpdatedTableRowChildRowsSubscription>
export const GetSettingsPageTableDetailsDocument = gql`
  query getSettingsPageTableDetails($tableId: ID!) {
    table(tableId: $tableId) {
      id
      name
      description
      showRowWorkspace
      hasRowWorkspaceObjects
      rootWorkspace {
        id
        parentObject {
          name
        }
      }
      views {
        id
        parentWorkspace {
          id
          parentObject {
            name
            objectId
          }
        }
      }
      parentTable {
        id
      }
      columns {
        id
        name
        description
        order
        type
        innerType
        isNullable
        isReadOnly
        isDecimal
        ...ColumnFormatting
        ...ResolvedSourceColumn
        indexType
        indexPrefix
        indexSuffix
        indexAutogenerate
        enumOptions
        ...EnumSetFields
        displayImagesInline
        isVisibleOnRecordDetails
        formula {
          id
          formulaString
        }
        lookupColumnGroup {
          id
          showBacklink
          backlinkName
          columns {
            id
            name
            type
            innerType
            lookupColumn {
              id
              name
            }
          }
          lookupTable {
            id
            name
            icon {
              id
              name
            }
          }
        }
        lookupColumn {
          ...LookupProviderColumn
        }
        lookupFilterExpression {
          id
          logicExpressionString
        }
      }
      childTables {
        id
        name
        description
        orderOnRecordDetails
        columns {
          id
          name
          description
          order
          type
          innerType
          isNullable
          isReadOnly
          isDecimal
          ...ColumnFormatting
          ...ResolvedSourceColumn
          indexType
          indexPrefix
          indexSuffix
          indexAutogenerate
          enumOptions
          ...EnumSetFields
          displayImagesInline
          isVisibleOnRecordDetails
          lookupColumn {
            ...LookupProviderColumn
          }
          formula {
            id
            formulaString
          }
          lookupFilterExpression {
            id
            logicExpressionString
          }
          lookupColumnGroup {
            id
            showBacklink
            backlinkName
            columns {
              id
              name
              type
              innerType
              lookupColumn {
                id
                name
              }
            }
            lookupTable {
              id
              name
              icon {
                id
                name
              }
            }
          }
        }
        hasRows
        icon {
          id
          name
        }
      }
      columnGroups {
        id
        name
        order
        columns {
          id
          order
          tableColumn {
            id
          }
        }
      }
      hasRows
      icon {
        id
        name
      }
      organization {
        id
      }
    }
  }
  ${ColumnFormattingFragmentDoc}
  ${ResolvedSourceColumnFragmentDoc}
  ${EnumSetFieldsFragmentDoc}
  ${LookupProviderColumnFragmentDoc}
`

/**
 * __useGetSettingsPageTableDetailsQuery__
 *
 * To run a query within a React component, call `useGetSettingsPageTableDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsPageTableDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsPageTableDetailsQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetSettingsPageTableDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSettingsPageTableDetailsQuery,
    GetSettingsPageTableDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetSettingsPageTableDetailsQuery,
    GetSettingsPageTableDetailsQueryVariables
  >(GetSettingsPageTableDetailsDocument, options)
}
export function useGetSettingsPageTableDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSettingsPageTableDetailsQuery,
    GetSettingsPageTableDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetSettingsPageTableDetailsQuery,
    GetSettingsPageTableDetailsQueryVariables
  >(GetSettingsPageTableDetailsDocument, options)
}
export type GetSettingsPageTableDetailsQueryHookResult = ReturnType<
  typeof useGetSettingsPageTableDetailsQuery
>
export type GetSettingsPageTableDetailsLazyQueryHookResult = ReturnType<
  typeof useGetSettingsPageTableDetailsLazyQuery
>
export type GetSettingsPageTableDetailsQueryResult = Apollo.QueryResult<
  GetSettingsPageTableDetailsQuery,
  GetSettingsPageTableDetailsQueryVariables
>
export const UploadTableDataCsvDocument = gql`
  mutation uploadTableDataCsv($input: UploadTableDataCsvInput!) {
    uploadTableDataCsv(input: $input) {
      id
    }
  }
`
export type UploadTableDataCsvMutationFn = Apollo.MutationFunction<
  UploadTableDataCsvMutation,
  UploadTableDataCsvMutationVariables
>

/**
 * __useUploadTableDataCsvMutation__
 *
 * To run a mutation, you first call `useUploadTableDataCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadTableDataCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadTableDataCsvMutation, { data, loading, error }] = useUploadTableDataCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadTableDataCsvMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadTableDataCsvMutation,
    UploadTableDataCsvMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UploadTableDataCsvMutation, UploadTableDataCsvMutationVariables>(
    UploadTableDataCsvDocument,
    options,
  )
}
export type UploadTableDataCsvMutationHookResult = ReturnType<typeof useUploadTableDataCsvMutation>
export type UploadTableDataCsvMutationResult = Apollo.MutationResult<UploadTableDataCsvMutation>
export type UploadTableDataCsvMutationOptions = Apollo.BaseMutationOptions<
  UploadTableDataCsvMutation,
  UploadTableDataCsvMutationVariables
>
export const CsvInsertedTableRowDocument = gql`
  subscription csvInsertedTableRow($input: TableCsvInsertedSubscriptionInput!) {
    csvInsertedTableRow(input: $input) {
      objectId
      completedCount
    }
  }
`

/**
 * __useCsvInsertedTableRowSubscription__
 *
 * To run a query within a React component, call `useCsvInsertedTableRowSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCsvInsertedTableRowSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCsvInsertedTableRowSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCsvInsertedTableRowSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    CsvInsertedTableRowSubscription,
    CsvInsertedTableRowSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    CsvInsertedTableRowSubscription,
    CsvInsertedTableRowSubscriptionVariables
  >(CsvInsertedTableRowDocument, options)
}
export type CsvInsertedTableRowSubscriptionHookResult = ReturnType<
  typeof useCsvInsertedTableRowSubscription
>
export type CsvInsertedTableRowSubscriptionResult =
  Apollo.SubscriptionResult<CsvInsertedTableRowSubscription>
export const GetIconsDocument = gql`
  query getIcons {
    icons {
      id
      name
    }
  }
`

/**
 * __useGetIconsQuery__
 *
 * To run a query within a React component, call `useGetIconsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIconsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIconsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIconsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetIconsQuery, GetIconsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetIconsQuery, GetIconsQueryVariables>(GetIconsDocument, options)
}
export function useGetIconsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIconsQuery, GetIconsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetIconsQuery, GetIconsQueryVariables>(GetIconsDocument, options)
}
export type GetIconsQueryHookResult = ReturnType<typeof useGetIconsQuery>
export type GetIconsLazyQueryHookResult = ReturnType<typeof useGetIconsLazyQuery>
export type GetIconsQueryResult = Apollo.QueryResult<GetIconsQuery, GetIconsQueryVariables>
export const SearchIconsDocument = gql`
  query searchIcons($input: String!) {
    searchIcons(input: $input) {
      id
      name
    }
  }
`

/**
 * __useSearchIconsQuery__
 *
 * To run a query within a React component, call `useSearchIconsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIconsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIconsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchIconsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchIconsQuery, SearchIconsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchIconsQuery, SearchIconsQueryVariables>(SearchIconsDocument, options)
}
export function useSearchIconsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchIconsQuery, SearchIconsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchIconsQuery, SearchIconsQueryVariables>(
    SearchIconsDocument,
    options,
  )
}
export type SearchIconsQueryHookResult = ReturnType<typeof useSearchIconsQuery>
export type SearchIconsLazyQueryHookResult = ReturnType<typeof useSearchIconsLazyQuery>
export type SearchIconsQueryResult = Apollo.QueryResult<SearchIconsQuery, SearchIconsQueryVariables>
export const CreateTableColumnGroupDocument = gql`
  mutation createTableColumnGroup($input: CreateTableColumnGroupInput!) {
    createTableColumnGroup(input: $input) {
      id
      name
      order
      columns {
        id
        order
        tableColumn {
          id
        }
      }
    }
  }
`
export type CreateTableColumnGroupMutationFn = Apollo.MutationFunction<
  CreateTableColumnGroupMutation,
  CreateTableColumnGroupMutationVariables
>

/**
 * __useCreateTableColumnGroupMutation__
 *
 * To run a mutation, you first call `useCreateTableColumnGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTableColumnGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTableColumnGroupMutation, { data, loading, error }] = useCreateTableColumnGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTableColumnGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTableColumnGroupMutation,
    CreateTableColumnGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateTableColumnGroupMutation,
    CreateTableColumnGroupMutationVariables
  >(CreateTableColumnGroupDocument, options)
}
export type CreateTableColumnGroupMutationHookResult = ReturnType<
  typeof useCreateTableColumnGroupMutation
>
export type CreateTableColumnGroupMutationResult =
  Apollo.MutationResult<CreateTableColumnGroupMutation>
export type CreateTableColumnGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateTableColumnGroupMutation,
  CreateTableColumnGroupMutationVariables
>
export const GetSimpleTableDocument = gql`
  query getSimpleTable($tableId: ID!) {
    table(tableId: $tableId) {
      id
      name
      rootWorkspace {
        id
      }
      parentTable {
        id
      }
    }
  }
`

/**
 * __useGetSimpleTableQuery__
 *
 * To run a query within a React component, call `useGetSimpleTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleTableQuery({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useGetSimpleTableQuery(
  baseOptions: Apollo.QueryHookOptions<GetSimpleTableQuery, GetSimpleTableQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSimpleTableQuery, GetSimpleTableQueryVariables>(
    GetSimpleTableDocument,
    options,
  )
}
export function useGetSimpleTableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleTableQuery, GetSimpleTableQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSimpleTableQuery, GetSimpleTableQueryVariables>(
    GetSimpleTableDocument,
    options,
  )
}
export type GetSimpleTableQueryHookResult = ReturnType<typeof useGetSimpleTableQuery>
export type GetSimpleTableLazyQueryHookResult = ReturnType<typeof useGetSimpleTableLazyQuery>
export type GetSimpleTableQueryResult = Apollo.QueryResult<
  GetSimpleTableQuery,
  GetSimpleTableQueryVariables
>
export const UpdateTableColumnGroupDocument = gql`
  mutation updateTableColumnGroup($input: UpdateTableColumnGroupInput!) {
    updateTableColumnGroup(input: $input) {
      id
      name
      order
      columns {
        id
        order
        tableColumn {
          id
        }
      }
    }
  }
`
export type UpdateTableColumnGroupMutationFn = Apollo.MutationFunction<
  UpdateTableColumnGroupMutation,
  UpdateTableColumnGroupMutationVariables
>

/**
 * __useUpdateTableColumnGroupMutation__
 *
 * To run a mutation, you first call `useUpdateTableColumnGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableColumnGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableColumnGroupMutation, { data, loading, error }] = useUpdateTableColumnGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableColumnGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTableColumnGroupMutation,
    UpdateTableColumnGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateTableColumnGroupMutation,
    UpdateTableColumnGroupMutationVariables
  >(UpdateTableColumnGroupDocument, options)
}
export type UpdateTableColumnGroupMutationHookResult = ReturnType<
  typeof useUpdateTableColumnGroupMutation
>
export type UpdateTableColumnGroupMutationResult =
  Apollo.MutationResult<UpdateTableColumnGroupMutation>
export type UpdateTableColumnGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateTableColumnGroupMutation,
  UpdateTableColumnGroupMutationVariables
>
export const DeleteTableColumnGroupDocument = gql`
  mutation deleteTableColumnGroup($tableColumnGroupId: ID!) {
    deleteTableColumnGroup(tableColumnGroupId: $tableColumnGroupId) {
      id
    }
  }
`
export type DeleteTableColumnGroupMutationFn = Apollo.MutationFunction<
  DeleteTableColumnGroupMutation,
  DeleteTableColumnGroupMutationVariables
>

/**
 * __useDeleteTableColumnGroupMutation__
 *
 * To run a mutation, you first call `useDeleteTableColumnGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTableColumnGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTableColumnGroupMutation, { data, loading, error }] = useDeleteTableColumnGroupMutation({
 *   variables: {
 *      tableColumnGroupId: // value for 'tableColumnGroupId'
 *   },
 * });
 */
export function useDeleteTableColumnGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTableColumnGroupMutation,
    DeleteTableColumnGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteTableColumnGroupMutation,
    DeleteTableColumnGroupMutationVariables
  >(DeleteTableColumnGroupDocument, options)
}
export type DeleteTableColumnGroupMutationHookResult = ReturnType<
  typeof useDeleteTableColumnGroupMutation
>
export type DeleteTableColumnGroupMutationResult =
  Apollo.MutationResult<DeleteTableColumnGroupMutation>
export type DeleteTableColumnGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteTableColumnGroupMutation,
  DeleteTableColumnGroupMutationVariables
>
export const PushTableTabDocument = gql`
  subscription pushTableTab($tableId: ID!) {
    pushTableTab(tableId: $tableId) {
      id
      name
      order
      booleanOperator
      filters {
        id
        operator
        operand
        systemGeneratedColumnType
        tableColumn {
          id
        }
      }
      sorts {
        id
        direction
        tableColumn {
          id
        }
      }
      columns {
        id
        order
        isFrozen
        tableColumn {
          id
          order
        }
      }
    }
  }
`

/**
 * __usePushTableTabSubscription__
 *
 * To run a query within a React component, call `usePushTableTabSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePushTableTabSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushTableTabSubscription({
 *   variables: {
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function usePushTableTabSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    PushTableTabSubscription,
    PushTableTabSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<PushTableTabSubscription, PushTableTabSubscriptionVariables>(
    PushTableTabDocument,
    options,
  )
}
export type PushTableTabSubscriptionHookResult = ReturnType<typeof usePushTableTabSubscription>
export type PushTableTabSubscriptionResult = Apollo.SubscriptionResult<PushTableTabSubscription>
export const AggregateTableColumnDocument = gql`
  query aggregateTableColumn($input: AggregateTableColumnInput!) {
    aggregateTableColumn(input: $input) {
      operation
      value
    }
  }
`

/**
 * __useAggregateTableColumnQuery__
 *
 * To run a query within a React component, call `useAggregateTableColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregateTableColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregateTableColumnQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAggregateTableColumnQuery(
  baseOptions: Apollo.QueryHookOptions<
    AggregateTableColumnQuery,
    AggregateTableColumnQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AggregateTableColumnQuery, AggregateTableColumnQueryVariables>(
    AggregateTableColumnDocument,
    options,
  )
}
export function useAggregateTableColumnLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AggregateTableColumnQuery,
    AggregateTableColumnQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AggregateTableColumnQuery, AggregateTableColumnQueryVariables>(
    AggregateTableColumnDocument,
    options,
  )
}
export type AggregateTableColumnQueryHookResult = ReturnType<typeof useAggregateTableColumnQuery>
export type AggregateTableColumnLazyQueryHookResult = ReturnType<
  typeof useAggregateTableColumnLazyQuery
>
export type AggregateTableColumnQueryResult = Apollo.QueryResult<
  AggregateTableColumnQuery,
  AggregateTableColumnQueryVariables
>
export const ActionJsonDocument = gql`
  query actionJson($actionId: ID!) {
    actionJson(actionId: $actionId)
  }
`

/**
 * __useActionJsonQuery__
 *
 * To run a query within a React component, call `useActionJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionJsonQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useActionJsonQuery(
  baseOptions: Apollo.QueryHookOptions<ActionJsonQuery, ActionJsonQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ActionJsonQuery, ActionJsonQueryVariables>(ActionJsonDocument, options)
}
export function useActionJsonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ActionJsonQuery, ActionJsonQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ActionJsonQuery, ActionJsonQueryVariables>(ActionJsonDocument, options)
}
export type ActionJsonQueryHookResult = ReturnType<typeof useActionJsonQuery>
export type ActionJsonLazyQueryHookResult = ReturnType<typeof useActionJsonLazyQuery>
export type ActionJsonQueryResult = Apollo.QueryResult<ActionJsonQuery, ActionJsonQueryVariables>
export const WorkflowDocument = gql`
  query workflow($workflowId: ID!) {
    workflow(workflowId: $workflowId) {
      id
      name
      description
      status
      actions {
        id
        name
        order
        status
        description
        manualTriggers {
          id
          name
        }
        autoTrigger {
          id
          type
          triggerMetadata
          filterExpression
          logo {
            id
            name
            storageUrl
          }
        }
        frequencyTriggers {
          id
          repeatNumber
          repeatUnit
          daysOfWeek
          hoursOfDay
          startAt
        }
        steps {
          id
          name
          order
          status
          type
          selectionsData
          slugifiedSelectionsData
          logo {
            id
            name
            storageUrl
          }
          branches {
            id
            order
            name
            actionSteps {
              id
              name
              order
              status
              type
              selectionsData
              slugifiedSelectionsData
            }
          }
        }
      }
    }
  }
`

/**
 * __useWorkflowQuery__
 *
 * To run a query within a React component, call `useWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useWorkflowQuery(
  baseOptions: Apollo.QueryHookOptions<WorkflowQuery, WorkflowQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<WorkflowQuery, WorkflowQueryVariables>(WorkflowDocument, options)
}
export function useWorkflowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WorkflowQuery, WorkflowQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<WorkflowQuery, WorkflowQueryVariables>(WorkflowDocument, options)
}
export type WorkflowQueryHookResult = ReturnType<typeof useWorkflowQuery>
export type WorkflowLazyQueryHookResult = ReturnType<typeof useWorkflowLazyQuery>
export type WorkflowQueryResult = Apollo.QueryResult<WorkflowQuery, WorkflowQueryVariables>
export const EnableWorkflowDocument = gql`
  mutation enableWorkflow($workflowId: ID!) {
    enableWorkflow(workflowId: $workflowId) {
      id
      status
    }
  }
`
export type EnableWorkflowMutationFn = Apollo.MutationFunction<
  EnableWorkflowMutation,
  EnableWorkflowMutationVariables
>

/**
 * __useEnableWorkflowMutation__
 *
 * To run a mutation, you first call `useEnableWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableWorkflowMutation, { data, loading, error }] = useEnableWorkflowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useEnableWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<EnableWorkflowMutation, EnableWorkflowMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EnableWorkflowMutation, EnableWorkflowMutationVariables>(
    EnableWorkflowDocument,
    options,
  )
}
export type EnableWorkflowMutationHookResult = ReturnType<typeof useEnableWorkflowMutation>
export type EnableWorkflowMutationResult = Apollo.MutationResult<EnableWorkflowMutation>
export type EnableWorkflowMutationOptions = Apollo.BaseMutationOptions<
  EnableWorkflowMutation,
  EnableWorkflowMutationVariables
>
export const DisableWorkflowDocument = gql`
  mutation disableWorkflow($workflowId: ID!) {
    disableWorkflow(workflowId: $workflowId) {
      id
      status
    }
  }
`
export type DisableWorkflowMutationFn = Apollo.MutationFunction<
  DisableWorkflowMutation,
  DisableWorkflowMutationVariables
>

/**
 * __useDisableWorkflowMutation__
 *
 * To run a mutation, you first call `useDisableWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableWorkflowMutation, { data, loading, error }] = useDisableWorkflowMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useDisableWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableWorkflowMutation,
    DisableWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DisableWorkflowMutation, DisableWorkflowMutationVariables>(
    DisableWorkflowDocument,
    options,
  )
}
export type DisableWorkflowMutationHookResult = ReturnType<typeof useDisableWorkflowMutation>
export type DisableWorkflowMutationResult = Apollo.MutationResult<DisableWorkflowMutation>
export type DisableWorkflowMutationOptions = Apollo.BaseMutationOptions<
  DisableWorkflowMutation,
  DisableWorkflowMutationVariables
>
export const WorkflowsDocument = gql`
  query workflows {
    workflows {
      id
      name
      status
      description
      isUserVisible
      updatedAt
      actions {
        id
        name
        manualTriggers {
          id
        }
        autoTrigger {
          id
          type
          triggerMetadata
          filterExpression
          logo {
            id
            name
            storageUrl
          }
        }
        frequencyTriggers {
          id
        }
        steps {
          id
          name
          order
          status
          type
          logo {
            id
            name
            storageUrl
          }
          branches {
            id
            order
            name
            actionSteps {
              id
              name
              order
              status
              type
            }
          }
        }
      }
    }
  }
`

/**
 * __useWorkflowsQuery__
 *
 * To run a query within a React component, call `useWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkflowsQuery(
  baseOptions?: Apollo.QueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<WorkflowsQuery, WorkflowsQueryVariables>(WorkflowsDocument, options)
}
export function useWorkflowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<WorkflowsQuery, WorkflowsQueryVariables>(WorkflowsDocument, options)
}
export type WorkflowsQueryHookResult = ReturnType<typeof useWorkflowsQuery>
export type WorkflowsLazyQueryHookResult = ReturnType<typeof useWorkflowsLazyQuery>
export type WorkflowsQueryResult = Apollo.QueryResult<WorkflowsQuery, WorkflowsQueryVariables>
export const GetSimpleWorkspaceViewsDocument = gql`
  query getSimpleWorkspaceViews($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      views {
        id
      }
      linkedViews {
        parentWorkspace {
          id
        }
      }
    }
  }
`

/**
 * __useGetSimpleWorkspaceViewsQuery__
 *
 * To run a query within a React component, call `useGetSimpleWorkspaceViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleWorkspaceViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleWorkspaceViewsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetSimpleWorkspaceViewsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSimpleWorkspaceViewsQuery,
    GetSimpleWorkspaceViewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSimpleWorkspaceViewsQuery, GetSimpleWorkspaceViewsQueryVariables>(
    GetSimpleWorkspaceViewsDocument,
    options,
  )
}
export function useGetSimpleWorkspaceViewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSimpleWorkspaceViewsQuery,
    GetSimpleWorkspaceViewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSimpleWorkspaceViewsQuery, GetSimpleWorkspaceViewsQueryVariables>(
    GetSimpleWorkspaceViewsDocument,
    options,
  )
}
export type GetSimpleWorkspaceViewsQueryHookResult = ReturnType<
  typeof useGetSimpleWorkspaceViewsQuery
>
export type GetSimpleWorkspaceViewsLazyQueryHookResult = ReturnType<
  typeof useGetSimpleWorkspaceViewsLazyQuery
>
export type GetSimpleWorkspaceViewsQueryResult = Apollo.QueryResult<
  GetSimpleWorkspaceViewsQuery,
  GetSimpleWorkspaceViewsQueryVariables
>
export const CreateWorkspaceDocument = gql`
  mutation createWorkspace($input: CreateWorkspaceInput!) {
    createWorkspace(input: $input) {
      id
      name
    }
  }
`
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<
  CreateWorkspaceMutation,
  CreateWorkspaceMutationVariables
>

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkspaceMutation,
    CreateWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(
    CreateWorkspaceDocument,
    options,
  )
}
export type CreateWorkspaceMutationHookResult = ReturnType<typeof useCreateWorkspaceMutation>
export type CreateWorkspaceMutationResult = Apollo.MutationResult<CreateWorkspaceMutation>
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkspaceMutation,
  CreateWorkspaceMutationVariables
>
export const UpdateWorkspaceDocument = gql`
  mutation updateWorkspace($input: UpdateWorkspaceInput!) {
    updateWorkspace(input: $input) {
      id
      name
      views {
        id
        order
        rowNumber
        unitHeight
      }
    }
  }
`
export type UpdateWorkspaceMutationFn = Apollo.MutationFunction<
  UpdateWorkspaceMutation,
  UpdateWorkspaceMutationVariables
>

/**
 * __useUpdateWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMutation, { data, loading, error }] = useUpdateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkspaceMutation,
    UpdateWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>(
    UpdateWorkspaceDocument,
    options,
  )
}
export type UpdateWorkspaceMutationHookResult = ReturnType<typeof useUpdateWorkspaceMutation>
export type UpdateWorkspaceMutationResult = Apollo.MutationResult<UpdateWorkspaceMutation>
export type UpdateWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkspaceMutation,
  UpdateWorkspaceMutationVariables
>
export const UpdateWorkspaceRowHeightDocument = gql`
  mutation updateWorkspaceRowHeight($input: UpdateWorkspaceRowHeightInput!) {
    updateWorkspaceRowHeight(input: $input) {
      id
      name
      views {
        id
        order
        rowNumber
        unitHeight
      }
    }
  }
`
export type UpdateWorkspaceRowHeightMutationFn = Apollo.MutationFunction<
  UpdateWorkspaceRowHeightMutation,
  UpdateWorkspaceRowHeightMutationVariables
>

/**
 * __useUpdateWorkspaceRowHeightMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceRowHeightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceRowHeightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceRowHeightMutation, { data, loading, error }] = useUpdateWorkspaceRowHeightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceRowHeightMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkspaceRowHeightMutation,
    UpdateWorkspaceRowHeightMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateWorkspaceRowHeightMutation,
    UpdateWorkspaceRowHeightMutationVariables
  >(UpdateWorkspaceRowHeightDocument, options)
}
export type UpdateWorkspaceRowHeightMutationHookResult = ReturnType<
  typeof useUpdateWorkspaceRowHeightMutation
>
export type UpdateWorkspaceRowHeightMutationResult =
  Apollo.MutationResult<UpdateWorkspaceRowHeightMutation>
export type UpdateWorkspaceRowHeightMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkspaceRowHeightMutation,
  UpdateWorkspaceRowHeightMutationVariables
>
export const CreateViewDocument = gql`
  mutation createView($input: CreateViewInput!) {
    createView(input: $input) {
      id
      embed {
        id
      }
    }
  }
`
export type CreateViewMutationFn = Apollo.MutationFunction<
  CreateViewMutation,
  CreateViewMutationVariables
>

/**
 * __useCreateViewMutation__
 *
 * To run a mutation, you first call `useCreateViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createViewMutation, { data, loading, error }] = useCreateViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateViewMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateViewMutation, CreateViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateViewMutation, CreateViewMutationVariables>(
    CreateViewDocument,
    options,
  )
}
export type CreateViewMutationHookResult = ReturnType<typeof useCreateViewMutation>
export type CreateViewMutationResult = Apollo.MutationResult<CreateViewMutation>
export type CreateViewMutationOptions = Apollo.BaseMutationOptions<
  CreateViewMutation,
  CreateViewMutationVariables
>
export const DeleteViewDocument = gql`
  mutation deleteView($viewId: ID!) {
    deleteView(viewId: $viewId) {
      id
    }
  }
`
export type DeleteViewMutationFn = Apollo.MutationFunction<
  DeleteViewMutation,
  DeleteViewMutationVariables
>

/**
 * __useDeleteViewMutation__
 *
 * To run a mutation, you first call `useDeleteViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViewMutation, { data, loading, error }] = useDeleteViewMutation({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useDeleteViewMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteViewMutation, DeleteViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteViewMutation, DeleteViewMutationVariables>(
    DeleteViewDocument,
    options,
  )
}
export type DeleteViewMutationHookResult = ReturnType<typeof useDeleteViewMutation>
export type DeleteViewMutationResult = Apollo.MutationResult<DeleteViewMutation>
export type DeleteViewMutationOptions = Apollo.BaseMutationOptions<
  DeleteViewMutation,
  DeleteViewMutationVariables
>
export const DuplicateViewDocument = gql`
  mutation duplicateView($input: DuplicateViewInput!) {
    duplicateView(input: $input) {
      id
    }
  }
`
export type DuplicateViewMutationFn = Apollo.MutationFunction<
  DuplicateViewMutation,
  DuplicateViewMutationVariables
>

/**
 * __useDuplicateViewMutation__
 *
 * To run a mutation, you first call `useDuplicateViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateViewMutation, { data, loading, error }] = useDuplicateViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateViewMutation(
  baseOptions?: Apollo.MutationHookOptions<DuplicateViewMutation, DuplicateViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DuplicateViewMutation, DuplicateViewMutationVariables>(
    DuplicateViewDocument,
    options,
  )
}
export type DuplicateViewMutationHookResult = ReturnType<typeof useDuplicateViewMutation>
export type DuplicateViewMutationResult = Apollo.MutationResult<DuplicateViewMutation>
export type DuplicateViewMutationOptions = Apollo.BaseMutationOptions<
  DuplicateViewMutation,
  DuplicateViewMutationVariables
>
export const UpdateEmbedNameDocument = gql`
  mutation updateEmbedName($embedId: ID!, $name: String!) {
    updateEmbedName(embedId: $embedId, name: $name) {
      id
      name
    }
  }
`
export type UpdateEmbedNameMutationFn = Apollo.MutationFunction<
  UpdateEmbedNameMutation,
  UpdateEmbedNameMutationVariables
>

/**
 * __useUpdateEmbedNameMutation__
 *
 * To run a mutation, you first call `useUpdateEmbedNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmbedNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmbedNameMutation, { data, loading, error }] = useUpdateEmbedNameMutation({
 *   variables: {
 *      embedId: // value for 'embedId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateEmbedNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateEmbedNameMutation,
    UpdateEmbedNameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateEmbedNameMutation, UpdateEmbedNameMutationVariables>(
    UpdateEmbedNameDocument,
    options,
  )
}
export type UpdateEmbedNameMutationHookResult = ReturnType<typeof useUpdateEmbedNameMutation>
export type UpdateEmbedNameMutationResult = Apollo.MutationResult<UpdateEmbedNameMutation>
export type UpdateEmbedNameMutationOptions = Apollo.BaseMutationOptions<
  UpdateEmbedNameMutation,
  UpdateEmbedNameMutationVariables
>
